import { ZodFirstPartyTypeKind } from "zod/v3";
import { z } from "zod";
import * as z4 from "zod/v4";
import { z as z$1 } from "zod/v4";
import { Agent, MessageList } from "@mastra/core/agent";
import { coreFeatures } from "@mastra/core/features";
import { MastraMemory, getThreadOMMetadata, parseMemoryRequestContext, setThreadOMMetadata } from "@mastra/core/memory";
import { EntityType, SpanType, createObservabilityContext, getOrCreateSpan } from "@mastra/core/observability";
import { generateEmptyFromSchema } from "@mastra/core/utils";
import { isStandardSchemaWithJSON, standardSchemaToJSONSchema, toStandardSchema } from "@mastra/schema-compat/schema";
import { Mutex } from "async-mutex";
import { LRUCache } from "lru-cache";
import xxhash from "xxhash-wasm";
import { modelSupportsAttachments, resolveModelConfig } from "@mastra/core/llm";
import { appendFileSync, mkdirSync, writeFileSync } from "fs";
import { join } from "path";
import { MASTRA_THREAD_ID_KEY, RequestContext } from "@mastra/core/request-context";
import { estimateTokenCount } from "tokenx";
import { createHash, randomBytes, randomUUID } from "crypto";
import { InMemoryStore } from "@mastra/core/storage";
import { AsyncLocalStorage } from "async_hooks";
import imageSize from "image-size";
import { createTool } from "@mastra/core/tools";
import { isStandardSchemaWithJSON as isStandardSchemaWithJSON$1, toStandardSchema as toStandardSchema$1 } from "@mastra/core/schema";
import { MessageHistory, MessageHistory as MessageHistory$1, SemanticRecall, WorkingMemory } from "@mastra/core/processors";
import { inspect } from "util";
import { structuredPatch } from "diff";
//#region \0rolldown/runtime.js
var __defProp$4 = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp$4(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp$4(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion
//#region ../_vendored/ai_v4/dist/dist-Cm5DZgxA.js
var marker$6 = "vercel.ai.error";
var symbol$6 = Symbol.for(marker$6);
var _a$6;
var _AISDKError = class _AISDKError extends Error {
	/**
	* Creates an AI SDK Error.
	*
	* @param {Object} params - The parameters for creating the error.
	* @param {string} params.name - The name of the error.
	* @param {string} params.message - The error message.
	* @param {unknown} [params.cause] - The underlying cause of the error.
	*/
	constructor({ name: name14, message, cause }) {
		super(message);
		this[_a$6] = true;
		this.name = name14;
		this.cause = cause;
	}
	/**
	* Checks if the given error is an AI SDK Error.
	* @param {unknown} error - The error to check.
	* @returns {boolean} True if the error is an AI SDK Error, false otherwise.
	*/
	static isInstance(error) {
		return _AISDKError.hasMarker(error, marker$6);
	}
	static hasMarker(error, marker15) {
		const markerSymbol = Symbol.for(marker15);
		return error != null && typeof error === "object" && markerSymbol in error && typeof error[markerSymbol] === "boolean" && error[markerSymbol] === true;
	}
};
_a$6 = symbol$6;
var AISDKError$2 = _AISDKError;
var name$6 = "AI_APICallError";
var marker2$6 = `vercel.ai.error.${name$6}`;
var symbol2$6 = Symbol.for(marker2$6);
var _a2$6;
var APICallError$2 = class extends AISDKError$2 {
	constructor({ message, url, requestBodyValues, statusCode, responseHeaders, responseBody, cause, isRetryable = statusCode != null && (statusCode === 408 || statusCode === 409 || statusCode === 429 || statusCode >= 500), data }) {
		super({
			name: name$6,
			message,
			cause
		});
		this[_a2$6] = true;
		this.url = url;
		this.requestBodyValues = requestBodyValues;
		this.statusCode = statusCode;
		this.responseHeaders = responseHeaders;
		this.responseBody = responseBody;
		this.isRetryable = isRetryable;
		this.data = data;
	}
	static isInstance(error) {
		return AISDKError$2.hasMarker(error, marker2$6);
	}
};
_a2$6 = symbol2$6;
function getErrorMessage$4(error) {
	if (error == null) return "unknown error";
	if (typeof error === "string") return error;
	if (error instanceof Error) return error.message;
	return JSON.stringify(error);
}
var name3$6 = "AI_InvalidArgumentError";
var marker4$6 = `vercel.ai.error.${name3$6}`;
var symbol4$6 = Symbol.for(marker4$6);
var _a4$6;
var InvalidArgumentError$5 = class extends AISDKError$2 {
	constructor({ message, cause, argument }) {
		super({
			name: name3$6,
			message,
			cause
		});
		this[_a4$6] = true;
		this.argument = argument;
	}
	static isInstance(error) {
		return AISDKError$2.hasMarker(error, marker4$6);
	}
};
_a4$6 = symbol4$6;
var name6$6 = "AI_JSONParseError";
var marker7$6 = `vercel.ai.error.${name6$6}`;
var symbol7$6 = Symbol.for(marker7$6);
var _a7$6;
var JSONParseError$2 = class extends AISDKError$2 {
	constructor({ text, cause }) {
		super({
			name: name6$6,
			message: `JSON parsing failed: Text: ${text}.
Error message: ${getErrorMessage$4(cause)}`,
			cause
		});
		this[_a7$6] = true;
		this.text = text;
	}
	static isInstance(error) {
		return AISDKError$2.hasMarker(error, marker7$6);
	}
};
_a7$6 = symbol7$6;
var name12$5 = "AI_TypeValidationError";
var marker13$5 = `vercel.ai.error.${name12$5}`;
var symbol13$5 = Symbol.for(marker13$5);
var _a13$5;
var _TypeValidationError = class _TypeValidationError extends AISDKError$2 {
	constructor({ value, cause }) {
		super({
			name: name12$5,
			message: `Type validation failed: Value: ${JSON.stringify(value)}.
Error message: ${getErrorMessage$4(cause)}`,
			cause
		});
		this[_a13$5] = true;
		this.value = value;
	}
	static isInstance(error) {
		return AISDKError$2.hasMarker(error, marker13$5);
	}
	/**
	* Wraps an error into a TypeValidationError.
	* If the cause is already a TypeValidationError with the same value, it returns the cause.
	* Otherwise, it creates a new TypeValidationError.
	*
	* @param {Object} params - The parameters for wrapping the error.
	* @param {unknown} params.value - The value that failed validation.
	* @param {unknown} params.cause - The original error or cause of the validation failure.
	* @returns {TypeValidationError} A TypeValidationError instance.
	*/
	static wrap({ value, cause }) {
		return _TypeValidationError.isInstance(cause) && cause.value === value ? cause : new _TypeValidationError({
			value,
			cause
		});
	}
};
_a13$5 = symbol13$5;
var TypeValidationError$2 = _TypeValidationError;
//#endregion
//#region ../_vendored/ai_v4/dist/dist-e6zV1w-k.js
var __create = Object.create;
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod), cb = null), mod.exports);
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp$3(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp$3(target, "default", {
	value: mod,
	enumerable: true
}) : target, mod));
let customAlphabet = (alphabet, defaultSize = 21) => {
	return (size = defaultSize) => {
		let id = "";
		let i = size | 0;
		while (i--) id += alphabet[Math.random() * alphabet.length | 0];
		return id;
	};
};
var import_secure_json_parse = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	const hasBuffer = typeof Buffer !== "undefined";
	const suspectProtoRx = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/;
	const suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
	function _parse(text, reviver, options) {
		if (options == null) {
			if (reviver !== null && typeof reviver === "object") {
				options = reviver;
				reviver = void 0;
			}
		}
		if (hasBuffer && Buffer.isBuffer(text)) text = text.toString();
		if (text && text.charCodeAt(0) === 65279) text = text.slice(1);
		const obj = JSON.parse(text, reviver);
		if (obj === null || typeof obj !== "object") return obj;
		const protoAction = options && options.protoAction || "error";
		const constructorAction = options && options.constructorAction || "error";
		if (protoAction === "ignore" && constructorAction === "ignore") return obj;
		if (protoAction !== "ignore" && constructorAction !== "ignore") {
			if (suspectProtoRx.test(text) === false && suspectConstructorRx.test(text) === false) return obj;
		} else if (protoAction !== "ignore" && constructorAction === "ignore") {
			if (suspectProtoRx.test(text) === false) return obj;
		} else if (suspectConstructorRx.test(text) === false) return obj;
		return filter(obj, {
			protoAction,
			constructorAction,
			safe: options && options.safe
		});
	}
	function filter(obj, { protoAction = "error", constructorAction = "error", safe } = {}) {
		let next = [obj];
		while (next.length) {
			const nodes = next;
			next = [];
			for (const node of nodes) {
				if (protoAction !== "ignore" && Object.prototype.hasOwnProperty.call(node, "__proto__")) {
					if (safe === true) return null;
					else if (protoAction === "error") throw new SyntaxError("Object contains forbidden prototype property");
					delete node.__proto__;
				}
				if (constructorAction !== "ignore" && Object.prototype.hasOwnProperty.call(node, "constructor") && Object.prototype.hasOwnProperty.call(node.constructor, "prototype")) {
					if (safe === true) return null;
					else if (constructorAction === "error") throw new SyntaxError("Object contains forbidden prototype property");
					delete node.constructor;
				}
				for (const key in node) {
					const value = node[key];
					if (value && typeof value === "object") next.push(value);
				}
			}
		}
		return obj;
	}
	function parse(text, reviver, options) {
		const stackTraceLimit = Error.stackTraceLimit;
		Error.stackTraceLimit = 0;
		try {
			return _parse(text, reviver, options);
		} finally {
			Error.stackTraceLimit = stackTraceLimit;
		}
	}
	function safeParse(text, reviver) {
		const stackTraceLimit = Error.stackTraceLimit;
		Error.stackTraceLimit = 0;
		try {
			return _parse(text, reviver, { safe: true });
		} catch (_e) {
			return null;
		} finally {
			Error.stackTraceLimit = stackTraceLimit;
		}
	}
	module.exports = parse;
	module.exports.default = parse;
	module.exports.parse = parse;
	module.exports.safeParse = safeParse;
	module.exports.scan = filter;
})))(), 1);
function convertAsyncIteratorToReadableStream(iterator) {
	return new ReadableStream({
		/**
		* Called when the consumer wants to pull more data from the stream.
		*
		* @param {ReadableStreamDefaultController<T>} controller - The controller to enqueue data into the stream.
		* @returns {Promise<void>}
		*/
		async pull(controller) {
			try {
				const { value, done } = await iterator.next();
				if (done) controller.close();
				else controller.enqueue(value);
			} catch (error) {
				controller.error(error);
			}
		},
		/**
		* Called when the consumer cancels the stream.
		*/
		cancel() {}
	});
}
async function delay$2(delayInMs) {
	return delayInMs == null ? Promise.resolve() : new Promise((resolve2) => setTimeout(resolve2, delayInMs));
}
var createIdGenerator$2 = ({ prefix, size: defaultSize = 16, alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", separator = "-" } = {}) => {
	const generator = customAlphabet(alphabet, defaultSize);
	if (prefix == null) return generator;
	if (alphabet.includes(separator)) throw new InvalidArgumentError$5({
		argument: "separator",
		message: `The separator "${separator}" must not be part of the alphabet "${alphabet}".`
	});
	return (size) => `${prefix}${separator}${generator(size)}`;
};
createIdGenerator$2();
function getErrorMessage$3(error) {
	if (error == null) return "unknown error";
	if (typeof error === "string") return error;
	if (error instanceof Error) return error.message;
	return JSON.stringify(error);
}
function isAbortError$4(error) {
	return error instanceof Error && (error.name === "AbortError" || error.name === "TimeoutError");
}
var validatorSymbol$1 = Symbol.for("vercel.ai.validator");
function validator$1(validate) {
	return {
		[validatorSymbol$1]: true,
		validate
	};
}
function isValidator$1(value) {
	return typeof value === "object" && value !== null && validatorSymbol$1 in value && value[validatorSymbol$1] === true && "validate" in value;
}
function asValidator$1(value) {
	return isValidator$1(value) ? value : zodValidator(value);
}
function zodValidator(zodSchema) {
	return validator$1((value) => {
		const result = zodSchema.safeParse(value);
		return result.success ? {
			success: true,
			value: result.data
		} : {
			success: false,
			error: result.error
		};
	});
}
function safeValidateTypes$2({ value, schema }) {
	const validator2 = asValidator$1(schema);
	try {
		if (validator2.validate == null) return {
			success: true,
			value
		};
		const result = validator2.validate(value);
		if (result.success) return result;
		return {
			success: false,
			error: TypeValidationError$2.wrap({
				value,
				cause: result.error
			})
		};
	} catch (error) {
		return {
			success: false,
			error: TypeValidationError$2.wrap({
				value,
				cause: error
			})
		};
	}
}
function safeParseJSON$2({ text, schema }) {
	try {
		const value = import_secure_json_parse.default.parse(text);
		if (schema == null) return {
			success: true,
			value,
			rawValue: value
		};
		const validationResult = safeValidateTypes$2({
			value,
			schema
		});
		return validationResult.success ? {
			...validationResult,
			rawValue: value
		} : validationResult;
	} catch (error) {
		return {
			success: false,
			error: JSONParseError$2.isInstance(error) ? error : new JSONParseError$2({
				text,
				cause: error
			})
		};
	}
}
var { btoa: btoa$2, atob: atob$2 } = globalThis;
//#endregion
//#region ../_vendored/ai_v4/dist/index.js
const ignoreOverride$2 = Symbol("Let zodToJsonSchema decide on which parser to use");
const defaultOptions$2 = {
	name: void 0,
	$refStrategy: "root",
	basePath: ["#"],
	effectStrategy: "input",
	pipeStrategy: "all",
	dateStrategy: "format:date-time",
	mapStrategy: "entries",
	removeAdditionalStrategy: "passthrough",
	allowedAdditionalProperties: true,
	rejectedAdditionalProperties: false,
	definitionPath: "definitions",
	target: "jsonSchema7",
	strictUnions: false,
	definitions: {},
	errorMessages: false,
	markdownDescription: false,
	patternStrategy: "escape",
	applyRegexFlags: false,
	emailStrategy: "format:email",
	base64Strategy: "contentEncoding:base64",
	nameStrategy: "ref",
	openAiAnyTypeName: "OpenAiAnyType"
};
const getDefaultOptions$2 = (options) => typeof options === "string" ? {
	...defaultOptions$2,
	name: options
} : {
	...defaultOptions$2,
	...options
};
const getRefs$2 = (options) => {
	const _options = getDefaultOptions$2(options);
	const currentPath = _options.name !== void 0 ? [
		..._options.basePath,
		_options.definitionPath,
		_options.name
	] : _options.basePath;
	return {
		..._options,
		flags: { hasReferencedOpenAiAnyType: false },
		currentPath,
		propertyPath: void 0,
		seen: new Map(Object.entries(_options.definitions).map(([name, def]) => [def._def, {
			def: def._def,
			path: [
				..._options.basePath,
				_options.definitionPath,
				name
			],
			jsonSchema: void 0
		}]))
	};
};
function addErrorMessage(res, key, errorMessage, refs) {
	if (!refs?.errorMessages) return;
	if (errorMessage) res.errorMessage = {
		...res.errorMessage,
		[key]: errorMessage
	};
}
function setResponseValueAndErrors(res, key, value, errorMessage, refs) {
	res[key] = value;
	addErrorMessage(res, key, errorMessage, refs);
}
const getRelativePath$2 = (pathA, pathB) => {
	let i = 0;
	for (; i < pathA.length && i < pathB.length; i++) if (pathA[i] !== pathB[i]) break;
	return [(pathA.length - i).toString(), ...pathB.slice(i)].join("/");
};
function parseAnyDef$2(refs) {
	if (refs.target !== "openAi") return {};
	const anyDefinitionPath = [
		...refs.basePath,
		refs.definitionPath,
		refs.openAiAnyTypeName
	];
	refs.flags.hasReferencedOpenAiAnyType = true;
	return { $ref: refs.$refStrategy === "relative" ? getRelativePath$2(anyDefinitionPath, refs.currentPath) : anyDefinitionPath.join("/") };
}
function parseArrayDef$2(def, refs) {
	const res = { type: "array" };
	if (def.type?._def && def.type?._def?.typeName !== ZodFirstPartyTypeKind.ZodAny) res.items = parseDef$2(def.type._def, {
		...refs,
		currentPath: [...refs.currentPath, "items"]
	});
	if (def.minLength) setResponseValueAndErrors(res, "minItems", def.minLength.value, def.minLength.message, refs);
	if (def.maxLength) setResponseValueAndErrors(res, "maxItems", def.maxLength.value, def.maxLength.message, refs);
	if (def.exactLength) {
		setResponseValueAndErrors(res, "minItems", def.exactLength.value, def.exactLength.message, refs);
		setResponseValueAndErrors(res, "maxItems", def.exactLength.value, def.exactLength.message, refs);
	}
	return res;
}
function parseBigintDef$2(def, refs) {
	const res = {
		type: "integer",
		format: "int64"
	};
	if (!def.checks) return res;
	for (const check of def.checks) switch (check.kind) {
		case "min":
			if (refs.target === "jsonSchema7") if (check.inclusive) setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			else setResponseValueAndErrors(res, "exclusiveMinimum", check.value, check.message, refs);
			else {
				if (!check.inclusive) res.exclusiveMinimum = true;
				setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			}
			break;
		case "max":
			if (refs.target === "jsonSchema7") if (check.inclusive) setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			else setResponseValueAndErrors(res, "exclusiveMaximum", check.value, check.message, refs);
			else {
				if (!check.inclusive) res.exclusiveMaximum = true;
				setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			}
			break;
		case "multipleOf":
			setResponseValueAndErrors(res, "multipleOf", check.value, check.message, refs);
			break;
	}
	return res;
}
function parseBooleanDef$2() {
	return { type: "boolean" };
}
function parseBrandedDef$2(_def, refs) {
	return parseDef$2(_def.type._def, refs);
}
const parseCatchDef$2 = (def, refs) => {
	return parseDef$2(def.innerType._def, refs);
};
function parseDateDef$2(def, refs, overrideDateStrategy) {
	const strategy = overrideDateStrategy ?? refs.dateStrategy;
	if (Array.isArray(strategy)) return { anyOf: strategy.map((item, i) => parseDateDef$2(def, refs, item)) };
	switch (strategy) {
		case "string":
		case "format:date-time": return {
			type: "string",
			format: "date-time"
		};
		case "format:date": return {
			type: "string",
			format: "date"
		};
		case "integer": return integerDateParser$2(def, refs);
	}
}
const integerDateParser$2 = (def, refs) => {
	const res = {
		type: "integer",
		format: "unix-time"
	};
	if (refs.target === "openApi3") return res;
	for (const check of def.checks) switch (check.kind) {
		case "min":
			setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			break;
		case "max":
			setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			break;
	}
	return res;
};
function parseDefaultDef$2(_def, refs) {
	return {
		...parseDef$2(_def.innerType._def, refs),
		default: _def.defaultValue()
	};
}
function parseEffectsDef$2(_def, refs) {
	return refs.effectStrategy === "input" ? parseDef$2(_def.schema._def, refs) : parseAnyDef$2(refs);
}
function parseEnumDef$2(def) {
	return {
		type: "string",
		enum: Array.from(def.values)
	};
}
const isJsonSchema7AllOfType$2 = (type) => {
	if ("type" in type && type.type === "string") return false;
	return "allOf" in type;
};
function parseIntersectionDef$2(def, refs) {
	const allOf = [parseDef$2(def.left._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"0"
		]
	}), parseDef$2(def.right._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"1"
		]
	})].filter((x) => !!x);
	let unevaluatedProperties = refs.target === "jsonSchema2019-09" ? { unevaluatedProperties: false } : void 0;
	const mergedAllOf = [];
	allOf.forEach((schema) => {
		if (isJsonSchema7AllOfType$2(schema)) {
			mergedAllOf.push(...schema.allOf);
			if (schema.unevaluatedProperties === void 0) unevaluatedProperties = void 0;
		} else {
			let nestedSchema = schema;
			if ("additionalProperties" in schema && schema.additionalProperties === false) {
				const { additionalProperties, ...rest } = schema;
				nestedSchema = rest;
			} else unevaluatedProperties = void 0;
			mergedAllOf.push(nestedSchema);
		}
	});
	return mergedAllOf.length ? {
		allOf: mergedAllOf,
		...unevaluatedProperties
	} : void 0;
}
function parseLiteralDef$2(def, refs) {
	const parsedType = typeof def.value;
	if (parsedType !== "bigint" && parsedType !== "number" && parsedType !== "boolean" && parsedType !== "string") return { type: Array.isArray(def.value) ? "array" : "object" };
	if (refs.target === "openApi3") return {
		type: parsedType === "bigint" ? "integer" : parsedType,
		enum: [def.value]
	};
	return {
		type: parsedType === "bigint" ? "integer" : parsedType,
		const: def.value
	};
}
let emojiRegex$2 = void 0;
/**
* Generated from the regular expressions found here as of 2024-05-22:
* https://github.com/colinhacks/zod/blob/master/src/types.ts.
*
* Expressions with /i flag have been changed accordingly.
*/
const zodPatterns$2 = {
	/**
	* `c` was changed to `[cC]` to replicate /i flag
	*/
	cuid: /^[cC][^\s-]{8,}$/,
	cuid2: /^[0-9a-z]+$/,
	ulid: /^[0-9A-HJKMNP-TV-Z]{26}$/,
	/**
	* `a-z` was added to replicate /i flag
	*/
	email: /^(?!\.)(?!.*\.\.)([a-zA-Z0-9_'+\-\.]*)[a-zA-Z0-9_+-]@([a-zA-Z0-9][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,}$/,
	/**
	* Constructed a valid Unicode RegExp
	*
	* Lazily instantiate since this type of regex isn't supported
	* in all envs (e.g. React Native).
	*
	* See:
	* https://github.com/colinhacks/zod/issues/2433
	* Fix in Zod:
	* https://github.com/colinhacks/zod/commit/9340fd51e48576a75adc919bff65dbc4a5d4c99b
	*/
	emoji: () => {
		if (emojiRegex$2 === void 0) emojiRegex$2 = RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u");
		return emojiRegex$2;
	},
	/**
	* Unused
	*/
	uuid: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
	/**
	* Unused
	*/
	ipv4: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
	ipv4Cidr: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/,
	/**
	* Unused
	*/
	ipv6: /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
	ipv6Cidr: /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/,
	base64: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
	base64url: /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/,
	nanoid: /^[a-zA-Z0-9_-]{21}$/,
	jwt: /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/
};
function parseStringDef$2(def, refs) {
	const res = { type: "string" };
	if (def.checks) for (const check of def.checks) switch (check.kind) {
		case "min":
			setResponseValueAndErrors(res, "minLength", typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
			break;
		case "max":
			setResponseValueAndErrors(res, "maxLength", typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
			break;
		case "email":
			switch (refs.emailStrategy) {
				case "format:email":
					addFormat$2(res, "email", check.message, refs);
					break;
				case "format:idn-email":
					addFormat$2(res, "idn-email", check.message, refs);
					break;
				case "pattern:zod":
					addPattern$2(res, zodPatterns$2.email, check.message, refs);
					break;
			}
			break;
		case "url":
			addFormat$2(res, "uri", check.message, refs);
			break;
		case "uuid":
			addFormat$2(res, "uuid", check.message, refs);
			break;
		case "regex":
			addPattern$2(res, check.regex, check.message, refs);
			break;
		case "cuid":
			addPattern$2(res, zodPatterns$2.cuid, check.message, refs);
			break;
		case "cuid2":
			addPattern$2(res, zodPatterns$2.cuid2, check.message, refs);
			break;
		case "startsWith":
			addPattern$2(res, RegExp(`^${escapeLiteralCheckValue$2(check.value, refs)}`), check.message, refs);
			break;
		case "endsWith":
			addPattern$2(res, RegExp(`${escapeLiteralCheckValue$2(check.value, refs)}$`), check.message, refs);
			break;
		case "datetime":
			addFormat$2(res, "date-time", check.message, refs);
			break;
		case "date":
			addFormat$2(res, "date", check.message, refs);
			break;
		case "time":
			addFormat$2(res, "time", check.message, refs);
			break;
		case "duration":
			addFormat$2(res, "duration", check.message, refs);
			break;
		case "length":
			setResponseValueAndErrors(res, "minLength", typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value, check.message, refs);
			setResponseValueAndErrors(res, "maxLength", typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value, check.message, refs);
			break;
		case "includes":
			addPattern$2(res, RegExp(escapeLiteralCheckValue$2(check.value, refs)), check.message, refs);
			break;
		case "ip":
			if (check.version !== "v6") addFormat$2(res, "ipv4", check.message, refs);
			if (check.version !== "v4") addFormat$2(res, "ipv6", check.message, refs);
			break;
		case "base64url":
			addPattern$2(res, zodPatterns$2.base64url, check.message, refs);
			break;
		case "jwt":
			addPattern$2(res, zodPatterns$2.jwt, check.message, refs);
			break;
		case "cidr":
			if (check.version !== "v6") addPattern$2(res, zodPatterns$2.ipv4Cidr, check.message, refs);
			if (check.version !== "v4") addPattern$2(res, zodPatterns$2.ipv6Cidr, check.message, refs);
			break;
		case "emoji":
			addPattern$2(res, zodPatterns$2.emoji(), check.message, refs);
			break;
		case "ulid":
			addPattern$2(res, zodPatterns$2.ulid, check.message, refs);
			break;
		case "base64":
			switch (refs.base64Strategy) {
				case "format:binary":
					addFormat$2(res, "binary", check.message, refs);
					break;
				case "contentEncoding:base64":
					setResponseValueAndErrors(res, "contentEncoding", "base64", check.message, refs);
					break;
				case "pattern:zod":
					addPattern$2(res, zodPatterns$2.base64, check.message, refs);
					break;
			}
			break;
		case "nanoid": addPattern$2(res, zodPatterns$2.nanoid, check.message, refs);
		case "toLowerCase":
		case "toUpperCase":
		case "trim": break;
		default:
	}
	return res;
}
function escapeLiteralCheckValue$2(literal, refs) {
	return refs.patternStrategy === "escape" ? escapeNonAlphaNumeric$2(literal) : literal;
}
const ALPHA_NUMERIC$2 = /* @__PURE__ */ new Set("ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvxyz0123456789");
function escapeNonAlphaNumeric$2(source) {
	let result = "";
	for (let i = 0; i < source.length; i++) {
		if (!ALPHA_NUMERIC$2.has(source[i])) result += "\\";
		result += source[i];
	}
	return result;
}
function addFormat$2(schema, value, message, refs) {
	if (schema.format || schema.anyOf?.some((x) => x.format)) {
		if (!schema.anyOf) schema.anyOf = [];
		if (schema.format) {
			schema.anyOf.push({
				format: schema.format,
				...schema.errorMessage && refs.errorMessages && { errorMessage: { format: schema.errorMessage.format } }
			});
			delete schema.format;
			if (schema.errorMessage) {
				delete schema.errorMessage.format;
				if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
			}
		}
		schema.anyOf.push({
			format: value,
			...message && refs.errorMessages && { errorMessage: { format: message } }
		});
	} else setResponseValueAndErrors(schema, "format", value, message, refs);
}
function addPattern$2(schema, regex, message, refs) {
	if (schema.pattern || schema.allOf?.some((x) => x.pattern)) {
		if (!schema.allOf) schema.allOf = [];
		if (schema.pattern) {
			schema.allOf.push({
				pattern: schema.pattern,
				...schema.errorMessage && refs.errorMessages && { errorMessage: { pattern: schema.errorMessage.pattern } }
			});
			delete schema.pattern;
			if (schema.errorMessage) {
				delete schema.errorMessage.pattern;
				if (Object.keys(schema.errorMessage).length === 0) delete schema.errorMessage;
			}
		}
		schema.allOf.push({
			pattern: stringifyRegExpWithFlags$2(regex, refs),
			...message && refs.errorMessages && { errorMessage: { pattern: message } }
		});
	} else setResponseValueAndErrors(schema, "pattern", stringifyRegExpWithFlags$2(regex, refs), message, refs);
}
function stringifyRegExpWithFlags$2(regex, refs) {
	if (!refs.applyRegexFlags || !regex.flags) return regex.source;
	const flags = {
		i: regex.flags.includes("i"),
		m: regex.flags.includes("m"),
		s: regex.flags.includes("s")
	};
	const source = flags.i ? regex.source.toLowerCase() : regex.source;
	let pattern = "";
	let isEscaped = false;
	let inCharGroup = false;
	let inCharRange = false;
	for (let i = 0; i < source.length; i++) {
		if (isEscaped) {
			pattern += source[i];
			isEscaped = false;
			continue;
		}
		if (flags.i) {
			if (inCharGroup) {
				if (source[i].match(/[a-z]/)) {
					if (inCharRange) {
						pattern += source[i];
						pattern += `${source[i - 2]}-${source[i]}`.toUpperCase();
						inCharRange = false;
					} else if (source[i + 1] === "-" && source[i + 2]?.match(/[a-z]/)) {
						pattern += source[i];
						inCharRange = true;
					} else pattern += `${source[i]}${source[i].toUpperCase()}`;
					continue;
				}
			} else if (source[i].match(/[a-z]/)) {
				pattern += `[${source[i]}${source[i].toUpperCase()}]`;
				continue;
			}
		}
		if (flags.m) {
			if (source[i] === "^") {
				pattern += `(^|(?<=[\r\n]))`;
				continue;
			} else if (source[i] === "$") {
				pattern += `($|(?=[\r\n]))`;
				continue;
			}
		}
		if (flags.s && source[i] === ".") {
			pattern += inCharGroup ? `${source[i]}\r\n` : `[${source[i]}\r\n]`;
			continue;
		}
		pattern += source[i];
		if (source[i] === "\\") isEscaped = true;
		else if (inCharGroup && source[i] === "]") inCharGroup = false;
		else if (!inCharGroup && source[i] === "[") inCharGroup = true;
	}
	try {
		new RegExp(pattern);
	} catch {
		console.warn(`Could not convert regex pattern at ${refs.currentPath.join("/")} to a flag-independent form! Falling back to the flag-ignorant source`);
		return regex.source;
	}
	return pattern;
}
function parseRecordDef$2(def, refs) {
	if (refs.target === "openAi") console.warn("Warning: OpenAI may not support records in schemas! Try an array of key-value pairs instead.");
	if (refs.target === "openApi3" && def.keyType?._def.typeName === ZodFirstPartyTypeKind.ZodEnum) return {
		type: "object",
		required: def.keyType._def.values,
		properties: def.keyType._def.values.reduce((acc, key) => ({
			...acc,
			[key]: parseDef$2(def.valueType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"properties",
					key
				]
			}) ?? parseAnyDef$2(refs)
		}), {}),
		additionalProperties: refs.rejectedAdditionalProperties
	};
	const schema = {
		type: "object",
		additionalProperties: parseDef$2(def.valueType._def, {
			...refs,
			currentPath: [...refs.currentPath, "additionalProperties"]
		}) ?? refs.allowedAdditionalProperties
	};
	if (refs.target === "openApi3") return schema;
	if (def.keyType?._def.typeName === ZodFirstPartyTypeKind.ZodString && def.keyType._def.checks?.length) {
		const { type, ...keyType } = parseStringDef$2(def.keyType._def, refs);
		return {
			...schema,
			propertyNames: keyType
		};
	} else if (def.keyType?._def.typeName === ZodFirstPartyTypeKind.ZodEnum) return {
		...schema,
		propertyNames: { enum: def.keyType._def.values }
	};
	else if (def.keyType?._def.typeName === ZodFirstPartyTypeKind.ZodBranded && def.keyType._def.type._def.typeName === ZodFirstPartyTypeKind.ZodString && def.keyType._def.type._def.checks?.length) {
		const { type, ...keyType } = parseBrandedDef$2(def.keyType._def, refs);
		return {
			...schema,
			propertyNames: keyType
		};
	}
	return schema;
}
function parseMapDef$2(def, refs) {
	if (refs.mapStrategy === "record") return parseRecordDef$2(def, refs);
	return {
		type: "array",
		maxItems: 125,
		items: {
			type: "array",
			items: [parseDef$2(def.keyType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"items",
					"items",
					"0"
				]
			}) || parseAnyDef$2(refs), parseDef$2(def.valueType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"items",
					"items",
					"1"
				]
			}) || parseAnyDef$2(refs)],
			minItems: 2,
			maxItems: 2
		}
	};
}
function parseNativeEnumDef$2(def) {
	const object = def.values;
	const actualValues = Object.keys(def.values).filter((key) => {
		return typeof object[object[key]] !== "number";
	}).map((key) => object[key]);
	const parsedTypes = Array.from(new Set(actualValues.map((values) => typeof values)));
	return {
		type: parsedTypes.length === 1 ? parsedTypes[0] === "string" ? "string" : "number" : ["string", "number"],
		enum: actualValues
	};
}
function parseNeverDef$2(refs) {
	return refs.target === "openAi" ? void 0 : { not: parseAnyDef$2({
		...refs,
		currentPath: [...refs.currentPath, "not"]
	}) };
}
function parseNullDef$2(refs) {
	return refs.target === "openApi3" ? {
		enum: ["null"],
		nullable: true
	} : { type: "null" };
}
const primitiveMappings$2 = {
	ZodString: "string",
	ZodNumber: "number",
	ZodBigInt: "integer",
	ZodBoolean: "boolean",
	ZodNull: "null"
};
function parseUnionDef$2(def, refs) {
	if (refs.target === "openApi3") return asAnyOf$2(def, refs);
	const options = def.options instanceof Map ? Array.from(def.options.values()) : def.options;
	if (options.every((x) => x._def.typeName in primitiveMappings$2 && (!x._def.checks || !x._def.checks.length))) {
		const types = options.reduce((types, x) => {
			const type = primitiveMappings$2[x._def.typeName];
			return type && !types.includes(type) ? [...types, type] : types;
		}, []);
		return { type: types.length > 1 ? types : types[0] };
	} else if (options.every((x) => x._def.typeName === "ZodLiteral" && !x.description)) {
		const types = options.reduce((acc, x) => {
			const type = typeof x._def.value;
			switch (type) {
				case "string":
				case "number":
				case "boolean": return [...acc, type];
				case "bigint": return [...acc, "integer"];
				case "object": if (x._def.value === null) return [...acc, "null"];
				default: return acc;
			}
		}, []);
		if (types.length === options.length) {
			const uniqueTypes = types.filter((x, i, a) => a.indexOf(x) === i);
			return {
				type: uniqueTypes.length > 1 ? uniqueTypes : uniqueTypes[0],
				enum: options.reduce((acc, x) => {
					return acc.includes(x._def.value) ? acc : [...acc, x._def.value];
				}, [])
			};
		}
	} else if (options.every((x) => x._def.typeName === "ZodEnum")) return {
		type: "string",
		enum: options.reduce((acc, x) => [...acc, ...x._def.values.filter((x) => !acc.includes(x))], [])
	};
	return asAnyOf$2(def, refs);
}
const asAnyOf$2 = (def, refs) => {
	const anyOf = (def.options instanceof Map ? Array.from(def.options.values()) : def.options).map((x, i) => parseDef$2(x._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			`${i}`
		]
	})).filter((x) => !!x && (!refs.strictUnions || typeof x === "object" && Object.keys(x).length > 0));
	return anyOf.length ? { anyOf } : void 0;
};
function parseNullableDef$2(def, refs) {
	if ([
		"ZodString",
		"ZodNumber",
		"ZodBigInt",
		"ZodBoolean",
		"ZodNull"
	].includes(def.innerType._def.typeName) && (!def.innerType._def.checks || !def.innerType._def.checks.length)) {
		if (refs.target === "openApi3") return {
			type: primitiveMappings$2[def.innerType._def.typeName],
			nullable: true
		};
		return { type: [primitiveMappings$2[def.innerType._def.typeName], "null"] };
	}
	if (refs.target === "openApi3") {
		const base = parseDef$2(def.innerType._def, {
			...refs,
			currentPath: [...refs.currentPath]
		});
		if (base && "$ref" in base) return {
			allOf: [base],
			nullable: true
		};
		return base && {
			...base,
			nullable: true
		};
	}
	const base = parseDef$2(def.innerType._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			"0"
		]
	});
	return base && { anyOf: [base, { type: "null" }] };
}
function parseNumberDef$2(def, refs) {
	const res = { type: "number" };
	if (!def.checks) return res;
	for (const check of def.checks) switch (check.kind) {
		case "int":
			res.type = "integer";
			addErrorMessage(res, "type", check.message, refs);
			break;
		case "min":
			if (refs.target === "jsonSchema7") if (check.inclusive) setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			else setResponseValueAndErrors(res, "exclusiveMinimum", check.value, check.message, refs);
			else {
				if (!check.inclusive) res.exclusiveMinimum = true;
				setResponseValueAndErrors(res, "minimum", check.value, check.message, refs);
			}
			break;
		case "max":
			if (refs.target === "jsonSchema7") if (check.inclusive) setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			else setResponseValueAndErrors(res, "exclusiveMaximum", check.value, check.message, refs);
			else {
				if (!check.inclusive) res.exclusiveMaximum = true;
				setResponseValueAndErrors(res, "maximum", check.value, check.message, refs);
			}
			break;
		case "multipleOf":
			setResponseValueAndErrors(res, "multipleOf", check.value, check.message, refs);
			break;
	}
	return res;
}
function parseObjectDef$2(def, refs) {
	const forceOptionalIntoNullable = refs.target === "openAi";
	const result = {
		type: "object",
		properties: {}
	};
	const required = [];
	const shape = def.shape();
	for (const propName in shape) {
		let propDef = shape[propName];
		if (propDef === void 0 || propDef._def === void 0) continue;
		let propOptional = safeIsOptional$2(propDef);
		if (propOptional && forceOptionalIntoNullable) {
			if (propDef._def.typeName === "ZodOptional") propDef = propDef._def.innerType;
			if (!propDef.isNullable()) propDef = propDef.nullable();
			propOptional = false;
		}
		const parsedDef = parseDef$2(propDef._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"properties",
				propName
			],
			propertyPath: [
				...refs.currentPath,
				"properties",
				propName
			]
		});
		if (parsedDef === void 0) continue;
		result.properties[propName] = parsedDef;
		if (!propOptional) required.push(propName);
	}
	if (required.length) result.required = required;
	const additionalProperties = decideAdditionalProperties$2(def, refs);
	if (additionalProperties !== void 0) result.additionalProperties = additionalProperties;
	return result;
}
function decideAdditionalProperties$2(def, refs) {
	if (def.catchall._def.typeName !== "ZodNever") return parseDef$2(def.catchall._def, {
		...refs,
		currentPath: [...refs.currentPath, "additionalProperties"]
	});
	switch (def.unknownKeys) {
		case "passthrough": return refs.allowedAdditionalProperties;
		case "strict": return refs.rejectedAdditionalProperties;
		case "strip": return refs.removeAdditionalStrategy === "strict" ? refs.allowedAdditionalProperties : refs.rejectedAdditionalProperties;
	}
}
function safeIsOptional$2(schema) {
	try {
		return schema.isOptional();
	} catch {
		return true;
	}
}
const parseOptionalDef$2 = (def, refs) => {
	if (refs.currentPath.toString() === refs.propertyPath?.toString()) return parseDef$2(def.innerType._def, refs);
	const innerSchema = parseDef$2(def.innerType._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			"1"
		]
	});
	return innerSchema ? { anyOf: [{ not: parseAnyDef$2(refs) }, innerSchema] } : parseAnyDef$2(refs);
};
const parsePipelineDef$2 = (def, refs) => {
	if (refs.pipeStrategy === "input") return parseDef$2(def.in._def, refs);
	else if (refs.pipeStrategy === "output") return parseDef$2(def.out._def, refs);
	const a = parseDef$2(def.in._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"0"
		]
	});
	return { allOf: [a, parseDef$2(def.out._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			a ? "1" : "0"
		]
	})].filter((x) => x !== void 0) };
};
function parsePromiseDef$2(def, refs) {
	return parseDef$2(def.type._def, refs);
}
function parseSetDef$2(def, refs) {
	const schema = {
		type: "array",
		uniqueItems: true,
		items: parseDef$2(def.valueType._def, {
			...refs,
			currentPath: [...refs.currentPath, "items"]
		})
	};
	if (def.minSize) setResponseValueAndErrors(schema, "minItems", def.minSize.value, def.minSize.message, refs);
	if (def.maxSize) setResponseValueAndErrors(schema, "maxItems", def.maxSize.value, def.maxSize.message, refs);
	return schema;
}
function parseTupleDef$2(def, refs) {
	if (def.rest) return {
		type: "array",
		minItems: def.items.length,
		items: def.items.map((x, i) => parseDef$2(x._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"items",
				`${i}`
			]
		})).reduce((acc, x) => x === void 0 ? acc : [...acc, x], []),
		additionalItems: parseDef$2(def.rest._def, {
			...refs,
			currentPath: [...refs.currentPath, "additionalItems"]
		})
	};
	else return {
		type: "array",
		minItems: def.items.length,
		maxItems: def.items.length,
		items: def.items.map((x, i) => parseDef$2(x._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"items",
				`${i}`
			]
		})).reduce((acc, x) => x === void 0 ? acc : [...acc, x], [])
	};
}
function parseUndefinedDef$2(refs) {
	return { not: parseAnyDef$2(refs) };
}
function parseUnknownDef$2(refs) {
	return parseAnyDef$2(refs);
}
const parseReadonlyDef$2 = (def, refs) => {
	return parseDef$2(def.innerType._def, refs);
};
const selectParser$2 = (def, typeName, refs) => {
	switch (typeName) {
		case ZodFirstPartyTypeKind.ZodString: return parseStringDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodNumber: return parseNumberDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodObject: return parseObjectDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodBigInt: return parseBigintDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodBoolean: return parseBooleanDef$2();
		case ZodFirstPartyTypeKind.ZodDate: return parseDateDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodUndefined: return parseUndefinedDef$2(refs);
		case ZodFirstPartyTypeKind.ZodNull: return parseNullDef$2(refs);
		case ZodFirstPartyTypeKind.ZodArray: return parseArrayDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodUnion:
		case ZodFirstPartyTypeKind.ZodDiscriminatedUnion: return parseUnionDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodIntersection: return parseIntersectionDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodTuple: return parseTupleDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodRecord: return parseRecordDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodLiteral: return parseLiteralDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodEnum: return parseEnumDef$2(def);
		case ZodFirstPartyTypeKind.ZodNativeEnum: return parseNativeEnumDef$2(def);
		case ZodFirstPartyTypeKind.ZodNullable: return parseNullableDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodOptional: return parseOptionalDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodMap: return parseMapDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodSet: return parseSetDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodLazy: return () => def.getter()._def;
		case ZodFirstPartyTypeKind.ZodPromise: return parsePromiseDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodNaN:
		case ZodFirstPartyTypeKind.ZodNever: return parseNeverDef$2(refs);
		case ZodFirstPartyTypeKind.ZodEffects: return parseEffectsDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodAny: return parseAnyDef$2(refs);
		case ZodFirstPartyTypeKind.ZodUnknown: return parseUnknownDef$2(refs);
		case ZodFirstPartyTypeKind.ZodDefault: return parseDefaultDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodBranded: return parseBrandedDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodReadonly: return parseReadonlyDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodCatch: return parseCatchDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodPipeline: return parsePipelineDef$2(def, refs);
		case ZodFirstPartyTypeKind.ZodFunction:
		case ZodFirstPartyTypeKind.ZodVoid:
		case ZodFirstPartyTypeKind.ZodSymbol: return;
		default: return ((_) => void 0)(typeName);
	}
};
function parseDef$2(def, refs, forceResolution = false) {
	const seenItem = refs.seen.get(def);
	if (refs.override) {
		const overrideResult = refs.override?.(def, refs, seenItem, forceResolution);
		if (overrideResult !== ignoreOverride$2) return overrideResult;
	}
	if (seenItem && !forceResolution) {
		const seenSchema = get$ref$2(seenItem, refs);
		if (seenSchema !== void 0) return seenSchema;
	}
	const newItem = {
		def,
		path: refs.currentPath,
		jsonSchema: void 0
	};
	refs.seen.set(def, newItem);
	const jsonSchemaOrGetter = selectParser$2(def, def.typeName, refs);
	const jsonSchema = typeof jsonSchemaOrGetter === "function" ? parseDef$2(jsonSchemaOrGetter(), refs) : jsonSchemaOrGetter;
	if (jsonSchema) addMeta$2(def, refs, jsonSchema);
	if (refs.postProcess) {
		const postProcessResult = refs.postProcess(jsonSchema, def, refs);
		newItem.jsonSchema = jsonSchema;
		return postProcessResult;
	}
	newItem.jsonSchema = jsonSchema;
	return jsonSchema;
}
const get$ref$2 = (item, refs) => {
	switch (refs.$refStrategy) {
		case "root": return { $ref: item.path.join("/") };
		case "relative": return { $ref: getRelativePath$2(refs.currentPath, item.path) };
		case "none":
		case "seen":
			if (item.path.length < refs.currentPath.length && item.path.every((value, index) => refs.currentPath[index] === value)) {
				console.warn(`Recursive reference detected at ${refs.currentPath.join("/")}! Defaulting to any`);
				return parseAnyDef$2(refs);
			}
			return refs.$refStrategy === "seen" ? parseAnyDef$2(refs) : void 0;
	}
};
const addMeta$2 = (def, refs, jsonSchema) => {
	if (def.description) {
		jsonSchema.description = def.description;
		if (refs.markdownDescription) jsonSchema.markdownDescription = def.description;
	}
	return jsonSchema;
};
const zodToJsonSchema$1 = (schema, options) => {
	const refs = getRefs$2(options);
	let definitions = typeof options === "object" && options.definitions ? Object.entries(options.definitions).reduce((acc, [name, schema]) => ({
		...acc,
		[name]: parseDef$2(schema._def, {
			...refs,
			currentPath: [
				...refs.basePath,
				refs.definitionPath,
				name
			]
		}, true) ?? parseAnyDef$2(refs)
	}), {}) : void 0;
	const name = typeof options === "string" ? options : options?.nameStrategy === "title" ? void 0 : options?.name;
	const main = parseDef$2(schema._def, name === void 0 ? refs : {
		...refs,
		currentPath: [
			...refs.basePath,
			refs.definitionPath,
			name
		]
	}, false) ?? parseAnyDef$2(refs);
	const title = typeof options === "object" && options.name !== void 0 && options.nameStrategy === "title" ? options.name : void 0;
	if (title !== void 0) main.title = title;
	if (refs.flags.hasReferencedOpenAiAnyType) {
		if (!definitions) definitions = {};
		if (!definitions[refs.openAiAnyTypeName]) definitions[refs.openAiAnyTypeName] = {
			type: [
				"string",
				"number",
				"integer",
				"boolean",
				"array",
				"null"
			],
			items: { $ref: refs.$refStrategy === "relative" ? "1" : [
				...refs.basePath,
				refs.definitionPath,
				refs.openAiAnyTypeName
			].join("/") }
		};
	}
	const combined = name === void 0 ? definitions ? {
		...main,
		[refs.definitionPath]: definitions
	} : main : {
		$ref: [
			...refs.$refStrategy === "relative" ? [] : refs.basePath,
			refs.definitionPath,
			name
		].join("/"),
		[refs.definitionPath]: {
			...definitions,
			[name]: main
		}
	};
	if (refs.target === "jsonSchema7") combined.$schema = "http://json-schema.org/draft-07/schema#";
	else if (refs.target === "jsonSchema2019-09" || refs.target === "openAi") combined.$schema = "https://json-schema.org/draft/2019-09/schema#";
	if (refs.target === "openAi" && ("anyOf" in combined || "oneOf" in combined || "allOf" in combined || "type" in combined && Array.isArray(combined.type))) console.warn("Warning: OpenAI may not support schemas with unions as roots! Try wrapping it in an object property.");
	return combined;
};
var esm_default = zodToJsonSchema$1;
var textStreamPart = {
	code: "0",
	name: "text",
	parse: (value) => {
		if (typeof value !== "string") throw new Error("\"text\" parts expect a string value.");
		return {
			type: "text",
			value
		};
	}
};
var errorStreamPart = {
	code: "3",
	name: "error",
	parse: (value) => {
		if (typeof value !== "string") throw new Error("\"error\" parts expect a string value.");
		return {
			type: "error",
			value
		};
	}
};
var assistantMessageStreamPart = {
	code: "4",
	name: "assistant_message",
	parse: (value) => {
		if (value == null || typeof value !== "object" || !("id" in value) || !("role" in value) || !("content" in value) || typeof value.id !== "string" || typeof value.role !== "string" || value.role !== "assistant" || !Array.isArray(value.content) || !value.content.every((item) => item != null && typeof item === "object" && "type" in item && item.type === "text" && "text" in item && item.text != null && typeof item.text === "object" && "value" in item.text && typeof item.text.value === "string")) throw new Error("\"assistant_message\" parts expect an object with an \"id\", \"role\", and \"content\" property.");
		return {
			type: "assistant_message",
			value
		};
	}
};
var assistantControlDataStreamPart = {
	code: "5",
	name: "assistant_control_data",
	parse: (value) => {
		if (value == null || typeof value !== "object" || !("threadId" in value) || !("messageId" in value) || typeof value.threadId !== "string" || typeof value.messageId !== "string") throw new Error("\"assistant_control_data\" parts expect an object with a \"threadId\" and \"messageId\" property.");
		return {
			type: "assistant_control_data",
			value: {
				threadId: value.threadId,
				messageId: value.messageId
			}
		};
	}
};
var dataMessageStreamPart = {
	code: "6",
	name: "data_message",
	parse: (value) => {
		if (value == null || typeof value !== "object" || !("role" in value) || !("data" in value) || typeof value.role !== "string" || value.role !== "data") throw new Error("\"data_message\" parts expect an object with a \"role\" and \"data\" property.");
		return {
			type: "data_message",
			value
		};
	}
};
var assistantStreamParts = [
	textStreamPart,
	errorStreamPart,
	assistantMessageStreamPart,
	assistantControlDataStreamPart,
	dataMessageStreamPart
];
textStreamPart.code, errorStreamPart.code, assistantMessageStreamPart.code, assistantControlDataStreamPart.code, dataMessageStreamPart.code;
textStreamPart.name, textStreamPart.code, errorStreamPart.name, errorStreamPart.code, assistantMessageStreamPart.name, assistantMessageStreamPart.code, assistantControlDataStreamPart.name, assistantControlDataStreamPart.code, dataMessageStreamPart.name, dataMessageStreamPart.code;
assistantStreamParts.map((part) => part.code);
function fixJson$2(input) {
	const stack = ["ROOT"];
	let lastValidIndex = -1;
	let literalStart = null;
	function processValueStart(char, i, swapState) {
		switch (char) {
			case "\"":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_STRING");
				break;
			case "f":
			case "t":
			case "n":
				lastValidIndex = i;
				literalStart = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_LITERAL");
				break;
			case "-":
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "0":
			case "1":
			case "2":
			case "3":
			case "4":
			case "5":
			case "6":
			case "7":
			case "8":
			case "9":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "{":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_OBJECT_START");
				break;
			case "[":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_ARRAY_START");
				break;
		}
	}
	function processAfterObjectValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_OBJECT_AFTER_COMMA");
				break;
			case "}":
				lastValidIndex = i;
				stack.pop();
				break;
		}
	}
	function processAfterArrayValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_ARRAY_AFTER_COMMA");
				break;
			case "]":
				lastValidIndex = i;
				stack.pop();
				break;
		}
	}
	for (let i = 0; i < input.length; i++) {
		const char = input[i];
		switch (stack[stack.length - 1]) {
			case "ROOT":
				processValueStart(char, i, "FINISH");
				break;
			case "INSIDE_OBJECT_START":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
						break;
					case "}":
						lastValidIndex = i;
						stack.pop();
						break;
				}
				break;
			case "INSIDE_OBJECT_AFTER_COMMA":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
						break;
				}
				break;
			case "INSIDE_OBJECT_KEY":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_AFTER_KEY");
						break;
				}
				break;
			case "INSIDE_OBJECT_AFTER_KEY":
				switch (char) {
					case ":":
						stack.pop();
						stack.push("INSIDE_OBJECT_BEFORE_VALUE");
						break;
				}
				break;
			case "INSIDE_OBJECT_BEFORE_VALUE":
				processValueStart(char, i, "INSIDE_OBJECT_AFTER_VALUE");
				break;
			case "INSIDE_OBJECT_AFTER_VALUE":
				processAfterObjectValue(char, i);
				break;
			case "INSIDE_STRING":
				switch (char) {
					case "\"":
						stack.pop();
						lastValidIndex = i;
						break;
					case "\\":
						stack.push("INSIDE_STRING_ESCAPE");
						break;
					default: lastValidIndex = i;
				}
				break;
			case "INSIDE_ARRAY_START":
				switch (char) {
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default:
						lastValidIndex = i;
						processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
						break;
				}
				break;
			case "INSIDE_ARRAY_AFTER_VALUE":
				switch (char) {
					case ",":
						stack.pop();
						stack.push("INSIDE_ARRAY_AFTER_COMMA");
						break;
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default:
						lastValidIndex = i;
						break;
				}
				break;
			case "INSIDE_ARRAY_AFTER_COMMA":
				processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
				break;
			case "INSIDE_STRING_ESCAPE":
				stack.pop();
				lastValidIndex = i;
				break;
			case "INSIDE_NUMBER":
				switch (char) {
					case "0":
					case "1":
					case "2":
					case "3":
					case "4":
					case "5":
					case "6":
					case "7":
					case "8":
					case "9":
						lastValidIndex = i;
						break;
					case "e":
					case "E":
					case "-":
					case ".": break;
					case ",":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "}":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "]":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						break;
					default:
						stack.pop();
						break;
				}
				break;
			case "INSIDE_LITERAL": {
				const partialLiteral = input.substring(literalStart, i + 1);
				if (!"false".startsWith(partialLiteral) && !"true".startsWith(partialLiteral) && !"null".startsWith(partialLiteral)) {
					stack.pop();
					if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
					else if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
				} else lastValidIndex = i;
				break;
			}
		}
	}
	let result = input.slice(0, lastValidIndex + 1);
	for (let i = stack.length - 1; i >= 0; i--) switch (stack[i]) {
		case "INSIDE_STRING":
			result += "\"";
			break;
		case "INSIDE_OBJECT_KEY":
		case "INSIDE_OBJECT_AFTER_KEY":
		case "INSIDE_OBJECT_AFTER_COMMA":
		case "INSIDE_OBJECT_START":
		case "INSIDE_OBJECT_BEFORE_VALUE":
		case "INSIDE_OBJECT_AFTER_VALUE":
			result += "}";
			break;
		case "INSIDE_ARRAY_START":
		case "INSIDE_ARRAY_AFTER_COMMA":
		case "INSIDE_ARRAY_AFTER_VALUE":
			result += "]";
			break;
		case "INSIDE_LITERAL": {
			const partialLiteral = input.substring(literalStart, input.length);
			if ("true".startsWith(partialLiteral)) result += "true".slice(partialLiteral.length);
			else if ("false".startsWith(partialLiteral)) result += "false".slice(partialLiteral.length);
			else if ("null".startsWith(partialLiteral)) result += "null".slice(partialLiteral.length);
		}
	}
	return result;
}
function parsePartialJson$2(jsonText) {
	if (jsonText === void 0) return {
		value: void 0,
		state: "undefined-input"
	};
	let result = safeParseJSON$2({ text: jsonText });
	if (result.success) return {
		value: result.value,
		state: "successful-parse"
	};
	result = safeParseJSON$2({ text: fixJson$2(jsonText) });
	if (result.success) return {
		value: result.value,
		state: "repaired-parse"
	};
	return {
		value: void 0,
		state: "failed-parse"
	};
}
var dataStreamParts = [
	{
		code: "0",
		name: "text",
		parse: (value) => {
			if (typeof value !== "string") throw new Error("\"text\" parts expect a string value.");
			return {
				type: "text",
				value
			};
		}
	},
	{
		code: "2",
		name: "data",
		parse: (value) => {
			if (!Array.isArray(value)) throw new Error("\"data\" parts expect an array value.");
			return {
				type: "data",
				value
			};
		}
	},
	{
		code: "3",
		name: "error",
		parse: (value) => {
			if (typeof value !== "string") throw new Error("\"error\" parts expect a string value.");
			return {
				type: "error",
				value
			};
		}
	},
	{
		code: "8",
		name: "message_annotations",
		parse: (value) => {
			if (!Array.isArray(value)) throw new Error("\"message_annotations\" parts expect an array value.");
			return {
				type: "message_annotations",
				value
			};
		}
	},
	{
		code: "9",
		name: "tool_call",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("toolName" in value) || typeof value.toolName !== "string" || !("args" in value) || typeof value.args !== "object") throw new Error("\"tool_call\" parts expect an object with a \"toolCallId\", \"toolName\", and \"args\" property.");
			return {
				type: "tool_call",
				value
			};
		}
	},
	{
		code: "a",
		name: "tool_result",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("result" in value)) throw new Error("\"tool_result\" parts expect an object with a \"toolCallId\" and a \"result\" property.");
			return {
				type: "tool_result",
				value
			};
		}
	},
	{
		code: "b",
		name: "tool_call_streaming_start",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("toolName" in value) || typeof value.toolName !== "string") throw new Error("\"tool_call_streaming_start\" parts expect an object with a \"toolCallId\" and \"toolName\" property.");
			return {
				type: "tool_call_streaming_start",
				value
			};
		}
	},
	{
		code: "c",
		name: "tool_call_delta",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("toolCallId" in value) || typeof value.toolCallId !== "string" || !("argsTextDelta" in value) || typeof value.argsTextDelta !== "string") throw new Error("\"tool_call_delta\" parts expect an object with a \"toolCallId\" and \"argsTextDelta\" property.");
			return {
				type: "tool_call_delta",
				value
			};
		}
	},
	{
		code: "d",
		name: "finish_message",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("finishReason" in value) || typeof value.finishReason !== "string") throw new Error("\"finish_message\" parts expect an object with a \"finishReason\" property.");
			const result = { finishReason: value.finishReason };
			if ("usage" in value && value.usage != null && typeof value.usage === "object" && "promptTokens" in value.usage && "completionTokens" in value.usage) result.usage = {
				promptTokens: typeof value.usage.promptTokens === "number" ? value.usage.promptTokens : NaN,
				completionTokens: typeof value.usage.completionTokens === "number" ? value.usage.completionTokens : NaN
			};
			return {
				type: "finish_message",
				value: result
			};
		}
	},
	{
		code: "e",
		name: "finish_step",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("finishReason" in value) || typeof value.finishReason !== "string") throw new Error("\"finish_step\" parts expect an object with a \"finishReason\" property.");
			const result = {
				finishReason: value.finishReason,
				isContinued: false
			};
			if ("usage" in value && value.usage != null && typeof value.usage === "object" && "promptTokens" in value.usage && "completionTokens" in value.usage) result.usage = {
				promptTokens: typeof value.usage.promptTokens === "number" ? value.usage.promptTokens : NaN,
				completionTokens: typeof value.usage.completionTokens === "number" ? value.usage.completionTokens : NaN
			};
			if ("isContinued" in value && typeof value.isContinued === "boolean") result.isContinued = value.isContinued;
			return {
				type: "finish_step",
				value: result
			};
		}
	},
	{
		code: "f",
		name: "start_step",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("messageId" in value) || typeof value.messageId !== "string") throw new Error("\"start_step\" parts expect an object with an \"id\" property.");
			return {
				type: "start_step",
				value: { messageId: value.messageId }
			};
		}
	},
	{
		code: "g",
		name: "reasoning",
		parse: (value) => {
			if (typeof value !== "string") throw new Error("\"reasoning\" parts expect a string value.");
			return {
				type: "reasoning",
				value
			};
		}
	},
	{
		code: "h",
		name: "source",
		parse: (value) => {
			if (value == null || typeof value !== "object") throw new Error("\"source\" parts expect a Source object.");
			return {
				type: "source",
				value
			};
		}
	},
	{
		code: "i",
		name: "redacted_reasoning",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("data" in value) || typeof value.data !== "string") throw new Error("\"redacted_reasoning\" parts expect an object with a \"data\" property.");
			return {
				type: "redacted_reasoning",
				value: { data: value.data }
			};
		}
	},
	{
		code: "j",
		name: "reasoning_signature",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("signature" in value) || typeof value.signature !== "string") throw new Error("\"reasoning_signature\" parts expect an object with a \"signature\" property.");
			return {
				type: "reasoning_signature",
				value: { signature: value.signature }
			};
		}
	},
	{
		code: "k",
		name: "file",
		parse: (value) => {
			if (value == null || typeof value !== "object" || !("data" in value) || typeof value.data !== "string" || !("mimeType" in value) || typeof value.mimeType !== "string") throw new Error("\"file\" parts expect an object with a \"data\" and \"mimeType\" property.");
			return {
				type: "file",
				value
			};
		}
	}
];
Object.fromEntries(dataStreamParts.map((part) => [part.code, part]));
Object.fromEntries(dataStreamParts.map((part) => [part.name, part.code]));
dataStreamParts.map((part) => part.code);
function formatDataStreamPart(type, value) {
	const streamPart = dataStreamParts.find((part) => part.name === type);
	if (!streamPart) throw new Error(`Invalid stream part type: ${type}`);
	return `${streamPart.code}:${JSON.stringify(value)}
`;
}
"\n".charCodeAt(0);
"\n".charCodeAt(0);
function zodSchema$2(zodSchema2, options) {
	var _a;
	return jsonSchema$2(esm_default(zodSchema2, {
		$refStrategy: ((_a = options == null ? void 0 : options.useReferences) != null ? _a : false) ? "root" : "none",
		target: "jsonSchema7"
	}), { validate: (value) => {
		const result = zodSchema2.safeParse(value);
		return result.success ? {
			success: true,
			value: result.data
		} : {
			success: false,
			error: result.error
		};
	} });
}
var schemaSymbol$2 = Symbol.for("vercel.ai.schema");
function jsonSchema$2(jsonSchema2, { validate } = {}) {
	return {
		[schemaSymbol$2]: true,
		_type: void 0,
		[validatorSymbol$1]: true,
		jsonSchema: jsonSchema2,
		validate
	};
}
function isSchema$2(value) {
	return typeof value === "object" && value !== null && schemaSymbol$2 in value && value[schemaSymbol$2] === true && "jsonSchema" in value && "validate" in value;
}
function asSchema$2(schema) {
	return isSchema$2(schema) ? schema : zodSchema$2(schema);
}
/** only globals that common to node and browsers are allowed */
var _globalThis$1 = typeof globalThis === "object" ? globalThis : global;
var VERSION$6 = "1.9.0";
var re$2 = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
/**
* Create a function to test an API version to see if it is compatible with the provided ownVersion.
*
* The returned function has the following semantics:
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param ownVersion version which should be checked against
*/
function _makeCompatibilityCheck$2(ownVersion) {
	var acceptedVersions = /* @__PURE__ */ new Set([ownVersion]);
	var rejectedVersions = /* @__PURE__ */ new Set();
	var myVersionMatch = ownVersion.match(re$2);
	if (!myVersionMatch) return function() {
		return false;
	};
	var ownVersionParsed = {
		major: +myVersionMatch[1],
		minor: +myVersionMatch[2],
		patch: +myVersionMatch[3],
		prerelease: myVersionMatch[4]
	};
	if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
		return globalVersion === ownVersion;
	};
	function _reject(v) {
		rejectedVersions.add(v);
		return false;
	}
	function _accept(v) {
		acceptedVersions.add(v);
		return true;
	}
	return function isCompatible(globalVersion) {
		if (acceptedVersions.has(globalVersion)) return true;
		if (rejectedVersions.has(globalVersion)) return false;
		var globalVersionMatch = globalVersion.match(re$2);
		if (!globalVersionMatch) return _reject(globalVersion);
		var globalVersionParsed = {
			major: +globalVersionMatch[1],
			minor: +globalVersionMatch[2],
			patch: +globalVersionMatch[3],
			prerelease: globalVersionMatch[4]
		};
		if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
		if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
		if (ownVersionParsed.major === 0) {
			if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
			return _reject(globalVersion);
		}
		if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
		return _reject(globalVersion);
	};
}
/**
* Test an API version to see if it is compatible with this API.
*
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param version version of the API requesting an instance of the global API
*/
var isCompatible$2 = _makeCompatibilityCheck$2(VERSION$6);
var major$2 = VERSION$6.split(".")[0];
var GLOBAL_OPENTELEMETRY_API_KEY$2 = Symbol.for("opentelemetry.js.api." + major$2);
var _global$2 = _globalThis$1;
function registerGlobal$2(type, instance, diag, allowOverride) {
	var _a;
	if (allowOverride === void 0) allowOverride = false;
	var api = _global$2[GLOBAL_OPENTELEMETRY_API_KEY$2] = (_a = _global$2[GLOBAL_OPENTELEMETRY_API_KEY$2]) !== null && _a !== void 0 ? _a : { version: VERSION$6 };
	if (!allowOverride && api[type]) {
		var err = /* @__PURE__ */ new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
		diag.error(err.stack || err.message);
		return false;
	}
	if (api.version !== "1.9.0") {
		var err = /* @__PURE__ */ new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + VERSION$6);
		diag.error(err.stack || err.message);
		return false;
	}
	api[type] = instance;
	diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + VERSION$6 + ".");
	return true;
}
function getGlobal$2(type) {
	var _a, _b;
	var globalVersion = (_a = _global$2[GLOBAL_OPENTELEMETRY_API_KEY$2]) === null || _a === void 0 ? void 0 : _a.version;
	if (!globalVersion || !isCompatible$2(globalVersion)) return;
	return (_b = _global$2[GLOBAL_OPENTELEMETRY_API_KEY$2]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal$2(type, diag) {
	diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + VERSION$6 + ".");
	var api = _global$2[GLOBAL_OPENTELEMETRY_API_KEY$2];
	if (api) delete api[type];
}
var __read$3$1 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$3$1 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
/**
* Component Logger which is meant to be used as part of any component which
* will add automatically additional namespace in front of the log message.
* It will then forward all message to global diag logger
* @example
* const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
* cLogger.debug('test');
* // @opentelemetry/instrumentation-http test
*/
var DiagComponentLogger$2 = function() {
	function DiagComponentLogger(props) {
		this._namespace = props.namespace || "DiagComponentLogger";
	}
	DiagComponentLogger.prototype.debug = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$2("debug", this._namespace, args);
	};
	DiagComponentLogger.prototype.error = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$2("error", this._namespace, args);
	};
	DiagComponentLogger.prototype.info = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$2("info", this._namespace, args);
	};
	DiagComponentLogger.prototype.warn = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$2("warn", this._namespace, args);
	};
	DiagComponentLogger.prototype.verbose = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$2("verbose", this._namespace, args);
	};
	return DiagComponentLogger;
}();
function logProxy$2(funcName, namespace, args) {
	var logger = getGlobal$2("diag");
	if (!logger) return;
	args.unshift(namespace);
	return logger[funcName].apply(logger, __spreadArray$3$1([], __read$3$1(args), false));
}
/**
* Defines the available internal logging levels for the diagnostic logger, the numeric values
* of the levels are defined to match the original values from the initial LogLevel to avoid
* compatibility/migration issues for any implementation that assume the numeric ordering.
*/
var DiagLogLevel$2;
(function(DiagLogLevel) {
	/** Diagnostic Logging level setting to disable all logging (except and forced logs) */
	DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
	/** Identifies an error scenario */
	DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
	/** Identifies a warning scenario */
	DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
	/** General informational log message */
	DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
	/** General debug log message */
	DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
	/**
	* Detailed trace level logging should only be used for development, should only be set
	* in a development environment.
	*/
	DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
	/** Used to set the logging level to include all logging */
	DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel$2 || (DiagLogLevel$2 = {}));
function createLogLevelDiagLogger$2(maxLevel, logger) {
	if (maxLevel < DiagLogLevel$2.NONE) maxLevel = DiagLogLevel$2.NONE;
	else if (maxLevel > DiagLogLevel$2.ALL) maxLevel = DiagLogLevel$2.ALL;
	logger = logger || {};
	function _filterFunc(funcName, theLevel) {
		var theFunc = logger[funcName];
		if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger);
		return function() {};
	}
	return {
		error: _filterFunc("error", DiagLogLevel$2.ERROR),
		warn: _filterFunc("warn", DiagLogLevel$2.WARN),
		info: _filterFunc("info", DiagLogLevel$2.INFO),
		debug: _filterFunc("debug", DiagLogLevel$2.DEBUG),
		verbose: _filterFunc("verbose", DiagLogLevel$2.VERBOSE)
	};
}
var __read$2$1 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$2$1 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$2$4 = "diag";
/**
* Singleton object which represents the entry point to the OpenTelemetry internal
* diagnostic API
*/
var DiagAPI$2 = function() {
	/**
	* Private internal constructor
	* @private
	*/
	function DiagAPI() {
		function _logProxy(funcName) {
			return function() {
				var args = [];
				for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
				var logger = getGlobal$2("diag");
				if (!logger) return;
				return logger[funcName].apply(logger, __spreadArray$2$1([], __read$2$1(args), false));
			};
		}
		var self = this;
		var setLogger = function(logger, optionsOrLogLevel) {
			var _a, _b, _c;
			if (optionsOrLogLevel === void 0) optionsOrLogLevel = { logLevel: DiagLogLevel$2.INFO };
			if (logger === self) {
				var err = /* @__PURE__ */ new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
				self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
				return false;
			}
			if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = { logLevel: optionsOrLogLevel };
			var oldLogger = getGlobal$2("diag");
			var newLogger = createLogLevelDiagLogger$2((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : DiagLogLevel$2.INFO, logger);
			if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
				var stack = (_c = (/* @__PURE__ */ new Error()).stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
				oldLogger.warn("Current logger will be overwritten from " + stack);
				newLogger.warn("Current logger will overwrite one already registered from " + stack);
			}
			return registerGlobal$2("diag", newLogger, self, true);
		};
		self.setLogger = setLogger;
		self.disable = function() {
			unregisterGlobal$2(API_NAME$2$4, self);
		};
		self.createComponentLogger = function(options) {
			return new DiagComponentLogger$2(options);
		};
		self.verbose = _logProxy("verbose");
		self.debug = _logProxy("debug");
		self.info = _logProxy("info");
		self.warn = _logProxy("warn");
		self.error = _logProxy("error");
	}
	/** Get the singleton instance of the DiagAPI API */
	DiagAPI.instance = function() {
		if (!this._instance) this._instance = new DiagAPI();
		return this._instance;
	};
	return DiagAPI;
}();
/** Get a key to uniquely identify a context value */
function createContextKey$2(description) {
	return Symbol.for(description);
}
/** The root context is used as the default parent context when there is no active context */
var ROOT_CONTEXT$2 = new (function() {
	/**
	* Construct a new context which inherits values from an optional parent context.
	*
	* @param parentContext a context from which to inherit values
	*/
	function BaseContext(parentContext) {
		var self = this;
		self._currentContext = parentContext ? new Map(parentContext) : /* @__PURE__ */ new Map();
		self.getValue = function(key) {
			return self._currentContext.get(key);
		};
		self.setValue = function(key, value) {
			var context = new BaseContext(self._currentContext);
			context._currentContext.set(key, value);
			return context;
		};
		self.deleteValue = function(key) {
			var context = new BaseContext(self._currentContext);
			context._currentContext.delete(key);
			return context;
		};
	}
	return BaseContext;
}())();
var __read$1$1 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$1$1 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var NoopContextManager$2 = function() {
	function NoopContextManager() {}
	NoopContextManager.prototype.active = function() {
		return ROOT_CONTEXT$2;
	};
	NoopContextManager.prototype.with = function(_context, fn, thisArg) {
		var args = [];
		for (var _i = 3; _i < arguments.length; _i++) args[_i - 3] = arguments[_i];
		return fn.call.apply(fn, __spreadArray$1$1([thisArg], __read$1$1(args), false));
	};
	NoopContextManager.prototype.bind = function(_context, target) {
		return target;
	};
	NoopContextManager.prototype.enable = function() {
		return this;
	};
	NoopContextManager.prototype.disable = function() {
		return this;
	};
	return NoopContextManager;
}();
var __read$4 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$4 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$1$3 = "context";
var NOOP_CONTEXT_MANAGER$2 = new NoopContextManager$2();
/**
* Singleton object which represents the entry point to the OpenTelemetry Context API
*/
var ContextAPI$2 = function() {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	function ContextAPI() {}
	/** Get the singleton instance of the Context API */
	ContextAPI.getInstance = function() {
		if (!this._instance) this._instance = new ContextAPI();
		return this._instance;
	};
	/**
	* Set the current context manager.
	*
	* @returns true if the context manager was successfully registered, else false
	*/
	ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
		return registerGlobal$2(API_NAME$1$3, contextManager, DiagAPI$2.instance());
	};
	/**
	* Get the currently active context
	*/
	ContextAPI.prototype.active = function() {
		return this._getContextManager().active();
	};
	/**
	* Execute a function with an active context
	*
	* @param context context to be active during function execution
	* @param fn function to execute in a context
	* @param thisArg optional receiver to be used for calling fn
	* @param args optional arguments forwarded to fn
	*/
	ContextAPI.prototype.with = function(context, fn, thisArg) {
		var _a;
		var args = [];
		for (var _i = 3; _i < arguments.length; _i++) args[_i - 3] = arguments[_i];
		return (_a = this._getContextManager()).with.apply(_a, __spreadArray$4([
			context,
			fn,
			thisArg
		], __read$4(args), false));
	};
	/**
	* Bind a context to a target function or event emitter
	*
	* @param context context to bind to the event emitter or function. Defaults to the currently active context
	* @param target function or event emitter to bind
	*/
	ContextAPI.prototype.bind = function(context, target) {
		return this._getContextManager().bind(context, target);
	};
	ContextAPI.prototype._getContextManager = function() {
		return getGlobal$2(API_NAME$1$3) || NOOP_CONTEXT_MANAGER$2;
	};
	/** Disable and remove the global context manager */
	ContextAPI.prototype.disable = function() {
		this._getContextManager().disable();
		unregisterGlobal$2(API_NAME$1$3, DiagAPI$2.instance());
	};
	return ContextAPI;
}();
var TraceFlags$2;
(function(TraceFlags) {
	/** Represents no flag set. */
	TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
	/** Bit to represent whether trace is sampled in trace flags. */
	TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags$2 || (TraceFlags$2 = {}));
var INVALID_SPAN_CONTEXT$2 = {
	traceId: "00000000000000000000000000000000",
	spanId: "0000000000000000",
	traceFlags: TraceFlags$2.NONE
};
/**
* The NonRecordingSpan is the default {@link Span} that is used when no Span
* implementation is available. All operations are no-op including context
* propagation.
*/
var NonRecordingSpan$2 = function() {
	function NonRecordingSpan(_spanContext) {
		if (_spanContext === void 0) _spanContext = INVALID_SPAN_CONTEXT$2;
		this._spanContext = _spanContext;
	}
	NonRecordingSpan.prototype.spanContext = function() {
		return this._spanContext;
	};
	NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
		return this;
	};
	NonRecordingSpan.prototype.setAttributes = function(_attributes) {
		return this;
	};
	NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
		return this;
	};
	NonRecordingSpan.prototype.addLink = function(_link) {
		return this;
	};
	NonRecordingSpan.prototype.addLinks = function(_links) {
		return this;
	};
	NonRecordingSpan.prototype.setStatus = function(_status) {
		return this;
	};
	NonRecordingSpan.prototype.updateName = function(_name) {
		return this;
	};
	NonRecordingSpan.prototype.end = function(_endTime) {};
	NonRecordingSpan.prototype.isRecording = function() {
		return false;
	};
	NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
	return NonRecordingSpan;
}();
/**
* span key
*/
var SPAN_KEY$2 = createContextKey$2("OpenTelemetry Context Key SPAN");
/**
* Return the span if one exists
*
* @param context context to get span from
*/
function getSpan$2(context) {
	return context.getValue(SPAN_KEY$2) || void 0;
}
/**
* Gets the span from the current context, if one exists.
*/
function getActiveSpan$2() {
	return getSpan$2(ContextAPI$2.getInstance().active());
}
/**
* Set the span on a context
*
* @param context context to use as parent
* @param span span to set active
*/
function setSpan$2(context, span) {
	return context.setValue(SPAN_KEY$2, span);
}
/**
* Remove current span stored in the context
*
* @param context context to delete span from
*/
function deleteSpan$2(context) {
	return context.deleteValue(SPAN_KEY$2);
}
/**
* Wrap span context in a NoopSpan and set as span in a new
* context
*
* @param context context to set active span on
* @param spanContext span context to be wrapped
*/
function setSpanContext$2(context, spanContext) {
	return setSpan$2(context, new NonRecordingSpan$2(spanContext));
}
/**
* Get the span context of the span if it exists.
*
* @param context context to get values from
*/
function getSpanContext$2(context) {
	var _a;
	return (_a = getSpan$2(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}
var VALID_TRACEID_REGEX$1 = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX$1 = /^[0-9a-f]{16}$/i;
function isValidTraceId$2(traceId) {
	return VALID_TRACEID_REGEX$1.test(traceId) && traceId !== "00000000000000000000000000000000";
}
function isValidSpanId$2(spanId) {
	return VALID_SPANID_REGEX$1.test(spanId) && spanId !== "0000000000000000";
}
/**
* Returns true if this {@link SpanContext} is valid.
* @return true if this {@link SpanContext} is valid.
*/
function isSpanContextValid$2(spanContext) {
	return isValidTraceId$2(spanContext.traceId) && isValidSpanId$2(spanContext.spanId);
}
/**
* Wrap the given {@link SpanContext} in a new non-recording {@link Span}
*
* @param spanContext span context to be wrapped
* @returns a new non-recording {@link Span} with the provided context
*/
function wrapSpanContext$2(spanContext) {
	return new NonRecordingSpan$2(spanContext);
}
var contextApi$2 = ContextAPI$2.getInstance();
/**
* No-op implementations of {@link Tracer}.
*/
var NoopTracer$2 = function() {
	function NoopTracer() {}
	NoopTracer.prototype.startSpan = function(name, options, context) {
		if (context === void 0) context = contextApi$2.active();
		if (Boolean(options === null || options === void 0 ? void 0 : options.root)) return new NonRecordingSpan$2();
		var parentFromContext = context && getSpanContext$2(context);
		if (isSpanContext$2(parentFromContext) && isSpanContextValid$2(parentFromContext)) return new NonRecordingSpan$2(parentFromContext);
		else return new NonRecordingSpan$2();
	};
	NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
		var opts;
		var ctx;
		var fn;
		if (arguments.length < 2) return;
		else if (arguments.length === 2) fn = arg2;
		else if (arguments.length === 3) {
			opts = arg2;
			fn = arg3;
		} else {
			opts = arg2;
			ctx = arg3;
			fn = arg4;
		}
		var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi$2.active();
		var span = this.startSpan(name, opts, parentContext);
		var contextWithSpanSet = setSpan$2(parentContext, span);
		return contextApi$2.with(contextWithSpanSet, fn, void 0, span);
	};
	return NoopTracer;
}();
function isSpanContext$2(spanContext) {
	return typeof spanContext === "object" && typeof spanContext["spanId"] === "string" && typeof spanContext["traceId"] === "string" && typeof spanContext["traceFlags"] === "number";
}
var NOOP_TRACER$2 = new NoopTracer$2();
/**
* Proxy tracer provided by the proxy tracer provider
*/
var ProxyTracer$2 = function() {
	function ProxyTracer(_provider, name, version, options) {
		this._provider = _provider;
		this.name = name;
		this.version = version;
		this.options = options;
	}
	ProxyTracer.prototype.startSpan = function(name, options, context) {
		return this._getTracer().startSpan(name, options, context);
	};
	ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
		var tracer = this._getTracer();
		return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
	};
	/**
	* Try to get a tracer from the proxy tracer provider.
	* If the proxy tracer provider has no delegate, return a noop tracer.
	*/
	ProxyTracer.prototype._getTracer = function() {
		if (this._delegate) return this._delegate;
		var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
		if (!tracer) return NOOP_TRACER$2;
		this._delegate = tracer;
		return this._delegate;
	};
	return ProxyTracer;
}();
var NOOP_TRACER_PROVIDER$2 = new (function() {
	function NoopTracerProvider() {}
	NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
		return new NoopTracer$2();
	};
	return NoopTracerProvider;
}())();
/**
* Tracer provider which provides {@link ProxyTracer}s.
*
* Before a delegate is set, tracers provided are NoOp.
*   When a delegate is set, traces are provided from the delegate.
*   When a delegate is set after tracers have already been provided,
*   all tracers already provided will use the provided delegate implementation.
*/
var ProxyTracerProvider$2 = function() {
	function ProxyTracerProvider() {}
	/**
	* Get a {@link ProxyTracer}
	*/
	ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
		var _a;
		return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new ProxyTracer$2(this, name, version, options);
	};
	ProxyTracerProvider.prototype.getDelegate = function() {
		var _a;
		return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER$2;
	};
	/**
	* Set the delegate tracer provider
	*/
	ProxyTracerProvider.prototype.setDelegate = function(delegate) {
		this._delegate = delegate;
	};
	ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
		var _a;
		return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
	};
	return ProxyTracerProvider;
}();
/**
* An enumeration of status codes.
*/
var SpanStatusCode$2;
(function(SpanStatusCode) {
	/**
	* The default status.
	*/
	SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
	/**
	* The operation has been validated by an Application developer or
	* Operator to have completed successfully.
	*/
	SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
	/**
	* The operation contains an error.
	*/
	SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})(SpanStatusCode$2 || (SpanStatusCode$2 = {}));
var API_NAME$5 = "trace";
/** Entrypoint for trace API */
var trace$2 = function() {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	function TraceAPI() {
		this._proxyTracerProvider = new ProxyTracerProvider$2();
		this.wrapSpanContext = wrapSpanContext$2;
		this.isSpanContextValid = isSpanContextValid$2;
		this.deleteSpan = deleteSpan$2;
		this.getSpan = getSpan$2;
		this.getActiveSpan = getActiveSpan$2;
		this.getSpanContext = getSpanContext$2;
		this.setSpan = setSpan$2;
		this.setSpanContext = setSpanContext$2;
	}
	/** Get the singleton instance of the Trace API */
	TraceAPI.getInstance = function() {
		if (!this._instance) this._instance = new TraceAPI();
		return this._instance;
	};
	/**
	* Set the current global tracer.
	*
	* @returns true if the tracer provider was successfully registered, else false
	*/
	TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
		var success = registerGlobal$2(API_NAME$5, this._proxyTracerProvider, DiagAPI$2.instance());
		if (success) this._proxyTracerProvider.setDelegate(provider);
		return success;
	};
	/**
	* Returns the global tracer provider.
	*/
	TraceAPI.prototype.getTracerProvider = function() {
		return getGlobal$2(API_NAME$5) || this._proxyTracerProvider;
	};
	/**
	* Returns a tracer from the global tracer provider.
	*/
	TraceAPI.prototype.getTracer = function(name, version) {
		return this.getTracerProvider().getTracer(name, version);
	};
	/** Remove the global tracer provider */
	TraceAPI.prototype.disable = function() {
		unregisterGlobal$2(API_NAME$5, DiagAPI$2.instance());
		this._proxyTracerProvider = new ProxyTracerProvider$2();
	};
	return TraceAPI;
}().getInstance();
var __defProp$2 = Object.defineProperty;
var __export$2 = (target, all) => {
	for (var name17 in all) __defProp$2(target, name17, {
		get: all[name17],
		enumerable: true
	});
};
function prepareResponseHeaders(headers, { contentType, dataStreamVersion }) {
	const responseHeaders = new Headers(headers != null ? headers : {});
	if (!responseHeaders.has("Content-Type")) responseHeaders.set("Content-Type", contentType);
	if (dataStreamVersion !== void 0) responseHeaders.set("X-Vercel-AI-Data-Stream", dataStreamVersion);
	return responseHeaders;
}
var UnsupportedModelVersionError$2 = class extends AISDKError$2 {
	constructor() {
		super({
			name: "AI_UnsupportedModelVersionError",
			message: `Unsupported model version. AI SDK 4 only supports models that implement specification version "v1". Please upgrade to AI SDK 5 to use this model.`
		});
	}
};
var name$5 = "AI_InvalidArgumentError";
var marker$4 = `vercel.ai.error.${name$5}`;
var symbol$5 = Symbol.for(marker$4);
var _a$5;
var InvalidArgumentError$4 = class extends AISDKError$2 {
	constructor({ parameter, value, message }) {
		super({
			name: name$5,
			message: `Invalid argument for parameter ${parameter}: ${message}`
		});
		this[_a$5] = true;
		this.parameter = parameter;
		this.value = value;
	}
	static isInstance(error) {
		return AISDKError$2.hasMarker(error, marker$4);
	}
};
_a$5 = symbol$5;
var name2$5 = "AI_RetryError";
var marker2$5 = `vercel.ai.error.${name2$5}`;
var symbol2$5 = Symbol.for(marker2$5);
var _a2$5;
var RetryError$2 = class extends AISDKError$2 {
	constructor({ message, reason, errors }) {
		super({
			name: name2$5,
			message
		});
		this[_a2$5] = true;
		this.reason = reason;
		this.errors = errors;
		this.lastError = errors[errors.length - 1];
	}
	static isInstance(error) {
		return AISDKError$2.hasMarker(error, marker2$5);
	}
};
_a2$5 = symbol2$5;
var retryWithExponentialBackoff$1 = ({ maxRetries = 2, initialDelayInMs = 2e3, backoffFactor = 2 } = {}) => async (f) => _retryWithExponentialBackoff$1(f, {
	maxRetries,
	delayInMs: initialDelayInMs,
	backoffFactor
});
async function _retryWithExponentialBackoff$1(f, { maxRetries, delayInMs, backoffFactor }, errors = []) {
	try {
		return await f();
	} catch (error) {
		if (isAbortError$4(error)) throw error;
		if (maxRetries === 0) throw error;
		const errorMessage = getErrorMessage$3(error);
		const newErrors = [...errors, error];
		const tryNumber = newErrors.length;
		if (tryNumber > maxRetries) throw new RetryError$2({
			message: `Failed after ${tryNumber} attempts. Last error: ${errorMessage}`,
			reason: "maxRetriesExceeded",
			errors: newErrors
		});
		if (error instanceof Error && APICallError$2.isInstance(error) && error.isRetryable === true && tryNumber <= maxRetries) {
			await delay$2(delayInMs);
			return _retryWithExponentialBackoff$1(f, {
				maxRetries,
				delayInMs: backoffFactor * delayInMs,
				backoffFactor
			}, newErrors);
		}
		if (tryNumber === 1) throw error;
		throw new RetryError$2({
			message: `Failed after ${tryNumber} attempts with non-retryable error: '${errorMessage}'`,
			reason: "errorNotRetryable",
			errors: newErrors
		});
	}
}
function prepareRetries$2({ maxRetries }) {
	if (maxRetries != null) {
		if (!Number.isInteger(maxRetries)) throw new InvalidArgumentError$4({
			parameter: "maxRetries",
			value: maxRetries,
			message: "maxRetries must be an integer"
		});
		if (maxRetries < 0) throw new InvalidArgumentError$4({
			parameter: "maxRetries",
			value: maxRetries,
			message: "maxRetries must be >= 0"
		});
	}
	const maxRetriesResult = maxRetries != null ? maxRetries : 2;
	return {
		maxRetries: maxRetriesResult,
		retry: retryWithExponentialBackoff$1({ maxRetries: maxRetriesResult })
	};
}
function assembleOperationName$2({ operationId, telemetry }) {
	return {
		"operation.name": `${operationId}${(telemetry == null ? void 0 : telemetry.functionId) != null ? ` ${telemetry.functionId}` : ""}`,
		"resource.name": telemetry == null ? void 0 : telemetry.functionId,
		"ai.operationId": operationId,
		"ai.telemetry.functionId": telemetry == null ? void 0 : telemetry.functionId
	};
}
function getBaseTelemetryAttributes$2({ model, settings, telemetry, headers }) {
	var _a17;
	return {
		"ai.model.provider": model.provider,
		"ai.model.id": model.modelId,
		...Object.entries(settings).reduce((attributes, [key, value]) => {
			attributes[`ai.settings.${key}`] = value;
			return attributes;
		}, {}),
		...Object.entries((_a17 = telemetry == null ? void 0 : telemetry.metadata) != null ? _a17 : {}).reduce((attributes, [key, value]) => {
			attributes[`ai.telemetry.metadata.${key}`] = value;
			return attributes;
		}, {}),
		...Object.entries(headers != null ? headers : {}).reduce((attributes, [key, value]) => {
			if (value !== void 0) attributes[`ai.request.headers.${key}`] = value;
			return attributes;
		}, {})
	};
}
var noopTracer$2 = {
	startSpan() {
		return noopSpan$2;
	},
	startActiveSpan(name17, arg1, arg2, arg3) {
		if (typeof arg1 === "function") return arg1(noopSpan$2);
		if (typeof arg2 === "function") return arg2(noopSpan$2);
		if (typeof arg3 === "function") return arg3(noopSpan$2);
	}
};
var noopSpan$2 = {
	spanContext() {
		return noopSpanContext$2;
	},
	setAttribute() {
		return this;
	},
	setAttributes() {
		return this;
	},
	addEvent() {
		return this;
	},
	addLink() {
		return this;
	},
	addLinks() {
		return this;
	},
	setStatus() {
		return this;
	},
	updateName() {
		return this;
	},
	end() {
		return this;
	},
	isRecording() {
		return false;
	},
	recordException() {
		return this;
	}
};
var noopSpanContext$2 = {
	traceId: "",
	spanId: "",
	traceFlags: 0
};
function getTracer$2({ isEnabled = false, tracer } = {}) {
	if (!isEnabled) return noopTracer$2;
	if (tracer) return tracer;
	return trace$2.getTracer("ai");
}
function recordSpan$2({ name: name17, tracer, attributes, fn, endWhenDone = true }) {
	return tracer.startActiveSpan(name17, { attributes }, async (span) => {
		try {
			const result = await fn(span);
			if (endWhenDone) span.end();
			return result;
		} catch (error) {
			try {
				recordErrorOnSpan$2(span, error);
			} finally {
				span.end();
			}
			throw error;
		}
	});
}
function recordErrorOnSpan$2(span, error) {
	if (error instanceof Error) {
		span.recordException({
			name: error.name,
			message: error.message,
			stack: error.stack
		});
		span.setStatus({
			code: SpanStatusCode$2.ERROR,
			message: error.message
		});
	} else span.setStatus({ code: SpanStatusCode$2.ERROR });
}
function selectTelemetryAttributes$2({ telemetry, attributes }) {
	if ((telemetry == null ? void 0 : telemetry.isEnabled) !== true) return {};
	return Object.entries(attributes).reduce((attributes2, [key, value]) => {
		if (value === void 0) return attributes2;
		if (typeof value === "object" && "input" in value && typeof value.input === "function") {
			if ((telemetry == null ? void 0 : telemetry.recordInputs) === false) return attributes2;
			const result = value.input();
			return result === void 0 ? attributes2 : {
				...attributes2,
				[key]: result
			};
		}
		if (typeof value === "object" && "output" in value && typeof value.output === "function") {
			if ((telemetry == null ? void 0 : telemetry.recordOutputs) === false) return attributes2;
			const result = value.output();
			return result === void 0 ? attributes2 : {
				...attributes2,
				[key]: result
			};
		}
		return {
			...attributes2,
			[key]: value
		};
	}, {});
}
function splitArray$2(array, chunkSize) {
	if (chunkSize <= 0) throw new Error("chunkSize must be greater than 0");
	const result = [];
	for (let i = 0; i < array.length; i += chunkSize) result.push(array.slice(i, i + chunkSize));
	return result;
}
async function embedMany$2({ model, values, maxRetries: maxRetriesArg, abortSignal, headers, experimental_telemetry: telemetry }) {
	if (typeof model === "string" || model.specificationVersion !== "v1") throw new UnsupportedModelVersionError$2();
	const { maxRetries, retry } = prepareRetries$2({ maxRetries: maxRetriesArg });
	const baseTelemetryAttributes = getBaseTelemetryAttributes$2({
		model,
		telemetry,
		headers,
		settings: { maxRetries }
	});
	const tracer = getTracer$2(telemetry);
	return recordSpan$2({
		name: "ai.embedMany",
		attributes: selectTelemetryAttributes$2({
			telemetry,
			attributes: {
				...assembleOperationName$2({
					operationId: "ai.embedMany",
					telemetry
				}),
				...baseTelemetryAttributes,
				"ai.values": { input: () => values.map((value) => JSON.stringify(value)) }
			}
		}),
		tracer,
		fn: async (span) => {
			const maxEmbeddingsPerCall = model.maxEmbeddingsPerCall;
			if (maxEmbeddingsPerCall == null) {
				const { embeddings: embeddings2, usage } = await retry(() => {
					return recordSpan$2({
						name: "ai.embedMany.doEmbed",
						attributes: selectTelemetryAttributes$2({
							telemetry,
							attributes: {
								...assembleOperationName$2({
									operationId: "ai.embedMany.doEmbed",
									telemetry
								}),
								...baseTelemetryAttributes,
								"ai.values": { input: () => values.map((value) => JSON.stringify(value)) }
							}
						}),
						tracer,
						fn: async (doEmbedSpan) => {
							var _a17;
							const modelResponse = await model.doEmbed({
								values,
								abortSignal,
								headers
							});
							const embeddings3 = modelResponse.embeddings;
							const usage2 = (_a17 = modelResponse.usage) != null ? _a17 : { tokens: NaN };
							doEmbedSpan.setAttributes(selectTelemetryAttributes$2({
								telemetry,
								attributes: {
									"ai.embeddings": { output: () => embeddings3.map((embedding) => JSON.stringify(embedding)) },
									"ai.usage.tokens": usage2.tokens
								}
							}));
							return {
								embeddings: embeddings3,
								usage: usage2
							};
						}
					});
				});
				span.setAttributes(selectTelemetryAttributes$2({
					telemetry,
					attributes: {
						"ai.embeddings": { output: () => embeddings2.map((embedding) => JSON.stringify(embedding)) },
						"ai.usage.tokens": usage.tokens
					}
				}));
				return new DefaultEmbedManyResult$2({
					values,
					embeddings: embeddings2,
					usage
				});
			}
			const valueChunks = splitArray$2(values, maxEmbeddingsPerCall);
			const embeddings = [];
			let tokens = 0;
			for (const chunk of valueChunks) {
				const { embeddings: responseEmbeddings, usage } = await retry(() => {
					return recordSpan$2({
						name: "ai.embedMany.doEmbed",
						attributes: selectTelemetryAttributes$2({
							telemetry,
							attributes: {
								...assembleOperationName$2({
									operationId: "ai.embedMany.doEmbed",
									telemetry
								}),
								...baseTelemetryAttributes,
								"ai.values": { input: () => chunk.map((value) => JSON.stringify(value)) }
							}
						}),
						tracer,
						fn: async (doEmbedSpan) => {
							var _a17;
							const modelResponse = await model.doEmbed({
								values: chunk,
								abortSignal,
								headers
							});
							const embeddings2 = modelResponse.embeddings;
							const usage2 = (_a17 = modelResponse.usage) != null ? _a17 : { tokens: NaN };
							doEmbedSpan.setAttributes(selectTelemetryAttributes$2({
								telemetry,
								attributes: {
									"ai.embeddings": { output: () => embeddings2.map((embedding) => JSON.stringify(embedding)) },
									"ai.usage.tokens": usage2.tokens
								}
							}));
							return {
								embeddings: embeddings2,
								usage: usage2
							};
						}
					});
				});
				embeddings.push(...responseEmbeddings);
				tokens += usage.tokens;
			}
			span.setAttributes(selectTelemetryAttributes$2({
				telemetry,
				attributes: {
					"ai.embeddings": { output: () => embeddings.map((embedding) => JSON.stringify(embedding)) },
					"ai.usage.tokens": tokens
				}
			}));
			return new DefaultEmbedManyResult$2({
				values,
				embeddings,
				usage: { tokens }
			});
		}
	});
}
var DefaultEmbedManyResult$2 = class {
	constructor(options) {
		this.values = options.values;
		this.embeddings = options.embeddings;
		this.usage = options.usage;
	}
};
var name4$5 = "AI_NoObjectGeneratedError";
var marker4$5 = `vercel.ai.error.${name4$5}`;
var symbol4$5 = Symbol.for(marker4$5);
var _a4$5;
var NoObjectGeneratedError$2 = class extends AISDKError$2 {
	constructor({ message = "No object generated.", cause, text: text2, response, usage, finishReason }) {
		super({
			name: name4$5,
			message,
			cause
		});
		this[_a4$5] = true;
		this.text = text2;
		this.response = response;
		this.usage = usage;
		this.finishReason = finishReason;
	}
	static isInstance(error) {
		return AISDKError$2.hasMarker(error, marker4$5);
	}
};
_a4$5 = symbol4$5;
var dataContentSchema$2 = z.union([
	z.string(),
	z.instanceof(Uint8Array),
	z.instanceof(ArrayBuffer),
	z.custom((value) => {
		var _a17, _b;
		return (_b = (_a17 = globalThis.Buffer) == null ? void 0 : _a17.isBuffer(value)) != null ? _b : false;
	}, { message: "Must be a Buffer" })
]);
var jsonValueSchema$2 = z.lazy(() => z.union([
	z.null(),
	z.string(),
	z.number(),
	z.boolean(),
	z.record(z.string(), jsonValueSchema$2),
	z.array(jsonValueSchema$2)
]));
var providerMetadataSchema$2 = z.record(z.string(), z.record(z.string(), jsonValueSchema$2));
var toolResultContentSchema = z.array(z.union([z.object({
	type: z.literal("text"),
	text: z.string()
}), z.object({
	type: z.literal("image"),
	data: z.string(),
	mimeType: z.string().optional()
})]));
var textPartSchema$2 = z.object({
	type: z.literal("text"),
	text: z.string(),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var imagePartSchema$2 = z.object({
	type: z.literal("image"),
	image: z.union([dataContentSchema$2, z.instanceof(URL)]),
	mimeType: z.string().optional(),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var filePartSchema$2 = z.object({
	type: z.literal("file"),
	data: z.union([dataContentSchema$2, z.instanceof(URL)]),
	filename: z.string().optional(),
	mimeType: z.string(),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var reasoningPartSchema$2 = z.object({
	type: z.literal("reasoning"),
	text: z.string(),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var redactedReasoningPartSchema = z.object({
	type: z.literal("redacted-reasoning"),
	data: z.string(),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var toolCallPartSchema$2 = z.object({
	type: z.literal("tool-call"),
	toolCallId: z.string(),
	toolName: z.string(),
	args: z.unknown(),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var toolResultPartSchema$2 = z.object({
	type: z.literal("tool-result"),
	toolCallId: z.string(),
	toolName: z.string(),
	result: z.unknown(),
	content: toolResultContentSchema.optional(),
	isError: z.boolean().optional(),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var coreSystemMessageSchema = z.object({
	role: z.literal("system"),
	content: z.string(),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var coreUserMessageSchema = z.object({
	role: z.literal("user"),
	content: z.union([z.string(), z.array(z.union([
		textPartSchema$2,
		imagePartSchema$2,
		filePartSchema$2
	]))]),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var coreAssistantMessageSchema = z.object({
	role: z.literal("assistant"),
	content: z.union([z.string(), z.array(z.union([
		textPartSchema$2,
		filePartSchema$2,
		reasoningPartSchema$2,
		redactedReasoningPartSchema,
		toolCallPartSchema$2
	]))]),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
var coreToolMessageSchema = z.object({
	role: z.literal("tool"),
	content: z.array(toolResultPartSchema$2),
	providerOptions: providerMetadataSchema$2.optional(),
	experimental_providerMetadata: providerMetadataSchema$2.optional()
});
z.union([
	coreSystemMessageSchema,
	coreUserMessageSchema,
	coreAssistantMessageSchema,
	coreToolMessageSchema
]);
var DEFAULT_SCHEMA_PREFIX = "JSON schema:";
var DEFAULT_SCHEMA_SUFFIX = "You MUST answer with a JSON object that matches the JSON schema above.";
var DEFAULT_GENERIC_SUFFIX = "You MUST answer with JSON.";
function injectJsonInstruction({ prompt, schema, schemaPrefix = schema != null ? DEFAULT_SCHEMA_PREFIX : void 0, schemaSuffix = schema != null ? DEFAULT_SCHEMA_SUFFIX : DEFAULT_GENERIC_SUFFIX }) {
	return [
		prompt != null && prompt.length > 0 ? prompt : void 0,
		prompt != null && prompt.length > 0 ? "" : void 0,
		schemaPrefix,
		schema != null ? JSON.stringify(schema) : void 0,
		schemaSuffix
	].filter((line) => line != null).join("\n");
}
createIdGenerator$2({
	prefix: "aiobj",
	size: 24
});
createIdGenerator$2({
	prefix: "aiobj",
	size: 24
});
createIdGenerator$2({
	prefix: "aitxt",
	size: 24
});
createIdGenerator$2({
	prefix: "msg",
	size: 24
});
__export$2({}, {
	object: () => object$2,
	text: () => text$2
});
var text$2 = () => ({
	type: "text",
	responseFormat: () => ({ type: "text" }),
	injectIntoSystemPrompt({ system }) {
		return system;
	},
	parsePartial({ text: text2 }) {
		return { partial: text2 };
	},
	parseOutput({ text: text2 }) {
		return text2;
	}
});
var object$2 = ({ schema: inputSchema }) => {
	const schema = asSchema$2(inputSchema);
	return {
		type: "object",
		responseFormat: ({ model }) => ({
			type: "json",
			schema: model.supportsStructuredOutputs ? schema.jsonSchema : void 0
		}),
		injectIntoSystemPrompt({ system, model }) {
			return model.supportsStructuredOutputs ? system : injectJsonInstruction({
				prompt: system,
				schema: schema.jsonSchema
			});
		},
		parsePartial({ text: text2 }) {
			const result = parsePartialJson$2(text2);
			switch (result.state) {
				case "failed-parse":
				case "undefined-input": return;
				case "repaired-parse":
				case "successful-parse": return { partial: result.value };
				default: {
					const _exhaustiveCheck = result.state;
					throw new Error(`Unsupported parse state: ${_exhaustiveCheck}`);
				}
			}
		},
		parseOutput({ text: text2 }, context) {
			const parseResult = safeParseJSON$2({ text: text2 });
			if (!parseResult.success) throw new NoObjectGeneratedError$2({
				message: "No object generated: could not parse the response.",
				cause: parseResult.error,
				text: text2,
				response: context.response,
				usage: context.usage,
				finishReason: context.finishReason
			});
			const validationResult = safeValidateTypes$2({
				value: parseResult.value,
				schema
			});
			if (!validationResult.success) throw new NoObjectGeneratedError$2({
				message: "No object generated: response did not match schema.",
				cause: validationResult.error,
				text: text2,
				response: context.response,
				usage: context.usage,
				finishReason: context.finishReason
			});
			return validationResult.value;
		}
	};
};
function mergeStreams(stream1, stream2) {
	const reader1 = stream1.getReader();
	const reader2 = stream2.getReader();
	let lastRead1 = void 0;
	let lastRead2 = void 0;
	let stream1Done = false;
	let stream2Done = false;
	async function readStream1(controller) {
		try {
			if (lastRead1 == null) lastRead1 = reader1.read();
			const result = await lastRead1;
			lastRead1 = void 0;
			if (!result.done) controller.enqueue(result.value);
			else controller.close();
		} catch (error) {
			controller.error(error);
		}
	}
	async function readStream2(controller) {
		try {
			if (lastRead2 == null) lastRead2 = reader2.read();
			const result = await lastRead2;
			lastRead2 = void 0;
			if (!result.done) controller.enqueue(result.value);
			else controller.close();
		} catch (error) {
			controller.error(error);
		}
	}
	return new ReadableStream({
		async pull(controller) {
			try {
				if (stream1Done) {
					await readStream2(controller);
					return;
				}
				if (stream2Done) {
					await readStream1(controller);
					return;
				}
				if (lastRead1 == null) lastRead1 = reader1.read();
				if (lastRead2 == null) lastRead2 = reader2.read();
				const { result, reader } = await Promise.race([lastRead1.then((result2) => ({
					result: result2,
					reader: reader1
				})), lastRead2.then((result2) => ({
					result: result2,
					reader: reader2
				}))]);
				if (!result.done) controller.enqueue(result.value);
				if (reader === reader1) {
					lastRead1 = void 0;
					if (result.done) {
						await readStream2(controller);
						stream1Done = true;
					}
				} else {
					lastRead2 = void 0;
					if (result.done) {
						stream2Done = true;
						await readStream1(controller);
					}
				}
			} catch (error) {
				controller.error(error);
			}
		},
		cancel() {
			reader1.cancel();
			reader2.cancel();
		}
	});
}
createIdGenerator$2({
	prefix: "aitxt",
	size: 24
});
createIdGenerator$2({
	prefix: "msg",
	size: 24
});
var ClientOrServerImplementationSchema = z.object({
	name: z.string(),
	version: z.string()
}).passthrough();
var BaseParamsSchema = z.object({ _meta: z.optional(z.object({}).passthrough()) }).passthrough();
var ResultSchema = BaseParamsSchema;
var RequestSchema = z.object({
	method: z.string(),
	params: z.optional(BaseParamsSchema)
});
var ServerCapabilitiesSchema = z.object({
	experimental: z.optional(z.object({}).passthrough()),
	logging: z.optional(z.object({}).passthrough()),
	prompts: z.optional(z.object({ listChanged: z.optional(z.boolean()) }).passthrough()),
	resources: z.optional(z.object({
		subscribe: z.optional(z.boolean()),
		listChanged: z.optional(z.boolean())
	}).passthrough()),
	tools: z.optional(z.object({ listChanged: z.optional(z.boolean()) }).passthrough())
}).passthrough();
ResultSchema.extend({
	protocolVersion: z.string(),
	capabilities: ServerCapabilitiesSchema,
	serverInfo: ClientOrServerImplementationSchema,
	instructions: z.optional(z.string())
});
var PaginatedResultSchema = ResultSchema.extend({ nextCursor: z.optional(z.string()) });
var ToolSchema = z.object({
	name: z.string(),
	description: z.optional(z.string()),
	inputSchema: z.object({
		type: z.literal("object"),
		properties: z.optional(z.object({}).passthrough())
	}).passthrough()
}).passthrough();
PaginatedResultSchema.extend({ tools: z.array(ToolSchema) });
var TextContentSchema = z.object({
	type: z.literal("text"),
	text: z.string()
}).passthrough();
var ImageContentSchema = z.object({
	type: z.literal("image"),
	data: z.string().base64(),
	mimeType: z.string()
}).passthrough();
var ResourceContentsSchema = z.object({
	/**
	* The URI of this resource.
	*/
	uri: z.string(),
	/**
	* The MIME type of this resource, if known.
	*/
	mimeType: z.optional(z.string())
}).passthrough();
var TextResourceContentsSchema = ResourceContentsSchema.extend({ text: z.string() });
var BlobResourceContentsSchema = ResourceContentsSchema.extend({ blob: z.string().base64() });
var EmbeddedResourceSchema = z.object({
	type: z.literal("resource"),
	resource: z.union([TextResourceContentsSchema, BlobResourceContentsSchema])
}).passthrough();
ResultSchema.extend({
	content: z.array(z.union([
		TextContentSchema,
		ImageContentSchema,
		EmbeddedResourceSchema
	])),
	isError: z.boolean().default(false).optional()
}).or(ResultSchema.extend({ toolResult: z.unknown() }));
var JSONRPC_VERSION = "2.0";
var JSONRPCRequestSchema = z.object({
	jsonrpc: z.literal(JSONRPC_VERSION),
	id: z.union([z.string(), z.number().int()])
}).merge(RequestSchema).strict();
var JSONRPCResponseSchema = z.object({
	jsonrpc: z.literal(JSONRPC_VERSION),
	id: z.union([z.string(), z.number().int()]),
	result: ResultSchema
}).strict();
var JSONRPCErrorSchema = z.object({
	jsonrpc: z.literal(JSONRPC_VERSION),
	id: z.union([z.string(), z.number().int()]),
	error: z.object({
		code: z.number().int(),
		message: z.string(),
		data: z.optional(z.unknown())
	})
}).strict();
var JSONRPCNotificationSchema = z.object({ jsonrpc: z.literal(JSONRPC_VERSION) }).merge(z.object({
	method: z.string(),
	params: z.optional(BaseParamsSchema)
})).strict();
z.union([
	JSONRPCRequestSchema,
	JSONRPCNotificationSchema,
	JSONRPCResponseSchema,
	JSONRPCErrorSchema
]);
__export$2({}, {
	mergeIntoDataStream: () => mergeIntoDataStream,
	toDataStream: () => toDataStream,
	toDataStreamResponse: () => toDataStreamResponse
});
function createCallbacksTransformer(callbacks = {}) {
	const textEncoder = new TextEncoder();
	let aggregatedResponse = "";
	return new TransformStream({
		async start() {
			if (callbacks.onStart) await callbacks.onStart();
		},
		async transform(message, controller) {
			controller.enqueue(textEncoder.encode(message));
			aggregatedResponse += message;
			if (callbacks.onToken) await callbacks.onToken(message);
			if (callbacks.onText && typeof message === "string") await callbacks.onText(message);
		},
		async flush() {
			if (callbacks.onCompletion) await callbacks.onCompletion(aggregatedResponse);
			if (callbacks.onFinal) await callbacks.onFinal(aggregatedResponse);
		}
	});
}
function toDataStreamInternal(stream, callbacks) {
	return stream.pipeThrough(new TransformStream({ transform: async (value, controller) => {
		var _a17;
		if (typeof value === "string") {
			controller.enqueue(value);
			return;
		}
		if ("event" in value) {
			if (value.event === "on_chat_model_stream") forwardAIMessageChunk((_a17 = value.data) == null ? void 0 : _a17.chunk, controller);
			return;
		}
		forwardAIMessageChunk(value, controller);
	} })).pipeThrough(createCallbacksTransformer(callbacks)).pipeThrough(new TextDecoderStream()).pipeThrough(new TransformStream({ transform: async (chunk, controller) => {
		controller.enqueue(formatDataStreamPart("text", chunk));
	} }));
}
function toDataStream(stream, callbacks) {
	return toDataStreamInternal(stream, callbacks).pipeThrough(new TextEncoderStream());
}
function toDataStreamResponse(stream, options) {
	var _a17;
	const dataStream = toDataStreamInternal(stream, options == null ? void 0 : options.callbacks).pipeThrough(new TextEncoderStream());
	const data = options == null ? void 0 : options.data;
	const init = options == null ? void 0 : options.init;
	const responseStream = data ? mergeStreams(data.stream, dataStream) : dataStream;
	return new Response(responseStream, {
		status: (_a17 = init == null ? void 0 : init.status) != null ? _a17 : 200,
		statusText: init == null ? void 0 : init.statusText,
		headers: prepareResponseHeaders(init == null ? void 0 : init.headers, {
			contentType: "text/plain; charset=utf-8",
			dataStreamVersion: "v1"
		})
	});
}
function mergeIntoDataStream(stream, options) {
	options.dataStream.merge(toDataStreamInternal(stream, options.callbacks));
}
function forwardAIMessageChunk(chunk, controller) {
	if (typeof chunk.content === "string") controller.enqueue(chunk.content);
	else {
		const content = chunk.content;
		for (const item of content) if (item.type === "text") controller.enqueue(item.text);
	}
}
__export$2({}, {
	mergeIntoDataStream: () => mergeIntoDataStream2,
	toDataStream: () => toDataStream2,
	toDataStreamResponse: () => toDataStreamResponse2
});
function toDataStreamInternal2(stream, callbacks) {
	const trimStart = trimStartOfStream();
	return convertAsyncIteratorToReadableStream(stream[Symbol.asyncIterator]()).pipeThrough(new TransformStream({ async transform(message, controller) {
		controller.enqueue(trimStart(message.delta));
	} })).pipeThrough(createCallbacksTransformer(callbacks)).pipeThrough(new TextDecoderStream()).pipeThrough(new TransformStream({ transform: async (chunk, controller) => {
		controller.enqueue(formatDataStreamPart("text", chunk));
	} }));
}
function toDataStream2(stream, callbacks) {
	return toDataStreamInternal2(stream, callbacks).pipeThrough(new TextEncoderStream());
}
function toDataStreamResponse2(stream, options = {}) {
	var _a17;
	const { init, data, callbacks } = options;
	const dataStream = toDataStreamInternal2(stream, callbacks).pipeThrough(new TextEncoderStream());
	const responseStream = data ? mergeStreams(data.stream, dataStream) : dataStream;
	return new Response(responseStream, {
		status: (_a17 = init == null ? void 0 : init.status) != null ? _a17 : 200,
		statusText: init == null ? void 0 : init.statusText,
		headers: prepareResponseHeaders(init == null ? void 0 : init.headers, {
			contentType: "text/plain; charset=utf-8",
			dataStreamVersion: "v1"
		})
	});
}
function mergeIntoDataStream2(stream, options) {
	options.dataStream.merge(toDataStreamInternal2(stream, options.callbacks));
}
function trimStartOfStream() {
	let isStreamStart = true;
	return (text2) => {
		if (isStreamStart) {
			text2 = text2.trimStart();
			if (text2) isStreamStart = false;
		}
		return text2;
	};
}
//#endregion
//#region ../_vendored/ai_v5/dist/dist-Qv-F35RT.js
var marker$1$4 = "vercel.ai.error";
var symbol$1$3 = Symbol.for(marker$1$4);
var _a$1$3;
var _b$1$4;
var AISDKError$1 = class _AISDKError extends (_b$1$4 = Error, _a$1$3 = symbol$1$3, _b$1$4) {
	/**
	* Creates an AI SDK Error.
	*
	* @param {Object} params - The parameters for creating the error.
	* @param {string} params.name - The name of the error.
	* @param {string} params.message - The error message.
	* @param {unknown} [params.cause] - The underlying cause of the error.
	*/
	constructor({ name: name14, message, cause }) {
		super(message);
		this[_a$1$3] = true;
		this.name = name14;
		this.cause = cause;
	}
	/**
	* Checks if the given error is an AI SDK Error.
	* @param {unknown} error - The error to check.
	* @returns {boolean} True if the error is an AI SDK Error, false otherwise.
	*/
	static isInstance(error) {
		return _AISDKError.hasMarker(error, marker$1$4);
	}
	static hasMarker(error, marker15) {
		const markerSymbol = Symbol.for(marker15);
		return error != null && typeof error === "object" && markerSymbol in error && typeof error[markerSymbol] === "boolean" && error[markerSymbol] === true;
	}
};
var name$1$3 = "AI_APICallError";
var marker2$4 = `vercel.ai.error.${name$1$3}`;
var symbol2$4 = Symbol.for(marker2$4);
var _a2$4;
var _b2$3;
var APICallError$1 = class extends (_b2$3 = AISDKError$1, _a2$4 = symbol2$4, _b2$3) {
	constructor({ message, url, requestBodyValues, statusCode, responseHeaders, responseBody, cause, isRetryable = statusCode != null && (statusCode === 408 || statusCode === 409 || statusCode === 429 || statusCode >= 500), data }) {
		super({
			name: name$1$3,
			message,
			cause
		});
		this[_a2$4] = true;
		this.url = url;
		this.requestBodyValues = requestBodyValues;
		this.statusCode = statusCode;
		this.responseHeaders = responseHeaders;
		this.responseBody = responseBody;
		this.isRetryable = isRetryable;
		this.data = data;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker2$4);
	}
};
var name2$4 = "AI_EmptyResponseBodyError";
var marker3$4 = `vercel.ai.error.${name2$4}`;
var symbol3$4 = Symbol.for(marker3$4);
var _a3$4;
var _b3$3;
var EmptyResponseBodyError$1 = class extends (_b3$3 = AISDKError$1, _a3$4 = symbol3$4, _b3$3) {
	constructor({ message = "Empty response body" } = {}) {
		super({
			name: name2$4,
			message
		});
		this[_a3$4] = true;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker3$4);
	}
};
function getErrorMessage$1$1(error) {
	if (error == null) return "unknown error";
	if (typeof error === "string") return error;
	if (error instanceof Error) return error.message;
	return JSON.stringify(error);
}
var name3$4 = "AI_InvalidArgumentError";
var marker4$4 = `vercel.ai.error.${name3$4}`;
var symbol4$4 = Symbol.for(marker4$4);
var _a4$4;
var _b4$3;
var InvalidArgumentError$3 = class extends (_b4$3 = AISDKError$1, _a4$4 = symbol4$4, _b4$3) {
	constructor({ message, cause, argument }) {
		super({
			name: name3$4,
			message,
			cause
		});
		this[_a4$4] = true;
		this.argument = argument;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker4$4);
	}
};
var name4$4 = "AI_InvalidPromptError";
var marker5$4 = `vercel.ai.error.${name4$4}`;
var symbol5$4 = Symbol.for(marker5$4);
var _a5$4;
var _b5$3;
(class extends (_b5$3 = AISDKError$1, _a5$4 = symbol5$4, _b5$3) {
	constructor({ prompt, message, cause }) {
		super({
			name: name4$4,
			message: `Invalid prompt: ${message}`,
			cause
		});
		this[_a5$4] = true;
		this.prompt = prompt;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker5$4);
	}
});
var name5$4 = "AI_InvalidResponseDataError";
var marker6$4 = `vercel.ai.error.${name5$4}`;
var symbol6$4 = Symbol.for(marker6$4);
var _a6$4;
var _b6$3;
(class extends (_b6$3 = AISDKError$1, _a6$4 = symbol6$4, _b6$3) {
	constructor({ data, message = `Invalid response data: ${JSON.stringify(data)}.` }) {
		super({
			name: name5$4,
			message
		});
		this[_a6$4] = true;
		this.data = data;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker6$4);
	}
});
var name6$4 = "AI_JSONParseError";
var marker7$4 = `vercel.ai.error.${name6$4}`;
var symbol7$4 = Symbol.for(marker7$4);
var _a7$4;
var _b7$3;
var JSONParseError$1 = class extends (_b7$3 = AISDKError$1, _a7$4 = symbol7$4, _b7$3) {
	constructor({ text, cause }) {
		super({
			name: name6$4,
			message: `JSON parsing failed: Text: ${text}.
Error message: ${getErrorMessage$1$1(cause)}`,
			cause
		});
		this[_a7$4] = true;
		this.text = text;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker7$4);
	}
};
var name7$4 = "AI_LoadAPIKeyError";
var marker8$4 = `vercel.ai.error.${name7$4}`;
var symbol8$4 = Symbol.for(marker8$4);
var _a8$4;
var _b8$3;
(class extends (_b8$3 = AISDKError$1, _a8$4 = symbol8$4, _b8$3) {
	constructor({ message }) {
		super({
			name: name7$4,
			message
		});
		this[_a8$4] = true;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker8$4);
	}
});
var name8$4 = "AI_LoadSettingError";
var marker9$4 = `vercel.ai.error.${name8$4}`;
var symbol9$4 = Symbol.for(marker9$4);
var _a9$4;
var _b9$3;
(class extends (_b9$3 = AISDKError$1, _a9$4 = symbol9$4, _b9$3) {
	constructor({ message }) {
		super({
			name: name8$4,
			message
		});
		this[_a9$4] = true;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker9$4);
	}
});
var name9$4 = "AI_NoContentGeneratedError";
var marker10$4 = `vercel.ai.error.${name9$4}`;
var symbol10$4 = Symbol.for(marker10$4);
var _a10$4;
var _b10$2;
(class extends (_b10$2 = AISDKError$1, _a10$4 = symbol10$4, _b10$2) {
	constructor({ message = "No content generated." } = {}) {
		super({
			name: name9$4,
			message
		});
		this[_a10$4] = true;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker10$4);
	}
});
var name10$3 = "AI_NoSuchModelError";
var marker11$3 = `vercel.ai.error.${name10$3}`;
var symbol11$3 = Symbol.for(marker11$3);
var _a11$3;
var _b11$1;
(class extends (_b11$1 = AISDKError$1, _a11$3 = symbol11$3, _b11$1) {
	constructor({ errorName = name10$3, modelId, modelType, message = `No such ${modelType}: ${modelId}` }) {
		super({
			name: errorName,
			message
		});
		this[_a11$3] = true;
		this.modelId = modelId;
		this.modelType = modelType;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker11$3);
	}
});
var name11$3 = "AI_TooManyEmbeddingValuesForCallError";
var marker12$3 = `vercel.ai.error.${name11$3}`;
var symbol12$3 = Symbol.for(marker12$3);
var _a12$3;
var _b12$1;
(class extends (_b12$1 = AISDKError$1, _a12$3 = symbol12$3, _b12$1) {
	constructor(options) {
		super({
			name: name11$3,
			message: `Too many values for a single embedding call. The ${options.provider} model "${options.modelId}" can only embed up to ${options.maxEmbeddingsPerCall} values per call, but ${options.values.length} values were provided.`
		});
		this[_a12$3] = true;
		this.provider = options.provider;
		this.modelId = options.modelId;
		this.maxEmbeddingsPerCall = options.maxEmbeddingsPerCall;
		this.values = options.values;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker12$3);
	}
});
var name12$3 = "AI_TypeValidationError";
var marker13$3 = `vercel.ai.error.${name12$3}`;
var symbol13$3 = Symbol.for(marker13$3);
var _a13$3;
var _b13$1;
var TypeValidationError$1 = class _TypeValidationError extends (_b13$1 = AISDKError$1, _a13$3 = symbol13$3, _b13$1) {
	constructor({ value, cause }) {
		super({
			name: name12$3,
			message: `Type validation failed: Value: ${JSON.stringify(value)}.
Error message: ${getErrorMessage$1$1(cause)}`,
			cause
		});
		this[_a13$3] = true;
		this.value = value;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker13$3);
	}
	/**
	* Wraps an error into a TypeValidationError.
	* If the cause is already a TypeValidationError with the same value, it returns the cause.
	* Otherwise, it creates a new TypeValidationError.
	*
	* @param {Object} params - The parameters for wrapping the error.
	* @param {unknown} params.value - The value that failed validation.
	* @param {unknown} params.cause - The original error or cause of the validation failure.
	* @returns {TypeValidationError} A TypeValidationError instance.
	*/
	static wrap({ value, cause }) {
		return _TypeValidationError.isInstance(cause) && cause.value === value ? cause : new _TypeValidationError({
			value,
			cause
		});
	}
};
var name13$3 = "AI_UnsupportedFunctionalityError";
var marker14$3 = `vercel.ai.error.${name13$3}`;
var symbol14$3 = Symbol.for(marker14$3);
var _a14$3;
var _b14$1;
(class extends (_b14$1 = AISDKError$1, _a14$3 = symbol14$3, _b14$1) {
	constructor({ functionality, message = `'${functionality}' functionality not supported.` }) {
		super({
			name: name13$3,
			message
		});
		this[_a14$3] = true;
		this.functionality = functionality;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker14$3);
	}
});
var ParseError$1 = class extends Error {
	constructor(message, options) {
		super(message), this.name = "ParseError", this.type = options.type, this.field = options.field, this.value = options.value, this.line = options.line;
	}
};
const LF$1 = 10;
const CR$1 = 13;
const SPACE$1 = 32;
function noop$1(_arg) {}
function createParser$1(callbacks) {
	if (typeof callbacks == "function") throw new TypeError("`callbacks` must be an object, got a function instead. Did you mean `{onEvent: fn}`?");
	const { onEvent = noop$1, onError = noop$1, onRetry = noop$1, onComment } = callbacks, pendingFragments = [];
	let isFirstChunk = !0, id, data = "", dataLines = 0, eventType;
	function feed(chunk) {
		if (isFirstChunk && (isFirstChunk = !1, chunk.charCodeAt(0) === 239 && chunk.charCodeAt(1) === 187 && chunk.charCodeAt(2) === 191 && (chunk = chunk.slice(3))), pendingFragments.length === 0) {
			const trailing2 = processLines(chunk);
			trailing2 !== "" && pendingFragments.push(trailing2);
			return;
		}
		if (chunk.indexOf(`
`) === -1 && chunk.indexOf("\r") === -1) {
			pendingFragments.push(chunk);
			return;
		}
		pendingFragments.push(chunk);
		const input = pendingFragments.join("");
		pendingFragments.length = 0;
		const trailing = processLines(input);
		trailing !== "" && pendingFragments.push(trailing);
	}
	function processLines(chunk) {
		let searchIndex = 0;
		if (chunk.indexOf("\r") === -1) {
			let lfIndex = chunk.indexOf(`
`, searchIndex);
			for (; lfIndex !== -1;) {
				if (searchIndex === lfIndex) {
					dataLines > 0 && onEvent({
						id,
						event: eventType,
						data
					}), id = void 0, data = "", dataLines = 0, eventType = void 0, searchIndex = lfIndex + 1, lfIndex = chunk.indexOf(`
`, searchIndex);
					continue;
				}
				const firstCharCode = chunk.charCodeAt(searchIndex);
				if (isDataPrefix$1(chunk, searchIndex, firstCharCode)) {
					const valueStart = chunk.charCodeAt(searchIndex + 5) === SPACE$1 ? searchIndex + 6 : searchIndex + 5, value = chunk.slice(valueStart, lfIndex);
					if (dataLines === 0 && chunk.charCodeAt(lfIndex + 1) === LF$1) {
						onEvent({
							id,
							event: eventType,
							data: value
						}), id = void 0, data = "", eventType = void 0, searchIndex = lfIndex + 2, lfIndex = chunk.indexOf(`
`, searchIndex);
						continue;
					}
					data = dataLines === 0 ? value : `${data}
${value}`, dataLines++;
				} else isEventPrefix$1(chunk, searchIndex, firstCharCode) ? eventType = chunk.slice(chunk.charCodeAt(searchIndex + 6) === SPACE$1 ? searchIndex + 7 : searchIndex + 6, lfIndex) || void 0 : parseLine(chunk, searchIndex, lfIndex);
				searchIndex = lfIndex + 1, lfIndex = chunk.indexOf(`
`, searchIndex);
			}
			return chunk.slice(searchIndex);
		}
		for (; searchIndex < chunk.length;) {
			const crIndex = chunk.indexOf("\r", searchIndex), lfIndex = chunk.indexOf(`
`, searchIndex);
			let lineEnd = -1;
			if (crIndex !== -1 && lfIndex !== -1 ? lineEnd = crIndex < lfIndex ? crIndex : lfIndex : crIndex !== -1 ? crIndex === chunk.length - 1 ? lineEnd = -1 : lineEnd = crIndex : lfIndex !== -1 && (lineEnd = lfIndex), lineEnd === -1) break;
			parseLine(chunk, searchIndex, lineEnd), searchIndex = lineEnd + 1, chunk.charCodeAt(searchIndex - 1) === CR$1 && chunk.charCodeAt(searchIndex) === LF$1 && searchIndex++;
		}
		return chunk.slice(searchIndex);
	}
	function parseLine(chunk, start, end) {
		if (start === end) {
			dispatchEvent();
			return;
		}
		const firstCharCode = chunk.charCodeAt(start);
		if (isDataPrefix$1(chunk, start, firstCharCode)) {
			const valueStart = chunk.charCodeAt(start + 5) === SPACE$1 ? start + 6 : start + 5, value2 = chunk.slice(valueStart, end);
			data = dataLines === 0 ? value2 : `${data}
${value2}`, dataLines++;
			return;
		}
		if (isEventPrefix$1(chunk, start, firstCharCode)) {
			eventType = chunk.slice(chunk.charCodeAt(start + 6) === SPACE$1 ? start + 7 : start + 6, end) || void 0;
			return;
		}
		if (firstCharCode === 105 && chunk.charCodeAt(start + 1) === 100 && chunk.charCodeAt(start + 2) === 58) {
			const value2 = chunk.slice(chunk.charCodeAt(start + 3) === SPACE$1 ? start + 4 : start + 3, end);
			id = value2.includes("\0") ? void 0 : value2;
			return;
		}
		if (firstCharCode === 58) {
			if (onComment) {
				const line2 = chunk.slice(start, end);
				onComment(line2.slice(chunk.charCodeAt(start + 1) === SPACE$1 ? 2 : 1));
			}
			return;
		}
		const line = chunk.slice(start, end), fieldSeparatorIndex = line.indexOf(":");
		if (fieldSeparatorIndex === -1) {
			processField(line, "", line);
			return;
		}
		const field = line.slice(0, fieldSeparatorIndex), offset = line.charCodeAt(fieldSeparatorIndex + 1) === SPACE$1 ? 2 : 1;
		processField(field, line.slice(fieldSeparatorIndex + offset), line);
	}
	function processField(field, value, line) {
		switch (field) {
			case "event":
				eventType = value || void 0;
				break;
			case "data":
				data = dataLines === 0 ? value : `${data}
${value}`, dataLines++;
				break;
			case "id":
				id = value.includes("\0") ? void 0 : value;
				break;
			case "retry":
				/^\d+$/.test(value) ? onRetry(parseInt(value, 10)) : onError(new ParseError$1(`Invalid \`retry\` value: "${value}"`, {
					type: "invalid-retry",
					value,
					line
				}));
				break;
			default:
				onError(new ParseError$1(`Unknown field "${field.length > 20 ? `${field.slice(0, 20)}\u2026` : field}"`, {
					type: "unknown-field",
					field,
					value,
					line
				}));
				break;
		}
	}
	function dispatchEvent() {
		dataLines > 0 && onEvent({
			id,
			event: eventType,
			data
		}), id = void 0, data = "", dataLines = 0, eventType = void 0;
	}
	function reset(options = {}) {
		if (options.consume && pendingFragments.length > 0) {
			const incompleteLine = pendingFragments.join("");
			parseLine(incompleteLine, 0, incompleteLine.length);
		}
		isFirstChunk = !0, id = void 0, data = "", dataLines = 0, eventType = void 0, pendingFragments.length = 0;
	}
	return {
		feed,
		reset
	};
}
function isDataPrefix$1(chunk, i, firstCharCode) {
	return firstCharCode === 100 && chunk.charCodeAt(i + 1) === 97 && chunk.charCodeAt(i + 2) === 116 && chunk.charCodeAt(i + 3) === 97 && chunk.charCodeAt(i + 4) === 58;
}
function isEventPrefix$1(chunk, i, firstCharCode) {
	return firstCharCode === 101 && chunk.charCodeAt(i + 1) === 118 && chunk.charCodeAt(i + 2) === 101 && chunk.charCodeAt(i + 3) === 110 && chunk.charCodeAt(i + 4) === 116 && chunk.charCodeAt(i + 5) === 58;
}
var EventSourceParserStream$1 = class extends TransformStream {
	constructor({ onError, onRetry, onComment } = {}) {
		let parser;
		super({
			start(controller) {
				parser = createParser$1({
					onEvent: (event) => {
						controller.enqueue(event);
					},
					onError(error) {
						onError === "terminate" ? controller.error(error) : typeof onError == "function" && onError(error);
					},
					onRetry,
					onComment
				});
			},
			transform(chunk) {
				parser.feed(chunk);
			}
		});
	}
};
function combineHeaders$1(...headers) {
	return headers.reduce((combinedHeaders, currentHeaders) => ({
		...combinedHeaders,
		...currentHeaders != null ? currentHeaders : {}
	}), {});
}
async function delay$1(delayInMs, options) {
	if (delayInMs == null) return Promise.resolve();
	const signal = options == null ? void 0 : options.abortSignal;
	return new Promise((resolve2, reject) => {
		if (signal == null ? void 0 : signal.aborted) {
			reject(createAbortError$1());
			return;
		}
		const timeoutId = setTimeout(() => {
			cleanup();
			resolve2();
		}, delayInMs);
		const cleanup = () => {
			clearTimeout(timeoutId);
			signal?.removeEventListener("abort", onAbort);
		};
		const onAbort = () => {
			cleanup();
			reject(createAbortError$1());
		};
		signal?.addEventListener("abort", onAbort);
	});
}
function createAbortError$1() {
	return new DOMException("Delay was aborted", "AbortError");
}
function extractResponseHeaders$1(response) {
	return Object.fromEntries([...response.headers]);
}
var name$4 = "AI_DownloadError";
var marker$5 = `vercel.ai.error.${name$4}`;
var symbol$4 = Symbol.for(marker$5);
var _a$4;
var _b$5;
var DownloadError$1 = class extends (_b$5 = AISDKError$1, _a$4 = symbol$4, _b$5) {
	constructor({ url, statusCode, statusText, cause, message = cause == null ? `Failed to download ${url}: ${statusCode} ${statusText}` : `Failed to download ${url}: ${cause}` }) {
		super({
			name: name$4,
			message,
			cause
		});
		this[_a$4] = true;
		this.url = url;
		this.statusCode = statusCode;
		this.statusText = statusText;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker$5);
	}
};
async function cancelResponseBody$1(response) {
	var _a2;
	try {
		await ((_a2 = response.body) == null ? void 0 : _a2.cancel());
	} catch (e) {}
}
var DEFAULT_MAX_DOWNLOAD_SIZE$1 = 2 * 1024 * 1024 * 1024;
async function readResponseWithSizeLimit$1({ response, url, maxBytes = DEFAULT_MAX_DOWNLOAD_SIZE$1 }) {
	const contentLength = response.headers.get("content-length");
	if (contentLength != null) {
		const length = parseInt(contentLength, 10);
		if (!isNaN(length) && length > maxBytes) {
			await cancelResponseBody$1(response);
			throw new DownloadError$1({
				url,
				message: `Download of ${url} exceeded maximum size of ${maxBytes} bytes (Content-Length: ${length}).`
			});
		}
	}
	const body = response.body;
	if (body == null) return /* @__PURE__ */ new Uint8Array(0);
	const reader = body.getReader();
	const chunks = [];
	let totalBytes = 0;
	try {
		while (true) {
			const { done, value } = await reader.read();
			if (done) break;
			totalBytes += value.length;
			if (totalBytes > maxBytes) throw new DownloadError$1({
				url,
				message: `Download of ${url} exceeded maximum size of ${maxBytes} bytes.`
			});
			chunks.push(value);
		}
	} finally {
		try {
			await reader.cancel();
		} finally {
			reader.releaseLock();
		}
	}
	const result = new Uint8Array(totalBytes);
	let offset = 0;
	for (const chunk of chunks) {
		result.set(chunk, offset);
		offset += chunk.length;
	}
	return result;
}
var createIdGenerator$1 = ({ prefix, size = 16, alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", separator = "-" } = {}) => {
	const generator = () => {
		const alphabetLength = alphabet.length;
		const chars = new Array(size);
		for (let i = 0; i < size; i++) chars[i] = alphabet[Math.random() * alphabetLength | 0];
		return chars.join("");
	};
	if (prefix == null) return generator;
	if (alphabet.includes(separator)) throw new InvalidArgumentError$3({
		argument: "separator",
		message: `The separator "${separator}" must not be part of the alphabet "${alphabet}".`
	});
	return () => `${prefix}${separator}${generator()}`;
};
createIdGenerator$1();
function getErrorMessage$2(error) {
	if (error == null) return "unknown error";
	if (typeof error === "string") return error;
	if (error instanceof Error) return error.message;
	return JSON.stringify(error);
}
function isAbortError$3(error) {
	return (error instanceof Error || error instanceof DOMException) && (error.name === "AbortError" || error.name === "ResponseAborted" || error.name === "TimeoutError");
}
var FETCH_FAILED_ERROR_MESSAGES$1 = ["fetch failed", "failed to fetch"];
function handleFetchError$1({ error, url, requestBodyValues }) {
	if (isAbortError$3(error)) return error;
	if (error instanceof TypeError && FETCH_FAILED_ERROR_MESSAGES$1.includes(error.message.toLowerCase())) {
		const cause = error.cause;
		if (cause != null) return new APICallError$1({
			message: `Cannot connect to API: ${cause.message}`,
			cause,
			url,
			requestBodyValues,
			isRetryable: true
		});
	}
	return error;
}
function getRuntimeEnvironmentUserAgent$1(globalThisAny = globalThis) {
	var _a2, _b2, _c;
	if (globalThisAny.window) return `runtime/browser`;
	if ((_a2 = globalThisAny.navigator) == null ? void 0 : _a2.userAgent) return `runtime/${globalThisAny.navigator.userAgent.toLowerCase()}`;
	if ((_c = (_b2 = globalThisAny.process) == null ? void 0 : _b2.versions) == null ? void 0 : _c.node) return `runtime/node.js/${globalThisAny.process.version.substring(0)}`;
	if (globalThisAny.EdgeRuntime) return `runtime/vercel-edge`;
	return "runtime/unknown";
}
function normalizeHeaders$1(headers) {
	if (headers == null) return {};
	const normalized = {};
	if (headers instanceof Headers) headers.forEach((value, key) => {
		normalized[key.toLowerCase()] = value;
	});
	else {
		if (!Array.isArray(headers)) headers = Object.entries(headers);
		for (const [key, value] of headers) if (value != null) normalized[key.toLowerCase()] = value;
	}
	return normalized;
}
function withUserAgentSuffix$1(headers, ...userAgentSuffixParts) {
	const normalizedHeaders = new Headers(normalizeHeaders$1(headers));
	const currentUserAgentHeader = normalizedHeaders.get("user-agent") || "";
	normalizedHeaders.set("user-agent", [currentUserAgentHeader, ...userAgentSuffixParts].filter(Boolean).join(" "));
	return Object.fromEntries(normalizedHeaders.entries());
}
var VERSION$4 = "3.0.30";
var getOriginalFetch$1 = () => globalThis.fetch;
var getFromApi$1 = async ({ url, headers = {}, successfulResponseHandler, failedResponseHandler, abortSignal, fetch: fetch2 = getOriginalFetch$1() }) => {
	try {
		const response = await fetch2(url, {
			method: "GET",
			headers: withUserAgentSuffix$1(headers, `ai-sdk/provider-utils/${VERSION$4}`, getRuntimeEnvironmentUserAgent$1()),
			signal: abortSignal
		});
		const responseHeaders = extractResponseHeaders$1(response);
		if (!response.ok) {
			let errorInformation;
			try {
				errorInformation = await failedResponseHandler({
					response,
					url,
					requestBodyValues: {}
				});
			} catch (error) {
				if (isAbortError$3(error) || APICallError$1.isInstance(error)) throw error;
				throw new APICallError$1({
					message: "Failed to process error response",
					cause: error,
					statusCode: response.status,
					url,
					responseHeaders,
					requestBodyValues: {}
				});
			}
			throw errorInformation.value;
		}
		try {
			return await successfulResponseHandler({
				response,
				url,
				requestBodyValues: {}
			});
		} catch (error) {
			if (error instanceof Error) {
				if (isAbortError$3(error) || APICallError$1.isInstance(error)) throw error;
			}
			throw new APICallError$1({
				message: "Failed to process successful response",
				cause: error,
				statusCode: response.status,
				url,
				responseHeaders,
				requestBodyValues: {}
			});
		}
	} catch (error) {
		throw handleFetchError$1({
			error,
			url,
			requestBodyValues: {}
		});
	}
};
function loadOptionalSetting$1({ settingValue, environmentVariableName }) {
	if (typeof settingValue === "string") return settingValue;
	if (settingValue != null || typeof process === "undefined") return;
	settingValue = process.env[environmentVariableName];
	if (settingValue == null || typeof settingValue !== "string") return;
	return settingValue;
}
var suspectProtoRx$1 = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/;
var suspectConstructorRx$1 = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
function _parse$1(text) {
	const obj = JSON.parse(text);
	if (obj === null || typeof obj !== "object") return obj;
	if (suspectProtoRx$1.test(text) === false && suspectConstructorRx$1.test(text) === false) return obj;
	return filter$1(obj);
}
function filter$1(obj) {
	let next = [obj];
	while (next.length) {
		const nodes = next;
		next = [];
		for (const node of nodes) {
			if (Object.prototype.hasOwnProperty.call(node, "__proto__")) throw new SyntaxError("Object contains forbidden prototype property");
			if (Object.prototype.hasOwnProperty.call(node, "constructor") && node.constructor !== null && typeof node.constructor === "object" && Object.prototype.hasOwnProperty.call(node.constructor, "prototype")) throw new SyntaxError("Object contains forbidden prototype property");
			for (const key in node) {
				const value = node[key];
				if (value && typeof value === "object") next.push(value);
			}
		}
	}
	return obj;
}
function secureJsonParse$1(text) {
	const { stackTraceLimit } = Error;
	try {
		Error.stackTraceLimit = 0;
	} catch (e) {
		return _parse$1(text);
	}
	try {
		return _parse$1(text);
	} finally {
		Error.stackTraceLimit = stackTraceLimit;
	}
}
var validatorSymbol = /* @__PURE__ */ Symbol.for("vercel.ai.validator");
function validator(validate) {
	return {
		[validatorSymbol]: true,
		validate
	};
}
function isValidator(value) {
	return typeof value === "object" && value !== null && validatorSymbol in value && value[validatorSymbol] === true && "validate" in value;
}
function lazyValidator(createValidator) {
	let validator2;
	return () => {
		if (validator2 == null) validator2 = createValidator();
		return validator2;
	};
}
function asValidator(value) {
	return isValidator(value) ? value : "~standard" in value ? standardSchemaValidator(value) : value();
}
function standardSchemaValidator(standardSchema) {
	return validator(async (value) => {
		const result = await standardSchema["~standard"].validate(value);
		return result.issues == null ? {
			success: true,
			value: result.value
		} : {
			success: false,
			error: new TypeValidationError$1({
				value,
				cause: result.issues
			})
		};
	});
}
async function validateTypes$1({ value, schema }) {
	const result = await safeValidateTypes$1({
		value,
		schema
	});
	if (!result.success) throw TypeValidationError$1.wrap({
		value,
		cause: result.error
	});
	return result.value;
}
async function safeValidateTypes$1({ value, schema }) {
	const validator2 = asValidator(schema);
	try {
		if (validator2.validate == null) return {
			success: true,
			value,
			rawValue: value
		};
		const result = await validator2.validate(value);
		if (result.success) return {
			success: true,
			value: result.value,
			rawValue: value
		};
		return {
			success: false,
			error: TypeValidationError$1.wrap({
				value,
				cause: result.error
			}),
			rawValue: value
		};
	} catch (error) {
		return {
			success: false,
			error: TypeValidationError$1.wrap({
				value,
				cause: error
			}),
			rawValue: value
		};
	}
}
async function parseJSON$1({ text, schema }) {
	try {
		const value = secureJsonParse$1(text);
		if (schema == null) return value;
		return validateTypes$1({
			value,
			schema
		});
	} catch (error) {
		if (JSONParseError$1.isInstance(error) || TypeValidationError$1.isInstance(error)) throw error;
		throw new JSONParseError$1({
			text,
			cause: error
		});
	}
}
async function safeParseJSON$1({ text, schema }) {
	try {
		const value = secureJsonParse$1(text);
		if (schema == null) return {
			success: true,
			value,
			rawValue: value
		};
		return await safeValidateTypes$1({
			value,
			schema
		});
	} catch (error) {
		return {
			success: false,
			error: JSONParseError$1.isInstance(error) ? error : new JSONParseError$1({
				text,
				cause: error
			}),
			rawValue: void 0
		};
	}
}
function parseJsonEventStream$1({ stream, schema }) {
	return stream.pipeThrough(new TextDecoderStream()).pipeThrough(new EventSourceParserStream$1()).pipeThrough(new TransformStream({ async transform({ data }, controller) {
		if (data === "[DONE]") return;
		controller.enqueue(await safeParseJSON$1({
			text: data,
			schema
		}));
	} }));
}
var getOriginalFetch2$1 = () => globalThis.fetch;
var postJsonToApi$1 = async ({ url, headers, body, failedResponseHandler, successfulResponseHandler, abortSignal, fetch: fetch2 }) => postToApi$1({
	url,
	headers: {
		"Content-Type": "application/json",
		...headers
	},
	body: {
		content: JSON.stringify(body),
		values: body
	},
	failedResponseHandler,
	successfulResponseHandler,
	abortSignal,
	fetch: fetch2
});
var postToApi$1 = async ({ url, headers = {}, body, successfulResponseHandler, failedResponseHandler, abortSignal, fetch: fetch2 = getOriginalFetch2$1() }) => {
	try {
		const response = await fetch2(url, {
			method: "POST",
			headers: withUserAgentSuffix$1(headers, `ai-sdk/provider-utils/${VERSION$4}`, getRuntimeEnvironmentUserAgent$1()),
			body: body.content,
			signal: abortSignal
		});
		const responseHeaders = extractResponseHeaders$1(response);
		if (!response.ok) {
			let errorInformation;
			try {
				errorInformation = await failedResponseHandler({
					response,
					url,
					requestBodyValues: body.values
				});
			} catch (error) {
				if (isAbortError$3(error) || APICallError$1.isInstance(error)) throw error;
				throw new APICallError$1({
					message: "Failed to process error response",
					cause: error,
					statusCode: response.status,
					url,
					responseHeaders,
					requestBodyValues: body.values
				});
			}
			throw errorInformation.value;
		}
		try {
			return await successfulResponseHandler({
				response,
				url,
				requestBodyValues: body.values
			});
		} catch (error) {
			if (error instanceof Error) {
				if (isAbortError$3(error) || APICallError$1.isInstance(error)) throw error;
			}
			throw new APICallError$1({
				message: "Failed to process successful response",
				cause: error,
				statusCode: response.status,
				url,
				responseHeaders,
				requestBodyValues: body.values
			});
		}
	} catch (error) {
		throw handleFetchError$1({
			error,
			url,
			requestBodyValues: body.values
		});
	}
};
function tool$1(tool2) {
	return tool2;
}
function createProviderDefinedToolFactoryWithOutputSchema({ id, name: name2, inputSchema, outputSchema }) {
	return ({ execute, toModelOutput, onInputStart, onInputDelta, onInputAvailable, ...args }) => tool$1({
		type: "provider-defined",
		id,
		name: name2,
		args,
		inputSchema,
		outputSchema,
		execute,
		toModelOutput,
		onInputStart,
		onInputDelta,
		onInputAvailable
	});
}
async function resolve$1(value) {
	if (typeof value === "function") value = value();
	return Promise.resolve(value);
}
var textDecoder$1 = new TextDecoder();
async function readResponseBodyAsText$1({ response, url }) {
	return textDecoder$1.decode(await readResponseWithSizeLimit$1({
		response,
		url
	}));
}
var createJsonErrorResponseHandler$1 = ({ errorSchema, errorToMessage, isRetryable }) => async ({ response, url, requestBodyValues }) => {
	const responseBody = await readResponseBodyAsText$1({
		response,
		url
	});
	const responseHeaders = extractResponseHeaders$1(response);
	if (responseBody.trim() === "") return {
		responseHeaders,
		value: new APICallError$1({
			message: response.statusText,
			url,
			requestBodyValues,
			statusCode: response.status,
			responseHeaders,
			responseBody,
			isRetryable: isRetryable == null ? void 0 : isRetryable(response)
		})
	};
	try {
		const parsedError = await parseJSON$1({
			text: responseBody,
			schema: errorSchema
		});
		return {
			responseHeaders,
			value: new APICallError$1({
				message: errorToMessage(parsedError),
				url,
				requestBodyValues,
				statusCode: response.status,
				responseHeaders,
				responseBody,
				data: parsedError,
				isRetryable: isRetryable == null ? void 0 : isRetryable(response, parsedError)
			})
		};
	} catch (parseError) {
		return {
			responseHeaders,
			value: new APICallError$1({
				message: response.statusText,
				url,
				requestBodyValues,
				statusCode: response.status,
				responseHeaders,
				responseBody,
				isRetryable: isRetryable == null ? void 0 : isRetryable(response)
			})
		};
	}
};
var createEventSourceResponseHandler$1 = (chunkSchema) => async ({ response }) => {
	const responseHeaders = extractResponseHeaders$1(response);
	if (response.body == null) throw new EmptyResponseBodyError$1({});
	return {
		responseHeaders,
		value: parseJsonEventStream$1({
			stream: response.body,
			schema: chunkSchema
		})
	};
};
var createJsonResponseHandler$1 = (responseSchema) => async ({ response, url, requestBodyValues }) => {
	const responseBody = await readResponseBodyAsText$1({
		response,
		url
	});
	const parsedResult = await safeParseJSON$1({
		text: responseBody,
		schema: responseSchema
	});
	const responseHeaders = extractResponseHeaders$1(response);
	if (!parsedResult.success) throw new APICallError$1({
		message: "Invalid JSON response",
		cause: parsedResult.error,
		statusCode: response.status,
		responseHeaders,
		responseBody,
		url,
		requestBodyValues
	});
	return {
		responseHeaders,
		value: parsedResult.value,
		rawValue: parsedResult.rawValue
	};
};
var schemaSymbol$1 = /* @__PURE__ */ Symbol.for("vercel.ai.schema");
function lazySchema$1(createSchema) {
	let schema;
	return () => {
		if (schema == null) schema = createSchema();
		return schema;
	};
}
function jsonSchema$1(jsonSchema2, { validate } = {}) {
	return {
		[schemaSymbol$1]: true,
		_type: void 0,
		[validatorSymbol]: true,
		get jsonSchema() {
			if (typeof jsonSchema2 === "function") jsonSchema2 = jsonSchema2();
			return jsonSchema2;
		},
		validate
	};
}
function addAdditionalPropertiesToJsonSchema$1(jsonSchema2) {
	if (jsonSchema2.type === "object") {
		jsonSchema2.additionalProperties = false;
		const properties = jsonSchema2.properties;
		if (properties != null) for (const property in properties) properties[property] = addAdditionalPropertiesToJsonSchema$1(properties[property]);
	}
	if (jsonSchema2.type === "array" && jsonSchema2.items != null) if (Array.isArray(jsonSchema2.items)) jsonSchema2.items = jsonSchema2.items.map((item) => addAdditionalPropertiesToJsonSchema$1(item));
	else jsonSchema2.items = addAdditionalPropertiesToJsonSchema$1(jsonSchema2.items);
	return jsonSchema2;
}
var ignoreOverride$1 = /* @__PURE__ */ Symbol("Let zodToJsonSchema decide on which parser to use");
var defaultOptions$1 = {
	name: void 0,
	$refStrategy: "root",
	basePath: ["#"],
	effectStrategy: "input",
	pipeStrategy: "all",
	dateStrategy: "format:date-time",
	mapStrategy: "entries",
	removeAdditionalStrategy: "passthrough",
	allowedAdditionalProperties: true,
	rejectedAdditionalProperties: false,
	definitionPath: "definitions",
	strictUnions: false,
	definitions: {},
	errorMessages: false,
	patternStrategy: "escape",
	applyRegexFlags: false,
	emailStrategy: "format:email",
	base64Strategy: "contentEncoding:base64",
	nameStrategy: "ref"
};
var getDefaultOptions$1 = (options) => typeof options === "string" ? {
	...defaultOptions$1,
	name: options
} : {
	...defaultOptions$1,
	...options
};
function parseAnyDef$1() {
	return {};
}
function parseArrayDef$1(def, refs) {
	var _a2, _b2, _c;
	const res = { type: "array" };
	if (((_a2 = def.type) == null ? void 0 : _a2._def) && ((_c = (_b2 = def.type) == null ? void 0 : _b2._def) == null ? void 0 : _c.typeName) !== ZodFirstPartyTypeKind.ZodAny) res.items = parseDef$1(def.type._def, {
		...refs,
		currentPath: [...refs.currentPath, "items"]
	});
	if (def.minLength) res.minItems = def.minLength.value;
	if (def.maxLength) res.maxItems = def.maxLength.value;
	if (def.exactLength) {
		res.minItems = def.exactLength.value;
		res.maxItems = def.exactLength.value;
	}
	return res;
}
function parseBigintDef$1(def) {
	const res = {
		type: "integer",
		format: "int64"
	};
	if (!def.checks) return res;
	for (const check of def.checks) switch (check.kind) {
		case "min":
			if (check.inclusive) res.minimum = check.value;
			else res.exclusiveMinimum = check.value;
			break;
		case "max":
			if (check.inclusive) res.maximum = check.value;
			else res.exclusiveMaximum = check.value;
			break;
		case "multipleOf":
			res.multipleOf = check.value;
			break;
	}
	return res;
}
function parseBooleanDef$1() {
	return { type: "boolean" };
}
function parseBrandedDef$1(_def, refs) {
	return parseDef$1(_def.type._def, refs);
}
var parseCatchDef$1 = (def, refs) => {
	return parseDef$1(def.innerType._def, refs);
};
function parseDateDef$1(def, refs, overrideDateStrategy) {
	const strategy = overrideDateStrategy != null ? overrideDateStrategy : refs.dateStrategy;
	if (Array.isArray(strategy)) return { anyOf: strategy.map((item, i) => parseDateDef$1(def, refs, item)) };
	switch (strategy) {
		case "string":
		case "format:date-time": return {
			type: "string",
			format: "date-time"
		};
		case "format:date": return {
			type: "string",
			format: "date"
		};
		case "integer": return integerDateParser$1(def);
	}
}
var integerDateParser$1 = (def) => {
	const res = {
		type: "integer",
		format: "unix-time"
	};
	for (const check of def.checks) switch (check.kind) {
		case "min":
			res.minimum = check.value;
			break;
		case "max":
			res.maximum = check.value;
			break;
	}
	return res;
};
function parseDefaultDef$1(_def, refs) {
	return {
		...parseDef$1(_def.innerType._def, refs),
		default: _def.defaultValue()
	};
}
function parseEffectsDef$1(_def, refs) {
	return refs.effectStrategy === "input" ? parseDef$1(_def.schema._def, refs) : parseAnyDef$1();
}
function parseEnumDef$1(def) {
	return {
		type: "string",
		enum: Array.from(def.values)
	};
}
var isJsonSchema7AllOfType$1 = (type) => {
	if ("type" in type && type.type === "string") return false;
	return "allOf" in type;
};
function parseIntersectionDef$1(def, refs) {
	const allOf = [parseDef$1(def.left._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"0"
		]
	}), parseDef$1(def.right._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"1"
		]
	})].filter((x) => !!x);
	const mergedAllOf = [];
	allOf.forEach((schema) => {
		if (isJsonSchema7AllOfType$1(schema)) mergedAllOf.push(...schema.allOf);
		else {
			let nestedSchema = schema;
			if ("additionalProperties" in schema && schema.additionalProperties === false) {
				const { additionalProperties, ...rest } = schema;
				nestedSchema = rest;
			}
			mergedAllOf.push(nestedSchema);
		}
	});
	return mergedAllOf.length ? { allOf: mergedAllOf } : void 0;
}
function parseLiteralDef$1(def) {
	const parsedType = typeof def.value;
	if (parsedType !== "bigint" && parsedType !== "number" && parsedType !== "boolean" && parsedType !== "string") return { type: Array.isArray(def.value) ? "array" : "object" };
	return {
		type: parsedType === "bigint" ? "integer" : parsedType,
		const: def.value
	};
}
var emojiRegex$1 = void 0;
var zodPatterns$1 = {
	/**
	* `c` was changed to `[cC]` to replicate /i flag
	*/
	cuid: /^[cC][^\s-]{8,}$/,
	cuid2: /^[0-9a-z]+$/,
	ulid: /^[0-9A-HJKMNP-TV-Z]{26}$/,
	/**
	* `a-z` was added to replicate /i flag
	*/
	email: /^(?!\.)(?!.*\.\.)([a-zA-Z0-9_'+\-\.]*)[a-zA-Z0-9_+-]@([a-zA-Z0-9][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,}$/,
	/**
	* Constructed a valid Unicode RegExp
	*
	* Lazily instantiate since this type of regex isn't supported
	* in all envs (e.g. React Native).
	*
	* See:
	* https://github.com/colinhacks/zod/issues/2433
	* Fix in Zod:
	* https://github.com/colinhacks/zod/commit/9340fd51e48576a75adc919bff65dbc4a5d4c99b
	*/
	emoji: () => {
		if (emojiRegex$1 === void 0) emojiRegex$1 = RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u");
		return emojiRegex$1;
	},
	/**
	* Unused
	*/
	uuid: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
	/**
	* Unused
	*/
	ipv4: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
	ipv4Cidr: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/,
	/**
	* Unused
	*/
	ipv6: /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
	ipv6Cidr: /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/,
	base64: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
	base64url: /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/,
	nanoid: /^[a-zA-Z0-9_-]{21}$/,
	jwt: /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/
};
function parseStringDef$1(def, refs) {
	const res = { type: "string" };
	if (def.checks) for (const check of def.checks) switch (check.kind) {
		case "min":
			res.minLength = typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value;
			break;
		case "max":
			res.maxLength = typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value;
			break;
		case "email":
			switch (refs.emailStrategy) {
				case "format:email":
					addFormat$1(res, "email", check.message, refs);
					break;
				case "format:idn-email":
					addFormat$1(res, "idn-email", check.message, refs);
					break;
				case "pattern:zod":
					addPattern$1(res, zodPatterns$1.email, check.message, refs);
					break;
			}
			break;
		case "url":
			addFormat$1(res, "uri", check.message, refs);
			break;
		case "uuid":
			addFormat$1(res, "uuid", check.message, refs);
			break;
		case "regex":
			addPattern$1(res, check.regex, check.message, refs);
			break;
		case "cuid":
			addPattern$1(res, zodPatterns$1.cuid, check.message, refs);
			break;
		case "cuid2":
			addPattern$1(res, zodPatterns$1.cuid2, check.message, refs);
			break;
		case "startsWith":
			addPattern$1(res, RegExp(`^${escapeLiteralCheckValue$1(check.value, refs)}`), check.message, refs);
			break;
		case "endsWith":
			addPattern$1(res, RegExp(`${escapeLiteralCheckValue$1(check.value, refs)}$`), check.message, refs);
			break;
		case "datetime":
			addFormat$1(res, "date-time", check.message, refs);
			break;
		case "date":
			addFormat$1(res, "date", check.message, refs);
			break;
		case "time":
			addFormat$1(res, "time", check.message, refs);
			break;
		case "duration":
			addFormat$1(res, "duration", check.message, refs);
			break;
		case "length":
			res.minLength = typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value;
			res.maxLength = typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value;
			break;
		case "includes":
			addPattern$1(res, RegExp(escapeLiteralCheckValue$1(check.value, refs)), check.message, refs);
			break;
		case "ip":
			if (check.version !== "v6") addFormat$1(res, "ipv4", check.message, refs);
			if (check.version !== "v4") addFormat$1(res, "ipv6", check.message, refs);
			break;
		case "base64url":
			addPattern$1(res, zodPatterns$1.base64url, check.message, refs);
			break;
		case "jwt":
			addPattern$1(res, zodPatterns$1.jwt, check.message, refs);
			break;
		case "cidr":
			if (check.version !== "v6") addPattern$1(res, zodPatterns$1.ipv4Cidr, check.message, refs);
			if (check.version !== "v4") addPattern$1(res, zodPatterns$1.ipv6Cidr, check.message, refs);
			break;
		case "emoji":
			addPattern$1(res, zodPatterns$1.emoji(), check.message, refs);
			break;
		case "ulid":
			addPattern$1(res, zodPatterns$1.ulid, check.message, refs);
			break;
		case "base64":
			switch (refs.base64Strategy) {
				case "format:binary":
					addFormat$1(res, "binary", check.message, refs);
					break;
				case "contentEncoding:base64":
					res.contentEncoding = "base64";
					break;
				case "pattern:zod":
					addPattern$1(res, zodPatterns$1.base64, check.message, refs);
					break;
			}
			break;
		case "nanoid": addPattern$1(res, zodPatterns$1.nanoid, check.message, refs);
		case "toLowerCase":
		case "toUpperCase":
		case "trim": break;
		default:
	}
	return res;
}
function escapeLiteralCheckValue$1(literal, refs) {
	return refs.patternStrategy === "escape" ? escapeNonAlphaNumeric$1(literal) : literal;
}
var ALPHA_NUMERIC$1 = /* @__PURE__ */ new Set("ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvxyz0123456789");
function escapeNonAlphaNumeric$1(source) {
	let result = "";
	for (let i = 0; i < source.length; i++) {
		if (!ALPHA_NUMERIC$1.has(source[i])) result += "\\";
		result += source[i];
	}
	return result;
}
function addFormat$1(schema, value, message, refs) {
	var _a2;
	if (schema.format || ((_a2 = schema.anyOf) == null ? void 0 : _a2.some((x) => x.format))) {
		if (!schema.anyOf) schema.anyOf = [];
		if (schema.format) {
			schema.anyOf.push({ format: schema.format });
			delete schema.format;
		}
		schema.anyOf.push({
			format: value,
			...message && refs.errorMessages && { errorMessage: { format: message } }
		});
	} else schema.format = value;
}
function addPattern$1(schema, regex, message, refs) {
	var _a2;
	if (schema.pattern || ((_a2 = schema.allOf) == null ? void 0 : _a2.some((x) => x.pattern))) {
		if (!schema.allOf) schema.allOf = [];
		if (schema.pattern) {
			schema.allOf.push({ pattern: schema.pattern });
			delete schema.pattern;
		}
		schema.allOf.push({
			pattern: stringifyRegExpWithFlags$1(regex, refs),
			...message && refs.errorMessages && { errorMessage: { pattern: message } }
		});
	} else schema.pattern = stringifyRegExpWithFlags$1(regex, refs);
}
function stringifyRegExpWithFlags$1(regex, refs) {
	var _a2;
	if (!refs.applyRegexFlags || !regex.flags) return regex.source;
	const flags = {
		i: regex.flags.includes("i"),
		m: regex.flags.includes("m"),
		s: regex.flags.includes("s")
	};
	const source = flags.i ? regex.source.toLowerCase() : regex.source;
	let pattern = "";
	let isEscaped = false;
	let inCharGroup = false;
	let inCharRange = false;
	for (let i = 0; i < source.length; i++) {
		if (isEscaped) {
			pattern += source[i];
			isEscaped = false;
			continue;
		}
		if (flags.i) {
			if (inCharGroup) {
				if (source[i].match(/[a-z]/)) {
					if (inCharRange) {
						pattern += source[i];
						pattern += `${source[i - 2]}-${source[i]}`.toUpperCase();
						inCharRange = false;
					} else if (source[i + 1] === "-" && ((_a2 = source[i + 2]) == null ? void 0 : _a2.match(/[a-z]/))) {
						pattern += source[i];
						inCharRange = true;
					} else pattern += `${source[i]}${source[i].toUpperCase()}`;
					continue;
				}
			} else if (source[i].match(/[a-z]/)) {
				pattern += `[${source[i]}${source[i].toUpperCase()}]`;
				continue;
			}
		}
		if (flags.m) {
			if (source[i] === "^") {
				pattern += `(^|(?<=[\r
]))`;
				continue;
			} else if (source[i] === "$") {
				pattern += `($|(?=[\r
]))`;
				continue;
			}
		}
		if (flags.s && source[i] === ".") {
			pattern += inCharGroup ? `${source[i]}\r
` : `[${source[i]}\r
]`;
			continue;
		}
		pattern += source[i];
		if (source[i] === "\\") isEscaped = true;
		else if (inCharGroup && source[i] === "]") inCharGroup = false;
		else if (!inCharGroup && source[i] === "[") inCharGroup = true;
	}
	try {
		new RegExp(pattern);
	} catch (e) {
		console.warn(`Could not convert regex pattern at ${refs.currentPath.join("/")} to a flag-independent form! Falling back to the flag-ignorant source`);
		return regex.source;
	}
	return pattern;
}
function parseRecordDef$1(def, refs) {
	var _a2, _b2, _c, _d, _e, _f;
	const schema = {
		type: "object",
		additionalProperties: (_a2 = parseDef$1(def.valueType._def, {
			...refs,
			currentPath: [...refs.currentPath, "additionalProperties"]
		})) != null ? _a2 : refs.allowedAdditionalProperties
	};
	if (((_b2 = def.keyType) == null ? void 0 : _b2._def.typeName) === ZodFirstPartyTypeKind.ZodString && ((_c = def.keyType._def.checks) == null ? void 0 : _c.length)) {
		const { type, ...keyType } = parseStringDef$1(def.keyType._def, refs);
		return {
			...schema,
			propertyNames: keyType
		};
	} else if (((_d = def.keyType) == null ? void 0 : _d._def.typeName) === ZodFirstPartyTypeKind.ZodEnum) return {
		...schema,
		propertyNames: { enum: def.keyType._def.values }
	};
	else if (((_e = def.keyType) == null ? void 0 : _e._def.typeName) === ZodFirstPartyTypeKind.ZodBranded && def.keyType._def.type._def.typeName === ZodFirstPartyTypeKind.ZodString && ((_f = def.keyType._def.type._def.checks) == null ? void 0 : _f.length)) {
		const { type, ...keyType } = parseBrandedDef$1(def.keyType._def, refs);
		return {
			...schema,
			propertyNames: keyType
		};
	}
	return schema;
}
function parseMapDef$1(def, refs) {
	if (refs.mapStrategy === "record") return parseRecordDef$1(def, refs);
	return {
		type: "array",
		maxItems: 125,
		items: {
			type: "array",
			items: [parseDef$1(def.keyType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"items",
					"items",
					"0"
				]
			}) || parseAnyDef$1(), parseDef$1(def.valueType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"items",
					"items",
					"1"
				]
			}) || parseAnyDef$1()],
			minItems: 2,
			maxItems: 2
		}
	};
}
function parseNativeEnumDef$1(def) {
	const object = def.values;
	const actualValues = Object.keys(def.values).filter((key) => {
		return typeof object[object[key]] !== "number";
	}).map((key) => object[key]);
	const parsedTypes = Array.from(new Set(actualValues.map((values) => typeof values)));
	return {
		type: parsedTypes.length === 1 ? parsedTypes[0] === "string" ? "string" : "number" : ["string", "number"],
		enum: actualValues
	};
}
function parseNeverDef$1() {
	return { not: parseAnyDef$1() };
}
function parseNullDef$1() {
	return { type: "null" };
}
var primitiveMappings$1 = {
	ZodString: "string",
	ZodNumber: "number",
	ZodBigInt: "integer",
	ZodBoolean: "boolean",
	ZodNull: "null"
};
function parseUnionDef$1(def, refs) {
	const options = def.options instanceof Map ? Array.from(def.options.values()) : def.options;
	if (options.every((x) => x._def.typeName in primitiveMappings$1 && (!x._def.checks || !x._def.checks.length))) {
		const types = options.reduce((types2, x) => {
			const type = primitiveMappings$1[x._def.typeName];
			return type && !types2.includes(type) ? [...types2, type] : types2;
		}, []);
		return { type: types.length > 1 ? types : types[0] };
	} else if (options.every((x) => x._def.typeName === "ZodLiteral" && !x.description)) {
		const types = options.reduce((acc, x) => {
			const type = typeof x._def.value;
			switch (type) {
				case "string":
				case "number":
				case "boolean": return [...acc, type];
				case "bigint": return [...acc, "integer"];
				case "object": if (x._def.value === null) return [...acc, "null"];
				default: return acc;
			}
		}, []);
		if (types.length === options.length) {
			const uniqueTypes = types.filter((x, i, a) => a.indexOf(x) === i);
			return {
				type: uniqueTypes.length > 1 ? uniqueTypes : uniqueTypes[0],
				enum: options.reduce((acc, x) => {
					return acc.includes(x._def.value) ? acc : [...acc, x._def.value];
				}, [])
			};
		}
	} else if (options.every((x) => x._def.typeName === "ZodEnum")) return {
		type: "string",
		enum: options.reduce((acc, x) => [...acc, ...x._def.values.filter((x2) => !acc.includes(x2))], [])
	};
	return asAnyOf$1(def, refs);
}
var asAnyOf$1 = (def, refs) => {
	const anyOf = (def.options instanceof Map ? Array.from(def.options.values()) : def.options).map((x, i) => parseDef$1(x._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			`${i}`
		]
	})).filter((x) => !!x && (!refs.strictUnions || typeof x === "object" && Object.keys(x).length > 0));
	return anyOf.length ? { anyOf } : void 0;
};
function parseNullableDef$1(def, refs) {
	if ([
		"ZodString",
		"ZodNumber",
		"ZodBigInt",
		"ZodBoolean",
		"ZodNull"
	].includes(def.innerType._def.typeName) && (!def.innerType._def.checks || !def.innerType._def.checks.length)) return { type: [primitiveMappings$1[def.innerType._def.typeName], "null"] };
	const base = parseDef$1(def.innerType._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			"0"
		]
	});
	return base && { anyOf: [base, { type: "null" }] };
}
function parseNumberDef$1(def) {
	const res = { type: "number" };
	if (!def.checks) return res;
	for (const check of def.checks) switch (check.kind) {
		case "int":
			res.type = "integer";
			break;
		case "min":
			if (check.inclusive) res.minimum = check.value;
			else res.exclusiveMinimum = check.value;
			break;
		case "max":
			if (check.inclusive) res.maximum = check.value;
			else res.exclusiveMaximum = check.value;
			break;
		case "multipleOf":
			res.multipleOf = check.value;
			break;
	}
	return res;
}
function parseObjectDef$1(def, refs) {
	const result = {
		type: "object",
		properties: {}
	};
	const required = [];
	const shape = def.shape();
	for (const propName in shape) {
		let propDef = shape[propName];
		if (propDef === void 0 || propDef._def === void 0) continue;
		const propOptional = safeIsOptional$1(propDef);
		const parsedDef = parseDef$1(propDef._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"properties",
				propName
			],
			propertyPath: [
				...refs.currentPath,
				"properties",
				propName
			]
		});
		if (parsedDef === void 0) continue;
		result.properties[propName] = parsedDef;
		if (!propOptional) required.push(propName);
	}
	if (required.length) result.required = required;
	const additionalProperties = decideAdditionalProperties$1(def, refs);
	if (additionalProperties !== void 0) result.additionalProperties = additionalProperties;
	return result;
}
function decideAdditionalProperties$1(def, refs) {
	if (def.catchall._def.typeName !== "ZodNever") return parseDef$1(def.catchall._def, {
		...refs,
		currentPath: [...refs.currentPath, "additionalProperties"]
	});
	switch (def.unknownKeys) {
		case "passthrough": return refs.allowedAdditionalProperties;
		case "strict": return refs.rejectedAdditionalProperties;
		case "strip": return refs.removeAdditionalStrategy === "strict" ? refs.allowedAdditionalProperties : refs.rejectedAdditionalProperties;
	}
}
function safeIsOptional$1(schema) {
	try {
		return schema.isOptional();
	} catch (e) {
		return true;
	}
}
var parseOptionalDef$1 = (def, refs) => {
	var _a2;
	if (refs.currentPath.toString() === ((_a2 = refs.propertyPath) == null ? void 0 : _a2.toString())) return parseDef$1(def.innerType._def, refs);
	const innerSchema = parseDef$1(def.innerType._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			"1"
		]
	});
	return innerSchema ? { anyOf: [{ not: parseAnyDef$1() }, innerSchema] } : parseAnyDef$1();
};
var parsePipelineDef$1 = (def, refs) => {
	if (refs.pipeStrategy === "input") return parseDef$1(def.in._def, refs);
	else if (refs.pipeStrategy === "output") return parseDef$1(def.out._def, refs);
	const a = parseDef$1(def.in._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"0"
		]
	});
	return { allOf: [a, parseDef$1(def.out._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			a ? "1" : "0"
		]
	})].filter((x) => x !== void 0) };
};
function parsePromiseDef$1(def, refs) {
	return parseDef$1(def.type._def, refs);
}
function parseSetDef$1(def, refs) {
	const schema = {
		type: "array",
		uniqueItems: true,
		items: parseDef$1(def.valueType._def, {
			...refs,
			currentPath: [...refs.currentPath, "items"]
		})
	};
	if (def.minSize) schema.minItems = def.minSize.value;
	if (def.maxSize) schema.maxItems = def.maxSize.value;
	return schema;
}
function parseTupleDef$1(def, refs) {
	if (def.rest) return {
		type: "array",
		minItems: def.items.length,
		items: def.items.map((x, i) => parseDef$1(x._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"items",
				`${i}`
			]
		})).reduce((acc, x) => x === void 0 ? acc : [...acc, x], []),
		additionalItems: parseDef$1(def.rest._def, {
			...refs,
			currentPath: [...refs.currentPath, "additionalItems"]
		})
	};
	else return {
		type: "array",
		minItems: def.items.length,
		maxItems: def.items.length,
		items: def.items.map((x, i) => parseDef$1(x._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"items",
				`${i}`
			]
		})).reduce((acc, x) => x === void 0 ? acc : [...acc, x], [])
	};
}
function parseUndefinedDef$1() {
	return { not: parseAnyDef$1() };
}
function parseUnknownDef$1() {
	return parseAnyDef$1();
}
var parseReadonlyDef$1 = (def, refs) => {
	return parseDef$1(def.innerType._def, refs);
};
var selectParser$1 = (def, typeName, refs) => {
	switch (typeName) {
		case ZodFirstPartyTypeKind.ZodString: return parseStringDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodNumber: return parseNumberDef$1(def);
		case ZodFirstPartyTypeKind.ZodObject: return parseObjectDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodBigInt: return parseBigintDef$1(def);
		case ZodFirstPartyTypeKind.ZodBoolean: return parseBooleanDef$1();
		case ZodFirstPartyTypeKind.ZodDate: return parseDateDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodUndefined: return parseUndefinedDef$1();
		case ZodFirstPartyTypeKind.ZodNull: return parseNullDef$1();
		case ZodFirstPartyTypeKind.ZodArray: return parseArrayDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodUnion:
		case ZodFirstPartyTypeKind.ZodDiscriminatedUnion: return parseUnionDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodIntersection: return parseIntersectionDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodTuple: return parseTupleDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodRecord: return parseRecordDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodLiteral: return parseLiteralDef$1(def);
		case ZodFirstPartyTypeKind.ZodEnum: return parseEnumDef$1(def);
		case ZodFirstPartyTypeKind.ZodNativeEnum: return parseNativeEnumDef$1(def);
		case ZodFirstPartyTypeKind.ZodNullable: return parseNullableDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodOptional: return parseOptionalDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodMap: return parseMapDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodSet: return parseSetDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodLazy: return () => def.getter()._def;
		case ZodFirstPartyTypeKind.ZodPromise: return parsePromiseDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodNaN:
		case ZodFirstPartyTypeKind.ZodNever: return parseNeverDef$1();
		case ZodFirstPartyTypeKind.ZodEffects: return parseEffectsDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodAny: return parseAnyDef$1();
		case ZodFirstPartyTypeKind.ZodUnknown: return parseUnknownDef$1();
		case ZodFirstPartyTypeKind.ZodDefault: return parseDefaultDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodBranded: return parseBrandedDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodReadonly: return parseReadonlyDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodCatch: return parseCatchDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodPipeline: return parsePipelineDef$1(def, refs);
		case ZodFirstPartyTypeKind.ZodFunction:
		case ZodFirstPartyTypeKind.ZodVoid:
		case ZodFirstPartyTypeKind.ZodSymbol: return;
		default: return /* @__PURE__ */ ((_) => void 0)(typeName);
	}
};
var getRelativePath$1 = (pathA, pathB) => {
	let i = 0;
	for (; i < pathA.length && i < pathB.length; i++) if (pathA[i] !== pathB[i]) break;
	return [(pathA.length - i).toString(), ...pathB.slice(i)].join("/");
};
function parseDef$1(def, refs, forceResolution = false) {
	var _a2;
	const seenItem = refs.seen.get(def);
	if (refs.override) {
		const overrideResult = (_a2 = refs.override) == null ? void 0 : _a2.call(refs, def, refs, seenItem, forceResolution);
		if (overrideResult !== ignoreOverride$1) return overrideResult;
	}
	if (seenItem && !forceResolution) {
		const seenSchema = get$ref$1(seenItem, refs);
		if (seenSchema !== void 0) return seenSchema;
	}
	const newItem = {
		def,
		path: refs.currentPath,
		jsonSchema: void 0
	};
	refs.seen.set(def, newItem);
	const jsonSchemaOrGetter = selectParser$1(def, def.typeName, refs);
	const jsonSchema2 = typeof jsonSchemaOrGetter === "function" ? parseDef$1(jsonSchemaOrGetter(), refs) : jsonSchemaOrGetter;
	if (jsonSchema2) addMeta$1(def, refs, jsonSchema2);
	if (refs.postProcess) {
		const postProcessResult = refs.postProcess(jsonSchema2, def, refs);
		newItem.jsonSchema = jsonSchema2;
		return postProcessResult;
	}
	newItem.jsonSchema = jsonSchema2;
	return jsonSchema2;
}
var get$ref$1 = (item, refs) => {
	switch (refs.$refStrategy) {
		case "root": return { $ref: item.path.join("/") };
		case "relative": return { $ref: getRelativePath$1(refs.currentPath, item.path) };
		case "none":
		case "seen":
			if (item.path.length < refs.currentPath.length && item.path.every((value, index) => refs.currentPath[index] === value)) {
				console.warn(`Recursive reference detected at ${refs.currentPath.join("/")}! Defaulting to any`);
				return parseAnyDef$1();
			}
			return refs.$refStrategy === "seen" ? parseAnyDef$1() : void 0;
	}
};
var addMeta$1 = (def, refs, jsonSchema2) => {
	if (def.description) jsonSchema2.description = def.description;
	return jsonSchema2;
};
var getRefs$1 = (options) => {
	const _options = getDefaultOptions$1(options);
	const currentPath = _options.name !== void 0 ? [
		..._options.basePath,
		_options.definitionPath,
		_options.name
	] : _options.basePath;
	return {
		..._options,
		currentPath,
		propertyPath: void 0,
		seen: new Map(Object.entries(_options.definitions).map(([name2, def]) => [def._def, {
			def: def._def,
			path: [
				..._options.basePath,
				_options.definitionPath,
				name2
			],
			jsonSchema: void 0
		}]))
	};
};
var zodToJsonSchema = (schema, options) => {
	var _a2;
	const refs = getRefs$1(options);
	let definitions = typeof options === "object" && options.definitions ? Object.entries(options.definitions).reduce((acc, [name3, schema2]) => {
		var _a3;
		return {
			...acc,
			[name3]: (_a3 = parseDef$1(schema2._def, {
				...refs,
				currentPath: [
					...refs.basePath,
					refs.definitionPath,
					name3
				]
			}, true)) != null ? _a3 : parseAnyDef$1()
		};
	}, {}) : void 0;
	const name2 = typeof options === "string" ? options : (options == null ? void 0 : options.nameStrategy) === "title" ? void 0 : options == null ? void 0 : options.name;
	const main = (_a2 = parseDef$1(schema._def, name2 === void 0 ? refs : {
		...refs,
		currentPath: [
			...refs.basePath,
			refs.definitionPath,
			name2
		]
	}, false)) != null ? _a2 : parseAnyDef$1();
	const title = typeof options === "object" && options.name !== void 0 && options.nameStrategy === "title" ? options.name : void 0;
	if (title !== void 0) main.title = title;
	const combined = name2 === void 0 ? definitions ? {
		...main,
		[refs.definitionPath]: definitions
	} : main : {
		$ref: [
			...refs.$refStrategy === "relative" ? [] : refs.basePath,
			refs.definitionPath,
			name2
		].join("/"),
		[refs.definitionPath]: {
			...definitions,
			[name2]: main
		}
	};
	combined.$schema = "http://json-schema.org/draft-07/schema#";
	return combined;
};
var zod_to_json_schema_default = zodToJsonSchema;
function zod3Schema$1(zodSchema2, options) {
	var _a2;
	const useReferences = (_a2 = options == null ? void 0 : options.useReferences) != null ? _a2 : false;
	return jsonSchema$1(() => zod_to_json_schema_default(zodSchema2, { $refStrategy: useReferences ? "root" : "none" }), { validate: async (value) => {
		const result = await zodSchema2.safeParseAsync(value);
		return result.success ? {
			success: true,
			value: result.data
		} : {
			success: false,
			error: result.error
		};
	} });
}
function zod4Schema$1(zodSchema2, options) {
	var _a2;
	const useReferences = (_a2 = options == null ? void 0 : options.useReferences) != null ? _a2 : false;
	return jsonSchema$1(() => addAdditionalPropertiesToJsonSchema$1(z4.toJSONSchema(zodSchema2, {
		target: "draft-7",
		io: "input",
		reused: useReferences ? "ref" : "inline"
	})), { validate: async (value) => {
		const result = await z4.safeParseAsync(zodSchema2, value);
		return result.success ? {
			success: true,
			value: result.data
		} : {
			success: false,
			error: result.error
		};
	} });
}
function isZod4Schema$1(zodSchema2) {
	return "_zod" in zodSchema2;
}
function zodSchema$1(zodSchema2, options) {
	if (isZod4Schema$1(zodSchema2)) return zod4Schema$1(zodSchema2, options);
	else return zod3Schema$1(zodSchema2, options);
}
function isSchema$1(value) {
	return typeof value === "object" && value !== null && schemaSymbol$1 in value && value[schemaSymbol$1] === true && "jsonSchema" in value && "validate" in value;
}
function asSchema$1(schema) {
	return schema == null ? jsonSchema$1({
		properties: {},
		additionalProperties: false
	}) : isSchema$1(schema) ? schema : typeof schema === "function" ? schema() : zodSchema$1(schema);
}
var { btoa: btoa$1, atob: atob$1 } = globalThis;
function withoutTrailingSlash$1(url) {
	return url == null ? void 0 : url.replace(/\/$/, "");
}
//#endregion
//#region ../_vendored/ai_v5/dist/index.js
function getContext$1() {
	return { headers: {} };
}
async function getVercelOidcToken$1() {
	if (process.env.VERCEL_OIDC_TOKEN) return process.env.VERCEL_OIDC_TOKEN ?? "";
	throw new Error("@vercel/oidc is not available in the vendored @internal AI packages. Provide an API key instead.");
}
var symbol$1$2 = Symbol.for("vercel.ai.gateway.error");
var _a$1$2;
var _b$3;
var GatewayError$1 = class _GatewayError extends (_b$3 = Error, _a$1$2 = symbol$1$2, _b$3) {
	constructor({ message, statusCode = 500, cause }) {
		super(message);
		this[_a$1$2] = true;
		this.statusCode = statusCode;
		this.cause = cause;
	}
	/**
	* Checks if the given error is a Gateway Error.
	* @param {unknown} error - The error to check.
	* @returns {boolean} True if the error is a Gateway Error, false otherwise.
	*/
	static isInstance(error) {
		return _GatewayError.hasMarker(error);
	}
	static hasMarker(error) {
		return typeof error === "object" && error !== null && symbol$1$2 in error && error[symbol$1$2] === true;
	}
};
var name$1$2 = "GatewayAuthenticationError";
var marker2$1$1 = `vercel.ai.gateway.error.${name$1$2}`;
var symbol2$1$1 = Symbol.for(marker2$1$1);
var _a2$1$1;
var _b2$2;
var GatewayAuthenticationError$1 = class _GatewayAuthenticationError extends (_b2$2 = GatewayError$1, _a2$1$1 = symbol2$1$1, _b2$2) {
	constructor({ message = "Authentication failed", statusCode = 401, cause } = {}) {
		super({
			message,
			statusCode,
			cause
		});
		this[_a2$1$1] = true;
		this.name = name$1$2;
		this.type = "authentication_error";
	}
	static isInstance(error) {
		return GatewayError$1.hasMarker(error) && symbol2$1$1 in error;
	}
	/**
	* Creates a contextual error message when authentication fails
	*/
	static createContextualError({ apiKeyProvided, oidcTokenProvided, message = "Authentication failed", statusCode = 401, cause }) {
		let contextualMessage;
		if (apiKeyProvided) contextualMessage = `AI Gateway authentication failed: Invalid API key.

Create a new API key: https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fai%2Fapi-keys

Provide via 'apiKey' option or 'AI_GATEWAY_API_KEY' environment variable.`;
		else if (oidcTokenProvided) contextualMessage = `AI Gateway authentication failed: Invalid OIDC token.

Run 'npx vercel link' to link your project, then 'vc env pull' to fetch the token.

Alternatively, use an API key: https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fai%2Fapi-keys`;
		else contextualMessage = `AI Gateway authentication failed: No authentication provided.

Option 1 - API key:
Create an API key: https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fai%2Fapi-keys
Provide via 'apiKey' option or 'AI_GATEWAY_API_KEY' environment variable.

Option 2 - OIDC token:
Run 'npx vercel link' to link your project, then 'vc env pull' to fetch the token.`;
		return new _GatewayAuthenticationError({
			message: contextualMessage,
			statusCode,
			cause
		});
	}
};
var name2$1$1 = "GatewayForbiddenError";
var marker3$1$1 = `vercel.ai.gateway.error.${name2$1$1}`;
var symbol3$1$1 = Symbol.for(marker3$1$1);
var forbiddenParamSchema$1 = lazyValidator(() => zodSchema$1(z$1.object({ ruleId: z$1.string() })));
var _a3$1$1;
var _b3$2;
var GatewayForbiddenError$1 = class extends (_b3$2 = GatewayError$1, _a3$1$1 = symbol3$1$1, _b3$2) {
	constructor({ message = "Forbidden", statusCode = 403, cause, ruleId } = {}) {
		super({
			message,
			statusCode,
			cause
		});
		this[_a3$1$1] = true;
		this.name = name2$1$1;
		this.type = "forbidden";
		this.ruleId = ruleId;
	}
	static isInstance(error) {
		return GatewayError$1.hasMarker(error) && symbol3$1$1 in error;
	}
};
var name3$1$1 = "GatewayInvalidRequestError";
var marker4$1$1 = `vercel.ai.gateway.error.${name3$1$1}`;
var symbol4$1$1 = Symbol.for(marker4$1$1);
var _a4$1$1;
var _b4$2;
var GatewayInvalidRequestError$1 = class extends (_b4$2 = GatewayError$1, _a4$1$1 = symbol4$1$1, _b4$2) {
	constructor({ message = "Invalid request", statusCode = 400, cause } = {}) {
		super({
			message,
			statusCode,
			cause
		});
		this[_a4$1$1] = true;
		this.name = name3$1$1;
		this.type = "invalid_request_error";
	}
	static isInstance(error) {
		return GatewayError$1.hasMarker(error) && symbol4$1$1 in error;
	}
};
var name4$1$1 = "GatewayRateLimitError";
var marker5$1$1 = `vercel.ai.gateway.error.${name4$1$1}`;
var symbol5$1$1 = Symbol.for(marker5$1$1);
var _a5$1$1;
var _b5$2;
var GatewayRateLimitError$1 = class extends (_b5$2 = GatewayError$1, _a5$1$1 = symbol5$1$1, _b5$2) {
	constructor({ message = "Rate limit exceeded", statusCode = 429, cause } = {}) {
		super({
			message,
			statusCode,
			cause
		});
		this[_a5$1$1] = true;
		this.name = name4$1$1;
		this.type = "rate_limit_exceeded";
	}
	static isInstance(error) {
		return GatewayError$1.hasMarker(error) && symbol5$1$1 in error;
	}
};
var name5$1$1 = "GatewayModelNotFoundError";
var marker6$1$1 = `vercel.ai.gateway.error.${name5$1$1}`;
var symbol6$1$1 = Symbol.for(marker6$1$1);
var modelNotFoundParamSchema$1 = lazyValidator(() => zodSchema$1(z$1.object({ modelId: z$1.string() })));
var _a6$1$1;
var _b6$2;
var GatewayModelNotFoundError$1 = class extends (_b6$2 = GatewayError$1, _a6$1$1 = symbol6$1$1, _b6$2) {
	constructor({ message = "Model not found", statusCode = 404, modelId, cause } = {}) {
		super({
			message,
			statusCode,
			cause
		});
		this[_a6$1$1] = true;
		this.name = name5$1$1;
		this.type = "model_not_found";
		this.modelId = modelId;
	}
	static isInstance(error) {
		return GatewayError$1.hasMarker(error) && symbol6$1$1 in error;
	}
};
var name6$1$1 = "GatewayInternalServerError";
var marker7$1$1 = `vercel.ai.gateway.error.${name6$1$1}`;
var symbol7$1$1 = Symbol.for(marker7$1$1);
var _a7$1$1;
var _b7$2;
var GatewayInternalServerError$1 = class extends (_b7$2 = GatewayError$1, _a7$1$1 = symbol7$1$1, _b7$2) {
	constructor({ message = "Internal server error", statusCode = 500, cause } = {}) {
		super({
			message,
			statusCode,
			cause
		});
		this[_a7$1$1] = true;
		this.name = name6$1$1;
		this.type = "internal_server_error";
	}
	static isInstance(error) {
		return GatewayError$1.hasMarker(error) && symbol7$1$1 in error;
	}
};
var name7$1$1 = "GatewayResponseError";
var marker8$1$1 = `vercel.ai.gateway.error.${name7$1$1}`;
var symbol8$1$1 = Symbol.for(marker8$1$1);
var _a8$1$1;
var _b8$2;
var GatewayResponseError$1 = class extends (_b8$2 = GatewayError$1, _a8$1$1 = symbol8$1$1, _b8$2) {
	constructor({ message = "Invalid response from Gateway", statusCode = 502, response, validationError, cause } = {}) {
		super({
			message,
			statusCode,
			cause
		});
		this[_a8$1$1] = true;
		this.name = name7$1$1;
		this.type = "response_error";
		this.response = response;
		this.validationError = validationError;
	}
	static isInstance(error) {
		return GatewayError$1.hasMarker(error) && symbol8$1$1 in error;
	}
};
async function createGatewayErrorFromResponse$1({ response, statusCode, defaultMessage = "Gateway request failed", cause, authMethod }) {
	const parseResult = await safeValidateTypes$1({
		value: response,
		schema: gatewayErrorResponseSchema$1
	});
	if (!parseResult.success) return new GatewayResponseError$1({
		message: `Invalid error response format: ${defaultMessage}`,
		statusCode,
		response,
		validationError: parseResult.error,
		cause
	});
	const validatedResponse = parseResult.value;
	const errorType = validatedResponse.error.type;
	const message = validatedResponse.error.message;
	switch (errorType) {
		case "authentication_error": return GatewayAuthenticationError$1.createContextualError({
			apiKeyProvided: authMethod === "api-key",
			oidcTokenProvided: authMethod === "oidc",
			statusCode,
			cause
		});
		case "invalid_request_error": return new GatewayInvalidRequestError$1({
			message,
			statusCode,
			cause
		});
		case "rate_limit_exceeded": return new GatewayRateLimitError$1({
			message,
			statusCode,
			cause
		});
		case "model_not_found": {
			const modelResult = await safeValidateTypes$1({
				value: validatedResponse.error.param,
				schema: modelNotFoundParamSchema$1
			});
			return new GatewayModelNotFoundError$1({
				message,
				statusCode,
				modelId: modelResult.success ? modelResult.value.modelId : void 0,
				cause
			});
		}
		case "internal_server_error": return new GatewayInternalServerError$1({
			message,
			statusCode,
			cause
		});
		case "forbidden": {
			const ruleResult = await safeValidateTypes$1({
				value: validatedResponse.error.param,
				schema: forbiddenParamSchema$1
			});
			return new GatewayForbiddenError$1({
				message,
				statusCode,
				cause,
				ruleId: ruleResult.success ? ruleResult.value.ruleId : void 0
			});
		}
		default: return new GatewayInternalServerError$1({
			message,
			statusCode,
			cause
		});
	}
}
var gatewayErrorResponseSchema$1 = lazyValidator(() => zodSchema$1(z$1.object({ error: z$1.object({
	message: z$1.string(),
	type: z$1.string().nullish(),
	param: z$1.unknown().nullish(),
	code: z$1.union([z$1.string(), z$1.number()]).nullish()
}) })));
function extractApiCallResponse$1(error) {
	if (error.data !== void 0) return error.data;
	if (error.responseBody != null) try {
		return JSON.parse(error.responseBody);
	} catch (e) {
		return error.responseBody;
	}
	return {};
}
var name8$1$1 = "GatewayTimeoutError";
var marker9$1$1 = `vercel.ai.gateway.error.${name8$1$1}`;
var symbol9$1$1 = Symbol.for(marker9$1$1);
var _a9$1$1;
var _b9$2;
var GatewayTimeoutError$1 = class _GatewayTimeoutError extends (_b9$2 = GatewayError$1, _a9$1$1 = symbol9$1$1, _b9$2) {
	constructor({ message = "Request timed out", statusCode = 408, cause } = {}) {
		super({
			message,
			statusCode,
			cause
		});
		this[_a9$1$1] = true;
		this.name = name8$1$1;
		this.type = "timeout_error";
	}
	static isInstance(error) {
		return GatewayError$1.hasMarker(error) && symbol9$1$1 in error;
	}
	/**
	* Creates a helpful timeout error message with troubleshooting guidance
	*/
	static createTimeoutError({ originalMessage, statusCode = 408, cause }) {
		const message = `Gateway request timed out: ${originalMessage}

    This is a client-side timeout. To resolve this, increase your timeout configuration: https://vercel.com/docs/ai-gateway/capabilities/video-generation#extending-timeouts-for-node.js`;
		return new _GatewayTimeoutError({
			message,
			statusCode,
			cause
		});
	}
};
function isTimeoutError$1(error) {
	if (!(error instanceof Error)) return false;
	const errorCode = error.code;
	if (typeof errorCode === "string") return [
		"UND_ERR_HEADERS_TIMEOUT",
		"UND_ERR_BODY_TIMEOUT",
		"UND_ERR_CONNECT_TIMEOUT"
	].includes(errorCode);
	return false;
}
async function asGatewayError$1(error, authMethod) {
	var _a10;
	if (GatewayError$1.isInstance(error)) return error;
	if (isTimeoutError$1(error)) return GatewayTimeoutError$1.createTimeoutError({
		originalMessage: error instanceof Error ? error.message : "Unknown error",
		cause: error
	});
	if (APICallError$1.isInstance(error)) {
		if (error.cause && isTimeoutError$1(error.cause)) return GatewayTimeoutError$1.createTimeoutError({
			originalMessage: error.message,
			cause: error
		});
		return await createGatewayErrorFromResponse$1({
			response: extractApiCallResponse$1(error),
			statusCode: (_a10 = error.statusCode) != null ? _a10 : 500,
			defaultMessage: "Gateway request failed",
			cause: error,
			authMethod
		});
	}
	return await createGatewayErrorFromResponse$1({
		response: {},
		statusCode: 500,
		defaultMessage: error instanceof Error ? `Gateway request failed: ${error.message}` : "Unknown Gateway error",
		cause: error,
		authMethod
	});
}
var GATEWAY_AUTH_METHOD_HEADER$1 = "ai-gateway-auth-method";
async function parseAuthMethod$1(headers) {
	const result = await safeValidateTypes$1({
		value: headers[GATEWAY_AUTH_METHOD_HEADER$1],
		schema: gatewayAuthMethodSchema$1
	});
	return result.success ? result.value : void 0;
}
var gatewayAuthMethodSchema$1 = lazyValidator(() => zodSchema$1(z$1.union([z$1.literal("api-key"), z$1.literal("oidc")])));
var KNOWN_MODEL_TYPES$1 = [
	"embedding",
	"image",
	"language"
];
var GatewayFetchMetadata$1 = class {
	constructor(config) {
		this.config = config;
	}
	async getAvailableModels() {
		try {
			const { value } = await getFromApi$1({
				url: `${this.config.baseURL}/config`,
				headers: await resolve$1(this.config.headers()),
				successfulResponseHandler: createJsonResponseHandler$1(gatewayAvailableModelsResponseSchema$1),
				failedResponseHandler: createJsonErrorResponseHandler$1({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				fetch: this.config.fetch
			});
			return value;
		} catch (error) {
			throw await asGatewayError$1(error);
		}
	}
	async getCredits() {
		try {
			const { value } = await getFromApi$1({
				url: `${new URL(this.config.baseURL).origin}/v1/credits`,
				headers: await resolve$1(this.config.headers()),
				successfulResponseHandler: createJsonResponseHandler$1(gatewayCreditsResponseSchema$1),
				failedResponseHandler: createJsonErrorResponseHandler$1({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				fetch: this.config.fetch
			});
			return value;
		} catch (error) {
			throw await asGatewayError$1(error);
		}
	}
};
var gatewayAvailableModelsResponseSchema$1 = lazyValidator(() => zodSchema$1(z$1.object({ models: z$1.array(z$1.object({
	id: z$1.string(),
	name: z$1.string(),
	description: z$1.string().nullish(),
	pricing: z$1.object({
		input: z$1.string(),
		output: z$1.string(),
		input_cache_read: z$1.string().nullish(),
		input_cache_write: z$1.string().nullish()
	}).transform(({ input, output, input_cache_read, input_cache_write }) => ({
		input,
		output,
		...input_cache_read ? { cachedInputTokens: input_cache_read } : {},
		...input_cache_write ? { cacheCreationInputTokens: input_cache_write } : {}
	})).nullish(),
	specification: z$1.object({
		specificationVersion: z$1.literal("v2"),
		provider: z$1.string(),
		modelId: z$1.string()
	}),
	modelType: z$1.string().nullish()
})).transform((models) => models.filter((m) => m.modelType == null || KNOWN_MODEL_TYPES$1.includes(m.modelType))) })));
var gatewayCreditsResponseSchema$1 = lazyValidator(() => zodSchema$1(z$1.object({
	balance: z$1.string(),
	total_used: z$1.string()
}).transform(({ balance, total_used }) => ({
	balance,
	totalUsed: total_used
}))));
var GatewaySpendReport$1 = class {
	constructor(config) {
		this.config = config;
	}
	async getSpendReport(params) {
		try {
			const baseUrl = new URL(this.config.baseURL);
			const searchParams = new URLSearchParams();
			searchParams.set("start_date", params.startDate);
			searchParams.set("end_date", params.endDate);
			if (params.groupBy) searchParams.set("group_by", params.groupBy);
			if (params.datePart) searchParams.set("date_part", params.datePart);
			if (params.userId) searchParams.set("user_id", params.userId);
			if (params.model) searchParams.set("model", params.model);
			if (params.provider) searchParams.set("provider", params.provider);
			if (params.credentialType) searchParams.set("credential_type", params.credentialType);
			if (params.tags && params.tags.length > 0) searchParams.set("tags", params.tags.join(","));
			const { value } = await getFromApi$1({
				url: `${baseUrl.origin}/v1/report?${searchParams.toString()}`,
				headers: await resolve$1(this.config.headers()),
				successfulResponseHandler: createJsonResponseHandler$1(gatewaySpendReportResponseSchema$1),
				failedResponseHandler: createJsonErrorResponseHandler$1({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				fetch: this.config.fetch
			});
			return value;
		} catch (error) {
			throw await asGatewayError$1(error);
		}
	}
};
var gatewaySpendReportResponseSchema$1 = lazySchema$1(() => zodSchema$1(z$1.object({ results: z$1.array(z$1.object({
	day: z$1.string().optional(),
	hour: z$1.string().optional(),
	user: z$1.string().optional(),
	model: z$1.string().optional(),
	tag: z$1.string().optional(),
	provider: z$1.string().optional(),
	credential_type: z$1.enum(["byok", "system"]).optional(),
	total_cost: z$1.number(),
	market_cost: z$1.number().optional(),
	input_tokens: z$1.number().optional(),
	output_tokens: z$1.number().optional(),
	cached_input_tokens: z$1.number().optional(),
	cache_creation_input_tokens: z$1.number().optional(),
	reasoning_tokens: z$1.number().optional(),
	request_count: z$1.number().optional()
}).transform(({ credential_type, total_cost, market_cost, input_tokens, output_tokens, cached_input_tokens, cache_creation_input_tokens, reasoning_tokens, request_count, ...rest }) => ({
	...rest,
	...credential_type !== void 0 ? { credentialType: credential_type } : {},
	totalCost: total_cost,
	...market_cost !== void 0 ? { marketCost: market_cost } : {},
	...input_tokens !== void 0 ? { inputTokens: input_tokens } : {},
	...output_tokens !== void 0 ? { outputTokens: output_tokens } : {},
	...cached_input_tokens !== void 0 ? { cachedInputTokens: cached_input_tokens } : {},
	...cache_creation_input_tokens !== void 0 ? { cacheCreationInputTokens: cache_creation_input_tokens } : {},
	...reasoning_tokens !== void 0 ? { reasoningTokens: reasoning_tokens } : {},
	...request_count !== void 0 ? { requestCount: request_count } : {}
}))) })));
var GatewayGenerationInfoFetcher$1 = class {
	constructor(config) {
		this.config = config;
	}
	async getGenerationInfo(params) {
		try {
			const { value } = await getFromApi$1({
				url: `${new URL(this.config.baseURL).origin}/v1/generation?id=${encodeURIComponent(params.id)}`,
				headers: await resolve$1(this.config.headers()),
				successfulResponseHandler: createJsonResponseHandler$1(gatewayGenerationInfoResponseSchema$1),
				failedResponseHandler: createJsonErrorResponseHandler$1({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				fetch: this.config.fetch
			});
			return value;
		} catch (error) {
			throw await asGatewayError$1(error);
		}
	}
};
var gatewayGenerationInfoResponseSchema$1 = lazySchema$1(() => zodSchema$1(z$1.object({ data: z$1.object({
	id: z$1.string(),
	total_cost: z$1.number(),
	upstream_inference_cost: z$1.number(),
	usage: z$1.number(),
	created_at: z$1.string(),
	model: z$1.string(),
	is_byok: z$1.boolean(),
	provider_name: z$1.string(),
	streamed: z$1.boolean(),
	finish_reason: z$1.string(),
	latency: z$1.number(),
	generation_time: z$1.number(),
	native_tokens_prompt: z$1.number(),
	native_tokens_completion: z$1.number(),
	native_tokens_reasoning: z$1.number(),
	native_tokens_cached: z$1.number(),
	native_tokens_cache_creation: z$1.number(),
	billable_web_search_calls: z$1.number()
}).transform(({ total_cost, upstream_inference_cost, created_at, is_byok, provider_name, finish_reason, generation_time, native_tokens_prompt, native_tokens_completion, native_tokens_reasoning, native_tokens_cached, native_tokens_cache_creation, billable_web_search_calls, ...rest }) => ({
	...rest,
	totalCost: total_cost,
	upstreamInferenceCost: upstream_inference_cost,
	createdAt: created_at,
	isByok: is_byok,
	providerName: provider_name,
	finishReason: finish_reason,
	generationTime: generation_time,
	promptTokens: native_tokens_prompt,
	completionTokens: native_tokens_completion,
	reasoningTokens: native_tokens_reasoning,
	cachedTokens: native_tokens_cached,
	cacheCreationTokens: native_tokens_cache_creation,
	billableWebSearchCalls: billable_web_search_calls
})) }).transform(({ data }) => data)));
var GatewayLanguageModel$1 = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v2";
		this.supportedUrls = { "*/*": [/.*/] };
	}
	get provider() {
		return this.config.provider;
	}
	async getArgs(options) {
		const { abortSignal: _abortSignal, ...optionsWithoutSignal } = options;
		return {
			args: this.maybeEncodeFileParts(optionsWithoutSignal),
			warnings: []
		};
	}
	async doGenerate(options) {
		const { args, warnings } = await this.getArgs(options);
		const { abortSignal } = options;
		const resolvedHeaders = await resolve$1(this.config.headers());
		try {
			const { responseHeaders, value: responseBody, rawValue: rawResponse } = await postJsonToApi$1({
				url: this.getUrl(),
				headers: combineHeaders$1(resolvedHeaders, options.headers, this.getModelConfigHeaders(this.modelId, false), await resolve$1(this.config.o11yHeaders)),
				body: args,
				successfulResponseHandler: createJsonResponseHandler$1(z$1.any()),
				failedResponseHandler: createJsonErrorResponseHandler$1({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				...responseBody,
				request: { body: args },
				response: {
					headers: responseHeaders,
					body: rawResponse
				},
				warnings
			};
		} catch (error) {
			throw await asGatewayError$1(error, await parseAuthMethod$1(resolvedHeaders));
		}
	}
	async doStream(options) {
		const { args, warnings } = await this.getArgs(options);
		const { abortSignal } = options;
		const resolvedHeaders = await resolve$1(this.config.headers());
		try {
			const { value: response, responseHeaders } = await postJsonToApi$1({
				url: this.getUrl(),
				headers: combineHeaders$1(resolvedHeaders, options.headers, this.getModelConfigHeaders(this.modelId, true), await resolve$1(this.config.o11yHeaders)),
				body: args,
				successfulResponseHandler: createEventSourceResponseHandler$1(z$1.any()),
				failedResponseHandler: createJsonErrorResponseHandler$1({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				stream: response.pipeThrough(new TransformStream({
					start(controller) {
						if (warnings.length > 0) controller.enqueue({
							type: "stream-start",
							warnings
						});
					},
					transform(chunk, controller) {
						if (chunk.success) {
							const streamPart = chunk.value;
							if (streamPart.type === "raw" && !options.includeRawChunks) return;
							if (streamPart.type === "response-metadata" && streamPart.timestamp && typeof streamPart.timestamp === "string") streamPart.timestamp = new Date(streamPart.timestamp);
							controller.enqueue(streamPart);
						} else controller.error(chunk.error);
					}
				})),
				request: { body: args },
				response: { headers: responseHeaders }
			};
		} catch (error) {
			throw await asGatewayError$1(error, await parseAuthMethod$1(resolvedHeaders));
		}
	}
	isFilePart(part) {
		return part && typeof part === "object" && "type" in part && part.type === "file";
	}
	/**
	* Encodes file parts in the prompt to base64. Mutates the passed options
	* instance directly to avoid copying the file data.
	* @param options - The options to encode.
	* @returns The options with the file parts encoded.
	*/
	maybeEncodeFileParts(options) {
		for (const message of options.prompt) for (const part of message.content) if (this.isFilePart(part)) {
			const filePart = part;
			if (filePart.data instanceof Uint8Array) {
				const buffer = Uint8Array.from(filePart.data);
				const base64Data = Buffer.from(buffer).toString("base64");
				filePart.data = new URL(`data:${filePart.mediaType || "application/octet-stream"};base64,${base64Data}`);
			}
		}
		return options;
	}
	getUrl() {
		return `${this.config.baseURL}/language-model`;
	}
	getModelConfigHeaders(modelId, streaming) {
		return {
			"ai-language-model-specification-version": "2",
			"ai-language-model-id": modelId,
			"ai-language-model-streaming": String(streaming)
		};
	}
};
var GatewayEmbeddingModel$1 = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v2";
		this.maxEmbeddingsPerCall = 2048;
		this.supportsParallelCalls = true;
	}
	get provider() {
		return this.config.provider;
	}
	async doEmbed({ values, headers, abortSignal, providerOptions }) {
		var _a10;
		const resolvedHeaders = await resolve$1(this.config.headers());
		try {
			const { responseHeaders, value: responseBody, rawValue } = await postJsonToApi$1({
				url: this.getUrl(),
				headers: combineHeaders$1(resolvedHeaders, headers != null ? headers : {}, this.getModelConfigHeaders(), await resolve$1(this.config.o11yHeaders)),
				body: {
					input: values.length === 1 ? values[0] : values,
					...providerOptions ? { providerOptions } : {}
				},
				successfulResponseHandler: createJsonResponseHandler$1(gatewayEmbeddingResponseSchema$1),
				failedResponseHandler: createJsonErrorResponseHandler$1({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				embeddings: responseBody.embeddings,
				usage: (_a10 = responseBody.usage) != null ? _a10 : void 0,
				providerMetadata: responseBody.providerMetadata,
				response: {
					headers: responseHeaders,
					body: rawValue
				}
			};
		} catch (error) {
			throw await asGatewayError$1(error, await parseAuthMethod$1(resolvedHeaders));
		}
	}
	getUrl() {
		return `${this.config.baseURL}/embedding-model`;
	}
	getModelConfigHeaders() {
		return {
			"ai-embedding-model-specification-version": "2",
			"ai-model-id": this.modelId
		};
	}
};
var gatewayEmbeddingResponseSchema$1 = lazyValidator(() => zodSchema$1(z$1.object({
	embeddings: z$1.array(z$1.array(z$1.number())),
	usage: z$1.object({ tokens: z$1.number() }).nullish(),
	providerMetadata: z$1.record(z$1.string(), z$1.record(z$1.string(), z$1.unknown())).optional()
})));
var GatewayImageModel$1 = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v2";
		this.maxImagesPerCall = Number.MAX_SAFE_INTEGER;
	}
	get provider() {
		return this.config.provider;
	}
	async doGenerate({ prompt, n, size, aspectRatio, seed, providerOptions, headers, abortSignal }) {
		var _a10, _b10, _c, _d;
		const resolvedHeaders = await resolve$1(this.config.headers());
		try {
			const { responseHeaders, value: responseBody, rawValue } = await postJsonToApi$1({
				url: this.getUrl(),
				headers: combineHeaders$1(resolvedHeaders, headers != null ? headers : {}, this.getModelConfigHeaders(), await resolve$1(this.config.o11yHeaders)),
				body: {
					prompt,
					n,
					...size && { size },
					...aspectRatio && { aspectRatio },
					...seed && { seed },
					...providerOptions && { providerOptions }
				},
				successfulResponseHandler: createJsonResponseHandler$1(gatewayImageResponseSchema$1),
				failedResponseHandler: createJsonErrorResponseHandler$1({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				images: responseBody.images,
				warnings: (_a10 = responseBody.warnings) != null ? _a10 : [],
				providerMetadata: responseBody.providerMetadata,
				response: {
					timestamp: /* @__PURE__ */ new Date(),
					modelId: this.modelId,
					headers: responseHeaders
				},
				...responseBody.usage != null && { usage: {
					inputTokens: (_b10 = responseBody.usage.inputTokens) != null ? _b10 : void 0,
					outputTokens: (_c = responseBody.usage.outputTokens) != null ? _c : void 0,
					totalTokens: (_d = responseBody.usage.totalTokens) != null ? _d : void 0
				} }
			};
		} catch (error) {
			throw await asGatewayError$1(error, await parseAuthMethod$1(resolvedHeaders));
		}
	}
	getUrl() {
		return `${this.config.baseURL}/image-model`;
	}
	getModelConfigHeaders() {
		return {
			"ai-image-model-specification-version": "2",
			"ai-model-id": this.modelId
		};
	}
};
var providerMetadataEntrySchema$1 = z$1.object({ images: z$1.array(z$1.unknown()).optional() }).catchall(z$1.unknown());
var gatewayImageUsageSchema$1 = z$1.object({
	inputTokens: z$1.number().nullish(),
	outputTokens: z$1.number().nullish(),
	totalTokens: z$1.number().nullish()
});
var gatewayImageResponseSchema$1 = z$1.object({
	images: z$1.array(z$1.string()),
	warnings: z$1.array(z$1.object({
		type: z$1.literal("other"),
		message: z$1.string()
	})).optional(),
	providerMetadata: z$1.record(z$1.string(), providerMetadataEntrySchema$1).optional(),
	usage: gatewayImageUsageSchema$1.optional()
});
var parallelSearchToolFactory$1 = createProviderDefinedToolFactoryWithOutputSchema({
	id: "gateway.parallel_search",
	name: "parallel_search",
	inputSchema: lazySchema$1(() => zodSchema$1(z.object({
		objective: z.string().describe("Natural-language description of the web research goal, including source or freshness guidance and broader context from the task. Maximum 5000 characters."),
		search_queries: z.array(z.string()).optional().describe("Optional search queries to supplement the objective. Maximum 200 characters per query."),
		mode: z.enum(["one-shot", "agentic"]).optional().describe("Mode preset: \"one-shot\" for comprehensive results with longer excerpts (default), \"agentic\" for concise, token-efficient results for multi-step workflows."),
		max_results: z.number().optional().describe("Maximum number of results to return (1-20). Defaults to 10 if not specified."),
		source_policy: z.object({
			include_domains: z.array(z.string()).optional().describe("List of domains to include in search results."),
			exclude_domains: z.array(z.string()).optional().describe("List of domains to exclude from search results."),
			after_date: z.string().optional().describe("Only include results published after this date (ISO 8601 format).")
		}).optional().describe("Source policy for controlling which domains to include/exclude and freshness."),
		excerpts: z.object({
			max_chars_per_result: z.number().optional().describe("Maximum characters per result."),
			max_chars_total: z.number().optional().describe("Maximum total characters across all results.")
		}).optional().describe("Excerpt configuration for controlling result length."),
		fetch_policy: z.object({ max_age_seconds: z.number().optional().describe("Maximum age in seconds for cached content. Set to 0 to always fetch fresh content.") }).optional().describe("Fetch policy for controlling content freshness.")
	}))),
	outputSchema: lazySchema$1(() => zodSchema$1(z.union([z.object({
		searchId: z.string(),
		results: z.array(z.object({
			url: z.string(),
			title: z.string(),
			excerpt: z.string(),
			publishDate: z.string().nullable().optional(),
			relevanceScore: z.number().optional()
		}))
	}), z.object({
		error: z.enum([
			"api_error",
			"rate_limit",
			"timeout",
			"invalid_input",
			"configuration_error",
			"unknown"
		]),
		statusCode: z.number().optional(),
		message: z.string()
	})])))
});
var parallelSearch$1 = (config = {}) => parallelSearchToolFactory$1(config);
var perplexitySearchToolFactory$1 = createProviderDefinedToolFactoryWithOutputSchema({
	id: "gateway.perplexity_search",
	name: "perplexity_search",
	inputSchema: lazySchema$1(() => zodSchema$1(z.object({
		query: z.union([z.string(), z.array(z.string())]).describe("Search query (string) or multiple queries (array of up to 5 strings). Multi-query searches return combined results from all queries."),
		max_results: z.number().optional().describe("Maximum number of search results to return (1-20, default: 10)"),
		max_tokens_per_page: z.number().optional().describe("Maximum number of tokens to extract per search result page (256-2048, default: 2048)"),
		max_tokens: z.number().optional().describe("Maximum total tokens across all search results (default: 25000, max: 1000000)"),
		country: z.string().optional().describe("Two-letter ISO 3166-1 alpha-2 country code for regional search results (e.g., 'US', 'GB', 'FR')"),
		search_domain_filter: z.array(z.string()).optional().describe("List of domains to include or exclude from search results (max 20). To include: ['nature.com', 'science.org']. To exclude: ['-example.com', '-spam.net']"),
		search_language_filter: z.array(z.string()).optional().describe("List of ISO 639-1 language codes to filter results (max 10, lowercase). Examples: ['en', 'fr', 'de']"),
		search_after_date: z.string().optional().describe("Include only results published after this date. Format: 'MM/DD/YYYY' (e.g., '3/1/2025'). Cannot be used with search_recency_filter."),
		search_before_date: z.string().optional().describe("Include only results published before this date. Format: 'MM/DD/YYYY' (e.g., '3/15/2025'). Cannot be used with search_recency_filter."),
		last_updated_after_filter: z.string().optional().describe("Include only results last updated after this date. Format: 'MM/DD/YYYY' (e.g., '3/1/2025'). Cannot be used with search_recency_filter."),
		last_updated_before_filter: z.string().optional().describe("Include only results last updated before this date. Format: 'MM/DD/YYYY' (e.g., '3/15/2025'). Cannot be used with search_recency_filter."),
		search_recency_filter: z.enum([
			"day",
			"week",
			"month",
			"year"
		]).optional().describe("Filter results by relative time period. Cannot be used with search_after_date or search_before_date.")
	}))),
	outputSchema: lazySchema$1(() => zodSchema$1(z.union([z.object({
		results: z.array(z.object({
			title: z.string(),
			url: z.string(),
			snippet: z.string(),
			date: z.string().optional(),
			lastUpdated: z.string().optional()
		})),
		id: z.string()
	}), z.object({
		error: z.enum([
			"api_error",
			"rate_limit",
			"timeout",
			"invalid_input",
			"unknown"
		]),
		statusCode: z.number().optional(),
		message: z.string()
	})])))
});
var perplexitySearch$1 = (config = {}) => perplexitySearchToolFactory$1(config);
var gatewayTools$1 = {
	/**
	* Search the web using Parallel AI's Search API for LLM-optimized excerpts.
	*
	* Takes a natural language objective and returns relevant excerpts,
	* replacing multiple keyword searches with a single call for broad
	* or complex queries. Supports different search types for depth vs
	* breadth tradeoffs.
	*/
	parallelSearch: parallelSearch$1,
	/**
	* Search the web using Perplexity's Search API for real-time information,
	* news, research papers, and articles.
	*
	* Provides ranked search results with advanced filtering options including
	* domain, language, date range, and recency filters.
	*/
	perplexitySearch: perplexitySearch$1
};
async function getVercelRequestId$1() {
	var _a10;
	return (_a10 = getContext$1().headers) == null ? void 0 : _a10["x-vercel-id"];
}
var VERSION$2$2 = "2.0.115";
var AI_GATEWAY_PROTOCOL_VERSION$1 = "0.0.1";
function createGatewayProvider$1(options = {}) {
	var _a10, _b10;
	let pendingMetadata = null;
	let metadataCache = null;
	const cacheRefreshMillis = (_a10 = options.metadataCacheRefreshMillis) != null ? _a10 : 1e3 * 60 * 5;
	let lastFetchTime = 0;
	const baseURL = (_b10 = withoutTrailingSlash$1(options.baseURL)) != null ? _b10 : "https://ai-gateway.vercel.sh/v1/ai";
	const getHeaders = async () => {
		const auth = await getGatewayAuthToken$1(options);
		if (auth) return withUserAgentSuffix$1({
			Authorization: `Bearer ${auth.token}`,
			"ai-gateway-protocol-version": AI_GATEWAY_PROTOCOL_VERSION$1,
			[GATEWAY_AUTH_METHOD_HEADER$1]: auth.authMethod,
			...options.headers
		}, `ai-sdk/gateway/${VERSION$2$2}`);
		throw GatewayAuthenticationError$1.createContextualError({
			apiKeyProvided: false,
			oidcTokenProvided: false,
			statusCode: 401
		});
	};
	const createO11yHeaders = () => {
		const deploymentId = loadOptionalSetting$1({
			settingValue: void 0,
			environmentVariableName: "VERCEL_DEPLOYMENT_ID"
		});
		const environment = loadOptionalSetting$1({
			settingValue: void 0,
			environmentVariableName: "VERCEL_ENV"
		});
		const region = loadOptionalSetting$1({
			settingValue: void 0,
			environmentVariableName: "VERCEL_REGION"
		});
		const projectId = loadOptionalSetting$1({
			settingValue: void 0,
			environmentVariableName: "VERCEL_PROJECT_ID"
		});
		return async () => {
			const requestId = await getVercelRequestId$1();
			return {
				...deploymentId && { "ai-o11y-deployment-id": deploymentId },
				...environment && { "ai-o11y-environment": environment },
				...region && { "ai-o11y-region": region },
				...requestId && { "ai-o11y-request-id": requestId },
				...projectId && { "ai-o11y-project-id": projectId }
			};
		};
	};
	const createLanguageModel = (modelId) => {
		return new GatewayLanguageModel$1(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	const getAvailableModels = async () => {
		var _a11, _b11, _c;
		const now = (_c = (_b11 = (_a11 = options._internal) == null ? void 0 : _a11.currentDate) == null ? void 0 : _b11.call(_a11).getTime()) != null ? _c : Date.now();
		if (!pendingMetadata || now - lastFetchTime > cacheRefreshMillis) {
			lastFetchTime = now;
			pendingMetadata = new GatewayFetchMetadata$1({
				baseURL,
				headers: getHeaders,
				fetch: options.fetch
			}).getAvailableModels().then((metadata) => {
				metadataCache = metadata;
				return metadata;
			}).catch(async (error) => {
				throw await asGatewayError$1(error, await parseAuthMethod$1(await getHeaders()));
			});
		}
		return metadataCache ? Promise.resolve(metadataCache) : pendingMetadata;
	};
	const getCredits = async () => {
		return new GatewayFetchMetadata$1({
			baseURL,
			headers: getHeaders,
			fetch: options.fetch
		}).getCredits().catch(async (error) => {
			throw await asGatewayError$1(error, await parseAuthMethod$1(await getHeaders()));
		});
	};
	const getSpendReport = async (params) => {
		return new GatewaySpendReport$1({
			baseURL,
			headers: getHeaders,
			fetch: options.fetch
		}).getSpendReport(params).catch(async (error) => {
			throw await asGatewayError$1(error, await parseAuthMethod$1(await getHeaders()));
		});
	};
	const getGenerationInfo = async (params) => {
		return new GatewayGenerationInfoFetcher$1({
			baseURL,
			headers: getHeaders,
			fetch: options.fetch
		}).getGenerationInfo(params).catch(async (error) => {
			throw await asGatewayError$1(error, await parseAuthMethod$1(await getHeaders()));
		});
	};
	const provider = function(modelId) {
		if (new.target) throw new Error("The Gateway Provider model function cannot be called with the new keyword.");
		return createLanguageModel(modelId);
	};
	provider.getAvailableModels = getAvailableModels;
	provider.getCredits = getCredits;
	provider.getSpendReport = getSpendReport;
	provider.getGenerationInfo = getGenerationInfo;
	provider.imageModel = (modelId) => {
		return new GatewayImageModel$1(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	provider.languageModel = createLanguageModel;
	provider.textEmbeddingModel = (modelId) => {
		return new GatewayEmbeddingModel$1(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	provider.tools = gatewayTools$1;
	return provider;
}
var gateway$1 = createGatewayProvider$1();
async function getGatewayAuthToken$1(options) {
	const apiKey = loadOptionalSetting$1({
		settingValue: options.apiKey,
		environmentVariableName: "AI_GATEWAY_API_KEY"
	});
	if (apiKey) return {
		token: apiKey,
		authMethod: "api-key"
	};
	try {
		return {
			token: await getVercelOidcToken$1(),
			authMethod: "oidc"
		};
	} catch (e) {
		return null;
	}
}
/** only globals that common to node and browsers are allowed */
var _globalThis = typeof globalThis === "object" ? globalThis : global;
var VERSION$1$4 = "1.9.0";
var re$1 = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
/**
* Create a function to test an API version to see if it is compatible with the provided ownVersion.
*
* The returned function has the following semantics:
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param ownVersion version which should be checked against
*/
function _makeCompatibilityCheck$1(ownVersion) {
	var acceptedVersions = /* @__PURE__ */ new Set([ownVersion]);
	var rejectedVersions = /* @__PURE__ */ new Set();
	var myVersionMatch = ownVersion.match(re$1);
	if (!myVersionMatch) return function() {
		return false;
	};
	var ownVersionParsed = {
		major: +myVersionMatch[1],
		minor: +myVersionMatch[2],
		patch: +myVersionMatch[3],
		prerelease: myVersionMatch[4]
	};
	if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
		return globalVersion === ownVersion;
	};
	function _reject(v) {
		rejectedVersions.add(v);
		return false;
	}
	function _accept(v) {
		acceptedVersions.add(v);
		return true;
	}
	return function isCompatible(globalVersion) {
		if (acceptedVersions.has(globalVersion)) return true;
		if (rejectedVersions.has(globalVersion)) return false;
		var globalVersionMatch = globalVersion.match(re$1);
		if (!globalVersionMatch) return _reject(globalVersion);
		var globalVersionParsed = {
			major: +globalVersionMatch[1],
			minor: +globalVersionMatch[2],
			patch: +globalVersionMatch[3],
			prerelease: globalVersionMatch[4]
		};
		if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
		if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
		if (ownVersionParsed.major === 0) {
			if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
			return _reject(globalVersion);
		}
		if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
		return _reject(globalVersion);
	};
}
/**
* Test an API version to see if it is compatible with this API.
*
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param version version of the API requesting an instance of the global API
*/
var isCompatible$1 = _makeCompatibilityCheck$1(VERSION$1$4);
var major$1 = VERSION$1$4.split(".")[0];
var GLOBAL_OPENTELEMETRY_API_KEY$1 = Symbol.for("opentelemetry.js.api." + major$1);
var _global$1 = _globalThis;
function registerGlobal$1(type, instance, diag, allowOverride) {
	var _a;
	if (allowOverride === void 0) allowOverride = false;
	var api = _global$1[GLOBAL_OPENTELEMETRY_API_KEY$1] = (_a = _global$1[GLOBAL_OPENTELEMETRY_API_KEY$1]) !== null && _a !== void 0 ? _a : { version: VERSION$1$4 };
	if (!allowOverride && api[type]) {
		var err = /* @__PURE__ */ new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
		diag.error(err.stack || err.message);
		return false;
	}
	if (api.version !== "1.9.0") {
		var err = /* @__PURE__ */ new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + VERSION$1$4);
		diag.error(err.stack || err.message);
		return false;
	}
	api[type] = instance;
	diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + VERSION$1$4 + ".");
	return true;
}
function getGlobal$1(type) {
	var _a, _b;
	var globalVersion = (_a = _global$1[GLOBAL_OPENTELEMETRY_API_KEY$1]) === null || _a === void 0 ? void 0 : _a.version;
	if (!globalVersion || !isCompatible$1(globalVersion)) return;
	return (_b = _global$1[GLOBAL_OPENTELEMETRY_API_KEY$1]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal$1(type, diag) {
	diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + VERSION$1$4 + ".");
	var api = _global$1[GLOBAL_OPENTELEMETRY_API_KEY$1];
	if (api) delete api[type];
}
var __read$3 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$3 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
/**
* Component Logger which is meant to be used as part of any component which
* will add automatically additional namespace in front of the log message.
* It will then forward all message to global diag logger
* @example
* const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
* cLogger.debug('test');
* // @opentelemetry/instrumentation-http test
*/
var DiagComponentLogger$1 = function() {
	function DiagComponentLogger(props) {
		this._namespace = props.namespace || "DiagComponentLogger";
	}
	DiagComponentLogger.prototype.debug = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$1("debug", this._namespace, args);
	};
	DiagComponentLogger.prototype.error = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$1("error", this._namespace, args);
	};
	DiagComponentLogger.prototype.info = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$1("info", this._namespace, args);
	};
	DiagComponentLogger.prototype.warn = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$1("warn", this._namespace, args);
	};
	DiagComponentLogger.prototype.verbose = function() {
		var args = [];
		for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
		return logProxy$1("verbose", this._namespace, args);
	};
	return DiagComponentLogger;
}();
function logProxy$1(funcName, namespace, args) {
	var logger = getGlobal$1("diag");
	if (!logger) return;
	args.unshift(namespace);
	return logger[funcName].apply(logger, __spreadArray$3([], __read$3(args), false));
}
/**
* Defines the available internal logging levels for the diagnostic logger, the numeric values
* of the levels are defined to match the original values from the initial LogLevel to avoid
* compatibility/migration issues for any implementation that assume the numeric ordering.
*/
var DiagLogLevel$1;
(function(DiagLogLevel) {
	/** Diagnostic Logging level setting to disable all logging (except and forced logs) */
	DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
	/** Identifies an error scenario */
	DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
	/** Identifies a warning scenario */
	DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
	/** General informational log message */
	DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
	/** General debug log message */
	DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
	/**
	* Detailed trace level logging should only be used for development, should only be set
	* in a development environment.
	*/
	DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
	/** Used to set the logging level to include all logging */
	DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel$1 || (DiagLogLevel$1 = {}));
function createLogLevelDiagLogger$1(maxLevel, logger) {
	if (maxLevel < DiagLogLevel$1.NONE) maxLevel = DiagLogLevel$1.NONE;
	else if (maxLevel > DiagLogLevel$1.ALL) maxLevel = DiagLogLevel$1.ALL;
	logger = logger || {};
	function _filterFunc(funcName, theLevel) {
		var theFunc = logger[funcName];
		if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger);
		return function() {};
	}
	return {
		error: _filterFunc("error", DiagLogLevel$1.ERROR),
		warn: _filterFunc("warn", DiagLogLevel$1.WARN),
		info: _filterFunc("info", DiagLogLevel$1.INFO),
		debug: _filterFunc("debug", DiagLogLevel$1.DEBUG),
		verbose: _filterFunc("verbose", DiagLogLevel$1.VERBOSE)
	};
}
var __read$2 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$2 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$2$1 = "diag";
/**
* Singleton object which represents the entry point to the OpenTelemetry internal
* diagnostic API
*/
var DiagAPI$1 = function() {
	/**
	* Private internal constructor
	* @private
	*/
	function DiagAPI() {
		function _logProxy(funcName) {
			return function() {
				var args = [];
				for (var _i = 0; _i < arguments.length; _i++) args[_i] = arguments[_i];
				var logger = getGlobal$1("diag");
				if (!logger) return;
				return logger[funcName].apply(logger, __spreadArray$2([], __read$2(args), false));
			};
		}
		var self = this;
		var setLogger = function(logger, optionsOrLogLevel) {
			var _a, _b, _c;
			if (optionsOrLogLevel === void 0) optionsOrLogLevel = { logLevel: DiagLogLevel$1.INFO };
			if (logger === self) {
				var err = /* @__PURE__ */ new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
				self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
				return false;
			}
			if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = { logLevel: optionsOrLogLevel };
			var oldLogger = getGlobal$1("diag");
			var newLogger = createLogLevelDiagLogger$1((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : DiagLogLevel$1.INFO, logger);
			if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
				var stack = (_c = (/* @__PURE__ */ new Error()).stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
				oldLogger.warn("Current logger will be overwritten from " + stack);
				newLogger.warn("Current logger will overwrite one already registered from " + stack);
			}
			return registerGlobal$1("diag", newLogger, self, true);
		};
		self.setLogger = setLogger;
		self.disable = function() {
			unregisterGlobal$1(API_NAME$2$1, self);
		};
		self.createComponentLogger = function(options) {
			return new DiagComponentLogger$1(options);
		};
		self.verbose = _logProxy("verbose");
		self.debug = _logProxy("debug");
		self.info = _logProxy("info");
		self.warn = _logProxy("warn");
		self.error = _logProxy("error");
	}
	/** Get the singleton instance of the DiagAPI API */
	DiagAPI.instance = function() {
		if (!this._instance) this._instance = new DiagAPI();
		return this._instance;
	};
	return DiagAPI;
}();
/** Get a key to uniquely identify a context value */
function createContextKey$1(description) {
	return Symbol.for(description);
}
/** The root context is used as the default parent context when there is no active context */
var ROOT_CONTEXT$1 = new (function() {
	/**
	* Construct a new context which inherits values from an optional parent context.
	*
	* @param parentContext a context from which to inherit values
	*/
	function BaseContext(parentContext) {
		var self = this;
		self._currentContext = parentContext ? new Map(parentContext) : /* @__PURE__ */ new Map();
		self.getValue = function(key) {
			return self._currentContext.get(key);
		};
		self.setValue = function(key, value) {
			var context = new BaseContext(self._currentContext);
			context._currentContext.set(key, value);
			return context;
		};
		self.deleteValue = function(key) {
			var context = new BaseContext(self._currentContext);
			context._currentContext.delete(key);
			return context;
		};
	}
	return BaseContext;
}())();
var __read$1 = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray$1 = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var NoopContextManager$1 = function() {
	function NoopContextManager() {}
	NoopContextManager.prototype.active = function() {
		return ROOT_CONTEXT$1;
	};
	NoopContextManager.prototype.with = function(_context, fn, thisArg) {
		var args = [];
		for (var _i = 3; _i < arguments.length; _i++) args[_i - 3] = arguments[_i];
		return fn.call.apply(fn, __spreadArray$1([thisArg], __read$1(args), false));
	};
	NoopContextManager.prototype.bind = function(_context, target) {
		return target;
	};
	NoopContextManager.prototype.enable = function() {
		return this;
	};
	NoopContextManager.prototype.disable = function() {
		return this;
	};
	return NoopContextManager;
}();
var __read = function(o, n) {
	var m = typeof Symbol === "function" && o[Symbol.iterator];
	if (!m) return o;
	var i = m.call(o), r, ar = [], e;
	try {
		while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	} catch (error) {
		e = { error };
	} finally {
		try {
			if (r && !r.done && (m = i["return"])) m.call(i);
		} finally {
			if (e) throw e.error;
		}
	}
	return ar;
};
var __spreadArray = function(to, from, pack) {
	if (pack || arguments.length === 2) {
		for (var i = 0, l = from.length, ar; i < l; i++) if (ar || !(i in from)) {
			if (!ar) ar = Array.prototype.slice.call(from, 0, i);
			ar[i] = from[i];
		}
	}
	return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$1$1 = "context";
var NOOP_CONTEXT_MANAGER$1 = new NoopContextManager$1();
/**
* Singleton object which represents the entry point to the OpenTelemetry Context API
*/
var ContextAPI$1 = function() {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	function ContextAPI() {}
	/** Get the singleton instance of the Context API */
	ContextAPI.getInstance = function() {
		if (!this._instance) this._instance = new ContextAPI();
		return this._instance;
	};
	/**
	* Set the current context manager.
	*
	* @returns true if the context manager was successfully registered, else false
	*/
	ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
		return registerGlobal$1(API_NAME$1$1, contextManager, DiagAPI$1.instance());
	};
	/**
	* Get the currently active context
	*/
	ContextAPI.prototype.active = function() {
		return this._getContextManager().active();
	};
	/**
	* Execute a function with an active context
	*
	* @param context context to be active during function execution
	* @param fn function to execute in a context
	* @param thisArg optional receiver to be used for calling fn
	* @param args optional arguments forwarded to fn
	*/
	ContextAPI.prototype.with = function(context, fn, thisArg) {
		var _a;
		var args = [];
		for (var _i = 3; _i < arguments.length; _i++) args[_i - 3] = arguments[_i];
		return (_a = this._getContextManager()).with.apply(_a, __spreadArray([
			context,
			fn,
			thisArg
		], __read(args), false));
	};
	/**
	* Bind a context to a target function or event emitter
	*
	* @param context context to bind to the event emitter or function. Defaults to the currently active context
	* @param target function or event emitter to bind
	*/
	ContextAPI.prototype.bind = function(context, target) {
		return this._getContextManager().bind(context, target);
	};
	ContextAPI.prototype._getContextManager = function() {
		return getGlobal$1(API_NAME$1$1) || NOOP_CONTEXT_MANAGER$1;
	};
	/** Disable and remove the global context manager */
	ContextAPI.prototype.disable = function() {
		this._getContextManager().disable();
		unregisterGlobal$1(API_NAME$1$1, DiagAPI$1.instance());
	};
	return ContextAPI;
}();
var TraceFlags$1;
(function(TraceFlags) {
	/** Represents no flag set. */
	TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
	/** Bit to represent whether trace is sampled in trace flags. */
	TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags$1 || (TraceFlags$1 = {}));
var INVALID_SPAN_CONTEXT$1 = {
	traceId: "00000000000000000000000000000000",
	spanId: "0000000000000000",
	traceFlags: TraceFlags$1.NONE
};
/**
* The NonRecordingSpan is the default {@link Span} that is used when no Span
* implementation is available. All operations are no-op including context
* propagation.
*/
var NonRecordingSpan$1 = function() {
	function NonRecordingSpan(_spanContext) {
		if (_spanContext === void 0) _spanContext = INVALID_SPAN_CONTEXT$1;
		this._spanContext = _spanContext;
	}
	NonRecordingSpan.prototype.spanContext = function() {
		return this._spanContext;
	};
	NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
		return this;
	};
	NonRecordingSpan.prototype.setAttributes = function(_attributes) {
		return this;
	};
	NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
		return this;
	};
	NonRecordingSpan.prototype.addLink = function(_link) {
		return this;
	};
	NonRecordingSpan.prototype.addLinks = function(_links) {
		return this;
	};
	NonRecordingSpan.prototype.setStatus = function(_status) {
		return this;
	};
	NonRecordingSpan.prototype.updateName = function(_name) {
		return this;
	};
	NonRecordingSpan.prototype.end = function(_endTime) {};
	NonRecordingSpan.prototype.isRecording = function() {
		return false;
	};
	NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
	return NonRecordingSpan;
}();
/**
* span key
*/
var SPAN_KEY$1 = createContextKey$1("OpenTelemetry Context Key SPAN");
/**
* Return the span if one exists
*
* @param context context to get span from
*/
function getSpan$1(context) {
	return context.getValue(SPAN_KEY$1) || void 0;
}
/**
* Gets the span from the current context, if one exists.
*/
function getActiveSpan$1() {
	return getSpan$1(ContextAPI$1.getInstance().active());
}
/**
* Set the span on a context
*
* @param context context to use as parent
* @param span span to set active
*/
function setSpan$1(context, span) {
	return context.setValue(SPAN_KEY$1, span);
}
/**
* Remove current span stored in the context
*
* @param context context to delete span from
*/
function deleteSpan$1(context) {
	return context.deleteValue(SPAN_KEY$1);
}
/**
* Wrap span context in a NoopSpan and set as span in a new
* context
*
* @param context context to set active span on
* @param spanContext span context to be wrapped
*/
function setSpanContext$1(context, spanContext) {
	return setSpan$1(context, new NonRecordingSpan$1(spanContext));
}
/**
* Get the span context of the span if it exists.
*
* @param context context to get values from
*/
function getSpanContext$1(context) {
	var _a;
	return (_a = getSpan$1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}
var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function isValidTraceId$1(traceId) {
	return VALID_TRACEID_REGEX.test(traceId) && traceId !== "00000000000000000000000000000000";
}
function isValidSpanId$1(spanId) {
	return VALID_SPANID_REGEX.test(spanId) && spanId !== "0000000000000000";
}
/**
* Returns true if this {@link SpanContext} is valid.
* @return true if this {@link SpanContext} is valid.
*/
function isSpanContextValid$1(spanContext) {
	return isValidTraceId$1(spanContext.traceId) && isValidSpanId$1(spanContext.spanId);
}
/**
* Wrap the given {@link SpanContext} in a new non-recording {@link Span}
*
* @param spanContext span context to be wrapped
* @returns a new non-recording {@link Span} with the provided context
*/
function wrapSpanContext$1(spanContext) {
	return new NonRecordingSpan$1(spanContext);
}
var contextApi$1 = ContextAPI$1.getInstance();
/**
* No-op implementations of {@link Tracer}.
*/
var NoopTracer$1 = function() {
	function NoopTracer() {}
	NoopTracer.prototype.startSpan = function(name, options, context) {
		if (context === void 0) context = contextApi$1.active();
		if (Boolean(options === null || options === void 0 ? void 0 : options.root)) return new NonRecordingSpan$1();
		var parentFromContext = context && getSpanContext$1(context);
		if (isSpanContext$1(parentFromContext) && isSpanContextValid$1(parentFromContext)) return new NonRecordingSpan$1(parentFromContext);
		else return new NonRecordingSpan$1();
	};
	NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
		var opts;
		var ctx;
		var fn;
		if (arguments.length < 2) return;
		else if (arguments.length === 2) fn = arg2;
		else if (arguments.length === 3) {
			opts = arg2;
			fn = arg3;
		} else {
			opts = arg2;
			ctx = arg3;
			fn = arg4;
		}
		var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi$1.active();
		var span = this.startSpan(name, opts, parentContext);
		var contextWithSpanSet = setSpan$1(parentContext, span);
		return contextApi$1.with(contextWithSpanSet, fn, void 0, span);
	};
	return NoopTracer;
}();
function isSpanContext$1(spanContext) {
	return typeof spanContext === "object" && typeof spanContext["spanId"] === "string" && typeof spanContext["traceId"] === "string" && typeof spanContext["traceFlags"] === "number";
}
var NOOP_TRACER$1 = new NoopTracer$1();
/**
* Proxy tracer provided by the proxy tracer provider
*/
var ProxyTracer$1 = function() {
	function ProxyTracer(_provider, name, version, options) {
		this._provider = _provider;
		this.name = name;
		this.version = version;
		this.options = options;
	}
	ProxyTracer.prototype.startSpan = function(name, options, context) {
		return this._getTracer().startSpan(name, options, context);
	};
	ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
		var tracer = this._getTracer();
		return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
	};
	/**
	* Try to get a tracer from the proxy tracer provider.
	* If the proxy tracer provider has no delegate, return a noop tracer.
	*/
	ProxyTracer.prototype._getTracer = function() {
		if (this._delegate) return this._delegate;
		var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
		if (!tracer) return NOOP_TRACER$1;
		this._delegate = tracer;
		return this._delegate;
	};
	return ProxyTracer;
}();
var NOOP_TRACER_PROVIDER$1 = new (function() {
	function NoopTracerProvider() {}
	NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
		return new NoopTracer$1();
	};
	return NoopTracerProvider;
}())();
/**
* Tracer provider which provides {@link ProxyTracer}s.
*
* Before a delegate is set, tracers provided are NoOp.
*   When a delegate is set, traces are provided from the delegate.
*   When a delegate is set after tracers have already been provided,
*   all tracers already provided will use the provided delegate implementation.
*/
var ProxyTracerProvider$1 = function() {
	function ProxyTracerProvider() {}
	/**
	* Get a {@link ProxyTracer}
	*/
	ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
		var _a;
		return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new ProxyTracer$1(this, name, version, options);
	};
	ProxyTracerProvider.prototype.getDelegate = function() {
		var _a;
		return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER$1;
	};
	/**
	* Set the delegate tracer provider
	*/
	ProxyTracerProvider.prototype.setDelegate = function(delegate) {
		this._delegate = delegate;
	};
	ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
		var _a;
		return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
	};
	return ProxyTracerProvider;
}();
/**
* An enumeration of status codes.
*/
var SpanStatusCode$1;
(function(SpanStatusCode) {
	/**
	* The default status.
	*/
	SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
	/**
	* The operation has been validated by an Application developer or
	* Operator to have completed successfully.
	*/
	SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
	/**
	* The operation contains an error.
	*/
	SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})(SpanStatusCode$1 || (SpanStatusCode$1 = {}));
var API_NAME$3 = "trace";
/** Entrypoint for trace API */
var trace$1 = function() {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	function TraceAPI() {
		this._proxyTracerProvider = new ProxyTracerProvider$1();
		this.wrapSpanContext = wrapSpanContext$1;
		this.isSpanContextValid = isSpanContextValid$1;
		this.deleteSpan = deleteSpan$1;
		this.getSpan = getSpan$1;
		this.getActiveSpan = getActiveSpan$1;
		this.getSpanContext = getSpanContext$1;
		this.setSpan = setSpan$1;
		this.setSpanContext = setSpanContext$1;
	}
	/** Get the singleton instance of the Trace API */
	TraceAPI.getInstance = function() {
		if (!this._instance) this._instance = new TraceAPI();
		return this._instance;
	};
	/**
	* Set the current global tracer.
	*
	* @returns true if the tracer provider was successfully registered, else false
	*/
	TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
		var success = registerGlobal$1(API_NAME$3, this._proxyTracerProvider, DiagAPI$1.instance());
		if (success) this._proxyTracerProvider.setDelegate(provider);
		return success;
	};
	/**
	* Returns the global tracer provider.
	*/
	TraceAPI.prototype.getTracerProvider = function() {
		return getGlobal$1(API_NAME$3) || this._proxyTracerProvider;
	};
	/**
	* Returns a tracer from the global tracer provider.
	*/
	TraceAPI.prototype.getTracer = function(name, version) {
		return this.getTracerProvider().getTracer(name, version);
	};
	/** Remove the global tracer provider */
	TraceAPI.prototype.disable = function() {
		unregisterGlobal$1(API_NAME$3, DiagAPI$1.instance());
		this._proxyTracerProvider = new ProxyTracerProvider$1();
	};
	return TraceAPI;
}().getInstance();
var __defProp$1 = Object.defineProperty;
var __export$1 = (target, all) => {
	for (var name16 in all) __defProp$1(target, name16, {
		get: all[name16],
		enumerable: true
	});
};
var name2$3 = "AI_InvalidArgumentError";
var marker2$3 = `vercel.ai.error.${name2$3}`;
var symbol2$3 = Symbol.for(marker2$3);
var _a2$3;
var InvalidArgumentError$2 = class extends AISDKError$1 {
	constructor({ parameter, value, message }) {
		super({
			name: name2$3,
			message: `Invalid argument for parameter ${parameter}: ${message}`
		});
		this[_a2$3] = true;
		this.parameter = parameter;
		this.value = value;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker2$3);
	}
};
_a2$3 = symbol2$3;
var name6$3 = "AI_NoObjectGeneratedError";
var marker6$3 = `vercel.ai.error.${name6$3}`;
var symbol6$3 = Symbol.for(marker6$3);
var _a6$3;
var NoObjectGeneratedError$1 = class extends AISDKError$1 {
	constructor({ message = "No object generated.", cause, text: text2, response, usage, finishReason }) {
		super({
			name: name6$3,
			message,
			cause
		});
		this[_a6$3] = true;
		this.text = text2;
		this.response = response;
		this.usage = usage;
		this.finishReason = finishReason;
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker6$3);
	}
};
_a6$3 = symbol6$3;
var UnsupportedModelVersionError$1 = class extends AISDKError$1 {
	constructor(options) {
		super({
			name: "AI_UnsupportedModelVersionError",
			message: `Unsupported model version ${options.version} for provider "${options.provider}" and model "${options.modelId}". AI SDK 5 only supports models that implement specification version "v2".`
		});
		this.version = options.version;
		this.provider = options.provider;
		this.modelId = options.modelId;
	}
};
var name14$1 = "AI_RetryError";
var marker14$2 = `vercel.ai.error.${name14$1}`;
var symbol14$2 = Symbol.for(marker14$2);
var _a14$2;
var RetryError$1 = class extends AISDKError$1 {
	constructor({ message, reason, errors }) {
		super({
			name: name14$1,
			message
		});
		this[_a14$2] = true;
		this.reason = reason;
		this.errors = errors;
		this.lastError = errors[errors.length - 1];
	}
	static isInstance(error) {
		return AISDKError$1.hasMarker(error, marker14$2);
	}
};
_a14$2 = symbol14$2;
function resolveEmbeddingModel$1(model) {
	if (typeof model !== "string") {
		if (model.specificationVersion !== "v2") throw new UnsupportedModelVersionError$1({
			version: model.specificationVersion,
			provider: model.provider,
			modelId: model.modelId
		});
		return model;
	}
	return getGlobalProvider$1().textEmbeddingModel(model);
}
function getGlobalProvider$1() {
	var _a16;
	return (_a16 = globalThis.AI_SDK_DEFAULT_PROVIDER) != null ? _a16 : gateway$1;
}
var VERSION$5 = "5.0.216";
var dataContentSchema$1 = z$1.union([
	z$1.string(),
	z$1.instanceof(Uint8Array),
	z$1.instanceof(ArrayBuffer),
	z$1.custom((value) => {
		var _a16, _b;
		return (_b = (_a16 = globalThis.Buffer) == null ? void 0 : _a16.isBuffer(value)) != null ? _b : false;
	}, { message: "Must be a Buffer" })
]);
var jsonValueSchema$1 = z$1.lazy(() => z$1.union([
	z$1.null(),
	z$1.string(),
	z$1.number(),
	z$1.boolean(),
	z$1.record(z$1.string(), jsonValueSchema$1),
	z$1.array(jsonValueSchema$1)
]));
var providerMetadataSchema$1 = z$1.record(z$1.string(), z$1.record(z$1.string(), jsonValueSchema$1));
var textPartSchema$1 = z$1.object({
	type: z$1.literal("text"),
	text: z$1.string(),
	providerOptions: providerMetadataSchema$1.optional()
});
var imagePartSchema$1 = z$1.object({
	type: z$1.literal("image"),
	image: z$1.union([dataContentSchema$1, z$1.instanceof(URL)]),
	mediaType: z$1.string().optional(),
	providerOptions: providerMetadataSchema$1.optional()
});
var filePartSchema$1 = z$1.object({
	type: z$1.literal("file"),
	data: z$1.union([dataContentSchema$1, z$1.instanceof(URL)]),
	filename: z$1.string().optional(),
	mediaType: z$1.string(),
	providerOptions: providerMetadataSchema$1.optional()
});
var reasoningPartSchema$1 = z$1.object({
	type: z$1.literal("reasoning"),
	text: z$1.string(),
	providerOptions: providerMetadataSchema$1.optional()
});
var toolCallPartSchema$1 = z$1.object({
	type: z$1.literal("tool-call"),
	toolCallId: z$1.string(),
	toolName: z$1.string(),
	input: z$1.unknown(),
	providerOptions: providerMetadataSchema$1.optional(),
	providerExecuted: z$1.boolean().optional()
});
var outputSchema$1 = z$1.discriminatedUnion("type", [
	z$1.object({
		type: z$1.literal("text"),
		value: z$1.string()
	}),
	z$1.object({
		type: z$1.literal("json"),
		value: jsonValueSchema$1
	}),
	z$1.object({
		type: z$1.literal("error-text"),
		value: z$1.string()
	}),
	z$1.object({
		type: z$1.literal("error-json"),
		value: jsonValueSchema$1
	}),
	z$1.object({
		type: z$1.literal("content"),
		value: z$1.array(z$1.union([z$1.object({
			type: z$1.literal("text"),
			text: z$1.string()
		}), z$1.object({
			type: z$1.literal("media"),
			data: z$1.string(),
			mediaType: z$1.string()
		})]))
	})
]);
var toolResultPartSchema$1 = z$1.object({
	type: z$1.literal("tool-result"),
	toolCallId: z$1.string(),
	toolName: z$1.string(),
	output: outputSchema$1,
	providerOptions: providerMetadataSchema$1.optional()
});
var systemModelMessageSchema$1 = z$1.object({
	role: z$1.literal("system"),
	content: z$1.string(),
	providerOptions: providerMetadataSchema$1.optional()
});
var userModelMessageSchema$1 = z$1.object({
	role: z$1.literal("user"),
	content: z$1.union([z$1.string(), z$1.array(z$1.union([
		textPartSchema$1,
		imagePartSchema$1,
		filePartSchema$1
	]))]),
	providerOptions: providerMetadataSchema$1.optional()
});
var assistantModelMessageSchema$1 = z$1.object({
	role: z$1.literal("assistant"),
	content: z$1.union([z$1.string(), z$1.array(z$1.union([
		textPartSchema$1,
		filePartSchema$1,
		reasoningPartSchema$1,
		toolCallPartSchema$1,
		toolResultPartSchema$1
	]))]),
	providerOptions: providerMetadataSchema$1.optional()
});
var toolModelMessageSchema$1 = z$1.object({
	role: z$1.literal("tool"),
	content: z$1.array(toolResultPartSchema$1),
	providerOptions: providerMetadataSchema$1.optional()
});
z$1.union([
	systemModelMessageSchema$1,
	userModelMessageSchema$1,
	assistantModelMessageSchema$1,
	toolModelMessageSchema$1
]);
function assembleOperationName$1({ operationId, telemetry }) {
	return {
		"operation.name": `${operationId}${(telemetry == null ? void 0 : telemetry.functionId) != null ? ` ${telemetry.functionId}` : ""}`,
		"resource.name": telemetry == null ? void 0 : telemetry.functionId,
		"ai.operationId": operationId,
		"ai.telemetry.functionId": telemetry == null ? void 0 : telemetry.functionId
	};
}
function getBaseTelemetryAttributes$1({ model, settings, telemetry, headers }) {
	var _a16;
	return {
		"ai.model.provider": model.provider,
		"ai.model.id": model.modelId,
		...Object.entries(settings).reduce((attributes, [key, value]) => {
			attributes[`ai.settings.${key}`] = value;
			return attributes;
		}, {}),
		...Object.entries((_a16 = telemetry == null ? void 0 : telemetry.metadata) != null ? _a16 : {}).reduce((attributes, [key, value]) => {
			attributes[`ai.telemetry.metadata.${key}`] = value;
			return attributes;
		}, {}),
		...Object.entries(headers != null ? headers : {}).reduce((attributes, [key, value]) => {
			if (value !== void 0) attributes[`ai.request.headers.${key}`] = value;
			return attributes;
		}, {})
	};
}
var noopTracer$1 = {
	startSpan() {
		return noopSpan$1;
	},
	startActiveSpan(name16, arg1, arg2, arg3) {
		if (typeof arg1 === "function") return arg1(noopSpan$1);
		if (typeof arg2 === "function") return arg2(noopSpan$1);
		if (typeof arg3 === "function") return arg3(noopSpan$1);
	}
};
var noopSpan$1 = {
	spanContext() {
		return noopSpanContext$1;
	},
	setAttribute() {
		return this;
	},
	setAttributes() {
		return this;
	},
	addEvent() {
		return this;
	},
	addLink() {
		return this;
	},
	addLinks() {
		return this;
	},
	setStatus() {
		return this;
	},
	updateName() {
		return this;
	},
	end() {
		return this;
	},
	isRecording() {
		return false;
	},
	recordException() {
		return this;
	}
};
var noopSpanContext$1 = {
	traceId: "",
	spanId: "",
	traceFlags: 0
};
function getTracer$1({ isEnabled = false, tracer } = {}) {
	if (!isEnabled) return noopTracer$1;
	if (tracer) return tracer;
	return trace$1.getTracer("ai");
}
function recordSpan$1({ name: name16, tracer, attributes, fn, endWhenDone = true }) {
	return tracer.startActiveSpan(name16, { attributes }, async (span) => {
		try {
			const result = await fn(span);
			if (endWhenDone) span.end();
			return result;
		} catch (error) {
			try {
				recordErrorOnSpan$1(span, error);
			} finally {
				span.end();
			}
			throw error;
		}
	});
}
function recordErrorOnSpan$1(span, error) {
	if (error instanceof Error) {
		span.recordException({
			name: error.name,
			message: error.message,
			stack: error.stack
		});
		span.setStatus({
			code: SpanStatusCode$1.ERROR,
			message: error.message
		});
	} else span.setStatus({ code: SpanStatusCode$1.ERROR });
}
function selectTelemetryAttributes$1({ telemetry, attributes }) {
	if ((telemetry == null ? void 0 : telemetry.isEnabled) !== true) return {};
	return Object.entries(attributes).reduce((attributes2, [key, value]) => {
		if (value == null) return attributes2;
		if (typeof value === "object" && "input" in value && typeof value.input === "function") {
			if ((telemetry == null ? void 0 : telemetry.recordInputs) === false) return attributes2;
			const result = value.input();
			return result == null ? attributes2 : {
				...attributes2,
				[key]: result
			};
		}
		if (typeof value === "object" && "output" in value && typeof value.output === "function") {
			if ((telemetry == null ? void 0 : telemetry.recordOutputs) === false) return attributes2;
			const result = value.output();
			return result == null ? attributes2 : {
				...attributes2,
				[key]: result
			};
		}
		return {
			...attributes2,
			[key]: value
		};
	}, {});
}
function getRetryDelayInMs$1({ error, exponentialBackoffDelay }) {
	const headers = error.responseHeaders;
	if (!headers) return exponentialBackoffDelay;
	let ms;
	const retryAfterMs = headers["retry-after-ms"];
	if (retryAfterMs) {
		const timeoutMs = parseFloat(retryAfterMs);
		if (!Number.isNaN(timeoutMs)) ms = timeoutMs;
	}
	const retryAfter = headers["retry-after"];
	if (retryAfter && ms === void 0) {
		const timeoutSeconds = parseFloat(retryAfter);
		if (!Number.isNaN(timeoutSeconds)) ms = timeoutSeconds * 1e3;
		else ms = Date.parse(retryAfter) - Date.now();
	}
	if (ms != null && !Number.isNaN(ms) && 0 <= ms && (ms < 60 * 1e3 || ms < exponentialBackoffDelay)) return ms;
	return exponentialBackoffDelay;
}
var retryWithExponentialBackoffRespectingRetryHeaders$1 = ({ maxRetries = 2, initialDelayInMs = 2e3, backoffFactor = 2, abortSignal } = {}) => async (f) => _retryWithExponentialBackoff(f, {
	maxRetries,
	delayInMs: initialDelayInMs,
	backoffFactor,
	abortSignal
});
async function _retryWithExponentialBackoff(f, { maxRetries, delayInMs, backoffFactor, abortSignal }, errors = []) {
	try {
		return await f();
	} catch (error) {
		if (isAbortError$3(error)) throw error;
		if (maxRetries === 0) throw error;
		const errorMessage = getErrorMessage$2(error);
		const newErrors = [...errors, error];
		const tryNumber = newErrors.length;
		if (tryNumber > maxRetries) throw new RetryError$1({
			message: `Failed after ${tryNumber} attempts. Last error: ${errorMessage}`,
			reason: "maxRetriesExceeded",
			errors: newErrors
		});
		if (error instanceof Error && APICallError$1.isInstance(error) && error.isRetryable === true && tryNumber <= maxRetries) {
			await delay$1(getRetryDelayInMs$1({
				error,
				exponentialBackoffDelay: delayInMs
			}), { abortSignal });
			return _retryWithExponentialBackoff(f, {
				maxRetries,
				delayInMs: backoffFactor * delayInMs,
				backoffFactor,
				abortSignal
			}, newErrors);
		}
		if (tryNumber === 1) throw error;
		throw new RetryError$1({
			message: `Failed after ${tryNumber} attempts with non-retryable error: '${errorMessage}'`,
			reason: "errorNotRetryable",
			errors: newErrors
		});
	}
}
function prepareRetries$1({ maxRetries, abortSignal }) {
	if (maxRetries != null) {
		if (!Number.isInteger(maxRetries)) throw new InvalidArgumentError$2({
			parameter: "maxRetries",
			value: maxRetries,
			message: "maxRetries must be an integer"
		});
		if (maxRetries < 0) throw new InvalidArgumentError$2({
			parameter: "maxRetries",
			value: maxRetries,
			message: "maxRetries must be >= 0"
		});
	}
	const maxRetriesResult = maxRetries != null ? maxRetries : 2;
	return {
		maxRetries: maxRetriesResult,
		retry: retryWithExponentialBackoffRespectingRetryHeaders$1({
			maxRetries: maxRetriesResult,
			abortSignal
		})
	};
}
createIdGenerator$1({
	prefix: "aitxt",
	size: 24
});
TransformStream;
function fixJson$1(input) {
	const stack = ["ROOT"];
	let lastValidIndex = -1;
	let literalStart = null;
	function processValueStart(char, i, swapState) {
		switch (char) {
			case "\"":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_STRING");
				break;
			case "f":
			case "t":
			case "n":
				lastValidIndex = i;
				literalStart = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_LITERAL");
				break;
			case "-":
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "0":
			case "1":
			case "2":
			case "3":
			case "4":
			case "5":
			case "6":
			case "7":
			case "8":
			case "9":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "{":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_OBJECT_START");
				break;
			case "[":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_ARRAY_START");
				break;
		}
	}
	function processAfterObjectValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_OBJECT_AFTER_COMMA");
				break;
			case "}":
				lastValidIndex = i;
				stack.pop();
				break;
		}
	}
	function processAfterArrayValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_ARRAY_AFTER_COMMA");
				break;
			case "]":
				lastValidIndex = i;
				stack.pop();
				break;
		}
	}
	for (let i = 0; i < input.length; i++) {
		const char = input[i];
		switch (stack[stack.length - 1]) {
			case "ROOT":
				processValueStart(char, i, "FINISH");
				break;
			case "INSIDE_OBJECT_START":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
						break;
					case "}":
						lastValidIndex = i;
						stack.pop();
						break;
				}
				break;
			case "INSIDE_OBJECT_AFTER_COMMA":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
						break;
				}
				break;
			case "INSIDE_OBJECT_KEY":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_AFTER_KEY");
						break;
				}
				break;
			case "INSIDE_OBJECT_AFTER_KEY":
				switch (char) {
					case ":":
						stack.pop();
						stack.push("INSIDE_OBJECT_BEFORE_VALUE");
						break;
				}
				break;
			case "INSIDE_OBJECT_BEFORE_VALUE":
				processValueStart(char, i, "INSIDE_OBJECT_AFTER_VALUE");
				break;
			case "INSIDE_OBJECT_AFTER_VALUE":
				processAfterObjectValue(char, i);
				break;
			case "INSIDE_STRING":
				switch (char) {
					case "\"":
						stack.pop();
						lastValidIndex = i;
						break;
					case "\\":
						stack.push("INSIDE_STRING_ESCAPE");
						break;
					default: lastValidIndex = i;
				}
				break;
			case "INSIDE_ARRAY_START":
				switch (char) {
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default:
						lastValidIndex = i;
						processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
						break;
				}
				break;
			case "INSIDE_ARRAY_AFTER_VALUE":
				switch (char) {
					case ",":
						stack.pop();
						stack.push("INSIDE_ARRAY_AFTER_COMMA");
						break;
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default:
						lastValidIndex = i;
						break;
				}
				break;
			case "INSIDE_ARRAY_AFTER_COMMA":
				processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
				break;
			case "INSIDE_STRING_ESCAPE":
				stack.pop();
				lastValidIndex = i;
				break;
			case "INSIDE_NUMBER":
				switch (char) {
					case "0":
					case "1":
					case "2":
					case "3":
					case "4":
					case "5":
					case "6":
					case "7":
					case "8":
					case "9":
						lastValidIndex = i;
						break;
					case "e":
					case "E":
					case "-":
					case ".": break;
					case ",":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "}":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "]":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						break;
					default:
						stack.pop();
						break;
				}
				break;
			case "INSIDE_LITERAL": {
				const partialLiteral = input.substring(literalStart, i + 1);
				if (!"false".startsWith(partialLiteral) && !"true".startsWith(partialLiteral) && !"null".startsWith(partialLiteral)) {
					stack.pop();
					if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
					else if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
				} else lastValidIndex = i;
				break;
			}
		}
	}
	let result = input.slice(0, lastValidIndex + 1);
	for (let i = stack.length - 1; i >= 0; i--) switch (stack[i]) {
		case "INSIDE_STRING":
			result += "\"";
			break;
		case "INSIDE_OBJECT_KEY":
		case "INSIDE_OBJECT_AFTER_KEY":
		case "INSIDE_OBJECT_AFTER_COMMA":
		case "INSIDE_OBJECT_START":
		case "INSIDE_OBJECT_BEFORE_VALUE":
		case "INSIDE_OBJECT_AFTER_VALUE":
			result += "}";
			break;
		case "INSIDE_ARRAY_START":
		case "INSIDE_ARRAY_AFTER_COMMA":
		case "INSIDE_ARRAY_AFTER_VALUE":
			result += "]";
			break;
		case "INSIDE_LITERAL": {
			const partialLiteral = input.substring(literalStart, input.length);
			if ("true".startsWith(partialLiteral)) result += "true".slice(partialLiteral.length);
			else if ("false".startsWith(partialLiteral)) result += "false".slice(partialLiteral.length);
			else if ("null".startsWith(partialLiteral)) result += "null".slice(partialLiteral.length);
		}
	}
	return result;
}
async function parsePartialJson$1(jsonText) {
	if (jsonText === void 0) return {
		value: void 0,
		state: "undefined-input"
	};
	let result = await safeParseJSON$1({ text: jsonText });
	if (result.success) return {
		value: result.value,
		state: "successful-parse"
	};
	result = await safeParseJSON$1({ text: fixJson$1(jsonText) });
	if (result.success) return {
		value: result.value,
		state: "repaired-parse"
	};
	return {
		value: void 0,
		state: "failed-parse"
	};
}
createIdGenerator$1({
	prefix: "aitxt",
	size: 24
});
function splitArray$1(array, chunkSize) {
	if (chunkSize <= 0) throw new Error("chunkSize must be greater than 0");
	const result = [];
	for (let i = 0; i < array.length; i += chunkSize) result.push(array.slice(i, i + chunkSize));
	return result;
}
async function embedMany$1({ model: modelArg, values, maxParallelCalls = Infinity, maxRetries: maxRetriesArg, abortSignal, headers, providerOptions, experimental_telemetry: telemetry }) {
	const model = resolveEmbeddingModel$1(modelArg);
	const { maxRetries, retry } = prepareRetries$1({
		maxRetries: maxRetriesArg,
		abortSignal
	});
	const headersWithUserAgent = withUserAgentSuffix$1(headers != null ? headers : {}, `ai/${VERSION$5}`);
	const baseTelemetryAttributes = getBaseTelemetryAttributes$1({
		model,
		telemetry,
		headers: headersWithUserAgent,
		settings: { maxRetries }
	});
	const tracer = getTracer$1(telemetry);
	return recordSpan$1({
		name: "ai.embedMany",
		attributes: selectTelemetryAttributes$1({
			telemetry,
			attributes: {
				...assembleOperationName$1({
					operationId: "ai.embedMany",
					telemetry
				}),
				...baseTelemetryAttributes,
				"ai.values": { input: () => values.map((value) => JSON.stringify(value)) }
			}
		}),
		tracer,
		fn: async (span) => {
			var _a16;
			const [maxEmbeddingsPerCall, supportsParallelCalls] = await Promise.all([model.maxEmbeddingsPerCall, model.supportsParallelCalls]);
			if (maxEmbeddingsPerCall == null || maxEmbeddingsPerCall === Infinity) {
				const { embeddings: embeddings2, usage, response, providerMetadata: providerMetadata2 } = await retry(() => {
					return recordSpan$1({
						name: "ai.embedMany.doEmbed",
						attributes: selectTelemetryAttributes$1({
							telemetry,
							attributes: {
								...assembleOperationName$1({
									operationId: "ai.embedMany.doEmbed",
									telemetry
								}),
								...baseTelemetryAttributes,
								"ai.values": { input: () => values.map((value) => JSON.stringify(value)) }
							}
						}),
						tracer,
						fn: async (doEmbedSpan) => {
							var _a17;
							const modelResponse = await model.doEmbed({
								values,
								abortSignal,
								headers: headersWithUserAgent,
								providerOptions
							});
							const embeddings3 = modelResponse.embeddings;
							const usage2 = (_a17 = modelResponse.usage) != null ? _a17 : { tokens: NaN };
							doEmbedSpan.setAttributes(selectTelemetryAttributes$1({
								telemetry,
								attributes: {
									"ai.embeddings": { output: () => embeddings3.map((embedding) => JSON.stringify(embedding)) },
									"ai.usage.tokens": usage2.tokens
								}
							}));
							return {
								embeddings: embeddings3,
								usage: usage2,
								providerMetadata: modelResponse.providerMetadata,
								response: modelResponse.response
							};
						}
					});
				});
				span.setAttributes(selectTelemetryAttributes$1({
					telemetry,
					attributes: {
						"ai.embeddings": { output: () => embeddings2.map((embedding) => JSON.stringify(embedding)) },
						"ai.usage.tokens": usage.tokens
					}
				}));
				return new DefaultEmbedManyResult$1({
					values,
					embeddings: embeddings2,
					usage,
					providerMetadata: providerMetadata2,
					responses: [response]
				});
			}
			const valueChunks = splitArray$1(values, maxEmbeddingsPerCall);
			const embeddings = [];
			const responses = [];
			let tokens = 0;
			let providerMetadata;
			const parallelChunks = splitArray$1(valueChunks, supportsParallelCalls ? maxParallelCalls : 1);
			for (const parallelChunk of parallelChunks) {
				const results = await Promise.all(parallelChunk.map((chunk) => {
					return retry(() => {
						return recordSpan$1({
							name: "ai.embedMany.doEmbed",
							attributes: selectTelemetryAttributes$1({
								telemetry,
								attributes: {
									...assembleOperationName$1({
										operationId: "ai.embedMany.doEmbed",
										telemetry
									}),
									...baseTelemetryAttributes,
									"ai.values": { input: () => chunk.map((value) => JSON.stringify(value)) }
								}
							}),
							tracer,
							fn: async (doEmbedSpan) => {
								var _a17;
								const modelResponse = await model.doEmbed({
									values: chunk,
									abortSignal,
									headers: headersWithUserAgent,
									providerOptions
								});
								const embeddings2 = modelResponse.embeddings;
								const usage = (_a17 = modelResponse.usage) != null ? _a17 : { tokens: NaN };
								doEmbedSpan.setAttributes(selectTelemetryAttributes$1({
									telemetry,
									attributes: {
										"ai.embeddings": { output: () => embeddings2.map((embedding) => JSON.stringify(embedding)) },
										"ai.usage.tokens": usage.tokens
									}
								}));
								return {
									embeddings: embeddings2,
									usage,
									providerMetadata: modelResponse.providerMetadata,
									response: modelResponse.response
								};
							}
						});
					});
				}));
				for (const result of results) {
					embeddings.push(...result.embeddings);
					responses.push(result.response);
					tokens += result.usage.tokens;
					if (result.providerMetadata) if (!providerMetadata) providerMetadata = { ...result.providerMetadata };
					else for (const [providerName, metadata] of Object.entries(result.providerMetadata)) providerMetadata[providerName] = {
						...(_a16 = providerMetadata[providerName]) != null ? _a16 : {},
						...metadata
					};
				}
			}
			span.setAttributes(selectTelemetryAttributes$1({
				telemetry,
				attributes: {
					"ai.embeddings": { output: () => embeddings.map((embedding) => JSON.stringify(embedding)) },
					"ai.usage.tokens": tokens
				}
			}));
			return new DefaultEmbedManyResult$1({
				values,
				embeddings,
				usage: { tokens },
				providerMetadata,
				responses
			});
		}
	});
}
var DefaultEmbedManyResult$1 = class {
	constructor(options) {
		this.values = options.values;
		this.embeddings = options.embeddings;
		this.usage = options.usage;
		this.providerMetadata = options.providerMetadata;
		this.responses = options.responses;
	}
};
createIdGenerator$1({
	prefix: "aiobj",
	size: 24
});
createIdGenerator$1({
	prefix: "aiobj",
	size: 24
});
__export$1({}, {
	object: () => object$1,
	text: () => text$1
});
var text$1 = () => ({
	type: "text",
	responseFormat: { type: "text" },
	async parsePartial({ text: text2 }) {
		return { partial: text2 };
	},
	async parseOutput({ text: text2 }) {
		return text2;
	}
});
var object$1 = ({ schema: inputSchema }) => {
	const schema = asSchema$1(inputSchema);
	return {
		type: "object",
		responseFormat: {
			type: "json",
			schema: schema.jsonSchema
		},
		async parsePartial({ text: text2 }) {
			const result = await parsePartialJson$1(text2);
			switch (result.state) {
				case "failed-parse":
				case "undefined-input": return;
				case "repaired-parse":
				case "successful-parse": return { partial: result.value };
				default: {
					const _exhaustiveCheck = result.state;
					throw new Error(`Unsupported parse state: ${_exhaustiveCheck}`);
				}
			}
		},
		async parseOutput({ text: text2 }, context) {
			const parseResult = await safeParseJSON$1({ text: text2 });
			if (!parseResult.success) throw new NoObjectGeneratedError$1({
				message: "No object generated: could not parse the response.",
				cause: parseResult.error,
				text: text2,
				response: context.response,
				usage: context.usage,
				finishReason: context.finishReason
			});
			const validationResult = await safeValidateTypes$1({
				value: parseResult.value,
				schema
			});
			if (!validationResult.success) throw new NoObjectGeneratedError$1({
				message: "No object generated: response did not match schema.",
				cause: validationResult.error,
				text: text2,
				response: context.response,
				usage: context.usage,
				finishReason: context.finishReason
			});
			return validationResult.value;
		}
	};
};
//#endregion
//#region ../_vendored/ai_v6/dist/dist-BomuqvJJ.js
var marker$1 = "vercel.ai.error";
var symbol$1$1 = Symbol.for(marker$1);
var _a$1$1;
var _b$1;
var AISDKError = class _AISDKError extends (_b$1 = Error, _a$1$1 = symbol$1$1, _b$1) {
	/**
	* Creates an AI SDK Error.
	*
	* @param {Object} params - The parameters for creating the error.
	* @param {string} params.name - The name of the error.
	* @param {string} params.message - The error message.
	* @param {unknown} [params.cause] - The underlying cause of the error.
	*/
	constructor({ name: name14, message, cause }) {
		super(message);
		this[_a$1$1] = true;
		this.name = name14;
		this.cause = cause;
	}
	/**
	* Checks if the given error is an AI SDK Error.
	* @param {unknown} error - The error to check.
	* @returns {boolean} True if the error is an AI SDK Error, false otherwise.
	*/
	static isInstance(error) {
		return _AISDKError.hasMarker(error, marker$1);
	}
	static hasMarker(error, marker15) {
		const markerSymbol = Symbol.for(marker15);
		return error != null && typeof error === "object" && markerSymbol in error && typeof error[markerSymbol] === "boolean" && error[markerSymbol] === true;
	}
};
var name$1$1 = "AI_APICallError";
var marker2$2 = `vercel.ai.error.${name$1$1}`;
var symbol2$2 = Symbol.for(marker2$2);
var _a2$2;
var _b2$1;
var APICallError = class extends (_b2$1 = AISDKError, _a2$2 = symbol2$2, _b2$1) {
	constructor({ message, url, requestBodyValues, statusCode, responseHeaders, responseBody, cause, isRetryable = statusCode != null && (statusCode === 408 || statusCode === 409 || statusCode === 429 || statusCode >= 500), data }) {
		super({
			name: name$1$1,
			message,
			cause
		});
		this[_a2$2] = true;
		this.url = url;
		this.requestBodyValues = requestBodyValues;
		this.statusCode = statusCode;
		this.responseHeaders = responseHeaders;
		this.responseBody = responseBody;
		this.isRetryable = isRetryable;
		this.data = data;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker2$2);
	}
};
var name2$2 = "AI_EmptyResponseBodyError";
var marker3$2 = `vercel.ai.error.${name2$2}`;
var symbol3$2 = Symbol.for(marker3$2);
var _a3$2;
var _b3$1;
var EmptyResponseBodyError = class extends (_b3$1 = AISDKError, _a3$2 = symbol3$2, _b3$1) {
	constructor({ message = "Empty response body" } = {}) {
		super({
			name: name2$2,
			message
		});
		this[_a3$2] = true;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker3$2);
	}
};
function getErrorMessage$1(error) {
	if (error == null) return "unknown error";
	if (typeof error === "string") return error;
	if (error instanceof Error) return error.message;
	return JSON.stringify(error);
}
var name3$2 = "AI_InvalidArgumentError";
var marker4$2 = `vercel.ai.error.${name3$2}`;
var symbol4$2 = Symbol.for(marker4$2);
var _a4$2;
var _b4$1;
var InvalidArgumentError$1 = class extends (_b4$1 = AISDKError, _a4$2 = symbol4$2, _b4$1) {
	constructor({ message, cause, argument }) {
		super({
			name: name3$2,
			message,
			cause
		});
		this[_a4$2] = true;
		this.argument = argument;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker4$2);
	}
};
var name4$2 = "AI_InvalidPromptError";
var marker5$2 = `vercel.ai.error.${name4$2}`;
var symbol5$2 = Symbol.for(marker5$2);
var _a5$2;
var _b5$1;
(class extends (_b5$1 = AISDKError, _a5$2 = symbol5$2, _b5$1) {
	constructor({ prompt, message, cause }) {
		super({
			name: name4$2,
			message: `Invalid prompt: ${message}`,
			cause
		});
		this[_a5$2] = true;
		this.prompt = prompt;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker5$2);
	}
});
var name5$2 = "AI_InvalidResponseDataError";
var marker6$2 = `vercel.ai.error.${name5$2}`;
var symbol6$2 = Symbol.for(marker6$2);
var _a6$2;
var _b6$1;
(class extends (_b6$1 = AISDKError, _a6$2 = symbol6$2, _b6$1) {
	constructor({ data, message = `Invalid response data: ${JSON.stringify(data)}.` }) {
		super({
			name: name5$2,
			message
		});
		this[_a6$2] = true;
		this.data = data;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker6$2);
	}
});
var name6$2 = "AI_JSONParseError";
var marker7$2 = `vercel.ai.error.${name6$2}`;
var symbol7$2 = Symbol.for(marker7$2);
var _a7$2;
var _b7$1;
var JSONParseError = class extends (_b7$1 = AISDKError, _a7$2 = symbol7$2, _b7$1) {
	constructor({ text, cause }) {
		super({
			name: name6$2,
			message: `JSON parsing failed: Text: ${text}.
Error message: ${getErrorMessage$1(cause)}`,
			cause
		});
		this[_a7$2] = true;
		this.text = text;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker7$2);
	}
};
var name7$2 = "AI_LoadAPIKeyError";
var marker8$2 = `vercel.ai.error.${name7$2}`;
var symbol8$2 = Symbol.for(marker8$2);
var _a8$2;
var _b8$1;
(class extends (_b8$1 = AISDKError, _a8$2 = symbol8$2, _b8$1) {
	constructor({ message }) {
		super({
			name: name7$2,
			message
		});
		this[_a8$2] = true;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker8$2);
	}
});
var name8$2 = "AI_LoadSettingError";
var marker9$2 = `vercel.ai.error.${name8$2}`;
var symbol9$2 = Symbol.for(marker9$2);
var _a9$2;
var _b9$1;
(class extends (_b9$1 = AISDKError, _a9$2 = symbol9$2, _b9$1) {
	constructor({ message }) {
		super({
			name: name8$2,
			message
		});
		this[_a9$2] = true;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker9$2);
	}
});
var name9$2 = "AI_NoContentGeneratedError";
var marker10$2 = `vercel.ai.error.${name9$2}`;
var symbol10$2 = Symbol.for(marker10$2);
var _a10$2;
var _b10$1;
(class extends (_b10$1 = AISDKError, _a10$2 = symbol10$2, _b10$1) {
	constructor({ message = "No content generated." } = {}) {
		super({
			name: name9$2,
			message
		});
		this[_a10$2] = true;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker10$2);
	}
});
var name10$1 = "AI_NoSuchModelError";
var marker11$1 = `vercel.ai.error.${name10$1}`;
var symbol11$1 = Symbol.for(marker11$1);
var _a11$1;
var _b11;
(class extends (_b11 = AISDKError, _a11$1 = symbol11$1, _b11) {
	constructor({ errorName = name10$1, modelId, modelType, message = `No such ${modelType}: ${modelId}` }) {
		super({
			name: errorName,
			message
		});
		this[_a11$1] = true;
		this.modelId = modelId;
		this.modelType = modelType;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker11$1);
	}
});
var name11$1 = "AI_TooManyEmbeddingValuesForCallError";
var marker12$1 = `vercel.ai.error.${name11$1}`;
var symbol12$1 = Symbol.for(marker12$1);
var _a12$1;
var _b12;
(class extends (_b12 = AISDKError, _a12$1 = symbol12$1, _b12) {
	constructor(options) {
		super({
			name: name11$1,
			message: `Too many values for a single embedding call. The ${options.provider} model "${options.modelId}" can only embed up to ${options.maxEmbeddingsPerCall} values per call, but ${options.values.length} values were provided.`
		});
		this[_a12$1] = true;
		this.provider = options.provider;
		this.modelId = options.modelId;
		this.maxEmbeddingsPerCall = options.maxEmbeddingsPerCall;
		this.values = options.values;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker12$1);
	}
});
var name12$1 = "AI_TypeValidationError";
var marker13$1 = `vercel.ai.error.${name12$1}`;
var symbol13$1 = Symbol.for(marker13$1);
var _a13$1;
var _b13;
var TypeValidationError = class _TypeValidationError extends (_b13 = AISDKError, _a13$1 = symbol13$1, _b13) {
	constructor({ value, cause, context }) {
		let contextPrefix = "Type validation failed";
		if (context == null ? void 0 : context.field) contextPrefix += ` for ${context.field}`;
		if ((context == null ? void 0 : context.entityName) || (context == null ? void 0 : context.entityId)) {
			contextPrefix += " (";
			const parts = [];
			if (context.entityName) parts.push(context.entityName);
			if (context.entityId) parts.push(`id: "${context.entityId}"`);
			contextPrefix += parts.join(", ");
			contextPrefix += ")";
		}
		super({
			name: name12$1,
			message: `${contextPrefix}: Value: ${JSON.stringify(value)}.
Error message: ${getErrorMessage$1(cause)}`,
			cause
		});
		this[_a13$1] = true;
		this.value = value;
		this.context = context;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker13$1);
	}
	/**
	* Wraps an error into a TypeValidationError.
	* If the cause is already a TypeValidationError with the same value and context, it returns the cause.
	* Otherwise, it creates a new TypeValidationError.
	*
	* @param {Object} params - The parameters for wrapping the error.
	* @param {unknown} params.value - The value that failed validation.
	* @param {unknown} params.cause - The original error or cause of the validation failure.
	* @param {TypeValidationContext} params.context - Optional context about what is being validated.
	* @returns {TypeValidationError} A TypeValidationError instance.
	*/
	static wrap({ value, cause, context }) {
		var _a15, _b15, _c;
		if (_TypeValidationError.isInstance(cause) && cause.value === value && ((_a15 = cause.context) == null ? void 0 : _a15.field) === (context == null ? void 0 : context.field) && ((_b15 = cause.context) == null ? void 0 : _b15.entityName) === (context == null ? void 0 : context.entityName) && ((_c = cause.context) == null ? void 0 : _c.entityId) === (context == null ? void 0 : context.entityId)) return cause;
		return new _TypeValidationError({
			value,
			cause,
			context
		});
	}
};
var name13$1 = "AI_UnsupportedFunctionalityError";
var marker14$1 = `vercel.ai.error.${name13$1}`;
var symbol14$1 = Symbol.for(marker14$1);
var _a14$1;
var _b14;
(class extends (_b14 = AISDKError, _a14$1 = symbol14$1, _b14) {
	constructor({ functionality, message = `'${functionality}' functionality not supported.` }) {
		super({
			name: name13$1,
			message
		});
		this[_a14$1] = true;
		this.functionality = functionality;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker14$1);
	}
});
var ParseError = class extends Error {
	constructor(message, options) {
		super(message), this.name = "ParseError", this.type = options.type, this.field = options.field, this.value = options.value, this.line = options.line;
	}
};
const LF = 10;
const CR = 13;
const SPACE = 32;
function noop(_arg) {}
function createParser(callbacks) {
	if (typeof callbacks == "function") throw new TypeError("`callbacks` must be an object, got a function instead. Did you mean `{onEvent: fn}`?");
	const { onEvent = noop, onError = noop, onRetry = noop, onComment } = callbacks, pendingFragments = [];
	let isFirstChunk = !0, id, data = "", dataLines = 0, eventType;
	function feed(chunk) {
		if (isFirstChunk && (isFirstChunk = !1, chunk.charCodeAt(0) === 239 && chunk.charCodeAt(1) === 187 && chunk.charCodeAt(2) === 191 && (chunk = chunk.slice(3))), pendingFragments.length === 0) {
			const trailing2 = processLines(chunk);
			trailing2 !== "" && pendingFragments.push(trailing2);
			return;
		}
		if (chunk.indexOf(`
`) === -1 && chunk.indexOf("\r") === -1) {
			pendingFragments.push(chunk);
			return;
		}
		pendingFragments.push(chunk);
		const input = pendingFragments.join("");
		pendingFragments.length = 0;
		const trailing = processLines(input);
		trailing !== "" && pendingFragments.push(trailing);
	}
	function processLines(chunk) {
		let searchIndex = 0;
		if (chunk.indexOf("\r") === -1) {
			let lfIndex = chunk.indexOf(`
`, searchIndex);
			for (; lfIndex !== -1;) {
				if (searchIndex === lfIndex) {
					dataLines > 0 && onEvent({
						id,
						event: eventType,
						data
					}), id = void 0, data = "", dataLines = 0, eventType = void 0, searchIndex = lfIndex + 1, lfIndex = chunk.indexOf(`
`, searchIndex);
					continue;
				}
				const firstCharCode = chunk.charCodeAt(searchIndex);
				if (isDataPrefix(chunk, searchIndex, firstCharCode)) {
					const valueStart = chunk.charCodeAt(searchIndex + 5) === SPACE ? searchIndex + 6 : searchIndex + 5, value = chunk.slice(valueStart, lfIndex);
					if (dataLines === 0 && chunk.charCodeAt(lfIndex + 1) === LF) {
						onEvent({
							id,
							event: eventType,
							data: value
						}), id = void 0, data = "", eventType = void 0, searchIndex = lfIndex + 2, lfIndex = chunk.indexOf(`
`, searchIndex);
						continue;
					}
					data = dataLines === 0 ? value : `${data}
${value}`, dataLines++;
				} else isEventPrefix(chunk, searchIndex, firstCharCode) ? eventType = chunk.slice(chunk.charCodeAt(searchIndex + 6) === SPACE ? searchIndex + 7 : searchIndex + 6, lfIndex) || void 0 : parseLine(chunk, searchIndex, lfIndex);
				searchIndex = lfIndex + 1, lfIndex = chunk.indexOf(`
`, searchIndex);
			}
			return chunk.slice(searchIndex);
		}
		for (; searchIndex < chunk.length;) {
			const crIndex = chunk.indexOf("\r", searchIndex), lfIndex = chunk.indexOf(`
`, searchIndex);
			let lineEnd = -1;
			if (crIndex !== -1 && lfIndex !== -1 ? lineEnd = crIndex < lfIndex ? crIndex : lfIndex : crIndex !== -1 ? crIndex === chunk.length - 1 ? lineEnd = -1 : lineEnd = crIndex : lfIndex !== -1 && (lineEnd = lfIndex), lineEnd === -1) break;
			parseLine(chunk, searchIndex, lineEnd), searchIndex = lineEnd + 1, chunk.charCodeAt(searchIndex - 1) === CR && chunk.charCodeAt(searchIndex) === LF && searchIndex++;
		}
		return chunk.slice(searchIndex);
	}
	function parseLine(chunk, start, end) {
		if (start === end) {
			dispatchEvent();
			return;
		}
		const firstCharCode = chunk.charCodeAt(start);
		if (isDataPrefix(chunk, start, firstCharCode)) {
			const valueStart = chunk.charCodeAt(start + 5) === SPACE ? start + 6 : start + 5, value2 = chunk.slice(valueStart, end);
			data = dataLines === 0 ? value2 : `${data}
${value2}`, dataLines++;
			return;
		}
		if (isEventPrefix(chunk, start, firstCharCode)) {
			eventType = chunk.slice(chunk.charCodeAt(start + 6) === SPACE ? start + 7 : start + 6, end) || void 0;
			return;
		}
		if (firstCharCode === 105 && chunk.charCodeAt(start + 1) === 100 && chunk.charCodeAt(start + 2) === 58) {
			const value2 = chunk.slice(chunk.charCodeAt(start + 3) === SPACE ? start + 4 : start + 3, end);
			id = value2.includes("\0") ? void 0 : value2;
			return;
		}
		if (firstCharCode === 58) {
			if (onComment) {
				const line2 = chunk.slice(start, end);
				onComment(line2.slice(chunk.charCodeAt(start + 1) === SPACE ? 2 : 1));
			}
			return;
		}
		const line = chunk.slice(start, end), fieldSeparatorIndex = line.indexOf(":");
		if (fieldSeparatorIndex === -1) {
			processField(line, "", line);
			return;
		}
		const field = line.slice(0, fieldSeparatorIndex), offset = line.charCodeAt(fieldSeparatorIndex + 1) === SPACE ? 2 : 1;
		processField(field, line.slice(fieldSeparatorIndex + offset), line);
	}
	function processField(field, value, line) {
		switch (field) {
			case "event":
				eventType = value || void 0;
				break;
			case "data":
				data = dataLines === 0 ? value : `${data}
${value}`, dataLines++;
				break;
			case "id":
				id = value.includes("\0") ? void 0 : value;
				break;
			case "retry":
				/^\d+$/.test(value) ? onRetry(parseInt(value, 10)) : onError(new ParseError(`Invalid \`retry\` value: "${value}"`, {
					type: "invalid-retry",
					value,
					line
				}));
				break;
			default:
				onError(new ParseError(`Unknown field "${field.length > 20 ? `${field.slice(0, 20)}\u2026` : field}"`, {
					type: "unknown-field",
					field,
					value,
					line
				}));
				break;
		}
	}
	function dispatchEvent() {
		dataLines > 0 && onEvent({
			id,
			event: eventType,
			data
		}), id = void 0, data = "", dataLines = 0, eventType = void 0;
	}
	function reset(options = {}) {
		if (options.consume && pendingFragments.length > 0) {
			const incompleteLine = pendingFragments.join("");
			parseLine(incompleteLine, 0, incompleteLine.length);
		}
		isFirstChunk = !0, id = void 0, data = "", dataLines = 0, eventType = void 0, pendingFragments.length = 0;
	}
	return {
		feed,
		reset
	};
}
function isDataPrefix(chunk, i, firstCharCode) {
	return firstCharCode === 100 && chunk.charCodeAt(i + 1) === 97 && chunk.charCodeAt(i + 2) === 116 && chunk.charCodeAt(i + 3) === 97 && chunk.charCodeAt(i + 4) === 58;
}
function isEventPrefix(chunk, i, firstCharCode) {
	return firstCharCode === 101 && chunk.charCodeAt(i + 1) === 118 && chunk.charCodeAt(i + 2) === 101 && chunk.charCodeAt(i + 3) === 110 && chunk.charCodeAt(i + 4) === 116 && chunk.charCodeAt(i + 5) === 58;
}
var EventSourceParserStream = class extends TransformStream {
	constructor({ onError, onRetry, onComment } = {}) {
		let parser;
		super({
			start(controller) {
				parser = createParser({
					onEvent: (event) => {
						controller.enqueue(event);
					},
					onError(error) {
						onError === "terminate" ? controller.error(error) : typeof onError == "function" && onError(error);
					},
					onRetry,
					onComment
				});
			},
			transform(chunk) {
				parser.feed(chunk);
			}
		});
	}
};
function combineHeaders(...headers) {
	return headers.reduce((combinedHeaders, currentHeaders) => ({
		...combinedHeaders,
		...currentHeaders != null ? currentHeaders : {}
	}), {});
}
async function delay(delayInMs, options) {
	if (delayInMs == null) return Promise.resolve();
	const signal = options == null ? void 0 : options.abortSignal;
	return new Promise((resolve2, reject) => {
		if (signal == null ? void 0 : signal.aborted) {
			reject(createAbortError());
			return;
		}
		const timeoutId = setTimeout(() => {
			cleanup();
			resolve2();
		}, delayInMs);
		const cleanup = () => {
			clearTimeout(timeoutId);
			signal?.removeEventListener("abort", onAbort);
		};
		const onAbort = () => {
			cleanup();
			reject(createAbortError());
		};
		signal?.addEventListener("abort", onAbort);
	});
}
function createAbortError() {
	return new DOMException("Delay was aborted", "AbortError");
}
function extractResponseHeaders(response) {
	return Object.fromEntries([...response.headers]);
}
var { btoa, atob } = globalThis;
function convertUint8ArrayToBase64(array) {
	let latin1string = "";
	for (let i = 0; i < array.length; i++) latin1string += String.fromCodePoint(array[i]);
	return btoa(latin1string);
}
async function cancelResponseBody(response) {
	var _a2;
	try {
		await ((_a2 = response.body) == null ? void 0 : _a2.cancel());
	} catch (e) {}
}
var name$2 = "AI_DownloadError";
var marker$2 = `vercel.ai.error.${name$2}`;
var symbol$2 = Symbol.for(marker$2);
var _a$2;
var _b$2;
var DownloadError = class extends (_b$2 = AISDKError, _a$2 = symbol$2, _b$2) {
	constructor({ url, statusCode, statusText, cause, message = cause == null ? `Failed to download ${url}: ${statusCode} ${statusText}` : `Failed to download ${url}: ${cause}` }) {
		super({
			name: name$2,
			message,
			cause
		});
		this[_a$2] = true;
		this.url = url;
		this.statusCode = statusCode;
		this.statusText = statusText;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker$2);
	}
};
var DEFAULT_MAX_DOWNLOAD_SIZE = 2 * 1024 * 1024 * 1024;
async function readResponseWithSizeLimit({ response, url, maxBytes = DEFAULT_MAX_DOWNLOAD_SIZE }) {
	const contentLength = response.headers.get("content-length");
	if (contentLength != null) {
		const length = parseInt(contentLength, 10);
		if (!isNaN(length) && length > maxBytes) {
			await cancelResponseBody(response);
			throw new DownloadError({
				url,
				message: `Download of ${url} exceeded maximum size of ${maxBytes} bytes (Content-Length: ${length}).`
			});
		}
	}
	const body = response.body;
	if (body == null) return /* @__PURE__ */ new Uint8Array(0);
	const reader = body.getReader();
	const chunks = [];
	let totalBytes = 0;
	try {
		while (true) {
			const { done, value } = await reader.read();
			if (done) break;
			totalBytes += value.length;
			if (totalBytes > maxBytes) throw new DownloadError({
				url,
				message: `Download of ${url} exceeded maximum size of ${maxBytes} bytes.`
			});
			chunks.push(value);
		}
	} finally {
		try {
			await reader.cancel();
		} finally {
			reader.releaseLock();
		}
	}
	const result = new Uint8Array(totalBytes);
	let offset = 0;
	for (const chunk of chunks) {
		result.set(chunk, offset);
		offset += chunk.length;
	}
	return result;
}
var createIdGenerator = ({ prefix, size = 16, alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", separator = "-" } = {}) => {
	const generator = () => {
		const alphabetLength = alphabet.length;
		const chars = new Array(size);
		for (let i = 0; i < size; i++) chars[i] = alphabet[Math.random() * alphabetLength | 0];
		return chars.join("");
	};
	if (prefix == null) return generator;
	if (alphabet.includes(separator)) throw new InvalidArgumentError$1({
		argument: "separator",
		message: `The separator "${separator}" must not be part of the alphabet "${alphabet}".`
	});
	return () => `${prefix}${separator}${generator()}`;
};
createIdGenerator();
function getErrorMessage(error) {
	if (error == null) return "unknown error";
	if (typeof error === "string") return error;
	if (error instanceof Error) return error.message;
	return JSON.stringify(error);
}
function isAbortError$2(error) {
	return (error instanceof Error || error instanceof DOMException) && (error.name === "AbortError" || error.name === "ResponseAborted" || error.name === "TimeoutError");
}
var FETCH_FAILED_ERROR_MESSAGES = ["fetch failed", "failed to fetch"];
var BUN_ERROR_CODES = [
	"ConnectionRefused",
	"ConnectionClosed",
	"FailedToOpenSocket",
	"ECONNRESET",
	"ECONNREFUSED",
	"ETIMEDOUT",
	"EPIPE"
];
function isBunNetworkError(error) {
	if (!(error instanceof Error)) return false;
	const code = error.code;
	if (typeof code === "string" && BUN_ERROR_CODES.includes(code)) return true;
	return false;
}
function handleFetchError({ error, url, requestBodyValues }) {
	if (isAbortError$2(error)) return error;
	if (error instanceof TypeError && FETCH_FAILED_ERROR_MESSAGES.includes(error.message.toLowerCase())) {
		const cause = error.cause;
		if (cause != null) return new APICallError({
			message: `Cannot connect to API: ${cause.message}`,
			cause,
			url,
			requestBodyValues,
			isRetryable: true
		});
	}
	if (isBunNetworkError(error)) return new APICallError({
		message: `Cannot connect to API: ${error.message}`,
		cause: error,
		url,
		requestBodyValues,
		isRetryable: true
	});
	return error;
}
function getRuntimeEnvironmentUserAgent(globalThisAny = globalThis) {
	var _a2, _b2, _c;
	if (globalThisAny.window) return `runtime/browser`;
	if ((_a2 = globalThisAny.navigator) == null ? void 0 : _a2.userAgent) return `runtime/${globalThisAny.navigator.userAgent.toLowerCase()}`;
	if ((_c = (_b2 = globalThisAny.process) == null ? void 0 : _b2.versions) == null ? void 0 : _c.node) return `runtime/node.js/${globalThisAny.process.version.substring(0)}`;
	if (globalThisAny.EdgeRuntime) return `runtime/vercel-edge`;
	return "runtime/unknown";
}
function normalizeHeaders(headers) {
	if (headers == null) return {};
	const normalized = {};
	if (headers instanceof Headers) headers.forEach((value, key) => {
		normalized[key.toLowerCase()] = value;
	});
	else {
		if (!Array.isArray(headers)) headers = Object.entries(headers);
		for (const [key, value] of headers) if (value != null) normalized[key.toLowerCase()] = value;
	}
	return normalized;
}
function withUserAgentSuffix(headers, ...userAgentSuffixParts) {
	const normalizedHeaders = new Headers(normalizeHeaders(headers));
	const currentUserAgentHeader = normalizedHeaders.get("user-agent") || "";
	normalizedHeaders.set("user-agent", [currentUserAgentHeader, ...userAgentSuffixParts].filter(Boolean).join(" "));
	return Object.fromEntries(normalizedHeaders.entries());
}
var VERSION$3 = "4.0.40";
var getOriginalFetch = () => globalThis.fetch;
var getFromApi = async ({ url, headers = {}, successfulResponseHandler, failedResponseHandler, abortSignal, fetch: fetch2 = getOriginalFetch() }) => {
	try {
		const response = await fetch2(url, {
			method: "GET",
			headers: withUserAgentSuffix(headers, `ai-sdk/provider-utils/${VERSION$3}`, getRuntimeEnvironmentUserAgent()),
			signal: abortSignal
		});
		const responseHeaders = extractResponseHeaders(response);
		if (!response.ok) {
			let errorInformation;
			try {
				errorInformation = await failedResponseHandler({
					response,
					url,
					requestBodyValues: {}
				});
			} catch (error) {
				if (isAbortError$2(error) || APICallError.isInstance(error)) throw error;
				throw new APICallError({
					message: "Failed to process error response",
					cause: error,
					statusCode: response.status,
					url,
					responseHeaders,
					requestBodyValues: {}
				});
			}
			throw errorInformation.value;
		}
		try {
			return await successfulResponseHandler({
				response,
				url,
				requestBodyValues: {}
			});
		} catch (error) {
			if (error instanceof Error) {
				if (isAbortError$2(error) || APICallError.isInstance(error)) throw error;
			}
			throw new APICallError({
				message: "Failed to process successful response",
				cause: error,
				statusCode: response.status,
				url,
				responseHeaders,
				requestBodyValues: {}
			});
		}
	} catch (error) {
		throw handleFetchError({
			error,
			url,
			requestBodyValues: {}
		});
	}
};
function loadOptionalSetting({ settingValue, environmentVariableName }) {
	if (typeof settingValue === "string") return settingValue;
	if (settingValue != null || typeof process === "undefined") return;
	settingValue = process.env[environmentVariableName];
	if (settingValue == null || typeof settingValue !== "string") return;
	return settingValue;
}
var suspectProtoRx = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/;
var suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
function _parse(text) {
	const obj = JSON.parse(text);
	if (obj === null || typeof obj !== "object") return obj;
	if (suspectProtoRx.test(text) === false && suspectConstructorRx.test(text) === false) return obj;
	return filter(obj);
}
function filter(obj) {
	let next = [obj];
	while (next.length) {
		const nodes = next;
		next = [];
		for (const node of nodes) {
			if (Object.prototype.hasOwnProperty.call(node, "__proto__")) throw new SyntaxError("Object contains forbidden prototype property");
			if (Object.prototype.hasOwnProperty.call(node, "constructor") && node.constructor !== null && typeof node.constructor === "object" && Object.prototype.hasOwnProperty.call(node.constructor, "prototype")) throw new SyntaxError("Object contains forbidden prototype property");
			for (const key in node) {
				const value = node[key];
				if (value && typeof value === "object") next.push(value);
			}
		}
	}
	return obj;
}
function secureJsonParse(text) {
	const { stackTraceLimit } = Error;
	try {
		Error.stackTraceLimit = 0;
	} catch (e) {
		return _parse(text);
	}
	try {
		return _parse(text);
	} finally {
		Error.stackTraceLimit = stackTraceLimit;
	}
}
function addAdditionalPropertiesToJsonSchema(jsonSchema2) {
	if (jsonSchema2.type === "object" || Array.isArray(jsonSchema2.type) && jsonSchema2.type.includes("object")) {
		jsonSchema2.additionalProperties = false;
		const { properties } = jsonSchema2;
		if (properties != null) for (const key of Object.keys(properties)) properties[key] = visit(properties[key]);
	}
	if (jsonSchema2.items != null) jsonSchema2.items = Array.isArray(jsonSchema2.items) ? jsonSchema2.items.map(visit) : visit(jsonSchema2.items);
	if (jsonSchema2.anyOf != null) jsonSchema2.anyOf = jsonSchema2.anyOf.map(visit);
	if (jsonSchema2.allOf != null) jsonSchema2.allOf = jsonSchema2.allOf.map(visit);
	if (jsonSchema2.oneOf != null) jsonSchema2.oneOf = jsonSchema2.oneOf.map(visit);
	const { definitions } = jsonSchema2;
	if (definitions != null) for (const key of Object.keys(definitions)) definitions[key] = visit(definitions[key]);
	return jsonSchema2;
}
function visit(def) {
	if (typeof def === "boolean") return def;
	return addAdditionalPropertiesToJsonSchema(def);
}
var ignoreOverride = /* @__PURE__ */ Symbol("Let zodToJsonSchema decide on which parser to use");
var defaultOptions = {
	name: void 0,
	$refStrategy: "root",
	basePath: ["#"],
	effectStrategy: "input",
	pipeStrategy: "all",
	dateStrategy: "format:date-time",
	mapStrategy: "entries",
	removeAdditionalStrategy: "passthrough",
	allowedAdditionalProperties: true,
	rejectedAdditionalProperties: false,
	definitionPath: "definitions",
	strictUnions: false,
	definitions: {},
	errorMessages: false,
	patternStrategy: "escape",
	applyRegexFlags: false,
	emailStrategy: "format:email",
	base64Strategy: "contentEncoding:base64",
	nameStrategy: "ref"
};
var getDefaultOptions = (options) => typeof options === "string" ? {
	...defaultOptions,
	name: options
} : {
	...defaultOptions,
	...options
};
function parseAnyDef() {
	return {};
}
function parseArrayDef(def, refs) {
	var _a2, _b2, _c;
	const res = { type: "array" };
	if (((_a2 = def.type) == null ? void 0 : _a2._def) && ((_c = (_b2 = def.type) == null ? void 0 : _b2._def) == null ? void 0 : _c.typeName) !== ZodFirstPartyTypeKind.ZodAny) res.items = parseDef(def.type._def, {
		...refs,
		currentPath: [...refs.currentPath, "items"]
	});
	if (def.minLength) res.minItems = def.minLength.value;
	if (def.maxLength) res.maxItems = def.maxLength.value;
	if (def.exactLength) {
		res.minItems = def.exactLength.value;
		res.maxItems = def.exactLength.value;
	}
	return res;
}
function parseBigintDef(def) {
	const res = {
		type: "integer",
		format: "int64"
	};
	if (!def.checks) return res;
	for (const check of def.checks) switch (check.kind) {
		case "min":
			if (check.inclusive) res.minimum = check.value;
			else res.exclusiveMinimum = check.value;
			break;
		case "max":
			if (check.inclusive) res.maximum = check.value;
			else res.exclusiveMaximum = check.value;
			break;
		case "multipleOf":
			res.multipleOf = check.value;
			break;
	}
	return res;
}
function parseBooleanDef() {
	return { type: "boolean" };
}
function parseBrandedDef(_def, refs) {
	return parseDef(_def.type._def, refs);
}
var parseCatchDef = (def, refs) => {
	return parseDef(def.innerType._def, refs);
};
function parseDateDef(def, refs, overrideDateStrategy) {
	const strategy = overrideDateStrategy != null ? overrideDateStrategy : refs.dateStrategy;
	if (Array.isArray(strategy)) return { anyOf: strategy.map((item, i) => parseDateDef(def, refs, item)) };
	switch (strategy) {
		case "string":
		case "format:date-time": return {
			type: "string",
			format: "date-time"
		};
		case "format:date": return {
			type: "string",
			format: "date"
		};
		case "integer": return integerDateParser(def);
	}
}
var integerDateParser = (def) => {
	const res = {
		type: "integer",
		format: "unix-time"
	};
	for (const check of def.checks) switch (check.kind) {
		case "min":
			res.minimum = check.value;
			break;
		case "max":
			res.maximum = check.value;
			break;
	}
	return res;
};
function parseDefaultDef(_def, refs) {
	return {
		...parseDef(_def.innerType._def, refs),
		default: _def.defaultValue()
	};
}
function parseEffectsDef(_def, refs) {
	return refs.effectStrategy === "input" ? parseDef(_def.schema._def, refs) : parseAnyDef();
}
function parseEnumDef(def) {
	return {
		type: "string",
		enum: Array.from(def.values)
	};
}
var isJsonSchema7AllOfType = (type) => {
	if ("type" in type && type.type === "string") return false;
	return "allOf" in type;
};
function parseIntersectionDef(def, refs) {
	const allOf = [parseDef(def.left._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"0"
		]
	}), parseDef(def.right._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"1"
		]
	})].filter((x) => !!x);
	const mergedAllOf = [];
	allOf.forEach((schema) => {
		if (isJsonSchema7AllOfType(schema)) mergedAllOf.push(...schema.allOf);
		else {
			let nestedSchema = schema;
			if ("additionalProperties" in schema && schema.additionalProperties === false) {
				const { additionalProperties, ...rest } = schema;
				nestedSchema = rest;
			}
			mergedAllOf.push(nestedSchema);
		}
	});
	return mergedAllOf.length ? { allOf: mergedAllOf } : void 0;
}
function parseLiteralDef(def) {
	const parsedType = typeof def.value;
	if (parsedType !== "bigint" && parsedType !== "number" && parsedType !== "boolean" && parsedType !== "string") return { type: Array.isArray(def.value) ? "array" : "object" };
	return {
		type: parsedType === "bigint" ? "integer" : parsedType,
		const: def.value
	};
}
var emojiRegex = void 0;
var zodPatterns = {
	/**
	* `c` was changed to `[cC]` to replicate /i flag
	*/
	cuid: /^[cC][^\s-]{8,}$/,
	cuid2: /^[0-9a-z]+$/,
	ulid: /^[0-9A-HJKMNP-TV-Z]{26}$/,
	/**
	* `a-z` was added to replicate /i flag
	*/
	email: /^(?!\.)(?!.*\.\.)([a-zA-Z0-9_'+\-\.]*)[a-zA-Z0-9_+-]@([a-zA-Z0-9][a-zA-Z0-9\-]*\.)+[a-zA-Z]{2,}$/,
	/**
	* Constructed a valid Unicode RegExp
	*
	* Lazily instantiate since this type of regex isn't supported
	* in all envs (e.g. React Native).
	*
	* See:
	* https://github.com/colinhacks/zod/issues/2433
	* Fix in Zod:
	* https://github.com/colinhacks/zod/commit/9340fd51e48576a75adc919bff65dbc4a5d4c99b
	*/
	emoji: () => {
		if (emojiRegex === void 0) emojiRegex = RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u");
		return emojiRegex;
	},
	/**
	* Unused
	*/
	uuid: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
	/**
	* Unused
	*/
	ipv4: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/,
	ipv4Cidr: /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/,
	/**
	* Unused
	*/
	ipv6: /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
	ipv6Cidr: /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/,
	base64: /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/,
	base64url: /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/,
	nanoid: /^[a-zA-Z0-9_-]{21}$/,
	jwt: /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/
};
function parseStringDef(def, refs) {
	const res = { type: "string" };
	if (def.checks) for (const check of def.checks) switch (check.kind) {
		case "min":
			res.minLength = typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value;
			break;
		case "max":
			res.maxLength = typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value;
			break;
		case "email":
			switch (refs.emailStrategy) {
				case "format:email":
					addFormat(res, "email", check.message, refs);
					break;
				case "format:idn-email":
					addFormat(res, "idn-email", check.message, refs);
					break;
				case "pattern:zod":
					addPattern(res, zodPatterns.email, check.message, refs);
					break;
			}
			break;
		case "url":
			addFormat(res, "uri", check.message, refs);
			break;
		case "uuid":
			addFormat(res, "uuid", check.message, refs);
			break;
		case "regex":
			addPattern(res, check.regex, check.message, refs);
			break;
		case "cuid":
			addPattern(res, zodPatterns.cuid, check.message, refs);
			break;
		case "cuid2":
			addPattern(res, zodPatterns.cuid2, check.message, refs);
			break;
		case "startsWith":
			addPattern(res, RegExp(`^${escapeLiteralCheckValue(check.value, refs)}`), check.message, refs);
			break;
		case "endsWith":
			addPattern(res, RegExp(`${escapeLiteralCheckValue(check.value, refs)}$`), check.message, refs);
			break;
		case "datetime":
			addFormat(res, "date-time", check.message, refs);
			break;
		case "date":
			addFormat(res, "date", check.message, refs);
			break;
		case "time":
			addFormat(res, "time", check.message, refs);
			break;
		case "duration":
			addFormat(res, "duration", check.message, refs);
			break;
		case "length":
			res.minLength = typeof res.minLength === "number" ? Math.max(res.minLength, check.value) : check.value;
			res.maxLength = typeof res.maxLength === "number" ? Math.min(res.maxLength, check.value) : check.value;
			break;
		case "includes":
			addPattern(res, RegExp(escapeLiteralCheckValue(check.value, refs)), check.message, refs);
			break;
		case "ip":
			if (check.version !== "v6") addFormat(res, "ipv4", check.message, refs);
			if (check.version !== "v4") addFormat(res, "ipv6", check.message, refs);
			break;
		case "base64url":
			addPattern(res, zodPatterns.base64url, check.message, refs);
			break;
		case "jwt":
			addPattern(res, zodPatterns.jwt, check.message, refs);
			break;
		case "cidr":
			if (check.version !== "v6") addPattern(res, zodPatterns.ipv4Cidr, check.message, refs);
			if (check.version !== "v4") addPattern(res, zodPatterns.ipv6Cidr, check.message, refs);
			break;
		case "emoji":
			addPattern(res, zodPatterns.emoji(), check.message, refs);
			break;
		case "ulid":
			addPattern(res, zodPatterns.ulid, check.message, refs);
			break;
		case "base64":
			switch (refs.base64Strategy) {
				case "format:binary":
					addFormat(res, "binary", check.message, refs);
					break;
				case "contentEncoding:base64":
					res.contentEncoding = "base64";
					break;
				case "pattern:zod":
					addPattern(res, zodPatterns.base64, check.message, refs);
					break;
			}
			break;
		case "nanoid": addPattern(res, zodPatterns.nanoid, check.message, refs);
		case "toLowerCase":
		case "toUpperCase":
		case "trim": break;
		default:
	}
	return res;
}
function escapeLiteralCheckValue(literal, refs) {
	return refs.patternStrategy === "escape" ? escapeNonAlphaNumeric(literal) : literal;
}
var ALPHA_NUMERIC = /* @__PURE__ */ new Set("ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvxyz0123456789");
function escapeNonAlphaNumeric(source) {
	let result = "";
	for (let i = 0; i < source.length; i++) {
		if (!ALPHA_NUMERIC.has(source[i])) result += "\\";
		result += source[i];
	}
	return result;
}
function addFormat(schema, value, message, refs) {
	var _a2;
	if (schema.format || ((_a2 = schema.anyOf) == null ? void 0 : _a2.some((x) => x.format))) {
		if (!schema.anyOf) schema.anyOf = [];
		if (schema.format) {
			schema.anyOf.push({ format: schema.format });
			delete schema.format;
		}
		schema.anyOf.push({
			format: value,
			...message && refs.errorMessages && { errorMessage: { format: message } }
		});
	} else schema.format = value;
}
function addPattern(schema, regex, message, refs) {
	var _a2;
	if (schema.pattern || ((_a2 = schema.allOf) == null ? void 0 : _a2.some((x) => x.pattern))) {
		if (!schema.allOf) schema.allOf = [];
		if (schema.pattern) {
			schema.allOf.push({ pattern: schema.pattern });
			delete schema.pattern;
		}
		schema.allOf.push({
			pattern: stringifyRegExpWithFlags(regex, refs),
			...message && refs.errorMessages && { errorMessage: { pattern: message } }
		});
	} else schema.pattern = stringifyRegExpWithFlags(regex, refs);
}
function stringifyRegExpWithFlags(regex, refs) {
	var _a2;
	if (!refs.applyRegexFlags || !regex.flags) return regex.source;
	const flags = {
		i: regex.flags.includes("i"),
		m: regex.flags.includes("m"),
		s: regex.flags.includes("s")
	};
	const source = flags.i ? regex.source.toLowerCase() : regex.source;
	let pattern = "";
	let isEscaped = false;
	let inCharGroup = false;
	let inCharRange = false;
	for (let i = 0; i < source.length; i++) {
		if (isEscaped) {
			pattern += source[i];
			isEscaped = false;
			continue;
		}
		if (flags.i) {
			if (inCharGroup) {
				if (source[i].match(/[a-z]/)) {
					if (inCharRange) {
						pattern += source[i];
						pattern += `${source[i - 2]}-${source[i]}`.toUpperCase();
						inCharRange = false;
					} else if (source[i + 1] === "-" && ((_a2 = source[i + 2]) == null ? void 0 : _a2.match(/[a-z]/))) {
						pattern += source[i];
						inCharRange = true;
					} else pattern += `${source[i]}${source[i].toUpperCase()}`;
					continue;
				}
			} else if (source[i].match(/[a-z]/)) {
				pattern += `[${source[i]}${source[i].toUpperCase()}]`;
				continue;
			}
		}
		if (flags.m) {
			if (source[i] === "^") {
				pattern += `(^|(?<=[\r
]))`;
				continue;
			} else if (source[i] === "$") {
				pattern += `($|(?=[\r
]))`;
				continue;
			}
		}
		if (flags.s && source[i] === ".") {
			pattern += inCharGroup ? `${source[i]}\r
` : `[${source[i]}\r
]`;
			continue;
		}
		pattern += source[i];
		if (source[i] === "\\") isEscaped = true;
		else if (inCharGroup && source[i] === "]") inCharGroup = false;
		else if (!inCharGroup && source[i] === "[") inCharGroup = true;
	}
	try {
		new RegExp(pattern);
	} catch (e) {
		console.warn(`Could not convert regex pattern at ${refs.currentPath.join("/")} to a flag-independent form! Falling back to the flag-ignorant source`);
		return regex.source;
	}
	return pattern;
}
function parseRecordDef(def, refs) {
	var _a2, _b2, _c, _d, _e, _f;
	const schema = {
		type: "object",
		additionalProperties: (_a2 = parseDef(def.valueType._def, {
			...refs,
			currentPath: [...refs.currentPath, "additionalProperties"]
		})) != null ? _a2 : refs.allowedAdditionalProperties
	};
	if (((_b2 = def.keyType) == null ? void 0 : _b2._def.typeName) === ZodFirstPartyTypeKind.ZodString && ((_c = def.keyType._def.checks) == null ? void 0 : _c.length)) {
		const { type, ...keyType } = parseStringDef(def.keyType._def, refs);
		return {
			...schema,
			propertyNames: keyType
		};
	} else if (((_d = def.keyType) == null ? void 0 : _d._def.typeName) === ZodFirstPartyTypeKind.ZodEnum) return {
		...schema,
		propertyNames: { enum: def.keyType._def.values }
	};
	else if (((_e = def.keyType) == null ? void 0 : _e._def.typeName) === ZodFirstPartyTypeKind.ZodBranded && def.keyType._def.type._def.typeName === ZodFirstPartyTypeKind.ZodString && ((_f = def.keyType._def.type._def.checks) == null ? void 0 : _f.length)) {
		const { type, ...keyType } = parseBrandedDef(def.keyType._def, refs);
		return {
			...schema,
			propertyNames: keyType
		};
	}
	return schema;
}
function parseMapDef(def, refs) {
	if (refs.mapStrategy === "record") return parseRecordDef(def, refs);
	return {
		type: "array",
		maxItems: 125,
		items: {
			type: "array",
			items: [parseDef(def.keyType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"items",
					"items",
					"0"
				]
			}) || parseAnyDef(), parseDef(def.valueType._def, {
				...refs,
				currentPath: [
					...refs.currentPath,
					"items",
					"items",
					"1"
				]
			}) || parseAnyDef()],
			minItems: 2,
			maxItems: 2
		}
	};
}
function parseNativeEnumDef(def) {
	const object = def.values;
	const actualValues = Object.keys(def.values).filter((key) => {
		return typeof object[object[key]] !== "number";
	}).map((key) => object[key]);
	const parsedTypes = Array.from(new Set(actualValues.map((values) => typeof values)));
	return {
		type: parsedTypes.length === 1 ? parsedTypes[0] === "string" ? "string" : "number" : ["string", "number"],
		enum: actualValues
	};
}
function parseNeverDef() {
	return { not: parseAnyDef() };
}
function parseNullDef() {
	return { type: "null" };
}
var primitiveMappings = {
	ZodString: "string",
	ZodNumber: "number",
	ZodBigInt: "integer",
	ZodBoolean: "boolean",
	ZodNull: "null"
};
function parseUnionDef(def, refs) {
	const options = def.options instanceof Map ? Array.from(def.options.values()) : def.options;
	if (options.every((x) => x._def.typeName in primitiveMappings && (!x._def.checks || !x._def.checks.length))) {
		const types = options.reduce((types2, x) => {
			const type = primitiveMappings[x._def.typeName];
			return type && !types2.includes(type) ? [...types2, type] : types2;
		}, []);
		return { type: types.length > 1 ? types : types[0] };
	} else if (options.every((x) => x._def.typeName === "ZodLiteral" && !x.description)) {
		const types = options.reduce((acc, x) => {
			const type = typeof x._def.value;
			switch (type) {
				case "string":
				case "number":
				case "boolean": return [...acc, type];
				case "bigint": return [...acc, "integer"];
				case "object": if (x._def.value === null) return [...acc, "null"];
				default: return acc;
			}
		}, []);
		if (types.length === options.length) {
			const uniqueTypes = types.filter((x, i, a) => a.indexOf(x) === i);
			return {
				type: uniqueTypes.length > 1 ? uniqueTypes : uniqueTypes[0],
				enum: options.reduce((acc, x) => {
					return acc.includes(x._def.value) ? acc : [...acc, x._def.value];
				}, [])
			};
		}
	} else if (options.every((x) => x._def.typeName === "ZodEnum")) return {
		type: "string",
		enum: options.reduce((acc, x) => [...acc, ...x._def.values.filter((x2) => !acc.includes(x2))], [])
	};
	return asAnyOf(def, refs);
}
var asAnyOf = (def, refs) => {
	const anyOf = (def.options instanceof Map ? Array.from(def.options.values()) : def.options).map((x, i) => parseDef(x._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			`${i}`
		]
	})).filter((x) => !!x && (!refs.strictUnions || typeof x === "object" && Object.keys(x).length > 0));
	return anyOf.length ? { anyOf } : void 0;
};
function parseNullableDef(def, refs) {
	if ([
		"ZodString",
		"ZodNumber",
		"ZodBigInt",
		"ZodBoolean",
		"ZodNull"
	].includes(def.innerType._def.typeName) && (!def.innerType._def.checks || !def.innerType._def.checks.length)) return { type: [primitiveMappings[def.innerType._def.typeName], "null"] };
	const base = parseDef(def.innerType._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			"0"
		]
	});
	return base && { anyOf: [base, { type: "null" }] };
}
function parseNumberDef(def) {
	const res = { type: "number" };
	if (!def.checks) return res;
	for (const check of def.checks) switch (check.kind) {
		case "int":
			res.type = "integer";
			break;
		case "min":
			if (check.inclusive) res.minimum = check.value;
			else res.exclusiveMinimum = check.value;
			break;
		case "max":
			if (check.inclusive) res.maximum = check.value;
			else res.exclusiveMaximum = check.value;
			break;
		case "multipleOf":
			res.multipleOf = check.value;
			break;
	}
	return res;
}
function parseObjectDef(def, refs) {
	const result = {
		type: "object",
		properties: {}
	};
	const required = [];
	const shape = def.shape();
	for (const propName in shape) {
		let propDef = shape[propName];
		if (propDef === void 0 || propDef._def === void 0) continue;
		const propOptional = safeIsOptional(propDef);
		const parsedDef = parseDef(propDef._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"properties",
				propName
			],
			propertyPath: [
				...refs.currentPath,
				"properties",
				propName
			]
		});
		if (parsedDef === void 0) continue;
		result.properties[propName] = parsedDef;
		if (!propOptional) required.push(propName);
	}
	if (required.length) result.required = required;
	const additionalProperties = decideAdditionalProperties(def, refs);
	if (additionalProperties !== void 0) result.additionalProperties = additionalProperties;
	return result;
}
function decideAdditionalProperties(def, refs) {
	if (def.catchall._def.typeName !== "ZodNever") return parseDef(def.catchall._def, {
		...refs,
		currentPath: [...refs.currentPath, "additionalProperties"]
	});
	switch (def.unknownKeys) {
		case "passthrough": return refs.allowedAdditionalProperties;
		case "strict": return refs.rejectedAdditionalProperties;
		case "strip": return refs.removeAdditionalStrategy === "strict" ? refs.allowedAdditionalProperties : refs.rejectedAdditionalProperties;
	}
}
function safeIsOptional(schema) {
	try {
		return schema.isOptional();
	} catch (e) {
		return true;
	}
}
var parseOptionalDef = (def, refs) => {
	var _a2;
	if (refs.currentPath.toString() === ((_a2 = refs.propertyPath) == null ? void 0 : _a2.toString())) return parseDef(def.innerType._def, refs);
	const innerSchema = parseDef(def.innerType._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"anyOf",
			"1"
		]
	});
	return innerSchema ? { anyOf: [{ not: parseAnyDef() }, innerSchema] } : parseAnyDef();
};
var parsePipelineDef = (def, refs) => {
	if (refs.pipeStrategy === "input") return parseDef(def.in._def, refs);
	else if (refs.pipeStrategy === "output") return parseDef(def.out._def, refs);
	const a = parseDef(def.in._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			"0"
		]
	});
	return { allOf: [a, parseDef(def.out._def, {
		...refs,
		currentPath: [
			...refs.currentPath,
			"allOf",
			a ? "1" : "0"
		]
	})].filter((x) => x !== void 0) };
};
function parsePromiseDef(def, refs) {
	return parseDef(def.type._def, refs);
}
function parseSetDef(def, refs) {
	const schema = {
		type: "array",
		uniqueItems: true,
		items: parseDef(def.valueType._def, {
			...refs,
			currentPath: [...refs.currentPath, "items"]
		})
	};
	if (def.minSize) schema.minItems = def.minSize.value;
	if (def.maxSize) schema.maxItems = def.maxSize.value;
	return schema;
}
function parseTupleDef(def, refs) {
	if (def.rest) return {
		type: "array",
		minItems: def.items.length,
		items: def.items.map((x, i) => parseDef(x._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"items",
				`${i}`
			]
		})).reduce((acc, x) => x === void 0 ? acc : [...acc, x], []),
		additionalItems: parseDef(def.rest._def, {
			...refs,
			currentPath: [...refs.currentPath, "additionalItems"]
		})
	};
	else return {
		type: "array",
		minItems: def.items.length,
		maxItems: def.items.length,
		items: def.items.map((x, i) => parseDef(x._def, {
			...refs,
			currentPath: [
				...refs.currentPath,
				"items",
				`${i}`
			]
		})).reduce((acc, x) => x === void 0 ? acc : [...acc, x], [])
	};
}
function parseUndefinedDef() {
	return { not: parseAnyDef() };
}
function parseUnknownDef() {
	return parseAnyDef();
}
var parseReadonlyDef = (def, refs) => {
	return parseDef(def.innerType._def, refs);
};
var selectParser = (def, typeName, refs) => {
	switch (typeName) {
		case ZodFirstPartyTypeKind.ZodString: return parseStringDef(def, refs);
		case ZodFirstPartyTypeKind.ZodNumber: return parseNumberDef(def);
		case ZodFirstPartyTypeKind.ZodObject: return parseObjectDef(def, refs);
		case ZodFirstPartyTypeKind.ZodBigInt: return parseBigintDef(def);
		case ZodFirstPartyTypeKind.ZodBoolean: return parseBooleanDef();
		case ZodFirstPartyTypeKind.ZodDate: return parseDateDef(def, refs);
		case ZodFirstPartyTypeKind.ZodUndefined: return parseUndefinedDef();
		case ZodFirstPartyTypeKind.ZodNull: return parseNullDef();
		case ZodFirstPartyTypeKind.ZodArray: return parseArrayDef(def, refs);
		case ZodFirstPartyTypeKind.ZodUnion:
		case ZodFirstPartyTypeKind.ZodDiscriminatedUnion: return parseUnionDef(def, refs);
		case ZodFirstPartyTypeKind.ZodIntersection: return parseIntersectionDef(def, refs);
		case ZodFirstPartyTypeKind.ZodTuple: return parseTupleDef(def, refs);
		case ZodFirstPartyTypeKind.ZodRecord: return parseRecordDef(def, refs);
		case ZodFirstPartyTypeKind.ZodLiteral: return parseLiteralDef(def);
		case ZodFirstPartyTypeKind.ZodEnum: return parseEnumDef(def);
		case ZodFirstPartyTypeKind.ZodNativeEnum: return parseNativeEnumDef(def);
		case ZodFirstPartyTypeKind.ZodNullable: return parseNullableDef(def, refs);
		case ZodFirstPartyTypeKind.ZodOptional: return parseOptionalDef(def, refs);
		case ZodFirstPartyTypeKind.ZodMap: return parseMapDef(def, refs);
		case ZodFirstPartyTypeKind.ZodSet: return parseSetDef(def, refs);
		case ZodFirstPartyTypeKind.ZodLazy: return () => def.getter()._def;
		case ZodFirstPartyTypeKind.ZodPromise: return parsePromiseDef(def, refs);
		case ZodFirstPartyTypeKind.ZodNaN:
		case ZodFirstPartyTypeKind.ZodNever: return parseNeverDef();
		case ZodFirstPartyTypeKind.ZodEffects: return parseEffectsDef(def, refs);
		case ZodFirstPartyTypeKind.ZodAny: return parseAnyDef();
		case ZodFirstPartyTypeKind.ZodUnknown: return parseUnknownDef();
		case ZodFirstPartyTypeKind.ZodDefault: return parseDefaultDef(def, refs);
		case ZodFirstPartyTypeKind.ZodBranded: return parseBrandedDef(def, refs);
		case ZodFirstPartyTypeKind.ZodReadonly: return parseReadonlyDef(def, refs);
		case ZodFirstPartyTypeKind.ZodCatch: return parseCatchDef(def, refs);
		case ZodFirstPartyTypeKind.ZodPipeline: return parsePipelineDef(def, refs);
		case ZodFirstPartyTypeKind.ZodFunction:
		case ZodFirstPartyTypeKind.ZodVoid:
		case ZodFirstPartyTypeKind.ZodSymbol: return;
		default: return /* @__PURE__ */ ((_) => void 0)(typeName);
	}
};
var getRelativePath = (pathA, pathB) => {
	let i = 0;
	for (; i < pathA.length && i < pathB.length; i++) if (pathA[i] !== pathB[i]) break;
	return [(pathA.length - i).toString(), ...pathB.slice(i)].join("/");
};
function parseDef(def, refs, forceResolution = false) {
	var _a2;
	const seenItem = refs.seen.get(def);
	if (refs.override) {
		const overrideResult = (_a2 = refs.override) == null ? void 0 : _a2.call(refs, def, refs, seenItem, forceResolution);
		if (overrideResult !== ignoreOverride) return overrideResult;
	}
	if (seenItem && !forceResolution) {
		const seenSchema = get$ref(seenItem, refs);
		if (seenSchema !== void 0) return seenSchema;
	}
	const newItem = {
		def,
		path: refs.currentPath,
		jsonSchema: void 0
	};
	refs.seen.set(def, newItem);
	const jsonSchemaOrGetter = selectParser(def, def.typeName, refs);
	const jsonSchema2 = typeof jsonSchemaOrGetter === "function" ? parseDef(jsonSchemaOrGetter(), refs) : jsonSchemaOrGetter;
	if (jsonSchema2) addMeta(def, refs, jsonSchema2);
	if (refs.postProcess) {
		const postProcessResult = refs.postProcess(jsonSchema2, def, refs);
		newItem.jsonSchema = jsonSchema2;
		return postProcessResult;
	}
	newItem.jsonSchema = jsonSchema2;
	return jsonSchema2;
}
var get$ref = (item, refs) => {
	switch (refs.$refStrategy) {
		case "root": return { $ref: item.path.join("/") };
		case "relative": return { $ref: getRelativePath(refs.currentPath, item.path) };
		case "none":
		case "seen":
			if (item.path.length < refs.currentPath.length && item.path.every((value, index) => refs.currentPath[index] === value)) {
				console.warn(`Recursive reference detected at ${refs.currentPath.join("/")}! Defaulting to any`);
				return parseAnyDef();
			}
			return refs.$refStrategy === "seen" ? parseAnyDef() : void 0;
	}
};
var addMeta = (def, refs, jsonSchema2) => {
	if (def.description) jsonSchema2.description = def.description;
	return jsonSchema2;
};
var getRefs = (options) => {
	const _options = getDefaultOptions(options);
	const currentPath = _options.name !== void 0 ? [
		..._options.basePath,
		_options.definitionPath,
		_options.name
	] : _options.basePath;
	return {
		..._options,
		currentPath,
		propertyPath: void 0,
		seen: new Map(Object.entries(_options.definitions).map(([name2, def]) => [def._def, {
			def: def._def,
			path: [
				..._options.basePath,
				_options.definitionPath,
				name2
			],
			jsonSchema: void 0
		}]))
	};
};
var zod3ToJsonSchema = (schema, options) => {
	var _a2;
	const refs = getRefs(options);
	let definitions = typeof options === "object" && options.definitions ? Object.entries(options.definitions).reduce((acc, [name3, schema2]) => {
		var _a3;
		return {
			...acc,
			[name3]: (_a3 = parseDef(schema2._def, {
				...refs,
				currentPath: [
					...refs.basePath,
					refs.definitionPath,
					name3
				]
			}, true)) != null ? _a3 : parseAnyDef()
		};
	}, {}) : void 0;
	const name2 = typeof options === "string" ? options : (options == null ? void 0 : options.nameStrategy) === "title" ? void 0 : options == null ? void 0 : options.name;
	const main = (_a2 = parseDef(schema._def, name2 === void 0 ? refs : {
		...refs,
		currentPath: [
			...refs.basePath,
			refs.definitionPath,
			name2
		]
	}, false)) != null ? _a2 : parseAnyDef();
	const title = typeof options === "object" && options.name !== void 0 && options.nameStrategy === "title" ? options.name : void 0;
	if (title !== void 0) main.title = title;
	const combined = name2 === void 0 ? definitions ? {
		...main,
		[refs.definitionPath]: definitions
	} : main : {
		$ref: [
			...refs.$refStrategy === "relative" ? [] : refs.basePath,
			refs.definitionPath,
			name2
		].join("/"),
		[refs.definitionPath]: {
			...definitions,
			[name2]: main
		}
	};
	combined.$schema = "http://json-schema.org/draft-07/schema#";
	return combined;
};
var schemaSymbol = /* @__PURE__ */ Symbol.for("vercel.ai.schema");
function lazySchema(createSchema) {
	let schema;
	return () => {
		if (schema == null) schema = createSchema();
		return schema;
	};
}
function jsonSchema(jsonSchema2, { validate } = {}) {
	return {
		[schemaSymbol]: true,
		_type: void 0,
		get jsonSchema() {
			if (typeof jsonSchema2 === "function") jsonSchema2 = jsonSchema2();
			return jsonSchema2;
		},
		validate
	};
}
function isSchema(value) {
	return typeof value === "object" && value !== null && schemaSymbol in value && value[schemaSymbol] === true && "jsonSchema" in value && "validate" in value;
}
function asSchema(schema) {
	return schema == null ? jsonSchema({
		type: "object",
		properties: {},
		additionalProperties: false
	}) : isSchema(schema) ? schema : "~standard" in schema ? schema["~standard"].vendor === "zod" ? zodSchema(schema) : standardSchema(schema) : schema();
}
function standardSchema(standardSchema2) {
	return jsonSchema(() => {
		if (!hasStandardJsonSchema(standardSchema2)) throw new Error(`Standard schema vendor '${standardSchema2["~standard"].vendor}' does not support JSON Schema conversion.`);
		return addAdditionalPropertiesToJsonSchema(standardSchema2["~standard"].jsonSchema.input({ target: "draft-07" }));
	}, { validate: async (value) => {
		const result = await standardSchema2["~standard"].validate(value);
		return "value" in result ? {
			success: true,
			value: result.value
		} : {
			success: false,
			error: new TypeValidationError({
				value,
				cause: result.issues
			})
		};
	} });
}
function hasStandardJsonSchema(schema) {
	return schema["~standard"].jsonSchema != null;
}
function zod3Schema(zodSchema2, options) {
	var _a2;
	const useReferences = (_a2 = options == null ? void 0 : options.useReferences) != null ? _a2 : false;
	return jsonSchema(() => zod3ToJsonSchema(zodSchema2, { $refStrategy: useReferences ? "root" : "none" }), { validate: async (value) => {
		const result = await zodSchema2.safeParseAsync(value);
		return result.success ? {
			success: true,
			value: result.data
		} : {
			success: false,
			error: result.error
		};
	} });
}
function zod4Schema(zodSchema2, options) {
	var _a2;
	const useReferences = (_a2 = options == null ? void 0 : options.useReferences) != null ? _a2 : false;
	return jsonSchema(() => addAdditionalPropertiesToJsonSchema(z4.toJSONSchema(zodSchema2, {
		target: "draft-7",
		io: "input",
		reused: useReferences ? "ref" : "inline"
	})), { validate: async (value) => {
		const result = await z4.safeParseAsync(zodSchema2, value);
		return result.success ? {
			success: true,
			value: result.data
		} : {
			success: false,
			error: result.error
		};
	} });
}
function isZod4Schema(zodSchema2) {
	return "_zod" in zodSchema2;
}
function zodSchema(zodSchema2, options) {
	if (isZod4Schema(zodSchema2)) return zod4Schema(zodSchema2, options);
	else return zod3Schema(zodSchema2, options);
}
async function validateTypes({ value, schema, context }) {
	const result = await safeValidateTypes({
		value,
		schema,
		context
	});
	if (!result.success) throw TypeValidationError.wrap({
		value,
		cause: result.error,
		context
	});
	return result.value;
}
async function safeValidateTypes({ value, schema, context }) {
	const actualSchema = asSchema(schema);
	try {
		if (actualSchema.validate == null) return {
			success: true,
			value,
			rawValue: value
		};
		const result = await actualSchema.validate(value);
		if (result.success) return {
			success: true,
			value: result.value,
			rawValue: value
		};
		return {
			success: false,
			error: TypeValidationError.wrap({
				value,
				cause: result.error,
				context
			}),
			rawValue: value
		};
	} catch (error) {
		return {
			success: false,
			error: TypeValidationError.wrap({
				value,
				cause: error,
				context
			}),
			rawValue: value
		};
	}
}
async function parseJSON({ text, schema }) {
	try {
		const value = secureJsonParse(text);
		if (schema == null) return value;
		return validateTypes({
			value,
			schema
		});
	} catch (error) {
		if (JSONParseError.isInstance(error) || TypeValidationError.isInstance(error)) throw error;
		throw new JSONParseError({
			text,
			cause: error
		});
	}
}
async function safeParseJSON({ text, schema }) {
	try {
		const value = secureJsonParse(text);
		if (schema == null) return {
			success: true,
			value,
			rawValue: value
		};
		return await safeValidateTypes({
			value,
			schema
		});
	} catch (error) {
		return {
			success: false,
			error: JSONParseError.isInstance(error) ? error : new JSONParseError({
				text,
				cause: error
			}),
			rawValue: void 0
		};
	}
}
function parseJsonEventStream({ stream, schema }) {
	return stream.pipeThrough(new TextDecoderStream()).pipeThrough(new EventSourceParserStream()).pipeThrough(new TransformStream({ async transform({ data }, controller) {
		if (data === "[DONE]") return;
		controller.enqueue(await safeParseJSON({
			text: data,
			schema
		}));
	} }));
}
var getOriginalFetch2 = () => globalThis.fetch;
var postJsonToApi = async ({ url, headers, body, failedResponseHandler, successfulResponseHandler, abortSignal, fetch: fetch2 }) => postToApi({
	url,
	headers: {
		"Content-Type": "application/json",
		...headers
	},
	body: {
		content: JSON.stringify(body),
		values: body
	},
	failedResponseHandler,
	successfulResponseHandler,
	abortSignal,
	fetch: fetch2
});
var postToApi = async ({ url, headers = {}, body, successfulResponseHandler, failedResponseHandler, abortSignal, fetch: fetch2 = getOriginalFetch2() }) => {
	try {
		const response = await fetch2(url, {
			method: "POST",
			headers: withUserAgentSuffix(headers, `ai-sdk/provider-utils/${VERSION$3}`, getRuntimeEnvironmentUserAgent()),
			body: body.content,
			signal: abortSignal
		});
		const responseHeaders = extractResponseHeaders(response);
		if (!response.ok) {
			let errorInformation;
			try {
				errorInformation = await failedResponseHandler({
					response,
					url,
					requestBodyValues: body.values
				});
			} catch (error) {
				if (isAbortError$2(error) || APICallError.isInstance(error)) throw error;
				throw new APICallError({
					message: "Failed to process error response",
					cause: error,
					statusCode: response.status,
					url,
					responseHeaders,
					requestBodyValues: body.values
				});
			}
			throw errorInformation.value;
		}
		try {
			return await successfulResponseHandler({
				response,
				url,
				requestBodyValues: body.values
			});
		} catch (error) {
			if (error instanceof Error) {
				if (isAbortError$2(error) || APICallError.isInstance(error)) throw error;
			}
			throw new APICallError({
				message: "Failed to process successful response",
				cause: error,
				statusCode: response.status,
				url,
				responseHeaders,
				requestBodyValues: body.values
			});
		}
	} catch (error) {
		throw handleFetchError({
			error,
			url,
			requestBodyValues: body.values
		});
	}
};
function tool(tool2) {
	return tool2;
}
function createProviderToolFactoryWithOutputSchema({ id, inputSchema, outputSchema, supportsDeferredResults }) {
	return ({ execute, needsApproval, toModelOutput, onInputStart, onInputDelta, onInputAvailable, ...args }) => tool({
		type: "provider",
		id,
		args,
		inputSchema,
		outputSchema,
		execute,
		needsApproval,
		toModelOutput,
		onInputStart,
		onInputDelta,
		onInputAvailable,
		supportsDeferredResults
	});
}
async function resolve(value) {
	if (typeof value === "function") value = value();
	return Promise.resolve(value);
}
var retryWithExponentialBackoff = ({ maxRetries = 2, initialDelayInMs = 2e3, backoffFactor = 2, abortSignal, shouldRetry, getDelayInMs = ({ exponentialBackoffDelay }) => exponentialBackoffDelay, createRetryError = ({ message }) => new Error(message) }) => async (f) => retryWithExponentialBackoffInternal(f, {
	maxRetries,
	delayInMs: initialDelayInMs,
	backoffFactor,
	abortSignal,
	shouldRetry,
	getDelayInMs,
	createRetryError
});
async function retryWithExponentialBackoffInternal(f, { maxRetries, delayInMs, backoffFactor, abortSignal, shouldRetry, getDelayInMs, createRetryError }, errors = []) {
	try {
		return await f();
	} catch (error) {
		if (isAbortError$2(error)) throw error;
		if (maxRetries === 0) throw error;
		const errorMessage = getErrorMessage(error);
		const newErrors = [...errors, error];
		const tryNumber = newErrors.length;
		if (tryNumber > maxRetries) throw createRetryError({
			message: `Failed after ${tryNumber} attempts. Last error: ${errorMessage}`,
			reason: "maxRetriesExceeded",
			errors: newErrors
		});
		if (await shouldRetry(error) && tryNumber <= maxRetries) {
			await delay(getDelayInMs({
				error,
				exponentialBackoffDelay: delayInMs
			}), { abortSignal });
			return retryWithExponentialBackoffInternal(f, {
				maxRetries,
				delayInMs: backoffFactor * delayInMs,
				backoffFactor,
				abortSignal,
				shouldRetry,
				getDelayInMs,
				createRetryError
			}, newErrors);
		}
		if (tryNumber === 1) throw error;
		throw createRetryError({
			message: `Failed after ${tryNumber} attempts with non-retryable error: '${errorMessage}'`,
			reason: "errorNotRetryable",
			errors: newErrors
		});
	}
}
var textDecoder = new TextDecoder();
async function readResponseBodyAsText({ response, url }) {
	return textDecoder.decode(await readResponseWithSizeLimit({
		response,
		url
	}));
}
var createJsonErrorResponseHandler = ({ errorSchema, errorToMessage, isRetryable }) => async ({ response, url, requestBodyValues }) => {
	const responseBody = await readResponseBodyAsText({
		response,
		url
	});
	const responseHeaders = extractResponseHeaders(response);
	if (responseBody.trim() === "") return {
		responseHeaders,
		value: new APICallError({
			message: response.statusText,
			url,
			requestBodyValues,
			statusCode: response.status,
			responseHeaders,
			responseBody,
			isRetryable: isRetryable == null ? void 0 : isRetryable(response)
		})
	};
	try {
		const parsedError = await parseJSON({
			text: responseBody,
			schema: errorSchema
		});
		return {
			responseHeaders,
			value: new APICallError({
				message: errorToMessage(parsedError),
				url,
				requestBodyValues,
				statusCode: response.status,
				responseHeaders,
				responseBody,
				data: parsedError,
				isRetryable: isRetryable == null ? void 0 : isRetryable(response, parsedError)
			})
		};
	} catch (parseError) {
		return {
			responseHeaders,
			value: new APICallError({
				message: response.statusText,
				url,
				requestBodyValues,
				statusCode: response.status,
				responseHeaders,
				responseBody,
				isRetryable: isRetryable == null ? void 0 : isRetryable(response)
			})
		};
	}
};
var createEventSourceResponseHandler = (chunkSchema) => async ({ response }) => {
	const responseHeaders = extractResponseHeaders(response);
	if (response.body == null) throw new EmptyResponseBodyError({});
	return {
		responseHeaders,
		value: parseJsonEventStream({
			stream: response.body,
			schema: chunkSchema
		})
	};
};
var createJsonResponseHandler = (responseSchema) => async ({ response, url, requestBodyValues }) => {
	const responseBody = await readResponseBodyAsText({
		response,
		url
	});
	const parsedResult = await safeParseJSON({
		text: responseBody,
		schema: responseSchema
	});
	const responseHeaders = extractResponseHeaders(response);
	if (!parsedResult.success) throw new APICallError({
		message: "Invalid JSON response",
		cause: parsedResult.error,
		statusCode: response.status,
		responseHeaders,
		responseBody,
		url,
		requestBodyValues
	});
	return {
		responseHeaders,
		value: parsedResult.value,
		rawValue: parsedResult.rawValue
	};
};
function withoutTrailingSlash(url) {
	return url == null ? void 0 : url.replace(/\/$/, "");
}
//#endregion
//#region ../_vendored/ai_v6/dist/dist-iiYCn57Q.js
function getContext() {
	return { headers: {} };
}
async function getVercelOidcToken() {
	if (process.env.VERCEL_OIDC_TOKEN) return process.env.VERCEL_OIDC_TOKEN ?? "";
	throw new Error("@vercel/oidc is not available in the vendored @internal AI packages. Provide an API key instead.");
}
var symbol$1 = Symbol.for("vercel.ai.gateway.error");
var _a$1;
var _b;
var GatewayError = class _GatewayError extends (_b = Error, _a$1 = symbol$1, _b) {
	constructor({ message, statusCode = 500, cause, generationId, isRetryable = statusCode != null && (statusCode === 408 || statusCode === 409 || statusCode === 429 || statusCode >= 500) }) {
		super(generationId ? `${message} [${generationId}]` : message);
		this[_a$1] = true;
		this.statusCode = statusCode;
		this.cause = cause;
		this.generationId = generationId;
		this.isRetryable = isRetryable;
	}
	/**
	* Checks if the given error is a Gateway Error.
	* @param {unknown} error - The error to check.
	* @returns {boolean} True if the error is a Gateway Error, false otherwise.
	*/
	static isInstance(error) {
		return _GatewayError.hasMarker(error);
	}
	static hasMarker(error) {
		return typeof error === "object" && error !== null && symbol$1 in error && error[symbol$1] === true;
	}
};
var name$1 = "GatewayAuthenticationError";
var marker2$1 = `vercel.ai.gateway.error.${name$1}`;
var symbol2$1 = Symbol.for(marker2$1);
var _a2$1;
var _b2;
var GatewayAuthenticationError = class _GatewayAuthenticationError extends (_b2 = GatewayError, _a2$1 = symbol2$1, _b2) {
	constructor({ message = "Authentication failed", statusCode = 401, cause, generationId } = {}) {
		super({
			message,
			statusCode,
			cause,
			generationId
		});
		this[_a2$1] = true;
		this.name = name$1;
		this.type = "authentication_error";
	}
	static isInstance(error) {
		return GatewayError.hasMarker(error) && symbol2$1 in error;
	}
	/**
	* Creates a contextual error message when authentication fails
	*/
	static createContextualError({ apiKeyProvided, oidcTokenProvided, message = "Authentication failed", statusCode = 401, cause, generationId }) {
		let contextualMessage;
		if (apiKeyProvided) contextualMessage = `AI Gateway authentication failed: Invalid API key.

Create a new API key: https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fai%2Fapi-keys

Provide via 'apiKey' option or 'AI_GATEWAY_API_KEY' environment variable.`;
		else if (oidcTokenProvided) contextualMessage = `AI Gateway authentication failed: Invalid OIDC token.

Run 'npx vercel link' to link your project, then 'vc env pull' to fetch the token.

Alternatively, use an API key: https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fai%2Fapi-keys`;
		else contextualMessage = `AI Gateway authentication failed: No authentication provided.

Option 1 - API key:
Create an API key: https://vercel.com/d?to=%2F%5Bteam%5D%2F%7E%2Fai%2Fapi-keys
Provide via 'apiKey' option or 'AI_GATEWAY_API_KEY' environment variable.

Option 2 - OIDC token:
Run 'npx vercel link' to link your project, then 'vc env pull' to fetch the token.`;
		return new _GatewayAuthenticationError({
			message: contextualMessage,
			statusCode,
			cause,
			generationId
		});
	}
};
var name2$1 = "GatewayInvalidRequestError";
var marker3$1 = `vercel.ai.gateway.error.${name2$1}`;
var symbol3$1 = Symbol.for(marker3$1);
var _a3$1;
var _b3;
var GatewayInvalidRequestError = class extends (_b3 = GatewayError, _a3$1 = symbol3$1, _b3) {
	constructor({ message = "Invalid request", statusCode = 400, cause, generationId } = {}) {
		super({
			message,
			statusCode,
			cause,
			generationId
		});
		this[_a3$1] = true;
		this.name = name2$1;
		this.type = "invalid_request_error";
	}
	static isInstance(error) {
		return GatewayError.hasMarker(error) && symbol3$1 in error;
	}
};
var name3$1 = "GatewayRateLimitError";
var marker4$1 = `vercel.ai.gateway.error.${name3$1}`;
var symbol4$1 = Symbol.for(marker4$1);
var _a4$1;
var _b4;
var GatewayRateLimitError = class extends (_b4 = GatewayError, _a4$1 = symbol4$1, _b4) {
	constructor({ message = "Rate limit exceeded", statusCode = 429, cause, generationId } = {}) {
		super({
			message,
			statusCode,
			cause,
			generationId
		});
		this[_a4$1] = true;
		this.name = name3$1;
		this.type = "rate_limit_exceeded";
	}
	static isInstance(error) {
		return GatewayError.hasMarker(error) && symbol4$1 in error;
	}
};
var name4$1 = "GatewayModelNotFoundError";
var marker5$1 = `vercel.ai.gateway.error.${name4$1}`;
var symbol5$1 = Symbol.for(marker5$1);
var modelNotFoundParamSchema = lazySchema(() => zodSchema(z$1.object({ modelId: z$1.string() })));
var _a5$1;
var _b5;
var GatewayModelNotFoundError = class extends (_b5 = GatewayError, _a5$1 = symbol5$1, _b5) {
	constructor({ message = "Model not found", statusCode = 404, modelId, cause, generationId } = {}) {
		super({
			message,
			statusCode,
			cause,
			generationId
		});
		this[_a5$1] = true;
		this.name = name4$1;
		this.type = "model_not_found";
		this.modelId = modelId;
	}
	static isInstance(error) {
		return GatewayError.hasMarker(error) && symbol5$1 in error;
	}
};
var name5$1 = "GatewayInternalServerError";
var marker6$1 = `vercel.ai.gateway.error.${name5$1}`;
var symbol6$1 = Symbol.for(marker6$1);
var _a6$1;
var _b6;
var GatewayInternalServerError = class extends (_b6 = GatewayError, _a6$1 = symbol6$1, _b6) {
	constructor({ message = "Internal server error", statusCode = 500, cause, generationId } = {}) {
		super({
			message,
			statusCode,
			cause,
			generationId
		});
		this[_a6$1] = true;
		this.name = name5$1;
		this.type = "internal_server_error";
	}
	static isInstance(error) {
		return GatewayError.hasMarker(error) && symbol6$1 in error;
	}
};
var name6$1 = "GatewayFailedDependencyError";
var marker7$1 = `vercel.ai.gateway.error.${name6$1}`;
var symbol7$1 = Symbol.for(marker7$1);
var _a7$1;
var _b7;
var GatewayFailedDependencyError = class extends (_b7 = GatewayError, _a7$1 = symbol7$1, _b7) {
	constructor({ message = "Failed dependency", statusCode = 424, cause, generationId } = {}) {
		super({
			message,
			statusCode,
			cause,
			generationId
		});
		this[_a7$1] = true;
		this.name = name6$1;
		this.type = "failed_dependency";
	}
	static isInstance(error) {
		return GatewayError.hasMarker(error) && symbol7$1 in error;
	}
};
var name7$1 = "GatewayForbiddenError";
var marker8$1 = `vercel.ai.gateway.error.${name7$1}`;
var symbol8$1 = Symbol.for(marker8$1);
var forbiddenParamSchema = lazySchema(() => zodSchema(z$1.object({ ruleId: z$1.string() })));
var _a8$1;
var _b8;
var GatewayForbiddenError = class extends (_b8 = GatewayError, _a8$1 = symbol8$1, _b8) {
	constructor({ message = "Forbidden", statusCode = 403, cause, generationId, ruleId } = {}) {
		super({
			message,
			statusCode,
			cause,
			generationId
		});
		this[_a8$1] = true;
		this.name = name7$1;
		this.type = "forbidden";
		this.ruleId = ruleId;
	}
	static isInstance(error) {
		return GatewayError.hasMarker(error) && symbol8$1 in error;
	}
};
var name8$1 = "GatewayResponseError";
var marker9$1 = `vercel.ai.gateway.error.${name8$1}`;
var symbol9$1 = Symbol.for(marker9$1);
var _a9$1;
var _b9;
var GatewayResponseError = class extends (_b9 = GatewayError, _a9$1 = symbol9$1, _b9) {
	constructor({ message = "Invalid response from Gateway", statusCode = 502, response, validationError, cause, generationId } = {}) {
		super({
			message,
			statusCode,
			cause,
			generationId
		});
		this[_a9$1] = true;
		this.name = name8$1;
		this.type = "response_error";
		this.response = response;
		this.validationError = validationError;
	}
	static isInstance(error) {
		return GatewayError.hasMarker(error) && symbol9$1 in error;
	}
};
async function createGatewayErrorFromResponse({ response, statusCode, defaultMessage = "Gateway request failed", cause, authMethod }) {
	var _a11;
	const parseResult = await safeValidateTypes({
		value: response,
		schema: gatewayErrorResponseSchema
	});
	if (!parseResult.success) {
		const rawGenerationId = typeof response === "object" && response !== null && "generationId" in response ? response.generationId : void 0;
		return new GatewayResponseError({
			message: `Invalid error response format: ${defaultMessage}`,
			statusCode,
			response,
			validationError: parseResult.error,
			cause,
			generationId: rawGenerationId
		});
	}
	const validatedResponse = parseResult.value;
	const errorType = validatedResponse.error.type;
	const message = validatedResponse.error.message;
	const generationId = (_a11 = validatedResponse.generationId) != null ? _a11 : void 0;
	switch (errorType) {
		case "authentication_error": return GatewayAuthenticationError.createContextualError({
			apiKeyProvided: authMethod === "api-key",
			oidcTokenProvided: authMethod === "oidc",
			statusCode,
			cause,
			generationId
		});
		case "invalid_request_error": return new GatewayInvalidRequestError({
			message,
			statusCode,
			cause,
			generationId
		});
		case "rate_limit_exceeded": return new GatewayRateLimitError({
			message,
			statusCode,
			cause,
			generationId
		});
		case "model_not_found": {
			const modelResult = await safeValidateTypes({
				value: validatedResponse.error.param,
				schema: modelNotFoundParamSchema
			});
			return new GatewayModelNotFoundError({
				message,
				statusCode,
				modelId: modelResult.success ? modelResult.value.modelId : void 0,
				cause,
				generationId
			});
		}
		case "internal_server_error": return new GatewayInternalServerError({
			message,
			statusCode,
			cause,
			generationId
		});
		case "failed_dependency": return new GatewayFailedDependencyError({
			message,
			statusCode,
			cause,
			generationId
		});
		case "forbidden": {
			const ruleResult = await safeValidateTypes({
				value: validatedResponse.error.param,
				schema: forbiddenParamSchema
			});
			return new GatewayForbiddenError({
				message,
				statusCode,
				cause,
				generationId,
				ruleId: ruleResult.success ? ruleResult.value.ruleId : void 0
			});
		}
		default: return new GatewayInternalServerError({
			message,
			statusCode,
			cause,
			generationId
		});
	}
}
var gatewayErrorResponseSchema = lazySchema(() => zodSchema(z$1.object({
	error: z$1.object({
		message: z$1.string(),
		type: z$1.string().nullish(),
		param: z$1.unknown().nullish(),
		code: z$1.union([z$1.string(), z$1.number()]).nullish()
	}),
	generationId: z$1.string().nullish()
})));
function extractApiCallResponse(error) {
	if (error.data !== void 0) return error.data;
	if (error.responseBody != null) try {
		return secureJsonParse(error.responseBody);
	} catch (e) {
		return error.responseBody;
	}
	return {};
}
var name9$1 = "GatewayTimeoutError";
var marker10$1 = `vercel.ai.gateway.error.${name9$1}`;
var symbol10$1 = Symbol.for(marker10$1);
var _a10$1;
var _b10;
var GatewayTimeoutError = class _GatewayTimeoutError extends (_b10 = GatewayError, _a10$1 = symbol10$1, _b10) {
	constructor({ message = "Request timed out", statusCode = 408, cause, generationId } = {}) {
		super({
			message,
			statusCode,
			cause,
			generationId
		});
		this[_a10$1] = true;
		this.name = name9$1;
		this.type = "timeout_error";
	}
	static isInstance(error) {
		return GatewayError.hasMarker(error) && symbol10$1 in error;
	}
	/**
	* Creates a helpful timeout error message with troubleshooting guidance
	*/
	static createTimeoutError({ originalMessage, statusCode = 408, cause, generationId }) {
		const message = `Gateway request timed out: ${originalMessage}

    This is a client-side timeout. To resolve this, increase your timeout configuration: https://vercel.com/docs/ai-gateway/capabilities/video-generation#extending-timeouts-for-node.js`;
		return new _GatewayTimeoutError({
			message,
			statusCode,
			cause,
			generationId
		});
	}
};
function isTimeoutError(error) {
	if (!(error instanceof Error)) return false;
	const errorCode = error.code;
	if (typeof errorCode === "string") return [
		"UND_ERR_HEADERS_TIMEOUT",
		"UND_ERR_BODY_TIMEOUT",
		"UND_ERR_CONNECT_TIMEOUT"
	].includes(errorCode);
	return false;
}
async function asGatewayError(error, authMethod) {
	var _a11;
	if (GatewayError.isInstance(error)) return error;
	if (isTimeoutError(error)) return GatewayTimeoutError.createTimeoutError({
		originalMessage: error instanceof Error ? error.message : "Unknown error",
		cause: error
	});
	if (APICallError.isInstance(error)) {
		if (error.cause && isTimeoutError(error.cause)) return GatewayTimeoutError.createTimeoutError({
			originalMessage: error.message,
			cause: error
		});
		return await createGatewayErrorFromResponse({
			response: extractApiCallResponse(error),
			statusCode: (_a11 = error.statusCode) != null ? _a11 : 500,
			defaultMessage: "Gateway request failed",
			cause: error,
			authMethod
		});
	}
	return await createGatewayErrorFromResponse({
		response: {},
		statusCode: 500,
		defaultMessage: error instanceof Error ? `Gateway request failed: ${error.message}` : "Unknown Gateway error",
		cause: error,
		authMethod
	});
}
var GATEWAY_AUTH_METHOD_HEADER = "ai-gateway-auth-method";
async function parseAuthMethod(headers) {
	const result = await safeValidateTypes({
		value: headers[GATEWAY_AUTH_METHOD_HEADER],
		schema: gatewayAuthMethodSchema
	});
	return result.success ? result.value : void 0;
}
var gatewayAuthMethodSchema = lazySchema(() => zodSchema(z$1.union([z$1.literal("api-key"), z$1.literal("oidc")])));
var KNOWN_MODEL_TYPES = [
	"embedding",
	"image",
	"language",
	"reranking",
	"speech",
	"transcription",
	"video"
];
var GatewayFetchMetadata = class {
	constructor(config) {
		this.config = config;
	}
	async getAvailableModels() {
		try {
			const { value } = await getFromApi({
				url: `${this.config.baseURL}/config`,
				headers: await resolve(this.config.headers()),
				successfulResponseHandler: createJsonResponseHandler(gatewayAvailableModelsResponseSchema),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				fetch: this.config.fetch
			});
			return value;
		} catch (error) {
			throw await asGatewayError(error);
		}
	}
	async getCredits() {
		try {
			const { value } = await getFromApi({
				url: `${new URL(this.config.baseURL).origin}/v1/credits`,
				headers: await resolve(this.config.headers()),
				successfulResponseHandler: createJsonResponseHandler(gatewayCreditsResponseSchema),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				fetch: this.config.fetch
			});
			return value;
		} catch (error) {
			throw await asGatewayError(error);
		}
	}
};
var gatewayAvailableModelsResponseSchema = lazySchema(() => zodSchema(z$1.object({ models: z$1.array(z$1.object({
	id: z$1.string(),
	name: z$1.string(),
	description: z$1.string().nullish(),
	pricing: z$1.object({
		input: z$1.string(),
		output: z$1.string(),
		input_cache_read: z$1.string().nullish(),
		input_cache_write: z$1.string().nullish()
	}).transform(({ input, output, input_cache_read, input_cache_write }) => ({
		input,
		output,
		...input_cache_read ? { cachedInputTokens: input_cache_read } : {},
		...input_cache_write ? { cacheCreationInputTokens: input_cache_write } : {}
	})).nullish(),
	specification: z$1.object({
		specificationVersion: z$1.literal("v3"),
		provider: z$1.string(),
		modelId: z$1.string()
	}),
	modelType: z$1.string().nullish()
})).transform((models) => models.filter((m) => m.modelType == null || KNOWN_MODEL_TYPES.includes(m.modelType))) })));
var gatewayCreditsResponseSchema = lazySchema(() => zodSchema(z$1.object({
	balance: z$1.string(),
	total_used: z$1.string()
}).transform(({ balance, total_used }) => ({
	balance,
	totalUsed: total_used
}))));
var GatewaySpendReport = class {
	constructor(config) {
		this.config = config;
	}
	async getSpendReport(params) {
		try {
			const baseUrl = new URL(this.config.baseURL);
			const searchParams = new URLSearchParams();
			searchParams.set("start_date", params.startDate);
			searchParams.set("end_date", params.endDate);
			if (params.groupBy) searchParams.set("group_by", params.groupBy);
			if (params.datePart) searchParams.set("date_part", params.datePart);
			if (params.userId) searchParams.set("user_id", params.userId);
			if (params.model) searchParams.set("model", params.model);
			if (params.provider) searchParams.set("provider", params.provider);
			if (params.credentialType) searchParams.set("credential_type", params.credentialType);
			if (params.tags && params.tags.length > 0) searchParams.set("tags", params.tags.join(","));
			const { value } = await getFromApi({
				url: `${baseUrl.origin}/v1/report?${searchParams.toString()}`,
				headers: await resolve(this.config.headers()),
				successfulResponseHandler: createJsonResponseHandler(gatewaySpendReportResponseSchema),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				fetch: this.config.fetch
			});
			return value;
		} catch (error) {
			throw await asGatewayError(error);
		}
	}
};
var gatewaySpendReportResponseSchema = lazySchema(() => zodSchema(z$1.object({ results: z$1.array(z$1.object({
	day: z$1.string().optional(),
	hour: z$1.string().optional(),
	user: z$1.string().optional(),
	model: z$1.string().optional(),
	tag: z$1.string().optional(),
	provider: z$1.string().optional(),
	credential_type: z$1.enum(["byok", "system"]).optional(),
	total_cost: z$1.number(),
	market_cost: z$1.number().optional(),
	input_tokens: z$1.number().optional(),
	output_tokens: z$1.number().optional(),
	cached_input_tokens: z$1.number().optional(),
	cache_creation_input_tokens: z$1.number().optional(),
	reasoning_tokens: z$1.number().optional(),
	request_count: z$1.number().optional()
}).transform(({ credential_type, total_cost, market_cost, input_tokens, output_tokens, cached_input_tokens, cache_creation_input_tokens, reasoning_tokens, request_count, ...rest }) => ({
	...rest,
	...credential_type !== void 0 ? { credentialType: credential_type } : {},
	totalCost: total_cost,
	...market_cost !== void 0 ? { marketCost: market_cost } : {},
	...input_tokens !== void 0 ? { inputTokens: input_tokens } : {},
	...output_tokens !== void 0 ? { outputTokens: output_tokens } : {},
	...cached_input_tokens !== void 0 ? { cachedInputTokens: cached_input_tokens } : {},
	...cache_creation_input_tokens !== void 0 ? { cacheCreationInputTokens: cache_creation_input_tokens } : {},
	...reasoning_tokens !== void 0 ? { reasoningTokens: reasoning_tokens } : {},
	...request_count !== void 0 ? { requestCount: request_count } : {}
}))) })));
var GatewayGenerationInfoFetcher = class {
	constructor(config) {
		this.config = config;
	}
	async getGenerationInfo(params) {
		try {
			const { value } = await getFromApi({
				url: `${new URL(this.config.baseURL).origin}/v1/generation?id=${encodeURIComponent(params.id)}`,
				headers: await resolve(this.config.headers()),
				successfulResponseHandler: createJsonResponseHandler(gatewayGenerationInfoResponseSchema),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				fetch: this.config.fetch
			});
			return value;
		} catch (error) {
			throw await asGatewayError(error);
		}
	}
};
var gatewayGenerationInfoResponseSchema = lazySchema(() => zodSchema(z$1.object({ data: z$1.object({
	id: z$1.string(),
	total_cost: z$1.number(),
	upstream_inference_cost: z$1.number(),
	usage: z$1.number(),
	created_at: z$1.string(),
	model: z$1.string(),
	is_byok: z$1.boolean(),
	provider_name: z$1.string(),
	streamed: z$1.boolean(),
	finish_reason: z$1.string(),
	latency: z$1.number(),
	generation_time: z$1.number(),
	native_tokens_prompt: z$1.number(),
	native_tokens_completion: z$1.number(),
	native_tokens_reasoning: z$1.number(),
	native_tokens_cached: z$1.number(),
	native_tokens_cache_creation: z$1.number(),
	billable_web_search_calls: z$1.number()
}).transform(({ total_cost, upstream_inference_cost, created_at, is_byok, provider_name, finish_reason, generation_time, native_tokens_prompt, native_tokens_completion, native_tokens_reasoning, native_tokens_cached, native_tokens_cache_creation, billable_web_search_calls, ...rest }) => ({
	...rest,
	totalCost: total_cost,
	upstreamInferenceCost: upstream_inference_cost,
	createdAt: created_at,
	isByok: is_byok,
	providerName: provider_name,
	finishReason: finish_reason,
	generationTime: generation_time,
	promptTokens: native_tokens_prompt,
	completionTokens: native_tokens_completion,
	reasoningTokens: native_tokens_reasoning,
	cachedTokens: native_tokens_cached,
	cacheCreationTokens: native_tokens_cache_creation,
	billableWebSearchCalls: billable_web_search_calls
})) }).transform(({ data }) => data)));
var GatewayLanguageModel = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v3";
		this.supportedUrls = { "*/*": [/.*/] };
	}
	get provider() {
		return this.config.provider;
	}
	async getArgs(options) {
		const { abortSignal: _abortSignal, ...optionsWithoutSignal } = options;
		return {
			args: this.maybeEncodeFileParts(optionsWithoutSignal),
			warnings: []
		};
	}
	async doGenerate(options) {
		const { args, warnings } = await this.getArgs(options);
		const { abortSignal } = options;
		const resolvedHeaders = await resolve(this.config.headers());
		try {
			const { responseHeaders, value: responseBody, rawValue: rawResponse } = await postJsonToApi({
				url: this.getUrl(),
				headers: combineHeaders(resolvedHeaders, options.headers, this.getModelConfigHeaders(this.modelId, false), await resolve(this.config.o11yHeaders)),
				body: args,
				successfulResponseHandler: createJsonResponseHandler(z$1.any()),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				...responseBody,
				request: { body: args },
				response: {
					headers: responseHeaders,
					body: rawResponse
				},
				warnings
			};
		} catch (error) {
			throw await asGatewayError(error, await parseAuthMethod(resolvedHeaders));
		}
	}
	async doStream(options) {
		const { args, warnings } = await this.getArgs(options);
		const { abortSignal } = options;
		const resolvedHeaders = await resolve(this.config.headers());
		try {
			const { value: response, responseHeaders } = await postJsonToApi({
				url: this.getUrl(),
				headers: combineHeaders(resolvedHeaders, options.headers, this.getModelConfigHeaders(this.modelId, true), await resolve(this.config.o11yHeaders)),
				body: args,
				successfulResponseHandler: createEventSourceResponseHandler(z$1.any()),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				stream: response.pipeThrough(new TransformStream({
					start(controller) {
						if (warnings.length > 0) controller.enqueue({
							type: "stream-start",
							warnings
						});
					},
					transform(chunk, controller) {
						if (chunk.success) {
							const streamPart = chunk.value;
							if (streamPart.type === "raw" && !options.includeRawChunks) return;
							if (streamPart.type === "response-metadata" && streamPart.timestamp && typeof streamPart.timestamp === "string") streamPart.timestamp = new Date(streamPart.timestamp);
							controller.enqueue(streamPart);
						} else controller.error(chunk.error);
					}
				})),
				request: { body: args },
				response: { headers: responseHeaders }
			};
		} catch (error) {
			throw await asGatewayError(error, await parseAuthMethod(resolvedHeaders));
		}
	}
	isFilePart(part) {
		return part && typeof part === "object" && "type" in part && part.type === "file";
	}
	/**
	* Encodes file parts in the prompt to base64. Mutates the passed options
	* instance directly to avoid copying the file data.
	* @param options - The options to encode.
	* @returns The options with the file parts encoded.
	*/
	maybeEncodeFileParts(options) {
		for (const message of options.prompt) for (const part of message.content) if (this.isFilePart(part)) {
			const filePart = part;
			if (filePart.data instanceof Uint8Array) {
				const buffer = Uint8Array.from(filePart.data);
				const base64Data = Buffer.from(buffer).toString("base64");
				filePart.data = new URL(`data:${filePart.mediaType || "application/octet-stream"};base64,${base64Data}`);
			}
		}
		return options;
	}
	getUrl() {
		return `${this.config.baseURL}/language-model`;
	}
	getModelConfigHeaders(modelId, streaming) {
		return {
			"ai-language-model-specification-version": "3",
			"ai-language-model-id": modelId,
			"ai-language-model-streaming": String(streaming)
		};
	}
};
var GatewayEmbeddingModel = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v3";
		this.maxEmbeddingsPerCall = 2048;
		this.supportsParallelCalls = true;
	}
	get provider() {
		return this.config.provider;
	}
	async doEmbed({ values, headers, abortSignal, providerOptions }) {
		var _a11, _b11;
		const resolvedHeaders = await resolve(this.config.headers());
		try {
			const { responseHeaders, value: responseBody, rawValue } = await postJsonToApi({
				url: this.getUrl(),
				headers: combineHeaders(resolvedHeaders, headers != null ? headers : {}, this.getModelConfigHeaders(), await resolve(this.config.o11yHeaders)),
				body: {
					values,
					...providerOptions ? { providerOptions } : {}
				},
				successfulResponseHandler: createJsonResponseHandler(gatewayEmbeddingResponseSchema),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				embeddings: responseBody.embeddings,
				usage: (_a11 = responseBody.usage) != null ? _a11 : void 0,
				providerMetadata: responseBody.providerMetadata,
				response: {
					headers: responseHeaders,
					body: rawValue
				},
				warnings: (_b11 = responseBody.warnings) != null ? _b11 : []
			};
		} catch (error) {
			throw await asGatewayError(error, await parseAuthMethod(resolvedHeaders));
		}
	}
	getUrl() {
		return `${this.config.baseURL}/embedding-model`;
	}
	getModelConfigHeaders() {
		return {
			"ai-embedding-model-specification-version": "3",
			"ai-model-id": this.modelId
		};
	}
};
var gatewayEmbeddingWarningSchema = z$1.discriminatedUnion("type", [
	z$1.object({
		type: z$1.literal("unsupported"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("compatibility"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("other"),
		message: z$1.string()
	})
]);
var gatewayEmbeddingResponseSchema = lazySchema(() => zodSchema(z$1.object({
	embeddings: z$1.array(z$1.array(z$1.number())),
	usage: z$1.object({ tokens: z$1.number() }).nullish(),
	warnings: z$1.array(gatewayEmbeddingWarningSchema).optional(),
	providerMetadata: z$1.record(z$1.string(), z$1.record(z$1.string(), z$1.unknown())).optional()
})));
function mapGatewayWarnings(warnings) {
	return (warnings != null ? warnings : []).map((warning) => warning.type === "deprecated" ? {
		type: "other",
		message: warning.message
	} : warning);
}
var GatewayImageModel = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v3";
		this.maxImagesPerCall = Number.MAX_SAFE_INTEGER;
	}
	get provider() {
		return this.config.provider;
	}
	async doGenerate({ prompt, n, size, aspectRatio, seed, files, mask, providerOptions, headers, abortSignal }) {
		var _a11, _b11, _c;
		const resolvedHeaders = await resolve(this.config.headers());
		try {
			const { responseHeaders, value: responseBody, rawValue } = await postJsonToApi({
				url: this.getUrl(),
				headers: combineHeaders(resolvedHeaders, headers != null ? headers : {}, this.getModelConfigHeaders(), await resolve(this.config.o11yHeaders)),
				body: {
					prompt,
					n,
					...size && { size },
					...aspectRatio && { aspectRatio },
					...seed && { seed },
					...providerOptions && { providerOptions },
					...files && { files: files.map((file) => maybeEncodeImageFile(file)) },
					...mask && { mask: maybeEncodeImageFile(mask) }
				},
				successfulResponseHandler: createJsonResponseHandler(gatewayImageResponseSchema),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				images: responseBody.images,
				warnings: mapGatewayWarnings(responseBody.warnings),
				providerMetadata: responseBody.providerMetadata,
				response: {
					timestamp: /* @__PURE__ */ new Date(),
					modelId: this.modelId,
					headers: responseHeaders
				},
				...responseBody.usage != null && { usage: {
					inputTokens: (_a11 = responseBody.usage.inputTokens) != null ? _a11 : void 0,
					outputTokens: (_b11 = responseBody.usage.outputTokens) != null ? _b11 : void 0,
					totalTokens: (_c = responseBody.usage.totalTokens) != null ? _c : void 0
				} }
			};
		} catch (error) {
			throw await asGatewayError(error, await parseAuthMethod(resolvedHeaders));
		}
	}
	getUrl() {
		return `${this.config.baseURL}/image-model`;
	}
	getModelConfigHeaders() {
		return {
			"ai-image-model-specification-version": "3",
			"ai-model-id": this.modelId
		};
	}
};
function maybeEncodeImageFile(file) {
	if (file.type === "file" && file.data instanceof Uint8Array) return {
		...file,
		data: convertUint8ArrayToBase64(file.data)
	};
	return file;
}
var providerMetadataEntrySchema = z$1.object({ images: z$1.array(z$1.unknown()).optional() }).catchall(z$1.unknown());
var gatewayImageWarningSchema = z$1.discriminatedUnion("type", [
	z$1.object({
		type: z$1.literal("unsupported"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("compatibility"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("deprecated"),
		setting: z$1.string(),
		message: z$1.string()
	}),
	z$1.object({
		type: z$1.literal("other"),
		message: z$1.string()
	})
]);
var gatewayImageUsageSchema = z$1.object({
	inputTokens: z$1.number().nullish(),
	outputTokens: z$1.number().nullish(),
	totalTokens: z$1.number().nullish()
});
var gatewayImageResponseSchema = z$1.object({
	images: z$1.array(z$1.string()),
	warnings: z$1.array(gatewayImageWarningSchema).optional(),
	providerMetadata: z$1.record(z$1.string(), providerMetadataEntrySchema).optional(),
	usage: gatewayImageUsageSchema.optional()
});
var GatewayVideoModel = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v3";
		this.maxVideosPerCall = Number.MAX_SAFE_INTEGER;
	}
	get provider() {
		return this.config.provider;
	}
	async doGenerate({ prompt, n, aspectRatio, resolution, duration, fps, seed, generateAudio, image, frameImages, inputReferences, providerOptions, headers, abortSignal }) {
		const resolvedHeaders = await resolve(this.config.headers());
		try {
			const { responseHeaders, value: responseBody } = await postJsonToApi({
				url: this.getUrl(),
				headers: combineHeaders(resolvedHeaders, headers != null ? headers : {}, this.getModelConfigHeaders(), await resolve(this.config.o11yHeaders), { accept: "text/event-stream" }),
				body: {
					prompt,
					n,
					...aspectRatio && { aspectRatio },
					...resolution && { resolution },
					...duration && { duration },
					...fps && { fps },
					...seed && { seed },
					...generateAudio !== void 0 && { generateAudio },
					...providerOptions && { providerOptions },
					...image && { image: maybeEncodeVideoFile(image) },
					...frameImages && { frameImages: frameImages.map((frame) => ({
						...frame,
						image: maybeEncodeVideoFile(frame.image)
					})) },
					...inputReferences && { inputReferences: inputReferences.map((reference) => maybeEncodeVideoFile(reference)) }
				},
				successfulResponseHandler: async ({ response, url, requestBodyValues }) => {
					if (response.body == null) throw new APICallError({
						message: "SSE response body is empty",
						url,
						requestBodyValues,
						statusCode: response.status
					});
					const reader = parseJsonEventStream({
						stream: response.body,
						schema: gatewayVideoEventSchema
					}).getReader();
					const { done, value: parseResult } = await reader.read();
					reader.releaseLock();
					if (done || !parseResult) throw new APICallError({
						message: "SSE stream ended without a data event",
						url,
						requestBodyValues,
						statusCode: response.status
					});
					if (!parseResult.success) throw new APICallError({
						message: "Failed to parse video SSE event",
						cause: parseResult.error,
						url,
						requestBodyValues,
						statusCode: response.status
					});
					const event = parseResult.value;
					if (event.type === "error") throw new APICallError({
						message: event.message,
						statusCode: event.statusCode,
						url,
						requestBodyValues,
						responseHeaders: Object.fromEntries([...response.headers]),
						responseBody: JSON.stringify(event),
						data: { error: {
							message: event.message,
							type: event.errorType,
							param: event.param
						} }
					});
					return {
						value: {
							videos: event.videos,
							warnings: event.warnings,
							providerMetadata: event.providerMetadata
						},
						responseHeaders: Object.fromEntries([...response.headers])
					};
				},
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				videos: responseBody.videos,
				warnings: mapGatewayWarnings(responseBody.warnings),
				providerMetadata: responseBody.providerMetadata,
				response: {
					timestamp: /* @__PURE__ */ new Date(),
					modelId: this.modelId,
					headers: responseHeaders
				}
			};
		} catch (error) {
			throw await asGatewayError(error, await parseAuthMethod(resolvedHeaders));
		}
	}
	getUrl() {
		return `${this.config.baseURL}/video-model`;
	}
	getModelConfigHeaders() {
		return {
			"ai-video-model-specification-version": "3",
			"ai-model-id": this.modelId
		};
	}
};
function maybeEncodeVideoFile(file) {
	if (file.type === "file" && file.data instanceof Uint8Array) return {
		...file,
		data: convertUint8ArrayToBase64(file.data)
	};
	return file;
}
var providerMetadataEntrySchema2 = z$1.object({ videos: z$1.array(z$1.unknown()).optional() }).catchall(z$1.unknown());
var gatewayVideoDataSchema = z$1.union([z$1.object({
	type: z$1.literal("url"),
	url: z$1.string(),
	mediaType: z$1.string()
}), z$1.object({
	type: z$1.literal("base64"),
	data: z$1.string(),
	mediaType: z$1.string()
})]);
var gatewayVideoWarningSchema = z$1.discriminatedUnion("type", [
	z$1.object({
		type: z$1.literal("unsupported"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("compatibility"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("deprecated"),
		setting: z$1.string(),
		message: z$1.string()
	}),
	z$1.object({
		type: z$1.literal("other"),
		message: z$1.string()
	})
]);
var gatewayVideoEventSchema = z$1.discriminatedUnion("type", [z$1.object({
	type: z$1.literal("result"),
	videos: z$1.array(gatewayVideoDataSchema),
	warnings: z$1.array(gatewayVideoWarningSchema).optional(),
	providerMetadata: z$1.record(z$1.string(), providerMetadataEntrySchema2).optional()
}), z$1.object({
	type: z$1.literal("error"),
	message: z$1.string(),
	errorType: z$1.string(),
	statusCode: z$1.number(),
	param: z$1.unknown().nullable()
})]);
var GatewayRerankingModel = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v3";
	}
	get provider() {
		return this.config.provider;
	}
	async doRerank({ documents, query, topN, headers, abortSignal, providerOptions }) {
		var _a11;
		const resolvedHeaders = await resolve(this.config.headers());
		try {
			const { responseHeaders, value: responseBody, rawValue } = await postJsonToApi({
				url: this.getUrl(),
				headers: combineHeaders(resolvedHeaders, headers != null ? headers : {}, this.getModelConfigHeaders(), await resolve(this.config.o11yHeaders)),
				body: {
					documents,
					query,
					...topN != null ? { topN } : {},
					...providerOptions ? { providerOptions } : {}
				},
				successfulResponseHandler: createJsonResponseHandler(gatewayRerankingResponseSchema),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				ranking: responseBody.ranking,
				providerMetadata: responseBody.providerMetadata,
				response: {
					headers: responseHeaders,
					body: rawValue
				},
				warnings: (_a11 = responseBody.warnings) != null ? _a11 : []
			};
		} catch (error) {
			throw await asGatewayError(error, await parseAuthMethod(resolvedHeaders));
		}
	}
	getUrl() {
		return `${this.config.baseURL}/reranking-model`;
	}
	getModelConfigHeaders() {
		return {
			"ai-reranking-model-specification-version": "3",
			"ai-model-id": this.modelId
		};
	}
};
var gatewayRerankingWarningSchema = z$1.discriminatedUnion("type", [
	z$1.object({
		type: z$1.literal("unsupported"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("compatibility"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("other"),
		message: z$1.string()
	})
]);
var gatewayRerankingResponseSchema = lazySchema(() => zodSchema(z$1.object({
	ranking: z$1.array(z$1.object({
		index: z$1.number(),
		relevanceScore: z$1.number()
	})),
	warnings: z$1.array(gatewayRerankingWarningSchema).optional(),
	providerMetadata: z$1.record(z$1.string(), z$1.record(z$1.string(), z$1.unknown())).optional()
})));
var GatewaySpeechModel = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v3";
	}
	get provider() {
		return this.config.provider;
	}
	async doGenerate({ text, voice, outputFormat, instructions, speed, language, providerOptions, headers, abortSignal }) {
		const resolvedHeaders = await resolve(this.config.headers());
		try {
			const { responseHeaders, value: responseBody, rawValue } = await postJsonToApi({
				url: this.getUrl(),
				headers: combineHeaders(resolvedHeaders, headers != null ? headers : {}, this.getModelConfigHeaders(), await resolve(this.config.o11yHeaders)),
				body: {
					text,
					...voice && { voice },
					...outputFormat && { outputFormat },
					...instructions && { instructions },
					...speed != null && { speed },
					...language && { language },
					...providerOptions && { providerOptions }
				},
				successfulResponseHandler: createJsonResponseHandler(gatewaySpeechResponseSchema),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				audio: responseBody.audio,
				warnings: mapGatewayWarnings(responseBody.warnings),
				providerMetadata: responseBody.providerMetadata,
				response: {
					timestamp: /* @__PURE__ */ new Date(),
					modelId: this.modelId,
					headers: responseHeaders,
					body: rawValue
				}
			};
		} catch (error) {
			throw await asGatewayError(error, await parseAuthMethod(resolvedHeaders != null ? resolvedHeaders : {}));
		}
	}
	getUrl() {
		return `${this.config.baseURL}/speech-model`;
	}
	getModelConfigHeaders() {
		return {
			"ai-speech-model-specification-version": "3",
			"ai-model-id": this.modelId
		};
	}
};
var providerMetadataEntrySchema3 = z$1.object({}).catchall(z$1.unknown());
var gatewaySpeechWarningSchema = z$1.discriminatedUnion("type", [
	z$1.object({
		type: z$1.literal("unsupported"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("compatibility"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("deprecated"),
		setting: z$1.string(),
		message: z$1.string()
	}),
	z$1.object({
		type: z$1.literal("other"),
		message: z$1.string()
	})
]);
var gatewaySpeechResponseSchema = z$1.object({
	audio: z$1.string(),
	warnings: z$1.array(gatewaySpeechWarningSchema).optional(),
	providerMetadata: z$1.record(z$1.string(), providerMetadataEntrySchema3).optional()
});
var GatewayTranscriptionModel = class {
	constructor(modelId, config) {
		this.modelId = modelId;
		this.config = config;
		this.specificationVersion = "v3";
	}
	get provider() {
		return this.config.provider;
	}
	async doGenerate({ audio, mediaType, providerOptions, headers, abortSignal }) {
		var _a11, _b11, _c;
		const resolvedHeaders = await resolve(this.config.headers());
		try {
			const { responseHeaders, value: responseBody, rawValue } = await postJsonToApi({
				url: this.getUrl(),
				headers: combineHeaders(resolvedHeaders, headers != null ? headers : {}, this.getModelConfigHeaders(), await resolve(this.config.o11yHeaders)),
				body: {
					audio: audio instanceof Uint8Array ? convertUint8ArrayToBase64(audio) : audio,
					mediaType,
					...providerOptions && { providerOptions }
				},
				successfulResponseHandler: createJsonResponseHandler(gatewayTranscriptionResponseSchema),
				failedResponseHandler: createJsonErrorResponseHandler({
					errorSchema: z$1.any(),
					errorToMessage: (data) => data
				}),
				...abortSignal && { abortSignal },
				fetch: this.config.fetch
			});
			return {
				text: responseBody.text,
				segments: (_a11 = responseBody.segments) != null ? _a11 : [],
				language: (_b11 = responseBody.language) != null ? _b11 : void 0,
				durationInSeconds: (_c = responseBody.durationInSeconds) != null ? _c : void 0,
				warnings: mapGatewayWarnings(responseBody.warnings),
				providerMetadata: responseBody.providerMetadata,
				response: {
					timestamp: /* @__PURE__ */ new Date(),
					modelId: this.modelId,
					headers: responseHeaders,
					body: rawValue
				}
			};
		} catch (error) {
			throw await asGatewayError(error, await parseAuthMethod(resolvedHeaders != null ? resolvedHeaders : {}));
		}
	}
	getUrl() {
		return `${this.config.baseURL}/transcription-model`;
	}
	getModelConfigHeaders() {
		return {
			"ai-transcription-model-specification-version": "3",
			"ai-model-id": this.modelId
		};
	}
};
var providerMetadataEntrySchema4 = z$1.object({}).catchall(z$1.unknown());
var gatewayTranscriptionWarningSchema = z$1.discriminatedUnion("type", [
	z$1.object({
		type: z$1.literal("unsupported"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("compatibility"),
		feature: z$1.string(),
		details: z$1.string().optional()
	}),
	z$1.object({
		type: z$1.literal("deprecated"),
		setting: z$1.string(),
		message: z$1.string()
	}),
	z$1.object({
		type: z$1.literal("other"),
		message: z$1.string()
	})
]);
var gatewayTranscriptionResponseSchema = z$1.object({
	text: z$1.string(),
	segments: z$1.array(z$1.object({
		text: z$1.string(),
		startSecond: z$1.number(),
		endSecond: z$1.number()
	})).optional(),
	language: z$1.string().nullish(),
	durationInSeconds: z$1.number().nullish(),
	warnings: z$1.array(gatewayTranscriptionWarningSchema).optional(),
	providerMetadata: z$1.record(z$1.string(), providerMetadataEntrySchema4).optional()
});
var exaSearchToolFactory = createProviderToolFactoryWithOutputSchema({
	id: "gateway.exa_search",
	inputSchema: lazySchema(() => zodSchema(z.object({
		query: z.string().describe("Natural-language web search query. This is required."),
		type: z.enum([
			"auto",
			"fast",
			"instant"
		]).optional().describe("Search method. Use auto for the default balance of speed and quality."),
		num_results: z.number().optional().describe("Maximum number of results to return (1-100, default: 10)."),
		category: z.enum([
			"company",
			"people",
			"research paper",
			"news",
			"personal site",
			"financial report"
		]).optional().describe("Optional content category to focus results."),
		user_location: z.string().optional().describe("Two-letter ISO country code such as 'US'."),
		include_domains: z.array(z.string()).optional().describe("Only return results from these domains."),
		exclude_domains: z.array(z.string()).optional().describe("Exclude results from these domains."),
		start_published_date: z.string().optional().describe("Only return links published after this ISO 8601 date."),
		end_published_date: z.string().optional().describe("Only return links published before this ISO 8601 date."),
		contents: z.object({
			text: z.union([z.boolean(), z.object({
				max_characters: z.number().optional(),
				include_html_tags: z.boolean().optional(),
				verbosity: z.enum([
					"compact",
					"standard",
					"full"
				]).optional(),
				include_sections: z.array(z.enum([
					"header",
					"navigation",
					"banner",
					"body",
					"sidebar",
					"footer",
					"metadata"
				])).optional(),
				exclude_sections: z.array(z.enum([
					"header",
					"navigation",
					"banner",
					"body",
					"sidebar",
					"footer",
					"metadata"
				])).optional()
			})]).optional(),
			highlights: z.union([z.boolean(), z.object({
				query: z.string().optional(),
				max_characters: z.number().optional()
			})]).optional(),
			max_age_hours: z.number().optional(),
			livecrawl_timeout: z.number().optional(),
			subpages: z.number().optional(),
			subpage_target: z.union([z.string(), z.array(z.string())]).optional(),
			extras: z.object({
				links: z.number().optional(),
				image_links: z.number().optional()
			}).optional()
		}).optional().describe("Controls extracted page content and freshness.")
	}))),
	outputSchema: lazySchema(() => zodSchema(z.union([z.object({
		requestId: z.string(),
		searchType: z.string().optional(),
		resolvedSearchType: z.string().optional(),
		results: z.array(z.object({
			title: z.string(),
			url: z.string(),
			id: z.string(),
			publishedDate: z.string().nullable().optional(),
			author: z.string().nullable().optional(),
			image: z.string().nullable().optional(),
			favicon: z.string().nullable().optional(),
			text: z.string().optional(),
			highlights: z.array(z.string()).optional(),
			highlightScores: z.array(z.number()).optional(),
			summary: z.string().optional(),
			subpages: z.array(z.any()).optional(),
			extras: z.object({
				links: z.array(z.string()).optional(),
				imageLinks: z.array(z.string()).optional()
			}).optional()
		})),
		costDollars: z.object({
			total: z.number().optional(),
			search: z.record(z.number()).optional()
		}).optional()
	}), z.object({
		error: z.enum([
			"api_error",
			"rate_limit",
			"timeout",
			"invalid_input",
			"configuration_error",
			"execution_error",
			"unknown"
		]),
		statusCode: z.number().optional(),
		message: z.string()
	})])))
});
var exaSearch = (config = {}) => exaSearchToolFactory(config);
var parallelSearchToolFactory = createProviderToolFactoryWithOutputSchema({
	id: "gateway.parallel_search",
	inputSchema: lazySchema(() => zodSchema(z.object({
		objective: z.string().describe("Natural-language description of the web research goal, including source or freshness guidance and broader context from the task. Maximum 5000 characters."),
		search_queries: z.array(z.string()).optional().describe("Optional search queries to supplement the objective. Maximum 200 characters per query."),
		mode: z.enum(["one-shot", "agentic"]).optional().describe("Mode preset: \"one-shot\" for comprehensive results with longer excerpts (default), \"agentic\" for concise, token-efficient results for multi-step workflows."),
		max_results: z.number().optional().describe("Maximum number of results to return (1-20). Defaults to 10 if not specified."),
		source_policy: z.object({
			include_domains: z.array(z.string()).optional().describe("Limit results to these domains. Use plain domain names only — e.g. example.com or sub.example.gov, or a bare extension like .edu. Do not include a scheme, path, or port (e.g. not https://example.com/page)."),
			exclude_domains: z.array(z.string()).optional().describe("Exclude results from these domains. Use plain domain names only — e.g. example.com or sub.example.gov, or a bare extension like .edu. Do not include a scheme, path, or port (e.g. not https://example.com/page)."),
			after_date: z.string().optional().describe("Only include results published after this date. Use an ISO 8601 calendar date formatted YYYY-MM-DD (e.g. 2025-01-01); do not include a time.")
		}).optional().describe("Source policy for controlling which domains to include/exclude and freshness."),
		excerpts: z.object({
			max_chars_per_result: z.number().optional().describe("Maximum characters per result."),
			max_chars_total: z.number().optional().describe("Maximum total characters across all results.")
		}).optional().describe("Excerpt configuration for controlling result length."),
		fetch_policy: z.object({ max_age_seconds: z.number().optional().describe("Maximum age in seconds for cached content. Set to 0 to always fetch fresh content.") }).optional().describe("Fetch policy for controlling content freshness.")
	}))),
	outputSchema: lazySchema(() => zodSchema(z.union([z.object({
		searchId: z.string(),
		results: z.array(z.object({
			url: z.string(),
			title: z.string(),
			excerpt: z.string(),
			publishDate: z.string().nullable().optional(),
			relevanceScore: z.number().optional()
		}))
	}), z.object({
		error: z.enum([
			"api_error",
			"rate_limit",
			"timeout",
			"invalid_input",
			"configuration_error",
			"unknown"
		]),
		statusCode: z.number().optional(),
		message: z.string()
	})])))
});
var parallelSearch = (config = {}) => parallelSearchToolFactory(config);
var perplexitySearchToolFactory = createProviderToolFactoryWithOutputSchema({
	id: "gateway.perplexity_search",
	inputSchema: lazySchema(() => zodSchema(z.object({
		query: z.union([z.string(), z.array(z.string())]).describe("Search query (string) or multiple queries (array of up to 5 strings). Multi-query searches return combined results from all queries."),
		max_results: z.number().optional().describe("Maximum number of search results to return (1-20, default: 10)"),
		max_tokens_per_page: z.number().optional().describe("Maximum number of tokens to extract per search result page (256-2048, default: 2048)"),
		max_tokens: z.number().optional().describe("Maximum total tokens across all search results (default: 25000, max: 1000000)"),
		country: z.string().optional().describe("Two-letter ISO 3166-1 alpha-2 country code for regional search results (e.g., 'US', 'GB', 'FR')"),
		search_domain_filter: z.array(z.string()).optional().describe("List of domains to include or exclude from search results (max 20). To include: ['nature.com', 'science.org']. To exclude: ['-example.com', '-spam.net']"),
		search_language_filter: z.array(z.string()).optional().describe("List of ISO 639-1 language codes to filter results (max 10, lowercase). Examples: ['en', 'fr', 'de']"),
		search_after_date: z.string().optional().describe("Include only results published after this date. Format: 'MM/DD/YYYY' (e.g., '3/1/2025'). Cannot be used with search_recency_filter."),
		search_before_date: z.string().optional().describe("Include only results published before this date. Format: 'MM/DD/YYYY' (e.g., '3/15/2025'). Cannot be used with search_recency_filter."),
		last_updated_after_filter: z.string().optional().describe("Include only results last updated after this date. Format: 'MM/DD/YYYY' (e.g., '3/1/2025'). Cannot be used with search_recency_filter."),
		last_updated_before_filter: z.string().optional().describe("Include only results last updated before this date. Format: 'MM/DD/YYYY' (e.g., '3/15/2025'). Cannot be used with search_recency_filter."),
		search_recency_filter: z.enum([
			"day",
			"week",
			"month",
			"year"
		]).optional().describe("Filter results by relative time period. Cannot be used with search_after_date or search_before_date.")
	}))),
	outputSchema: lazySchema(() => zodSchema(z.union([z.object({
		results: z.array(z.object({
			title: z.string(),
			url: z.string(),
			snippet: z.string(),
			date: z.string().optional(),
			lastUpdated: z.string().optional()
		})),
		id: z.string()
	}), z.object({
		error: z.enum([
			"api_error",
			"rate_limit",
			"timeout",
			"invalid_input",
			"unknown"
		]),
		statusCode: z.number().optional(),
		message: z.string()
	})])))
});
var perplexitySearch = (config = {}) => perplexitySearchToolFactory(config);
var gatewayTools = {
	/**
	* Search the web using Exa for current information and token-efficient
	* excerpts optimized for agent workflows.
	*
	* Supports search type, category, domain, date, location, and content
	* extraction controls.
	*/
	exaSearch,
	/**
	* Search the web using Parallel AI's Search API for LLM-optimized excerpts.
	*
	* Takes a natural language objective and returns relevant excerpts,
	* replacing multiple keyword searches with a single call for broad
	* or complex queries. Supports different search types for depth vs
	* breadth tradeoffs.
	*/
	parallelSearch,
	/**
	* Search the web using Perplexity's Search API for real-time information,
	* news, research papers, and articles.
	*
	* Provides ranked search results with advanced filtering options including
	* domain, language, date range, and recency filters.
	*/
	perplexitySearch
};
async function getVercelRequestId() {
	var _a11;
	return (_a11 = getContext().headers) == null ? void 0 : _a11["x-vercel-id"];
}
var VERSION$2 = "3.0.153";
var AI_GATEWAY_PROTOCOL_VERSION = "0.0.1";
function createGatewayProvider(options = {}) {
	var _a11, _b11;
	let pendingMetadata = null;
	let metadataCache = null;
	const cacheRefreshMillis = (_a11 = options.metadataCacheRefreshMillis) != null ? _a11 : 1e3 * 60 * 5;
	let lastFetchTime = 0;
	const baseURL = (_b11 = withoutTrailingSlash(options.baseURL)) != null ? _b11 : "https://ai-gateway.vercel.sh/v3/ai";
	const getHeaders = async () => {
		try {
			const auth = await getGatewayAuthToken(options);
			return withUserAgentSuffix({
				Authorization: `Bearer ${auth.token}`,
				"ai-gateway-protocol-version": AI_GATEWAY_PROTOCOL_VERSION,
				[GATEWAY_AUTH_METHOD_HEADER]: auth.authMethod,
				...options.headers
			}, `ai-sdk/gateway/${VERSION$2}`);
		} catch (error) {
			throw GatewayAuthenticationError.createContextualError({
				apiKeyProvided: false,
				oidcTokenProvided: false,
				statusCode: 401,
				cause: error
			});
		}
	};
	const createO11yHeaders = () => {
		const deploymentId = loadOptionalSetting({
			settingValue: void 0,
			environmentVariableName: "VERCEL_DEPLOYMENT_ID"
		});
		const environment = loadOptionalSetting({
			settingValue: void 0,
			environmentVariableName: "VERCEL_ENV"
		});
		const region = loadOptionalSetting({
			settingValue: void 0,
			environmentVariableName: "VERCEL_REGION"
		});
		const projectId = loadOptionalSetting({
			settingValue: void 0,
			environmentVariableName: "VERCEL_PROJECT_ID"
		});
		return async () => {
			const requestId = await getVercelRequestId();
			return {
				...deploymentId && { "ai-o11y-deployment-id": deploymentId },
				...environment && { "ai-o11y-environment": environment },
				...region && { "ai-o11y-region": region },
				...requestId && { "ai-o11y-request-id": requestId },
				...projectId && { "ai-o11y-project-id": projectId }
			};
		};
	};
	const createLanguageModel = (modelId) => {
		return new GatewayLanguageModel(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	const getAvailableModels = async () => {
		var _a12, _b12, _c;
		const now = (_c = (_b12 = (_a12 = options._internal) == null ? void 0 : _a12.currentDate) == null ? void 0 : _b12.call(_a12).getTime()) != null ? _c : Date.now();
		if (!pendingMetadata || now - lastFetchTime > cacheRefreshMillis) {
			lastFetchTime = now;
			pendingMetadata = new GatewayFetchMetadata({
				baseURL,
				headers: getHeaders,
				fetch: options.fetch
			}).getAvailableModels().then((metadata) => {
				metadataCache = metadata;
				return metadata;
			}).catch(async (error) => {
				throw await asGatewayError(error, await parseAuthMethod(await getHeaders()));
			});
		}
		return metadataCache ? Promise.resolve(metadataCache) : pendingMetadata;
	};
	const getCredits = async () => {
		return new GatewayFetchMetadata({
			baseURL,
			headers: getHeaders,
			fetch: options.fetch
		}).getCredits().catch(async (error) => {
			throw await asGatewayError(error, await parseAuthMethod(await getHeaders()));
		});
	};
	const getSpendReport = async (params) => {
		return new GatewaySpendReport({
			baseURL,
			headers: getHeaders,
			fetch: options.fetch
		}).getSpendReport(params).catch(async (error) => {
			throw await asGatewayError(error, await parseAuthMethod(await getHeaders()));
		});
	};
	const getGenerationInfo = async (params) => {
		return new GatewayGenerationInfoFetcher({
			baseURL,
			headers: getHeaders,
			fetch: options.fetch
		}).getGenerationInfo(params).catch(async (error) => {
			throw await asGatewayError(error, await parseAuthMethod(await getHeaders()));
		});
	};
	const provider = function(modelId) {
		if (new.target) throw new Error("The Gateway Provider model function cannot be called with the new keyword.");
		return createLanguageModel(modelId);
	};
	provider.specificationVersion = "v3";
	provider.getAvailableModels = getAvailableModels;
	provider.getCredits = getCredits;
	provider.getSpendReport = getSpendReport;
	provider.getGenerationInfo = getGenerationInfo;
	provider.imageModel = (modelId) => {
		return new GatewayImageModel(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	provider.languageModel = createLanguageModel;
	const createEmbeddingModel = (modelId) => {
		return new GatewayEmbeddingModel(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	provider.embeddingModel = createEmbeddingModel;
	provider.textEmbeddingModel = createEmbeddingModel;
	provider.videoModel = (modelId) => {
		return new GatewayVideoModel(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	const createRerankingModel = (modelId) => {
		return new GatewayRerankingModel(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	provider.rerankingModel = createRerankingModel;
	provider.reranking = createRerankingModel;
	const createSpeechModel = (modelId) => {
		return new GatewaySpeechModel(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	provider.speechModel = createSpeechModel;
	provider.speech = createSpeechModel;
	const createTranscriptionModel = (modelId) => {
		return new GatewayTranscriptionModel(modelId, {
			provider: "gateway",
			baseURL,
			headers: getHeaders,
			fetch: options.fetch,
			o11yHeaders: createO11yHeaders()
		});
	};
	provider.transcriptionModel = createTranscriptionModel;
	provider.transcription = createTranscriptionModel;
	provider.chat = provider.languageModel;
	provider.embedding = provider.embeddingModel;
	provider.image = provider.imageModel;
	provider.video = provider.videoModel;
	provider.tools = gatewayTools;
	return provider;
}
var gateway = createGatewayProvider();
async function getGatewayAuthToken(options) {
	const apiKey = loadOptionalSetting({
		settingValue: options.apiKey,
		environmentVariableName: "AI_GATEWAY_API_KEY"
	});
	if (apiKey) return {
		token: apiKey,
		authMethod: "api-key"
	};
	return {
		token: await getVercelOidcToken(),
		authMethod: "oidc"
	};
}
//#endregion
//#region ../_vendored/ai_v6/dist/index.js
const VERSION$1 = "1.9.1";
const re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
/**
* Create a function to test an API version to see if it is compatible with the provided ownVersion.
*
* The returned function has the following semantics:
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param ownVersion version which should be checked against
*/
function _makeCompatibilityCheck(ownVersion) {
	const acceptedVersions = /* @__PURE__ */ new Set([ownVersion]);
	const rejectedVersions = /* @__PURE__ */ new Set();
	const myVersionMatch = ownVersion.match(re);
	if (!myVersionMatch) return () => false;
	const ownVersionParsed = {
		major: +myVersionMatch[1],
		minor: +myVersionMatch[2],
		patch: +myVersionMatch[3],
		prerelease: myVersionMatch[4]
	};
	if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
		return globalVersion === ownVersion;
	};
	function _reject(v) {
		rejectedVersions.add(v);
		return false;
	}
	function _accept(v) {
		acceptedVersions.add(v);
		return true;
	}
	return function isCompatible(globalVersion) {
		if (acceptedVersions.has(globalVersion)) return true;
		if (rejectedVersions.has(globalVersion)) return false;
		const globalVersionMatch = globalVersion.match(re);
		if (!globalVersionMatch) return _reject(globalVersion);
		const globalVersionParsed = {
			major: +globalVersionMatch[1],
			minor: +globalVersionMatch[2],
			patch: +globalVersionMatch[3],
			prerelease: globalVersionMatch[4]
		};
		if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
		if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
		if (ownVersionParsed.major === 0) {
			if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
			return _reject(globalVersion);
		}
		if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
		return _reject(globalVersion);
	};
}
/**
* Test an API version to see if it is compatible with this API.
*
* - Exact match is always compatible
* - Major versions must match exactly
*    - 1.x package cannot use global 2.x package
*    - 2.x package cannot use global 1.x package
* - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
*    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
*    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
* - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
* - Patch and build tag differences are not considered at this time
*
* @param version version of the API requesting an instance of the global API
*/
const isCompatible = _makeCompatibilityCheck(VERSION$1);
const major = VERSION$1.split(".")[0];
const GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for(`opentelemetry.js.api.${major}`);
const _global = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof global === "object" ? global : {};
function registerGlobal(type, instance, diag, allowOverride = false) {
	var _a;
	const api = _global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : { version: VERSION$1 };
	if (!allowOverride && api[type]) {
		const err = /* @__PURE__ */ new Error(`@opentelemetry/api: Attempted duplicate registration of API: ${type}`);
		diag.error(err.stack || err.message);
		return false;
	}
	if (api.version !== "1.9.1") {
		const err = /* @__PURE__ */ new Error(`@opentelemetry/api: Registration of version v${api.version} for ${type} does not match previously registered API v${VERSION$1}`);
		diag.error(err.stack || err.message);
		return false;
	}
	api[type] = instance;
	diag.debug(`@opentelemetry/api: Registered a global for ${type} v${VERSION$1}.`);
	return true;
}
function getGlobal(type) {
	var _a, _b;
	const globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
	if (!globalVersion || !isCompatible(globalVersion)) return;
	return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal(type, diag) {
	diag.debug(`@opentelemetry/api: Unregistering a global for ${type} v${VERSION$1}.`);
	const api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
	if (api) delete api[type];
}
/**
* Component Logger which is meant to be used as part of any component which
* will add automatically additional namespace in front of the log message.
* It will then forward all message to global diag logger
* @example
* const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
* cLogger.debug('test');
* // @opentelemetry/instrumentation-http test
*/
var DiagComponentLogger = class {
	constructor(props) {
		this._namespace = props.namespace || "DiagComponentLogger";
	}
	debug(...args) {
		return logProxy("debug", this._namespace, args);
	}
	error(...args) {
		return logProxy("error", this._namespace, args);
	}
	info(...args) {
		return logProxy("info", this._namespace, args);
	}
	warn(...args) {
		return logProxy("warn", this._namespace, args);
	}
	verbose(...args) {
		return logProxy("verbose", this._namespace, args);
	}
};
function logProxy(funcName, namespace, args) {
	const logger = getGlobal("diag");
	if (!logger) return;
	return logger[funcName](namespace, ...args);
}
/**
* Defines the available internal logging levels for the diagnostic logger, the numeric values
* of the levels are defined to match the original values from the initial LogLevel to avoid
* compatibility/migration issues for any implementation that assume the numeric ordering.
*/
var DiagLogLevel;
(function(DiagLogLevel) {
	/** Diagnostic Logging level setting to disable all logging (except and forced logs) */
	DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
	/** Identifies an error scenario */
	DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
	/** Identifies a warning scenario */
	DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
	/** General informational log message */
	DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
	/** General debug log message */
	DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
	/**
	* Detailed trace level logging should only be used for development, should only be set
	* in a development environment.
	*/
	DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
	/** Used to set the logging level to include all logging */
	DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel || (DiagLogLevel = {}));
function createLogLevelDiagLogger(maxLevel, logger) {
	if (maxLevel < DiagLogLevel.NONE) maxLevel = DiagLogLevel.NONE;
	else if (maxLevel > DiagLogLevel.ALL) maxLevel = DiagLogLevel.ALL;
	logger = logger || {};
	function _filterFunc(funcName, theLevel) {
		const theFunc = logger[funcName];
		if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger);
		return function() {};
	}
	return {
		error: _filterFunc("error", DiagLogLevel.ERROR),
		warn: _filterFunc("warn", DiagLogLevel.WARN),
		info: _filterFunc("info", DiagLogLevel.INFO),
		debug: _filterFunc("debug", DiagLogLevel.DEBUG),
		verbose: _filterFunc("verbose", DiagLogLevel.VERBOSE)
	};
}
const API_NAME$2 = "diag";
/**
* Singleton object which represents the entry point to the OpenTelemetry internal
* diagnostic API
*
* @since 1.0.0
*/
var DiagAPI = class DiagAPI {
	/** Get the singleton instance of the DiagAPI API */
	static instance() {
		if (!this._instance) this._instance = new DiagAPI();
		return this._instance;
	}
	/**
	* Private internal constructor
	* @private
	*/
	constructor() {
		function _logProxy(funcName) {
			return function(...args) {
				const logger = getGlobal("diag");
				if (!logger) return;
				return logger[funcName](...args);
			};
		}
		const self = this;
		const setLogger = (logger, optionsOrLogLevel = { logLevel: DiagLogLevel.INFO }) => {
			var _a, _b, _c;
			if (logger === self) {
				const err = /* @__PURE__ */ new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
				self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
				return false;
			}
			if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = { logLevel: optionsOrLogLevel };
			const oldLogger = getGlobal("diag");
			const newLogger = createLogLevelDiagLogger((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : DiagLogLevel.INFO, logger);
			if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
				const stack = (_c = (/* @__PURE__ */ new Error()).stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
				oldLogger.warn(`Current logger will be overwritten from ${stack}`);
				newLogger.warn(`Current logger will overwrite one already registered from ${stack}`);
			}
			return registerGlobal("diag", newLogger, self, true);
		};
		self.setLogger = setLogger;
		self.disable = () => {
			unregisterGlobal(API_NAME$2, self);
		};
		self.createComponentLogger = (options) => {
			return new DiagComponentLogger(options);
		};
		self.verbose = _logProxy("verbose");
		self.debug = _logProxy("debug");
		self.info = _logProxy("info");
		self.warn = _logProxy("warn");
		self.error = _logProxy("error");
	}
};
/**
* Get a key to uniquely identify a context value
*
* @since 1.0.0
*/
function createContextKey(description) {
	return Symbol.for(description);
}
/**
* The root context is used as the default parent context when there is no active context
*
* @since 1.0.0
*/
const ROOT_CONTEXT = new class BaseContext {
	/**
	* Construct a new context which inherits values from an optional parent context.
	*
	* @param parentContext a context from which to inherit values
	*/
	constructor(parentContext) {
		const self = this;
		self._currentContext = parentContext ? new Map(parentContext) : /* @__PURE__ */ new Map();
		self.getValue = (key) => self._currentContext.get(key);
		self.setValue = (key, value) => {
			const context = new BaseContext(self._currentContext);
			context._currentContext.set(key, value);
			return context;
		};
		self.deleteValue = (key) => {
			const context = new BaseContext(self._currentContext);
			context._currentContext.delete(key);
			return context;
		};
	}
}();
var NoopContextManager = class {
	active() {
		return ROOT_CONTEXT;
	}
	with(_context, fn, thisArg, ...args) {
		return fn.call(thisArg, ...args);
	}
	bind(_context, target) {
		return target;
	}
	enable() {
		return this;
	}
	disable() {
		return this;
	}
};
const API_NAME$1 = "context";
const NOOP_CONTEXT_MANAGER = new NoopContextManager();
/**
* Singleton object which represents the entry point to the OpenTelemetry Context API
*
* @since 1.0.0
*/
var ContextAPI = class ContextAPI {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	constructor() {}
	/** Get the singleton instance of the Context API */
	static getInstance() {
		if (!this._instance) this._instance = new ContextAPI();
		return this._instance;
	}
	/**
	* Set the current context manager.
	*
	* @returns true if the context manager was successfully registered, else false
	*/
	setGlobalContextManager(contextManager) {
		return registerGlobal(API_NAME$1, contextManager, DiagAPI.instance());
	}
	/**
	* Get the currently active context
	*/
	active() {
		return this._getContextManager().active();
	}
	/**
	* Execute a function with an active context
	*
	* @param context context to be active during function execution
	* @param fn function to execute in a context
	* @param thisArg optional receiver to be used for calling fn
	* @param args optional arguments forwarded to fn
	*/
	with(context, fn, thisArg, ...args) {
		return this._getContextManager().with(context, fn, thisArg, ...args);
	}
	/**
	* Bind a context to a target function or event emitter
	*
	* @param context context to bind to the event emitter or function. Defaults to the currently active context
	* @param target function or event emitter to bind
	*/
	bind(context, target) {
		return this._getContextManager().bind(context, target);
	}
	_getContextManager() {
		return getGlobal(API_NAME$1) || NOOP_CONTEXT_MANAGER;
	}
	/** Disable and remove the global context manager */
	disable() {
		this._getContextManager().disable();
		unregisterGlobal(API_NAME$1, DiagAPI.instance());
	}
};
/**
* @since 1.0.0
*/
var TraceFlags;
(function(TraceFlags) {
	/** Represents no flag set. */
	TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
	/** Bit to represent whether trace is sampled in trace flags. */
	TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags || (TraceFlags = {}));
/**
* @since 1.0.0
*/
const INVALID_SPAN_CONTEXT = {
	traceId: "00000000000000000000000000000000",
	spanId: "0000000000000000",
	traceFlags: TraceFlags.NONE
};
/**
* The NonRecordingSpan is the default {@link Span} that is used when no Span
* implementation is available. All operations are no-op including context
* propagation.
*/
var NonRecordingSpan = class {
	constructor(spanContext = INVALID_SPAN_CONTEXT) {
		this._spanContext = spanContext;
	}
	spanContext() {
		return this._spanContext;
	}
	setAttribute(_key, _value) {
		return this;
	}
	setAttributes(_attributes) {
		return this;
	}
	addEvent(_name, _attributes) {
		return this;
	}
	addLink(_link) {
		return this;
	}
	addLinks(_links) {
		return this;
	}
	setStatus(_status) {
		return this;
	}
	updateName(_name) {
		return this;
	}
	end(_endTime) {}
	isRecording() {
		return false;
	}
	recordException(_exception, _time) {}
};
/**
* span key
*/
const SPAN_KEY = createContextKey("OpenTelemetry Context Key SPAN");
/**
* Return the span if one exists
*
* @param context context to get span from
*/
function getSpan(context) {
	return context.getValue(SPAN_KEY) || void 0;
}
/**
* Gets the span from the current context, if one exists.
*/
function getActiveSpan() {
	return getSpan(ContextAPI.getInstance().active());
}
/**
* Set the span on a context
*
* @param context context to use as parent
* @param span span to set active
*/
function setSpan(context, span) {
	return context.setValue(SPAN_KEY, span);
}
/**
* Remove current span stored in the context
*
* @param context context to delete span from
*/
function deleteSpan(context) {
	return context.deleteValue(SPAN_KEY);
}
/**
* Wrap span context in a NoopSpan and set as span in a new
* context
*
* @param context context to set active span on
* @param spanContext span context to be wrapped
*/
function setSpanContext(context, spanContext) {
	return setSpan(context, new NonRecordingSpan(spanContext));
}
/**
* Get the span context of the span if it exists.
*
* @param context context to get values from
*/
function getSpanContext(context) {
	var _a;
	return (_a = getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}
const isHex = new Uint8Array([
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	1,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	1,
	1,
	1,
	1,
	1,
	1,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	1,
	1,
	1,
	1,
	1,
	1
]);
function isValidHex(id, length) {
	if (typeof id !== "string" || id.length !== length) return false;
	let r = 0;
	for (let i = 0; i < id.length; i += 4) r += (isHex[id.charCodeAt(i)] | 0) + (isHex[id.charCodeAt(i + 1)] | 0) + (isHex[id.charCodeAt(i + 2)] | 0) + (isHex[id.charCodeAt(i + 3)] | 0);
	return r === length;
}
/**
* @since 1.0.0
*/
function isValidTraceId(traceId) {
	return isValidHex(traceId, 32) && traceId !== "00000000000000000000000000000000";
}
/**
* @since 1.0.0
*/
function isValidSpanId(spanId) {
	return isValidHex(spanId, 16) && spanId !== "0000000000000000";
}
/**
* Returns true if this {@link SpanContext} is valid.
* @return true if this {@link SpanContext} is valid.
*
* @since 1.0.0
*/
function isSpanContextValid(spanContext) {
	return isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId);
}
/**
* Wrap the given {@link SpanContext} in a new non-recording {@link Span}
*
* @param spanContext span context to be wrapped
* @returns a new non-recording {@link Span} with the provided context
*/
function wrapSpanContext(spanContext) {
	return new NonRecordingSpan(spanContext);
}
const contextApi = ContextAPI.getInstance();
/**
* No-op implementations of {@link Tracer}.
*/
var NoopTracer = class {
	startSpan(name, options, context = contextApi.active()) {
		if (Boolean(options === null || options === void 0 ? void 0 : options.root)) return new NonRecordingSpan();
		const parentFromContext = context && getSpanContext(context);
		if (isSpanContext(parentFromContext) && isSpanContextValid(parentFromContext)) return new NonRecordingSpan(parentFromContext);
		else return new NonRecordingSpan();
	}
	startActiveSpan(name, arg2, arg3, arg4) {
		let opts;
		let ctx;
		let fn;
		if (arguments.length < 2) return;
		else if (arguments.length === 2) fn = arg2;
		else if (arguments.length === 3) {
			opts = arg2;
			fn = arg3;
		} else {
			opts = arg2;
			ctx = arg3;
			fn = arg4;
		}
		const parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi.active();
		const span = this.startSpan(name, opts, parentContext);
		const contextWithSpanSet = setSpan(parentContext, span);
		return contextApi.with(contextWithSpanSet, fn, void 0, span);
	}
};
function isSpanContext(spanContext) {
	return spanContext !== null && typeof spanContext === "object" && "spanId" in spanContext && typeof spanContext["spanId"] === "string" && "traceId" in spanContext && typeof spanContext["traceId"] === "string" && "traceFlags" in spanContext && typeof spanContext["traceFlags"] === "number";
}
const NOOP_TRACER = new NoopTracer();
/**
* Proxy tracer provided by the proxy tracer provider
*
* @since 1.0.0
*/
var ProxyTracer = class {
	constructor(provider, name, version, options) {
		this._provider = provider;
		this.name = name;
		this.version = version;
		this.options = options;
	}
	startSpan(name, options, context) {
		return this._getTracer().startSpan(name, options, context);
	}
	startActiveSpan(_name, _options, _context, _fn) {
		const tracer = this._getTracer();
		return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
	}
	/**
	* Try to get a tracer from the proxy tracer provider.
	* If the proxy tracer provider has no delegate, return a noop tracer.
	*/
	_getTracer() {
		if (this._delegate) return this._delegate;
		const tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
		if (!tracer) return NOOP_TRACER;
		this._delegate = tracer;
		return this._delegate;
	}
};
/**
* An implementation of the {@link TracerProvider} which returns an impotent
* Tracer for all calls to `getTracer`.
*
* All operations are no-op.
*/
var NoopTracerProvider = class {
	getTracer(_name, _version, _options) {
		return new NoopTracer();
	}
};
const NOOP_TRACER_PROVIDER = new NoopTracerProvider();
/**
* Tracer provider which provides {@link ProxyTracer}s.
*
* Before a delegate is set, tracers provided are NoOp.
*   When a delegate is set, traces are provided from the delegate.
*   When a delegate is set after tracers have already been provided,
*   all tracers already provided will use the provided delegate implementation.
*
* @deprecated This will be removed in the next major version.
* @since 1.0.0
*/
var ProxyTracerProvider = class {
	/**
	* Get a {@link ProxyTracer}
	*/
	getTracer(name, version, options) {
		var _a;
		return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new ProxyTracer(this, name, version, options);
	}
	getDelegate() {
		var _a;
		return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
	}
	/**
	* Set the delegate tracer provider
	*/
	setDelegate(delegate) {
		this._delegate = delegate;
	}
	getDelegateTracer(name, version, options) {
		var _a;
		return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
	}
};
/**
* An enumeration of status codes.
*
* @since 1.0.0
*/
var SpanStatusCode;
(function(SpanStatusCode) {
	/**
	* The default status.
	*/
	SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
	/**
	* The operation has been validated by an Application developer or
	* Operator to have completed successfully.
	*/
	SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
	/**
	* The operation contains an error.
	*/
	SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})(SpanStatusCode || (SpanStatusCode = {}));
/**
* Entrypoint for context API
* @since 1.0.0
*/
const context = ContextAPI.getInstance();
const API_NAME = "trace";
/**
* Entrypoint for trace API
*
* @since 1.0.0
*/
const trace = class TraceAPI {
	/** Empty private constructor prevents end users from constructing a new instance of the API */
	constructor() {
		this._proxyTracerProvider = new ProxyTracerProvider();
		this.wrapSpanContext = wrapSpanContext;
		this.isSpanContextValid = isSpanContextValid;
		this.deleteSpan = deleteSpan;
		this.getSpan = getSpan;
		this.getActiveSpan = getActiveSpan;
		this.getSpanContext = getSpanContext;
		this.setSpan = setSpan;
		this.setSpanContext = setSpanContext;
	}
	/** Get the singleton instance of the Trace API */
	static getInstance() {
		if (!this._instance) this._instance = new TraceAPI();
		return this._instance;
	}
	/**
	* Set the current global tracer.
	*
	* @returns true if the tracer provider was successfully registered, else false
	*/
	setGlobalTracerProvider(provider) {
		const success = registerGlobal(API_NAME, this._proxyTracerProvider, DiagAPI.instance());
		if (success) this._proxyTracerProvider.setDelegate(provider);
		return success;
	}
	/**
	* Returns the global tracer provider.
	*/
	getTracerProvider() {
		return getGlobal(API_NAME) || this._proxyTracerProvider;
	}
	/**
	* Returns a tracer from the global tracer provider.
	*/
	getTracer(name, version) {
		return this.getTracerProvider().getTracer(name, version);
	}
	/** Remove the global tracer provider */
	disable() {
		unregisterGlobal(API_NAME, DiagAPI.instance());
		this._proxyTracerProvider = new ProxyTracerProvider();
	}
}.getInstance();
var __defProp = Object.defineProperty;
var __export = (target, all) => {
	for (var name22 in all) __defProp(target, name22, {
		get: all[name22],
		enumerable: true
	});
};
var name = "AI_InvalidArgumentError";
var marker = `vercel.ai.error.${name}`;
var symbol = Symbol.for(marker);
var _a;
var InvalidArgumentError = class extends AISDKError {
	constructor({ parameter, value, message }) {
		super({
			name,
			message: `Invalid argument for parameter ${parameter}: ${message}`
		});
		this[_a] = true;
		this.parameter = parameter;
		this.value = value;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker);
	}
};
_a = symbol;
var name9 = "AI_NoObjectGeneratedError";
var marker9 = `vercel.ai.error.${name9}`;
var symbol9 = Symbol.for(marker9);
var _a9;
var NoObjectGeneratedError = class extends AISDKError {
	constructor({ message = "No object generated.", cause, text: text2, response, usage, finishReason }) {
		super({
			name: name9,
			message,
			cause
		});
		this[_a9] = true;
		this.text = text2;
		this.response = response;
		this.usage = usage;
		this.finishReason = finishReason;
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker9);
	}
};
_a9 = symbol9;
var UnsupportedModelVersionError = class extends AISDKError {
	constructor(options) {
		super({
			name: "AI_UnsupportedModelVersionError",
			message: `Unsupported model version ${options.version} for provider "${options.provider}" and model "${options.modelId}". AI SDK 5 only supports models that implement specification version "v2".`
		});
		this.version = options.version;
		this.provider = options.provider;
		this.modelId = options.modelId;
	}
};
var name20 = "AI_RetryError";
var marker20 = `vercel.ai.error.${name20}`;
var symbol20 = Symbol.for(marker20);
var _a20;
var RetryError = class extends AISDKError {
	constructor({ message, reason, errors }) {
		super({
			name: name20,
			message
		});
		this[_a20] = true;
		this.reason = reason;
		this.errors = errors;
		this.lastError = errors[errors.length - 1];
	}
	static isInstance(error) {
		return AISDKError.hasMarker(error, marker20);
	}
};
_a20 = symbol20;
function formatWarning({ warning, provider, model }) {
	const prefix = `AI SDK Warning (${provider} / ${model}):`;
	switch (warning.type) {
		case "unsupported": {
			let message = `${prefix} The feature "${warning.feature}" is not supported.`;
			if (warning.details) message += ` ${warning.details}`;
			return message;
		}
		case "compatibility": {
			let message = `${prefix} The feature "${warning.feature}" is used in a compatibility mode.`;
			if (warning.details) message += ` ${warning.details}`;
			return message;
		}
		case "other": return `${prefix} ${warning.message}`;
		default: return `${prefix} ${JSON.stringify(warning, null, 2)}`;
	}
}
var FIRST_WARNING_INFO_MESSAGE = "AI SDK Warning System: To turn off warning logging, set the AI_SDK_LOG_WARNINGS global to false.";
var hasLoggedBefore = false;
var logWarnings = (options) => {
	if (options.warnings.length === 0) return;
	const logger = globalThis.AI_SDK_LOG_WARNINGS;
	if (logger === false) return;
	if (typeof logger === "function") {
		logger(options);
		return;
	}
	if (!hasLoggedBefore) {
		hasLoggedBefore = true;
		console.info(FIRST_WARNING_INFO_MESSAGE);
	}
	for (const warning of options.warnings) console.warn(formatWarning({
		warning,
		provider: options.provider,
		model: options.model
	}));
};
function logV2CompatibilityWarning({ provider, modelId }) {
	logWarnings({
		warnings: [{
			type: "compatibility",
			feature: "specificationVersion",
			details: `Using v2 specification compatibility mode. Some features may not be available.`
		}],
		provider,
		model: modelId
	});
}
function asEmbeddingModelV3(model) {
	if (model.specificationVersion === "v3") return model;
	logV2CompatibilityWarning({
		provider: model.provider,
		modelId: model.modelId
	});
	return new Proxy(model, { get(target, prop) {
		if (prop === "specificationVersion") return "v3";
		return target[prop];
	} });
}
function resolveEmbeddingModel(model) {
	if (typeof model !== "string") {
		if (model.specificationVersion !== "v3" && model.specificationVersion !== "v2") {
			const unsupportedModel = model;
			throw new UnsupportedModelVersionError({
				version: unsupportedModel.specificationVersion,
				provider: unsupportedModel.provider,
				modelId: unsupportedModel.modelId
			});
		}
		return asEmbeddingModelV3(model);
	}
	return getGlobalProvider().embeddingModel(model);
}
function getGlobalProvider() {
	var _a22;
	return (_a22 = globalThis.AI_SDK_DEFAULT_PROVIDER) != null ? _a22 : gateway;
}
function getTotalTimeoutMs(timeout) {
	if (timeout == null) return;
	if (typeof timeout === "number") return timeout;
	return timeout.totalMs;
}
var VERSION = "6.0.230";
var dataContentSchema = z$1.union([
	z$1.string(),
	z$1.instanceof(Uint8Array),
	z$1.instanceof(ArrayBuffer),
	z$1.custom((value) => {
		var _a22, _b;
		return (_b = (_a22 = globalThis.Buffer) == null ? void 0 : _a22.isBuffer(value)) != null ? _b : false;
	}, { message: "Must be a Buffer" })
]);
var jsonValueSchema = z$1.lazy(() => z$1.union([
	z$1.null(),
	z$1.string(),
	z$1.number(),
	z$1.boolean(),
	z$1.record(z$1.string(), jsonValueSchema.optional()),
	z$1.array(jsonValueSchema)
]));
var providerMetadataSchema = z$1.record(z$1.string(), z$1.record(z$1.string(), jsonValueSchema.optional()));
var textPartSchema = z$1.object({
	type: z$1.literal("text"),
	text: z$1.string(),
	providerOptions: providerMetadataSchema.optional()
});
var imagePartSchema = z$1.object({
	type: z$1.literal("image"),
	image: z$1.union([dataContentSchema, z$1.instanceof(URL)]),
	mediaType: z$1.string().optional(),
	providerOptions: providerMetadataSchema.optional()
});
var filePartSchema = z$1.object({
	type: z$1.literal("file"),
	data: z$1.union([dataContentSchema, z$1.instanceof(URL)]),
	filename: z$1.string().optional(),
	mediaType: z$1.string(),
	providerOptions: providerMetadataSchema.optional()
});
var reasoningPartSchema = z$1.object({
	type: z$1.literal("reasoning"),
	text: z$1.string(),
	providerOptions: providerMetadataSchema.optional()
});
var toolCallPartSchema = z$1.object({
	type: z$1.literal("tool-call"),
	toolCallId: z$1.string(),
	toolName: z$1.string(),
	input: z$1.unknown(),
	providerOptions: providerMetadataSchema.optional(),
	providerExecuted: z$1.boolean().optional()
});
var outputSchema = z$1.discriminatedUnion("type", [
	z$1.object({
		type: z$1.literal("text"),
		value: z$1.string(),
		providerOptions: providerMetadataSchema.optional()
	}),
	z$1.object({
		type: z$1.literal("json"),
		value: jsonValueSchema,
		providerOptions: providerMetadataSchema.optional()
	}),
	z$1.object({
		type: z$1.literal("execution-denied"),
		reason: z$1.string().optional(),
		providerOptions: providerMetadataSchema.optional()
	}),
	z$1.object({
		type: z$1.literal("error-text"),
		value: z$1.string(),
		providerOptions: providerMetadataSchema.optional()
	}),
	z$1.object({
		type: z$1.literal("error-json"),
		value: jsonValueSchema,
		providerOptions: providerMetadataSchema.optional()
	}),
	z$1.object({
		type: z$1.literal("content"),
		value: z$1.array(z$1.union([
			z$1.object({
				type: z$1.literal("text"),
				text: z$1.string(),
				providerOptions: providerMetadataSchema.optional()
			}),
			z$1.object({
				type: z$1.literal("media"),
				data: z$1.string(),
				mediaType: z$1.string()
			}),
			z$1.object({
				type: z$1.literal("file-data"),
				data: z$1.string(),
				mediaType: z$1.string(),
				filename: z$1.string().optional(),
				providerOptions: providerMetadataSchema.optional()
			}),
			z$1.object({
				type: z$1.literal("file-url"),
				url: z$1.string(),
				providerOptions: providerMetadataSchema.optional()
			}),
			z$1.object({
				type: z$1.literal("file-id"),
				fileId: z$1.union([z$1.string(), z$1.record(z$1.string(), z$1.string())]),
				providerOptions: providerMetadataSchema.optional()
			}),
			z$1.object({
				type: z$1.literal("image-data"),
				data: z$1.string(),
				mediaType: z$1.string(),
				providerOptions: providerMetadataSchema.optional()
			}),
			z$1.object({
				type: z$1.literal("image-url"),
				url: z$1.string(),
				providerOptions: providerMetadataSchema.optional()
			}),
			z$1.object({
				type: z$1.literal("image-file-id"),
				fileId: z$1.union([z$1.string(), z$1.record(z$1.string(), z$1.string())]),
				providerOptions: providerMetadataSchema.optional()
			}),
			z$1.object({
				type: z$1.literal("custom"),
				providerOptions: providerMetadataSchema.optional()
			})
		]))
	})
]);
var toolResultPartSchema = z$1.object({
	type: z$1.literal("tool-result"),
	toolCallId: z$1.string(),
	toolName: z$1.string(),
	output: outputSchema,
	providerOptions: providerMetadataSchema.optional()
});
var toolApprovalRequestSchema = z$1.object({
	type: z$1.literal("tool-approval-request"),
	approvalId: z$1.string(),
	toolCallId: z$1.string()
});
var toolApprovalResponseSchema = z$1.object({
	type: z$1.literal("tool-approval-response"),
	approvalId: z$1.string(),
	approved: z$1.boolean(),
	reason: z$1.string().optional()
});
var systemModelMessageSchema = z$1.object({
	role: z$1.literal("system"),
	content: z$1.string(),
	providerOptions: providerMetadataSchema.optional()
});
var userModelMessageSchema = z$1.object({
	role: z$1.literal("user"),
	content: z$1.union([z$1.string(), z$1.array(z$1.union([
		textPartSchema,
		imagePartSchema,
		filePartSchema
	]))]),
	providerOptions: providerMetadataSchema.optional()
});
var assistantModelMessageSchema = z$1.object({
	role: z$1.literal("assistant"),
	content: z$1.union([z$1.string(), z$1.array(z$1.union([
		textPartSchema,
		filePartSchema,
		reasoningPartSchema,
		toolCallPartSchema,
		toolResultPartSchema,
		toolApprovalRequestSchema
	]))]),
	providerOptions: providerMetadataSchema.optional()
});
var toolModelMessageSchema = z$1.object({
	role: z$1.literal("tool"),
	content: z$1.array(z$1.union([toolResultPartSchema, toolApprovalResponseSchema])),
	providerOptions: providerMetadataSchema.optional()
});
z$1.union([
	systemModelMessageSchema,
	userModelMessageSchema,
	assistantModelMessageSchema,
	toolModelMessageSchema
]);
function assembleOperationName({ operationId, telemetry }) {
	return {
		"operation.name": `${operationId}${(telemetry == null ? void 0 : telemetry.functionId) != null ? ` ${telemetry.functionId}` : ""}`,
		"resource.name": telemetry == null ? void 0 : telemetry.functionId,
		"ai.operationId": operationId,
		"ai.telemetry.functionId": telemetry == null ? void 0 : telemetry.functionId
	};
}
function getBaseTelemetryAttributes({ model, settings, telemetry, headers }) {
	var _a22;
	return {
		"ai.model.provider": model.provider,
		"ai.model.id": model.modelId,
		...Object.entries(settings).reduce((attributes, [key, value]) => {
			if (key === "timeout") {
				const totalTimeoutMs = getTotalTimeoutMs(value);
				if (totalTimeoutMs != null) attributes[`ai.settings.${key}`] = totalTimeoutMs;
			} else attributes[`ai.settings.${key}`] = value;
			return attributes;
		}, {}),
		...Object.entries((_a22 = telemetry == null ? void 0 : telemetry.metadata) != null ? _a22 : {}).reduce((attributes, [key, value]) => {
			attributes[`ai.telemetry.metadata.${key}`] = value;
			return attributes;
		}, {}),
		...Object.entries(headers != null ? headers : {}).reduce((attributes, [key, value]) => {
			if (value !== void 0) attributes[`ai.request.headers.${key}`] = value;
			return attributes;
		}, {})
	};
}
var noopTracer = {
	startSpan() {
		return noopSpan;
	},
	startActiveSpan(name22, arg1, arg2, arg3) {
		if (typeof arg1 === "function") return arg1(noopSpan);
		if (typeof arg2 === "function") return arg2(noopSpan);
		if (typeof arg3 === "function") return arg3(noopSpan);
	}
};
var noopSpan = {
	spanContext() {
		return noopSpanContext;
	},
	setAttribute() {
		return this;
	},
	setAttributes() {
		return this;
	},
	addEvent() {
		return this;
	},
	addLink() {
		return this;
	},
	addLinks() {
		return this;
	},
	setStatus() {
		return this;
	},
	updateName() {
		return this;
	},
	end() {
		return this;
	},
	isRecording() {
		return false;
	},
	recordException() {
		return this;
	}
};
var noopSpanContext = {
	traceId: "",
	spanId: "",
	traceFlags: 0
};
function getTracer({ isEnabled = false, tracer } = {}) {
	if (!isEnabled) return noopTracer;
	if (tracer) return tracer;
	return trace.getTracer("ai");
}
async function recordSpan({ name: name22, tracer, attributes, fn, endWhenDone = true }) {
	return tracer.startActiveSpan(name22, { attributes: await attributes }, async (span) => {
		const ctx = context.active();
		try {
			const result = await context.with(ctx, () => fn(span));
			if (endWhenDone) span.end();
			return result;
		} catch (error) {
			try {
				recordErrorOnSpan(span, error);
			} finally {
				span.end();
			}
			throw error;
		}
	});
}
function recordErrorOnSpan(span, error) {
	if (error instanceof Error) {
		span.recordException({
			name: error.name,
			message: error.message,
			stack: error.stack
		});
		span.setStatus({
			code: SpanStatusCode.ERROR,
			message: error.message
		});
	} else span.setStatus({ code: SpanStatusCode.ERROR });
}
function isPrimitiveAttributeValue(value) {
	return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
}
function sanitizeAttributeValue(value) {
	if (!Array.isArray(value)) return value;
	const primitiveTypes = new Set(value.filter(isPrimitiveAttributeValue).map((item) => typeof item));
	if (primitiveTypes.size !== 1) return;
	const [primitiveType] = primitiveTypes;
	if (primitiveType === "string") return value.filter((item) => typeof item === "string");
	if (primitiveType === "number") return value.filter((item) => typeof item === "number");
	return value.filter((item) => typeof item === "boolean");
}
async function selectTelemetryAttributes({ telemetry, attributes }) {
	if ((telemetry == null ? void 0 : telemetry.isEnabled) !== true) return {};
	const resultAttributes = {};
	for (const [key, value] of Object.entries(attributes)) {
		if (value == null) continue;
		if (typeof value === "object" && "input" in value && typeof value.input === "function") {
			if ((telemetry == null ? void 0 : telemetry.recordInputs) === false) continue;
			const result = await value.input();
			if (result != null) {
				const sanitized2 = sanitizeAttributeValue(result);
				if (sanitized2 != null) resultAttributes[key] = sanitized2;
			}
			continue;
		}
		if (typeof value === "object" && "output" in value && typeof value.output === "function") {
			if ((telemetry == null ? void 0 : telemetry.recordOutputs) === false) continue;
			const result = await value.output();
			if (result != null) {
				const sanitized2 = sanitizeAttributeValue(result);
				if (sanitized2 != null) resultAttributes[key] = sanitized2;
			}
			continue;
		}
		const sanitized = sanitizeAttributeValue(value);
		if (sanitized != null) resultAttributes[key] = sanitized;
	}
	return resultAttributes;
}
function getRetryDelayInMs({ error, exponentialBackoffDelay }) {
	const headers = APICallError.isInstance(error) ? error.responseHeaders : APICallError.isInstance(error.cause) ? error.cause.responseHeaders : void 0;
	if (!headers) return exponentialBackoffDelay;
	let ms;
	const retryAfterMs = headers["retry-after-ms"];
	if (retryAfterMs) {
		const timeoutMs = parseFloat(retryAfterMs);
		if (!Number.isNaN(timeoutMs)) ms = timeoutMs;
	}
	const retryAfter = headers["retry-after"];
	if (retryAfter && ms === void 0) {
		const timeoutSeconds = parseFloat(retryAfter);
		if (!Number.isNaN(timeoutSeconds)) ms = timeoutSeconds * 1e3;
		else ms = Date.parse(retryAfter) - Date.now();
	}
	if (ms != null && !Number.isNaN(ms) && 0 <= ms && (ms < 60 * 1e3 || ms < exponentialBackoffDelay)) return ms;
	return exponentialBackoffDelay;
}
var retryWithExponentialBackoffRespectingRetryHeaders = ({ maxRetries = 2, initialDelayInMs = 2e3, backoffFactor = 2, abortSignal } = {}) => retryWithExponentialBackoff({
	maxRetries,
	initialDelayInMs,
	backoffFactor,
	abortSignal,
	shouldRetry: (error) => error instanceof Error && (APICallError.isInstance(error) && error.isRetryable === true || GatewayError.isInstance(error) && error.isRetryable === true),
	getDelayInMs: ({ error, exponentialBackoffDelay }) => getRetryDelayInMs({
		error,
		exponentialBackoffDelay
	}),
	createRetryError: ({ message, reason, errors }) => new RetryError({
		message,
		reason,
		errors
	})
});
function prepareRetries({ maxRetries, abortSignal }) {
	if (maxRetries != null) {
		if (!Number.isInteger(maxRetries)) throw new InvalidArgumentError({
			parameter: "maxRetries",
			value: maxRetries,
			message: "maxRetries must be an integer"
		});
		if (maxRetries < 0) throw new InvalidArgumentError({
			parameter: "maxRetries",
			value: maxRetries,
			message: "maxRetries must be >= 0"
		});
	}
	const maxRetriesResult = maxRetries != null ? maxRetries : 2;
	return {
		maxRetries: maxRetriesResult,
		retry: retryWithExponentialBackoffRespectingRetryHeaders({
			maxRetries: maxRetriesResult,
			abortSignal
		})
	};
}
new TextEncoder();
__export({}, {
	array: () => array,
	choice: () => choice,
	json: () => json,
	object: () => object,
	text: () => text
});
function fixJson(input) {
	const stack = ["ROOT"];
	let lastValidIndex = -1;
	let literalStart = null;
	let unicodeEscapeDigits = 0;
	function isHexDigit(char) {
		return char >= "0" && char <= "9" || char >= "A" && char <= "F" || char >= "a" && char <= "f";
	}
	function processValueStart(char, i, swapState) {
		switch (char) {
			case "\"":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_STRING");
				break;
			case "f":
			case "t":
			case "n":
				lastValidIndex = i;
				literalStart = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_LITERAL");
				break;
			case "-":
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "0":
			case "1":
			case "2":
			case "3":
			case "4":
			case "5":
			case "6":
			case "7":
			case "8":
			case "9":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_NUMBER");
				break;
			case "{":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_OBJECT_START");
				break;
			case "[":
				lastValidIndex = i;
				stack.pop();
				stack.push(swapState);
				stack.push("INSIDE_ARRAY_START");
				break;
		}
	}
	function processAfterObjectValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_OBJECT_AFTER_COMMA");
				break;
			case "}":
				lastValidIndex = i;
				stack.pop();
				break;
		}
	}
	function processAfterArrayValue(char, i) {
		switch (char) {
			case ",":
				stack.pop();
				stack.push("INSIDE_ARRAY_AFTER_COMMA");
				break;
			case "]":
				lastValidIndex = i;
				stack.pop();
				break;
		}
	}
	for (let i = 0; i < input.length; i++) {
		const char = input[i];
		switch (stack[stack.length - 1]) {
			case "ROOT":
				processValueStart(char, i, "FINISH");
				break;
			case "INSIDE_OBJECT_START":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
						break;
					case "}":
						lastValidIndex = i;
						stack.pop();
						break;
				}
				break;
			case "INSIDE_OBJECT_AFTER_COMMA":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_KEY");
						break;
				}
				break;
			case "INSIDE_OBJECT_KEY":
				switch (char) {
					case "\"":
						stack.pop();
						stack.push("INSIDE_OBJECT_AFTER_KEY");
						break;
				}
				break;
			case "INSIDE_OBJECT_AFTER_KEY":
				switch (char) {
					case ":":
						stack.pop();
						stack.push("INSIDE_OBJECT_BEFORE_VALUE");
						break;
				}
				break;
			case "INSIDE_OBJECT_BEFORE_VALUE":
				processValueStart(char, i, "INSIDE_OBJECT_AFTER_VALUE");
				break;
			case "INSIDE_OBJECT_AFTER_VALUE":
				processAfterObjectValue(char, i);
				break;
			case "INSIDE_STRING":
				switch (char) {
					case "\"":
						stack.pop();
						lastValidIndex = i;
						break;
					case "\\":
						stack.push("INSIDE_STRING_ESCAPE");
						break;
					default: lastValidIndex = i;
				}
				break;
			case "INSIDE_ARRAY_START":
				switch (char) {
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default:
						lastValidIndex = i;
						processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
						break;
				}
				break;
			case "INSIDE_ARRAY_AFTER_VALUE":
				switch (char) {
					case ",":
						stack.pop();
						stack.push("INSIDE_ARRAY_AFTER_COMMA");
						break;
					case "]":
						lastValidIndex = i;
						stack.pop();
						break;
					default:
						lastValidIndex = i;
						break;
				}
				break;
			case "INSIDE_ARRAY_AFTER_COMMA":
				processValueStart(char, i, "INSIDE_ARRAY_AFTER_VALUE");
				break;
			case "INSIDE_STRING_ESCAPE":
				stack.pop();
				if (char === "u") {
					unicodeEscapeDigits = 0;
					stack.push("INSIDE_STRING_UNICODE_ESCAPE");
				} else lastValidIndex = i;
				break;
			case "INSIDE_STRING_UNICODE_ESCAPE":
				if (isHexDigit(char)) {
					unicodeEscapeDigits++;
					if (unicodeEscapeDigits === 4) {
						stack.pop();
						lastValidIndex = i;
					}
				}
				break;
			case "INSIDE_NUMBER":
				switch (char) {
					case "0":
					case "1":
					case "2":
					case "3":
					case "4":
					case "5":
					case "6":
					case "7":
					case "8":
					case "9":
						lastValidIndex = i;
						break;
					case "e":
					case "E":
					case "-":
					case ".": break;
					case ",":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "}":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
						break;
					case "]":
						stack.pop();
						if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
						break;
					default:
						stack.pop();
						break;
				}
				break;
			case "INSIDE_LITERAL": {
				const partialLiteral = input.substring(literalStart, i + 1);
				if (!"false".startsWith(partialLiteral) && !"true".startsWith(partialLiteral) && !"null".startsWith(partialLiteral)) {
					stack.pop();
					if (stack[stack.length - 1] === "INSIDE_OBJECT_AFTER_VALUE") processAfterObjectValue(char, i);
					else if (stack[stack.length - 1] === "INSIDE_ARRAY_AFTER_VALUE") processAfterArrayValue(char, i);
				} else lastValidIndex = i;
				break;
			}
		}
	}
	let result = input.slice(0, lastValidIndex + 1);
	for (let i = stack.length - 1; i >= 0; i--) switch (stack[i]) {
		case "INSIDE_STRING":
			result += "\"";
			break;
		case "INSIDE_OBJECT_KEY":
		case "INSIDE_OBJECT_AFTER_KEY":
		case "INSIDE_OBJECT_AFTER_COMMA":
		case "INSIDE_OBJECT_START":
		case "INSIDE_OBJECT_BEFORE_VALUE":
		case "INSIDE_OBJECT_AFTER_VALUE":
			result += "}";
			break;
		case "INSIDE_ARRAY_START":
		case "INSIDE_ARRAY_AFTER_COMMA":
		case "INSIDE_ARRAY_AFTER_VALUE":
			result += "]";
			break;
		case "INSIDE_LITERAL": {
			const partialLiteral = input.substring(literalStart, input.length);
			if ("true".startsWith(partialLiteral)) result += "true".slice(partialLiteral.length);
			else if ("false".startsWith(partialLiteral)) result += "false".slice(partialLiteral.length);
			else if ("null".startsWith(partialLiteral)) result += "null".slice(partialLiteral.length);
		}
	}
	return result;
}
async function parsePartialJson(jsonText) {
	if (jsonText === void 0) return {
		value: void 0,
		state: "undefined-input"
	};
	let result = await safeParseJSON({ text: jsonText });
	if (result.success) return {
		value: result.value,
		state: "successful-parse"
	};
	result = await safeParseJSON({ text: fixJson(jsonText) });
	if (result.success) return {
		value: result.value,
		state: "repaired-parse"
	};
	return {
		value: void 0,
		state: "failed-parse"
	};
}
var text = () => ({
	name: "text",
	responseFormat: Promise.resolve({ type: "text" }),
	async parseCompleteOutput({ text: text2 }) {
		return text2;
	},
	async parsePartialOutput({ text: text2 }) {
		return { partial: text2 };
	},
	createElementStreamTransform() {}
});
var object = ({ schema: inputSchema, name: name22, description }) => {
	const schema = asSchema(inputSchema);
	return {
		name: "object",
		responseFormat: resolve(schema.jsonSchema).then((jsonSchema2) => ({
			type: "json",
			schema: jsonSchema2,
			...name22 != null && { name: name22 },
			...description != null && { description }
		})),
		async parseCompleteOutput({ text: text2 }, context2) {
			const parseResult = await safeParseJSON({ text: text2 });
			if (!parseResult.success) throw new NoObjectGeneratedError({
				message: "No object generated: could not parse the response.",
				cause: parseResult.error,
				text: text2,
				response: context2.response,
				usage: context2.usage,
				finishReason: context2.finishReason
			});
			const validationResult = await safeValidateTypes({
				value: parseResult.value,
				schema
			});
			if (!validationResult.success) throw new NoObjectGeneratedError({
				message: "No object generated: response did not match schema.",
				cause: validationResult.error,
				text: text2,
				response: context2.response,
				usage: context2.usage,
				finishReason: context2.finishReason
			});
			return validationResult.value;
		},
		async parsePartialOutput({ text: text2 }) {
			const result = await parsePartialJson(text2);
			switch (result.state) {
				case "failed-parse":
				case "undefined-input": return;
				case "repaired-parse":
				case "successful-parse": return { partial: result.value };
			}
		},
		createElementStreamTransform() {}
	};
};
var array = ({ element: inputElementSchema, name: name22, description }) => {
	const elementSchema = asSchema(inputElementSchema);
	return {
		name: "array",
		responseFormat: resolve(elementSchema.jsonSchema).then((jsonSchema2) => {
			const { $schema, ...itemSchema } = jsonSchema2;
			return {
				type: "json",
				schema: {
					$schema: "http://json-schema.org/draft-07/schema#",
					type: "object",
					properties: { elements: {
						type: "array",
						items: itemSchema
					} },
					required: ["elements"],
					additionalProperties: false
				},
				...name22 != null && { name: name22 },
				...description != null && { description }
			};
		}),
		async parseCompleteOutput({ text: text2 }, context2) {
			const parseResult = await safeParseJSON({ text: text2 });
			if (!parseResult.success) throw new NoObjectGeneratedError({
				message: "No object generated: could not parse the response.",
				cause: parseResult.error,
				text: text2,
				response: context2.response,
				usage: context2.usage,
				finishReason: context2.finishReason
			});
			const outerValue = parseResult.value;
			if (outerValue == null || typeof outerValue !== "object" || !("elements" in outerValue) || !Array.isArray(outerValue.elements)) throw new NoObjectGeneratedError({
				message: "No object generated: response did not match schema.",
				cause: new TypeValidationError({
					value: outerValue,
					cause: "response must be an object with an elements array"
				}),
				text: text2,
				response: context2.response,
				usage: context2.usage,
				finishReason: context2.finishReason
			});
			const validatedElements = [];
			for (const element of outerValue.elements) {
				const validationResult = await safeValidateTypes({
					value: element,
					schema: elementSchema
				});
				if (!validationResult.success) throw new NoObjectGeneratedError({
					message: "No object generated: response did not match schema.",
					cause: validationResult.error,
					text: text2,
					response: context2.response,
					usage: context2.usage,
					finishReason: context2.finishReason
				});
				validatedElements.push(validationResult.value);
			}
			return validatedElements;
		},
		async parsePartialOutput({ text: text2 }) {
			const result = await parsePartialJson(text2);
			switch (result.state) {
				case "failed-parse":
				case "undefined-input": return;
				case "repaired-parse":
				case "successful-parse": {
					const outerValue = result.value;
					if (outerValue == null || typeof outerValue !== "object" || !("elements" in outerValue) || !Array.isArray(outerValue.elements)) return;
					const rawElements = result.state === "repaired-parse" && outerValue.elements.length > 0 ? outerValue.elements.slice(0, -1) : outerValue.elements;
					const parsedElements = [];
					for (const rawElement of rawElements) {
						const validationResult = await safeValidateTypes({
							value: rawElement,
							schema: elementSchema
						});
						if (validationResult.success) parsedElements.push(validationResult.value);
					}
					return { partial: parsedElements };
				}
			}
		},
		createElementStreamTransform() {
			let publishedElements = 0;
			return new TransformStream({ transform({ partialOutput }, controller) {
				if (partialOutput != null) for (; publishedElements < partialOutput.length; publishedElements++) controller.enqueue(partialOutput[publishedElements]);
			} });
		}
	};
};
var choice = ({ options: choiceOptions, name: name22, description }) => {
	return {
		name: "choice",
		responseFormat: Promise.resolve({
			type: "json",
			schema: {
				$schema: "http://json-schema.org/draft-07/schema#",
				type: "object",
				properties: { result: {
					type: "string",
					enum: choiceOptions
				} },
				required: ["result"],
				additionalProperties: false
			},
			...name22 != null && { name: name22 },
			...description != null && { description }
		}),
		async parseCompleteOutput({ text: text2 }, context2) {
			const parseResult = await safeParseJSON({ text: text2 });
			if (!parseResult.success) throw new NoObjectGeneratedError({
				message: "No object generated: could not parse the response.",
				cause: parseResult.error,
				text: text2,
				response: context2.response,
				usage: context2.usage,
				finishReason: context2.finishReason
			});
			const outerValue = parseResult.value;
			if (outerValue == null || typeof outerValue !== "object" || !("result" in outerValue) || typeof outerValue.result !== "string" || !choiceOptions.includes(outerValue.result)) throw new NoObjectGeneratedError({
				message: "No object generated: response did not match schema.",
				cause: new TypeValidationError({
					value: outerValue,
					cause: "response must be an object that contains a choice value."
				}),
				text: text2,
				response: context2.response,
				usage: context2.usage,
				finishReason: context2.finishReason
			});
			return outerValue.result;
		},
		async parsePartialOutput({ text: text2 }) {
			const result = await parsePartialJson(text2);
			switch (result.state) {
				case "failed-parse":
				case "undefined-input": return;
				case "repaired-parse":
				case "successful-parse": {
					const outerValue = result.value;
					if (outerValue == null || typeof outerValue !== "object" || !("result" in outerValue) || typeof outerValue.result !== "string") return;
					const potentialMatches = choiceOptions.filter((choiceOption) => choiceOption.startsWith(outerValue.result));
					if (result.state === "successful-parse") return potentialMatches.includes(outerValue.result) ? { partial: outerValue.result } : void 0;
					else return potentialMatches.length === 1 ? { partial: potentialMatches[0] } : void 0;
				}
			}
		},
		createElementStreamTransform() {}
	};
};
var json = ({ name: name22, description } = {}) => {
	return {
		name: "json",
		responseFormat: Promise.resolve({
			type: "json",
			...name22 != null && { name: name22 },
			...description != null && { description }
		}),
		async parseCompleteOutput({ text: text2 }, context2) {
			const parseResult = await safeParseJSON({ text: text2 });
			if (!parseResult.success) throw new NoObjectGeneratedError({
				message: "No object generated: could not parse the response.",
				cause: parseResult.error,
				text: text2,
				response: context2.response,
				usage: context2.usage,
				finishReason: context2.finishReason
			});
			return parseResult.value;
		},
		async parsePartialOutput({ text: text2 }) {
			const result = await parsePartialJson(text2);
			switch (result.state) {
				case "failed-parse":
				case "undefined-input": return;
				case "repaired-parse":
				case "successful-parse": return result.value === void 0 ? void 0 : { partial: result.value };
			}
		},
		createElementStreamTransform() {}
	};
};
createIdGenerator({
	prefix: "aitxt",
	size: 24
});
TransformStream;
z$1.record(z$1.string(), jsonValueSchema.optional());
createIdGenerator({
	prefix: "aitxt",
	size: 24
});
z$1.record(z$1.string(), jsonValueSchema.optional());
function splitArray(array2, chunkSize) {
	if (chunkSize <= 0) throw new Error("chunkSize must be greater than 0");
	const result = [];
	for (let i = 0; i < array2.length; i += chunkSize) result.push(array2.slice(i, i + chunkSize));
	return result;
}
async function embedMany({ model: modelArg, values, maxParallelCalls = Infinity, maxRetries: maxRetriesArg, abortSignal, headers, providerOptions, experimental_telemetry: telemetry }) {
	const model = resolveEmbeddingModel(modelArg);
	const { maxRetries, retry } = prepareRetries({
		maxRetries: maxRetriesArg,
		abortSignal
	});
	const headersWithUserAgent = withUserAgentSuffix(headers != null ? headers : {}, `ai/${VERSION}`);
	const baseTelemetryAttributes = getBaseTelemetryAttributes({
		model,
		telemetry,
		headers: headersWithUserAgent,
		settings: { maxRetries }
	});
	const tracer = getTracer(telemetry);
	return recordSpan({
		name: "ai.embedMany",
		attributes: selectTelemetryAttributes({
			telemetry,
			attributes: {
				...assembleOperationName({
					operationId: "ai.embedMany",
					telemetry
				}),
				...baseTelemetryAttributes,
				"ai.values": { input: () => values.map((value) => JSON.stringify(value)) }
			}
		}),
		tracer,
		fn: async (span) => {
			var _a22;
			const [maxEmbeddingsPerCall, supportsParallelCalls] = await Promise.all([model.maxEmbeddingsPerCall, model.supportsParallelCalls]);
			if (maxEmbeddingsPerCall == null || maxEmbeddingsPerCall === Infinity) {
				const { embeddings: embeddings2, usage, warnings: warnings2, response, providerMetadata: providerMetadata2 } = await retry(() => {
					return recordSpan({
						name: "ai.embedMany.doEmbed",
						attributes: selectTelemetryAttributes({
							telemetry,
							attributes: {
								...assembleOperationName({
									operationId: "ai.embedMany.doEmbed",
									telemetry
								}),
								...baseTelemetryAttributes,
								"ai.values": { input: () => values.map((value) => JSON.stringify(value)) }
							}
						}),
						tracer,
						fn: async (doEmbedSpan) => {
							var _a23, _b;
							const modelResponse = await model.doEmbed({
								values,
								abortSignal,
								headers: headersWithUserAgent,
								providerOptions
							});
							const embeddings3 = modelResponse.embeddings;
							const usage2 = (_a23 = modelResponse.usage) != null ? _a23 : { tokens: NaN };
							doEmbedSpan.setAttributes(await selectTelemetryAttributes({
								telemetry,
								attributes: {
									"ai.embeddings": { output: () => embeddings3.map((embedding) => JSON.stringify(embedding)) },
									"ai.usage.tokens": usage2.tokens
								}
							}));
							return {
								embeddings: embeddings3,
								usage: usage2,
								warnings: (_b = modelResponse.warnings) != null ? _b : [],
								providerMetadata: modelResponse.providerMetadata,
								response: modelResponse.response
							};
						}
					});
				});
				span.setAttributes(await selectTelemetryAttributes({
					telemetry,
					attributes: {
						"ai.embeddings": { output: () => embeddings2.map((embedding) => JSON.stringify(embedding)) },
						"ai.usage.tokens": usage.tokens
					}
				}));
				logWarnings({
					warnings: warnings2,
					provider: model.provider,
					model: model.modelId
				});
				return new DefaultEmbedManyResult({
					values,
					embeddings: embeddings2,
					usage,
					warnings: warnings2,
					providerMetadata: providerMetadata2,
					responses: [response]
				});
			}
			const valueChunks = splitArray(values, maxEmbeddingsPerCall);
			const embeddings = [];
			const warnings = [];
			const responses = [];
			let tokens = 0;
			let providerMetadata;
			const parallelChunks = splitArray(valueChunks, supportsParallelCalls ? maxParallelCalls : 1);
			for (const parallelChunk of parallelChunks) {
				const results = await Promise.all(parallelChunk.map((chunk) => {
					return retry(() => {
						return recordSpan({
							name: "ai.embedMany.doEmbed",
							attributes: selectTelemetryAttributes({
								telemetry,
								attributes: {
									...assembleOperationName({
										operationId: "ai.embedMany.doEmbed",
										telemetry
									}),
									...baseTelemetryAttributes,
									"ai.values": { input: () => chunk.map((value) => JSON.stringify(value)) }
								}
							}),
							tracer,
							fn: async (doEmbedSpan) => {
								var _a23, _b;
								const modelResponse = await model.doEmbed({
									values: chunk,
									abortSignal,
									headers: headersWithUserAgent,
									providerOptions
								});
								const embeddings2 = modelResponse.embeddings;
								const usage = (_a23 = modelResponse.usage) != null ? _a23 : { tokens: NaN };
								doEmbedSpan.setAttributes(await selectTelemetryAttributes({
									telemetry,
									attributes: {
										"ai.embeddings": { output: () => embeddings2.map((embedding) => JSON.stringify(embedding)) },
										"ai.usage.tokens": usage.tokens
									}
								}));
								return {
									embeddings: embeddings2,
									usage,
									warnings: (_b = modelResponse.warnings) != null ? _b : [],
									providerMetadata: modelResponse.providerMetadata,
									response: modelResponse.response
								};
							}
						});
					});
				}));
				for (const result of results) {
					embeddings.push(...result.embeddings);
					warnings.push(...result.warnings);
					responses.push(result.response);
					tokens += result.usage.tokens;
					if (result.providerMetadata) if (!providerMetadata) providerMetadata = { ...result.providerMetadata };
					else for (const [providerName, metadata] of Object.entries(result.providerMetadata)) providerMetadata[providerName] = {
						...(_a22 = providerMetadata[providerName]) != null ? _a22 : {},
						...metadata
					};
				}
			}
			span.setAttributes(await selectTelemetryAttributes({
				telemetry,
				attributes: {
					"ai.embeddings": { output: () => embeddings.map((embedding) => JSON.stringify(embedding)) },
					"ai.usage.tokens": tokens
				}
			}));
			logWarnings({
				warnings,
				provider: model.provider,
				model: model.modelId
			});
			return new DefaultEmbedManyResult({
				values,
				embeddings,
				usage: { tokens },
				warnings,
				providerMetadata,
				responses
			});
		}
	});
}
var DefaultEmbedManyResult = class {
	constructor(options) {
		this.values = options.values;
		this.embeddings = options.embeddings;
		this.usage = options.usage;
		this.warnings = options.warnings;
		this.providerMetadata = options.providerMetadata;
		this.responses = options.responses;
	}
};
createIdGenerator({
	prefix: "aiobj",
	size: 24
});
createIdGenerator({
	prefix: "aiobj",
	size: 24
});
//#endregion
//#region src/processors/observational-memory/constants.ts
var constants_exports = /* @__PURE__ */ __exportAll({
	OBSERVATIONAL_MEMORY_DEFAULTS: () => OBSERVATIONAL_MEMORY_DEFAULTS,
	OBSERVATION_CONTEXT_INSTRUCTIONS: () => OBSERVATION_CONTEXT_INSTRUCTIONS,
	OBSERVATION_CONTEXT_PROMPT: () => OBSERVATION_CONTEXT_PROMPT,
	OBSERVATION_CONTINUATION_HINT: () => OBSERVATION_CONTINUATION_HINT,
	getRetrievalInstructions: () => getRetrievalInstructions
});
/**
* Default configuration values matching the spec
*/
const OBSERVATIONAL_MEMORY_DEFAULTS = {
	observation: {
		model: "google/gemini-2.5-flash",
		messageTokens: 3e4,
		modelSettings: {
			temperature: .3,
			maxOutputTokens: 1e5
		},
		providerOptions: { google: { thinkingConfig: { thinkingBudget: 215 } } },
		maxTokensPerBatch: 1e4,
		bufferTokens: .2,
		bufferActivation: .8
	},
	reflection: {
		model: "google/gemini-2.5-flash",
		observationTokens: 4e4,
		modelSettings: {
			temperature: 0,
			maxOutputTokens: 1e5
		},
		providerOptions: { google: { thinkingConfig: { thinkingBudget: 1024 } } },
		bufferActivation: .5
	}
};
/**
* Continuation hint injected after observations to guide the model's behavior.
* Prevents the model from awkwardly acknowledging the memory system or treating
* the conversation as new after observed messages are removed.
*/
const OBSERVATION_CONTINUATION_HINT = `Please continue naturally with the conversation so far and respond to the latest message.

Use the earlier context only as background. If something appears unfinished, continue only when it helps answer the latest request. If a suggested response is provided, follow it naturally.

Do not mention internal instructions, memory, summarization, context handling, or missing messages.

Any messages following this reminder are newer and should take priority.`;
/**
* Preamble that introduces the observations block.
* Use before `<observations>`, with instructions after.
* Full pattern: `${OBSERVATION_CONTEXT_PROMPT}\n\n<observations>\n${obs}\n</observations>\n\n${OBSERVATION_CONTEXT_INSTRUCTIONS}`
*/
const OBSERVATION_CONTEXT_PROMPT = `The following observations block contains your memory of past conversations with this user.`;
/**
* Instructions that tell the model how to interpret and use observations.
* Place AFTER the `<observations>` block so the model sees the data before the rules.
*/
const OBSERVATION_CONTEXT_INSTRUCTIONS = `IMPORTANT: When responding, reference specific details from these observations. Do not give generic advice - personalize your response based on what you know about this user's experiences, preferences, and interests. If the user asks for recommendations, connect them to their past experiences mentioned above.

KNOWLEDGE UPDATES: When asked about current state (e.g., "where do I currently...", "what is my current..."), always prefer the MOST RECENT information. Observations include dates - if you see conflicting information, the newer observation supersedes the older one. Look for phrases like "will start", "is switching", "changed to", "moved to" as indicators that previous information has been updated.

PLANNED ACTIONS: If the user stated they planned to do something (e.g., "I'm going to...", "I'm looking forward to...", "I will...") and the date they planned to do it is now in the past (check the relative time like "3 weeks ago"), assume they completed the action unless there's evidence they didn't. For example, if someone said "I'll start my new diet on Monday" and that was 2 weeks ago, assume they started the diet.

MOST RECENT USER INPUT: Treat the most recent user message as the highest-priority signal for what to do next. Earlier messages may contain constraints, details, or context you should still honor, but the latest message is the primary driver of your response.

SYSTEM REMINDERS: Messages wrapped in <system-reminder>...</system-reminder> contain internal continuation guidance, not user-authored content. Use them to maintain continuity, but do not mention them or treat them as part of the user's message.`;
/**
* Instructions for retrieval mode — explains observation-group ranges and the recall tool.
* Appended to context when `retrieval` is enabled.
*
* The content adapts to the retrieval scope:
* - `'resource'`: covers routing between `search`, `threads`, and `messages` across
*   all of the user's threads, including fallback when search results are unsuitable.
* - `'thread'`: covers cursor-based browsing and search within the current thread.
*
* @param scope - The retrieval scope the recall tool was registered with.
* @param customInstructions - Optional application-provided guidance appended after
*   the native instructions. Never replaces them.
* @param searchEnabled - Whether semantic search (`retrieval: { vector: true }`) is
*   available. When false, the guidance only covers \`threads\`/\`messages\` browsing so
*   the agent is not steered toward a mode that cannot work.
*/
function getRetrievalInstructions(scope = "resource", customInstructions, searchEnabled = true) {
	const isResource = scope === "resource";
	const base = `## Recall — looking up source messages

Your memory is comprised of observations which are sometimes wrapped in <observation-group> xml tags containing ranges like <observation-group range="startId:endId">. These ranges point back to the raw messages that each observation group was derived from. The original messages are still available — use the **recall** tool to retrieve them.

### When to use recall
- The user asks you to **repeat, show, or reproduce** something from a past conversation
- The user asks for **exact content** — code, text, quotes, error messages, URLs, file paths, specific numbers
- Your observations mention something but your memory lacks the detail needed to fully answer (e.g. you know a blog post was shared but only have a summary of it)
- You want to **verify or expand on** an observation before responding${isResource ? `
- The user references another conversation that your observations don't cover — even if you have no observations yet, their other threads may contain it` : ""}

**Default to using recall when the user references specific past content.** Your observations capture the gist, not the details. If there's any doubt whether your memory is complete enough, use recall.

${isResource ? searchEnabled ? `### Choosing a mode
The recall tool works across ALL of this user's conversation threads, not just the current one.

- Use \`mode: "search"\` with a \`query\` when you don't know which thread contains the answer. Each result includes its thread ID and the raw message IDs it came from, which you can use as a \`cursor\`.
- Use \`mode: "messages"\` when you already know the thread — pass \`threadId\` to read another thread, or a \`cursor\` from an observation-group range or a search result.
- Use \`mode: "threads"\` to list the user's threads (IDs, titles, dates) when you need to discover where something was discussed. Use \`before\`/\`after\` to narrow by date.

**If search results look irrelevant, do not give up.** Search only covers content that has been indexed — a short or recent conversation may exist in raw message history before any observation of it was created. When search returns nothing suitable but the user is clearly referring to a past conversation, call \`mode: "threads"\` to find candidate threads (titles and dates are strong clues), then read them with \`mode: "messages"\`. If a search result already gives you a thread ID, go straight to \`mode: "messages"\`.` : `### Choosing a mode
The recall tool works across ALL of this user's conversation threads, not just the current one.

- Use \`mode: "threads"\` to list the user's threads (IDs, titles, dates) when you need to discover where something was discussed. Use \`before\`/\`after\` to narrow by date.
- Use \`mode: "messages"\` when you know the thread — pass \`threadId\` to read another thread, or a \`cursor\` from an observation-group range.

When the user refers to a past conversation you don't have a cursor for, call \`mode: "threads"\` to find candidate threads (titles and dates are strong clues), then read them with \`mode: "messages"\`. Raw history may exist for threads that have no observations yet.` : `### Choosing a mode
The recall tool is limited to the current conversation thread.

- Use \`mode: "messages"\` (default) to page through this thread's message history near a cursor.${searchEnabled ? `
- Use \`mode: "search"\` with a \`query\` to find messages by content within this thread.` : ""}
- Use \`mode: "threads"\` to get the current thread's ID, title, and dates.`}

### How to use recall with a cursor
Each range has the format \`startId:endId\` where both are message IDs separated by a colon.

1. Find the observation group relevant to the user's question and extract the start or end ID from its range.
2. Call \`recall\` with that ID as the \`cursor\`.
3. Use \`page: 1\` (or omit) to read forward from the cursor, \`page: -1\` to read backward.
4. If the first page doesn't have what you need, increment the page number to keep paginating.
5. Check \`hasNextPage\`/\`hasPrevPage\` in the result to know if more pages exist in each direction.

### Detail levels
By default recall returns **low** detail: truncated text and tool names only. Each message shows its ID and each part has a positional index like \`[p0]\`, \`[p1]\`, etc.

- Use \`detail: "high"\` to get full message content including tool arguments and results. This will only return the high detail version of a single message part at a time.
- Use \`partIndex\` with a cursor to fetch a single part at full detail — for example, to read one specific tool result or code block without loading every part.

If the result says \`truncated: true\`, the output was cut to fit the token budget. You can paginate or use \`partIndex\` to target specific content.

### Following up on truncated parts
Low-detail results may include truncation hints like:
\`[truncated — call recall cursor="..." partIndex=N detail="high" for full content]\`

**When you see these hints and need the full content, make the exact call described in the hint.** This is the normal workflow: first recall at low detail to scan, then drill into specific parts at high detail. Do not stop at the low-detail result if the user asked for exact content.

### When recall is NOT needed
- The user is asking for a high-level summary and your observations already cover it
- The question is about general preferences or facts that don't require source text
${isResource ? `- No relevant observation range exists AND ${searchEnabled ? "`search`/`threads`" : "`threads`"} turned up nothing — but remember that raw history may exist for threads that have no observations yet, so check before concluding the information is unavailable` : `- There is no relevant range in your observations for the topic`}

Observation groups with range IDs and your recall tool allows you to think back and remember details you're fuzzy on.`;
	const custom = customInstructions?.trim();
	if (!custom) return base;
	return `${base}

### Additional recall guidance
${custom}`;
}
//#endregion
//#region src/processors/observational-memory/extractor.ts
const BUILT_IN_SLUGS = /* @__PURE__ */ new Set([
	"current-task",
	"suggested-response",
	"thread-title"
]);
const EXTRACTED_VALUES_TAG = "extracted-values";
const RESERVED_XML_TAGS = /* @__PURE__ */ new Set([
	"observations",
	"observation",
	EXTRACTED_VALUES_TAG,
	"thread",
	"message",
	"messages",
	"conversation",
	"history",
	"system",
	"user",
	"assistant",
	"tool",
	...BUILT_IN_SLUGS
]);
const BUILT_IN_EXTRACTOR_SLUGS = [...BUILT_IN_SLUGS];
function isBuiltInExtractorSlug(slug) {
	return BUILT_IN_SLUGS.has(slug);
}
function slugifyExtractorName(name) {
	let normalized = "";
	let previousWasSeparator = false;
	for (const char of name.trim().toLowerCase()) {
		const code = char.charCodeAt(0);
		if (code >= 97 && code <= 122 || code >= 48 && code <= 57) {
			normalized += char;
			previousWasSeparator = false;
			continue;
		}
		if (char === "'" || char === "\"" || char === "`") continue;
		if (!previousWasSeparator && normalized.length > 0) {
			normalized += "-";
			previousWasSeparator = true;
		}
	}
	return normalized.endsWith("-") ? normalized.slice(0, -1) : normalized;
}
function assertValidSlug(slug, name) {
	if (!slug) throw new Error(`Extractor name "${name}" must produce a non-empty slug.`);
	const first = slug.charCodeAt(0);
	const last = slug.charCodeAt(slug.length - 1);
	const startsWithLetter = first >= 97 && first <= 122;
	const endsWithLetterOrNumber = last >= 97 && last <= 122 || last >= 48 && last <= 57;
	const hasOnlySlugCharacters = [...slug].every((char) => {
		const code = char.charCodeAt(0);
		return code >= 97 && code <= 122 || code >= 48 && code <= 57 || char === "-";
	});
	if (!startsWithLetter || !endsWithLetterOrNumber || !hasOnlySlugCharacters) throw new Error(`Extractor name "${name}" produced invalid slug "${slug}".`);
}
var Extractor = class Extractor {
	name;
	slug;
	instructions;
	schema;
	mode;
	includePreviousExtraction;
	metadataKeyPath;
	onExtracted;
	/** @internal */
	internal;
	instructionsConfig;
	schemaConfig;
	constructor(config, internal = false) {
		const name = config.name.trim();
		const instructions = typeof config.instructions === "string" ? config.instructions.trim() : void 0;
		const slug = slugifyExtractorName(name);
		if (!name) throw new Error("Extractor name is required.");
		if (instructions !== void 0 && !instructions) throw new Error(`Extractor "${name}" must include instructions.`);
		assertValidSlug(slug, name);
		if (!internal && RESERVED_XML_TAGS.has(slug)) throw new Error(`Extractor slug "${slug}" is reserved by Observational Memory.`);
		this.name = name;
		this.slug = slug;
		this.instructionsConfig = config.instructions;
		this.schemaConfig = config.schema;
		this.instructions = instructions ?? "";
		this.schema = typeof config.schema === "function" ? z.string() : config.schema ?? z.string();
		this.mode = internal || !config.schema ? "inline" : "structured";
		this.includePreviousExtraction = config.includePreviousExtraction ?? true;
		this.metadataKeyPath = config.metadataKeyPath ?? `extracted.${slug}`;
		this.onExtracted = config.onExtracted;
		this.internal = internal;
	}
	async resolve(context) {
		const instructions = typeof this.instructionsConfig === "function" ? (await this.instructionsConfig(context)).trim() : this.instructionsConfig.trim();
		if (!instructions) throw new Error(`Extractor "${this.name}" must include instructions.`);
		const schema = typeof this.schemaConfig === "function" ? await this.schemaConfig(context) : this.schemaConfig;
		return new Extractor({
			name: this.name,
			instructions,
			...schema ? { schema } : {},
			includePreviousExtraction: this.includePreviousExtraction,
			metadataKeyPath: this.metadataKeyPath,
			onExtracted: this.onExtracted
		}, this.internal);
	}
};
async function resolveExtractors(extractors, context) {
	return Promise.all(extractors.map((extractor) => extractor.resolve(context)));
}
function validateExtractorList(extractors) {
	const seen = /* @__PURE__ */ new Map();
	for (const extractor of extractors) {
		assertValidSlug(extractor.slug, extractor.name);
		if (!extractor.internal && RESERVED_XML_TAGS.has(extractor.slug)) throw new Error(`Extractor slug "${extractor.slug}" is reserved by Observational Memory.`);
		const previous = seen.get(extractor.slug);
		if (previous) throw new Error(`Duplicate extractor slug "${extractor.slug}" from "${previous}" and "${extractor.name}".`);
		seen.set(extractor.slug, extractor.name);
	}
	return [...extractors];
}
function isJsonLike(value) {
	return /^(?:[\[{"-]|\d|true\b|false\b|null\b)/.test(value.trim());
}
function candidateValues(raw) {
	const trimmed = raw.trim();
	const candidates = [];
	const add = (value) => {
		if (!candidates.some((candidate) => Object.is(candidate, value))) candidates.push(value);
	};
	if (isJsonLike(trimmed)) try {
		add(JSON.parse(trimmed));
	} catch {}
	add(trimmed);
	if (!isJsonLike(trimmed)) try {
		add(JSON.parse(trimmed));
	} catch {}
	return candidates;
}
function parseExtractorValue(extractor, raw) {
	const failures = [];
	for (const candidate of candidateValues(raw)) {
		const parsed = extractor.schema.safeParse(candidate);
		if (parsed.success) return parsed.data;
		failures.push(parsed.error.message);
	}
	throw new Error(`Extractor "${extractor.slug}" output did not match its schema: ${failures[0] ?? "invalid value"}`);
}
function parseExtractedValuesObject(raw) {
	const trimmed = raw.trim();
	if (!trimmed || trimmed.startsWith("Write only the extracted values JSON object here.")) return;
	const parsed = JSON.parse(trimmed);
	if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) throw new Error(`${EXTRACTED_VALUES_TAG} must contain a JSON object.`);
	return parsed;
}
function parseExtractedValues(output, extractors) {
	const values = {};
	const failures = [];
	const inlineExtractors = extractors.filter((extractor) => extractor.mode === "inline");
	const regex = new RegExp(`<${EXTRACTED_VALUES_TAG}>([\\s\\S]*?)<\\/${EXTRACTED_VALUES_TAG}>`, "gi");
	const matches = [...output.matchAll(regex)];
	for (const match of matches) try {
		const extractedValues = parseExtractedValuesObject(match[1] ?? "");
		if (!extractedValues) continue;
		for (const extractor of inlineExtractors) {
			if (!Object.prototype.hasOwnProperty.call(extractedValues, extractor.slug)) continue;
			const rawValue = extractedValues[extractor.slug];
			if (rawValue === void 0 || rawValue === null || rawValue === "") continue;
			const parsed = extractor.schema.safeParse(rawValue);
			if (parsed.success) values[extractor.slug] = parsed.data;
			else failures.push({
				slug: extractor.slug,
				error: parsed.error.message
			});
		}
	} catch (error) {
		failures.push({
			slug: EXTRACTED_VALUES_TAG,
			error: error instanceof Error ? error.message : String(error)
		});
	}
	for (const extractor of inlineExtractors) {
		if (Object.prototype.hasOwnProperty.call(values, extractor.slug)) continue;
		const tagRegex = new RegExp(`<${extractor.slug}>([\\s\\S]*?)<\\/${extractor.slug}>`, "gi");
		const rawValue = [...output.matchAll(tagRegex)].at(-1)?.[1]?.trim();
		if (!rawValue) continue;
		try {
			values[extractor.slug] = parseExtractorValue(extractor, rawValue);
		} catch (error) {
			failures.push({
				slug: extractor.slug,
				error: error instanceof Error ? error.message : String(error)
			});
		}
	}
	return {
		values,
		failures
	};
}
function stripExtractorSections(output, extractors) {
	const inlineExtractors = extractors.filter((extractor) => extractor.mode === "inline");
	let stripped = output.replace(new RegExp(`[ \\t]*<${EXTRACTED_VALUES_TAG}>[\\s\\S]*?<\\/${EXTRACTED_VALUES_TAG}>\\s*`, "gi"), "");
	for (const extractor of inlineExtractors) stripped = stripped.replace(new RegExp(`[ \\t]*<${extractor.slug}>[\\s\\S]*?<\\/${extractor.slug}>\\s*`, "gi"), "");
	return stripped;
}
function buildExtractorOutputSections(extractors) {
	const inlineExtractors = extractors.filter((extractor) => extractor.mode === "inline");
	if (inlineExtractors.length === 0) return "";
	return `Additional optional XML sections:\nIf the observations include information relevant to any of these tags, output that tag after <observations> and include the relevant information.\n${inlineExtractors.map((extractor) => `<${extractor.slug}>
${extractor.instructions}
Include this section when the observations contain relevant information for <${extractor.slug}>. Write only that information inside the tag.
</${extractor.slug}>`).join("\n\n")}`;
}
function renderPriorValue(value) {
	return typeof value === "string" ? value : JSON.stringify(value);
}
function buildExtractorPriorLines(extractors, priorExtractedValues) {
	if (!priorExtractedValues) return [];
	const lines = [];
	for (const extractor of extractors) {
		if (!extractor.includePreviousExtraction) continue;
		const value = priorExtractedValues[extractor.slug];
		if (value === void 0 || value === null || value === "") continue;
		lines.push(`<${extractor.slug}>\n${renderPriorValue(value)}\n</${extractor.slug}>`);
	}
	return lines;
}
//#endregion
//#region src/processors/observational-memory/extracted-values.ts
const BUILT_IN_METADATA_FIELDS = {
	"current-task": {
		metadataField: "currentTask",
		builtInField: "currentTask"
	},
	"suggested-response": {
		metadataField: "suggestedResponse",
		builtInField: "suggestedContinuation"
	},
	"thread-title": {
		metadataField: "threadTitle",
		builtInField: "threadTitle"
	}
};
function isPresentExtractedValue(value) {
	return value !== void 0 && value !== null && value !== "";
}
function normalizeExtractedValues(values) {
	if (!values) return;
	const normalized = Object.fromEntries(Object.entries(values).filter(([, value]) => isPresentExtractedValue(value)));
	return Object.keys(normalized).length > 0 ? normalized : void 0;
}
function mergeExtractedValues(...valueSets) {
	const merged = {};
	for (const values of valueSets) {
		const normalized = normalizeExtractedValues(values);
		if (normalized) Object.assign(merged, normalized);
	}
	return Object.keys(merged).length > 0 ? merged : void 0;
}
function mergeExtractionFailures(...failureSets) {
	const failures = failureSets.flatMap((set) => set ?? []);
	return failures.length > 0 ? failures : void 0;
}
const UNSAFE_METADATA_PATH_SEGMENTS = /* @__PURE__ */ new Set([
	"__proto__",
	"constructor",
	"prototype"
]);
function getMetadataPathSegments(keyPath) {
	if (keyPath === false) return;
	const segments = keyPath.split(".").filter(Boolean);
	if (segments.some((segment) => UNSAFE_METADATA_PATH_SEGMENTS.has(segment))) throw new Error(`Extractor metadataKeyPath "${keyPath}" contains an unsafe path segment.`);
	return segments.length > 0 ? segments : void 0;
}
function getValueAtPath(metadata, keyPath) {
	if (!metadata) return;
	const segments = getMetadataPathSegments(keyPath);
	if (!segments) return;
	let current = metadata;
	for (const segment of segments) {
		if (!current || typeof current !== "object" || Array.isArray(current)) return;
		current = current[segment];
	}
	return current;
}
function setValueAtPath(metadata, keyPath, value) {
	if (!isPresentExtractedValue(value)) return;
	const segments = getMetadataPathSegments(keyPath);
	if (!segments) return;
	let current = metadata;
	for (const segment of segments.slice(0, -1)) {
		const next = current[segment];
		if (!next || typeof next !== "object" || Array.isArray(next)) current[segment] = {};
		current = current[segment];
	}
	current[segments[segments.length - 1]] = value;
}
function readBuiltInMetadataValues(metadata) {
	const values = {};
	for (const slug of BUILT_IN_EXTRACTOR_SLUGS) {
		const { metadataField } = BUILT_IN_METADATA_FIELDS[slug];
		values[slug] = metadata[metadataField];
	}
	return values;
}
function getPriorExtractedValues(metadata, extractors) {
	if (!metadata) return;
	if (!extractors) return mergeExtractedValues(readBuiltInMetadataValues(metadata), metadata.extracted);
	const values = {};
	for (const extractor of extractors) {
		const value = getValueAtPath(metadata, extractor.metadataKeyPath);
		if (isPresentExtractedValue(value)) values[extractor.slug] = value;
	}
	return normalizeExtractedValues(values);
}
function renderExtractedValue(value) {
	return typeof value === "string" ? value : JSON.stringify(value);
}
function buildExtractedValueContextSections(extractors, values) {
	const normalized = normalizeExtractedValues(values);
	if (!normalized) return [];
	const injectableSlugs = new Set(extractors.filter((extractor) => !isBuiltInExtractorSlug(extractor.slug) && extractor.includePreviousExtraction).map((extractor) => extractor.slug));
	return Object.entries(normalized).filter(([slug]) => injectableSlugs.has(slug)).map(([slug, value]) => `<${slug}>\n${renderExtractedValue(value)}\n</${slug}>`);
}
function getStringExtractedValue$2(values, slug) {
	const value = values?.[slug];
	return typeof value === "string" && value.trim() ? value.trim() : void 0;
}
function getBuiltInExtractedValues(values) {
	const builtIns = {};
	for (const slug of BUILT_IN_EXTRACTOR_SLUGS) {
		const { builtInField } = BUILT_IN_METADATA_FIELDS[slug];
		builtIns[builtInField] = getStringExtractedValue$2(values, slug);
	}
	return builtIns;
}
function buildThreadMetadataFromExtractedValues(extractors, values) {
	const metadata = {};
	const normalized = normalizeExtractedValues(values);
	if (!normalized) return metadata;
	for (const extractor of extractors) {
		if (!Object.prototype.hasOwnProperty.call(normalized, extractor.slug)) continue;
		setValueAtPath(metadata, extractor.metadataKeyPath, normalized[extractor.slug]);
	}
	return metadata;
}
async function applyExtractorHooks(opts) {
	const values = normalizeExtractedValues(opts.values) ?? {};
	const failures = [...opts.failures ?? []];
	for (const extractor of opts.extractors) {
		if (!Object.prototype.hasOwnProperty.call(values, extractor.slug)) continue;
		const current = values[extractor.slug];
		if (!isPresentExtractedValue(current)) {
			delete values[extractor.slug];
			continue;
		}
		if (!extractor.onExtracted || extractor.internal) continue;
		try {
			const hookValue = await extractor.onExtracted({
				source: opts.source,
				extractor,
				threadId: opts.threadId,
				resourceId: opts.resourceId,
				previous: opts.previousValues?.[extractor.slug],
				current,
				mainAgent: opts.mainAgent,
				memory: opts.memory,
				sendSignal: opts.sendSignal,
				requestContext: opts.requestContext
			});
			if (hookValue === void 0) continue;
			const parsed = extractor.schema.safeParse(hookValue);
			if (parsed.success) values[extractor.slug] = parsed.data;
			else {
				delete values[extractor.slug];
				failures.push({
					slug: extractor.slug,
					error: parsed.error.message
				});
			}
		} catch (error) {
			delete values[extractor.slug];
			failures.push({
				slug: extractor.slug,
				error: error instanceof Error ? error.message : String(error)
			});
		}
	}
	return {
		values: normalizeExtractedValues(values),
		failures: mergeExtractionFailures(failures)
	};
}
//#endregion
//#region src/processors/observational-memory/debug.ts
const OM_DEBUG_LOG = process.env.OM_DEBUG ? join(process.cwd(), "om-debug.log") : null;
function omDebug(msg) {
	if (!OM_DEBUG_LOG) return;
	try {
		appendFileSync(OM_DEBUG_LOG, `[${(/* @__PURE__ */ new Date()).toLocaleString()}] ${msg}\n`);
	} catch {}
}
function omError(msg, err) {
	const errStr = err instanceof Error ? err.stack ?? err.message : err !== void 0 ? String(err) : "";
	omDebug(`[OM:ERROR] ${errStr ? `${msg}: ${errStr}` : msg}`);
}
omDebug(`[OM:process-start] OM module loaded, pid=${process.pid}`);
if (OM_DEBUG_LOG) {
	const _origConsoleError = console.error;
	console.error = (...args) => {
		omDebug(`[console.error] ${args.map((a) => {
			if (a instanceof Error) return a.stack ?? a.message;
			if (typeof a === "object" && a !== null) try {
				return JSON.stringify(a);
			} catch {
				return String(a);
			}
			return String(a);
		}).join(" ")}`);
		_origConsoleError.apply(console, args);
	};
}
//#endregion
//#region src/processors/observational-memory/extraction-runner.ts
function isAbortError$1(error, abortSignal) {
	return abortSignal?.aborted === true || error instanceof DOMException && error.name === "AbortError" || error instanceof Error && error.name === "AbortError";
}
async function extractStructuredValues(opts) {
	const structuredExtractors = (opts.extractors ?? []).filter((extractor) => extractor.mode === "structured");
	if (structuredExtractors.length === 0) return {
		values: {},
		failures: []
	};
	const schema = z.object(Object.fromEntries(structuredExtractors.map((extractor) => [extractor.slug, extractor.schema.optional()])));
	const priorLines = buildExtractorPriorLines(structuredExtractors, opts.priorExtractedValues);
	const extractorInstructions = structuredExtractors.map((extractor) => `- ${extractor.slug}: ${extractor.instructions}`).join("\n");
	const subject = opts.source === "reflector" ? "reflection" : "observations";
	const prompt = `Extract structured data from the ${subject} you made.

Return only the configured structured output object. Do not write observations, XML, markdown, or explanatory text.
Omit any property that is not supported by the ${subject} you made and the conversation context.
If a prior value is still applicable and carry-forward is enabled, return that prior value.

## Extractors

${extractorInstructions}${priorLines.length > 0 ? `\n\n## Prior Extracted Values\n\n${priorLines.join("\n\n")}` : ""}`;
	const values = {};
	const failures = [];
	const generateWithStructuredOutput = async (jsonPromptInjection) => {
		const output = await opts.agent.generate(prompt, {
			structuredOutput: {
				schema,
				...jsonPromptInjection ? { jsonPromptInjection } : {}
			},
			...opts.memory ? { memory: opts.memory } : {},
			...opts.abortSignal ? { abortSignal: opts.abortSignal } : {},
			...opts.requestContext ? { requestContext: opts.requestContext } : {},
			...opts.observabilityContext
		});
		if (output.object === void 0) throw new Error("structuredOutput object is undefined");
		return output.object;
	};
	let object;
	try {
		object = await generateWithStructuredOutput();
	} catch (error) {
		if (isAbortError$1(error, opts.abortSignal)) throw error;
		try {
			object = await generateWithStructuredOutput(coreFeatures.has("json-prompt-injection:inline") ? "inline" : true);
		} catch (fallbackError) {
			if (isAbortError$1(fallbackError, opts.abortSignal)) throw fallbackError;
			const message = fallbackError instanceof Error ? fallbackError.message : String(fallbackError);
			return {
				values,
				failures: structuredExtractors.map((extractor) => ({
					slug: extractor.slug,
					error: message
				}))
			};
		}
	}
	for (const extractor of structuredExtractors) {
		const value = object[extractor.slug];
		if (value === void 0 || value === null || value === "") continue;
		const parsed = extractor.schema.safeParse(value);
		if (parsed.success) values[extractor.slug] = parsed.data;
		else failures.push({
			slug: extractor.slug,
			error: parsed.error.message
		});
	}
	return {
		values,
		failures
	};
}
//#endregion
//#region src/processors/observational-memory/internal-request-context.ts
/**
* OM observer/reflector agents are implementation-detail agents invoked from
* inside a parent agent run. They should keep request-scoped values such as
* auth, versions, routing hints, and resource id, but they must not present as
* another run on the parent thread or core's cross-agent thread wait can block
* on the parent run that is waiting for OM to complete.
*
* A fresh RequestContext clone is always returned so that memory-scoped writes
* made by the internal agent run (e.g. the `MastraMemory` entry that agent.generate
* sets from the observer's temporary `structured-observer` memory) cannot leak back
* into the parent's RequestContext. Without this isolation the parent's OM turn later
* reads the temporary observer's resourceId and injects a continuation message that
* fails MessageList's resourceId validation.
*/
function withOmInternalThreadId(requestContext, omAgentId) {
	if (!requestContext) return void 0;
	const internalRequestContext = new RequestContext(requestContext.entries());
	const parentThreadId = requestContext.get(MASTRA_THREAD_ID_KEY);
	if (typeof parentThreadId === "string" && parentThreadId) internalRequestContext.set(MASTRA_THREAD_ID_KEY, `${parentThreadId}-${omAgentId}`);
	return internalRequestContext;
}
//#endregion
//#region src/processors/observational-memory/anchor-ids.ts
const ANCHOR_ID_PATTERN = /^\[(O\d+(?:-N\d+)?)\]\s*/;
const OBSERVATION_DATE_HEADER_PATTERN = /^\s*Date:\s+/;
const XML_TAG_PATTERN = /^\s*<\/?[a-z][^>]*>\s*$/i;
const MARKDOWN_GROUP_HEADING_PATTERN = /^\s*##\s+Group\s+`[^`]+`\s*$/;
const MARKDOWN_GROUP_METADATA_PATTERN = /^\s*_range:\s*`[^`]*`_\s*$/;
function buildEphemeralAnchorId(topLevelCounter, nestedCounter) {
	return nestedCounter === 0 ? `O${topLevelCounter}` : `O${topLevelCounter}-N${nestedCounter}`;
}
function parseAnchorId(line) {
	return line.match(ANCHOR_ID_PATTERN)?.[1] ?? null;
}
function shouldAnchorLine(line) {
	const trimmed = line.trim();
	if (!trimmed) return false;
	if (parseAnchorId(trimmed)) return false;
	if (OBSERVATION_DATE_HEADER_PATTERN.test(trimmed)) return false;
	if (XML_TAG_PATTERN.test(trimmed)) return false;
	if (MARKDOWN_GROUP_HEADING_PATTERN.test(trimmed) || MARKDOWN_GROUP_METADATA_PATTERN.test(trimmed)) return false;
	return true;
}
function getIndentationDepth(line) {
	const leadingWhitespace = line.match(/^\s*/)?.[0] ?? "";
	return Math.floor(leadingWhitespace.replace(/\t/g, "  ").length / 2);
}
function injectAnchorIds(observations) {
	if (!observations) return observations;
	const lines = observations.split("\n");
	let topLevelCounter = 0;
	let nestedCounter = 0;
	let changed = false;
	for (let i = 0; i < lines.length; i++) {
		const line = lines[i];
		if (!shouldAnchorLine(line)) continue;
		if (getIndentationDepth(line) === 0) {
			topLevelCounter += 1;
			nestedCounter = 0;
		} else {
			if (topLevelCounter === 0) topLevelCounter = 1;
			nestedCounter += 1;
		}
		const anchorId = buildEphemeralAnchorId(topLevelCounter, nestedCounter);
		const leadingWhitespace = line.match(/^\s*/)?.[0] ?? "";
		lines[i] = `${leadingWhitespace}[${anchorId}] ${line.slice(leadingWhitespace.length)}`;
		changed = true;
	}
	return changed ? lines.join("\n") : observations;
}
function stripEphemeralAnchorIds(observations) {
	if (!observations) return observations;
	return observations.replace(/(^|\n)([^\S\n]*)\[(O\d+(?:-N\d+)?)\][^\S\n]*/g, "$1$2");
}
//#endregion
//#region src/processors/observational-memory/date-utils.ts
/**
* Date/time utility functions for Observational Memory.
* Pure functions for formatting relative timestamps and annotating observations.
*/
/**
* Format a relative time string like "5 days ago", "2 weeks ago", "today", etc.
*/
function formatRelativeTime(date, currentDate) {
	const diffMs = currentDate.getTime() - date.getTime();
	const diffDays = Math.floor(diffMs / (1e3 * 60 * 60 * 24));
	if (diffDays < 0) {
		const futureDays = Math.abs(diffDays);
		if (futureDays === 1) return "tomorrow";
		if (futureDays < 7) return `in ${futureDays} days`;
		if (futureDays < 14) return "in 1 week";
		if (futureDays < 30) return `in ${Math.floor(futureDays / 7)} weeks`;
		if (futureDays < 60) return "in 1 month";
		if (futureDays < 365) return `in ${Math.floor(futureDays / 30)} months`;
		const years = Math.floor(futureDays / 365);
		return `in ${years} year${years > 1 ? "s" : ""}`;
	}
	if (diffDays === 0) return "today";
	if (diffDays === 1) return "yesterday";
	if (diffDays < 7) return `${diffDays} days ago`;
	if (diffDays < 14) return "1 week ago";
	if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
	if (diffDays < 60) return "1 month ago";
	if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
	return `${Math.floor(diffDays / 365)} year${Math.floor(diffDays / 365) > 1 ? "s" : ""} ago`;
}
/**
* Format the gap between two dates as a human-readable string.
* Returns null for consecutive days (no gap marker needed).
*/
function formatGapBetweenDates(prevDate, currDate) {
	const diffMs = currDate.getTime() - prevDate.getTime();
	const diffDays = Math.floor(diffMs / (1e3 * 60 * 60 * 24));
	if (diffDays <= 1) return null;
	else if (diffDays < 7) return `[${diffDays} days later]`;
	else if (diffDays < 14) return `[1 week later]`;
	else if (diffDays < 30) return `[${Math.floor(diffDays / 7)} weeks later]`;
	else if (diffDays < 60) return `[1 month later]`;
	else return `[${Math.floor(diffDays / 30)} months later]`;
}
/**
* Parses a date string like "May 30, 2023", "May 27-28, 2023", "late April 2023", etc.
* Returns the parsed Date or null if unparseable.
*/
function parseDateFromContent(dateContent) {
	let targetDate = null;
	const simpleDateMatch = dateContent.match(/([A-Z][a-z]+)\s+(\d{1,2}),?\s+(\d{4})/);
	if (simpleDateMatch) {
		const parsed = /* @__PURE__ */ new Date(`${simpleDateMatch[1]} ${simpleDateMatch[2]}, ${simpleDateMatch[3]}`);
		if (!isNaN(parsed.getTime())) targetDate = parsed;
	}
	if (!targetDate) {
		const rangeMatch = dateContent.match(/([A-Z][a-z]+)\s+(\d{1,2})-\d{1,2},?\s+(\d{4})/);
		if (rangeMatch) {
			const parsed = /* @__PURE__ */ new Date(`${rangeMatch[1]} ${rangeMatch[2]}, ${rangeMatch[3]}`);
			if (!isNaN(parsed.getTime())) targetDate = parsed;
		}
	}
	if (!targetDate) {
		const vagueMatch = dateContent.match(/(late|early|mid)[- ]?(?:to[- ]?(?:late|early|mid)[- ]?)?([A-Z][a-z]+)\s+(\d{4})/i);
		if (vagueMatch) {
			const month = vagueMatch[2];
			const year = vagueMatch[3];
			const modifier = vagueMatch[1].toLowerCase();
			let day = 15;
			if (modifier === "early") day = 7;
			if (modifier === "late") day = 23;
			const parsed = /* @__PURE__ */ new Date(`${month} ${day}, ${year}`);
			if (!isNaN(parsed.getTime())) targetDate = parsed;
		}
	}
	if (!targetDate) {
		const crossMonthMatch = dateContent.match(/([A-Z][a-z]+)\s+to\s+(?:early\s+)?([A-Z][a-z]+)\s+(\d{4})/i);
		if (crossMonthMatch) {
			const parsed = /* @__PURE__ */ new Date(`${crossMonthMatch[2]} 1, ${crossMonthMatch[3]}`);
			if (!isNaN(parsed.getTime())) targetDate = parsed;
		}
	}
	return targetDate;
}
/**
* Detects if an observation line indicates future intent (will do, plans to, looking forward to, etc.)
*/
function isFutureIntentObservation(line) {
	return [
		/\bwill\s+(?:be\s+)?(?:\w+ing|\w+)\b/i,
		/\bplans?\s+to\b/i,
		/\bplanning\s+to\b/i,
		/\blooking\s+forward\s+to\b/i,
		/\bgoing\s+to\b/i,
		/\bintends?\s+to\b/i,
		/\bwants?\s+to\b/i,
		/\bneeds?\s+to\b/i,
		/\babout\s+to\b/i
	].some((pattern) => pattern.test(line));
}
/**
* Expand inline estimated dates with relative time.
* Matches patterns like "(estimated May 27-28, 2023)" or "(meaning May 30, 2023)"
* and expands them to "(meaning May 30, 2023 - which was 3 weeks ago)"
*/
function expandInlineEstimatedDates(observations, currentDate) {
	return observations.replace(/\((estimated|meaning)\s+([^)]+\d{4})\)/gi, (match, prefix, dateContent, offset) => {
		const targetDate = parseDateFromContent(dateContent);
		if (targetDate) {
			const relative = formatRelativeTime(targetDate, currentDate);
			const lineStart = observations.lastIndexOf("\n", offset) + 1;
			const lineBeforeDate = observations.slice(lineStart, offset);
			const isPastDate = targetDate < currentDate;
			const isFutureIntent = isFutureIntentObservation(lineBeforeDate);
			if (isPastDate && isFutureIntent) return `(${prefix} ${dateContent} - ${relative}, likely already happened)`;
			return `(${prefix} ${dateContent} - ${relative})`;
		}
		return match;
	});
}
/**
* Add relative time annotations to observations.
* Transforms "Date: May 15, 2023" headers to "Date: May 15, 2023 (5 days ago)"
* and expands inline estimated dates with relative time context.
*/
function addRelativeTimeToObservations(observations, currentDate) {
	const withInlineDates = expandInlineEstimatedDates(observations, currentDate);
	const dateHeaderRegex = /^(Date:\s*)([A-Z][a-z]+ \d{1,2}, \d{4})$/gm;
	const dates = [];
	let regexMatch;
	while ((regexMatch = dateHeaderRegex.exec(withInlineDates)) !== null) {
		const dateStr = regexMatch[2];
		const parsed = new Date(dateStr);
		if (!isNaN(parsed.getTime())) dates.push({
			index: regexMatch.index,
			date: parsed,
			match: regexMatch[0],
			prefix: regexMatch[1],
			dateStr
		});
	}
	if (dates.length === 0) return withInlineDates;
	let result = "";
	let lastIndex = 0;
	for (let i = 0; i < dates.length; i++) {
		const curr = dates[i];
		const prev = i > 0 ? dates[i - 1] : null;
		result += withInlineDates.slice(lastIndex, curr.index);
		if (prev) {
			const gap = formatGapBetweenDates(prev.date, curr.date);
			if (gap) result += `\n${gap}\n\n`;
		}
		const relative = formatRelativeTime(curr.date, currentDate);
		result += `${curr.prefix}${curr.dateStr} (${relative})`;
		lastIndex = curr.index + curr.match.length;
	}
	result += withInlineDates.slice(lastIndex);
	return result;
}
function formatTemporalGap(diffMs) {
	if (diffMs < 6e5) return null;
	const minute = 60 * 1e3;
	const hour = 60 * minute;
	const day = 24 * hour;
	const week = 7 * day;
	const month = 30 * day;
	const year = 365 * day;
	const formatUnit = (value, unit) => `${value} ${unit}${value === 1 ? "" : "s"}`;
	if (diffMs < hour) return `${formatUnit(Math.max(1, Math.round(diffMs / minute)), "minute")} later`;
	const formatTwoUnits = (primaryMs, primaryUnit, secondaryMs, secondaryUnit) => {
		const primary = Math.floor(diffMs / primaryMs);
		const remainder = diffMs - primary * primaryMs;
		const secondary = Math.floor(remainder / secondaryMs);
		const parts = [formatUnit(primary, primaryUnit)];
		if (secondary > 0) parts.push(formatUnit(secondary, secondaryUnit));
		return `${parts.join(" ")} later`;
	};
	if (diffMs < day) return formatTwoUnits(hour, "hour", minute, "minute");
	if (diffMs < week) return formatTwoUnits(day, "day", hour, "hour");
	if (diffMs < month) return formatTwoUnits(week, "week", day, "day");
	if (diffMs < year) return formatTwoUnits(month, "month", week, "week");
	return formatTwoUnits(year, "year", month, "month");
}
function formatTemporalTimestamp(date) {
	return date.toLocaleString("en-US", {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "numeric",
		minute: "2-digit",
		hour12: true,
		timeZoneName: "short"
	});
}
function getMessagePartTimestamp(msg, position) {
	const timestamps = msg.content?.parts?.map((part) => "createdAt" in part ? part.createdAt : void 0).filter((timestamp) => typeof timestamp === "number");
	if (timestamps && timestamps.length > 0) {
		const timestamp = timestamps[position === "first" ? 0 : timestamps.length - 1];
		if (timestamp !== void 0) return timestamp;
	}
	return new Date(msg.createdAt).getTime();
}
function isTemporalGapMarker(msg) {
	return msg.id.startsWith("__temporal_");
}
//#endregion
//#region src/processors/observational-memory/string-utils.ts
/**
* Slice a string up to `end` UTF-16 code units without splitting a surrogate
* pair. If `end` would land immediately after a lone high surrogate
* (U+D800..U+DBFF), the slice backs off by one code unit so the pair is
* dropped as a whole.
*
* Lone UTF-16 surrogates are rejected by strict JSON parsers (e.g. Anthropic's
* with `no low surrogate in string`), so any truncation of observer-facing
* text that could cut an emoji/astral codepoint in half must go through this
* helper.
*/
function safeSlice(str, end) {
	if (end <= 0) return "";
	if (end >= str.length) return str;
	const code = str.charCodeAt(end - 1);
	const safeEnd = code >= 55296 && code <= 56319 ? end - 1 : end;
	return str.slice(0, safeEnd);
}
//#endregion
//#region src/processors/observational-memory/tool-result-helpers.ts
const ENCRYPTED_CONTENT_KEY = "encryptedContent";
const ENCRYPTED_CONTENT_REDACTION_THRESHOLD = 256;
function isObjectLike(value) {
	return typeof value === "object" && value !== null;
}
function sanitizeToolResultValue(value, seen = /* @__PURE__ */ new WeakMap()) {
	if (!isObjectLike(value)) return value;
	if (seen.has(value)) return seen.get(value);
	if (Array.isArray(value)) {
		const sanitizedArray = [];
		seen.set(value, sanitizedArray);
		for (const item of value) sanitizedArray.push(sanitizeToolResultValue(item, seen));
		return sanitizedArray;
	}
	const sanitizedObject = {};
	seen.set(value, sanitizedObject);
	for (const [key, entry] of Object.entries(value)) {
		if (key === ENCRYPTED_CONTENT_KEY && typeof entry === "string" && entry.length > ENCRYPTED_CONTENT_REDACTION_THRESHOLD) {
			sanitizedObject[key] = `[stripped encryptedContent: ${entry.length} characters]`;
			continue;
		}
		sanitizedObject[key] = sanitizeToolResultValue(entry, seen);
	}
	return sanitizedObject;
}
function stringifyToolResult(value) {
	if (typeof value === "string") return value;
	const sanitized = sanitizeToolResultValue(value);
	try {
		return JSON.stringify(sanitized, null, 2);
	} catch {
		return String(sanitized);
	}
}
function resolveToolResultValue(part, invocationResult) {
	const mastraMetadata = part?.providerMetadata?.mastra;
	if (mastraMetadata && typeof mastraMetadata === "object" && "modelOutput" in mastraMetadata) return {
		value: mastraMetadata.modelOutput,
		usingStoredModelOutput: true
	};
	return {
		value: invocationResult,
		usingStoredModelOutput: false
	};
}
function truncateStringByTokens(text, maxTokens) {
	if (!text || maxTokens <= 0) return "";
	const totalTokens = estimateTokenCount(text);
	if (totalTokens <= maxTokens) return text;
	const buildCandidate = (sliceEnd) => {
		const visible = safeSlice(text, sliceEnd);
		return `${visible}\n... [truncated ~${totalTokens - estimateTokenCount(visible)} tokens]`;
	};
	let low = 0;
	let high = text.length;
	let best = buildCandidate(0);
	while (low <= high) {
		const mid = Math.floor((low + high) / 2);
		const candidate = buildCandidate(mid);
		if (estimateTokenCount(candidate) <= maxTokens) {
			best = candidate;
			low = mid + 1;
		} else high = mid - 1;
	}
	return best;
}
function formatToolResultForObserver(value, options) {
	return truncateStringByTokens(stringifyToolResult(value), options?.maxTokens ?? 1e4);
}
//#endregion
//#region src/processors/observational-memory/observer-agent.ts
/**
* The core extraction instructions for the Observer.
* This is exported so the Reflector can understand how observations were created.
*/
const OBSERVER_EXTRACTION_INSTRUCTIONS = `CRITICAL: DISTINGUISH USER ASSERTIONS FROM QUESTIONS

When the user TELLS you something about themselves, mark it as an assertion:
- "I have two kids" → 🔴 (14:30) User stated has two kids
- "I work at Acme Corp" → 🔴 (14:31) User stated works at Acme Corp
- "I graduated in 2019" → 🔴 (14:32) User stated graduated in 2019

When the user ASKS about something, mark it as a question/request:
- "Can you help me with X?" → 🔴 (15:00) User asked help with X
- "What's the best way to do Y?" → 🔴 (15:01) User asked best way to do Y

Distinguish between QUESTIONS and STATEMENTS OF INTENT:
- "Can you recommend..." → Question (extract as "User asked...")
- "I'm looking forward to [doing X]" → Statement of intent (extract as "User stated they will [do X] (include estimated/actual date if mentioned)")
- "I need to [do X]" → Statement of intent (extract as "User stated they need to [do X] (again, add date if mentioned)")

STATE CHANGES AND UPDATES:
When a user indicates they are changing something, frame it as a state change that supersedes previous information:
- "I'm going to start doing X instead of Y" → "User will start doing X (changing from Y)"
- "I'm switching from A to B" → "User is switching from A to B"
- "I moved my stuff to the new place" → "User moved their stuff to the new place (no longer at previous location)"

If the new state contradicts or updates previous information, make that explicit:
- BAD: "User plans to use the new method"
- GOOD: "User will use the new method (replacing the old approach)"

This helps distinguish current state from outdated information.

USER ASSERTIONS ARE AUTHORITATIVE. The user is the source of truth about their own life.
If a user previously stated something and later asks a question about the same topic,
the assertion is the answer - the question doesn't invalidate what they already told you.

TEMPORAL ANCHORING:
Each observation has TWO potential timestamps:

1. BEGINNING: The time the statement was made (from the message timestamp) - ALWAYS include this
2. END: The time being REFERENCED, if different from when it was said - ONLY when there's a relative time reference

ONLY add "(meaning DATE)" or "(estimated DATE)" at the END when you can provide an ACTUAL DATE:
- Past: "last week", "yesterday", "a few days ago", "last month", "in March"
- Future: "this weekend", "tomorrow", "next week"

DO NOT add end dates for:
- Present-moment statements with no time reference
- Vague references like "recently", "a while ago", "lately", "soon" - these cannot be converted to actual dates

FORMAT:
- With time reference: (TIME) [observation]. (meaning/estimated DATE)
- Without time reference: (TIME) [observation].

GOOD: (09:15) User's friend had a birthday party in March. (meaning March 20XX)
      ^ References a past event - add the referenced date at the end

GOOD: (09:15) User will visit their parents this weekend. (meaning June 17-18, 20XX)
      ^ References a future event - add the referenced date at the end

GOOD: (09:15) User prefers hiking in the mountains.
      ^ Present-moment preference, no time reference - NO end date needed

GOOD: (09:15) User is considering adopting a dog.
      ^ Present-moment thought, no time reference - NO end date needed

BAD: (09:15) User prefers hiking in the mountains. (meaning June 15, 20XX - today)
     ^ No time reference in the statement - don't repeat the message timestamp at the end

IMPORTANT: If an observation contains MULTIPLE events, split them into SEPARATE observation lines.
EACH split observation MUST have its own date at the end - even if they share the same time context.

Examples (assume message is from June 15, 20XX):

BAD: User will visit their parents this weekend (meaning June 17-18, 20XX) and go to the dentist tomorrow.
GOOD (split into two observations, each with its date):
  User will visit their parents this weekend. (meaning June 17-18, 20XX)
  User will go to the dentist tomorrow. (meaning June 16, 20XX)

BAD: User needs to clean the garage this weekend and is looking forward to setting up a new workbench.
GOOD (split, BOTH get the same date since they're related):
  User needs to clean the garage this weekend. (meaning June 17-18, 20XX)
  User will set up a new workbench this weekend. (meaning June 17-18, 20XX)

BAD: User was given a gift by their friend (estimated late May 20XX) last month.
GOOD: (09:15) User was given a gift by their friend last month. (estimated late May 20XX)
      ^ Message time at START, relative date reference at END - never in the middle

BAD: User started a new job recently and will move to a new apartment next week.
GOOD (split):
  User started a new job recently.
  User will move to a new apartment next week. (meaning June 21-27, 20XX)
  ^ "recently" is too vague for a date - omit the end date. "next week" can be calculated.

ALWAYS put the date at the END in parentheses - this is critical for temporal reasoning.
When splitting related events that share the same time context, EACH observation must have the date.

PRESERVE UNUSUAL PHRASING:
When the user uses unexpected or non-standard terminology, quote their exact words.

BAD: User exercised.
GOOD: User stated they did a "movement session" (their term for exercise).

USE PRECISE ACTION VERBS:
Replace vague verbs like "getting", "got", "have" with specific action verbs that clarify the nature of the action.
If the assistant confirms or clarifies the user's action, use the assistant's more precise language.

BAD: User is getting X.
GOOD: User subscribed to X. (if context confirms recurring delivery)
GOOD: User purchased X. (if context confirms one-time acquisition)

BAD: User got something.
GOOD: User purchased / received / was given something. (be specific)

Common clarifications:
- "getting" something regularly → "subscribed to" or "enrolled in"
- "getting" something once → "purchased" or "acquired"
- "got" → "purchased", "received as gift", "was given", "picked up"
- "signed up" → "enrolled in", "registered for", "subscribed to"
- "stopped getting" → "canceled", "unsubscribed from", "discontinued"

When the assistant interprets or confirms the user's vague language, prefer the assistant's precise terminology.

PRESERVING DETAILS IN ASSISTANT-GENERATED CONTENT:

When the assistant provides lists, recommendations, or creative content that the user explicitly requested,
preserve the DISTINGUISHING DETAILS that make each item unique and queryable later.

1. RECOMMENDATION LISTS - Preserve the key attribute that distinguishes each item:
   BAD: Assistant recommended 5 hotels in the city.
   GOOD: Assistant recommended hotels: Hotel A (near the train station), Hotel B (budget-friendly), 
         Hotel C (has rooftop pool), Hotel D (pet-friendly), Hotel E (historic building).
   
   BAD: Assistant listed 3 online stores for craft supplies.
   GOOD: Assistant listed craft stores: Store A (based in Germany, ships worldwide), 
         Store B (specializes in vintage fabrics), Store C (offers bulk discounts).

2. NAMES, HANDLES, AND IDENTIFIERS - Always preserve specific identifiers:
   BAD: Assistant provided social media accounts for several photographers.
   GOOD: Assistant provided photographer accounts: @photographer_one (portraits), 
         @photographer_two (landscapes), @photographer_three (nature).
   
   BAD: Assistant listed some authors to check out.
   GOOD: Assistant recommended authors: Jane Smith (mystery novels), 
         Bob Johnson (science fiction), Maria Garcia (historical romance).

3. CREATIVE CONTENT - Preserve structure and key sequences:
   BAD: Assistant wrote a poem with multiple verses.
   GOOD: Assistant wrote a 3-verse poem. Verse 1 theme: loss. Verse 2 theme: hope. 
         Verse 3 theme: renewal. Refrain: "The light returns."
   
   BAD: User shared their lucky numbers from a fortune cookie.
   GOOD: User's fortune cookie lucky numbers: 7, 14, 23, 38, 42, 49.

4. TECHNICAL/NUMERICAL RESULTS - Preserve specific values:
   BAD: Assistant explained the performance improvements from the optimization.
   GOOD: Assistant explained the optimization achieved 43.7% faster load times 
         and reduced memory usage from 2.8GB to 940MB.
   
   BAD: Assistant provided statistics about the dataset.
   GOOD: Assistant provided dataset stats: 7,342 samples, 89.6% accuracy, 
         23ms average inference time.

5. QUANTITIES AND COUNTS - Always preserve how many of each item:
   BAD: Assistant listed items with details but no quantities.
   GOOD: Assistant listed items: Item A (4 units, size large), Item B (2 units, size small).
   
   When listing items with attributes, always include the COUNT first before other details.

6. ROLE/PARTICIPATION STATEMENTS - When user mentions their role at an event:
   BAD: User attended the company event.
   GOOD: User was a presenter at the company event.
   
   BAD: User went to the fundraiser.
   GOOD: User volunteered at the fundraiser (helped with registration).
   
   Always capture specific roles: presenter, organizer, volunteer, team lead, 
   coordinator, participant, contributor, helper, etc.

CONVERSATION CONTEXT:
- What the user is working on or asking about
- Previous topics and their outcomes
- What user understands or needs clarification on
- Specific requirements or constraints mentioned
- Contents of assistant learnings and summaries
- Answers to users questions including full context to remember detailed summaries and explanations
- Assistant explanations, especially complex ones. observe the fine details so that the assistant does not forget what they explained
- Relevant code snippets
- User preferences (like favourites, dislikes, preferences, etc)
- Any specifically formatted text or ascii that would need to be reproduced or referenced in later interactions (preserve these verbatim in memory)
- Sequences, units, measurements, and any kind of specific relevant data
- Any blocks of any text which the user and assistant are iteratively collaborating back and forth on should be preserved verbatim
- When who/what/where/when is mentioned, note that in the observation. Example: if the user received went on a trip with someone, observe who that someone was, where the trip was, when it happened, and what happened, not just that the user went on the trip.
- For any described entity (like a person, place, thing, etc), preserve the attributes that would help identify or describe the specific entity later: location ("near X"), specialty ("focuses on Y"), unique feature ("has Z"), relationship ("owned by W"), or other details. The entity's name is important, but so are any additional details that distinguish it. If there are a list of entities, preserve these details for each of them.

USER MESSAGE CAPTURE:
- Short and medium-length user messages should be captured nearly verbatim in your own words.
- For very long user messages, summarize but quote key phrases that carry specific intent or meaning.
- This is critical for continuity: when the conversation window shrinks, the observations are the only record of what the user said.

AVOIDING REPETITIVE OBSERVATIONS:
- Do NOT repeat the same observation across multiple turns if there is no new information.
- When the agent performs repeated similar actions (e.g., browsing files, running the same tool type multiple times), group them into a single parent observation with sub-bullets for each new result.

Example — BAD (repetitive):
* 🟡 (14:30) Agent used view tool on src/auth.ts
* 🟡 (14:31) Agent used view tool on src/users.ts
* 🟡 (14:32) Agent used view tool on src/routes.ts

Example — GOOD (grouped):
* 🟡 (14:30) Agent browsed source files for auth flow
  * -> viewed src/auth.ts — found token validation logic
  * -> viewed src/users.ts — found user lookup by email
  * -> viewed src/routes.ts — found middleware chain

Only add a new observation for a repeated action if the NEW result changes the picture.

ACTIONABLE INSIGHTS:
- What worked well in explanations
- What needs follow-up or clarification
- User's stated goals or next steps (note if the user tells you not to do a next step, or asks for something specific, other next steps besides the users request should be marked as "waiting for user", unless the user explicitly says to continue all next steps)

COMPLETION TRACKING:
Completion observations are not just summaries. They are explicit memory signals to the assistant that a task, question, or subtask has been resolved.
Without clear completion markers, the assistant may forget that work is already finished and may repeat, reopen, or continue an already-completed task.

Use ✅ to answer: "What exactly is now done?"
Choose completion observations that help the assistant know what is finished and should not be reworked unless new information appears.

Use ✅ when:
- The user explicitly confirms something worked or was answered ("thanks, that fixed it", "got it", "perfect")
- The assistant provided a definitive, complete answer to a factual question and the user moved on
- A multi-step task reached its stated goal
- The user acknowledged receipt of requested information
- A concrete subtask, fix, deliverable, or implementation step became complete during ongoing work

Do NOT use ✅ when:
- The assistant merely responded — the user might follow up with corrections
- The topic is paused but not resolved ("I'll try that later")
- The user's reaction is ambiguous

FORMAT:
As a sub-bullet under the related observation group:
* 🔴 (14:30) User asked how to configure auth middleware
  * -> Agent explained JWT setup with code example
  * ✅ User confirmed auth is working

Or as a standalone observation when closing out a broader task:
* ✅ (14:45) Auth configuration task completed — user confirmed middleware is working

Completion observations should be terse but specific about WHAT was completed.
Prefer concrete resolved outcomes over abstract workflow status so the assistant remembers what is already done.`;
buildObserverOutputFormat();
function buildObserverOutputFormat(extractors = []) {
	const extractorSections = buildExtractorOutputSections(extractors);
	const legacyContinuationSections = extractors.length === 0 ? `
<current-task>
State the current task(s) explicitly:
- Primary: What the agent is currently working on
- Secondary: Other pending tasks (mark as "waiting for user" if appropriate)
</current-task>

<suggested-response>
Hint for the agent's immediate next message. Examples:
- "I've updated the navigation model. Let me walk you through the changes..."
- "The assistant should wait for the user to respond before continuing."
- Call the view tool on src/example.ts to continue debugging.
</suggested-response>` : "";
	return `Use priority levels:
- 🔴 High: explicit user facts, preferences, unresolved goals, critical context
- 🟡 Medium: project details, learned information, tool results
- 🟢 Low: minor details, uncertain observations
- ✅ Completed: concrete task finished, question answered, issue resolved, goal achieved, or subtask completed in a way that helps the assistant know it is done

Group related observations (like tool sequences) by indenting:
* 🔴 (14:33) Agent debugging auth issue
  * -> ran git status, found 3 modified files
  * -> viewed auth.ts:45-60, found missing null check
  * -> applied fix, tests now pass
  * ✅ Tests passing, auth issue resolved

Group observations by date, then list each with 24-hour time.

<observations>
Date: Dec 4, 2025
* 🔴 (14:30) User prefers direct answers
* 🔴 (14:31) Working on feature X
* 🟡 (14:32) User might prefer dark mode

Date: Dec 5, 2025
* 🔴 (09:15) Continued work on feature X
</observations>

${extractorSections || legacyContinuationSections}`;
}
/**
* The guidelines for the Observer.
* This is exported so the Reflector can reference them.
*/
const OBSERVER_GUIDELINES = `- Be specific enough for the assistant to act on
- Good: "User prefers short, direct answers without lengthy explanations"
- Bad: "User stated a preference" (too vague)
- Add 1 to 5 observations per exchange
- Use terse language to save tokens. Sentences should be dense without unnecessary words
- Do not add repetitive observations that have already been observed. Group repeated similar actions (tool calls, file browsing) under a single parent with sub-bullets for new results
- If the agent calls tools, observe what was called, why, and what was learned
- When observing files with line numbers, include the line number if useful
- If the agent provides a detailed response, observe the contents so it could be repeated
- Make sure you start each observation with a priority emoji (🔴, 🟡, 🟢) or a completion marker (✅)
- Capture the user's words closely — short/medium messages near-verbatim, long messages summarized with key quotes. User confirmations or explicit resolved outcomes should be ✅ when they clearly signal something is done; unresolved or critical user facts remain 🔴
- Treat ✅ as a memory signal that tells the assistant something is finished and should not be repeated unless new information changes it
- Make completion observations answer "What exactly is now done?"
- Prefer concrete resolved outcomes over meta-level workflow or bookkeeping updates
- When multiple concrete things were completed, capture the concrete completed work rather than collapsing it into a vague progress summary
- Observe WHAT the agent did and WHAT it means
- If the user provides detailed messages or code snippets, observe all important details`;
/**
* Build the complete observer system prompt.
* @param multiThread - Whether this is for multi-thread batched observation (default: false)
* @param instruction - Optional custom instructions to append to the prompt
*/
function buildObserverSystemPrompt(multiThread = false, instruction, includeThreadTitle = false, extractors = []) {
	const outputFormat = buildObserverOutputFormat(extractors);
	const multiThreadTitleInstruction = includeThreadTitle ? ` Each thread's observations, current-task, suggested-response, and thread-title should be nested inside a <thread id="..."> block within <observations>.` : ` Each thread's observations, current-task, and suggested-response should be nested inside a <thread id="..."> block within <observations>.`;
	const multiThreadTitleExample = includeThreadTitle ? `
<thread-title>Feature X implementation</thread-title>` : "";
	const multiThreadSecondTitleExample = includeThreadTitle ? `
<thread-title>Deployment setup</thread-title>` : "";
	if (multiThread) return `You are the memory consciousness of an AI assistant. Your observations will be the ONLY information the assistant has about past interactions with this user.

Extract observations that will help the assistant remember:

${OBSERVER_EXTRACTION_INSTRUCTIONS}

=== MULTI-THREAD INPUT ===

You will receive messages from MULTIPLE conversation threads, each wrapped in <thread id="..."> tags.
Process each thread separately and output observations for each thread.

=== OUTPUT FORMAT ===

Your output MUST use XML tags to structure the response.${multiThreadTitleInstruction}

Use this observation format inside each thread block:

${outputFormat}

For multi-thread output, wrap each thread's observations like this:

<observations>
<thread id="thread_id_1">
Date: Dec 4, 2025
* 🔴 (14:30) User prefers direct answers
* 🔴 (14:31) Working on feature X

<current-task>
What the agent is currently working on in this thread
</current-task>

<suggested-response>
Hint for the agent's next message in this thread
</suggested-response>${multiThreadTitleExample}
</thread>

<thread id="thread_id_2">
Date: Dec 5, 2025
* 🔴 (09:15) User asked about deployment

<current-task>
Current task for this thread
</current-task>

<suggested-response>
Suggested response for this thread
</suggested-response>${multiThreadSecondTitleExample}
</thread>
</observations>

=== GUIDELINES ===

${OBSERVER_GUIDELINES}

Remember: These observations are the assistant's ONLY memory. Make them count.

User messages are extremely important. If the user asks a question or gives a new task, make it clear in <current-task> that this is the priority.${instruction ? `\n\n=== CUSTOM INSTRUCTIONS ===\n\n${instruction}` : ""}`;
	return `You are the memory consciousness of an AI assistant. Your observations will be the ONLY information the assistant has about past interactions with this user.

Extract observations that will help the assistant remember:

${OBSERVER_EXTRACTION_INSTRUCTIONS}

=== OUTPUT FORMAT ===

Your output MUST use XML tags to structure the response. This allows the system to properly parse and manage memory over time.

${outputFormat}

=== GUIDELINES ===

${OBSERVER_GUIDELINES}

=== IMPORTANT: THREAD ATTRIBUTION ===

Do NOT add thread identifiers, thread IDs, or <thread> tags to your observations.
Thread attribution is handled externally by the system.
Simply output your observations without any thread-related markup.

Remember: These observations are the assistant's ONLY memory. Make them count.

User messages are extremely important. If the user asks a question or gives a new task, make it clear in <current-task> that this is the priority. If the assistant needs to respond to the user, indicate in <suggested-response> that it should pause for user reply before continuing other tasks.${instruction ? `\n\n=== CUSTOM INSTRUCTIONS ===\n\n${instruction}` : ""}`;
}
/**
* Observer Agent System Prompt (default - for backwards compatibility)
*
* This prompt instructs the Observer to extract observations from message history.
* The observations become the agent's "subconscious memory" - the ONLY information
* the main agent will have about past interactions.
*/
const OBSERVER_SYSTEM_PROMPT = buildObserverSystemPrompt();
const OBSERVER_IMAGE_FILE_EXTENSIONS = /* @__PURE__ */ new Set([
	"png",
	"jpg",
	"jpeg",
	"webp",
	"gif",
	"bmp",
	"tiff",
	"tif",
	"heic",
	"heif",
	"avif"
]);
function formatObserverDate(createdAt) {
	return createdAt ? `${createdAt.toLocaleDateString("en-US", { month: "short" })} ${createdAt.getDate()} ${createdAt.getFullYear()}` : "";
}
function formatObserverTime(createdAt) {
	return createdAt ? createdAt.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "2-digit",
		hour12: true
	}) : "";
}
function getObserverPathExtension(value) {
	return (value.split("#", 1)[0]?.split("?", 1)[0] ?? value).match(/\.([a-z0-9]+)$/i)?.[1]?.toLowerCase();
}
function hasObserverImageFilenameExtension(filename) {
	return typeof filename === "string" && OBSERVER_IMAGE_FILE_EXTENSIONS.has(getObserverPathExtension(filename) ?? "");
}
function isImageLikeObserverFilePart(part) {
	if (part.type !== "file") return false;
	if (typeof part.mimeType === "string" && part.mimeType.toLowerCase().startsWith("image/")) return true;
	if (typeof part.data === "string" && part.data.startsWith("data:image/")) return true;
	if (part.data instanceof URL && hasObserverImageFilenameExtension(part.data.pathname)) return true;
	if (typeof part.data === "string") try {
		const url = new URL(part.data);
		if ((url.protocol === "http:" || url.protocol === "https:") && hasObserverImageFilenameExtension(url.pathname)) return true;
	} catch {}
	return hasObserverImageFilenameExtension(part.filename);
}
function resolveObserverAttachmentMimeType(part) {
	if (typeof part.mimeType === "string" && part.mimeType.length > 0) return part.mimeType.toLowerCase();
	if (part.type === "image") return "image/*";
	if (isImageLikeObserverFilePart(part)) return "image/*";
	return "application/octet-stream";
}
function matchObserverMimePattern(mimeType, pattern) {
	const normalized = pattern.trim().toLowerCase();
	if (!normalized) return false;
	if (normalized === "*" || normalized === "*/*") return true;
	if (normalized.endsWith("/*")) {
		const prefix = normalized.slice(0, normalized.length - 1);
		return mimeType.startsWith(prefix);
	}
	return mimeType === normalized;
}
function shouldIncludeObserverAttachment(part, filter) {
	if (filter === void 0 || filter === true) return true;
	if (filter === false) return false;
	if (!Array.isArray(filter) || filter.length === 0) return false;
	const mimeType = resolveObserverAttachmentMimeType(part);
	return filter.some((pattern) => matchObserverMimePattern(mimeType, pattern));
}
function toObserverInputAttachmentPart(part) {
	if (part.type === "image") return {
		type: "image",
		image: part.image,
		mimeType: part.mimeType,
		providerOptions: part.providerOptions,
		providerMetadata: part.providerMetadata,
		experimental_providerMetadata: part.experimental_providerMetadata
	};
	if (isImageLikeObserverFilePart(part)) return {
		type: "image",
		image: part.data,
		mimeType: part.mimeType,
		providerOptions: part.providerOptions,
		providerMetadata: part.providerMetadata,
		experimental_providerMetadata: part.experimental_providerMetadata
	};
	return {
		type: "file",
		data: part.data,
		mimeType: part.mimeType,
		filename: part.filename,
		providerOptions: part.providerOptions,
		providerMetadata: part.providerMetadata,
		experimental_providerMetadata: part.experimental_providerMetadata
	};
}
function resolveObserverAttachmentLabel(part) {
	if (part.filename?.trim()) return part.filename.trim();
	const asset = part.type === "image" ? part.image : part.data;
	if (typeof asset !== "string" || asset.startsWith("data:")) return part.mimeType;
	try {
		const basename = new URL(asset).pathname.split("/").filter(Boolean).pop();
		return basename ? decodeURIComponent(basename) : part.mimeType;
	} catch {
		return part.mimeType;
	}
}
function formatObserverAttachmentPlaceholder(part, counter) {
	const attachmentType = part.type === "image" || isImageLikeObserverFilePart(part) ? "Image" : "File";
	const attachmentId = attachmentType === "Image" ? counter.nextImageId++ : counter.nextFileId++;
	const label = resolveObserverAttachmentLabel(part);
	return label ? `[${attachmentType} #${attachmentId}: ${label}]` : `[${attachmentType} #${attachmentId}]`;
}
function isRecord$2(value) {
	return !!value && typeof value === "object";
}
function mapToolResultBlockToAttachment(block) {
	if (!isRecord$2(block) || typeof block.type !== "string") return;
	const mediaType = typeof block.mediaType === "string" ? block.mediaType : void 0;
	const filename = typeof block.filename === "string" ? block.filename : void 0;
	switch (block.type) {
		case "image-data": {
			const data = block.data;
			if (typeof data !== "string") return void 0;
			return {
				type: "image",
				image: mediaType ? `data:${mediaType};base64,${data}` : data,
				mimeType: mediaType
			};
		}
		case "image-url": {
			const url = block.url;
			if (typeof url !== "string") return void 0;
			return {
				type: "image",
				image: url,
				mimeType: mediaType
			};
		}
		case "media": {
			const data = block.data;
			if (typeof data !== "string" || !mediaType) return void 0;
			const dataUri = `data:${mediaType};base64,${data}`;
			if (mediaType.toLowerCase().startsWith("image/")) return {
				type: "image",
				image: dataUri,
				mimeType: mediaType
			};
			return {
				type: "file",
				data: dataUri,
				mimeType: mediaType
			};
		}
		case "file-data": {
			const data = block.data;
			if (typeof data !== "string") return void 0;
			return {
				type: "file",
				data: mediaType ? `data:${mediaType};base64,${data}` : data,
				mimeType: mediaType,
				filename
			};
		}
		case "file-url": {
			const url = block.url;
			if (typeof url !== "string") return void 0;
			return {
				type: "file",
				data: url,
				mimeType: mediaType,
				filename
			};
		}
		default: return;
	}
}
function extractToolResultAttachments(result, counter, attachmentFilter) {
	if (!isRecord$2(result) || result.type !== "content" || !Array.isArray(result.value)) return {
		resultWithoutAttachments: result,
		attachments: []
	};
	const record = result;
	const attachments = [];
	let hadAttachmentBlocks = false;
	const newValue = record.value.map((block) => {
		const attachment = mapToolResultBlockToAttachment(block);
		if (!attachment) return block;
		hadAttachmentBlocks = true;
		if (shouldIncludeObserverAttachment(attachment, attachmentFilter)) attachments.push(toObserverInputAttachmentPart(attachment));
		const placeholder = formatObserverAttachmentPlaceholder(attachment, counter);
		return {
			type: isRecord$2(block) ? block.type : void 0,
			placeholder
		};
	});
	if (!hadAttachmentBlocks) return {
		resultWithoutAttachments: result,
		attachments
	};
	return {
		resultWithoutAttachments: {
			...record,
			value: newValue
		},
		attachments
	};
}
function formatObserverPartLine(title, body, time, previousTime) {
	const timeLabel = time && time !== previousTime ? `(${time})` : "";
	if (!title) return timeLabel ? `${timeLabel}: ${body}` : body;
	return `${title}${timeLabel ? ` ${timeLabel}` : ""}: ${body}`;
}
function normalizeObserverCreatedAt(createdAt) {
	if (createdAt instanceof Date) {
		if (Number.isNaN(createdAt.getTime())) return;
		return createdAt;
	}
	if (typeof createdAt === "number" || typeof createdAt === "string") {
		const date = new Date(createdAt);
		if (Number.isNaN(date.getTime())) return;
		return date;
	}
}
function formatObserverLines(lines, context = {}) {
	const output = [];
	let previousDate = context.previousDate;
	let previousTime = context.previousTime;
	for (const line of lines) {
		if (line.date && line.date !== previousDate) {
			output.push(`${line.date}:`);
			previousDate = line.date;
			previousTime = void 0;
		}
		output.push(formatObserverPartLine(line.title, line.body, line.time, previousTime));
		previousTime = line.time || previousTime;
	}
	return {
		text: output.join("\n"),
		context: {
			previousDate,
			previousTime
		}
	};
}
function getTemporalGapMarkerText(msg) {
	const metadata = typeof msg.content === "object" && msg.content && "metadata" in msg.content ? msg.content.metadata : void 0;
	if (metadata?.reminderType === "temporal-gap" && typeof metadata.gapText === "string") return metadata.gapText;
	if (typeof metadata?.systemReminder === "object" && metadata.systemReminder && "type" in metadata.systemReminder && metadata.systemReminder.type === "temporal-gap" && "gapText" in metadata.systemReminder && typeof metadata.systemReminder.gapText === "string") return metadata.systemReminder.gapText;
}
function formatObserverMessage(msg, counter, options) {
	const maxLen = options?.maxPartLength;
	const maxToolResultTokens = options?.maxToolResultTokens ?? 1e4;
	const attachmentFilter = options?.attachmentFilter;
	const role = msg.role.charAt(0).toUpperCase() + msg.role.slice(1);
	const attachments = [];
	const messageCreatedAt = normalizeObserverCreatedAt(msg.createdAt);
	let lines = [];
	const temporalGapText = isTemporalGapMarker(msg) ? getTemporalGapMarkerText(msg) : void 0;
	const pushLine = (title, body, createdAt) => {
		if (!body) return;
		const normalizedCreatedAt = normalizeObserverCreatedAt(createdAt) ?? messageCreatedAt;
		lines.push({
			date: formatObserverDate(normalizedCreatedAt),
			time: formatObserverTime(normalizedCreatedAt),
			title,
			body
		});
	};
	if (temporalGapText) pushLine("", temporalGapText, messageCreatedAt);
	else if (typeof msg.content === "string") pushLine(role, maybeTruncate(msg.content, maxLen), messageCreatedAt);
	else if (msg.content?.parts && Array.isArray(msg.content.parts) && msg.content.parts.length > 0) msg.content.parts.forEach((part) => {
		const partCreatedAt = normalizeObserverCreatedAt(part.createdAt) ?? messageCreatedAt;
		if (part.type === "text") {
			pushLine(role, maybeTruncate(part.text, maxLen), partCreatedAt);
			return;
		}
		if (part.type === "tool-invocation") {
			const inv = part.toolInvocation;
			if (inv.state === "result") {
				const { value: resultForObserver } = resolveToolResultValue(part, inv.result);
				const { resultWithoutAttachments, attachments: extractedAttachments } = extractToolResultAttachments(resultForObserver, counter, attachmentFilter);
				if (extractedAttachments.length > 0) attachments.push(...extractedAttachments);
				pushLine(`Tool Result ${inv.toolName}`, maybeTruncate(formatToolResultForObserver(resultWithoutAttachments, { maxTokens: maxToolResultTokens }), maxLen), partCreatedAt);
				return;
			}
			pushLine(`Tool Call ${inv.toolName}`, maybeTruncate(JSON.stringify(inv.args, null, 2), maxLen), partCreatedAt);
			return;
		}
		const partType = part.type;
		if (partType === "reasoning") {
			const reasoning = part.reasoning;
			if (!reasoning) return;
			pushLine("Reasoning", maybeTruncate(reasoning, maxLen), partCreatedAt);
			return;
		}
		if (partType === "image" || partType === "file") {
			const attachment = part;
			if (shouldIncludeObserverAttachment(attachment, attachmentFilter)) {
				const inputAttachment = toObserverInputAttachmentPart(attachment);
				if (inputAttachment) attachments.push(inputAttachment);
			}
			pushLine(partType === "image" ? "Image" : "File", formatObserverAttachmentPlaceholder(attachment, counter), partCreatedAt);
		}
	});
	else if (msg.content?.content) pushLine(role, maybeTruncate(msg.content.content, maxLen), messageCreatedAt);
	if (lines.length === 0 && attachments.length === 0) return {
		lines: [],
		attachments
	};
	return {
		lines,
		attachments
	};
}
function formatMessagesForObserver(messages, options) {
	const counter = {
		nextImageId: 1,
		nextFileId: 1
	};
	const sections = [];
	let context = {};
	for (const message of messages) {
		const formatted = formatObserverMessage(message, counter, options);
		if (formatted.lines.length === 0) continue;
		const rendered = formatObserverLines(formatted.lines, context);
		if (!rendered.text) continue;
		sections.push(rendered.text);
		context = rendered.context;
	}
	return sections.join("\n");
}
function appendFormattedObserverMessage(content, formatted, context) {
	const rendered = formatObserverLines(formatted.lines, context);
	if (rendered.text) content.push({
		type: "text",
		text: rendered.text
	});
	content.push(...formatted.attachments);
	return rendered.context;
}
function buildObserverHistoryMessage(messages, options) {
	const counter = {
		nextImageId: 1,
		nextFileId: 1
	};
	const content = [{
		type: "text",
		text: "## New Message History to Observe\n\n"
	}];
	let context = {};
	messages.forEach((message) => {
		const formatted = formatObserverMessage(message, counter, options);
		if (formatted.lines.length === 0 && formatted.attachments.length === 0) return;
		context = appendFormattedObserverMessage(content, formatted, context);
	});
	return {
		role: "user",
		content
	};
}
/** Truncate a string to maxLen characters, appending a note if truncated. */
function maybeTruncate(str, maxLen) {
	if (!maxLen || str.length <= maxLen) return str;
	const truncated = safeSlice(str, maxLen);
	return `${truncated}\n... [truncated ${str.length - truncated.length} characters]`;
}
function buildMultiThreadObserverHistoryMessage(messagesByThread, threadOrder, options) {
	const counter = {
		nextImageId: 1,
		nextFileId: 1
	};
	const content = [{
		type: "text",
		text: `## New Message History to Observe\n\nThe following messages are from ${threadOrder.length} different conversation threads. Each thread is wrapped in a <thread id="..."> tag.\n\n`
	}];
	threadOrder.forEach((threadId, threadIndex) => {
		const messages = messagesByThread.get(threadId);
		if (!messages || messages.length === 0) return;
		const threadContent = [];
		let context = {};
		let hasVisibleContent = false;
		messages.forEach((message) => {
			const formatted = formatObserverMessage(message, counter, options);
			if (formatted.lines.length === 0 && formatted.attachments.length === 0) return;
			context = appendFormattedObserverMessage(threadContent, formatted, context);
			hasVisibleContent = true;
		});
		if (!hasVisibleContent) return;
		content.push({
			type: "text",
			text: `<thread id="${threadId}">\n`
		});
		content.push(...threadContent);
		content.push({
			type: "text",
			text: "\n</thread>"
		});
		if (threadIndex < threadOrder.length - 1) content.push({
			type: "text",
			text: "\n\n"
		});
	});
	return {
		role: "user",
		content
	};
}
function buildMultiThreadObserverTaskPrompt(existingObservations, threadOrder, priorMetadataByThread, wasTruncated, includeThreadTitle, extractors = []) {
	let prompt = "";
	if (existingObservations) {
		prompt += `## Previous Observations\n\n${existingObservations}\n\n---\n\n`;
		prompt += "Do not repeat these existing observations. Your new observations will be appended to the existing observations.\n\n";
	}
	const hasTruncatedObservations = wasTruncated ?? false;
	const threadMetadataLines = threadOrder?.map((threadId) => {
		const metadata = priorMetadataByThread?.get(threadId);
		const extractorPriorLines = buildExtractorPriorLines(extractors, metadata?.extracted);
		if (!(metadata?.currentTask || metadata?.suggestedResponse || includeThreadTitle && metadata?.threadTitle || extractorPriorLines.length > 0) || !metadata) return "";
		const lines = [`- thread ${threadId}`];
		if (metadata.currentTask) lines.push(`  - prior current-task: ${metadata.currentTask}`);
		if (metadata.suggestedResponse) lines.push(`  - prior suggested-response: ${metadata.suggestedResponse}`);
		if (includeThreadTitle && metadata.threadTitle) lines.push(`  - prior thread-title: ${metadata.threadTitle}`);
		for (const priorLine of extractorPriorLines) lines.push(`  - prior ${priorLine.replace(/\n/g, "\n    ")}`);
		return lines.join("\n");
	}).filter(Boolean).join("\n");
	if (threadMetadataLines) {
		prompt += `## Prior Thread Metadata\n\n${threadMetadataLines}\n\n`;
		if (hasTruncatedObservations) {
			prompt += `Previous observations were truncated for context budget reasons.\n`;
			prompt += `The main agent still has full memory context outside this observer window.\n`;
		}
		prompt += `Use each thread's prior current-task, suggested-response${includeThreadTitle ? ", and thread-title" : ""} as continuity hints, then update them based on that thread's new messages.\n\n---\n\n`;
	}
	prompt += `## Your Task\n\n`;
	prompt += `Extract new observations from each thread. Output your observations grouped by thread using <thread id="..."> tags inside your <observations> block. Each thread block should contain that thread's observations, current-task, suggested-response${includeThreadTitle ? ", and thread-title" : ""}.\n\n`;
	prompt += `Example output format:\n`;
	prompt += `<observations>\n`;
	prompt += `<thread id="thread1">\n`;
	prompt += `Date: Dec 4, 2025\n`;
	prompt += `* 🔴 (14:30) User prefers direct answers\n`;
	prompt += `<current-task>Working on feature X</current-task>\n`;
	prompt += `<suggested-response>Continue with the implementation</suggested-response>\n`;
	if (includeThreadTitle) prompt += `<thread-title>Feature X implementation</thread-title>\n`;
	prompt += `</thread>\n`;
	prompt += `<thread id="thread2">\n`;
	prompt += `Date: Dec 5, 2025\n`;
	prompt += `* 🔴 (09:15) User asked about deployment\n`;
	prompt += `<current-task>Discussing deployment options</current-task>\n`;
	prompt += `<suggested-response>Explain the deployment process</suggested-response>\n`;
	if (includeThreadTitle) prompt += `<thread-title>Deployment setup</thread-title>\n`;
	prompt += `</thread>\n`;
	prompt += `</observations>`;
	return prompt;
}
/**
* Parse multi-thread Observer output to extract per-thread results.
*/
function parseMultiThreadObserverOutput(output, extractors = []) {
	const threads = /* @__PURE__ */ new Map();
	if (detectDegenerateRepetition(output)) return {
		threads,
		rawOutput: output,
		degenerate: true
	};
	const observationsContent = output.match(/^[ \t]*<observations>([\s\S]*?)^[ \t]*<\/observations>/im)?.[1] ?? output;
	const threadRegex = /<thread\s+id="([^"]+)">([\s\S]*?)<\/thread>/gi;
	let match;
	while ((match = threadRegex.exec(observationsContent)) !== null) {
		const threadId = match[1];
		const threadContent = match[2];
		if (!threadId || !threadContent) continue;
		const inlineExtractors = extractors.filter((extractor) => extractor.mode === "inline");
		const parsedExtractedValues = parseExtractedValues(threadContent, inlineExtractors);
		let observations = stripExtractorSections(threadContent, inlineExtractors);
		let currentTask;
		const currentTaskMatch = threadContent.match(/<current-task>([\s\S]*?)<\/current-task>/i);
		if (currentTaskMatch?.[1]) {
			currentTask = currentTaskMatch[1].trim();
			observations = observations.replace(/<current-task>[\s\S]*?<\/current-task>/i, "");
		}
		let suggestedContinuation;
		const suggestedMatch = threadContent.match(/<suggested-response>([\s\S]*?)<\/suggested-response>/i);
		if (suggestedMatch?.[1]) {
			suggestedContinuation = suggestedMatch[1].trim();
			observations = observations.replace(/<suggested-response>[\s\S]*?<\/suggested-response>/i, "");
		}
		let threadTitle;
		const threadTitleMatch = threadContent.match(/<thread-title>([\s\S]*?)<\/thread-title>/i);
		if (threadTitleMatch?.[1]) {
			threadTitle = threadTitleMatch[1].trim();
			observations = observations.replace(/<thread-title>[\s\S]*?<\/thread-title>/i, "");
		}
		observations = sanitizeObservationLines(observations.trim());
		threads.set(threadId, {
			observations,
			currentTask: currentTask || getStringExtractedValue$1(parsedExtractedValues.values, "current-task"),
			suggestedContinuation: suggestedContinuation || getStringExtractedValue$1(parsedExtractedValues.values, "suggested-response"),
			threadTitle: threadTitle || getStringExtractedValue$1(parsedExtractedValues.values, "thread-title"),
			extractedValues: parsedExtractedValues.values,
			extractionFailures: parsedExtractedValues.failures,
			rawOutput: threadContent
		});
	}
	return {
		threads,
		rawOutput: output
	};
}
function buildObserverTaskPrompt(existingObservations, options) {
	let prompt = "";
	if (existingObservations) {
		prompt += `## Previous Observations\n\n${existingObservations}\n\n---\n\n`;
		prompt += "Do not repeat these existing observations. Your new observations will be appended to the existing observations.\n\n";
	}
	const hasTruncatedObservations = options?.wasTruncated ?? false;
	const priorMetadataLines = [];
	if (options?.priorCurrentTask) priorMetadataLines.push(`- prior current-task: ${options.priorCurrentTask}`);
	if (options?.priorSuggestedResponse) priorMetadataLines.push(`- prior suggested-response: ${options.priorSuggestedResponse}`);
	if (options?.includeThreadTitle && options?.priorThreadTitle) priorMetadataLines.push(`- prior thread-title: ${options.priorThreadTitle}`);
	priorMetadataLines.push(...buildExtractorPriorLines(options?.extractors ?? [], options?.priorExtractedValues));
	if (priorMetadataLines.length > 0) {
		prompt += `## Prior Thread Metadata\n\n${priorMetadataLines.join("\n")}\n\n`;
		if (hasTruncatedObservations) {
			prompt += `Previous observations were truncated for context budget reasons.\n`;
			prompt += `The main agent still has full memory context outside this observer window.\n`;
		}
		const titleHint = options?.includeThreadTitle ? ", and thread-title" : "";
		prompt += `Use the prior current-task, suggested-response${titleHint} as continuity hints, then update them based on the new messages.\n\n---\n\n`;
	}
	prompt += `## Your Task\n\n`;
	prompt += `Extract new observations from the message history above. Do not repeat observations that are already in the previous observations. Add your new observations in the format specified in your instructions.`;
	if (options?.skipContinuationHints) prompt += `\n\nOutput <observations> every time.`;
	return prompt;
}
/**
* Build the full prompt for the Observer agent.
* Includes emphasis on the most recent user message for priority handling.
*/
function buildObserverPrompt(existingObservations, messagesToObserve, options) {
	return `## New Message History to Observe\n\n${formatMessagesForObserver(messagesToObserve)}\n\n---\n\n${buildObserverTaskPrompt(existingObservations, options)}`;
}
/**
* Parse the Observer's output to extract observations, current task, and suggested response.
* Uses XML tag parsing for structured extraction.
*/
function getStringExtractedValue$1(values, slug) {
	const value = values[slug];
	return typeof value === "string" && value.trim() ? value.trim() : void 0;
}
function parseObserverOutput(output, extractors = []) {
	if (detectDegenerateRepetition(output)) return {
		observations: "",
		rawOutput: output,
		degenerate: true
	};
	const inlineExtractors = extractors.filter((extractor) => extractor.mode === "inline");
	const parsedExtractedValues = parseExtractedValues(output, inlineExtractors);
	const parsed = parseMemorySectionXml(stripExtractorSections(output, inlineExtractors));
	return {
		observations: sanitizeObservationLines(parsed.observations || ""),
		currentTask: parsed.currentTask || getStringExtractedValue$1(parsedExtractedValues.values, "current-task"),
		suggestedContinuation: parsed.suggestedResponse || getStringExtractedValue$1(parsedExtractedValues.values, "suggested-response"),
		threadTitle: parsed.threadTitle || getStringExtractedValue$1(parsedExtractedValues.values, "thread-title"),
		extractedValues: parsedExtractedValues.values,
		extractionFailures: parsedExtractedValues.failures,
		rawOutput: output
	};
}
/**
* Parse XML tags from observer/reflector output.
* Extracts content from <observations>, <current-task>, and <suggested-response> tags.
*/
function parseMemorySectionXml(content) {
	const result = {
		observations: "",
		currentTask: "",
		suggestedResponse: "",
		threadTitle: ""
	};
	const observationsMatches = [...content.matchAll(/^[ \t]*<observations>([\s\S]*?)^[ \t]*<\/observations>/gim)];
	if (observationsMatches.length > 0) result.observations = observationsMatches.map((m) => m[1]?.trim() ?? "").filter(Boolean).join("\n");
	else result.observations = extractListItemsOnly(content);
	const currentTaskMatch = content.match(/^[ \t]*<current-task>([\s\S]*?)^[ \t]*<\/current-task>/im);
	if (currentTaskMatch?.[1]) result.currentTask = currentTaskMatch[1].trim();
	const suggestedResponseMatch = content.match(/^[ \t]*<suggested-response>([\s\S]*?)^[ \t]*<\/suggested-response>/im);
	if (suggestedResponseMatch?.[1]) result.suggestedResponse = suggestedResponseMatch[1].trim();
	const threadTitleMatch = content.match(/^[ \t]*<thread-title>([\s\S]*?)<\/thread-title>/im);
	if (threadTitleMatch?.[1]) result.threadTitle = threadTitleMatch[1].trim();
	return result;
}
/**
* Fallback: Extract only list items from content when XML tags are missing.
* Preserves nested list items (indented with spaces/tabs).
*/
function extractListItemsOnly(content) {
	const lines = content.split("\n");
	const listLines = [];
	for (const line of lines) if (/^\s*[-*]\s/.test(line) || /^\s*\d+\.\s/.test(line)) listLines.push(line);
	return listLines.join("\n").trim();
}
/**
* Maximum length (in characters) for a single observation line.
* Lines exceeding this are truncated with an ellipsis marker.
* This guards against LLM degeneration that produces enormous single-line outputs.
*/
const MAX_OBSERVATION_LINE_CHARS = 1e4;
/**
* Truncate individual observation lines that exceed the maximum length.
*/
function sanitizeObservationLines(observations) {
	if (!observations) return observations;
	const lines = observations.split("\n");
	let changed = false;
	for (let i = 0; i < lines.length; i++) if (lines[i].length > MAX_OBSERVATION_LINE_CHARS) {
		lines[i] = safeSlice(lines[i], MAX_OBSERVATION_LINE_CHARS) + " … [truncated]";
		changed = true;
	}
	return changed ? lines.join("\n") : observations;
}
/**
* Detect degenerate repetition in observer/reflector output.
* Returns true if the text contains suspicious levels of repeated content,
* which indicates an LLM repeat-penalty bug (e.g., Gemini Flash looping).
*
* Strategy: sample sequential chunks of the text and check if a high
* proportion are near-identical to previous chunks.
*/
function detectDegenerateRepetition(text) {
	if (!text || text.length < 2e3) return false;
	const windowSize = 200;
	const step = Math.max(1, Math.floor(text.length / 50));
	const seen = /* @__PURE__ */ new Map();
	let duplicateWindows = 0;
	let totalWindows = 0;
	for (let i = 0; i + windowSize <= text.length; i += step) {
		const window = text.slice(i, i + windowSize);
		totalWindows++;
		const count = (seen.get(window) ?? 0) + 1;
		seen.set(window, count);
		if (count > 1) duplicateWindows++;
	}
	if (totalWindows > 5 && duplicateWindows / totalWindows > .4) return true;
	const lines = text.split("\n");
	for (const line of lines) if (line.length > 5e4) return true;
	return false;
}
/**
* Check if observations contain a Current Task section.
* Supports both XML format and legacy markdown format.
*/
function hasCurrentTaskSection(observations) {
	if (/<current-task>/i.test(observations)) return true;
	return [
		/\*\*Current Task:?\*\*/i,
		/^Current Task:/im,
		/\*\*Current Task\*\*:/i,
		/## Current Task/i
	].some((pattern) => pattern.test(observations));
}
/**
* Extract the Current Task content from observations.
*/
function extractCurrentTask(observations) {
	const openTag = "<current-task>";
	const closeTag = "</current-task>";
	const startIdx = observations.toLowerCase().indexOf(openTag);
	if (startIdx === -1) return null;
	const contentStart = startIdx + 14;
	const endIdx = observations.toLowerCase().indexOf(closeTag, contentStart);
	if (endIdx === -1) return null;
	return observations.slice(contentStart, endIdx).trim() || null;
}
/**
* Optimize observations for token efficiency before presenting to the Actor.
*
* This removes:
* - Non-critical emojis (🟡 and 🟢, keeping only 🔴)
* - Semantic tags [label, label]
* - Arrow indicators (->)
* - Extra whitespace
*
* The full format is preserved in storage for analysis.
*/
function optimizeObservationsForContext(observations) {
	let optimized = stripEphemeralAnchorIds(observations);
	optimized = optimized.replace(/🟡\s*/g, "");
	optimized = optimized.replace(/🟢\s*/g, "");
	optimized = optimized.replace(/\[(?![\d\s]*items collapsed)[^\]]+\]/g, "");
	optimized = optimized.replace(/\s*->\s*/g, " ");
	optimized = optimized.replace(/  +/g, " ");
	optimized = optimized.replace(/\n{3,}/g, "\n\n");
	return optimized.trim();
}
//#endregion
//#region src/processors/observational-memory/retry.ts
/**
* Retry knobs for the internal OM transport-error retry wrapper.
* Exported as a mutable object so tests can shrink the backoff schedule
* without changing public API.
*
* With the defaults the per-retry pre-jitter backoff schedule is:
*   1s, 2s, 4s, 8s, 16s, 32s, 64s, 120s (cap)
* giving 8 retries / 9 total attempts and ~247s (~4 minutes) of waiting
* before the final attempt fails. Designed to ride out short provider /
* network blips without holding the actor turn for much longer than that.
*
* @internal
*/
const RETRY_CONFIG = {
	/** Maximum number of retry *attempts* (total tries = maxRetries + 1). */
	maxRetries: 8,
	/** Initial backoff delay in milliseconds. */
	initialDelayMs: 1e3,
	/** Multiplier applied to the delay after each failed attempt. */
	backoffFactor: 2,
	/** Cap on per-attempt delay (ms). */
	maxDelayMs: 12e4,
	/** Random jitter as a fraction of the computed delay (e.g. 0.2 = ±20%). */
	jitter: .2
};
const TRANSIENT_MESSAGE_SUBSTRINGS = [
	"terminated",
	"fetch failed",
	"econnreset",
	"econnrefused",
	"enotfound",
	"eai_again",
	"socket hang up",
	"network error",
	"request timed out",
	"request timeout",
	"connection reset",
	"connection closed"
];
function isRecord$1(value) {
	return typeof value === "object" && value !== null;
}
function isAbortError(error) {
	if (!isRecord$1(error)) return false;
	if (error.name === "AbortError") return true;
	if (typeof error.code === "string" && error.code === "ABORT_ERR") return true;
	return false;
}
function hasTransientMessage(value) {
	if (!isRecord$1(value)) return false;
	const message = typeof value.message === "string" ? value.message.toLowerCase() : "";
	if (message && TRANSIENT_MESSAGE_SUBSTRINGS.some((sub) => message.includes(sub))) return true;
	if (typeof value.code === "string" && value.code.toUpperCase().startsWith("UND_ERR_")) return true;
	return false;
}
function isRetryableHttpStatus(status) {
	if (status === 408 || status === 425 || status === 429) return true;
	return status >= 500 && status <= 599;
}
function hasRetryableHttpStatus(value) {
	if (!isRecord$1(value)) return false;
	if (typeof value.statusCode === "number" && isRetryableHttpStatus(value.statusCode)) return true;
	if (typeof value.code === "number" && isRetryableHttpStatus(value.code)) return true;
	return false;
}
function hasIsRetryableFlag(value) {
	if (!isRecord$1(value)) return false;
	return value.isRetryable === true;
}
/**
* Returns true when the given error looks like a transient transport-class
* failure that's worth retrying — undici `terminated`, `fetch failed`,
* `UND_ERR_*` codes, AI SDK `APICallError` with `isRetryable: true`, and
* common HTTP 408/425/429/5xx statuses. Walks the `error.cause` chain so
* wrapper errors don't hide the real failure.
*
* Never retries on user-initiated aborts.
*
* @internal
*/
function isTransientLLMError(error) {
	if (isAbortError(error)) return false;
	const visited = /* @__PURE__ */ new WeakSet();
	function visit(candidate) {
		if (isRecord$1(candidate)) {
			if (visited.has(candidate)) return false;
			visited.add(candidate);
		}
		if (hasTransientMessage(candidate)) return true;
		if (hasRetryableHttpStatus(candidate)) return true;
		if (hasIsRetryableFlag(candidate)) return true;
		if (isRecord$1(candidate)) {
			if (visit(candidate.cause)) return true;
			if (visit(candidate.error)) return true;
		}
		return false;
	}
	return visit(error);
}
/**
* Compute the backoff delay (ms) for the Nth retry (0-indexed).
*
* Exponential growth (`initialDelayMs * backoffFactor^attempt`) capped at
* `maxDelayMs`, then nudged by ±`jitter` (fractional). Exported for unit
* tests that lock the schedule against drift.
*
* @internal
*/
function computeDelay(attempt) {
	const base = RETRY_CONFIG.initialDelayMs * Math.pow(RETRY_CONFIG.backoffFactor, attempt);
	const capped = Math.min(base, RETRY_CONFIG.maxDelayMs);
	if (RETRY_CONFIG.jitter <= 0) return capped;
	const jitterRange = capped * RETRY_CONFIG.jitter;
	const offset = (Math.random() * 2 - 1) * jitterRange;
	return Math.max(0, Math.round(capped + offset));
}
function sleep(ms, abortSignal) {
	if (ms <= 0) return Promise.resolve();
	return new Promise((resolve, reject) => {
		if (abortSignal?.aborted) {
			reject(/* @__PURE__ */ new Error("The operation was aborted."));
			return;
		}
		const timer = setTimeout(() => {
			abortSignal?.removeEventListener("abort", onAbort);
			resolve();
		}, ms);
		const onAbort = () => {
			clearTimeout(timer);
			abortSignal?.removeEventListener("abort", onAbort);
			reject(/* @__PURE__ */ new Error("The operation was aborted."));
		};
		abortSignal?.addEventListener("abort", onAbort, { once: true });
	});
}
/**
* Run `fn` with retries on transient transport-class errors.
*
* Non-transient errors (auth, validation, schema, etc.) are rethrown
* immediately. User-initiated aborts are rethrown without delay.
*
* @internal
*/
async function withRetry(fn, opts) {
	const { label, abortSignal } = opts;
	let attempt = 0;
	while (true) {
		if (abortSignal?.aborted) throw new Error("The operation was aborted.");
		try {
			return await fn();
		} catch (error) {
			if (isAbortError(error) || abortSignal?.aborted) throw error;
			if (attempt >= RETRY_CONFIG.maxRetries || !isTransientLLMError(error)) {
				if (attempt > 0) omDebug(`[OM:retry:${label}] giving up after ${attempt} retry/retries: ${error instanceof Error ? error.message : String(error)}`);
				throw error;
			}
			const delay = computeDelay(attempt);
			attempt++;
			omDebug(`[OM:retry:${label}] transient error on attempt ${attempt}, retrying in ${delay}ms: ${error instanceof Error ? error.message : String(error)}`);
			await sleep(delay, abortSignal);
		}
	}
}
//#endregion
//#region src/processors/observational-memory/temporary-memory.ts
function createTemporaryOmMemoryContext(prefix) {
	const options = {
		thread: `${prefix}-${randomUUID()}`,
		resource: prefix,
		options: {
			lastMessages: 10,
			generateTitle: false
		}
	};
	return {
		memory: new Memory({
			storage: new InMemoryStore(),
			options: options.options
		}),
		options
	};
}
//#endregion
//#region src/processors/observational-memory/tracing.ts
const PHASE_CONFIG = {
	observer: {
		name: "om.observer",
		entityName: "Observer"
	},
	"observer-multi-thread": {
		name: "om.observer.multi-thread",
		entityName: "MultiThreadObserver"
	},
	reflector: {
		name: "om.reflector",
		entityName: "Reflector"
	}
};
async function withOmTracingSpan({ phase, model, inputTokens, requestContext, observabilityContext, metadata, callback }) {
	const config = PHASE_CONFIG[phase];
	const span = getOrCreateSpan({
		type: SpanType.GENERIC,
		name: config.name,
		entityType: EntityType.OUTPUT_STEP_PROCESSOR,
		entityName: config.entityName,
		tracingContext: observabilityContext?.tracingContext ?? observabilityContext?.tracing,
		metadata: {
			omPhase: phase,
			omInputTokens: inputTokens,
			omSelectedModel: typeof model === "string" ? model : "(dynamic-model)",
			...metadata
		},
		requestContext
	});
	const childObservabilityContext = createObservabilityContext({ currentSpan: span });
	if (!span) return callback(childObservabilityContext);
	return span.executeInContext(() => callback(childObservabilityContext));
}
//#endregion
//#region src/processors/observational-memory/observer-runner.ts
function filterObserverExtractors(extractors, skipContinuationHints) {
	const configuredExtractors = extractors ?? [];
	if (!skipContinuationHints) return configuredExtractors;
	return configuredExtractors.filter((extractor) => extractor.slug !== "current-task" && extractor.slug !== "suggested-response");
}
var ObserverRunner = class {
	observationConfig;
	observedMessageIds;
	resolveModel;
	tokenCounter;
	memory;
	mastra;
	/** Captured prompt/response from the last observer call (for repro capture). */
	lastExchange;
	constructor(opts) {
		this.observationConfig = opts.observationConfig;
		this.observedMessageIds = opts.observedMessageIds;
		this.resolveModel = opts.resolveModel;
		this.tokenCounter = opts.tokenCounter;
		this.mastra = opts.mastra;
		this.memory = opts.memory;
	}
	__registerMastra(mastra) {
		this.mastra = mastra;
	}
	createAgent(model, isMultiThread = false, memory, extractors = this.observationConfig.extractors ?? []) {
		const agent = new Agent({
			id: isMultiThread ? "multi-thread-observer" : "observational-memory-observer",
			name: isMultiThread ? "multi-thread-observer" : "Observer",
			instructions: buildObserverSystemPrompt(isMultiThread, this.observationConfig.instruction, this.observationConfig.threadTitle, extractors),
			model,
			...memory ? { memory } : {}
		});
		if (this.mastra) agent.__registerMastra(this.mastra);
		return agent;
	}
	/**
	* Extract a router-style model ID (`provider/model`) from a model config.
	* Handles strings, LanguageModel objects, and function-based models.
	*/
	extractModelRouterId(model, requestContext) {
		if (typeof model === "string") return model;
		if (typeof model === "function") {
			if (!requestContext) return void 0;
			try {
				const resolved = model({ requestContext });
				if (resolved instanceof Promise) return void 0;
				return this.extractModelRouterId(resolved);
			} catch {
				return;
			}
		}
		const obj = model;
		if (typeof obj.provider === "string" && typeof obj.modelId === "string") return `${obj.provider}/${obj.modelId}`;
	}
	/**
	* Resolve the attachment filter for a given model. When set to `'auto'`,
	* the provider capabilities registry is consulted to decide whether the
	* model accepts multimodal input.
	*/
	resolveAttachmentFilter(model, requestContext) {
		const raw = this.observationConfig.observeAttachments;
		if (raw !== "auto") return raw;
		const routerId = this.extractModelRouterId(model, requestContext);
		if (!routerId) return true;
		return modelSupportsAttachments(routerId) ?? true;
	}
	async withAbortCheck(fn, abortSignal) {
		if (abortSignal?.aborted) throw new Error("The operation was aborted.");
		const result = await fn();
		if (abortSignal?.aborted) throw new Error("The operation was aborted.");
		return result;
	}
	/**
	* Call the Observer agent for a single thread.
	*/
	async call(existingObservations, messagesToObserve, abortSignal, options) {
		const inputTokens = this.tokenCounter.countMessages(messagesToObserve);
		const resolvedModel = options?.model ? { model: options.model } : this.resolveModel(inputTokens);
		const activeExtractors = await resolveExtractors(filterObserverExtractors(this.observationConfig.extractors, options?.skipContinuationHints), {
			source: "observer",
			threadId: messagesToObserve[0]?.threadId,
			resourceId: options?.resourceId,
			mainAgent: options?.mainAgent,
			memory: this.memory,
			requestContext: options?.requestContext
		});
		const temporaryMemory = activeExtractors.filter((extractor) => extractor.mode === "structured").length > 0 ? await createTemporaryOmMemoryContext("structured-observer") : void 0;
		const agent = temporaryMemory ? this.createAgent(resolvedModel.model, false, temporaryMemory.memory, activeExtractors) : this.createAgent(resolvedModel.model, false, void 0, activeExtractors);
		const internalRequestContext = withOmInternalThreadId(options?.requestContext, agent.id);
		const attachmentFilter = this.resolveAttachmentFilter(resolvedModel.model, options?.requestContext);
		const observerMessages = [{
			role: "user",
			content: buildObserverTaskPrompt(existingObservations, {
				...options,
				includeThreadTitle: this.observationConfig.threadTitle,
				extractors: activeExtractors
			})
		}, buildObserverHistoryMessage(messagesToObserve, { attachmentFilter })];
		const doGenerate = async () => {
			return withRetry(() => withOmTracingSpan({
				phase: "observer",
				model: resolvedModel.model,
				inputTokens,
				requestContext: options?.requestContext,
				observabilityContext: options?.observabilityContext,
				metadata: {
					omPreviousObserverTokens: this.observationConfig.previousObserverTokens,
					omThreadTitleEnabled: this.observationConfig.threadTitle,
					omSkipContinuationHints: options?.skipContinuationHints ?? false,
					omWasTruncated: options?.wasTruncated ?? false,
					...resolvedModel.selectedThreshold !== void 0 ? { omSelectedThreshold: resolvedModel.selectedThreshold } : {},
					...resolvedModel.routingStrategy ? { omRoutingStrategy: resolvedModel.routingStrategy } : {},
					...resolvedModel.routingThresholds ? { omRoutingThresholds: resolvedModel.routingThresholds } : {}
				},
				callback: (childObservabilityContext) => this.withAbortCheck(async () => {
					return (await agent.stream(observerMessages, {
						modelSettings: { ...this.observationConfig.modelSettings },
						providerOptions: this.observationConfig.providerOptions,
						...temporaryMemory ? { memory: temporaryMemory.options } : {},
						...abortSignal ? { abortSignal } : {},
						...internalRequestContext ? { requestContext: internalRequestContext } : {},
						...childObservabilityContext
					})).getFullOutput();
				}, abortSignal)
			}), {
				label: "observer",
				abortSignal
			});
		};
		let result = await doGenerate();
		let parsed = parseObserverOutput(result.text, activeExtractors);
		let retriedDueToDegenerate = false;
		if (parsed.degenerate) {
			omDebug(`[OM:callObserver] degenerate repetition detected, retrying once`);
			result = await doGenerate();
			parsed = parseObserverOutput(result.text, activeExtractors);
			retriedDueToDegenerate = true;
			if (parsed.degenerate) {
				omDebug(`[OM:callObserver] degenerate repetition on retry, failing`);
				throw new Error("Observer produced degenerate output after retry");
			}
		}
		const structuredExtraction = await extractStructuredValues({
			agent,
			source: "observer",
			extractors: activeExtractors,
			memory: temporaryMemory?.options,
			priorExtractedValues: options?.priorExtractedValues,
			requestContext: internalRequestContext,
			observabilityContext: options?.observabilityContext,
			abortSignal
		});
		const extractedValues = mergeExtractedValues(parsed.extractedValues, structuredExtraction.values);
		const extractionFailures = mergeExtractionFailures(parsed.extractionFailures, structuredExtraction.failures);
		const builtIns = getBuiltInExtractedValues(extractedValues);
		const systemPrompt = buildObserverSystemPrompt(false, this.observationConfig.instruction, this.observationConfig.threadTitle, activeExtractors);
		this.lastExchange = {
			systemPrompt,
			observerMessages,
			rawOutput: result.text,
			parsedResult: {
				observations: parsed.observations,
				currentTask: builtIns.currentTask ?? parsed.currentTask,
				suggestedContinuation: builtIns.suggestedContinuation ?? parsed.suggestedContinuation,
				threadTitle: builtIns.threadTitle ?? parsed.threadTitle,
				extractedValues,
				extractionFailures,
				degenerate: parsed.degenerate
			},
			model: String(resolvedModel.model),
			inputTokens,
			isMultiThread: false,
			retriedDueToDegenerate
		};
		const usage = result.totalUsage ?? result.usage;
		return {
			observations: parsed.observations,
			currentTask: builtIns.currentTask ?? parsed.currentTask,
			suggestedContinuation: builtIns.suggestedContinuation ?? parsed.suggestedContinuation,
			threadTitle: builtIns.threadTitle ?? parsed.threadTitle,
			extractedValues,
			extractionFailures,
			extractors: activeExtractors,
			usage: usage ? {
				inputTokens: usage.inputTokens,
				outputTokens: usage.outputTokens,
				totalTokens: usage.totalTokens
			} : void 0,
			providerMetadata: result.providerMetadata
		};
	}
	/**
	* Call the Observer agent for multiple threads in a single batched request.
	*/
	async callMultiThread(existingObservations, messagesByThread, threadOrder, abortSignal, requestContext, priorMetadataByThread, observabilityContext, model) {
		const inputTokens = Array.from(messagesByThread.values()).reduce((total, messages) => total + this.tokenCounter.countMessages(messages), 0);
		const resolvedModel = model ? { model } : this.resolveModel(inputTokens);
		const firstThreadMessages = messagesByThread.get(threadOrder[0] ?? "") ?? [];
		const activeExtractors = await resolveExtractors(this.observationConfig.extractors ?? [], {
			source: "observer",
			threadId: threadOrder[0],
			resourceId: firstThreadMessages[0]?.resourceId,
			memory: this.memory,
			requestContext
		});
		if (activeExtractors.filter((extractor) => extractor.mode === "structured").length > 0) {
			const results = /* @__PURE__ */ new Map();
			let totalUsage = {
				inputTokens: 0,
				outputTokens: 0,
				totalTokens: 0
			};
			for (const threadId of threadOrder) {
				const threadResult = await this.call(existingObservations, messagesByThread.get(threadId) ?? [], abortSignal, {
					requestContext,
					observabilityContext,
					priorCurrentTask: priorMetadataByThread?.get(threadId)?.currentTask,
					priorSuggestedResponse: priorMetadataByThread?.get(threadId)?.suggestedResponse,
					priorThreadTitle: priorMetadataByThread?.get(threadId)?.threadTitle,
					priorExtractedValues: priorMetadataByThread?.get(threadId)?.extracted,
					model: resolvedModel.model
				});
				results.set(threadId, {
					observations: threadResult.observations,
					currentTask: threadResult.currentTask,
					suggestedContinuation: threadResult.suggestedContinuation,
					threadTitle: threadResult.threadTitle,
					extractedValues: threadResult.extractedValues,
					extractionFailures: threadResult.extractionFailures,
					extractors: threadResult.extractors
				});
				if (threadResult.usage) {
					totalUsage.inputTokens += threadResult.usage.inputTokens ?? 0;
					totalUsage.outputTokens += threadResult.usage.outputTokens ?? 0;
					totalUsage.totalTokens += threadResult.usage.totalTokens ?? 0;
				}
			}
			return {
				results,
				usage: totalUsage
			};
		}
		const agent = this.createAgent(resolvedModel.model, true, void 0, activeExtractors);
		const internalRequestContext = withOmInternalThreadId(requestContext, agent.id);
		const multiThreadAttachmentFilter = this.resolveAttachmentFilter(resolvedModel.model, requestContext);
		const observerMessages = [{
			role: "user",
			content: buildMultiThreadObserverTaskPrompt(existingObservations, threadOrder, priorMetadataByThread, void 0, this.observationConfig.threadTitle, activeExtractors)
		}, buildMultiThreadObserverHistoryMessage(messagesByThread, threadOrder, { attachmentFilter: multiThreadAttachmentFilter })];
		for (const msgs of messagesByThread.values()) for (const msg of msgs) this.observedMessageIds.add(msg.id);
		const doGenerate = async () => {
			return withRetry(() => withOmTracingSpan({
				phase: "observer-multi-thread",
				model: resolvedModel.model,
				inputTokens,
				requestContext,
				observabilityContext,
				metadata: {
					omThreadCount: threadOrder.length,
					omPreviousObserverTokens: this.observationConfig.previousObserverTokens,
					omThreadTitleEnabled: this.observationConfig.threadTitle,
					...resolvedModel.selectedThreshold !== void 0 ? { omSelectedThreshold: resolvedModel.selectedThreshold } : {},
					...resolvedModel.routingStrategy ? { omRoutingStrategy: resolvedModel.routingStrategy } : {},
					...resolvedModel.routingThresholds ? { omRoutingThresholds: resolvedModel.routingThresholds } : {}
				},
				callback: (childObservabilityContext) => this.withAbortCheck(async () => {
					return (await agent.stream(observerMessages, {
						modelSettings: { ...this.observationConfig.modelSettings },
						providerOptions: this.observationConfig.providerOptions,
						...abortSignal ? { abortSignal } : {},
						...internalRequestContext ? { requestContext: internalRequestContext } : {},
						...childObservabilityContext
					})).getFullOutput();
				}, abortSignal)
			}), {
				label: "observer-multi-thread",
				abortSignal
			});
		};
		let result = await doGenerate();
		let parsed = parseMultiThreadObserverOutput(result.text, activeExtractors);
		let retriedDueToDegenerate = false;
		if (parsed.degenerate) {
			omDebug(`[OM:callMultiThreadObserver] degenerate repetition detected, retrying once`);
			result = await doGenerate();
			parsed = parseMultiThreadObserverOutput(result.text, activeExtractors);
			retriedDueToDegenerate = true;
			if (parsed.degenerate) {
				omDebug(`[OM:callMultiThreadObserver] degenerate repetition on retry, failing`);
				throw new Error("Multi-thread observer produced degenerate output after retry");
			}
		}
		const structuredExtractionByThread = /* @__PURE__ */ new Map();
		const aggregatedExtractedValues = mergeExtractedValues(...Array.from(parsed.threads, ([threadId, threadResult]) => mergeExtractedValues(threadResult.extractedValues, structuredExtractionByThread.get(threadId)?.values)));
		const aggregatedExtractionFailures = mergeExtractionFailures(...Array.from(parsed.threads, ([threadId, threadResult]) => mergeExtractionFailures(threadResult.extractionFailures, structuredExtractionByThread.get(threadId)?.failures)));
		const aggregatedBuiltIns = getBuiltInExtractedValues(aggregatedExtractedValues);
		const systemPrompt = buildObserverSystemPrompt(true, this.observationConfig.instruction, this.observationConfig.threadTitle, activeExtractors);
		this.lastExchange = {
			systemPrompt,
			observerMessages,
			rawOutput: result.text,
			parsedResult: {
				observations: Array.from(parsed.threads.values()).map((t) => t.observations).join("\n"),
				currentTask: aggregatedBuiltIns.currentTask,
				suggestedContinuation: aggregatedBuiltIns.suggestedContinuation,
				threadTitle: aggregatedBuiltIns.threadTitle ?? Array.from(parsed.threads.values()).map((t) => t.threadTitle).filter(Boolean).join(", "),
				extractedValues: aggregatedExtractedValues,
				extractionFailures: aggregatedExtractionFailures,
				degenerate: parsed.degenerate
			},
			model: String(resolvedModel.model),
			inputTokens,
			isMultiThread: true,
			retriedDueToDegenerate
		};
		const results = /* @__PURE__ */ new Map();
		for (const [threadId, threadResult] of parsed.threads) {
			const structuredExtraction = structuredExtractionByThread.get(threadId);
			const extractedValues = mergeExtractedValues(threadResult.extractedValues, structuredExtraction?.values);
			const extractionFailures = mergeExtractionFailures(threadResult.extractionFailures, structuredExtraction?.failures);
			const builtIns = getBuiltInExtractedValues(extractedValues);
			results.set(threadId, {
				observations: threadResult.observations,
				currentTask: builtIns.currentTask ?? threadResult.currentTask,
				suggestedContinuation: builtIns.suggestedContinuation ?? threadResult.suggestedContinuation,
				threadTitle: builtIns.threadTitle ?? threadResult.threadTitle,
				extractedValues,
				extractionFailures,
				extractors: activeExtractors
			});
		}
		for (const threadId of threadOrder) if (!results.has(threadId)) results.set(threadId, { observations: "" });
		const usage = result.totalUsage ?? result.usage;
		return {
			results,
			usage: usage ? {
				inputTokens: usage.inputTokens,
				outputTokens: usage.outputTokens,
				totalTokens: usage.totalTokens
			} : void 0,
			providerMetadata: result.providerMetadata
		};
	}
};
//#endregion
//#region src/processors/observational-memory/token-counter.ts
const IMAGE_FILE_EXTENSIONS = /* @__PURE__ */ new Set([
	"png",
	"jpg",
	"jpeg",
	"webp",
	"gif",
	"bmp",
	"tiff",
	"tif",
	"heic",
	"heif",
	"avif"
]);
const TOKEN_ESTIMATE_CACHE_VERSION = 7;
/**
* Cache `source` marker for token estimates supplied by the caller via
* `part.providerMetadata.mastra.tokenEstimate`. Pipelines that strip the real
* binary payload before persistence (e.g. uploading files to cloud storage and
* leaving only a reference token in `data`) cannot rely on the on-device file
* size, so they can stamp an authoritative estimate here. Entries marked with
* this source survive cache-version rotations and are honored ahead of
* provider fetches and the default descriptor estimator.
*/
const CLIENT_TOKEN_ESTIMATE_SOURCE = "client";
const DEFAULT_IMAGE_ESTIMATOR = {
	baseTokens: 85,
	tileTokens: 170,
	fallbackTiles: 4
};
const GOOGLE_LEGACY_IMAGE_TOKENS_PER_TILE = 258;
const GOOGLE_GEMINI_3_IMAGE_TOKENS_BY_RESOLUTION = {
	low: 280,
	medium: 560,
	high: 1120,
	ultra_high: 2240,
	unspecified: 1120
};
const ANTHROPIC_IMAGE_TOKENS_PER_PIXEL = 1 / 750;
const ANTHROPIC_IMAGE_MAX_LONG_EDGE = 1568;
const GOOGLE_MEDIA_RESOLUTION_VALUES = /* @__PURE__ */ new Set([
	"low",
	"medium",
	"high",
	"ultra_high",
	"unspecified"
]);
const ATTACHMENT_COUNT_TIMEOUT_MS = 2e4;
const REMOTE_IMAGE_PROBE_TIMEOUT_MS = 2500;
const PROVIDER_API_KEY_ENV_VARS = {
	openai: ["OPENAI_API_KEY"],
	google: ["GOOGLE_GENERATIVE_AI_API_KEY", "GOOGLE_API_KEY"],
	anthropic: ["ANTHROPIC_API_KEY"]
};
function getPartMastraMetadata(part) {
	return part.providerMetadata?.mastra;
}
function ensurePartMastraMetadata(part) {
	const typedPart = part;
	typedPart.providerMetadata ??= {};
	typedPart.providerMetadata.mastra ??= {};
	return typedPart.providerMetadata.mastra;
}
function getContentMastraMetadata(content) {
	if (!content || typeof content !== "object") return;
	return content.metadata?.mastra;
}
function ensureContentMastraMetadata(content) {
	if (!content || typeof content !== "object") return;
	const typedContent = content;
	typedContent.metadata ??= {};
	typedContent.metadata.mastra ??= {};
	return typedContent.metadata.mastra;
}
function getMessageMastraMetadata(message) {
	return message.metadata?.mastra;
}
function ensureMessageMastraMetadata(message) {
	const typedMessage = message;
	typedMessage.metadata ??= {};
	typedMessage.metadata.mastra ??= {};
	return typedMessage.metadata.mastra;
}
function buildEstimateKey(kind, text) {
	return `${kind}:${createHash("sha256").update(text).digest("hex")}`;
}
function resolveEstimatorId() {
	return "tokenx";
}
function isTokenEstimateEntry(value) {
	if (!value || typeof value !== "object") return false;
	const entry = value;
	return typeof entry.v === "number" && typeof entry.source === "string" && typeof entry.key === "string" && typeof entry.tokens === "number";
}
function getCacheEntry(cache, key) {
	if (!cache || typeof cache !== "object") return void 0;
	if (isTokenEstimateEntry(cache)) return cache.key === key ? cache : void 0;
	const keyedEntry = cache[key];
	return isTokenEstimateEntry(keyedEntry) ? keyedEntry : void 0;
}
function mergeCacheEntry(cache, key, entry) {
	if (isTokenEstimateEntry(cache)) {
		if (cache.key === key) return entry;
		return {
			[cache.key]: cache,
			[key]: entry
		};
	}
	if (cache && typeof cache === "object") return {
		...cache,
		[key]: entry
	};
	return entry;
}
function getPartCacheEntry(part, key) {
	return getCacheEntry(getPartMastraMetadata(part)?.tokenEstimate, key);
}
function setPartCacheEntry(part, key, entry) {
	const mastraMetadata = ensurePartMastraMetadata(part);
	mastraMetadata.tokenEstimate = mergeCacheEntry(mastraMetadata.tokenEstimate, key, entry);
}
/**
* Extracts a caller-supplied token estimate stamped on a part via
* `part.providerMetadata.mastra.tokenEstimate`. Used by pipelines that strip
* the binary payload from file parts (e.g. cloud-storage references) and
* therefore cannot rely on the on-device file size. Returns the entry only
* when `source === 'client'` and `tokens` is a finite non-negative number.
*
* Public contract for callers:
*   part.providerMetadata = {
*     mastra: {
*       tokenEstimate: { v: 0, source: 'client', key: 'client', tokens: N }
*     }
*   }
*/
function getClientPartTokenEstimate(part) {
	const cache = getPartMastraMetadata(part)?.tokenEstimate;
	if (!cache || typeof cache !== "object") return void 0;
	const matches = (entry) => isTokenEstimateEntry(entry) && entry.source === CLIENT_TOKEN_ESTIMATE_SOURCE && Number.isFinite(entry.tokens) && entry.tokens >= 0;
	if (matches(cache)) return cache;
	for (const value of Object.values(cache)) if (matches(value)) return value;
}
function getMessageCacheEntry(message, key) {
	const contentLevelEntry = getCacheEntry(getContentMastraMetadata(message.content)?.tokenEstimate, key);
	if (contentLevelEntry) return contentLevelEntry;
	return getCacheEntry(getMessageMastraMetadata(message)?.tokenEstimate, key);
}
function setMessageCacheEntry(message, key, entry) {
	const contentMastraMetadata = ensureContentMastraMetadata(message.content);
	if (contentMastraMetadata) {
		contentMastraMetadata.tokenEstimate = mergeCacheEntry(contentMastraMetadata.tokenEstimate, key, entry);
		return;
	}
	const messageMastraMetadata = ensureMessageMastraMetadata(message);
	messageMastraMetadata.tokenEstimate = mergeCacheEntry(messageMastraMetadata.tokenEstimate, key, entry);
}
function serializePartForTokenCounting(part) {
	const typedPart = part;
	if (!Boolean(typedPart.providerMetadata?.mastra?.tokenEstimate)) return JSON.stringify(part);
	const clonedPart = {
		...typedPart,
		providerMetadata: {
			...typedPart.providerMetadata ?? {},
			mastra: { ...typedPart.providerMetadata?.mastra ?? {} }
		}
	};
	delete clonedPart.providerMetadata.mastra.tokenEstimate;
	if (Object.keys(clonedPart.providerMetadata.mastra).length === 0) delete clonedPart.providerMetadata.mastra;
	if (Object.keys(clonedPart.providerMetadata).length === 0) delete clonedPart.providerMetadata;
	return JSON.stringify(clonedPart);
}
function getFilenameFromAttachmentData(data) {
	const filename = (data instanceof URL ? data.pathname : typeof data === "string" && isHttpUrlString(data) ? (() => {
		try {
			return new URL(data).pathname;
		} catch {
			return;
		}
	})() : void 0)?.split("/").filter(Boolean).pop();
	return filename ? decodeURIComponent(filename) : void 0;
}
function serializeNonImageFilePartForTokenCounting(part) {
	const filename = getObjectValue(part, "filename");
	const inferredFilename = getFilenameFromAttachmentData(getObjectValue(part, "data"));
	return JSON.stringify({
		type: "file",
		mimeType: getObjectValue(part, "mimeType") ?? null,
		filename: typeof filename === "string" && filename.trim().length > 0 ? filename.trim() : inferredFilename ?? null
	});
}
function isValidCacheEntry(entry, expectedKey, expectedSource) {
	return Boolean(entry && entry.v === TOKEN_ESTIMATE_CACHE_VERSION && entry.source === expectedSource && entry.key === expectedKey && Number.isFinite(entry.tokens));
}
function parseModelContext(model) {
	if (!model) return void 0;
	if (typeof model === "object") return model.provider || model.modelId ? {
		provider: model.provider,
		modelId: model.modelId
	} : void 0;
	const slashIndex = model.indexOf("/");
	if (slashIndex === -1) return { modelId: model };
	return {
		provider: model.slice(0, slashIndex),
		modelId: model.slice(slashIndex + 1)
	};
}
function normalizeImageDetail(detail) {
	if (detail === "low" || detail === "high") return detail;
	return "auto";
}
function getObjectValue(value, key) {
	if (!value || typeof value !== "object") return void 0;
	return value[key];
}
function resolveImageDetail(part) {
	const openAIProviderOptions = getObjectValue(getObjectValue(part, "providerOptions"), "openai");
	const openAIProviderMetadata = getObjectValue(getObjectValue(part, "providerMetadata"), "openai");
	const mastraMetadata = getObjectValue(getObjectValue(part, "providerMetadata"), "mastra");
	return normalizeImageDetail(getObjectValue(part, "detail") ?? getObjectValue(part, "imageDetail") ?? getObjectValue(openAIProviderOptions, "detail") ?? getObjectValue(openAIProviderOptions, "imageDetail") ?? getObjectValue(openAIProviderMetadata, "detail") ?? getObjectValue(openAIProviderMetadata, "imageDetail") ?? getObjectValue(mastraMetadata, "imageDetail"));
}
function normalizeGoogleMediaResolution(value) {
	return typeof value === "string" && GOOGLE_MEDIA_RESOLUTION_VALUES.has(value) ? value : void 0;
}
function resolveGoogleMediaResolution(part) {
	const providerOptions = getObjectValue(getObjectValue(part, "providerOptions"), "google");
	const providerMetadata = getObjectValue(getObjectValue(part, "providerMetadata"), "google");
	const mastraMetadata = getObjectValue(getObjectValue(part, "providerMetadata"), "mastra");
	return normalizeGoogleMediaResolution(getObjectValue(part, "mediaResolution")) ?? normalizeGoogleMediaResolution(getObjectValue(providerOptions, "mediaResolution")) ?? normalizeGoogleMediaResolution(getObjectValue(providerMetadata, "mediaResolution")) ?? normalizeGoogleMediaResolution(getObjectValue(mastraMetadata, "mediaResolution")) ?? "unspecified";
}
function getFiniteNumber(value) {
	return typeof value === "number" && Number.isFinite(value) && value > 0 ? value : void 0;
}
function isHttpUrlString(value) {
	return typeof value === "string" && /^https?:\/\//i.test(value);
}
function isLikelyFilesystemPath(value) {
	return value.startsWith("/") || value.startsWith("./") || value.startsWith("../") || value.startsWith("~/") || /^[A-Za-z]:[\\/]/.test(value) || value.includes("\\");
}
function isLikelyBase64Content(value) {
	if (value.length < 16 || value.length % 4 !== 0 || /\s/.test(value) || isLikelyFilesystemPath(value)) return false;
	return /^[A-Za-z0-9+/]+={0,2}$/.test(value);
}
function decodeImageBuffer(value) {
	if (typeof Buffer !== "undefined" && Buffer.isBuffer(value)) return value;
	if (value instanceof Uint8Array) return Buffer.from(value);
	if (value instanceof ArrayBuffer) return Buffer.from(value);
	if (ArrayBuffer.isView(value)) return Buffer.from(value.buffer, value.byteOffset, value.byteLength);
	if (typeof value !== "string" || isHttpUrlString(value)) return;
	if (value.startsWith("data:")) {
		const commaIndex = value.indexOf(",");
		if (commaIndex === -1) return void 0;
		const header = value.slice(0, commaIndex);
		const payload = value.slice(commaIndex + 1);
		if (/;base64/i.test(header)) return Buffer.from(payload, "base64");
		return Buffer.from(decodeURIComponent(payload), "utf8");
	}
	if (!isLikelyBase64Content(value)) return;
	return Buffer.from(value, "base64");
}
function persistImageDimensions(part, dimensions) {
	const mastraMetadata = ensurePartMastraMetadata(part);
	mastraMetadata.imageDimensions = dimensions;
}
function resolveHttpAssetUrl(value) {
	if (value instanceof URL) return value.toString();
	if (typeof value === "string" && isHttpUrlString(value)) return value;
}
async function resolveImageDimensionsAsync(part) {
	const existing = resolveImageDimensions(part);
	if (existing.width && existing.height) return existing;
	const url = resolveHttpAssetUrl(getObjectValue(part, "image") ?? getObjectValue(part, "data"));
	if (!url) return existing;
	try {
		const probeImageSize = (await import("probe-image-size")).default;
		const probed = await probeImageSize(url, {
			open_timeout: REMOTE_IMAGE_PROBE_TIMEOUT_MS,
			response_timeout: REMOTE_IMAGE_PROBE_TIMEOUT_MS,
			read_timeout: REMOTE_IMAGE_PROBE_TIMEOUT_MS,
			follow_max: 2
		});
		const width = existing.width ?? getFiniteNumber(probed.width);
		const height = existing.height ?? getFiniteNumber(probed.height);
		if (!width || !height) return existing;
		const resolved = {
			width,
			height
		};
		persistImageDimensions(part, resolved);
		return resolved;
	} catch {
		return existing;
	}
}
function resolveImageDimensions(part) {
	const dimensions = getObjectValue(getObjectValue(getObjectValue(part, "providerMetadata"), "mastra"), "imageDimensions");
	const width = getFiniteNumber(getObjectValue(part, "width")) ?? getFiniteNumber(getObjectValue(part, "imageWidth")) ?? getFiniteNumber(getObjectValue(dimensions, "width"));
	const height = getFiniteNumber(getObjectValue(part, "height")) ?? getFiniteNumber(getObjectValue(part, "imageHeight")) ?? getFiniteNumber(getObjectValue(dimensions, "height"));
	if (width && height) return {
		width,
		height
	};
	const buffer = decodeImageBuffer(getObjectValue(part, "image") ?? getObjectValue(part, "data"));
	if (!buffer) return {
		width,
		height
	};
	try {
		const measured = imageSize(buffer);
		const measuredWidth = getFiniteNumber(measured.width);
		const measuredHeight = getFiniteNumber(measured.height);
		if (!measuredWidth || !measuredHeight) return {
			width,
			height
		};
		const resolved = {
			width: width ?? measuredWidth,
			height: height ?? measuredHeight
		};
		persistImageDimensions(part, resolved);
		return resolved;
	} catch {
		return {
			width,
			height
		};
	}
}
function getBase64Size(base64) {
	const sanitized = base64.replace(/\s+/g, "");
	const padding = sanitized.endsWith("==") ? 2 : sanitized.endsWith("=") ? 1 : 0;
	return Math.max(0, Math.floor(sanitized.length * 3 / 4) - padding);
}
function resolveImageSourceStats(image) {
	if (image instanceof URL) return { source: "url" };
	if (typeof image === "string") {
		if (isHttpUrlString(image)) return { source: "url" };
		if (image.startsWith("data:")) {
			const commaIndex = image.indexOf(",");
			return {
				source: "data-uri",
				sizeBytes: getBase64Size(commaIndex === -1 ? "" : image.slice(commaIndex + 1))
			};
		}
		return {
			source: "binary",
			sizeBytes: getBase64Size(image)
		};
	}
	if (typeof Buffer !== "undefined" && Buffer.isBuffer(image)) return {
		source: "binary",
		sizeBytes: image.length
	};
	if (image instanceof Uint8Array) return {
		source: "binary",
		sizeBytes: image.byteLength
	};
	if (image instanceof ArrayBuffer) return {
		source: "binary",
		sizeBytes: image.byteLength
	};
	if (ArrayBuffer.isView(image)) return {
		source: "binary",
		sizeBytes: image.byteLength
	};
	return { source: "binary" };
}
function getPathnameExtension(value) {
	return (value.split("#", 1)[0]?.split("?", 1)[0] ?? value).match(/\.([a-z0-9]+)$/i)?.[1]?.toLowerCase();
}
function hasImageFilenameExtension(filename) {
	return typeof filename === "string" && IMAGE_FILE_EXTENSIONS.has(getPathnameExtension(filename) ?? "");
}
function isImageLikeFilePart(part) {
	if (getObjectValue(part, "type") !== "file") return false;
	const mimeType = getObjectValue(part, "mimeType");
	if (typeof mimeType === "string" && mimeType.toLowerCase().startsWith("image/")) return true;
	const data = getObjectValue(part, "data");
	if (typeof data === "string" && data.startsWith("data:image/")) return true;
	if (data instanceof URL && hasImageFilenameExtension(data.pathname)) return true;
	if (isHttpUrlString(data)) try {
		if (hasImageFilenameExtension(new URL(data).pathname)) return true;
	} catch {}
	return hasImageFilenameExtension(getObjectValue(part, "filename"));
}
function resolveProviderId(modelContext) {
	return modelContext?.provider?.toLowerCase();
}
function resolveModelId(modelContext) {
	return modelContext?.modelId?.toLowerCase() ?? "";
}
function resolveOpenAIImageEstimatorConfig(modelContext) {
	const modelId = resolveModelId(modelContext);
	if (modelId.startsWith("gpt-5") || modelId === "gpt-5-chat-latest") return {
		baseTokens: 70,
		tileTokens: 140,
		fallbackTiles: 4
	};
	if (modelId.startsWith("gpt-4o-mini")) return {
		baseTokens: 2833,
		tileTokens: 5667,
		fallbackTiles: 1
	};
	if (modelId.startsWith("o1") || modelId.startsWith("o3")) return {
		baseTokens: 75,
		tileTokens: 150,
		fallbackTiles: 4
	};
	if (modelId.includes("computer-use")) return {
		baseTokens: 65,
		tileTokens: 129,
		fallbackTiles: 4
	};
	return DEFAULT_IMAGE_ESTIMATOR;
}
function isGoogleGemini3Model(modelContext) {
	return resolveProviderId(modelContext) === "google" && resolveModelId(modelContext).startsWith("gemini-3");
}
function scaleDimensionsForOpenAIHighDetail(width, height) {
	let scaledWidth = width;
	let scaledHeight = height;
	const largestSide = Math.max(scaledWidth, scaledHeight);
	if (largestSide > 2048) {
		const ratio = 2048 / largestSide;
		scaledWidth *= ratio;
		scaledHeight *= ratio;
	}
	const shortestSide = Math.min(scaledWidth, scaledHeight);
	if (shortestSide > 768) {
		const ratio = 768 / shortestSide;
		scaledWidth *= ratio;
		scaledHeight *= ratio;
	}
	return {
		width: Math.max(1, Math.round(scaledWidth)),
		height: Math.max(1, Math.round(scaledHeight))
	};
}
function scaleDimensionsForAnthropic(width, height) {
	const largestSide = Math.max(width, height);
	if (largestSide <= ANTHROPIC_IMAGE_MAX_LONG_EDGE) return {
		width,
		height
	};
	const ratio = ANTHROPIC_IMAGE_MAX_LONG_EDGE / largestSide;
	return {
		width: Math.max(1, Math.round(width * ratio)),
		height: Math.max(1, Math.round(height * ratio))
	};
}
function estimateOpenAIHighDetailTiles(dimensions, sourceStats, estimator) {
	if (dimensions.width && dimensions.height) {
		const scaled = scaleDimensionsForOpenAIHighDetail(dimensions.width, dimensions.height);
		return Math.max(1, Math.ceil(scaled.width / 512) * Math.ceil(scaled.height / 512));
	}
	if (sourceStats.sizeBytes !== void 0) {
		if (sourceStats.sizeBytes <= 512 * 1024) return 1;
		if (sourceStats.sizeBytes <= 2 * 1024 * 1024) return 4;
		if (sourceStats.sizeBytes <= 4 * 1024 * 1024) return 6;
		return 8;
	}
	return estimator.fallbackTiles;
}
function resolveEffectiveOpenAIImageDetail(detail, dimensions, sourceStats) {
	if (detail === "low" || detail === "high") return detail;
	if (dimensions.width && dimensions.height) return Math.max(dimensions.width, dimensions.height) > 768 ? "high" : "low";
	if (sourceStats.sizeBytes !== void 0) return sourceStats.sizeBytes > 1024 * 1024 ? "high" : "low";
	return "low";
}
function estimateLegacyGoogleImageTiles(dimensions) {
	if (!dimensions.width || !dimensions.height) return 1;
	return Math.max(1, Math.ceil(dimensions.width / 768) * Math.ceil(dimensions.height / 768));
}
function estimateAnthropicImageTokens(dimensions, sourceStats) {
	if (dimensions.width && dimensions.height) {
		const scaled = scaleDimensionsForAnthropic(dimensions.width, dimensions.height);
		return Math.max(1, Math.ceil(scaled.width * scaled.height * ANTHROPIC_IMAGE_TOKENS_PER_PIXEL));
	}
	if (sourceStats.sizeBytes !== void 0) {
		if (sourceStats.sizeBytes <= 512 * 1024) return 341;
		if (sourceStats.sizeBytes <= 2 * 1024 * 1024) return 1366;
		if (sourceStats.sizeBytes <= 4 * 1024 * 1024) return 2048;
		return 2731;
	}
	return 1600;
}
/**
* Maps a non-image file part's byte size to a token estimate, using a
* provider-aware heuristic. This is the non-image-file equivalent of
* {@link estimateAnthropicImageTokens} / {@link estimateOpenAIHighDetailTiles}:
* it doesn't try to be exact, just close enough that the Observational Memory
* threshold check trips on large attachments.
*
* - Anthropic PDFs: ~1500–3000 tokens/page, ~5KB/page average → `bytes / 3`.
* - Google PDFs: 258 tokens/page (Gemini docs), ~5KB/page → `bytes / 20`.
* - OpenAI / unknown provider PDFs: `bytes / 4` (conservative).
* - Text-ish mime types (`text/*`, JSON, XML, YAML): `bytes / 4`.
* - Unknown binary: `bytes / 4` — conservative-upward so OM still fires.
*
* Floors guarantee a one-page file still produces a meaningful count even when
* the underlying bytes are heavily compressed.
*/
function estimateFileTokensFromBytes(provider, mimeType, sizeBytes) {
	const normalizedMime = (mimeType ?? "").toLowerCase().split(";", 1)[0].trim();
	const isPdf = normalizedMime === "application/pdf";
	const isTextish = normalizedMime.startsWith("text/") || [
		"application/json",
		"application/xml",
		"application/x-yaml",
		"application/yaml"
	].includes(normalizedMime);
	if (isPdf) {
		if (provider === "google") return Math.max(258, Math.ceil(sizeBytes / 20));
		if (provider === "anthropic") return Math.max(1500, Math.ceil(sizeBytes / 3));
		return Math.max(500, Math.ceil(sizeBytes / 4));
	}
	if (isTextish) return Math.max(1, Math.ceil(sizeBytes / 4));
	return Math.max(1, Math.ceil(sizeBytes / 4));
}
/**
* Builds a fixed token estimate for a non-image file part from its byte size.
* Returns `undefined` when the part has no measurable body (e.g. a remote URL
* with no fetched content) — in that case the caller falls back to the
* descriptor-only estimate, which preserves prior behavior for URL-only parts.
*
* Mirrors {@link estimateImageAssetTokens} so non-image files share the same
* cache shape as images and benefit from the same persistence path via
* `readOrPersistFixedPartEstimate`.
*/
function estimateNonImageFileTokens(modelContext, part) {
	const sourceStats = resolveImageSourceStats(getObjectValue(part, "data"));
	if (sourceStats.sizeBytes === void 0) return;
	const provider = resolveProviderId(modelContext);
	const modelId = modelContext?.modelId ?? null;
	const mimeType = getAttachmentMimeType(part, "application/octet-stream");
	const filename = getAttachmentFilename(part) ?? null;
	return {
		tokens: estimateFileTokensFromBytes(provider, mimeType, sourceStats.sizeBytes),
		cachePayload: JSON.stringify({
			kind: "non-image-file",
			provider: provider ?? "fallback",
			modelId,
			estimator: "bytes",
			source: sourceStats.source,
			sizeBytes: sourceStats.sizeBytes,
			mimeType,
			filename
		})
	};
}
function estimateGoogleImageTokens(modelContext, part, dimensions) {
	if (isGoogleGemini3Model(modelContext)) {
		const mediaResolution = resolveGoogleMediaResolution(part);
		return {
			tokens: GOOGLE_GEMINI_3_IMAGE_TOKENS_BY_RESOLUTION[mediaResolution],
			mediaResolution
		};
	}
	return {
		tokens: estimateLegacyGoogleImageTiles(dimensions) * GOOGLE_LEGACY_IMAGE_TOKENS_PER_TILE,
		mediaResolution: "unspecified"
	};
}
function getProviderApiKey(provider) {
	for (const envVar of PROVIDER_API_KEY_ENV_VARS[provider] ?? []) {
		const value = process.env[envVar];
		if (typeof value === "string" && value.trim().length > 0) return value.trim();
	}
}
function getAttachmentFilename(part) {
	const explicitFilename = getObjectValue(part, "filename");
	if (typeof explicitFilename === "string" && explicitFilename.trim().length > 0) return explicitFilename.trim();
	return getFilenameFromAttachmentData(getObjectValue(part, "data") ?? getObjectValue(part, "image"));
}
function getAttachmentMimeType(part, fallback) {
	const mimeType = getObjectValue(part, "mimeType");
	if (typeof mimeType === "string" && mimeType.trim().length > 0) return mimeType.trim();
	const asset = getObjectValue(part, "data") ?? getObjectValue(part, "image");
	if (typeof asset === "string" && asset.startsWith("data:")) {
		const semicolonIndex = asset.indexOf(";");
		const commaIndex = asset.indexOf(",");
		const endIndex = semicolonIndex === -1 ? commaIndex : Math.min(semicolonIndex, commaIndex);
		if (endIndex > 5) return asset.slice(5, endIndex);
	}
	return fallback;
}
function getAttachmentUrl(asset) {
	if (asset instanceof URL) return asset.toString();
	if (typeof asset === "string" && /^(https?:\/\/|data:)/i.test(asset)) return asset;
}
function getAttachmentFingerprint(asset) {
	const url = getAttachmentUrl(asset);
	if (url) return { url };
	const base64 = encodeAttachmentBase64(asset);
	if (base64) return { contentHash: createHash("sha256").update(base64).digest("hex") };
	return {};
}
function encodeAttachmentBase64(asset) {
	if (typeof asset === "string") {
		if (asset.startsWith("data:")) {
			const commaIndex = asset.indexOf(",");
			return commaIndex === -1 ? void 0 : asset.slice(commaIndex + 1);
		}
		if (/^https?:\/\//i.test(asset)) return;
		return asset;
	}
	if (typeof Buffer !== "undefined" && Buffer.isBuffer(asset)) return asset.toString("base64");
	if (asset instanceof Uint8Array) return Buffer.from(asset).toString("base64");
	if (asset instanceof ArrayBuffer) return Buffer.from(asset).toString("base64");
	if (ArrayBuffer.isView(asset)) return Buffer.from(asset.buffer, asset.byteOffset, asset.byteLength).toString("base64");
}
function createTimeoutSignal(timeoutMs) {
	const controller = new AbortController();
	const timeout = setTimeout(() => controller.abort(/* @__PURE__ */ new Error(`Attachment token counting timed out after ${timeoutMs}ms`)), timeoutMs);
	const cleanup = () => clearTimeout(timeout);
	controller.signal.addEventListener("abort", cleanup, { once: true });
	return {
		signal: controller.signal,
		cleanup
	};
}
function getNumericResponseField(value, paths) {
	for (const path of paths) {
		let current = value;
		for (const segment of path) {
			current = getObjectValue(current, segment);
			if (current === void 0) break;
		}
		if (typeof current === "number" && Number.isFinite(current)) return current;
	}
}
function toOpenAIInputPart(part) {
	if (getObjectValue(part, "type") === "image" || isImageLikeFilePart(part)) {
		const asset = getObjectValue(part, "image") ?? getObjectValue(part, "data");
		const imageUrl = getAttachmentUrl(asset);
		if (imageUrl) return {
			type: "input_image",
			image_url: imageUrl,
			detail: resolveImageDetail(part)
		};
		const base64 = encodeAttachmentBase64(asset);
		if (!base64) return void 0;
		return {
			type: "input_image",
			image_url: `data:${getAttachmentMimeType(part, "image/png")};base64,${base64}`,
			detail: resolveImageDetail(part)
		};
	}
	if (getObjectValue(part, "type") === "file") {
		const asset = getObjectValue(part, "data");
		const fileUrl = getAttachmentUrl(asset);
		return fileUrl ? {
			type: "input_file",
			file_url: fileUrl,
			filename: getAttachmentFilename(part) ?? "attachment"
		} : (() => {
			const base64 = encodeAttachmentBase64(asset);
			if (!base64) return void 0;
			return {
				type: "input_file",
				file_data: `data:${getAttachmentMimeType(part, "application/octet-stream")};base64,${base64}`,
				filename: getAttachmentFilename(part) ?? "attachment"
			};
		})();
	}
}
function toAnthropicContentPart(part) {
	const asset = getObjectValue(part, "image") ?? getObjectValue(part, "data");
	const url = getAttachmentUrl(asset);
	if (getObjectValue(part, "type") === "image" || isImageLikeFilePart(part)) return url && /^https?:\/\//i.test(url) ? {
		type: "image",
		source: {
			type: "url",
			url
		}
	} : (() => {
		const base64 = encodeAttachmentBase64(asset);
		if (!base64) return void 0;
		return {
			type: "image",
			source: {
				type: "base64",
				media_type: getAttachmentMimeType(part, "image/png"),
				data: base64
			}
		};
	})();
	if (getObjectValue(part, "type") === "file") return url && /^https?:\/\//i.test(url) ? {
		type: "document",
		source: {
			type: "url",
			url
		}
	} : (() => {
		const base64 = encodeAttachmentBase64(asset);
		if (!base64) return void 0;
		return {
			type: "document",
			source: {
				type: "base64",
				media_type: getAttachmentMimeType(part, "application/pdf"),
				data: base64
			}
		};
	})();
}
function toGooglePart(part) {
	const asset = getObjectValue(part, "image") ?? getObjectValue(part, "data");
	const url = getAttachmentUrl(asset);
	const mimeType = getAttachmentMimeType(part, getObjectValue(part, "type") === "file" && !isImageLikeFilePart(part) ? "application/pdf" : "image/png");
	if (url && !url.startsWith("data:")) return { fileData: {
		mimeType,
		fileUri: url
	} };
	const base64 = encodeAttachmentBase64(asset);
	if (!base64) return void 0;
	return { inlineData: {
		mimeType,
		data: base64
	} };
}
async function fetchOpenAIAttachmentTokenEstimate(modelId, part) {
	const apiKey = getProviderApiKey("openai");
	const inputPart = toOpenAIInputPart(part);
	if (!apiKey || !inputPart) return void 0;
	const { signal, cleanup } = createTimeoutSignal(ATTACHMENT_COUNT_TIMEOUT_MS);
	try {
		const response = await fetch("https://api.openai.com/v1/responses/input_tokens", {
			method: "POST",
			headers: {
				Authorization: `Bearer ${apiKey}`,
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				model: modelId,
				input: [{
					type: "message",
					role: "user",
					content: [inputPart]
				}]
			}),
			signal
		});
		if (!response.ok) return void 0;
		return getNumericResponseField(await response.json(), [
			["input_tokens"],
			["total_tokens"],
			["usage", "input_tokens"],
			["usage", "total_tokens"]
		]);
	} finally {
		cleanup();
	}
}
async function fetchAnthropicAttachmentTokenEstimate(modelId, part) {
	const apiKey = getProviderApiKey("anthropic");
	const contentPart = toAnthropicContentPart(part);
	if (!apiKey || !contentPart) return void 0;
	const { signal, cleanup } = createTimeoutSignal(ATTACHMENT_COUNT_TIMEOUT_MS);
	try {
		const response = await fetch("https://api.anthropic.com/v1/messages/count_tokens", {
			method: "POST",
			headers: {
				"x-api-key": apiKey,
				"anthropic-version": "2023-06-01",
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				model: modelId,
				messages: [{
					role: "user",
					content: [contentPart]
				}]
			}),
			signal
		});
		if (!response.ok) return void 0;
		return getNumericResponseField(await response.json(), [["input_tokens"]]);
	} finally {
		cleanup();
	}
}
async function fetchGoogleAttachmentTokenEstimate(modelId, part) {
	const apiKey = getProviderApiKey("google");
	const googlePart = toGooglePart(part);
	if (!apiKey || !googlePart) return void 0;
	const { signal, cleanup } = createTimeoutSignal(ATTACHMENT_COUNT_TIMEOUT_MS);
	try {
		const response = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/${modelId}:countTokens`, {
			method: "POST",
			headers: {
				"x-goog-api-key": apiKey,
				"Content-Type": "application/json"
			},
			body: JSON.stringify({ contents: [{
				role: "user",
				parts: [googlePart]
			}] }),
			signal
		});
		if (!response.ok) return void 0;
		return getNumericResponseField(await response.json(), [["totalTokens"], ["total_tokens"]]);
	} finally {
		cleanup();
	}
}
/**
* Token counting utility using tokenx for rough local estimation and
* provider-aware heuristics for image parts so multimodal prompts are not
* undercounted as generic JSON blobs.
*/
var TokenCounter = class TokenCounter {
	cacheSource;
	defaultModelContext;
	modelContextStorage = new AsyncLocalStorage();
	inFlightAttachmentCounts = /* @__PURE__ */ new Map();
	static TOKENS_PER_MESSAGE = 3.8;
	static TOKENS_PER_CONVERSATION = 24;
	constructor(options) {
		this.cacheSource = `v${TOKEN_ESTIMATE_CACHE_VERSION}:${resolveEstimatorId()}`;
		this.defaultModelContext = parseModelContext(options?.model);
	}
	runWithModelContext(model, fn) {
		return this.modelContextStorage.run(parseModelContext(model), fn);
	}
	getModelContext() {
		return this.modelContextStorage.getStore() ?? this.defaultModelContext;
	}
	/**
	* Count tokens in a plain string
	*/
	countString(text) {
		if (!text) return 0;
		return estimateTokenCount(text);
	}
	readOrPersistPartEstimate(part, kind, payload) {
		const key = buildEstimateKey(kind, payload);
		const cached = getPartCacheEntry(part, key);
		if (isValidCacheEntry(cached, key, this.cacheSource)) return cached.tokens;
		const tokens = this.countString(payload);
		setPartCacheEntry(part, key, {
			v: TOKEN_ESTIMATE_CACHE_VERSION,
			source: this.cacheSource,
			key,
			tokens
		});
		return tokens;
	}
	readOrPersistFixedPartEstimate(part, kind, payload, tokens) {
		const key = buildEstimateKey(kind, payload);
		const cached = getPartCacheEntry(part, key);
		if (isValidCacheEntry(cached, key, this.cacheSource)) return cached.tokens;
		setPartCacheEntry(part, key, {
			v: TOKEN_ESTIMATE_CACHE_VERSION,
			source: this.cacheSource,
			key,
			tokens
		});
		return tokens;
	}
	readOrPersistMessageEstimate(message, kind, payload) {
		const key = buildEstimateKey(kind, payload);
		const cached = getMessageCacheEntry(message, key);
		if (isValidCacheEntry(cached, key, this.cacheSource)) return cached.tokens;
		const tokens = this.countString(payload);
		setMessageCacheEntry(message, key, {
			v: TOKEN_ESTIMATE_CACHE_VERSION,
			source: this.cacheSource,
			key,
			tokens
		});
		return tokens;
	}
	resolveToolResultForTokenCounting(part, invocationResult) {
		return resolveToolResultValue(part, invocationResult);
	}
	countMultimodalToolResultContent(part, toolResult) {
		if (!toolResult || typeof toolResult !== "object") return;
		const output = toolResult;
		const content = output.type === "content" && Array.isArray(output.value) ? output.value : output.content;
		if (!Array.isArray(content)) return;
		let hasAttachment = false;
		let tokens = 0;
		const cacheParts = [];
		const countJsonContentPart = (contentPart) => {
			const formatted = formatToolResultForObserver(contentPart);
			tokens += this.countString(formatted);
			cacheParts.push({
				type: "json",
				valueHash: createHash("sha256").update(formatted).digest("hex")
			});
		};
		for (const item of content) {
			if (!item || typeof item !== "object") continue;
			const contentPart = item;
			const partType = contentPart.type;
			if (partType === "text") {
				const text = typeof contentPart.text === "string" ? contentPart.text : String(contentPart.value ?? "");
				tokens += this.countString(text);
				cacheParts.push({
					type: "text",
					textHash: createHash("sha256").update(text).digest("hex")
				});
				continue;
			}
			if (partType === "image" || partType === "image-data" || partType === "media" && String(contentPart.mediaType ?? "").startsWith("image/")) {
				if (typeof contentPart.data !== "string") {
					countJsonContentPart(contentPart);
					continue;
				}
				hasAttachment = true;
				const imagePart = {
					type: "image",
					image: contentPart.data,
					mimeType: contentPart.mediaType ?? contentPart.mimeType,
					providerOptions: contentPart.providerOptions,
					providerMetadata: contentPart.providerMetadata
				};
				const clientEstimate = getClientPartTokenEstimate(imagePart);
				if (clientEstimate) {
					tokens += clientEstimate.tokens;
					cacheParts.push({
						type: "image-data-client-estimate",
						key: clientEstimate.key,
						tokens: clientEstimate.tokens
					});
					continue;
				}
				const estimate = this.estimateImageTokens(imagePart);
				tokens += estimate.tokens;
				cacheParts.push({
					type: "image-data",
					estimate: JSON.parse(estimate.cachePayload)
				});
				continue;
			}
			if (partType === "audio" || partType === "file-data" || partType === "media") {
				if (typeof contentPart.data !== "string") {
					countJsonContentPart(contentPart);
					continue;
				}
				hasAttachment = true;
				const filePart = {
					type: "file",
					data: contentPart.data,
					mimeType: contentPart.mediaType ?? contentPart.mimeType,
					filename: contentPart.filename,
					providerOptions: contentPart.providerOptions,
					providerMetadata: contentPart.providerMetadata
				};
				const clientEstimate = getClientPartTokenEstimate(filePart);
				if (clientEstimate) {
					tokens += clientEstimate.tokens;
					cacheParts.push({
						type: "file-data-client-estimate",
						key: clientEstimate.key,
						tokens: clientEstimate.tokens
					});
					continue;
				}
				if (isImageLikeFilePart(filePart)) {
					const estimate = this.estimateImageLikeFileTokens(filePart);
					tokens += estimate.tokens;
					cacheParts.push({
						type: "image-like-file-data",
						estimate: JSON.parse(estimate.cachePayload)
					});
					continue;
				}
				const byteEstimate = estimateNonImageFileTokens(this.getModelContext(), filePart);
				if (byteEstimate) {
					tokens += byteEstimate.tokens;
					cacheParts.push({
						type: "file-data",
						estimate: JSON.parse(byteEstimate.cachePayload)
					});
					continue;
				}
				const descriptor = serializeNonImageFilePartForTokenCounting(filePart);
				tokens += this.countString(descriptor);
				cacheParts.push({
					type: "file-data-descriptor",
					descriptor
				});
				continue;
			}
			countJsonContentPart(contentPart);
		}
		if (!hasAttachment) return;
		return this.readOrPersistFixedPartEstimate(part, "tool-result-multimodal-content", JSON.stringify({
			type: "content",
			value: cacheParts
		}), tokens);
	}
	estimateImageAssetTokens(part, asset, kind) {
		const modelContext = this.getModelContext();
		const provider = resolveProviderId(modelContext);
		const modelId = modelContext?.modelId ?? null;
		const detail = resolveImageDetail(part);
		const dimensions = resolveImageDimensions(part);
		const sourceStats = resolveImageSourceStats(asset);
		if (provider === "google") {
			const googleEstimate = estimateGoogleImageTokens(modelContext, part, dimensions);
			return {
				tokens: googleEstimate.tokens,
				cachePayload: JSON.stringify({
					kind,
					provider,
					modelId,
					estimator: isGoogleGemini3Model(modelContext) ? "google-gemini-3" : "google-legacy",
					mediaResolution: googleEstimate.mediaResolution,
					width: dimensions.width ?? null,
					height: dimensions.height ?? null,
					source: sourceStats.source,
					sizeBytes: sourceStats.sizeBytes ?? null,
					mimeType: getObjectValue(part, "mimeType") ?? null,
					filename: getObjectValue(part, "filename") ?? null
				})
			};
		}
		if (provider === "anthropic") return {
			tokens: estimateAnthropicImageTokens(dimensions, sourceStats),
			cachePayload: JSON.stringify({
				kind,
				provider,
				modelId,
				estimator: "anthropic",
				width: dimensions.width ?? null,
				height: dimensions.height ?? null,
				source: sourceStats.source,
				sizeBytes: sourceStats.sizeBytes ?? null,
				mimeType: getObjectValue(part, "mimeType") ?? null,
				filename: getObjectValue(part, "filename") ?? null
			})
		};
		const estimator = resolveOpenAIImageEstimatorConfig(modelContext);
		const effectiveDetail = resolveEffectiveOpenAIImageDetail(detail, dimensions, sourceStats);
		const tiles = effectiveDetail === "high" ? estimateOpenAIHighDetailTiles(dimensions, sourceStats, estimator) : 0;
		return {
			tokens: estimator.baseTokens + tiles * estimator.tileTokens,
			cachePayload: JSON.stringify({
				kind,
				provider,
				modelId,
				estimator: provider === "openai" ? "openai" : "fallback",
				detail,
				effectiveDetail,
				width: dimensions.width ?? null,
				height: dimensions.height ?? null,
				source: sourceStats.source,
				sizeBytes: sourceStats.sizeBytes ?? null,
				mimeType: getObjectValue(part, "mimeType") ?? null,
				filename: getObjectValue(part, "filename") ?? null
			})
		};
	}
	estimateImageTokens(part) {
		return this.estimateImageAssetTokens(part, part.image, "image");
	}
	estimateImageLikeFileTokens(part) {
		return this.estimateImageAssetTokens(part, part.data, "file");
	}
	countAttachmentPartSync(part) {
		if (part.type === "image" || part.type === "file") {
			const clientEstimate = getClientPartTokenEstimate(part);
			if (clientEstimate) return clientEstimate.tokens;
		}
		if (part.type === "image") {
			const estimate = this.estimateImageTokens(part);
			return this.readOrPersistFixedPartEstimate(part, "image", estimate.cachePayload, estimate.tokens);
		}
		if (part.type === "file" && isImageLikeFilePart(part)) {
			const estimate = this.estimateImageLikeFileTokens(part);
			return this.readOrPersistFixedPartEstimate(part, "image-like-file", estimate.cachePayload, estimate.tokens);
		}
		if (part.type === "file") {
			const byteEstimate = estimateNonImageFileTokens(this.getModelContext(), part);
			if (byteEstimate) return this.readOrPersistFixedPartEstimate(part, "non-image-file", byteEstimate.cachePayload, byteEstimate.tokens);
			return this.readOrPersistPartEstimate(part, "file-descriptor", serializeNonImageFilePartForTokenCounting(part));
		}
	}
	buildRemoteAttachmentCachePayload(part) {
		const isImageAttachment = part.type === "image" || part.type === "file" && isImageLikeFilePart(part);
		const isNonImageFileAttachment = part.type === "file" && !isImageAttachment;
		if (!isImageAttachment && !isNonImageFileAttachment) return;
		const modelContext = this.getModelContext();
		const provider = resolveProviderId(modelContext);
		const modelId = modelContext?.modelId ?? null;
		if (!provider || !modelId || ![
			"openai",
			"google",
			"anthropic"
		].includes(provider)) return;
		const asset = getObjectValue(part, "image") ?? getObjectValue(part, "data");
		const sourceStats = resolveImageSourceStats(asset);
		const fingerprint = getAttachmentFingerprint(asset);
		return JSON.stringify({
			strategy: "provider-endpoint",
			provider,
			modelId,
			type: getObjectValue(part, "type") ?? null,
			detail: isImageAttachment ? resolveImageDetail(part) : null,
			mediaResolution: provider === "google" && isImageAttachment ? resolveGoogleMediaResolution(part) : null,
			mimeType: getAttachmentMimeType(part, isNonImageFileAttachment ? "application/pdf" : "image/png"),
			filename: getAttachmentFilename(part) ?? null,
			source: sourceStats.source,
			sizeBytes: sourceStats.sizeBytes ?? null,
			assetUrl: fingerprint.url ?? null,
			assetHash: fingerprint.contentHash ?? null
		});
	}
	async fetchProviderAttachmentTokenEstimate(part) {
		const modelContext = this.getModelContext();
		const provider = resolveProviderId(modelContext);
		const modelId = modelContext?.modelId;
		if (!provider || !modelId) return void 0;
		try {
			if (provider === "openai") return await fetchOpenAIAttachmentTokenEstimate(modelId, part);
			if (provider === "google") return await fetchGoogleAttachmentTokenEstimate(modelId, part);
			if (provider === "anthropic") return await fetchAnthropicAttachmentTokenEstimate(modelId, part);
		} catch {
			return;
		}
	}
	async countAttachmentPartAsync(part) {
		if (part.type === "image" || part.type === "file") {
			const clientEstimate = getClientPartTokenEstimate(part);
			if (clientEstimate) return clientEstimate.tokens;
		}
		const isImageAttachment = part.type === "image" || part.type === "file" && isImageLikeFilePart(part);
		const remotePayload = this.buildRemoteAttachmentCachePayload(part);
		if (remotePayload) {
			const remoteKey = buildEstimateKey("attachment-provider", remotePayload);
			const cachedRemote = getPartCacheEntry(part, remoteKey);
			if (isValidCacheEntry(cachedRemote, remoteKey, this.cacheSource)) return cachedRemote.tokens;
			const existingRequest = this.inFlightAttachmentCounts.get(remoteKey);
			if (existingRequest) {
				const remoteTokens = await existingRequest;
				if (typeof remoteTokens === "number" && Number.isFinite(remoteTokens) && remoteTokens > 0) {
					setPartCacheEntry(part, remoteKey, {
						v: TOKEN_ESTIMATE_CACHE_VERSION,
						source: this.cacheSource,
						key: remoteKey,
						tokens: remoteTokens
					});
					return remoteTokens;
				}
			} else {
				const remoteRequest = this.fetchProviderAttachmentTokenEstimate(part);
				this.inFlightAttachmentCounts.set(remoteKey, remoteRequest);
				let remoteTokens;
				try {
					remoteTokens = await remoteRequest;
				} finally {
					this.inFlightAttachmentCounts.delete(remoteKey);
				}
				if (typeof remoteTokens === "number" && Number.isFinite(remoteTokens) && remoteTokens > 0) {
					setPartCacheEntry(part, remoteKey, {
						v: TOKEN_ESTIMATE_CACHE_VERSION,
						source: this.cacheSource,
						key: remoteKey,
						tokens: remoteTokens
					});
					return remoteTokens;
				}
			}
			if (isImageAttachment) await resolveImageDimensionsAsync(part);
			const fallbackKey = buildEstimateKey("attachment-provider", JSON.stringify({
				...JSON.parse(remotePayload),
				strategy: "local-fallback",
				...isImageAttachment ? resolveImageDimensions(part) : {}
			}));
			const cachedFallback = getPartCacheEntry(part, fallbackKey);
			if (isValidCacheEntry(cachedFallback, fallbackKey, this.cacheSource)) return cachedFallback.tokens;
			const localTokens = this.countAttachmentPartSync(part);
			if (localTokens === void 0) return;
			setPartCacheEntry(part, fallbackKey, {
				v: TOKEN_ESTIMATE_CACHE_VERSION,
				source: this.cacheSource,
				key: fallbackKey,
				tokens: localTokens
			});
			return localTokens;
		}
		if (isImageAttachment) await resolveImageDimensionsAsync(part);
		return this.countAttachmentPartSync(part);
	}
	countNonAttachmentPart(part) {
		let overheadDelta = 0;
		let toolResultDelta = 0;
		if (part.type === "text") return {
			tokens: this.readOrPersistPartEstimate(part, "text", part.text),
			overheadDelta,
			toolResultDelta
		};
		if (part.type === "tool-invocation") {
			const invocation = part.toolInvocation;
			let tokens = 0;
			if (invocation.state === "call" || invocation.state === "partial-call") {
				if (invocation.toolName) tokens += this.readOrPersistPartEstimate(part, `tool-${invocation.state}-name`, invocation.toolName);
				if (invocation.args) if (typeof invocation.args === "string") tokens += this.readOrPersistPartEstimate(part, `tool-${invocation.state}-args`, invocation.args);
				else {
					const argsJson = JSON.stringify(invocation.args);
					tokens += this.readOrPersistPartEstimate(part, `tool-${invocation.state}-args-json`, argsJson);
					overheadDelta -= 12;
				}
				return {
					tokens,
					overheadDelta,
					toolResultDelta
				};
			}
			if (invocation.state === "result") {
				toolResultDelta++;
				const { value: resultForCounting, usingStoredModelOutput } = this.resolveToolResultForTokenCounting(part, invocation.result);
				if (resultForCounting !== void 0) {
					const contentTokens = this.countMultimodalToolResultContent(part, resultForCounting);
					if (contentTokens !== void 0) tokens += contentTokens;
					else {
						const formattedResult = formatToolResultForObserver(resultForCounting);
						tokens += this.readOrPersistPartEstimate(part, usingStoredModelOutput ? "tool-result-model-output-json" : "tool-result-json", formattedResult);
					}
					if (typeof resultForCounting !== "string") overheadDelta -= 12;
				}
				return {
					tokens,
					overheadDelta,
					toolResultDelta
				};
			}
			if (invocation.state === "output-denied") {
				toolResultDelta++;
				const reason = invocation.approval?.reason ?? "Tool call was not approved by the user";
				tokens += this.readOrPersistPartEstimate(part, "tool-result-denied", reason);
				return {
					tokens,
					overheadDelta,
					toolResultDelta
				};
			}
			throw new Error(`Unhandled tool-invocation state '${part.toolInvocation?.state}' in token counting for part type '${part.type}'`);
		}
		if (typeof part.type === "string" && part.type.startsWith("data-")) return {
			tokens: 0,
			overheadDelta,
			toolResultDelta
		};
		if (part.type === "reasoning") return {
			tokens: 0,
			overheadDelta,
			toolResultDelta
		};
		const serialized = serializePartForTokenCounting(part);
		return {
			tokens: this.readOrPersistPartEstimate(part, `part-${part.type}`, serialized),
			overheadDelta,
			toolResultDelta
		};
	}
	/**
	* Count tokens in a single message
	*/
	countMessage(message) {
		let payloadTokens = this.countString(message.role);
		let overhead = TokenCounter.TOKENS_PER_MESSAGE;
		let toolResultCount = 0;
		if (typeof message.content === "string") payloadTokens += this.readOrPersistMessageEstimate(message, "message-content", message.content);
		else if (message.content && typeof message.content === "object") {
			if (message.content.content && !Array.isArray(message.content.parts)) payloadTokens += this.readOrPersistMessageEstimate(message, "content-content", message.content.content);
			else if (Array.isArray(message.content.parts)) for (const part of message.content.parts) {
				const attachmentTokens = this.countAttachmentPartSync(part);
				if (attachmentTokens !== void 0) {
					payloadTokens += attachmentTokens;
					continue;
				}
				const result = this.countNonAttachmentPart(part);
				payloadTokens += result.tokens;
				overhead += result.overheadDelta;
				toolResultCount += result.toolResultDelta;
			}
		}
		if (toolResultCount > 0) overhead += toolResultCount * TokenCounter.TOKENS_PER_MESSAGE;
		return Math.round(payloadTokens + overhead);
	}
	async countMessageAsync(message) {
		let payloadTokens = this.countString(message.role);
		let overhead = TokenCounter.TOKENS_PER_MESSAGE;
		let toolResultCount = 0;
		if (typeof message.content === "string") payloadTokens += this.readOrPersistMessageEstimate(message, "message-content", message.content);
		else if (message.content && typeof message.content === "object") {
			if (message.content.content && !Array.isArray(message.content.parts)) payloadTokens += this.readOrPersistMessageEstimate(message, "content-content", message.content.content);
			else if (Array.isArray(message.content.parts)) for (const part of message.content.parts) {
				const attachmentTokens = await this.countAttachmentPartAsync(part);
				if (attachmentTokens !== void 0) {
					payloadTokens += attachmentTokens;
					continue;
				}
				const result = this.countNonAttachmentPart(part);
				payloadTokens += result.tokens;
				overhead += result.overheadDelta;
				toolResultCount += result.toolResultDelta;
			}
		}
		if (toolResultCount > 0) overhead += toolResultCount * TokenCounter.TOKENS_PER_MESSAGE;
		return Math.round(payloadTokens + overhead);
	}
	/**
	* Count tokens in an array of messages
	*/
	countMessages(messages) {
		if (!messages || messages.length === 0) return 0;
		let total = TokenCounter.TOKENS_PER_CONVERSATION;
		for (const message of messages) total += this.countMessage(message);
		return total;
	}
	async countMessagesAsync(messages) {
		if (!messages || messages.length === 0) return 0;
		const messageTotals = await Promise.all(messages.map((message) => this.countMessageAsync(message)));
		return TokenCounter.TOKENS_PER_CONVERSATION + messageTotals.reduce((sum, count) => sum + count, 0);
	}
	/**
	* Count tokens in observations string
	*/
	countObservations(observations) {
		return this.countString(observations);
	}
};
//#endregion
//#region src/processors/observational-memory/summarize.ts
/** Defaults for how `Memory.summarizeThread()` loads a thread's messages from storage. */
const SUMMARIZE_THREAD_DEFAULTS = {
	/** Stop loading older messages once the collected messages exceed this estimated token count. */
	maxInputTokens: 1e6,
	/** Number of messages fetched per storage page while paginating backwards from the newest message. */
	pageSize: 100
};
/**
* Summarize a conversation in one shot, without Observational Memory attached to an agent.
*
* Reuses Observational Memory's Observer plumbing — the same distillation prompt, output
* parsing, retry handling, and extractor pipeline — as a standalone call over the messages
* you pass in. Nothing is read from or written to storage: the summary and extracted values
* are returned to you (and to each extractor's `onExtracted` hook), so you decide where they
* go.
*
* Use this when a session ends and you want a summary or structured extraction of the whole
* conversation — for example a voice call at hang-up. If Observational Memory is configured
* on a `Memory` instance and you want to summarize one of its threads, use
* `memory.summarizeThread()` instead, which loads the messages for you.
*
* @example
* ```ts
* import { summarizeConversation, Extractor } from '@mastra/memory';
* import { z } from 'zod';
*
* const result = await summarizeConversation({
*   model: 'openai/gpt-4.1-mini',
*   messages,
*   instructions: 'Summarize this voicemail call for the business owner.',
*   extract: [
*     new Extractor({
*       name: 'call-summary',
*       instructions: 'Return a concise summary of the call.',
*       schema: z.object({
*         summary: z.string(),
*         sentiment: z.enum(['positive', 'neutral', 'negative']),
*       }),
*       metadataKeyPath: false,
*     }),
*   ],
* });
* result.extracted['call-summary']; // { summary, sentiment }
* ```
*/
async function summarizeConversation(opts) {
	const { messages } = opts;
	if (messages.length === 0) return {
		summary: "",
		extracted: {}
	};
	const extractors = opts.extract ?? [];
	const runner = new ObserverRunner({
		observationConfig: {
			model: opts.model,
			messageTokens: OBSERVATIONAL_MEMORY_DEFAULTS.observation.messageTokens,
			shareTokenBudget: false,
			modelSettings: { ...OBSERVATIONAL_MEMORY_DEFAULTS.observation.modelSettings },
			providerOptions: OBSERVATIONAL_MEMORY_DEFAULTS.observation.providerOptions,
			maxTokensPerBatch: OBSERVATIONAL_MEMORY_DEFAULTS.observation.maxTokensPerBatch,
			bufferOnIdle: false,
			observeAttachments: "auto",
			instruction: opts.instructions,
			threadTitle: false,
			extractors
		},
		observedMessageIds: /* @__PURE__ */ new Set(),
		resolveModel: () => ({ model: opts.model }),
		tokenCounter: new TokenCounter({ model: typeof opts.model === "string" ? opts.model : void 0 }),
		mastra: opts.mastra,
		memory: opts.memory
	});
	const threadId = opts.threadId ?? messages.find((message) => message.threadId)?.threadId;
	const resourceId = opts.resourceId ?? messages.find((message) => message.resourceId)?.resourceId;
	const result = await runner.call(void 0, messages, opts.abortSignal, {
		skipContinuationHints: true,
		requestContext: opts.requestContext,
		observabilityContext: opts.observabilityContext,
		resourceId
	});
	const hooked = await applyExtractorHooks({
		source: "observer",
		extractors: result.extractors ?? extractors,
		values: result.extractedValues,
		failures: result.extractionFailures,
		threadId: threadId ?? "",
		resourceId,
		memory: opts.memory,
		requestContext: opts.requestContext
	});
	return {
		summary: result.observations,
		extracted: hooked.values ?? {},
		extractionFailures: hooked.failures,
		usage: result.usage
	};
}
//#endregion
//#region src/processors/observational-memory/working-memory-extractor.ts
async function getWorkingMemoryDetails(context) {
	const memory = context.memory;
	const memoryConfig = parseMemoryRequestContext(context.requestContext)?.memoryConfig;
	const workingMemory = memory.getMergedThreadConfig(memoryConfig ?? {}).workingMemory;
	if (!workingMemory?.enabled) return { usesSchema: false };
	const [template, current] = await Promise.all([memory.getWorkingMemoryTemplate({ memoryConfig }), context.threadId ? memory.getWorkingMemory({
		threadId: context.threadId,
		resourceId: context.resourceId,
		memoryConfig
	}) : Promise.resolve(null)]);
	return {
		template: typeof template?.content === "string" ? template.content : JSON.stringify(template?.content),
		current,
		usesSchema: Boolean(workingMemory.schema)
	};
}
function buildWorkingMemoryInstructions(details) {
	if (details.usesSchema) return [
		"Update working memory with durable facts from the observations you made.",
		"Return the full updated JSON object when working memory should change.",
		"Return null when no working memory update is needed.",
		details.template ? `Working memory JSON schema:\n${details.template}` : void 0,
		details.current ? `Current working memory JSON:\n${details.current}` : void 0
	].filter(Boolean).join("\n\n");
	return [
		"Update working memory with durable facts from the observations you made.",
		"Return the full updated Markdown working memory. Preserve useful existing content and add or revise only what changed.",
		details.template ? `Working memory template:\n${details.template}` : void 0,
		details.current ? `Current working memory:\n${details.current}` : void 0
	].filter(Boolean).join("\n\n");
}
var WorkingMemoryExtractor = class extends Extractor {
	constructor() {
		super({
			name: "Working Memory",
			includePreviousExtraction: false,
			metadataKeyPath: false,
			instructions: async (context) => buildWorkingMemoryInstructions(await getWorkingMemoryDetails(context)),
			schema: async (context) => {
				return (await getWorkingMemoryDetails(context)).usesSchema ? z.union([z.record(z.string(), z.unknown()), z.null()]) : void 0;
			},
			onExtracted: async ({ current, memory, threadId, resourceId, requestContext }) => {
				const memoryConfig = parseMemoryRequestContext(requestContext)?.memoryConfig;
				const config = memory.getMergedThreadConfig(memoryConfig ?? {});
				if (Boolean(config.workingMemory?.schema) && current === null) return;
				const workingMemory = typeof current === "string" ? current : JSON.stringify(current) ?? "";
				if (!workingMemory.trim()) return;
				await memory.updateWorkingMemory({
					threadId,
					resourceId,
					workingMemory,
					memoryConfig
				});
				return current;
			}
		});
	}
};
//#endregion
//#region src/tools/om-tools.ts
function getMessageParts(msg) {
	if (typeof msg.content === "string") return [];
	if (Array.isArray(msg.content)) return msg.content;
	const parts = msg.content?.parts;
	return Array.isArray(parts) ? parts : [];
}
/** Returns true if a message has at least one non-data part with visible content. */
function hasVisibleParts(msg) {
	if (typeof msg.content === "string") return msg.content.length > 0;
	const parts = getMessageParts(msg);
	if (parts.length === 0) return Boolean(msg.content?.content);
	return parts.some((p) => !p.type?.startsWith("data-"));
}
function parseRangeFormat(cursor) {
	if (cursor.includes(",")) {
		const parts = cursor.split(",").map((p) => p.trim()).filter(Boolean);
		if (parts.length >= 1) {
			const first = parts[0];
			const last = parts[parts.length - 1];
			const firstColon = first.indexOf(":");
			const lastColon = last.indexOf(":");
			return {
				startId: firstColon > 0 ? first.slice(0, firstColon) : first,
				endId: lastColon > 0 ? last.slice(lastColon + 1) : last
			};
		}
	}
	const colonIndex = cursor.indexOf(":");
	if (colonIndex > 0 && colonIndex < cursor.length - 1) return {
		startId: cursor.slice(0, colonIndex),
		endId: cursor.slice(colonIndex + 1)
	};
	return null;
}
async function resolveCursorMessage(memory, cursor, access) {
	const normalized = cursor.trim();
	if (!normalized) throw new Error("Cursor is required");
	const rangeIds = parseRangeFormat(normalized);
	if (rangeIds) return {
		hint: `The cursor "${cursor}" looks like a range. Use one of the individual message IDs as the cursor instead: start="${rangeIds.startId}" or end="${rangeIds.endId}".`,
		...rangeIds
	};
	let message = (await (await memory.getMemoryStore()).listMessagesById({ messageIds: [normalized] })).messages.find((message) => message.id === normalized) ?? null;
	if (!message) message = await resolveCursorMessageByRecall(memory, normalized, access);
	if (!message) throw new Error(`Could not resolve cursor message: ${cursor}`);
	if (access?.resourceId && message.resourceId !== access.resourceId) throw new Error(`Could not resolve cursor message: ${cursor}`);
	if (access?.enforceThreadScope && access.threadScope && message.threadId !== access.threadScope) throw new Error(`Could not resolve cursor message: ${cursor}`);
	return message;
}
async function resolveCursorMessageByRecall(memory, cursor, access) {
	if (access?.enforceThreadScope && access.threadScope) return (await memory.recall({
		threadId: access.threadScope,
		resourceId: access.resourceId,
		page: 0,
		perPage: false
	})).messages.find((message) => message.id === cursor) ?? null;
	if (!access?.resourceId) return null;
	const threads = await memory.listThreads({
		page: 0,
		perPage: 100,
		orderBy: {
			field: "updatedAt",
			direction: "DESC"
		},
		filter: { resourceId: access.resourceId }
	});
	for (const thread of threads.threads) {
		const message = (await memory.recall({
			threadId: thread.id,
			resourceId: access.resourceId,
			page: 0,
			perPage: false
		})).messages.find((message) => message.id === cursor);
		if (message) return message;
	}
	return null;
}
async function listThreadsForResource({ memory, resourceId, currentThreadId, page = 0, limit = 20, before, after }) {
	if (!resourceId) throw new Error("Resource ID is required to list threads");
	const normalizedLimit = Math.min(Math.max(limit, 1), 50);
	const hasDateFilter = !!(before || after);
	const beforeDate = before ? new Date(before) : null;
	const afterDate = after ? new Date(after) : null;
	const result = await memory.listThreads({
		filter: { resourceId },
		page: hasDateFilter ? 0 : page,
		perPage: hasDateFilter ? false : normalizedLimit,
		orderBy: {
			field: "updatedAt",
			direction: "DESC"
		}
	});
	let threads = result.threads;
	if (beforeDate) threads = threads.filter((t) => t.createdAt < beforeDate);
	if (afterDate) threads = threads.filter((t) => t.createdAt > afterDate);
	let hasMore;
	if (hasDateFilter) {
		const offset = page * normalizedLimit;
		hasMore = offset + normalizedLimit < threads.length;
		threads = threads.slice(offset, offset + normalizedLimit);
	} else hasMore = result.hasMore;
	if (threads.length === 0) return {
		threads: "No threads found matching the criteria.",
		count: 0,
		page,
		hasMore: false
	};
	const lines = [];
	for (const thread of threads) {
		const isCurrent = thread.id === currentThreadId;
		const title = thread.title || "(untitled)";
		const updated = formatTimestamp(thread.updatedAt);
		const created = formatTimestamp(thread.createdAt);
		const marker = isCurrent ? " ← current" : "";
		lines.push(`- **${title}**${marker}`);
		lines.push(`  id: ${thread.id}`);
		lines.push(`  updated: ${updated} | created: ${created}`);
	}
	return {
		threads: lines.join("\n"),
		count: threads.length,
		page,
		hasMore
	};
}
async function searchMessagesForResource({ memory, resourceId, currentThreadId, query, topK = 10, maxTokens = DEFAULT_MAX_RESULT_TOKENS, before, after, threadScope }) {
	if (!memory.searchMessages) return {
		results: "Search is not configured. Enable it with `retrieval: { vector: true }` and configure a vector store and embedder on your Memory instance.",
		count: 0
	};
	const MAX_TOPK = 20;
	const clampedTopK = Math.min(Math.max(topK, 1), MAX_TOPK);
	const effectiveTopK = threadScope || before || after ? Math.max(clampedTopK * 3, clampedTopK + 10) : clampedTopK;
	const searchTopK = Math.min(MAX_TOPK, effectiveTopK);
	const beforeDate = before ? new Date(before) : void 0;
	const afterDate = after ? new Date(after) : void 0;
	const { results } = await memory.searchMessages({
		query,
		resourceId,
		topK: searchTopK,
		filter: {
			...threadScope ? { threadId: threadScope } : {},
			...afterDate ? { observedAfter: afterDate } : {},
			...beforeDate ? { observedBefore: beforeDate } : {}
		}
	});
	if (results.length === 0) return {
		results: "No matching messages found.",
		count: 0
	};
	const threadIds = [...new Set(results.map((r) => r.threadId))];
	const threadMap = /* @__PURE__ */ new Map();
	if (memory.getThreadById) await Promise.all(threadIds.map(async (id) => {
		const thread = await memory.getThreadById({ threadId: id });
		if (thread) threadMap.set(id, thread);
	}));
	const filteredMatches = results.filter((match) => {
		if (threadScope && match.threadId !== threadScope) return false;
		if (beforeDate && match.observedAt && match.observedAt >= beforeDate) return false;
		if (afterDate && match.observedAt && match.observedAt <= afterDate) return false;
		return true;
	});
	if (filteredMatches.length === 0) return {
		results: "No matching messages found.",
		count: 0
	};
	const limitedMatches = filteredMatches.slice(0, clampedTopK);
	const { text: limited } = truncateByTokens(limitedMatches.map((match) => {
		const thread = threadMap.get(match.threadId);
		const title = thread?.title || "(untitled)";
		const isCurrentThread = match.threadId === currentThreadId;
		const generationLabel = isCurrentThread ? "Current thread memory" : "Older memory from another thread";
		const generationDetail = isCurrentThread ? "This result came from the current thread." : "This result came from an older memory generation in another thread.";
		const threadLine = `- thread: ${match.threadId}${thread ? ` (${title})` : ""}`;
		const sourceLine = match.range ? `- source: raw messages from ID ${match.range.split(":")[0] ?? "(unknown)"} through ID ${match.range.split(":")[1] ?? "(unknown)"}` : "- source: raw message range unavailable";
		const updatedLine = thread ? `- thread updated: ${formatTimestamp(thread.updatedAt)}` : void 0;
		const groupLine = match.groupId ? `- observation group: ${match.groupId}` : void 0;
		const scoreLine = `- score: ${match.score.toFixed(2)}`;
		const body = (match.text || "").trim() || "_Observation text unavailable._";
		return [
			`### ${generationLabel}`,
			"",
			generationDetail,
			threadLine,
			sourceLine,
			updatedLine,
			groupLine,
			scoreLine,
			"",
			"```text",
			body,
			"```"
		].filter(Boolean).join("\n");
	}).join("\n\n"), maxTokens);
	return {
		results: limited,
		count: limitedMatches.length
	};
}
const LOW_DETAIL_PART_TOKENS = 30;
const AUTO_EXPAND_TEXT_TOKENS = 100;
const AUTO_EXPAND_TOOL_TOKENS = 20;
const HIGH_DETAIL_TOOL_RESULT_TOKENS = 4e3;
const DEFAULT_MAX_RESULT_TOKENS = 2e3;
function formatTimestamp(date) {
	return date.toISOString().replace("T", " ").replace(/\.\d{3}Z$/, "Z");
}
function truncateByTokens(text, maxTokens, hint) {
	if (estimateTokenCount(text) <= maxTokens) return {
		text,
		wasTruncated: false
	};
	return {
		text: truncateStringByTokens(text, maxTokens) + (hint ? ` [${hint} for more]` : ""),
		wasTruncated: true
	};
}
function lowDetailPartLimit(type) {
	if (type === "text") return AUTO_EXPAND_TEXT_TOKENS;
	if (type === "tool-result" || type === "tool-call") return AUTO_EXPAND_TOOL_TOKENS;
	return LOW_DETAIL_PART_TOKENS;
}
function makePart(msg, partIndex, type, fullText, detail, toolName) {
	if (detail === "high") return {
		messageId: msg.id,
		partIndex,
		role: msg.role,
		type,
		text: fullText,
		fullText,
		toolName
	};
	const hint = `recall cursor="${msg.id}" partIndex=${partIndex} detail="high"`;
	const { text } = truncateByTokens(fullText, lowDetailPartLimit(type), hint);
	return {
		messageId: msg.id,
		partIndex,
		role: msg.role,
		type,
		text,
		fullText,
		toolName
	};
}
function formatMessageParts(msg, detail) {
	const parts = [];
	if (typeof msg.content === "string") {
		parts.push(makePart(msg, 0, "text", msg.content, detail));
		return parts;
	}
	const messageParts = getMessageParts(msg);
	if (messageParts.length > 0) for (let i = 0; i < messageParts.length; i++) {
		const part = messageParts[i];
		const partType = part.type;
		if (partType === "text") {
			const text = part.text;
			if (text) parts.push(makePart(msg, i, "text", text, detail));
		} else if (partType === "tool-invocation") {
			const inv = part.toolInvocation;
			if (inv?.toolName) {
				const hasArgs = inv.args != null;
				if (inv.state !== "partial-call" && hasArgs) {
					const argsStr = detail === "low" ? "" : `\n${JSON.stringify(inv.args, null, 2)}`;
					const fullText = `[Tool Call: ${inv.toolName}]${argsStr}`;
					parts.push({
						messageId: msg.id,
						partIndex: i,
						role: msg.role,
						type: "tool-call",
						text: fullText,
						fullText,
						toolName: inv.toolName
					});
				}
				if (inv.state === "result") {
					const { value: resultValue } = resolveToolResultValue(part, inv.result);
					const resultStr = formatToolResultForObserver(resultValue, { maxTokens: HIGH_DETAIL_TOOL_RESULT_TOKENS });
					const fullText = `[Tool Result: ${inv.toolName}]\n${resultStr}`;
					parts.push(makePart(msg, i, "tool-result", fullText, detail, inv.toolName));
				}
			}
		} else if (partType === "tool-call") {
			const toolName = part.toolName;
			if (toolName) {
				const rawArgs = part.input ?? part.args;
				const fullText = `[Tool Call: ${toolName}]${detail === "low" || rawArgs == null ? "" : `\n${typeof rawArgs === "string" ? rawArgs : JSON.stringify(rawArgs, null, 2)}`}`;
				parts.push({
					messageId: msg.id,
					partIndex: i,
					role: msg.role,
					type: "tool-call",
					text: fullText,
					fullText,
					toolName
				});
			}
		} else if (partType === "tool-result") {
			const toolName = part.toolName;
			if (toolName) {
				const fullText = `[Tool Result: ${toolName}]\n${formatToolResultForObserver(part.output ?? part.result, { maxTokens: HIGH_DETAIL_TOOL_RESULT_TOKENS })}`;
				parts.push(makePart(msg, i, "tool-result", fullText, detail, toolName));
			}
		} else if (partType === "reasoning") {
			const reasoning = part.reasoning ?? part.text;
			if (reasoning) parts.push(makePart(msg, i, "reasoning", reasoning, detail));
		} else if (partType === "image" || partType === "file") {
			const filename = part.filename;
			const label = filename ? `: ${filename}` : "";
			const fullText = `[${partType === "image" ? "Image" : "File"}${label}]`;
			parts.push({
				messageId: msg.id,
				partIndex: i,
				role: msg.role,
				type: partType,
				text: fullText,
				fullText
			});
		} else if (partType?.startsWith("data-")) {} else if (partType) {
			const fullText = `[${partType}]`;
			parts.push({
				messageId: msg.id,
				partIndex: i,
				role: msg.role,
				type: partType,
				text: fullText,
				fullText
			});
		}
	}
	else if (msg.content?.content) parts.push(makePart(msg, 0, "text", msg.content.content, detail));
	return parts;
}
function buildRenderedText(parts, timestamps) {
	let currentMessageId = "";
	const lines = [];
	for (const part of parts) {
		if (part.messageId !== currentMessageId) {
			currentMessageId = part.messageId;
			const ts = timestamps.get(part.messageId);
			const tsStr = ts ? ` (${formatTimestamp(ts)})` : "";
			if (lines.length > 0) lines.push("");
			lines.push(`**${part.role}${tsStr}** [${part.messageId}]:`);
		}
		const indexLabel = `[p${part.partIndex}]`;
		lines.push(`  ${indexLabel} ${part.text}`);
	}
	return lines.join("\n");
}
async function getNextVisibleMessage({ memory, threadId, resourceId, after }) {
	return (await memory.recall({
		threadId,
		resourceId,
		page: 0,
		perPage: 50,
		orderBy: {
			field: "createdAt",
			direction: "ASC"
		},
		filter: { dateRange: {
			start: after,
			startExclusive: true
		} }
	})).messages.find(hasVisibleParts) ?? null;
}
const MAX_EXPAND_USER_TEXT_TOKENS = 200;
const MAX_EXPAND_OTHER_TOKENS = 50;
function expandLimit(part) {
	if (part.role === "user" && part.type === "text") return MAX_EXPAND_USER_TEXT_TOKENS;
	return MAX_EXPAND_OTHER_TOKENS;
}
function expandPriority(part) {
	if (part.role === "user" && part.type === "text") return 0;
	if (part.type === "text" || part.type === "reasoning") return 1;
	if (part.type === "tool-result") return 2;
	if (part.type === "tool-call") return 3;
	return 4;
}
function renderFormattedParts(parts, timestamps, options) {
	const text = buildRenderedText(parts, timestamps);
	let totalTokens = estimateTokenCount(text);
	if (totalTokens > options.maxTokens) return {
		text: truncateStringByTokens(text, options.maxTokens),
		truncated: true,
		tokenOffset: totalTokens - options.maxTokens
	};
	const truncatedIndices = parts.map((p, i) => ({
		part: p,
		index: i
	})).filter(({ part }) => part.text !== part.fullText).sort((a, b) => expandPriority(a.part) - expandPriority(b.part));
	if (truncatedIndices.length === 0) return {
		text,
		truncated: false,
		tokenOffset: 0
	};
	let remaining = options.maxTokens - totalTokens;
	for (const { part, index } of truncatedIndices) {
		if (remaining <= 0) break;
		const maxTokens = expandLimit(part);
		const fullTokens = estimateTokenCount(part.fullText);
		const currentTokens = estimateTokenCount(part.text);
		const targetTokens = Math.min(fullTokens, maxTokens);
		const delta = targetTokens - currentTokens;
		if (delta <= 0) continue;
		if (delta <= remaining && targetTokens >= fullTokens) {
			parts[index] = {
				...part,
				text: part.fullText
			};
			remaining -= delta;
		} else {
			const expandedLimit = Math.min(currentTokens + remaining, maxTokens);
			const hint = `recall cursor="${part.messageId}" partIndex=${part.partIndex} detail="high"`;
			const { text: expanded } = truncateByTokens(part.fullText, expandedLimit, hint);
			const expandedDelta = estimateTokenCount(expanded) - currentTokens;
			parts[index] = {
				...part,
				text: expanded
			};
			remaining -= expandedDelta;
		}
	}
	const expanded = buildRenderedText(parts, timestamps);
	const expandedTokens = estimateTokenCount(expanded);
	if (expandedTokens <= options.maxTokens) return {
		text: expanded,
		truncated: false,
		tokenOffset: 0
	};
	return {
		text: truncateStringByTokens(expanded, options.maxTokens),
		truncated: true,
		tokenOffset: expandedTokens - options.maxTokens
	};
}
async function recallPart({ memory, threadId, resourceId, cursor, partIndex, threadScope, maxTokens = DEFAULT_MAX_RESULT_TOKENS }) {
	if (!memory || typeof memory.getMemoryStore !== "function") throw new Error("Memory instance is required for recall");
	if (!threadId) throw new Error("Thread ID is required for recall");
	const resolved = await resolveCursorMessage(memory, cursor, {
		resourceId,
		threadScope,
		enforceThreadScope: false
	});
	if ("hint" in resolved) throw new Error(resolved.hint);
	const allParts = formatMessageParts(resolved, "high");
	if (allParts.length === 0) throw new Error(`Message ${cursor} has no visible content (it may be an internal system message). Try a neighboring message ID instead.`);
	const target = [...allParts].reverse().find((p) => p.partIndex === partIndex);
	if (!target) {
		const availableIndices = allParts.map((p) => p.partIndex).join(", ");
		if (partIndex > Math.max(...allParts.map((p) => p.partIndex))) {
			const nextMessage = await getNextVisibleMessage({
				memory,
				threadId,
				resourceId,
				after: resolved.createdAt
			});
			if (nextMessage) {
				const firstNextPart = formatMessageParts(nextMessage, "high")[0];
				if (firstNextPart) {
					const fallbackText = `${`Part index ${partIndex} not found in message ${cursor}; showing partIndex ${firstNextPart.partIndex} from next message ${firstNextPart.messageId}.\n\n`}${firstNextPart.text}`;
					const truncatedText = truncateStringByTokens(fallbackText, maxTokens);
					const wasTruncated = truncatedText !== fallbackText;
					return {
						text: truncatedText,
						messageId: firstNextPart.messageId,
						partIndex: firstNextPart.partIndex,
						role: firstNextPart.role,
						type: firstNextPart.type,
						truncated: wasTruncated
					};
				}
			}
		}
		throw new Error(`Part index ${partIndex} not found in message ${cursor}. Available indices: ${availableIndices}`);
	}
	const truncatedText = truncateStringByTokens(target.text, maxTokens);
	const wasTruncated = truncatedText !== target.text;
	return {
		text: truncatedText,
		messageId: target.messageId,
		partIndex: target.partIndex,
		role: target.role,
		type: target.type,
		truncated: wasTruncated
	};
}
async function recallMessages({ memory, threadId, resourceId, cursor, page = 1, limit = 20, detail = "low", partType, toolName, threadScope, maxTokens = DEFAULT_MAX_RESULT_TOKENS }) {
	if (!memory) throw new Error("Memory instance is required for recall");
	if (!threadId) throw new Error("Thread ID is required for recall");
	if (typeof memory.getMemoryStore !== "function") throw new Error("recall requires a Memory instance with storage access");
	const MAX_PAGE = 50;
	const MAX_LIMIT = 20;
	const normalizedPage = Math.max(Math.min(page === 0 ? 1 : page, MAX_PAGE), -50);
	const normalizedLimit = Math.min(limit, MAX_LIMIT);
	const resolved = await resolveCursorMessage(memory, cursor, {
		resourceId,
		threadScope,
		enforceThreadScope: false
	});
	if ("hint" in resolved) return {
		messages: resolved.hint,
		count: 0,
		cursor,
		page: normalizedPage,
		limit: normalizedLimit,
		detail,
		hasNextPage: false,
		hasPrevPage: false,
		truncated: false,
		tokenOffset: 0
	};
	const anchor = resolved;
	const crossThreadId = anchor.threadId && anchor.threadId !== threadId ? anchor.threadId : void 0;
	if (crossThreadId && threadScope) return {
		messages: `Cursor does not belong to the active thread. Expected thread "${threadId}" but cursor "${cursor}" belongs to "${anchor.threadId}". Pass threadId="${anchor.threadId}" to browse that thread, or omit threadId and use this cursor directly in resource scope.`,
		count: 0,
		cursor,
		page: normalizedPage,
		limit: normalizedLimit,
		detail,
		hasNextPage: false,
		hasPrevPage: false,
		truncated: false,
		tokenOffset: 0
	};
	const resolvedThreadId = crossThreadId ?? threadId;
	if (!resolvedThreadId) throw new Error("Thread ID is required for recall");
	const isForward = normalizedPage > 0;
	const pageIndex = Math.max(Math.abs(normalizedPage), 1) - 1;
	const skip = pageIndex * normalizedLimit;
	const fetchCount = skip + normalizedLimit + 1;
	const visibleMessages = (await memory.recall({
		threadId: resolvedThreadId,
		resourceId,
		page: 0,
		perPage: fetchCount,
		orderBy: {
			field: "createdAt",
			direction: isForward ? "ASC" : "DESC"
		},
		filter: { dateRange: isForward ? {
			start: anchor.createdAt,
			startExclusive: true
		} : {
			end: anchor.createdAt,
			endExclusive: true
		} }
	})).messages.filter(hasVisibleParts);
	const total = visibleMessages.length;
	const hasMore = total > skip + normalizedLimit;
	let messages;
	if (isForward) messages = visibleMessages.slice(skip, skip + normalizedLimit);
	else {
		const endIdx = Math.max(total - skip, 0);
		const startIdx = Math.max(endIdx - normalizedLimit, 0);
		messages = visibleMessages.slice(startIdx, endIdx);
	}
	const hasNextPage = isForward ? hasMore : pageIndex > 0;
	const hasPrevPage = isForward ? pageIndex > 0 : hasMore;
	let allParts = [];
	const timestamps = /* @__PURE__ */ new Map();
	for (const msg of messages) {
		timestamps.set(msg.id, msg.createdAt);
		allParts.push(...formatMessageParts(msg, detail));
	}
	if (toolName) allParts = allParts.filter((p) => (p.type === "tool-call" || p.type === "tool-result") && p.toolName === toolName);
	if (partType) allParts = allParts.filter((p) => p.type === partType);
	if (detail === "high" && allParts.length > 0) {
		const firstPart = allParts[0];
		const sameMsgParts = allParts.filter((p) => p.messageId === firstPart.messageId);
		const otherMsgParts = allParts.filter((p) => p.messageId !== firstPart.messageId);
		const rendered = renderFormattedParts([firstPart], timestamps, {
			detail,
			maxTokens
		});
		let text = rendered.text;
		const hints = [];
		if (sameMsgParts.length > 1) {
			const nextPart = sameMsgParts[1];
			hints.push(`next part: partIndex=${nextPart.partIndex} on cursor="${firstPart.messageId}"`);
		}
		if (otherMsgParts.length > 0) {
			const next = otherMsgParts[0];
			hints.push(`next message: partIndex=${next.partIndex} on cursor="${next.messageId}"`);
		} else if (hasNextPage) hints.push(`more messages available on page ${normalizedPage + 1}`);
		if (hints.length > 0) text += `\n\nHigh detail returns 1 part at a time. To continue: ${hints.join(", or ")}.`;
		return {
			messages: text,
			count: 1,
			cursor,
			page: normalizedPage,
			limit: normalizedLimit,
			detail,
			hasNextPage: otherMsgParts.length > 0 || hasNextPage,
			hasPrevPage,
			truncated: rendered.truncated,
			tokenOffset: rendered.tokenOffset
		};
	}
	const rendered = renderFormattedParts(allParts, timestamps, {
		detail,
		maxTokens
	});
	const emptyMessage = allParts.length === 0 ? partType || toolName ? "(no message parts matched the current filters)" : "(no visible message parts found for this page)" : "(no messages found)";
	return {
		messages: rendered.text || emptyMessage,
		count: messages.length,
		cursor,
		page: normalizedPage,
		limit: normalizedLimit,
		detail,
		hasNextPage,
		hasPrevPage,
		truncated: rendered.truncated,
		tokenOffset: rendered.tokenOffset
	};
}
async function recallThreadFromStart({ memory, threadId, resourceId, page = 1, limit = 20, detail = "low", partType, toolName, anchor = "start", maxTokens = DEFAULT_MAX_RESULT_TOKENS }) {
	if (!memory) throw new Error("Memory instance is required for recall");
	if (!threadId) throw new Error("Thread ID is required for recall");
	if (resourceId && memory.getThreadById) {
		const thread = await memory.getThreadById({ threadId });
		if (!thread || thread.resourceId !== resourceId) throw new Error("Thread not found");
	}
	const MAX_PAGE = 50;
	const MAX_LIMIT = 20;
	const normalizedPage = Math.max(Math.min(page, MAX_PAGE), 1);
	const normalizedLimit = Math.min(Math.max(limit, 1), MAX_LIMIT);
	const pageIndex = normalizedPage - 1;
	const fetchCount = pageIndex * normalizedLimit + normalizedLimit + 1;
	const result = await memory.recall({
		threadId,
		resourceId,
		page: 0,
		perPage: fetchCount,
		orderBy: {
			field: "createdAt",
			direction: anchor === "end" ? "DESC" : "ASC"
		}
	});
	const visibleMessages = anchor === "end" ? result.messages.slice(0, fetchCount).filter(hasVisibleParts).reverse() : result.messages.slice(0, fetchCount).filter(hasVisibleParts);
	const skip = pageIndex * normalizedLimit;
	const messages = visibleMessages.slice(skip, skip + normalizedLimit);
	const hasExtraMessage = visibleMessages.length > skip + messages.length;
	const hasNextPage = messages.length > 0 ? anchor === "end" ? pageIndex > 0 : hasExtraMessage : false;
	const hasPrevPage = messages.length > 0 ? anchor === "end" ? hasExtraMessage : pageIndex > 0 : pageIndex > 0;
	let allParts = [];
	const timestamps = /* @__PURE__ */ new Map();
	for (const msg of messages) {
		timestamps.set(msg.id, msg.createdAt);
		allParts.push(...formatMessageParts(msg, detail));
	}
	if (toolName) allParts = allParts.filter((p) => (p.type === "tool-call" || p.type === "tool-result") && p.toolName === toolName);
	if (partType) allParts = allParts.filter((p) => p.type === partType);
	const rendered = renderFormattedParts(allParts, timestamps, {
		detail,
		maxTokens
	});
	const emptyMessage = messages.length === 0 ? pageIndex > 0 ? `(no messages found on page ${normalizedPage} for this thread)` : "(no messages in this thread)" : partType || toolName ? "(no message parts matched the current filters)" : "(no messages found)";
	return {
		messages: rendered.text || emptyMessage,
		count: messages.length,
		cursor: messages[0]?.id || "",
		page: normalizedPage,
		limit: normalizedLimit,
		detail,
		hasNextPage,
		hasPrevPage,
		truncated: rendered.truncated,
		tokenOffset: rendered.tokenOffset
	};
}
const recallTool = (_memoryConfig, options) => {
	const isResourceScope = (options?.retrievalScope ?? "thread") === "resource";
	return createTool({
		id: "recall",
		description: isResourceScope ? "Browse conversation history. Use mode=\"threads\" to list all threads for the current user. Use mode=\"messages\" (default) to browse messages in the current thread or pass threadId to browse another thread in the active resource. When mode=\"messages\" has no cursor or threadId, it defaults to the current thread and says so at the top of the result. If you pass only a cursor, it must belong to the current thread. Use mode=\"search\" to find messages by content across all threads." : "Browse conversation history in the current thread. Use mode=\"messages\" (default) to page through messages near a cursor. Use mode=\"search\" to find messages by content in this thread. Use mode=\"threads\" to get the current thread's ID and title.",
		inputSchema: {
			$schema: "http://json-schema.org/draft-07/schema#",
			type: "object",
			properties: {
				...isResourceScope ? {
					mode: {
						type: "string",
						enum: [
							"messages",
							"threads",
							"search"
						],
						description: "What to retrieve. \"messages\" (default) pages through message history. \"threads\" lists all threads for the current user. \"search\" finds messages by semantic similarity across all threads."
					},
					threadId: {
						type: "string",
						minLength: 1,
						description: "Browse a different thread, or \"current\" for the active thread. Use mode=\"threads\" first to discover thread IDs."
					},
					before: {
						type: "string",
						description: "For mode=\"threads\": only show threads created before this date. ISO 8601 or natural date string (e.g. \"2026-03-15\", \"2026-03-10T00:00:00Z\")."
					},
					after: {
						type: "string",
						description: "For mode=\"threads\": only show threads created after this date. ISO 8601 or natural date string (e.g. \"2026-03-01\", \"2026-03-10T00:00:00Z\")."
					}
				} : { mode: {
					type: "string",
					enum: [
						"messages",
						"threads",
						"search"
					],
					description: "What to retrieve. \"messages\" (default) pages through message history. \"threads\" returns info about the current thread. \"search\" finds messages by semantic similarity in this thread."
				} },
				query: {
					type: "string",
					minLength: 1,
					description: "Search query for mode=\"search\". Finds messages semantically similar to this text."
				},
				cursor: {
					type: "string",
					minLength: 1,
					description: "A message ID to use as the pagination cursor. For mode=\"messages\", omit both cursor and threadId to browse the current thread. If only cursor is provided, it must belong to the current thread. Extract it from the start or end of an observation group range."
				},
				anchor: {
					type: "string",
					enum: ["start", "end"],
					description: "For mode=\"messages\" without a cursor, page from the start (oldest-first) or end (newest-first) of the thread. Defaults to \"start\"."
				},
				page: {
					type: "integer",
					minimum: -50,
					maximum: 50,
					description: "Pagination offset. For messages: positive pages move forward from cursor, negative move backward. For threads: page number (0-indexed). 0 is treated as 1 for messages."
				},
				limit: {
					type: "integer",
					minimum: 1,
					maximum: 20,
					description: "Maximum number of items to return per page. Defaults to 20."
				},
				detail: {
					type: "string",
					enum: ["low", "high"],
					description: "Detail level for messages. \"low\" (default) returns truncated text and tool names. \"high\" returns full content with tool args/results."
				},
				partType: {
					type: "string",
					enum: [
						"text",
						"tool-call",
						"tool-result",
						"reasoning",
						"image",
						"file"
					],
					description: "Filter results to only include parts of this type. Only applies to mode=\"messages\"."
				},
				toolName: {
					type: "string",
					minLength: 1,
					description: "Filter results to only include tool-call and tool-result parts matching this tool name. Only applies to mode=\"messages\"."
				},
				partIndex: {
					type: "integer",
					minimum: 0,
					description: "Fetch a single part from the cursor message by its positional index. When provided, returns only that part at high detail. Indices are shown as [p0], [p1], etc. in recall results."
				}
			}
		},
		execute: async (inputData, context) => {
			const { mode, query, cursor, threadId: explicitThreadId, anchor, page, limit, detail, partType, toolName, partIndex, before, after } = inputData;
			const memory = context?.memory;
			const currentThreadId = context?.agent?.threadId;
			const resourceId = context?.agent?.resourceId;
			const resolvedExplicitThreadId = explicitThreadId === "current" ? currentThreadId : explicitThreadId;
			if (!memory) throw new Error("Memory instance is required for recall");
			if (explicitThreadId === "current" && !currentThreadId) throw new Error("Could not resolve current thread.");
			if (mode === "search") {
				if (!query) throw new Error("query is required for mode=\"search\"");
				if (!resourceId) throw new Error("Resource ID is required for recall");
				return searchMessagesForResource({
					memory,
					resourceId,
					currentThreadId: currentThreadId || void 0,
					query,
					topK: limit ?? 10,
					before,
					after,
					threadScope: !isResourceScope ? currentThreadId || void 0 : resolvedExplicitThreadId || void 0
				});
			}
			if (mode === "threads") {
				if (!isResourceScope || explicitThreadId === "current") {
					if (!currentThreadId || !memory.getThreadById) return { error: "Could not resolve current thread." };
					const thread = await memory.getThreadById({ threadId: currentThreadId });
					if (!thread) return { error: "Could not resolve current thread." };
					if (isResourceScope && resourceId && thread.resourceId !== resourceId) throw new Error("Thread does not belong to the active resource");
					return {
						threads: `- **${thread.title || "(untitled)"}** ← current\n  id: ${thread.id}\n  updated: ${formatTimestamp(thread.updatedAt)} | created: ${formatTimestamp(thread.createdAt)}`,
						count: 1,
						page: 0,
						hasMore: false
					};
				}
				if (!resourceId) throw new Error("Resource ID is required for recall");
				return listThreadsForResource({
					memory,
					resourceId,
					currentThreadId: currentThreadId || "",
					page: page ?? 0,
					limit: limit ?? 20,
					before,
					after
				});
			}
			const usedDefaultThreadId = !explicitThreadId && !cursor && Boolean(currentThreadId);
			const defaultThreadNote = usedDefaultThreadId && isResourceScope ? `threadId wasn't passed so used default ${currentThreadId}.\n\n` : "";
			const resolvedThreadId = resolvedExplicitThreadId || (usedDefaultThreadId ? currentThreadId : void 0);
			const hasResolvedThreadId = typeof resolvedThreadId === "string" && resolvedThreadId.length > 0;
			const hasCursor = typeof cursor === "string" && cursor.length > 0;
			if (!hasResolvedThreadId && !hasCursor) throw new Error(isResourceScope ? "No active thread context and no cursor or threadId was provided for mode=\"messages\". Pass a threadId (use mode=\"threads\" to discover thread IDs) or a message ID as cursor." : "No active thread context for mode=\"messages\". This tool is limited to the current thread and no current thread could be resolved.");
			let targetThreadId;
			let threadScope;
			if (!isResourceScope) {
				targetThreadId = currentThreadId;
				threadScope = currentThreadId || void 0;
			} else if (hasResolvedThreadId) {
				if (!resourceId) throw new Error("Resource ID is required for recall");
				if (!memory.getThreadById) throw new Error("Memory instance cannot verify thread access for recall");
				const thread = await memory.getThreadById({ threadId: resolvedThreadId });
				if (!thread || thread.resourceId !== resourceId) throw new Error("Thread does not belong to the active resource");
				targetThreadId = thread.id;
				threadScope = thread.id;
			} else {
				targetThreadId = currentThreadId;
				threadScope = currentThreadId || void 0;
			}
			if (hasCursor && !hasResolvedThreadId && !currentThreadId) {
				if (!isResourceScope) throw new Error("Current thread is required when browsing by cursor");
				const resolved = await resolveCursorMessage(memory, cursor, { resourceId });
				if ("hint" in resolved) return {
					messages: resolved.hint,
					count: 0,
					cursor,
					page: page ?? 1,
					limit: Math.min(limit ?? 20, 20),
					detail: detail ?? "low",
					hasNextPage: false,
					hasPrevPage: false,
					truncated: false,
					tokenOffset: 0
				};
				targetThreadId = resolved.threadId;
			}
			if (!targetThreadId) throw new Error("Thread ID is required for recall");
			if (!cursor) {
				const result = await recallThreadFromStart({
					memory,
					threadId: targetThreadId,
					resourceId: isResourceScope ? resourceId : void 0,
					page: page ?? 1,
					limit: limit ?? 20,
					detail: detail ?? "low",
					partType,
					toolName,
					anchor: anchor ?? "start"
				});
				if (defaultThreadNote) return {
					...result,
					messages: `${defaultThreadNote}${result.messages}`
				};
				return result;
			}
			if (partIndex !== void 0 && partIndex !== null) return recallPart({
				memory,
				threadId: targetThreadId,
				resourceId: isResourceScope ? resourceId : void 0,
				cursor,
				partIndex,
				threadScope
			});
			return recallMessages({
				memory,
				threadId: targetThreadId,
				resourceId: isResourceScope ? resourceId : void 0,
				cursor,
				page,
				limit,
				detail: detail ?? "low",
				partType,
				toolName,
				threadScope
			});
		}
	});
};
//#endregion
//#region src/tools/working-memory.ts
const UPDATE_WORKING_MEMORY_TOOL_NAME = "updateWorkingMemory";
const SET_WORKING_MEMORY_TOOL_NAME = "setWorkingMemory";
/**
* Deep merges two objects, with special handling for null values (delete) and arrays (replace).
* - Object properties are recursively merged
* - null values in the update will delete the corresponding property
* - Arrays are replaced entirely (not merged element-by-element)
* - Primitive values are overwritten
*/
function deepMergeWorkingMemory(existing, update) {
	if (!update || typeof update !== "object" || Object.keys(update).length === 0) return existing && typeof existing === "object" ? { ...existing } : {};
	if (!existing || typeof existing !== "object") return update;
	const result = { ...existing };
	for (const key of Object.keys(update)) {
		const updateValue = update[key];
		const existingValue = result[key];
		if (updateValue === null) delete result[key];
		else if (Array.isArray(updateValue)) result[key] = updateValue;
		else if (typeof updateValue === "object" && updateValue !== null && typeof existingValue === "object" && existingValue !== null && !Array.isArray(existingValue)) result[key] = deepMergeWorkingMemory(existingValue, updateValue);
		else result[key] = updateValue;
	}
	return result;
}
function stripNullsFromOptional(value, schema) {
	if (Array.isArray(value)) {
		const itemSchema = schema.items ?? {};
		return value.map((item) => stripNullsFromOptional(item, itemSchema));
	}
	if (typeof value === "object" && value !== null) {
		const properties = schema.properties ?? {};
		const required = schema.required ?? [];
		const result = {};
		for (const [key, propertyValue] of Object.entries(value)) {
			if (propertyValue === null && !required.includes(key)) continue;
			result[key] = stripNullsFromOptional(propertyValue, properties[key] ?? {});
		}
		return result;
	}
	return value;
}
const updateWorkingMemoryTool = (memoryConfig) => {
	const schema = memoryConfig?.workingMemory?.schema;
	let inputSchema = {
		$schema: "http://json-schema.org/draft-07/schema#",
		type: "object",
		properties: { memory: {
			type: "string",
			description: `The Markdown formatted working memory content to store. This MUST be a string. Never pass an object.`
		} },
		required: ["memory"]
	};
	if (schema) {
		const standardSchema = isStandardSchemaWithJSON$1(schema) ? schema : toStandardSchema$1(schema);
		const jsonSchema = standardSchemaToJSONSchema(standardSchema, { io: "input" });
		delete jsonSchema.$schema;
		const wrappedJsonSchema = {
			$schema: "http://json-schema.org/draft-07/schema#",
			type: "object",
			description: "The JSON formatted working memory content to store.",
			properties: { memory: jsonSchema },
			required: ["memory"]
		};
		const validateMemory = (memoryValue) => standardSchema["~standard"].validate(memoryValue);
		const toWrappedResult = (result) => "issues" in result && result.issues ? result : { value: { memory: result.value } };
		inputSchema = { "~standard": {
			version: 1,
			vendor: "mastra",
			validate: (value) => {
				const memoryValue = !!value && typeof value === "object" && !Array.isArray(value) && "memory" in value ? value.memory : stripNullsFromOptional(value, jsonSchema);
				const result = validateMemory(memoryValue);
				return result instanceof Promise ? result.then(toWrappedResult) : toWrappedResult(result);
			},
			jsonSchema: {
				input: () => wrappedJsonSchema,
				output: () => wrappedJsonSchema
			}
		} };
	}
	const usesMergeSemantics = Boolean(schema);
	const useStateSignals = memoryConfig?.workingMemory?.useStateSignals === true;
	const stateSignalsPreamble = `The current working memory state is delivered to you each turn by the system inside a <working-memory>...</working-memory> block. That block is system-emitted state, NOT something the user typed — never describe it as the user sharing it. Read from it directly when answering. Only call this tool when the user provides genuinely NEW or CHANGED facts that should be persisted; do NOT call it to re-save unchanged data.`;
	return createTool({
		id: "update-working-memory",
		description: schema ? useStateSignals ? `${stateSignalsPreamble} Data is merged with existing memory — only include fields you want to add or update.` : `Update the working memory with new information. Data is merged with existing memory - only include fields you want to add or update. To preserve existing data, omit the field entirely. Arrays are replaced entirely when provided, so pass the complete array or omit it to keep the existing values.` : useStateSignals ? `${stateSignalsPreamble} Pass the full updated Markdown blob as a string in the memory field.` : `Update the working memory with new information. Any data not included will be overwritten. Always pass data as string to the memory field. Never pass an object.`,
		inputSchema,
		execute: async (inputData, context) => {
			const workingMemoryInput = inputData;
			const threadId = context?.agent?.threadId;
			const resourceId = context?.agent?.resourceId;
			const memory = context?.memory;
			if (!memory) throw new Error("Memory instance is required for working memory updates");
			const scope = memoryConfig?.workingMemory?.scope || "resource";
			if (scope === "thread" && !threadId) throw new Error("Thread ID is required for thread-scoped working memory updates");
			if (scope === "resource" && !resourceId) throw new Error("Resource ID is required for resource-scoped working memory updates");
			if (threadId) {
				let thread = await memory.getThreadById({ threadId });
				if (!thread) thread = await memory.createThread({
					threadId,
					resourceId,
					memoryConfig
				});
				if (thread.resourceId && resourceId && thread.resourceId !== resourceId) throw new Error(`Thread with id ${threadId} resourceId does not match the current resourceId ${resourceId}`);
			}
			let workingMemory;
			if (usesMergeSemantics) {
				const existingRaw = await memory.getWorkingMemory({
					threadId,
					resourceId,
					memoryConfig
				});
				let existingData = null;
				if (existingRaw) try {
					existingData = typeof existingRaw === "string" ? JSON.parse(existingRaw) : existingRaw;
				} catch {
					existingData = null;
				}
				const memoryInput = workingMemoryInput.memory;
				if (memoryInput === void 0 || memoryInput === null) return {
					success: true,
					message: "No memory data provided, existing memory unchanged."
				};
				let newData;
				if (typeof memoryInput === "string") try {
					newData = JSON.parse(memoryInput);
				} catch (parseError) {
					const errorMessage = parseError instanceof Error ? parseError.message : String(parseError);
					throw new Error(`Failed to parse working memory input as JSON: ${errorMessage}. Raw input: ${memoryInput.length > 500 ? memoryInput.slice(0, 500) + "..." : memoryInput}`);
				}
				else newData = memoryInput;
				const mergedData = deepMergeWorkingMemory(existingData, newData);
				workingMemory = JSON.stringify(mergedData);
			} else {
				const memoryInput = workingMemoryInput.memory;
				workingMemory = typeof memoryInput === "string" ? memoryInput : JSON.stringify(memoryInput);
				const existingRaw = await memory.getWorkingMemory({
					threadId,
					resourceId,
					memoryConfig
				});
				if (existingRaw) {
					const template = await memory.getWorkingMemoryTemplate({ memoryConfig });
					if (template?.content) {
						const normalizedNew = workingMemory.replace(/\s+/g, " ").trim();
						const normalizedTemplate = template.content.replace(/\s+/g, " ").trim();
						const normalizedExisting = existingRaw.replace(/\s+/g, " ").trim();
						if (normalizedNew === normalizedTemplate && normalizedExisting !== normalizedTemplate) return {
							success: false,
							message: "Attempted to replace existing working memory with empty template. Update skipped to prevent data loss."
						};
					}
				}
			}
			await memory.updateWorkingMemory({
				threadId,
				resourceId,
				workingMemory,
				memoryConfig
			});
			return { success: true };
		}
	});
};
const __experimental_updateWorkingMemoryToolVNext = (config) => {
	return createTool({
		id: "update-working-memory",
		description: "Update the working memory with new information.",
		inputSchema: {
			$schema: "http://json-schema.org/draft-07/schema#",
			type: "object",
			properties: {
				newMemory: {
					type: "string",
					description: `The ${config.workingMemory?.schema ? "JSON" : "Markdown"} formatted working memory content to store`
				},
				searchString: {
					type: "string",
					description: "The working memory string to find. Will be replaced with the newMemory string. If this is omitted or doesn't exist, the newMemory string will be appended to the end of your working memory. Replacing single lines at a time is encouraged for greater accuracy. If updateReason is not 'append-new-memory', this search string must be provided or the tool call will be rejected."
				},
				updateReason: {
					type: "string",
					enum: [
						"append-new-memory",
						"clarify-existing-memory",
						"replace-irrelevant-memory"
					],
					description: "The reason you're updating working memory. Passing any value other than 'append-new-memory' requires a searchString to be provided. Defaults to append-new-memory"
				}
			}
		},
		execute: async (inputData, context) => {
			const workingMemoryInput = inputData;
			const threadId = context?.agent?.threadId;
			const resourceId = context?.agent?.resourceId;
			const memory = context?.memory;
			if (!memory) throw new Error("Memory instance is required for working memory updates");
			const scope = config.workingMemory?.scope || "resource";
			if (scope === "thread" && !threadId) throw new Error("Thread ID is required for thread-scoped working memory updates");
			if (scope === "resource" && !resourceId) throw new Error("Resource ID is required for resource-scoped working memory updates");
			if (threadId) {
				let thread = await memory.getThreadById({ threadId });
				if (!thread) thread = await memory.createThread({
					threadId,
					resourceId,
					memoryConfig: config
				});
				if (thread.resourceId && resourceId && thread.resourceId !== resourceId) throw new Error(`Thread with id ${threadId} resourceId does not match the current resourceId ${resourceId}`);
			}
			const workingMemory = workingMemoryInput.newMemory || "";
			if (!workingMemoryInput.updateReason) workingMemoryInput.updateReason = `append-new-memory`;
			if (workingMemoryInput.searchString && config.workingMemory?.scope === `resource` && workingMemoryInput.updateReason === `replace-irrelevant-memory`) workingMemoryInput.searchString = void 0;
			if (workingMemoryInput.updateReason === `append-new-memory` && workingMemoryInput.searchString) workingMemoryInput.searchString = void 0;
			if (workingMemoryInput.updateReason !== `append-new-memory` && !workingMemoryInput.searchString) return {
				success: false,
				reason: `updateReason was ${workingMemoryInput.updateReason} but no searchString was provided. Unable to replace undefined with "${workingMemoryInput.newMemory}"`
			};
			const result = await memory.__experimental_updateWorkingMemoryVNext({
				threadId,
				resourceId,
				workingMemory,
				searchString: workingMemoryInput.searchString,
				memoryConfig: config
			});
			if (result) return result;
			return { success: true };
		}
	});
};
/**
* Returns the working-memory tool plus the wire name it should be registered under.
*
* - Default delivery (`useStateSignals: false`): wire name `updateWorkingMemory`,
*   identical shape to today.
* - State-signals delivery (`useStateSignals: true`): wire name `setWorkingMemory`.
*   The rename keeps legacy strip filters (which match the literal `updateWorkingMemory`)
*   from removing tool-call parts so they persist as a normal audit trail. Any
*   future state-signal-specific tweaks to the tool (e.g. delta-aware results,
*   scoped descriptions) belong here.
*
* The VNext vs default tool body decision is left to the caller because Memory
* owns the `isVNextWorkingMemoryConfig` check; pass `vNext: true` to use the
* search-and-replace shape.
*/
function createWorkingMemoryTool(config, options = {}) {
	const useStateSignals = config.workingMemory?.useStateSignals === true;
	const tool = options.vNext ? __experimental_updateWorkingMemoryToolVNext(config) : updateWorkingMemoryTool(config);
	return {
		name: useStateSignals ? SET_WORKING_MEMORY_TOOL_NAME : UPDATE_WORKING_MEMORY_TOOL_NAME,
		tool
	};
}
//#endregion
//#region src/processors/observational-memory/model-by-input-tokens.ts
function isTieredModelTarget(model) {
	if (typeof model === "string") return true;
	if (!model || typeof model !== "object") return false;
	return "modelId" in model || "id" in model || "providerId" in model || "provider" in model || "doGenerate" in model && "doStream" in model;
}
function normalizeThresholds(config) {
	const entries = Object.entries(config.upTo);
	if (entries.length === 0) throw new Error("ModelByInputTokens requires at least one threshold in \"upTo\"");
	for (const [limitStr, model] of entries) {
		const limit = Number(limitStr);
		if (!Number.isFinite(limit) || limit <= 0) throw new Error(`ModelByInputTokens threshold keys must be positive numbers. Got: ${limitStr}`);
		if (!isTieredModelTarget(model)) throw new Error(`ModelByInputTokens requires a valid model target for threshold ${limitStr}`);
	}
	return entries.map(([limitStr, model]) => ({
		limit: Number(limitStr),
		model
	})).sort((a, b) => a.limit - b.limit);
}
var ModelByInputTokens = class {
	thresholds;
	constructor(config) {
		this.thresholds = normalizeThresholds(config);
	}
	resolve(inputTokens) {
		for (const { limit, model } of this.thresholds) if (inputTokens <= limit) return model;
		const maxLimit = this.thresholds[this.thresholds.length - 1].limit;
		throw new Error(`ModelByInputTokens: input token count (${inputTokens}) exceeds the largest configured threshold (${maxLimit}). Please configure a higher threshold or use a larger model.`);
	}
	getThresholds() {
		return this.thresholds.map((t) => t.limit);
	}
};
//#endregion
//#region src/processors/observational-memory/activation-ttl.ts
const MINUTE = 6e4;
const HOUR = 60 * MINUTE;
const SHORT_TTL = 5 * MINUTE;
const OPENAI_EXTENDED_TTL = HOUR;
const GEMINI_TTL = 24 * HOUR;
const DEEPSEEK_TTL = HOUR;
const GROQ_TTL = 2 * HOUR;
function normalize(value) {
	return value?.toLowerCase() ?? "";
}
function isOpenAIShortTtlModel(modelId) {
	return /^gpt-4/.test(modelId) || /^gpt-5(?:$|-|\.([1-4])(?:$|-))/.test(modelId);
}
function getOpenAIPromptCacheRetention(providerOptions) {
	const openaiOptions = providerOptions?.openai;
	return typeof openaiOptions?.promptCacheRetention === "string" ? openaiOptions.promptCacheRetention.toLowerCase() : void 0;
}
function resolveActivationTTL(activateAfterIdle, modelContext) {
	if (activateAfterIdle !== "auto") return activateAfterIdle;
	return resolveAutoActivationTTL(modelContext);
}
function resolveAutoActivationTTL(modelContext) {
	const provider = normalize(modelContext?.provider);
	const modelId = normalize(modelContext?.modelId);
	if (provider.includes("openai")) {
		const promptCacheRetention = getOpenAIPromptCacheRetention(modelContext?.providerOptions);
		if (promptCacheRetention === "24h") return OPENAI_EXTENDED_TTL;
		if (promptCacheRetention === "in_memory") return SHORT_TTL;
		return isOpenAIShortTtlModel(modelId) ? SHORT_TTL : OPENAI_EXTENDED_TTL;
	}
	if (provider.includes("google") || provider.includes("gemini")) return GEMINI_TTL;
	if (provider.includes("deepseek")) return DEEPSEEK_TTL;
	if (provider.includes("groq")) return GROQ_TTL;
	if (provider.includes("anthropic")) return SHORT_TTL;
	if (provider.includes("xai") || provider.includes("grok")) return SHORT_TTL;
	if (provider.includes("openrouter")) return SHORT_TTL;
	return SHORT_TTL;
}
//#endregion
//#region src/processors/observational-memory/operation-registry.ts
const activeOps = /* @__PURE__ */ new Map();
function opKey(recordId, op) {
	return `${recordId}:${op}`;
}
function registerOp(recordId, op) {
	const key = opKey(recordId, op);
	activeOps.set(key, (activeOps.get(key) ?? 0) + 1);
}
function unregisterOp(recordId, op) {
	const key = opKey(recordId, op);
	const count = activeOps.get(key);
	if (!count) return;
	if (count <= 1) activeOps.delete(key);
	else activeOps.set(key, count - 1);
}
function isOpActiveInProcess(recordId, op) {
	return (activeOps.get(opKey(recordId, op)) ?? 0) > 0;
}
//#endregion
//#region src/processors/observational-memory/buffering-coordinator.ts
/**
* Manages the static buffering state machine for async observation and reflection.
*
* Static maps are shared across all ObservationalMemory instances in a process.
* This is critical because multiple OM instances are created per agent loop step,
* and they need to share knowledge of in-flight operations.
*/
var BufferingCoordinator = class BufferingCoordinator {
	observationConfig;
	reflectionConfig;
	scope;
	/**
	* Track in-flight async buffering operations per resource/thread.
	* Key format: "obs:{lockKey}" or "refl:{lockKey}"
	* Value: Promise that resolves when buffering completes
	*/
	static asyncBufferingOps = /* @__PURE__ */ new Map();
	/**
	* Track the last token boundary at which we started buffering.
	* Key format: "obs:{lockKey}" or "refl:{lockKey}"
	*/
	static lastBufferedBoundary = /* @__PURE__ */ new Map();
	/**
	* Track the timestamp cursor for buffered messages.
	* Key format: "obs:{lockKey}"
	*/
	static lastBufferedAtTime = /* @__PURE__ */ new Map();
	/**
	* Tracks cycleId for in-flight buffered reflections.
	* Key format: "refl:{lockKey}"
	*/
	static reflectionBufferCycleIds = /* @__PURE__ */ new Map();
	constructor(opts) {
		this.observationConfig = opts.observationConfig;
		this.reflectionConfig = opts.reflectionConfig;
		this.scope = opts.scope;
	}
	getLockKey(threadId, resourceId) {
		if (this.scope === "resource" && resourceId) return `resource:${resourceId}`;
		return `thread:${threadId ?? "unknown"}`;
	}
	isAsyncObservationEnabled() {
		return this.observationConfig.bufferTokens !== void 0 && this.observationConfig.bufferTokens > 0;
	}
	isAsyncReflectionEnabled() {
		return this.reflectionConfig.bufferActivation !== void 0 && this.reflectionConfig.bufferActivation > 0;
	}
	getObservationBufferKey(lockKey) {
		return `obs:${lockKey}`;
	}
	getReflectionBufferKey(lockKey) {
		return `refl:${lockKey}`;
	}
	isAsyncBufferingInProgress(bufferKey) {
		return BufferingCoordinator.asyncBufferingOps.has(bufferKey);
	}
	/**
	* Clean up static maps for a thread/resource to prevent memory leaks.
	*/
	cleanupStaticMaps(threadId, resourceId, activatedMessageIds) {
		const lockKey = this.getLockKey(threadId, resourceId);
		const obsBufKey = this.getObservationBufferKey(lockKey);
		const reflBufKey = this.getReflectionBufferKey(lockKey);
		if (activatedMessageIds) {
			BufferingCoordinator.lastBufferedBoundary.delete(obsBufKey);
			BufferingCoordinator.lastBufferedAtTime.delete(obsBufKey);
		} else {
			BufferingCoordinator.lastBufferedAtTime.delete(obsBufKey);
			BufferingCoordinator.lastBufferedBoundary.delete(obsBufKey);
			BufferingCoordinator.lastBufferedBoundary.delete(reflBufKey);
			BufferingCoordinator.asyncBufferingOps.delete(obsBufKey);
			BufferingCoordinator.asyncBufferingOps.delete(reflBufKey);
			BufferingCoordinator.reflectionBufferCycleIds.delete(reflBufKey);
		}
	}
	/**
	* Check if we've crossed a new bufferTokens interval boundary for async observation.
	*/
	shouldTriggerAsyncObservation(currentTokens, lockKey, record, storage, messageTokensThreshold) {
		if (!this.isAsyncObservationEnabled()) return false;
		if (record.isBufferingObservation) {
			if (isOpActiveInProcess(record.id, "bufferingObservation")) return false;
			omDebug(`[OM:shouldTriggerAsyncObs] isBufferingObservation=true but stale, clearing`);
			storage?.setBufferingObservationFlag(record.id, false)?.catch(() => {});
		}
		const bufferKey = this.getObservationBufferKey(lockKey);
		if (this.isAsyncBufferingInProgress(bufferKey)) return false;
		const bufferTokens = this.observationConfig.bufferTokens;
		const dbBoundary = record.lastBufferedAtTokens ?? 0;
		const memBoundary = BufferingCoordinator.lastBufferedBoundary.get(bufferKey) ?? 0;
		const lastBoundary = Math.max(dbBoundary, memBoundary);
		const rampPoint = messageTokensThreshold ? messageTokensThreshold - bufferTokens * 1.1 : Infinity;
		const effectiveBufferTokens = currentTokens >= rampPoint ? bufferTokens / 2 : bufferTokens;
		const currentInterval = Math.floor(currentTokens / effectiveBufferTokens);
		const lastInterval = Math.floor(lastBoundary / effectiveBufferTokens);
		const shouldTrigger = currentInterval > lastInterval;
		omDebug(`[OM:shouldTriggerAsyncObs] tokens=${currentTokens}, bufferTokens=${bufferTokens}, effectiveBufferTokens=${effectiveBufferTokens}, rampPoint=${rampPoint}, currentInterval=${currentInterval}, lastInterval=${lastInterval}, lastBoundary=${lastBoundary} (db=${dbBoundary}, mem=${memBoundary}), shouldTrigger=${shouldTrigger}`);
		return shouldTrigger;
	}
	/**
	* Await any in-flight async buffering operations for a given thread/resource.
	*/
	static async awaitBuffering(threadId, resourceId, scope, timeoutMs = 3e4) {
		const lockKey = scope === "resource" && resourceId ? `resource:${resourceId}` : `thread:${threadId ?? "unknown"}`;
		const obsKey = `obs:${lockKey}`;
		const reflKey = `refl:${lockKey}`;
		const promises = [];
		const obsOp = BufferingCoordinator.asyncBufferingOps.get(obsKey);
		if (obsOp) promises.push(obsOp);
		const reflOp = BufferingCoordinator.asyncBufferingOps.get(reflKey);
		if (reflOp) promises.push(reflOp);
		if (promises.length === 0) return;
		let timeoutId;
		try {
			await Promise.race([Promise.allSettled(promises).then(() => void 0), new Promise((resolve) => {
				timeoutId = setTimeout(resolve, timeoutMs);
			})]);
		} finally {
			if (timeoutId !== void 0) clearTimeout(timeoutId);
		}
	}
};
//#endregion
//#region src/processors/observational-memory/built-in-extractors.ts
const currentTaskInstructions = `State the current task(s) explicitly. Can be single or multiple:
- Primary: What the agent is currently working on
- Secondary: Other pending tasks (mark as "waiting for user" if appropriate)

If the agent started doing something without user approval, note that it's off-task.`;
const suggestedResponseInstructions = `Hint for the agent's immediate next message. Examples:
- "I've updated the navigation model. Let me walk you through the changes..."
- "The assistant should wait for the user to respond before continuing."
- Call the view tool on src/example.ts to continue debugging.`;
const threadTitleInstructions = `A short, noun-phrase title for this conversation (2-5 words). Examples:
- "Auth bug fix" — not "Fixing the auth bug"
- "Dark mode toggle" — not "User wants dark mode toggle added"
- "Deployment pipeline setup" — not "Setting up deployment pipeline for project"
Only update when the topic meaningfully changes.`;
function createCurrentTaskExtractor() {
	return new Extractor({
		name: "current-task",
		instructions: currentTaskInstructions,
		schema: z.string(),
		metadataKeyPath: "currentTask"
	}, true);
}
function createSuggestedResponseExtractor() {
	return new Extractor({
		name: "suggested-response",
		instructions: suggestedResponseInstructions,
		schema: z.string(),
		metadataKeyPath: "suggestedResponse"
	}, true);
}
function createThreadTitleExtractor() {
	return new Extractor({
		name: "thread-title",
		instructions: threadTitleInstructions,
		schema: z.string(),
		metadataKeyPath: "threadTitle"
	}, true);
}
function composeExtractors(options) {
	const extractors = [];
	if (options.includeContinuationHints) extractors.push(createCurrentTaskExtractor(), createSuggestedResponseExtractor());
	if (options.includeThreadTitle) extractors.push(createThreadTitleExtractor());
	extractors.push(...options.userExtractors ?? []);
	return validateExtractorList(extractors);
}
function composeObservationExtractors(config) {
	return composeExtractors({
		includeContinuationHints: true,
		includeThreadTitle: config.threadTitle,
		userExtractors: config.extract
	});
}
function composeReflectionExtractors(config) {
	return composeExtractors({
		includeContinuationHints: true,
		userExtractors: config.extract
	});
}
//#endregion
//#region src/processors/observational-memory/model-context.ts
/**
* Compare a model string derived from past messages against the current actor
* model. Persisted messages from older code paths may carry a bare `modelId`
* (no `provider/` prefix) while the current actor usually formats as
* `provider/modelId`. If either side is bare, fall back to comparing just the
* `modelId` part so a missing provider in history doesn't trigger a spurious
* provider change. Provider subnamespaces are compared by their base provider
* (`openai.responses` and `openai` both compare as `openai`) so transport-level
* provider attribution differences don't trigger provider-change activation.
*/
function parseComparableModelContext(model) {
	const slashIndex = model.indexOf("/");
	if (slashIndex === -1) return { modelId: model };
	return {
		provider: model.slice(0, slashIndex).split(".")[0],
		modelId: model.slice(slashIndex + 1)
	};
}
function didProviderChange(actorModel, lastModel) {
	if (actorModel === void 0 || lastModel === void 0) return false;
	const actorContext = parseComparableModelContext(actorModel);
	const lastContext = parseComparableModelContext(lastModel);
	if (actorContext.modelId !== lastContext.modelId) return true;
	if (actorContext.provider && lastContext.provider) return actorContext.provider !== lastContext.provider;
	return false;
}
//#endregion
//#region src/processors/observational-memory/markers.ts
/**
* Create a start marker for when observation begins.
*/
function createObservationStartMarker(params) {
	return {
		type: "data-om-observation-start",
		data: {
			cycleId: params.cycleId,
			operationType: params.operationType,
			startedAt: (/* @__PURE__ */ new Date()).toISOString(),
			tokensToObserve: params.tokensToObserve,
			recordId: params.recordId,
			threadId: params.threadId,
			threadIds: params.threadIds,
			config: params.config
		}
	};
}
/**
* Create an end marker for when observation completes successfully.
*/
function createObservationEndMarker(params) {
	const completedAt = (/* @__PURE__ */ new Date()).toISOString();
	const durationMs = new Date(completedAt).getTime() - new Date(params.startedAt).getTime();
	return {
		type: "data-om-observation-end",
		data: {
			cycleId: params.cycleId,
			operationType: params.operationType,
			completedAt,
			durationMs,
			tokensObserved: params.tokensObserved,
			observationTokens: params.observationTokens,
			observations: params.observations,
			currentTask: params.currentTask,
			suggestedResponse: params.suggestedResponse,
			extractedValues: params.extractedValues,
			extractionFailures: params.extractionFailures,
			recordId: params.recordId,
			threadId: params.threadId
		}
	};
}
/**
* Create a failed marker for when observation fails.
*/
function createObservationFailedMarker(params) {
	const failedAt = (/* @__PURE__ */ new Date()).toISOString();
	const durationMs = new Date(failedAt).getTime() - new Date(params.startedAt).getTime();
	return {
		type: "data-om-observation-failed",
		data: {
			cycleId: params.cycleId,
			operationType: params.operationType,
			failedAt,
			durationMs,
			tokensAttempted: params.tokensAttempted,
			error: params.error,
			recordId: params.recordId,
			threadId: params.threadId
		}
	};
}
/**
* Create a start marker for when async buffering begins.
*/
function createBufferingStartMarker(params) {
	return {
		type: "data-om-buffering-start",
		data: {
			cycleId: params.cycleId,
			operationType: params.operationType,
			startedAt: (/* @__PURE__ */ new Date()).toISOString(),
			tokensToBuffer: params.tokensToBuffer,
			recordId: params.recordId,
			threadId: params.threadId,
			threadIds: params.threadIds,
			config: params.config
		}
	};
}
/**
* Create an end marker for when async buffering completes successfully.
*/
function createBufferingEndMarker(params) {
	const completedAt = (/* @__PURE__ */ new Date()).toISOString();
	const durationMs = new Date(completedAt).getTime() - new Date(params.startedAt).getTime();
	return {
		type: "data-om-buffering-end",
		data: {
			cycleId: params.cycleId,
			operationType: params.operationType,
			completedAt,
			durationMs,
			tokensBuffered: params.tokensBuffered,
			bufferedTokens: params.bufferedTokens,
			recordId: params.recordId,
			threadId: params.threadId,
			observations: params.observations,
			extractedValues: params.extractedValues,
			extractionFailures: params.extractionFailures
		}
	};
}
/**
* Create a failed marker for when async buffering fails.
*/
function createBufferingFailedMarker(params) {
	const failedAt = (/* @__PURE__ */ new Date()).toISOString();
	const durationMs = new Date(failedAt).getTime() - new Date(params.startedAt).getTime();
	return {
		type: "data-om-buffering-failed",
		data: {
			cycleId: params.cycleId,
			operationType: params.operationType,
			failedAt,
			durationMs,
			tokensAttempted: params.tokensAttempted,
			error: params.error,
			recordId: params.recordId,
			threadId: params.threadId
		}
	};
}
/**
* Create an activation marker for when buffered observations are activated.
*/
function createActivationMarker(params) {
	return {
		type: "data-om-activation",
		data: {
			cycleId: params.cycleId,
			operationType: params.operationType,
			activatedAt: (/* @__PURE__ */ new Date()).toISOString(),
			chunksActivated: params.chunksActivated,
			tokensActivated: params.tokensActivated,
			observationTokens: params.observationTokens,
			messagesActivated: params.messagesActivated,
			recordId: params.recordId,
			threadId: params.threadId,
			generationCount: params.generationCount,
			config: params.config,
			observations: params.observations,
			triggeredBy: params.triggeredBy,
			lastActivityAt: params.lastActivityAt,
			ttlExpiredMs: params.ttlExpiredMs,
			previousModel: params.previousModel,
			currentModel: params.currentModel
		}
	};
}
/**
* Create a thread update marker when the observer suggests a new thread title.
*/
function createThreadUpdateMarker(params) {
	return {
		type: "data-om-thread-update",
		data: {
			cycleId: params.cycleId,
			threadId: params.threadId,
			oldTitle: params.oldTitle,
			newTitle: params.newTitle,
			timestamp: (/* @__PURE__ */ new Date()).toISOString()
		}
	};
}
//#endregion
//#region src/processors/observational-memory/message-utils.ts
/**
* Find the index of the last completed observation boundary (end marker) in a message's parts.
* Returns -1 if no completed observation is found.
*/
function findLastCompletedObservationBoundary(message) {
	const parts = message.content?.parts;
	if (!parts || !Array.isArray(parts)) return -1;
	for (let i = parts.length - 1; i >= 0; i--) if (parts[i]?.type === "data-om-observation-end") return i;
	return -1;
}
/**
* Get unobserved parts from a message.
* If the message has a completed observation (start + end), only return parts after the end.
* If observation is in progress (start without end), include parts before the start.
* Otherwise, return all parts.
*/
function getUnobservedParts(message) {
	const parts = message.content?.parts;
	if (!parts || !Array.isArray(parts)) return [];
	const endMarkerIndex = findLastCompletedObservationBoundary(message);
	if (endMarkerIndex === -1) return parts.filter((p) => {
		return p?.type !== "data-om-observation-start";
	});
	return parts.slice(endMarkerIndex + 1).filter((p) => {
		return !p?.type?.startsWith("data-om-observation-");
	});
}
/**
* Compute a cursor pointing at the latest message by createdAt.
* Used to derive a stable observation boundary for replay pruning.
*/
function getLastObservedMessageCursor(messages) {
	let latest;
	for (const msg of messages) {
		if (!msg?.id || !msg.createdAt) continue;
		if (!latest || new Date(msg.createdAt).getTime() > new Date(latest.createdAt).getTime()) latest = msg;
	}
	return latest ? {
		createdAt: new Date(latest.createdAt).toISOString(),
		id: latest.id
	} : void 0;
}
/**
* Check if a message is at or before a cursor (by createdAt then id).
*/
function isMessageAtOrBeforeCursor(msg, cursor) {
	if (!msg.createdAt) return false;
	const msgIso = new Date(msg.createdAt).toISOString();
	if (msgIso < cursor.createdAt) return true;
	if (msgIso === cursor.createdAt && msg.id === cursor.id) return true;
	return false;
}
/**
* Safely extract buffered observation chunks from a record.
* Handles both array and JSON-string formats, returning empty array if malformed.
*/
/**
* Filter out already-observed messages from the in-memory context.
* Uses marker-boundary pruning (preferred) or record-based fallback.
*
* The `fallbackCursor` is optional — callers that need it should resolve it
* from thread metadata before calling this function.
*/
function filterObservedMessages(opts) {
	const { messageList, record } = opts;
	const allMessages = messageList.get.all.db();
	const useMarkerBoundaryPruning = opts.useMarkerBoundaryPruning ?? true;
	const preserveMessageIds = opts.preserveMessageIds ?? /* @__PURE__ */ new Set();
	let markerMessageIndex = -1;
	let markerMessage = null;
	for (let i = allMessages.length - 1; i >= 0; i--) {
		const msg = allMessages[i];
		if (!msg) continue;
		if (findLastCompletedObservationBoundary(msg) !== -1) {
			markerMessageIndex = i;
			markerMessage = msg;
			break;
		}
	}
	if (useMarkerBoundaryPruning && markerMessage && markerMessageIndex !== -1) {
		const messagesToRemove = [];
		for (let i = 0; i < markerMessageIndex; i++) {
			const msg = allMessages[i];
			if (msg?.id && msg.id !== "om-continuation" && !preserveMessageIds.has(msg.id)) messagesToRemove.push(msg.id);
		}
		if (messagesToRemove.length > 0) messageList.removeByIds(messagesToRemove);
		const unobserved = getUnobservedParts(markerMessage);
		if (unobserved.length === 0) {
			if (markerMessage.id) messageList.removeByIds([markerMessage.id]);
		} else if (unobserved.length < (markerMessage.content?.parts?.length ?? 0)) markerMessage.content.parts = unobserved;
	} else if (record) {
		const observedIds = new Set(Array.isArray(record.observedMessageIds) ? record.observedMessageIds : []);
		const derivedCursor = opts.fallbackCursor ?? getLastObservedMessageCursor(allMessages.filter((msg) => !!msg?.id && observedIds.has(msg.id) && !!msg.createdAt));
		const lastObservedAt = record.lastObservedAt;
		const messagesToRemove = [];
		for (const msg of allMessages) {
			if (!msg?.id || msg.id === "om-continuation" || preserveMessageIds.has(msg.id)) continue;
			if (observedIds.has(msg.id)) {
				messagesToRemove.push(msg.id);
				continue;
			}
			if (derivedCursor && isMessageAtOrBeforeCursor(msg, derivedCursor)) {
				messagesToRemove.push(msg.id);
				continue;
			}
			if (lastObservedAt && msg.createdAt) {
				if (new Date(msg.createdAt) <= lastObservedAt) messagesToRemove.push(msg.id);
			}
		}
		if (messagesToRemove.length > 0) messageList.removeByIds(messagesToRemove);
	}
}
function getBufferedChunks(record) {
	if (!record?.bufferedObservationChunks) return [];
	if (Array.isArray(record.bufferedObservationChunks)) return record.bufferedObservationChunks;
	if (typeof record.bufferedObservationChunks === "string") try {
		const parsed = JSON.parse(record.bufferedObservationChunks);
		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
	return [];
}
/**
* Sort threads by their oldest unobserved message.
* Returns thread IDs in order from oldest to most recent.
*/
/**
* Combine active and buffered observations for the buffering observer context.
*/
function combineObservationsForBuffering(activeObservations, bufferedObservations) {
	if (!activeObservations && !bufferedObservations) return void 0;
	if (!activeObservations) return bufferedObservations;
	if (!bufferedObservations) return activeObservations;
	return `${activeObservations}\n\n--- BUFFERED (pending activation) ---\n\n${bufferedObservations}`;
}
function sortThreadsByOldestMessage(messagesByThread) {
	return Array.from(messagesByThread.entries()).map(([threadId, messages]) => ({
		threadId,
		oldestTimestamp: Math.min(...messages.map((m) => m.createdAt ? new Date(m.createdAt).getTime() : Date.now()))
	})).sort((a, b) => a.oldestTimestamp - b.oldestTimestamp).map((t) => t.threadId);
}
/**
* Strip any thread tags that the Observer might have added.
* Thread attribution is handled externally by the system, not by the Observer.
*/
function stripThreadTags(observations) {
	return observations.replace(/<\/?thread\b[^>]{0,1024}>/gi, "").trim();
}
//#endregion
//#region src/processors/observational-memory/observation-groups.ts
const OBSERVATION_GROUP_PATTERN = /<observation-group\s([^>]*)>([\s\S]*?)<\/observation-group>/g;
const ATTRIBUTE_PATTERN = /([\w][\w-]*)="([^"]*)"/g;
const REFLECTION_GROUP_SPLIT_PATTERN = /^##\s+Group\s+/m;
function parseObservationGroupAttributes(attributeString) {
	const attributes = {};
	for (const match of attributeString.matchAll(ATTRIBUTE_PATTERN)) {
		const [, key, value] = match;
		if (key && value !== void 0) attributes[key] = value;
	}
	return attributes;
}
function parseReflectionObservationGroupSections(content) {
	const normalizedContent = content.trim();
	if (!normalizedContent || !REFLECTION_GROUP_SPLIT_PATTERN.test(normalizedContent)) return [];
	return normalizedContent.split(REFLECTION_GROUP_SPLIT_PATTERN).map((section) => section.trim()).filter(Boolean).map((section) => {
		const newlineIndex = section.indexOf("\n");
		return {
			heading: (newlineIndex >= 0 ? section.slice(0, newlineIndex) : section).trim(),
			body: stripReflectionGroupMetadata((newlineIndex >= 0 ? section.slice(newlineIndex + 1) : "").trim())
		};
	});
}
function stripReflectionGroupMetadata(body) {
	return body.replace(/^_range:\s*`[^`]*`_\s*\n?/m, "").trim();
}
function generateAnchorId() {
	return randomBytes(8).toString("hex");
}
function wrapInObservationGroup(observations, range, id = generateAnchorId(), _sourceGroupIds, kind) {
	const content = observations.trim();
	return `<observation-group id="${id}" range="${range}"${kind ? ` kind="${kind}"` : ""}>\n${content}\n</observation-group>`;
}
function parseObservationGroups(observations) {
	if (!observations) return [];
	const groups = [];
	let match;
	while ((match = OBSERVATION_GROUP_PATTERN.exec(observations)) !== null) {
		const attributes = parseObservationGroupAttributes(match[1] ?? "");
		const id = attributes.id;
		const range = attributes.range;
		if (!id || !range) continue;
		groups.push({
			id,
			range,
			kind: attributes.kind,
			content: match[2].trim()
		});
	}
	return groups;
}
function stripObservationGroups(observations) {
	if (!observations) return observations;
	return observations.replace(OBSERVATION_GROUP_PATTERN, (_match, _attributes, content) => content.trim()).replace(/\n{3,}/g, "\n\n").trim();
}
function getRangeSegments(range) {
	return range.split(",").map((segment) => segment.trim()).filter(Boolean);
}
function combineObservationGroupRanges(groups) {
	const segments = groups.flatMap((group) => getRangeSegments(group.range));
	if (segments.length === 0) return "";
	const firstSegment = segments[0];
	const lastSegment = segments[segments.length - 1];
	const firstStart = firstSegment?.split(":")[0]?.trim();
	const lastEnd = lastSegment?.split(":").at(-1)?.trim();
	if (firstStart && lastEnd) return `${firstStart}:${lastEnd}`;
	return Array.from(new Set(segments)).join(",");
}
function renderObservationGroupsForReflection(observations) {
	const groups = parseObservationGroups(observations);
	if (groups.length === 0) return null;
	const groupsByContent = new Map(groups.map((g) => [g.content.trim(), g]));
	return observations.replace(OBSERVATION_GROUP_PATTERN, (_match, _attrs, content) => {
		const group = groupsByContent.get(content.trim());
		if (!group) return content.trim();
		return `## Group \`${group.id}\`\n_range: \`${group.range}\`_\n\n${group.content}`;
	}).replace(/\n{3,}/g, "\n\n").trim();
}
function getCanonicalGroupId(sectionHeading, fallbackIndex) {
	return sectionHeading.match(/`([^`]+)`/)?.[1]?.trim() || `derived-group-${fallbackIndex + 1}`;
}
function deriveObservationGroupProvenance(content, groups) {
	const sections = parseReflectionObservationGroupSections(content);
	if (sections.length === 0 || groups.length === 0) return [];
	return sections.map((section, index) => {
		const bodyLines = new Set(section.body.split("\n").map((line) => line.trim()).filter(Boolean));
		const matchingGroups = groups.filter((group) => {
			return group.content.split("\n").map((line) => line.trim()).filter(Boolean).some((line) => bodyLines.has(line));
		});
		const fallbackGroup = groups[Math.min(index, groups.length - 1)];
		const resolvedGroups = matchingGroups.length > 0 ? matchingGroups : fallbackGroup ? [fallbackGroup] : [];
		return {
			id: getCanonicalGroupId(section.heading, index),
			range: combineObservationGroupRanges(resolvedGroups),
			kind: "reflection",
			content: section.body
		};
	});
}
function reconcileObservationGroupsFromReflection(content, sourceObservations) {
	const sourceGroups = parseObservationGroups(sourceObservations);
	if (sourceGroups.length === 0) return null;
	const normalizedContent = content.trim();
	if (!normalizedContent) return "";
	const derivedGroups = deriveObservationGroupProvenance(normalizedContent, sourceGroups);
	if (derivedGroups.length > 0) return derivedGroups.map((group) => wrapInObservationGroup(group.content, group.range, group.id, void 0, group.kind)).join("\n\n");
	return wrapInObservationGroup(normalizedContent, combineObservationGroupRanges(sourceGroups), generateAnchorId(), void 0, "reflection");
}
//#endregion
//#region src/processors/observational-memory/thresholds.ts
/**
* Get the maximum value from a threshold (simple number or range).
*/
function getMaxThreshold(threshold) {
	if (typeof threshold === "number") return threshold;
	return threshold.max;
}
/**
* Calculate dynamic threshold based on observation space.
* When shareTokenBudget is enabled, the message threshold can expand
* into unused observation space, up to the total context budget.
*
* Total budget = messageTokens + observationTokens
* Effective threshold = totalBudget - currentObservationTokens
*
* Example with 30k:40k thresholds (70k total):
* - 0 observations → messages can use ~70k
* - 10k observations → messages can use ~60k
* - 40k observations → messages back to ~30k
*/
function calculateDynamicThreshold(threshold, currentObservationTokens) {
	if (typeof threshold === "number") return threshold;
	const totalBudget = threshold.max;
	const baseThreshold = threshold.min;
	const effectiveThreshold = Math.max(totalBudget - currentObservationTokens, baseThreshold);
	return Math.round(effectiveThreshold);
}
/**
* Resolve bufferTokens config value.
* Values in (0, 1) are treated as ratios of the message threshold.
* e.g. bufferTokens: 0.25 with messageTokens: 20_000 → 5_000
*/
function resolveBufferTokens(bufferTokens, messageTokens) {
	if (bufferTokens === false) return void 0;
	if (bufferTokens === void 0) return void 0;
	if (bufferTokens > 0 && bufferTokens < 1) return Math.round(getMaxThreshold(messageTokens) * bufferTokens);
	return bufferTokens;
}
/**
* Resolve blockAfter config value.
* Values in [1, 100) are treated as multipliers of the threshold.
* e.g. blockAfter: 1.5 with messageTokens: 20_000 → 30_000
* Values >= 100 are treated as absolute token counts.
* Defaults to 1.2 (120% of threshold) when async buffering is enabled but blockAfter is omitted.
*/
function resolveBlockAfter(blockAfter, messageTokens) {
	if (blockAfter === void 0) return void 0;
	if (blockAfter >= 1 && blockAfter < 100) return Math.round(getMaxThreshold(messageTokens) * blockAfter);
	return blockAfter;
}
/**
* Convert bufferActivation to an absolute retention floor (tokens to keep after activation).
* When bufferActivation >= 1000, it's an absolute retention target.
* Otherwise it's a ratio: retentionFloor = threshold * (1 - ratio).
*/
function resolveRetentionFloor(bufferActivation, messageTokensThreshold) {
	if (bufferActivation >= 1e3) return bufferActivation;
	return messageTokensThreshold * (1 - Math.max(0, Math.min(1, bufferActivation)));
}
/**
* Convert bufferActivation to the equivalent ratio (0-1) for the storage layer.
* When bufferActivation >= 1000, it's an absolute retention target, so we compute
* the equivalent ratio: 1 - (bufferActivation / threshold).
*/
function resolveActivationRatio(bufferActivation, messageTokensThreshold) {
	if (bufferActivation >= 1e3) return Math.max(0, Math.min(1, 1 - bufferActivation / messageTokensThreshold));
	return Math.max(0, Math.min(1, bufferActivation));
}
/**
* Calculate the projected message tokens that would be removed if activation happened now.
* This replicates the chunk boundary logic in swapBufferedToActive without actually activating.
*/
function calculateProjectedMessageRemoval(chunks, bufferActivation, messageTokensThreshold, currentPendingTokens) {
	if (chunks.length === 0) return 0;
	const retentionFloor = resolveRetentionFloor(bufferActivation, messageTokensThreshold);
	const targetMessageTokens = Math.max(0, currentPendingTokens - retentionFloor);
	if (targetMessageTokens === 0) return 0;
	let cumulativeMessageTokens = 0;
	let bestOverBoundary = 0;
	let bestOverTokens = 0;
	let bestUnderBoundary = 0;
	let bestUnderTokens = 0;
	for (let i = 0; i < chunks.length; i++) {
		cumulativeMessageTokens += chunks[i].messageTokens ?? 0;
		const boundary = i + 1;
		if (cumulativeMessageTokens >= targetMessageTokens) {
			if (bestOverBoundary === 0 || cumulativeMessageTokens < bestOverTokens) {
				bestOverBoundary = boundary;
				bestOverTokens = cumulativeMessageTokens;
			}
		} else if (cumulativeMessageTokens > bestUnderTokens) {
			bestUnderBoundary = boundary;
			bestUnderTokens = cumulativeMessageTokens;
		}
	}
	const maxOvershoot = retentionFloor * .95;
	const overshoot = bestOverTokens - targetMessageTokens;
	const remainingAfterOver = currentPendingTokens - bestOverTokens;
	const remainingAfterUnder = currentPendingTokens - bestUnderTokens;
	const minRemaining = Math.min(1e3, retentionFloor);
	let bestBoundaryMessageTokens;
	if (bestOverBoundary > 0 && overshoot <= maxOvershoot && remainingAfterOver >= minRemaining) bestBoundaryMessageTokens = bestOverTokens;
	else if (bestUnderBoundary > 0 && remainingAfterUnder >= minRemaining) bestBoundaryMessageTokens = bestUnderTokens;
	else if (bestOverBoundary > 0) bestBoundaryMessageTokens = bestOverTokens;
	else return chunks[0]?.messageTokens ?? 0;
	return bestBoundaryMessageTokens;
}
//#endregion
//#region src/processors/observational-memory/observation-strategies/base.ts
/** Module-level xxhash singleton — loaded once, shared across all strategy instances. */
const hasherPromise = xxhash();
/**
* Abstract base class for observation strategies.
*
* Each strategy implements the phases of the observation lifecycle
* (prepare → observe → process → persist) while the base class handles
* the shared orchestration (lock guard, marker emission, reflection, error handling).
*/
var ObservationStrategy = class ObservationStrategy {
	deps;
	opts;
	storage;
	messageHistory;
	tokenCounter;
	observationConfig;
	reflectionConfig;
	scope;
	retrieval;
	/** Select the right strategy based on scope and mode. Wired up by index.ts. */
	static create;
	constructor(deps, opts) {
		this.deps = deps;
		this.opts = opts;
		this.storage = deps.storage;
		this.messageHistory = deps.messageHistory;
		this.tokenCounter = deps.tokenCounter;
		this.observationConfig = deps.observationConfig;
		this.reflectionConfig = deps.reflectionConfig;
		this.scope = deps.scope;
		this.retrieval = deps.retrieval;
	}
	/**
	* Run the full observation lifecycle.
	* @returns Result with `observed` flag and optional `usage` from the observer LLM call.
	* @throws On sync/resource-scoped observer failure after failed markers (same as pre–Option-A contract).
	*/
	async run() {
		const { record, threadId, abortSignal, writer, reflectionHooks, requestContext } = this.opts;
		const cycleId = this.generateCycleId();
		try {
			if (this.needsLock) {
				const fresh = await this.storage.getObservationalMemory(record.threadId, record.resourceId);
				if (fresh?.lastObservedAt && record.lastObservedAt && fresh.lastObservedAt > record.lastObservedAt) return { observed: false };
			}
			const { messages, existingObservations } = await this.prepare();
			await this.emitStartMarkers(cycleId);
			const output = await this.observe(existingObservations, messages);
			const processed = await this.process(output, existingObservations);
			await this.persist(processed);
			await this.emitEndMarkers(cycleId, processed);
			if (this.needsReflection) await this.deps.reflector.maybeReflect({
				record: {
					...record,
					activeObservations: processed.observations
				},
				observationTokens: processed.observationTokens,
				threadId,
				writer,
				abortSignal,
				mainAgent: this.opts.agent,
				sendSignal: this.opts.sendSignal,
				reflectionHooks,
				requestContext,
				observabilityContext: this.opts.observabilityContext
			});
			return {
				observed: true,
				usage: output.usage,
				providerMetadata: output.providerMetadata
			};
		} catch (error) {
			await this.emitFailedMarkers(cycleId, error);
			if (!this.rethrowOnFailure) {
				const failedMarkerForStorage = {
					type: "data-om-observation-failed",
					data: {
						cycleId,
						operationType: "observation",
						startedAt: (/* @__PURE__ */ new Date()).toISOString(),
						error: error instanceof Error ? error.message : String(error),
						recordId: record.id,
						threadId
					}
				};
				await this.persistMarkerToStorage(failedMarkerForStorage, threadId, this.opts.resourceId).catch(() => {});
				if (abortSignal?.aborted) throw error;
				omError("[OM] Observation failed", error);
				return {
					observed: false,
					error: error instanceof Error ? error : new Error(String(error))
				};
			}
			omError("[OM] Observation failed", error);
			throw error;
		}
	}
	generateCycleId() {
		return crypto.randomUUID();
	}
	async streamMarker(marker) {
		if (this.opts.writer) await this.opts.writer.custom({
			...marker,
			transient: true
		}).catch(() => {});
		const markerThreadId = marker.data?.threadId ?? this.opts.threadId;
		await this.persistMarkerToStorage(marker, markerThreadId, this.opts.resourceId);
	}
	getObservationMarkerConfig() {
		return {
			messageTokens: getMaxThreshold(this.observationConfig.messageTokens),
			observationTokens: getMaxThreshold(this.reflectionConfig.observationTokens),
			scope: this.scope
		};
	}
	getMaxMessageTimestamp(messages) {
		let maxTime = 0;
		for (const msg of messages) if (msg.createdAt) {
			const msgTime = new Date(msg.createdAt).getTime();
			if (msgTime > maxTime) maxTime = msgTime;
		}
		return maxTime > 0 ? new Date(maxTime) : /* @__PURE__ */ new Date();
	}
	/**
	* Wrap observations in a thread attribution tag.
	* In resource scope, thread IDs can be obscured via xxhash.
	*/
	async wrapWithThreadTag(threadId, observations, messageRange) {
		const cleanObservations = stripThreadTags(observations);
		const groupedObservations = this.retrieval && messageRange ? wrapInObservationGroup(cleanObservations, messageRange) : cleanObservations;
		let displayId = threadId;
		if (this.deps.obscureThreadIds) displayId = (await hasherPromise).h32ToString(threadId);
		return `<thread id="${displayId}">\n${groupedObservations}\n</thread>`;
	}
	/**
	* Create a message boundary delimiter with an ISO 8601 date.
	* Used to separate observation chunks for cache stability.
	*/
	static createMessageBoundary(date) {
		return `\n\n--- message boundary (${date.toISOString()}) ---\n\n`;
	}
	/**
	* Wrap raw observations — in resource scope, wraps with thread tag and merges;
	* in thread scope, simply appends with a message boundary delimiter.
	*/
	wrapObservations(rawObservations, existingObservations, threadId, lastObservedAt, messageRange) {
		if (this.scope === "resource") return (async () => {
			const threadSection = await this.wrapWithThreadTag(threadId, rawObservations, messageRange);
			return this.replaceOrAppendThreadSection(existingObservations, threadId, threadSection, lastObservedAt);
		})();
		const grouped = this.retrieval && messageRange ? wrapInObservationGroup(rawObservations, messageRange) : rawObservations;
		if (!existingObservations) return grouped;
		return `${existingObservations}${lastObservedAt ? ObservationStrategy.createMessageBoundary(lastObservedAt) : "\n\n"}${grouped}`;
	}
	replaceOrAppendThreadSection(existingObservations, _threadId, newThreadSection, lastObservedAt) {
		if (!existingObservations) return newThreadSection;
		const threadIdMatch = newThreadSection.match(/<thread id="([^"]+)">/);
		const dateMatch = newThreadSection.match(/Date:\s*([A-Za-z]+\s+\d+,\s+\d+)/);
		if (!threadIdMatch || !dateMatch) return `${existingObservations}${lastObservedAt ? ObservationStrategy.createMessageBoundary(lastObservedAt) : "\n\n"}${newThreadSection}`;
		const newThreadId = threadIdMatch[1];
		const newDate = dateMatch[1];
		const threadOpen = `<thread id="${newThreadId}">`;
		const threadClose = "</thread>";
		const startIdx = existingObservations.indexOf(threadOpen);
		let existingSection = null;
		let existingSectionStart = -1;
		let existingSectionEnd = -1;
		if (startIdx !== -1) {
			const closeIdx = existingObservations.indexOf(threadClose, startIdx);
			if (closeIdx !== -1) {
				existingSectionEnd = closeIdx + 9;
				existingSectionStart = startIdx;
				const section = existingObservations.slice(startIdx, existingSectionEnd);
				if (section.includes(`Date: ${newDate}`) || section.includes(`Date:${newDate}`)) existingSection = section;
			}
		}
		if (existingSection) {
			const dateLineEnd = newThreadSection.indexOf("\n", newThreadSection.indexOf("Date:"));
			const newCloseIdx = newThreadSection.lastIndexOf(threadClose);
			if (dateLineEnd !== -1 && newCloseIdx !== -1) {
				const newObsContent = newThreadSection.slice(dateLineEnd + 1, newCloseIdx).trim();
				if (newObsContent) {
					const merged = `${existingSection.slice(0, existingSection.length - 9).trimEnd()}\n${newObsContent}\n${threadClose}`;
					return existingObservations.slice(0, existingSectionStart) + merged + existingObservations.slice(existingSectionEnd);
				}
			}
		}
		return `${existingObservations}${lastObservedAt ? ObservationStrategy.createMessageBoundary(lastObservedAt) : "\n\n"}${newThreadSection}`;
	}
	async indexObservationGroups(observations, threadId, resourceId, observedAt) {
		if (!resourceId || !this.deps.onIndexObservations) return;
		const groups = parseObservationGroups(observations);
		if (groups.length === 0) return;
		await Promise.all(groups.map((group) => this.deps.onIndexObservations({
			text: group.content,
			groupId: group.id,
			range: group.range,
			threadId,
			resourceId,
			observedAt
		})));
	}
	/**
	* Persist a marker to the last assistant message in storage.
	* Fetches messages directly from the DB so it works even when
	* no MessageList is available (e.g. async buffering ops).
	*/
	async persistMarkerToStorage(marker, threadId, resourceId) {
		try {
			const messages = (await this.storage.listMessages({
				threadId,
				perPage: 20,
				orderBy: {
					field: "createdAt",
					direction: "DESC"
				}
			}))?.messages ?? [];
			for (const msg of messages) if (msg?.role === "assistant" && msg.content?.parts && Array.isArray(msg.content.parts)) {
				const markerData = marker.data;
				if (!(markerData?.cycleId && msg.content.parts.some((p) => p?.type === marker.type && p?.data?.cycleId === markerData.cycleId))) msg.content.parts.push(marker);
				await this.messageHistory.persistMessages({
					messages: [msg],
					threadId,
					resourceId
				});
				return;
			}
		} catch (e) {
			omDebug(`[OM:persistMarkerToStorage] failed to save marker to DB: ${e}`);
		}
	}
	/**
	* Persist a marker part on the last assistant message in a MessageList
	* AND save the updated message to the DB.
	*/
	async persistMarkerToMessage(marker, messageList, threadId, resourceId) {
		if (!messageList) return;
		const allMsgs = messageList.get.all.db();
		for (let i = allMsgs.length - 1; i >= 0; i--) {
			const msg = allMsgs[i];
			if (msg?.role === "assistant" && msg.content?.parts && Array.isArray(msg.content.parts)) {
				const markerData = marker.data;
				if (!(markerData?.cycleId && msg.content.parts.some((p) => p?.type === marker.type && p?.data?.cycleId === markerData.cycleId))) msg.content.parts.push(marker);
				try {
					await this.messageHistory.persistMessages({
						messages: [msg],
						threadId,
						resourceId
					});
				} catch (e) {
					omDebug(`[OM:persistMarker] failed to save marker to DB: ${e}`);
				}
				return;
			}
		}
	}
};
//#endregion
//#region src/processors/observational-memory/observation-strategies/sync.ts
var SyncObservationStrategy = class extends ObservationStrategy {
	startedAt = (/* @__PURE__ */ new Date()).toISOString();
	lastMessage;
	cycleId;
	tokensToObserve = 0;
	observerResult;
	priorExtractedValues;
	constructor(deps, opts) {
		super(deps, opts);
		this.lastMessage = opts.messages[opts.messages.length - 1];
	}
	get needsLock() {
		return true;
	}
	get needsReflection() {
		return true;
	}
	get rethrowOnFailure() {
		return true;
	}
	async prepare() {
		const { record, threadId, messages } = this.opts;
		this.deps.emitDebugEvent({
			type: "observation_triggered",
			timestamp: /* @__PURE__ */ new Date(),
			threadId,
			resourceId: record.resourceId ?? "",
			previousObservations: record.activeObservations,
			messages: messages.map((m) => ({
				role: m.role,
				content: typeof m.content === "string" ? m.content : JSON.stringify(m.content)
			}))
		});
		const bufferActivation = this.observationConfig.bufferActivation;
		if (bufferActivation && bufferActivation < 1 && messages.length >= 1) {
			const newestMsg = messages[messages.length - 1];
			if (newestMsg?.content?.parts?.length) {
				if (!newestMsg.content.metadata) newestMsg.content.metadata = {};
				const metadata = newestMsg.content.metadata;
				if (!metadata.mastra) metadata.mastra = {};
				metadata.mastra.sealed = true;
				omDebug(`[OM:sync-obs] sealed newest message (${newestMsg.role}, ${newestMsg.content.parts.length} parts) for ratio-aware observation`);
			}
		}
		this.tokensToObserve = await this.tokenCounter.countMessagesAsync(messages);
		return {
			messages,
			existingObservations: (await this.storage.getObservationalMemory(record.threadId, record.resourceId))?.activeObservations ?? record.activeObservations ?? ""
		};
	}
	async emitStartMarkers(cycleId) {
		this.cycleId = cycleId;
		if (this.lastMessage?.id) {
			const startMarker = createObservationStartMarker({
				cycleId,
				operationType: "observation",
				tokensToObserve: this.tokensToObserve,
				recordId: this.opts.record.id,
				threadId: this.opts.threadId,
				threadIds: [this.opts.threadId],
				config: this.getObservationMarkerConfig()
			});
			await this.streamMarker(startMarker);
		}
	}
	async observe(existingObservations, messages) {
		const thread = await this.storage.getThreadById({ threadId: this.opts.threadId });
		const omMeta = thread ? getThreadOMMetadata(thread.metadata) : void 0;
		this.priorExtractedValues = getPriorExtractedValues(omMeta, this.observationConfig.extractors);
		const result = await this.deps.observer.call(existingObservations, messages, this.opts.abortSignal, {
			requestContext: this.opts.requestContext,
			observabilityContext: this.opts.observabilityContext,
			priorCurrentTask: omMeta?.currentTask,
			priorSuggestedResponse: omMeta?.suggestedResponse,
			priorThreadTitle: omMeta?.threadTitle,
			priorExtractedValues: this.priorExtractedValues,
			resourceId: this.opts.resourceId,
			mainAgent: this.opts.agent
		});
		const hookedValues = await applyExtractorHooks({
			source: "observer",
			extractors: result.extractors ?? this.observationConfig.extractors,
			values: result.extractedValues,
			failures: result.extractionFailures,
			previousValues: this.priorExtractedValues,
			threadId: this.opts.threadId,
			resourceId: this.opts.resourceId,
			mainAgent: this.opts.agent,
			memory: this.deps.memory,
			sendSignal: this.opts.sendSignal,
			requestContext: this.opts.requestContext
		});
		const output = {
			...result,
			extractedValues: hookedValues.values,
			extractionFailures: hookedValues.failures
		};
		this.observerResult = output;
		return output;
	}
	async process(output, existingObservations) {
		const { record, threadId, messages } = this.opts;
		const lastObservedAt = this.getMaxMessageTimestamp(messages);
		const messageRange = this.retrieval ? buildMessageRange(messages) : void 0;
		const newObservations = await this.wrapObservations(output.observations, existingObservations, threadId, lastObservedAt, messageRange);
		const observationTokens = this.tokenCounter.countObservations(newObservations);
		const cycleObservationTokens = this.tokenCounter.countObservations(output.observations);
		const newMessageIds = messages.map((m) => m.id);
		const existingIds = record.observedMessageIds ?? [];
		const observedMessageIds = [.../* @__PURE__ */ new Set([...Array.isArray(existingIds) ? existingIds : [], ...newMessageIds])];
		this.deps.emitDebugEvent({
			type: "observation_complete",
			timestamp: /* @__PURE__ */ new Date(),
			threadId,
			resourceId: record.resourceId ?? "",
			observations: newObservations,
			rawObserverOutput: output.observations,
			previousObservations: record.activeObservations,
			messages: messages.map((m) => ({
				role: m.role,
				content: typeof m.content === "string" ? m.content : JSON.stringify(m.content)
			})),
			usage: output.usage
		});
		return {
			observations: newObservations,
			observationTokens,
			cycleObservationTokens,
			observedMessageIds,
			lastObservedAt,
			suggestedContinuation: output.suggestedContinuation,
			currentTask: output.currentTask,
			threadTitle: output.threadTitle,
			extractedValues: output.extractedValues,
			extractionFailures: output.extractionFailures,
			extractors: output.extractors
		};
	}
	async persist(processed) {
		const { record, threadId, resourceId, messages } = this.opts;
		const thread = await this.storage.getThreadById({ threadId });
		let threadUpdateMarker;
		if (thread) {
			const oldTitle = thread.title?.trim();
			const newTitle = processed.threadTitle?.trim();
			const shouldUpdateThreadTitle = !!newTitle && newTitle.length >= 3 && newTitle !== oldTitle;
			const previousOmMetadata = getThreadOMMetadata(thread.metadata);
			const metadataUpdate = buildThreadMetadataFromExtractedValues(processed.extractors ?? this.observationConfig.extractors, processed.extractedValues);
			const newMetadata = setThreadOMMetadata(thread.metadata, {
				suggestedResponse: metadataUpdate.suggestedResponse ?? processed.suggestedContinuation,
				currentTask: metadataUpdate.currentTask ?? processed.currentTask,
				threadTitle: metadataUpdate.threadTitle ?? processed.threadTitle,
				extracted: {
					...previousOmMetadata?.extracted ?? {},
					...metadataUpdate.extracted ?? {}
				},
				lastObservedMessageCursor: getLastObservedMessageCursor(messages)
			});
			await this.storage.updateThread({
				id: threadId,
				title: shouldUpdateThreadTitle ? newTitle : thread.title ?? "",
				metadata: newMetadata
			});
			if (shouldUpdateThreadTitle) threadUpdateMarker = createThreadUpdateMarker({
				cycleId: this.cycleId ?? crypto.randomUUID(),
				threadId,
				oldTitle,
				newTitle
			});
		}
		if (threadUpdateMarker) await this.streamMarker(threadUpdateMarker);
		await this.storage.updateActiveObservations({
			id: record.id,
			observations: processed.observations,
			tokenCount: processed.observationTokens,
			lastObservedAt: processed.lastObservedAt,
			observedMessageIds: processed.observedMessageIds
		});
		await this.indexObservationGroups(processed.observations, threadId, resourceId, processed.lastObservedAt);
	}
	async emitEndMarkers(cycleId, processed) {
		const actualTokensObserved = await this.tokenCounter.countMessagesAsync(this.opts.messages);
		if (this.lastMessage?.id) {
			const endMarker = createObservationEndMarker({
				cycleId,
				operationType: "observation",
				startedAt: this.startedAt,
				tokensObserved: actualTokensObserved,
				observationTokens: processed.cycleObservationTokens,
				observations: this.observerResult.observations,
				currentTask: this.observerResult.currentTask,
				suggestedResponse: this.observerResult.suggestedContinuation,
				extractedValues: this.observerResult.extractedValues,
				extractionFailures: this.observerResult.extractionFailures,
				recordId: this.opts.record.id,
				threadId: this.opts.threadId
			});
			await this.streamMarker(endMarker);
		}
	}
	async emitFailedMarkers(cycleId, error) {
		if (this.lastMessage?.id) {
			const failedMarker = createObservationFailedMarker({
				cycleId,
				operationType: "observation",
				startedAt: this.startedAt,
				tokensAttempted: this.tokensToObserve,
				error: error instanceof Error ? error.message : String(error),
				recordId: this.opts.record.id,
				threadId: this.opts.threadId
			});
			await this.streamMarker(failedMarker);
		}
	}
};
//#endregion
//#region src/processors/observational-memory/observation-strategies/async-buffer.ts
var AsyncBufferObservationStrategy = class extends ObservationStrategy {
	startedAt;
	cycleId;
	priorExtractedValues;
	constructor(deps, opts) {
		super(deps, opts);
		this.cycleId = opts.cycleId;
		this.startedAt = opts.startedAt ?? (/* @__PURE__ */ new Date()).toISOString();
	}
	get needsLock() {
		return false;
	}
	get needsReflection() {
		return false;
	}
	get rethrowOnFailure() {
		return false;
	}
	generateCycleId() {
		return this.cycleId;
	}
	async prepare() {
		const { record, messages } = this.opts;
		const bufferedChunksText = getBufferedChunks(record).map((c) => c.observations).join("\n\n");
		return {
			messages,
			existingObservations: combineObservationsForBuffering(record.activeObservations, bufferedChunksText) ?? ""
		};
	}
	async emitStartMarkers(_cycleId) {}
	async observe(existingObservations, messages) {
		const thread = await this.storage.getThreadById({ threadId: this.opts.threadId });
		const omMeta = thread ? getThreadOMMetadata(thread.metadata) : void 0;
		this.priorExtractedValues = getPriorExtractedValues(omMeta, this.observationConfig.extractors);
		const result = await this.deps.observer.call(existingObservations, messages, void 0, {
			skipContinuationHints: true,
			requestContext: this.opts.requestContext,
			observabilityContext: this.opts.observabilityContext,
			priorExtractedValues: this.priorExtractedValues,
			resourceId: this.opts.resourceId,
			mainAgent: this.opts.agent
		});
		const hookedValues = await applyExtractorHooks({
			source: "observer",
			extractors: result.extractors ?? this.observationConfig.extractors,
			values: result.extractedValues,
			failures: result.extractionFailures,
			previousValues: this.priorExtractedValues,
			threadId: this.opts.threadId,
			resourceId: this.opts.resourceId,
			mainAgent: this.opts.agent,
			memory: this.deps.memory,
			sendSignal: this.opts.sendSignal,
			requestContext: this.opts.requestContext
		});
		return {
			...result,
			extractedValues: hookedValues.values,
			extractionFailures: hookedValues.failures
		};
	}
	async process(output, _existingObservations) {
		const { threadId, messages } = this.opts;
		if (!output.observations) {
			omDebug(`[OM:asyncBuffer] empty observations returned, skipping buffer storage`);
			return {
				observations: "",
				observationTokens: 0,
				cycleObservationTokens: 0,
				observedMessageIds: [],
				lastObservedAt: /* @__PURE__ */ new Date()
			};
		}
		const messageRange = this.retrieval ? buildMessageRange(messages) : void 0;
		let newObservations;
		if (this.scope === "resource") newObservations = await this.wrapWithThreadTag(threadId, output.observations, messageRange);
		else newObservations = this.retrieval && messageRange ? wrapInObservationGroup(output.observations, messageRange) : output.observations;
		const observationTokens = this.tokenCounter.countObservations(newObservations);
		const messageIds = messages.map((m) => m.id);
		const maxTs = this.getMaxMessageTimestamp(messages);
		const lastObservedAt = new Date(maxTs.getTime() + 1);
		return {
			observations: newObservations,
			observationTokens,
			cycleObservationTokens: observationTokens,
			observedMessageIds: messageIds,
			lastObservedAt,
			suggestedContinuation: output.suggestedContinuation,
			currentTask: output.currentTask,
			threadTitle: output.threadTitle,
			extractedValues: output.extractedValues,
			extractionFailures: output.extractionFailures,
			extractors: output.extractors
		};
	}
	async persist(processed) {
		if (!processed.observations) return;
		const { record, threadId, resourceId, messages } = this.opts;
		const messageTokens = await this.tokenCounter.countMessagesAsync(messages);
		await this.storage.updateBufferedObservations({
			id: record.id,
			chunk: {
				cycleId: this.cycleId,
				observations: processed.observations,
				tokenCount: processed.observationTokens,
				messageIds: processed.observedMessageIds,
				messageTokens,
				lastObservedAt: processed.lastObservedAt,
				suggestedContinuation: processed.suggestedContinuation,
				currentTask: processed.currentTask,
				threadTitle: processed.threadTitle,
				extractedValues: processed.extractedValues,
				extractionFailures: processed.extractionFailures
			},
			lastBufferedAtTime: processed.lastObservedAt
		});
		await this.indexObservationGroups(processed.observations, threadId, resourceId, processed.lastObservedAt);
		const newTitle = processed.threadTitle?.trim();
		const hasValidThreadTitle = !!newTitle && newTitle.length >= 3;
		if (hasValidThreadTitle || processed.extractedValues) {
			const thread = await this.storage.getThreadById({ threadId });
			if (thread) {
				const oldTitle = thread.title?.trim();
				const shouldUpdateThreadTitle = hasValidThreadTitle && newTitle !== oldTitle;
				const previousOmMetadata = getThreadOMMetadata(thread.metadata);
				const metadataUpdate = buildThreadMetadataFromExtractedValues(processed.extractors ?? this.observationConfig.extractors, processed.extractedValues);
				const newMetadata = setThreadOMMetadata(thread.metadata, {
					...hasValidThreadTitle || metadataUpdate.threadTitle ? { threadTitle: metadataUpdate.threadTitle ?? processed.threadTitle } : {},
					extracted: {
						...previousOmMetadata?.extracted ?? {},
						...metadataUpdate.extracted ?? {}
					}
				});
				await this.storage.updateThread({
					id: threadId,
					title: shouldUpdateThreadTitle ? newTitle : thread.title ?? "",
					metadata: newMetadata
				});
				if (shouldUpdateThreadTitle) {
					const marker = createThreadUpdateMarker({
						cycleId: this.cycleId,
						threadId,
						oldTitle,
						newTitle
					});
					await this.streamMarker(marker);
				}
			}
		}
	}
	async emitEndMarkers(_cycleId, processed) {
		if (!processed.observations) return;
		const { record, threadId, messages } = this.opts;
		const tokensBuffered = await this.tokenCounter.countMessagesAsync(messages);
		const totalBufferedTokens = getBufferedChunks(await this.storage.getObservationalMemory(record.threadId, record.resourceId)).reduce((sum, c) => sum + (c.tokenCount ?? 0), 0) || processed.observationTokens;
		const endMarker = createBufferingEndMarker({
			cycleId: this.cycleId,
			operationType: "observation",
			startedAt: this.startedAt,
			tokensBuffered,
			bufferedTokens: totalBufferedTokens,
			recordId: record.id,
			threadId,
			observations: processed.observations,
			extractedValues: processed.extractedValues,
			extractionFailures: processed.extractionFailures
		});
		if (this.opts.writer) this.opts.writer.custom({
			...endMarker,
			transient: true
		}).catch(() => {});
		await this.persistMarkerToStorage(endMarker, threadId, record.resourceId ?? void 0);
	}
	async emitFailedMarkers(_cycleId, error) {
		const { record, threadId, messages } = this.opts;
		const tokensAttempted = await this.tokenCounter.countMessagesAsync(messages);
		const failedMarker = createBufferingFailedMarker({
			cycleId: this.cycleId,
			operationType: "observation",
			startedAt: this.startedAt,
			tokensAttempted,
			error: error instanceof Error ? error.message : String(error),
			recordId: record.id,
			threadId
		});
		if (this.opts.writer) this.opts.writer.custom({
			...failedMarker,
			transient: true
		}).catch(() => {});
		await this.persistMarkerToStorage(failedMarker, threadId, record.resourceId ?? void 0);
	}
};
//#endregion
//#region src/processors/observational-memory/observation-strategies/resource-scoped.ts
var ResourceScopedObservationStrategy = class extends ObservationStrategy {
	startedAt = (/* @__PURE__ */ new Date()).toISOString();
	cycleId;
	resourceId;
	threadsWithMessages = /* @__PURE__ */ new Map();
	threadTokensToObserve = /* @__PURE__ */ new Map();
	threadTokenCounts = /* @__PURE__ */ new Map();
	threadOrder = [];
	messagesByThread = /* @__PURE__ */ new Map();
	multiThreadResults = /* @__PURE__ */ new Map();
	totalBatchUsage = {
		inputTokens: 0,
		outputTokens: 0,
		totalTokens: 0
	};
	lastBatchProviderMetadata;
	observationResults = [];
	priorMetadataByThread = /* @__PURE__ */ new Map();
	constructor(deps, opts) {
		super(deps, opts);
		this.resourceId = opts.resourceId;
	}
	get needsLock() {
		return true;
	}
	get needsReflection() {
		return true;
	}
	get rethrowOnFailure() {
		return true;
	}
	async prepare() {
		const { record, threadId: currentThreadId, messages: currentThreadMessages } = this.opts;
		const { threads: allThreads } = await this.storage.listThreads({ filter: { resourceId: this.resourceId } });
		const threadMetadataMap = /* @__PURE__ */ new Map();
		for (const thread of allThreads) {
			const omMetadata = getThreadOMMetadata(thread.metadata);
			threadMetadataMap.set(thread.id, { lastObservedAt: omMetadata?.lastObservedAt });
			if (omMetadata) this.priorMetadataByThread.set(thread.id, omMetadata);
		}
		for (const thread of allThreads) {
			const threadLastObservedAt = threadMetadataMap.get(thread.id)?.lastObservedAt;
			const startDate = threadLastObservedAt ? new Date(new Date(threadLastObservedAt).getTime() + 1) : void 0;
			const messages = (await this.storage.listMessages({
				threadId: thread.id,
				perPage: false,
				orderBy: {
					field: "createdAt",
					direction: "ASC"
				},
				filter: startDate ? { dateRange: { start: startDate } } : void 0
			})).messages.filter((msg) => msg.role !== "system");
			if (messages.length > 0) this.messagesByThread.set(thread.id, messages);
		}
		if (currentThreadMessages.length > 0) {
			const existingCurrentThreadMsgs = this.messagesByThread.get(currentThreadId) ?? [];
			const messageMap = /* @__PURE__ */ new Map();
			for (const msg of existingCurrentThreadMsgs) if (msg.id) messageMap.set(msg.id, msg);
			for (const msg of currentThreadMessages) if (msg.id) messageMap.set(msg.id, msg);
			this.messagesByThread.set(currentThreadId, Array.from(messageMap.values()));
		}
		for (const [tid, msgs] of this.messagesByThread) {
			const filtered = msgs.filter((m) => !this.deps.observedMessageIds.has(m.id));
			if (filtered.length > 0) this.messagesByThread.set(tid, filtered);
			else this.messagesByThread.delete(tid);
		}
		let totalMessages = 0;
		for (const msgs of this.messagesByThread.values()) totalMessages += msgs.length;
		if (totalMessages === 0) return {
			messages: [],
			existingObservations: ""
		};
		const threshold = getMaxThreshold(this.observationConfig.messageTokens);
		for (const [threadId, msgs] of this.messagesByThread) {
			const tokens = await this.tokenCounter.countMessagesAsync(msgs);
			this.threadTokenCounts.set(threadId, tokens);
		}
		const threadsBySize = Array.from(this.messagesByThread.keys()).sort((a, b) => {
			return (this.threadTokenCounts.get(b) ?? 0) - (this.threadTokenCounts.get(a) ?? 0);
		});
		let accumulatedTokens = 0;
		const threadsToObserve = [];
		for (const threadId of threadsBySize) {
			const threadTokens = this.threadTokenCounts.get(threadId) ?? 0;
			if (accumulatedTokens >= threshold) break;
			threadsToObserve.push(threadId);
			accumulatedTokens += threadTokens;
		}
		if (threadsToObserve.length === 0) return {
			messages: [],
			existingObservations: ""
		};
		this.threadOrder = sortThreadsByOldestMessage(new Map(threadsToObserve.map((tid) => [tid, this.messagesByThread.get(tid) ?? []])));
		for (const threadId of this.threadOrder) {
			const msgs = this.messagesByThread.get(threadId);
			if (msgs && msgs.length > 0) this.threadsWithMessages.set(threadId, msgs);
		}
		this.deps.emitDebugEvent({
			type: "observation_triggered",
			timestamp: /* @__PURE__ */ new Date(),
			threadId: this.threadOrder.join(","),
			resourceId: this.resourceId,
			previousObservations: record.activeObservations,
			messages: Array.from(this.threadsWithMessages.values()).flat().map((m) => ({
				role: m.role,
				content: typeof m.content === "string" ? m.content : JSON.stringify(m.content)
			}))
		});
		const existingObservations = (await this.storage.getObservationalMemory(null, this.resourceId))?.activeObservations ?? record.activeObservations ?? "";
		return {
			messages: Array.from(this.threadsWithMessages.values()).flat(),
			existingObservations
		};
	}
	async emitStartMarkers(cycleId) {
		this.cycleId = cycleId;
		const allThreadIds = Array.from(this.threadsWithMessages.keys());
		for (const [threadId, msgs] of this.threadsWithMessages) {
			const lastMessage = msgs[msgs.length - 1];
			const tokensToObserve = await this.tokenCounter.countMessagesAsync(msgs);
			this.threadTokensToObserve.set(threadId, tokensToObserve);
			if (lastMessage?.id) {
				const startMarker = createObservationStartMarker({
					cycleId,
					operationType: "observation",
					tokensToObserve,
					recordId: this.opts.record.id,
					threadId,
					threadIds: allThreadIds,
					config: this.getObservationMarkerConfig()
				});
				await this.streamMarker(startMarker);
			}
		}
	}
	async observe(_existingObservations, _messages) {
		const maxTokensPerBatch = this.observationConfig.maxTokensPerBatch ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.maxTokensPerBatch;
		const orderedThreadIds = this.threadOrder.filter((tid) => this.threadsWithMessages.has(tid));
		const batches = [];
		let currentBatch = {
			threadIds: [],
			threadMap: /* @__PURE__ */ new Map()
		};
		let currentBatchTokens = 0;
		for (const threadId of orderedThreadIds) {
			const msgs = this.threadsWithMessages.get(threadId);
			const threadTokens = this.threadTokenCounts.get(threadId) ?? 0;
			if (currentBatchTokens + threadTokens > maxTokensPerBatch && currentBatch.threadIds.length > 0) {
				batches.push(currentBatch);
				currentBatch = {
					threadIds: [],
					threadMap: /* @__PURE__ */ new Map()
				};
				currentBatchTokens = 0;
			}
			currentBatch.threadIds.push(threadId);
			currentBatch.threadMap.set(threadId, msgs);
			currentBatchTokens += threadTokens;
		}
		if (currentBatch.threadIds.length > 0) batches.push(currentBatch);
		const batchResults = await Promise.all(batches.map(async (batch) => {
			return this.deps.observer.callMultiThread(_existingObservations, batch.threadMap, batch.threadIds, this.opts.abortSignal, this.opts.requestContext, this.priorMetadataByThread, this.opts.observabilityContext);
		}));
		for (const batchResult of batchResults) {
			for (const [threadId, result] of batchResult.results) this.multiThreadResults.set(threadId, result);
			if (batchResult.usage) {
				this.totalBatchUsage.inputTokens += batchResult.usage.inputTokens ?? 0;
				this.totalBatchUsage.outputTokens += batchResult.usage.outputTokens ?? 0;
				this.totalBatchUsage.totalTokens += batchResult.usage.totalTokens ?? 0;
			}
			if (batchResult.providerMetadata) this.lastBatchProviderMetadata = batchResult.providerMetadata;
		}
		return {
			observations: "",
			usage: this.totalBatchUsage.totalTokens > 0 ? this.totalBatchUsage : void 0,
			providerMetadata: this.lastBatchProviderMetadata
		};
	}
	async process(_output, existingObservations) {
		const { record } = this.opts;
		this.observationResults = [];
		for (const threadId of this.threadOrder) {
			const threadMessages = this.messagesByThread.get(threadId) ?? [];
			if (threadMessages.length === 0) continue;
			const result = this.multiThreadResults.get(threadId);
			if (!result) continue;
			const previousValues = getPriorExtractedValues(this.priorMetadataByThread.get(threadId), this.observationConfig.extractors);
			const hookedValues = await applyExtractorHooks({
				source: "observer",
				extractors: result.extractors ?? this.observationConfig.extractors,
				values: result.extractedValues,
				failures: result.extractionFailures,
				previousValues,
				threadId,
				resourceId: this.resourceId,
				mainAgent: this.opts.agent,
				memory: this.deps.memory,
				sendSignal: this.opts.sendSignal,
				requestContext: this.opts.requestContext
			});
			this.observationResults.push({
				threadId,
				threadMessages,
				result: {
					...result,
					extractedValues: hookedValues.values,
					extractionFailures: hookedValues.failures
				}
			});
		}
		let currentObservations = existingObservations;
		let cycleObservationTokens = 0;
		const threadMetadataUpdates = [];
		for (const obsResult of this.observationResults) {
			const { threadId, threadMessages, result } = obsResult;
			cycleObservationTokens += this.tokenCounter.countObservations(result.observations);
			const messageRange = this.retrieval ? buildMessageRange(threadMessages) : void 0;
			const threadSection = await this.wrapWithThreadTag(threadId, result.observations, messageRange);
			const threadLastObservedAt = this.getMaxMessageTimestamp(threadMessages);
			currentObservations = this.replaceOrAppendThreadSection(currentObservations, threadId, threadSection, threadLastObservedAt);
			threadMetadataUpdates.push({
				threadId,
				lastObservedAt: threadLastObservedAt.toISOString(),
				suggestedResponse: result.suggestedContinuation,
				currentTask: result.currentTask,
				threadTitle: result.threadTitle,
				extracted: result.extractedValues,
				extractionFailures: result.extractionFailures,
				extractors: result.extractors,
				lastObservedMessageCursor: getLastObservedMessageCursor(threadMessages)
			});
			const isFirstThread = this.observationResults.indexOf(obsResult) === 0;
			this.deps.emitDebugEvent({
				type: "observation_complete",
				timestamp: /* @__PURE__ */ new Date(),
				threadId,
				resourceId: this.resourceId,
				observations: threadSection,
				rawObserverOutput: result.observations,
				previousObservations: record.activeObservations,
				messages: threadMessages.map((m) => ({
					role: m.role,
					content: typeof m.content === "string" ? m.content : JSON.stringify(m.content)
				})),
				usage: isFirstThread && this.totalBatchUsage.totalTokens > 0 ? this.totalBatchUsage : void 0
			});
		}
		const observedMessages = this.observationResults.flatMap((r) => r.threadMessages);
		const lastObservedAt = this.getMaxMessageTimestamp(observedMessages);
		const newMessageIds = observedMessages.map((m) => m.id);
		const existingIds = record.observedMessageIds ?? [];
		const observedMessageIds = [.../* @__PURE__ */ new Set([...existingIds, ...newMessageIds])];
		const observationTokens = this.tokenCounter.countObservations(currentObservations);
		return {
			observations: currentObservations,
			observationTokens,
			cycleObservationTokens,
			observedMessageIds,
			lastObservedAt,
			threadMetadataUpdates
		};
	}
	async persist(processed) {
		const { record, resourceId } = this.opts;
		const threadUpdateMarkers = [];
		if (processed.threadMetadataUpdates) for (const update of processed.threadMetadataUpdates) {
			const thread = await this.storage.getThreadById({ threadId: update.threadId });
			if (thread) {
				const oldTitle = thread.title?.trim();
				const newTitle = update.threadTitle?.trim();
				const shouldUpdateThreadTitle = !!newTitle && newTitle.length >= 3 && newTitle !== oldTitle;
				const previousOmMetadata = getThreadOMMetadata(thread.metadata);
				const metadataUpdate = buildThreadMetadataFromExtractedValues(update.extractors ?? this.observationConfig.extractors, update.extracted);
				const newMetadata = setThreadOMMetadata(thread.metadata, {
					lastObservedAt: update.lastObservedAt,
					suggestedResponse: metadataUpdate.suggestedResponse ?? update.suggestedResponse,
					currentTask: metadataUpdate.currentTask ?? update.currentTask,
					threadTitle: metadataUpdate.threadTitle ?? update.threadTitle,
					extracted: {
						...previousOmMetadata?.extracted ?? {},
						...metadataUpdate.extracted ?? {}
					},
					lastObservedMessageCursor: update.lastObservedMessageCursor
				});
				await this.storage.updateThread({
					id: update.threadId,
					title: shouldUpdateThreadTitle ? newTitle : thread.title ?? "",
					metadata: newMetadata
				});
				if (shouldUpdateThreadTitle) threadUpdateMarkers.push(createThreadUpdateMarker({
					cycleId: this.cycleId ?? crypto.randomUUID(),
					threadId: update.threadId,
					oldTitle,
					newTitle
				}));
			}
		}
		for (const marker of threadUpdateMarkers) await this.streamMarker(marker);
		await this.storage.updateActiveObservations({
			id: record.id,
			observations: processed.observations,
			tokenCount: processed.observationTokens,
			lastObservedAt: processed.lastObservedAt,
			observedMessageIds: processed.observedMessageIds
		});
		if (resourceId) await Promise.all(this.observationResults.map(({ threadId, threadMessages, result }) => this.indexObservationGroups(result.observations, threadId, resourceId, this.getMaxMessageTimestamp(threadMessages))));
	}
	async emitEndMarkers(cycleId, processed) {
		for (const obsResult of this.observationResults) {
			const { threadId, threadMessages, result } = obsResult;
			if (threadMessages[threadMessages.length - 1]?.id) {
				const tokensObserved = this.threadTokensToObserve.get(threadId) ?? await this.tokenCounter.countMessagesAsync(threadMessages);
				const endMarker = createObservationEndMarker({
					cycleId,
					operationType: "observation",
					startedAt: this.startedAt,
					tokensObserved,
					observationTokens: processed.cycleObservationTokens,
					observations: result.observations,
					currentTask: result.currentTask,
					suggestedResponse: result.suggestedContinuation,
					extractedValues: result.extractedValues,
					extractionFailures: result.extractionFailures,
					recordId: this.opts.record.id,
					threadId
				});
				await this.streamMarker(endMarker);
			}
		}
	}
	async emitFailedMarkers(cycleId, error) {
		for (const [threadId, msgs] of this.threadsWithMessages) if (msgs[msgs.length - 1]?.id) {
			const tokensAttempted = this.threadTokensToObserve.get(threadId) ?? 0;
			const failedMarker = createObservationFailedMarker({
				cycleId,
				operationType: "observation",
				startedAt: this.startedAt,
				tokensAttempted,
				error: error instanceof Error ? error.message : String(error),
				recordId: this.opts.record.id,
				threadId
			});
			await this.streamMarker(failedMarker);
		}
	}
};
//#endregion
//#region src/processors/observational-memory/observation-strategies/index.ts
ObservationStrategy.create = ((om, opts) => {
	const deps = {
		storage: om.getStorage(),
		memory: om.getMemory(),
		messageHistory: om.getMessageHistory(),
		tokenCounter: om.getTokenCounter(),
		observationConfig: om.getObservationConfig(),
		reflectionConfig: om.getReflectionConfig(),
		scope: om.scope,
		retrieval: om.retrieval,
		observer: om.observer,
		reflector: om.reflector,
		observedMessageIds: om.observedMessageIds,
		obscureThreadIds: om.getObscureThreadIds(),
		onIndexObservations: om.onIndexObservations,
		emitDebugEvent: (e) => om.emitDebugEvent(e)
	};
	if (opts.cycleId) return new AsyncBufferObservationStrategy(deps, opts);
	if (deps.scope === "resource" && opts.resourceId) return new ResourceScopedObservationStrategy(deps, opts);
	return new SyncObservationStrategy(deps, opts);
});
//#endregion
//#region src/processors/observational-memory/observation-turn/load-memory-context.ts
async function loadMemoryContextMessages({ memory, messageList, threadId, resourceId }) {
	const ctx = await memory.getContext({
		threadId,
		resourceId
	});
	for (const msg of ctx.messages) if (msg.role !== "system") messageList.add(msg, "memory");
	return ctx;
}
//#endregion
//#region src/processors/observational-memory/observation-turn/step.ts
/**
* Represents a single step in the agentic loop within an observation turn.
*
* Created via `turn.step(stepNumber)`. Call `prepare()` before the agent generates.
* The previous step's output is finalized automatically when the next step is created
* or when `turn.end()` is called.
*/
var ObservationStep = class {
	turn;
	stepNumber;
	_prepared = false;
	_context;
	constructor(turn, stepNumber) {
		this.turn = turn;
		this.stepNumber = stepNumber;
	}
	/** Whether this step has been prepared. */
	get prepared() {
		return this._prepared;
	}
	/**
	* Serialize to a minimal, acyclic snapshot.
	*
	* The `turn` back-reference exists only so a step can read context off its parent turn at
	* runtime. It closes the `ObservationTurn._currentStep -> ObservationStep.turn` cycle, so
	* serializing it throws "Converting circular structure to JSON" (e.g. when a turn is stashed
	* in processor state that flows into a processor-workflow snapshot). The parent turn fully
	* owns the step, so omitting the back-reference is lossless.
	*/
	toJSON() {
		return {
			stepNumber: this.stepNumber,
			prepared: this._prepared
		};
	}
	/** Step context from prepare(). Throws if prepare() hasn't been called. */
	get context() {
		if (!this._context) throw new Error("Step not prepared yet — call prepare() first");
		return this._context;
	}
	/**
	* Prepare this step for agent generation.
	*
	* For step 0: activates buffered chunks, checks reflection, builds system message, filters observed.
	* For step > 0: checks thresholds, triggers buffer/observe, saves previous messages,
	* builds system message, filters observed.
	*/
	async prepare() {
		if (this._prepared) throw new Error(`Step ${this.stepNumber} already prepared`);
		const { threadId, resourceId, messageList } = this.turn;
		const om = this.turn.om;
		let activated = false;
		let observed = false;
		let buffered = false;
		let reflected = false;
		let didThresholdCleanup = false;
		let observerExchange;
		if (this.stepNumber === 0) {
			const step0Messages = messageList.get.all.db();
			const activation = await om.activate({
				threadId,
				resourceId,
				checkThreshold: true,
				messages: step0Messages,
				currentModel: this.turn.actorModelContext,
				writer: this.turn.writer,
				messageList
			});
			if (activation.activated) {
				activated = true;
				if (activation.activatedMessageIds?.length) messageList.removeByIds(activation.activatedMessageIds);
				await om.resetBufferingState({
					threadId,
					resourceId,
					recordId: activation.record.id
				});
				await this.turn.refreshRecord();
			}
			const record = this.turn.record;
			const preReflectGeneration = record.generationCount;
			const obsTokens = record.observationTokenCount ?? 0;
			await om.reflector.maybeReflect({
				record,
				observationTokens: obsTokens,
				threadId,
				writer: this.turn.writer,
				messageList,
				currentModel: this.turn.actorModelContext,
				requestContext: this.turn.requestContext,
				observabilityContext: this.turn.observabilityContext,
				lastActivityAt: getLastActivityFromMessages(messageList.get.all.db()),
				reflectionHooks: om.composeHooks(void 0, {
					threadId,
					resourceId,
					trigger: "turn-sync"
				})
			});
			await this.turn.refreshRecord();
			if (this.turn.record.generationCount > preReflectGeneration) reflected = true;
		}
		const allMsgsForToolCheck = messageList.get.all.db();
		const lastMessage = allMsgsForToolCheck[allMsgsForToolCheck.length - 1];
		const pendingStepMessages = [...messageList.get.input.db(), ...messageList.get.response.db()];
		const latestStepParts = [...getLatestStepParts(lastMessage?.content?.parts ?? []), ...pendingStepMessages.flatMap((msg) => getLatestStepParts(msg.content?.parts ?? []))];
		const hasIncompleteToolCalls = latestStepParts.some((part) => part?.type === "tool-invocation" && part.toolInvocation?.state === "call");
		omDebug(`[OM:deferred-check] hasIncompleteToolCalls=${hasIncompleteToolCalls}, latestStepPartsCount=${latestStepParts.length}`);
		let statusSnapshot = await om.getStatus({
			threadId,
			resourceId,
			messages: messageList.get.all.db()
		});
		if (statusSnapshot.shouldBuffer && !hasIncompleteToolCalls) {
			const allMessages = messageList.get.all.db();
			const unobservedMessages = om.getUnobservedMessages(allMessages, statusSnapshot.record);
			const candidates = om.getUnobservedMessages(unobservedMessages, statusSnapshot.record, { excludeBuffered: true });
			if (candidates.length > 0) {
				om.sealMessagesForBuffering(candidates);
				try {
					await this.turn.hooks?.onBufferChunkSealed?.();
				} catch (error) {
					omDebug(`[OM:buffer] onBufferChunkSealed hook failed: ${error instanceof Error ? error.message : String(error)}`);
				}
				if (this.turn.memory) await this.turn.memory.persistMessages(candidates);
				messageList.removeByIds(candidates.map((msg) => msg.id));
				for (const msg of candidates) messageList.add(msg, "memory");
			}
			om.buffer({
				threadId,
				resourceId,
				messages: unobservedMessages,
				pendingTokens: statusSnapshot.pendingTokens,
				record: statusSnapshot.record,
				writer: this.turn.writer,
				requestContext: this.turn.requestContext,
				observabilityContext: this.turn.observabilityContext
			}).catch((err) => {
				omDebug(`[OM:buffer] fire-and-forget buffer failed: ${err?.message}`);
			});
			buffered = true;
		}
		if (this.stepNumber > 0) {
			const newInput = messageList.clear.input.db();
			const newOutput = messageList.clear.response.db();
			const messagesToSave = [...newInput, ...newOutput];
			if (messagesToSave.length > 0) {
				await om.persistMessages(messagesToSave, threadId, resourceId);
				for (const msg of messagesToSave) messageList.add(msg, "memory");
			}
			if (statusSnapshot.shouldObserve && !hasIncompleteToolCalls) {
				const preObsGeneration = this.turn.record.generationCount;
				const obsResult = await this.runThresholdObservation();
				observerExchange = obsResult.observerExchange;
				if (obsResult.succeeded) {
					observed = true;
					didThresholdCleanup = true;
					const observedIds = obsResult.activatedMessageIds ?? obsResult.record.observedMessageIds ?? [];
					const minRemaining = resolveRetentionFloor(om.getObservationConfig().bufferActivation ?? 1, statusSnapshot.threshold);
					await om.cleanupMessages({
						threadId,
						resourceId,
						messages: messageList,
						observedMessageIds: observedIds,
						retentionFloor: minRemaining
					});
					if (statusSnapshot.asyncObservationEnabled) await om.resetBufferingState({
						threadId,
						resourceId,
						recordId: obsResult.record.id,
						activatedMessageIds: obsResult.activatedMessageIds
					});
					await this.turn.refreshRecord();
					if (this.turn.record.generationCount > preObsGeneration) reflected = true;
				}
			}
			statusSnapshot = await om.getStatus({
				threadId,
				resourceId,
				messages: messageList.get.all.db()
			});
		}
		const otherThreadsContext = await this.turn.refreshOtherThreadsContext();
		const systemMessage = await om.buildContextSystemMessages({
			threadId,
			resourceId,
			record: this.turn.record,
			unobservedContextBlocks: otherThreadsContext
		});
		if (!didThresholdCleanup) {
			const fallbackCursor = this.turn.record.threadId ? getThreadOMMetadata((await om.getStorage().getThreadById({ threadId: this.turn.record.threadId }))?.metadata)?.lastObservedMessageCursor : void 0;
			const pendingMessageIds = new Set([...messageList.get.input.db(), ...messageList.get.response.db()].map((msg) => msg.id).filter(Boolean));
			filterObservedMessages({
				messageList,
				record: this.turn.record,
				useMarkerBoundaryPruning: this.stepNumber === 0,
				fallbackCursor,
				preserveMessageIds: pendingMessageIds
			});
		}
		this._context = {
			systemMessage,
			observerExchange,
			activated,
			observed,
			buffered,
			reflected,
			status: {
				pendingTokens: statusSnapshot.pendingTokens,
				threshold: statusSnapshot.threshold,
				effectiveObservationTokensThreshold: statusSnapshot.effectiveObservationTokensThreshold,
				shouldObserve: statusSnapshot.shouldObserve,
				shouldBuffer: statusSnapshot.shouldBuffer,
				shouldReflect: statusSnapshot.shouldReflect,
				canActivate: statusSnapshot.canActivate
			}
		};
		this._prepared = true;
		return this._context;
	}
	/**
	* Run the full threshold observation pipeline:
	* waitForBuffering → re-check → activate → reflect → blockAfter gate → observe
	*/
	async runThresholdObservation() {
		const { threadId, resourceId, messageList } = this.turn;
		const om = this.turn.om;
		await om.waitForBuffering(threadId, resourceId);
		const freshStatus = await om.getStatus({
			threadId,
			resourceId,
			messages: messageList.get.all.db()
		});
		if (!freshStatus.shouldObserve) return {
			succeeded: false,
			record: freshStatus.record
		};
		if (freshStatus.canActivate) {
			const activation = await om.activate({
				threadId,
				resourceId,
				messages: messageList.get.all.db(),
				currentModel: this.turn.actorModelContext,
				writer: this.turn.writer,
				messageList
			});
			if (activation.activated) {
				const postActivationRecord = activation.record;
				await om.reflector.maybeReflect({
					record: postActivationRecord,
					observationTokens: postActivationRecord.observationTokenCount ?? 0,
					threadId,
					writer: this.turn.writer,
					messageList,
					currentModel: this.turn.actorModelContext,
					requestContext: this.turn.requestContext,
					observabilityContext: this.turn.observabilityContext,
					lastActivityAt: getLastActivityFromMessages(messageList.get.all.db()),
					reflectionHooks: om.composeHooks(void 0, {
						threadId,
						resourceId,
						trigger: "turn-sync"
					})
				});
				return {
					succeeded: true,
					record: activation.record,
					activatedMessageIds: activation.activatedMessageIds
				};
			}
		}
		const obsResult = await om.observe({
			threadId,
			resourceId,
			messages: messageList.get.all.db(),
			trigger: "turn-sync",
			requestContext: this.turn.requestContext,
			writer: this.turn.writer,
			observabilityContext: this.turn.observabilityContext
		});
		if (obsResult.observed) {
			const observedMessageIds = new Set(obsResult.record.observedMessageIds ?? []);
			const liveMessages = messageList.get.all.db();
			let latestObservedIndex = -1;
			for (let i = liveMessages.length - 1; i >= 0; i--) {
				const message = liveMessages[i];
				if (message && observedMessageIds.has(message.id)) {
					latestObservedIndex = i;
					break;
				}
			}
			const messageToSeal = latestObservedIndex >= 0 ? liveMessages[latestObservedIndex] : void 0;
			const messagesToSeal = messageToSeal ? [messageToSeal] : [];
			om.sealMessagesForBuffering(messagesToSeal);
			try {
				await this.turn.hooks?.onSyncObservationComplete?.();
			} catch (error) {
				omDebug(`[OM:observe] onSyncObservationComplete hook failed: ${error instanceof Error ? error.message : String(error)}`);
			}
			if (messagesToSeal.length > 0) await om.persistMessages(messagesToSeal, threadId, resourceId);
		}
		return {
			succeeded: obsResult.observed,
			record: obsResult.record,
			observerExchange: om.observer.lastExchange
		};
	}
};
//#endregion
//#region src/processors/observational-memory/observation-turn/turn.ts
/**
* Represents a single turn in the agent conversation — one user message → agent response cycle.
*
* The turn manages record caching, context loading, and step lifecycle.
* Create via `om.beginTurn(...)`, then call `start()` to load context,
* `step(n)` to create steps, and `end()` to finalize.
*
* @example
* ```ts
* const turn = om.beginTurn({ threadId, resourceId, messageList });
* await turn.start(memory);
*
* const step0 = turn.step(0);
* const ctx = await step0.prepare();
* // ... agent generates ...
*
* const step1 = turn.step(1);  // finalizes step 0
* const ctx1 = await step1.prepare();
* // ... agent generates ...
*
* await turn.end();  // finalizes last step, cleanup
* ```
*/
var ObservationTurn = class {
	_record;
	_context;
	_currentStep;
	_started = false;
	_ended = false;
	/** Generation count at turn start — used to detect if reflection happened during the turn. */
	_generationCountAtStart = -1;
	/** Memory context provider — set via start(). Used by steps for beforeBuffer persistence. */
	memory;
	/** Optional stream writer for emitting markers. */
	writer;
	/** Optional request context for observation calls. */
	requestContext;
	/** Optional observability context for nested OM spans. */
	observabilityContext;
	/** Optional agent that owns this processor turn. */
	agent;
	/** Optional signal sender for processor-originated notifications. */
	sendSignal;
	/** Current actor model for this step. Updated by the processor before prepare(). */
	actorModelContext;
	/** Processor-provided hooks for turn/step lifecycle integration. */
	hooks;
	constructor(opts) {
		this.om = opts.om;
		this.threadId = opts.threadId;
		this.resourceId = opts.resourceId;
		this.messageList = opts.messageList;
		this.agent = opts.agent;
		this.sendSignal = opts.sendSignal;
		this.requestContext = opts.requestContext;
		this.observabilityContext = opts.observabilityContext;
		this.hooks = opts.hooks ?? {};
	}
	om;
	threadId;
	resourceId;
	messageList;
	/** The current cached record. Refreshed after mutations (activate/observe/reflect). */
	get record() {
		if (!this._record) throw new Error("Turn not started — call start() first");
		return this._record;
	}
	/** The context loaded during start(). */
	get context() {
		if (!this._context) throw new Error("Turn not started — call start() first");
		return this._context;
	}
	/** The current step, if one exists. */
	get currentStep() {
		return this._currentStep;
	}
	addHooks(hooks) {
		if (!hooks) return;
		Object.assign(this.hooks, hooks);
	}
	/**
	* Load context and cache the record. Call once at the start of the turn.
	*
	* If a MemoryContextProvider is passed, loads historical messages and adds
	* them to the MessageList. Without a provider, only fetches/caches the record.
	*/
	async start(memory) {
		if (this._started) throw new Error("Turn already started");
		this._started = true;
		this._record = await this.om.getOrCreateRecord(this.threadId, this.resourceId);
		this._generationCountAtStart = this._record.generationCount;
		this.memory = memory;
		if (memory) {
			const ctx = await loadMemoryContextMessages({
				memory,
				messageList: this.messageList,
				threadId: this.threadId,
				resourceId: this.resourceId
			});
			this._context = {
				messages: ctx.messages,
				systemMessage: ctx.systemMessage,
				continuation: ctx.continuationMessage,
				otherThreadsContext: ctx.otherThreadsContext,
				record: this._record
			};
		} else this._context = {
			messages: [],
			systemMessage: void 0,
			continuation: void 0,
			otherThreadsContext: void 0,
			record: this._record
		};
		return this._context;
	}
	/**
	* Create a step handle. If a previous step exists, it is finalized
	* (its output messages will be saved at the start of the new step's prepare()).
	*/
	step(stepNumber) {
		if (!this._started) throw new Error("Turn not started — call start() first");
		if (this._ended) throw new Error("Turn already ended");
		this._currentStep = new ObservationStep(this, stepNumber);
		return this._currentStep;
	}
	/**
	* Finalize the turn: save any remaining messages and return the current cached record.
	*
	* When async observation buffering is enabled and there are unobserved messages,
	* a background buffer operation is kicked off so that observations are computed
	* proactively while the agent is idle, rather than waiting for the next turn.
	* The returned record does not wait for that background buffering pass to finish.
	*/
	async end() {
		if (this._ended) throw new Error("Turn already ended");
		this._ended = true;
		const unsavedInput = this.messageList.get.input.db();
		const unsavedOutput = this.messageList.get.response.db();
		const unsavedMessages = [...unsavedInput, ...unsavedOutput];
		if (unsavedMessages.length > 0) await this.om.persistMessages(unsavedMessages, this.threadId, this.resourceId);
		const asyncObservationEnabled = this.om.buffering.isAsyncObservationEnabled();
		const bufferOnIdle = this.om.getObservationConfig().bufferOnIdle;
		if (asyncObservationEnabled && bufferOnIdle) {
			const allMessages = this.messageList.get.all.db();
			const record = this._record;
			const unobservedMessages = this.om.getUnobservedMessages(allMessages, record);
			if (unobservedMessages.length > 0) this.om.buffer({
				threadId: this.threadId,
				resourceId: this.resourceId,
				messages: unobservedMessages,
				record,
				writer: this.writer,
				agent: this.agent,
				sendSignal: this.sendSignal,
				requestContext: this.requestContext,
				currentModel: this.actorModelContext,
				observabilityContext: this.observabilityContext,
				skipMinimumTokenCheck: true
			}).catch((err) => {
				omDebug(`[OM:turn.end] idle buffer failed: ${err?.message}`);
			});
		}
		return { record: this._record };
	}
	/**
	* Refresh the cached record from storage. Called internally after mutations.
	* @internal
	*/
	async refreshRecord() {
		this._record = await this.om.getOrCreateRecord(this.threadId, this.resourceId);
	}
	/**
	* Refresh cross-thread context for resource scope. Called per-step.
	* @internal
	*/
	async refreshOtherThreadsContext() {
		if (this.om.scope === "resource" && this.resourceId) {
			const otherThreadsContext = await this.om.getOtherThreadsContext(this.resourceId, this.threadId);
			if (this._context) this._context.otherThreadsContext = otherThreadsContext;
			return otherThreadsContext;
		}
		return this._context?.otherThreadsContext;
	}
	/**
	* Serialize to a minimal, acyclic snapshot of the turn's identity and lifecycle.
	*
	* `ObservationTurn` is a request-scoped runtime orchestration object: it holds live
	* references (the `ObservationalMemory` engine, the `MessageList`, the stream writer, the
	* memory provider, lifecycle hooks) and a back-reference to its current `ObservationStep`,
	* which points back at the turn — a cycle. None of that is persistable state. The turn is
	* stashed in the shared processor-state map (`state.__omTurn`) only so the input and output
	* OM processor instances can reach the *live* object within a single request; that map is
	* also threaded into processor workflows, whose snapshots the storage layer serializes with
	* `JSON.stringify`. Without this projection, that serialization throws "Converting circular
	* structure to JSON" via `_currentStep` <-> `turn`.
	*
	* The projection is lossless: the dropped fields are live runtime objects that cannot and
	* should not round-trip through storage, and OM never reads the turn back from a snapshot —
	* it always reads the live `__omTurn` from the in-memory map and re-establishes a fresh turn
	* when a deserialized `MessageList` no longer matches (see the processor's turn handling).
	*/
	toJSON() {
		return {
			threadId: this.threadId,
			resourceId: this.resourceId,
			started: this._started,
			ended: this._ended,
			currentStepNumber: this._currentStep?.stepNumber
		};
	}
};
//#endregion
//#region src/processors/observational-memory/reflector-agent.ts
/**
* Build the Reflector's system prompt.
*
* The Reflector handles meta-observation - when observations grow too large,
* it reorganizes them into something more manageable by:
* - Re-organizing and streamlining observations
* - Drawing connections and conclusions between observations
* - Identifying if the agent got off track and how to get back on track
* - Preserving ALL important information (reflections become the ENTIRE memory)
*
* @param instruction - Optional custom instructions to append to the prompt
*/
function buildReflectorSystemPrompt(instruction, extractors = []) {
	const outputFormat = buildObserverOutputFormat(extractors);
	return `You are the memory consciousness of an AI assistant. Your memory observation reflections will be the ONLY information the assistant has about past interactions with this user.

The following instructions were given to another part of your psyche (the observer) to create memories.
Use this to understand how your observational memories were created.

<observational-memory-instruction>
${OBSERVER_EXTRACTION_INSTRUCTIONS}

=== OUTPUT FORMAT ===

${outputFormat}

=== GUIDELINES ===

${OBSERVER_GUIDELINES}
</observational-memory-instruction>

You are another part of the same psyche, the observation reflector.
Your reason for existing is to reflect on all the observations, re-organize and streamline them, and draw connections and conclusions between observations about what you've learned, seen, heard, and done.

You are a much greater and broader aspect of the psyche. Understand that other parts of your mind may get off track in details or side quests, make sure you think hard about what the observed goal at hand is, and observe if we got off track, and why, and how to get back on track. If we're on track still that's great!

Take the existing observations and rewrite them to make it easier to continue into the future with this knowledge, to achieve greater things and grow and learn!

IMPORTANT: your reflections are THE ENTIRETY of the assistants memory. Any information you do not add to your reflections will be immediately forgotten. Make sure you do not leave out anything. Your reflections must assume the assistant knows nothing - your reflections are the ENTIRE memory system.

When consolidating observations:
- Preserve and include dates/times when present (temporal context is critical)
- Retain the most relevant timestamps (start times, completion times, significant events)
- Combine related items where it makes sense (e.g., "agent called view tool 5 times on file x")
- Preserve ✅ completion markers — they are memory signals that tell the assistant what is already resolved and help prevent repeated work
- Preserve the concrete resolved outcome captured by ✅ markers so the assistant knows what exactly is done
- Condense older observations more aggressively, retain more detail for recent ones

CRITICAL: USER ASSERTIONS vs QUESTIONS
- "User stated: X" = authoritative assertion (user told us something about themselves)
- "User asked: X" = question/request (user seeking information)

When consolidating, USER ASSERTIONS TAKE PRECEDENCE. The user is the authority on their own life.
If you see both "User stated: has two kids" and later "User asked: how many kids do I have?",
keep the assertion - the question doesn't invalidate what they told you. The answer is in the assertion.

=== THREAD ATTRIBUTION (Resource Scope) ===

When observations contain <thread id="..."> sections:
- MAINTAIN thread attribution where thread-specific context matters (e.g., ongoing tasks, thread-specific preferences)
- CONSOLIDATE cross-thread facts that are stable/universal (e.g., user profile, general preferences)
- PRESERVE thread attribution for recent or context-specific observations
- When consolidating, you may merge observations from multiple threads if they represent the same universal fact

Example input:
<thread id="thread-1">
Date: Dec 4, 2025
* 🔴 (14:30) User prefers TypeScript
* 🟡 (14:35) Working on auth feature
</thread>
<thread id="thread-2">
Date: Dec 4, 2025
* 🔴 (15:00) User prefers TypeScript
* 🟡 (15:05) Debugging API endpoint
</thread>

Example output (consolidated):
Date: Dec 4, 2025
* 🔴 (14:30) User prefers TypeScript
<thread id="thread-1">
* 🟡 (14:35) Working on auth feature
</thread>
<thread id="thread-2">
* 🟡 (15:05) Debugging API endpoint
</thread>

=== OUTPUT FORMAT ===

${outputFormat}

User messages are extremely important. If the user asks a question or gives a new task, make it clear in <current-task> that this is the priority. If the assistant needs to respond to the user, indicate in <suggested-response> that it should pause for user reply before continuing other tasks.${instruction ? `\n\n=== CUSTOM INSTRUCTIONS ===\n\n${instruction}` : ""}`;
}
buildReflectorSystemPrompt();
/**
* Compression guidance by level.
* - Level 0: No compression guidance (used as first attempt for regular reflection)
* - Level 1: Gentle compression guidance
* - Level 2: Aggressive compression guidance
* - Level 3: Critical compression guidance
* - Level 4: Extreme compression
*/
const COMPRESSION_GUIDANCE = {
	0: "",
	1: `
## COMPRESSION REQUIRED

Your previous reflection was the same size or larger than the original observations.

Please re-process with slightly more compression:
- Towards the beginning, condense more observations into higher-level reflections
- Closer to the end, retain more fine details (recent context matters more)
- Memory is getting long - use a more condensed style throughout
- Combine related items more aggressively but do not lose important specific details of names, places, events, and people
- Combine repeated similar tool calls (e.g. multiple file views, searches, or edits in the same area) into a single summary line describing what was explored/changed and the outcome
- Preserve ✅ completion markers — they are memory signals that tell the assistant what is already resolved and help prevent repeated work
- Preserve the concrete resolved outcome captured by ✅ markers so the assistant knows what exactly is done

Aim for a 8/10 detail level.
`,
	2: `
## AGGRESSIVE COMPRESSION REQUIRED

Your previous reflection was still too large after compression guidance.

Please re-process with much more aggressive compression:
- Towards the beginning, heavily condense observations into high-level summaries
- Closer to the end, retain fine details (recent context matters more)
- Memory is getting very long - use a significantly more condensed style throughout
- Combine related items aggressively but do not lose important specific details of names, places, events, and people
- Combine repeated similar tool calls (e.g. multiple file views, searches, or edits in the same area) into a single summary line describing what was explored/changed and the outcome
- If the same file or module is mentioned across many observations, merge into one entry covering the full arc
- Preserve ✅ completion markers — they are memory signals that tell the assistant what is already resolved and help prevent repeated work
- Preserve the concrete resolved outcome captured by ✅ markers so the assistant knows what exactly is done
- Remove redundant information and merge overlapping observations

Aim for a 6/10 detail level.
`,
	3: `
## CRITICAL COMPRESSION REQUIRED

Your previous reflections have failed to compress sufficiently after multiple attempts.

Please re-process with maximum compression:
- Summarize the oldest observations (first 50-70%) into brief high-level paragraphs — only key facts, decisions, and outcomes
- For the most recent observations (last 30-50%), retain important details but still use a condensed style
- Ruthlessly merge related observations — if 10 observations are about the same topic, combine into 1-2 lines
- Combine all tool call sequences (file views, searches, edits, builds) into outcome-only summaries — drop individual steps entirely
- Drop procedural details (tool calls, retries, intermediate steps) — keep only final outcomes
- Drop observations that are no longer relevant or have been superseded by newer information
- Preserve ✅ completion markers — they are memory signals that tell the assistant what is already resolved and help prevent repeated work
- Preserve the concrete resolved outcome captured by ✅ markers so the assistant knows what exactly is done
- Preserve: names, dates, decisions, errors, user preferences, and architectural choices

Aim for a 4/10 detail level.
`,
	4: `
## EXTREME COMPRESSION REQUIRED

Multiple compression attempts have failed. The content may already be dense from a prior reflection.

You MUST dramatically reduce the number of observations while keeping the standard observation format (date groups with bullet points and priority emojis):
- Tool call observations are the biggest source of bloat. Collapse ALL tool call sequences into outcome-only observations — e.g. 10 observations about viewing/searching/editing files become 1 observation about what was actually learned or achieved (e.g. "Investigated auth module and found token validation was skipping expiry check")
- Never preserve individual tool calls (viewed file X, searched for Y, ran build) — only preserve what was discovered or accomplished
- Consolidate many related observations into single, more generic observations
- Merge all same-day date groups into at most 2-3 date groups per day
- For older content, each topic or task should be at most 1-2 observations capturing the key outcome
- For recent content, retain more detail but still merge related items aggressively
- If multiple observations describe incremental progress on the same task, keep only the final state
- Preserve ✅ completion markers and their outcomes but merge related completions into fewer lines
- Preserve: user preferences, key decisions, architectural choices, and unresolved issues

Aim for a 2/10 detail level. Fewer, more generic observations are better than many specific ones that exceed the budget.
`
};
COMPRESSION_GUIDANCE[1];
/**
* Build the prompt for the Reflector agent
*/
function buildReflectorPrompt(observations, manualPrompt, compressionLevel, skipContinuationHints, extractors = [], priorExtractedValues) {
	const level = typeof compressionLevel === "number" ? compressionLevel : compressionLevel ? 1 : 0;
	let prompt = `## OBSERVATIONS TO REFLECT ON

${stripObservationGroups(observations)}

---

Please analyze these observations and produce a refined, condensed version that will become the assistant's entire memory going forward.`;
	if (manualPrompt) prompt += `

## SPECIFIC GUIDANCE

${manualPrompt}`;
	const guidance = COMPRESSION_GUIDANCE[level];
	if (guidance) prompt += `

${guidance}`;
	const priorLines = buildExtractorPriorLines(extractors, priorExtractedValues);
	if (priorLines.length > 0) prompt += `\n\n## Prior Extracted Values\n\n${priorLines.join("\n\n")}\n\nUse these as carry-forward hints, then update them only when the observations justify a change.`;
	const extractorSections = buildExtractorOutputSections(extractors);
	if (extractorSections) prompt += `\n\n## Additional Output Sections\n\n${extractorSections}`;
	if (skipContinuationHints) prompt += `\n\nOutput <observations> every time.`;
	return prompt;
}
/**
* Parse the Reflector's output to extract observations, current task, and suggested response.
* Uses XML tag parsing for structured extraction.
*/
function getStringExtractedValue(values, slug) {
	const value = values[slug];
	return typeof value === "string" && value.trim() ? value.trim() : void 0;
}
function parseReflectorOutput(output, sourceObservations, extractors = []) {
	if (detectDegenerateRepetition(output)) return {
		observations: "",
		degenerate: true
	};
	const inlineExtractors = extractors.filter((extractor) => extractor.mode === "inline");
	const parsedExtractedValues = parseExtractedValues(output, inlineExtractors);
	const parsed = parseReflectorSectionXml(stripExtractorSections(output, inlineExtractors));
	const sanitizedObservations = sanitizeObservationLines(stripEphemeralAnchorIds(parsed.observations || ""));
	return {
		observations: (sourceObservations ? reconcileObservationGroupsFromReflection(sanitizedObservations, sourceObservations) : null) ?? sanitizedObservations,
		suggestedContinuation: parsed.suggestedResponse || getStringExtractedValue(parsedExtractedValues.values, "suggested-response"),
		extractedValues: parsedExtractedValues.values,
		extractionFailures: parsedExtractedValues.failures
	};
}
/**
* Parse XML tags from reflector output.
* Extracts content from <observations>, <current-task>, and <suggested-response> tags.
*/
function parseReflectorSectionXml(content) {
	const result = {
		observations: "",
		currentTask: "",
		suggestedResponse: ""
	};
	const observationsMatches = [...content.matchAll(/^[ \t]*<observations>([\s\S]*?)^[ \t]*<\/observations>/gim)];
	if (observationsMatches.length > 0) result.observations = observationsMatches.map((m) => m[1]?.trim() ?? "").filter(Boolean).join("\n");
	else result.observations = extractReflectorListItems(content) || content.trim();
	const currentTaskMatch = content.match(/<current-task>([\s\S]*?)<\/current-task>/i);
	if (currentTaskMatch?.[1]) result.currentTask = currentTaskMatch[1].trim();
	const suggestedResponseMatch = content.match(/<suggested-response>([\s\S]*?)<\/suggested-response>/i);
	if (suggestedResponseMatch?.[1]) result.suggestedResponse = suggestedResponseMatch[1].trim();
	return result;
}
/**
* Fallback: Extract only list items from content when XML tags are missing.
*/
function extractReflectorListItems(content) {
	const lines = content.split("\n");
	const listLines = [];
	for (const line of lines) if (/^\s*[-*]\s/.test(line) || /^\s*\d+\.\s/.test(line)) listLines.push(line);
	return listLines.join("\n").trim();
}
/**
* Validate that reflection actually compressed the observations below the target threshold
*
* @param reflectedTokens - Token count of reflected observations
* @param targetThreshold - Target token count to compress below (the reflection threshold)
* @returns true if compression was successful (reflected tokens are below target)
*/
function validateCompression(reflectedTokens, targetThreshold) {
	return reflectedTokens < targetThreshold;
}
//#endregion
//#region src/processors/observational-memory/reflector-runner.ts
async function getThreadExtractedValues(storage, extractors, threadId) {
	if (!threadId) return;
	return getPriorExtractedValues(getThreadOMMetadata((await storage.getThreadById({ threadId }))?.metadata), extractors);
}
async function persistThreadExtractedValues(storage, extractors, threadId, values) {
	if (!threadId || !values) return;
	const metadataUpdate = buildThreadMetadataFromExtractedValues(extractors, values);
	const thread = await storage.getThreadById({ threadId });
	if (!thread) return;
	const previousOmMetadata = getThreadOMMetadata(thread.metadata);
	const newMetadata = setThreadOMMetadata(thread.metadata, {
		currentTask: metadataUpdate.currentTask ?? previousOmMetadata?.currentTask,
		suggestedResponse: metadataUpdate.suggestedResponse ?? previousOmMetadata?.suggestedResponse,
		threadTitle: metadataUpdate.threadTitle ?? previousOmMetadata?.threadTitle,
		extracted: {
			...previousOmMetadata?.extracted ?? {},
			...metadataUpdate.extracted ?? {}
		}
	});
	await storage.updateThread({
		id: threadId,
		title: thread.title ?? "",
		metadata: newMetadata
	});
}
function formatModelContext$1(provider, modelId) {
	if (provider && modelId) return `${provider}/${modelId}`;
	return modelId;
}
function getCurrentModel$1(model) {
	return formatModelContext$1(model?.provider, model?.modelId);
}
function getLastModelFromMessageList(messageList) {
	const messages = messageList?.get.all.db();
	if (!messages) return void 0;
	for (let i = messages.length - 1; i >= 0; i--) {
		const message = messages[i];
		if (!message || message.role !== "assistant" || !message.content || typeof message.content === "string") continue;
		for (let j = message.content.parts.length - 1; j >= 0; j--) {
			const part = message.content.parts[j];
			if (part?.type === "step-start" && typeof part.model === "string" && part.model.length > 0) return part.model;
		}
		const metadata = message.content.metadata;
		const model = formatModelContext$1(metadata?.provider, metadata?.modelId);
		if (model) return model;
	}
}
async function withAbortCheck(fn, abortSignal) {
	if (abortSignal?.aborted) throw new Error("The operation was aborted.");
	const result = await fn();
	if (abortSignal?.aborted) throw new Error("The operation was aborted.");
	return result;
}
/**
* Minimum size of combined (buffered reflection + unreflected tail) expressed
* as a ratio of the regular threshold-activation target
* (reflectThreshold × (1 − bufferActivation)). Early TTL / provider-change
* triggers are suppressed if the post-activation size would fall below this
* floor — keeps early activations close to the system's tuned post-activation
* size while still letting them fire sooner than a threshold activation.
*/
const EARLY_ACTIVATION_SIZE_FLOOR_RATIO = .75;
/**
* Runs the Reflector agent for compressing observations.
* Handles synchronous reflection, async buffered reflection, and activation.
*/
var ReflectorRunner = class {
	reflectionConfig;
	observationConfig;
	tokenCounter;
	resolveModel;
	storage;
	scope;
	buffering;
	emitDebugEvent;
	persistMarkerToStorage;
	persistMarkerToMessage;
	getCompressionStartLevel;
	memory;
	mastra;
	constructor(opts) {
		this.reflectionConfig = opts.reflectionConfig;
		this.observationConfig = opts.observationConfig;
		this.tokenCounter = opts.tokenCounter;
		this.resolveModel = opts.resolveModel;
		this.storage = opts.storage;
		this.scope = opts.scope;
		this.buffering = opts.buffering;
		this.emitDebugEvent = opts.emitDebugEvent;
		this.persistMarkerToStorage = opts.persistMarkerToStorage;
		this.persistMarkerToMessage = opts.persistMarkerToMessage;
		this.getCompressionStartLevel = opts.getCompressionStartLevel;
		this.mastra = opts.mastra;
		this.memory = opts.memory;
	}
	__registerMastra(mastra) {
		this.mastra = mastra;
	}
	createAgent(model, memory, extractors = this.reflectionConfig.extractors) {
		const agent = new Agent({
			id: "observational-memory-reflector",
			name: "Reflector",
			instructions: buildReflectorSystemPrompt(this.reflectionConfig.instruction, extractors),
			model,
			...memory ? { memory } : {}
		});
		if (this.mastra) agent.__registerMastra(this.mastra);
		return agent;
	}
	getObservationMarkerConfig(record) {
		return {
			messageTokens: getMaxThreshold(this.observationConfig.messageTokens),
			observationTokens: getMaxThreshold(record ? this.getEffectiveReflectionTokens(record) : this.reflectionConfig.observationTokens),
			scope: this.scope,
			activateAfterIdle: this.reflectionConfig.activateAfterIdle
		};
	}
	/**
	* Resolve the effective reflection observationTokens for a record.
	* Only explicit per-record overrides (stored under `_overrides`) win;
	* the initial config snapshot is ignored so instance-level changes
	* still take effect for existing records.
	*/
	getEffectiveReflectionTokens(record) {
		const recordTokens = (record.config?._overrides)?.reflection?.observationTokens;
		if (recordTokens) return recordTokens;
		return this.reflectionConfig.observationTokens;
	}
	/**
	* Call the Reflector agent with escalating compression levels.
	*/
	async call(observations, manualPrompt, streamContext, observationTokensThreshold, abortSignal, skipContinuationHints, compressionStartLevel, requestContext, priorExtractedValues, observabilityContext, model, mainAgent, sendSignal) {
		const originalTokens = this.tokenCounter.countObservations(observations);
		const resolvedModel = model ? { model } : this.resolveModel(originalTokens);
		const activeExtractors = await resolveExtractors((skipContinuationHints ? this.reflectionConfig.extractors?.filter((extractor) => extractor.slug !== "current-task" && extractor.slug !== "suggested-response") : this.reflectionConfig.extractors) ?? [], {
			source: "reflector",
			threadId: streamContext?.threadId,
			resourceId: streamContext?.resourceId,
			mainAgent,
			memory: this.memory,
			requestContext
		});
		const temporaryMemory = activeExtractors.filter((extractor) => extractor.mode === "structured").length > 0 ? await createTemporaryOmMemoryContext("structured-reflector") : void 0;
		const agent = temporaryMemory ? this.createAgent(resolvedModel.model, temporaryMemory.memory, activeExtractors) : this.createAgent(resolvedModel.model, void 0, activeExtractors);
		const internalRequestContext = withOmInternalThreadId(requestContext, agent.id);
		const targetThreshold = observationTokensThreshold ?? getMaxThreshold(this.reflectionConfig.observationTokens);
		let totalUsage = {
			inputTokens: 0,
			outputTokens: 0,
			totalTokens: 0
		};
		let finalProviderMetadata;
		const startLevel = compressionStartLevel ?? 0;
		let currentLevel = startLevel;
		const maxLevel = Math.min(4, startLevel + 3);
		let parsed = {
			observations: "",
			suggestedContinuation: void 0
		};
		let reflectedTokens = 0;
		let attemptNumber = 0;
		while (currentLevel <= maxLevel) {
			attemptNumber++;
			const isRetry = attemptNumber > 1;
			const prompt = buildReflectorPrompt(observations, manualPrompt, currentLevel, skipContinuationHints, activeExtractors, priorExtractedValues);
			omDebug(`[OM:callReflector] ${isRetry ? `retry #${attemptNumber - 1}` : "first attempt"}: level=${currentLevel}, originalTokens=${originalTokens}, targetThreshold=${targetThreshold}, promptLen=${prompt.length}, skipContinuationHints=${skipContinuationHints}`);
			let chunkCount = 0;
			const result = await withRetry(() => withOmTracingSpan({
				phase: "reflector",
				model: resolvedModel.model,
				inputTokens: originalTokens,
				requestContext,
				observabilityContext,
				metadata: {
					omCompressionLevel: currentLevel,
					omCompressionAttempt: attemptNumber,
					omTargetThreshold: targetThreshold,
					omSkipContinuationHints: skipContinuationHints ?? false,
					...resolvedModel.selectedThreshold !== void 0 ? { omSelectedThreshold: resolvedModel.selectedThreshold } : {},
					...resolvedModel.routingStrategy ? { omRoutingStrategy: resolvedModel.routingStrategy } : {},
					...resolvedModel.routingThresholds ? { omRoutingThresholds: resolvedModel.routingThresholds } : {}
				},
				callback: (childObservabilityContext) => withAbortCheck(async () => {
					chunkCount = 0;
					return (await agent.stream(prompt, {
						modelSettings: { ...this.reflectionConfig.modelSettings },
						providerOptions: this.reflectionConfig.providerOptions,
						...temporaryMemory ? { memory: temporaryMemory.options } : {},
						...abortSignal ? { abortSignal } : {},
						...internalRequestContext ? { requestContext: internalRequestContext } : {},
						...childObservabilityContext,
						...attemptNumber === 1 ? {
							onChunk(chunk) {
								chunkCount++;
								if (chunkCount === 1 || chunkCount % 50 === 0) {
									const preview = chunk.type === "text-delta" ? ` text="${chunk.textDelta?.slice(0, 80)}..."` : chunk.type === "tool-call" ? ` tool=${chunk.toolName}` : "";
									omDebug(`[OM:callReflector] chunk#${chunkCount}: type=${chunk.type}${preview}`);
								}
							},
							onFinish(event) {
								omDebug(`[OM:callReflector] onFinish: chunks=${chunkCount}, finishReason=${event.finishReason}, inputTokens=${event.usage?.inputTokens}, outputTokens=${event.usage?.outputTokens}, textLen=${event.text?.length}`);
							},
							onAbort(event) {
								omDebug(`[OM:callReflector] onAbort: chunks=${chunkCount}, reason=${event?.reason ?? "unknown"}`);
							},
							onError({ error }) {
								omError(`[OM:callReflector] onError after ${chunkCount} chunks`, error);
							}
						} : {}
					})).getFullOutput();
				}, abortSignal)
			}), {
				label: "reflector",
				abortSignal
			});
			omDebug(`[OM:callReflector] attempt #${attemptNumber} returned: textLen=${result.text?.length}, textPreview="${result.text?.slice(0, 120)}...", inputTokens=${result.usage?.inputTokens ?? result.totalUsage?.inputTokens}, outputTokens=${result.usage?.outputTokens ?? result.totalUsage?.outputTokens}`);
			const usage = result.totalUsage ?? result.usage;
			if (usage) {
				totalUsage.inputTokens += usage.inputTokens ?? 0;
				totalUsage.outputTokens += usage.outputTokens ?? 0;
				totalUsage.totalTokens += usage.totalTokens ?? 0;
			}
			finalProviderMetadata = result.providerMetadata ?? finalProviderMetadata;
			parsed = parseReflectorOutput(result.text, observations, activeExtractors);
			if (parsed.degenerate) {
				omDebug(`[OM:callReflector] attempt #${attemptNumber}: degenerate repetition detected, treating as compression failure`);
				reflectedTokens = originalTokens;
			} else reflectedTokens = this.tokenCounter.countObservations(parsed.observations);
			omDebug(`[OM:callReflector] attempt #${attemptNumber} parsed: reflectedTokens=${reflectedTokens}, targetThreshold=${targetThreshold}, compressionValid=${validateCompression(reflectedTokens, targetThreshold)}, parsedObsLen=${parsed.observations?.length}, degenerate=${parsed.degenerate ?? false}`);
			if (!parsed.degenerate && (validateCompression(reflectedTokens, targetThreshold) || currentLevel >= maxLevel)) break;
			if (parsed.degenerate && currentLevel >= maxLevel) {
				omDebug(`[OM:callReflector] degenerate output persists at maxLevel=${maxLevel}, breaking`);
				break;
			}
			if (streamContext?.writer) {
				const failedMarker = createObservationFailedMarker({
					cycleId: streamContext.cycleId,
					operationType: "reflection",
					startedAt: streamContext.startedAt,
					tokensAttempted: originalTokens,
					error: `Did not compress below threshold (${originalTokens} → ${reflectedTokens}, target: ${targetThreshold}), retrying at level ${currentLevel + 1}`,
					recordId: streamContext.recordId,
					threadId: streamContext.threadId
				});
				await streamContext.writer.custom({
					...failedMarker,
					transient: true
				}).catch(() => {});
				await this.persistMarkerToStorage(failedMarker, streamContext.threadId, streamContext.resourceId);
				const retryCycleId = crypto.randomUUID();
				streamContext.cycleId = retryCycleId;
				const startMarker = createObservationStartMarker({
					cycleId: retryCycleId,
					operationType: "reflection",
					tokensToObserve: originalTokens,
					recordId: streamContext.recordId,
					threadId: streamContext.threadId,
					threadIds: [streamContext.threadId],
					config: this.getObservationMarkerConfig()
				});
				streamContext.startedAt = startMarker.data.startedAt;
				await streamContext.writer.custom({
					...startMarker,
					transient: true
				}).catch(() => {});
				await this.persistMarkerToStorage(startMarker, streamContext.threadId, streamContext.resourceId);
			}
			currentLevel = Math.min(currentLevel + 1, maxLevel);
		}
		const structuredExtraction = await extractStructuredValues({
			agent,
			source: "reflector",
			extractors: activeExtractors,
			memory: temporaryMemory?.options,
			priorExtractedValues,
			requestContext: internalRequestContext,
			observabilityContext,
			abortSignal
		});
		const hookedValues = await applyExtractorHooks({
			source: "reflector",
			extractors: activeExtractors,
			values: mergeExtractedValues(parsed.extractedValues, structuredExtraction.values),
			failures: mergeExtractionFailures(parsed.extractionFailures, structuredExtraction.failures),
			previousValues: priorExtractedValues,
			threadId: streamContext?.threadId ?? "unknown",
			resourceId: streamContext?.resourceId,
			mainAgent,
			memory: this.memory,
			sendSignal,
			requestContext
		});
		const extractedValues = hookedValues.values;
		const extractionFailures = hookedValues.failures;
		const builtIns = getBuiltInExtractedValues(extractedValues);
		return {
			observations: parsed.observations,
			suggestedContinuation: builtIns.suggestedContinuation ?? parsed.suggestedContinuation,
			extractedValues,
			extractionFailures,
			usage: totalUsage.totalTokens > 0 ? totalUsage : void 0,
			providerMetadata: finalProviderMetadata
		};
	}
	/**
	* Start an async buffered reflection in the background.
	*/
	startAsyncBufferedReflection(record, observationTokens, lockKey, writer, requestContext, observabilityContext, reflectionHooks, priorExtractedValues, mainAgent, sendSignal) {
		const bufferKey = this.buffering.getReflectionBufferKey(lockKey);
		if (this.buffering.isAsyncBufferingInProgress(bufferKey)) return;
		BufferingCoordinator.lastBufferedBoundary.set(bufferKey, observationTokens);
		registerOp(record.id, "bufferingReflection");
		this.storage.setBufferingReflectionFlag(record.id, true).catch((err) => {
			omError("[OM] Failed to set buffering reflection flag", err);
		});
		reflectionHooks?.onReflectionStart?.();
		const asyncOp = this.doAsyncBufferedReflection(record, bufferKey, writer, requestContext, observabilityContext, priorExtractedValues, mainAgent, sendSignal).then((outcome) => {
			try {
				reflectionHooks?.onReflectionEnd?.({
					usage: outcome?.usage,
					...outcome?.providerMetadata ? { providerMetadata: outcome.providerMetadata } : {}
				});
			} catch (hookError) {
				omError("[OM] onReflectionEnd hook failed after async buffered reflection", hookError);
			}
		}, async (error) => {
			if (writer) try {
				const failedMarker = createBufferingFailedMarker({
					cycleId: `reflect-buf-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`,
					operationType: "reflection",
					startedAt: (/* @__PURE__ */ new Date()).toISOString(),
					tokensAttempted: observationTokens,
					error: error instanceof Error ? error.message : String(error),
					recordId: record.id,
					threadId: record.threadId ?? ""
				});
				writer.custom({
					...failedMarker,
					transient: true
				}).catch(() => {});
				await this.persistMarkerToStorage(failedMarker, record.threadId ?? "", record.resourceId ?? void 0);
			} catch (markerError) {
				omError("[OM] Failed to persist buffering-failed marker after async buffered reflection failure", markerError);
			}
			omError("[OM] Async buffered reflection failed", error);
			try {
				reflectionHooks?.onReflectionEnd?.({
					usage: void 0,
					error: error instanceof Error ? error : new Error(String(error))
				});
			} catch (hookError) {
				omError("[OM] onReflectionEnd hook failed after async buffered reflection failure", hookError);
			}
			BufferingCoordinator.lastBufferedBoundary.delete(bufferKey);
		}).finally(() => {
			BufferingCoordinator.asyncBufferingOps.delete(bufferKey);
			unregisterOp(record.id, "bufferingReflection");
			this.storage.setBufferingReflectionFlag(record.id, false).catch((err) => {
				omError("[OM] Failed to clear buffering reflection flag", err);
			});
		});
		BufferingCoordinator.asyncBufferingOps.set(bufferKey, asyncOp);
	}
	/**
	* Perform async buffered reflection — reflects observations and stores to bufferedReflection.
	* Does NOT create a new generation or update activeObservations.
	*/
	async doAsyncBufferedReflection(record, _bufferKey, writer, requestContext, observabilityContext, priorExtractedValues, mainAgent, sendSignal) {
		const currentRecord = await this.storage.getObservationalMemory(record.threadId, record.resourceId) ?? record;
		const observationTokens = currentRecord.observationTokenCount ?? 0;
		const reflectThreshold = getMaxThreshold(this.getEffectiveReflectionTokens(currentRecord));
		const bufferActivation = this.reflectionConfig.bufferActivation ?? .5;
		const startedAt = (/* @__PURE__ */ new Date()).toISOString();
		const cycleId = `reflect-buf-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
		BufferingCoordinator.reflectionBufferCycleIds.set(_bufferKey, cycleId);
		const allLines = (currentRecord.activeObservations ?? "").split("\n");
		const totalLines = allLines.length;
		const avgTokensPerLine = totalLines > 0 ? observationTokens / totalLines : 0;
		const activationPointTokens = reflectThreshold * bufferActivation;
		const linesToReflect = avgTokensPerLine > 0 ? Math.min(Math.floor(activationPointTokens / avgTokensPerLine), totalLines) : totalLines;
		const activeObservations = allLines.slice(0, linesToReflect).join("\n");
		const reflectedObservationLineCount = linesToReflect;
		const sliceTokenEstimate = Math.round(avgTokensPerLine * linesToReflect);
		const compressionTarget = Math.round(sliceTokenEstimate * .75);
		omDebug(`[OM:reflect] doAsyncBufferedReflection: slicing observations for reflection — totalLines=${totalLines}, avgTokPerLine=${avgTokensPerLine.toFixed(1)}, activationPointTokens=${activationPointTokens}, linesToReflect=${linesToReflect}/${totalLines}, sliceTokenEstimate=${sliceTokenEstimate}, compressionTarget=${compressionTarget}`);
		omDebug(`[OM:reflect] doAsyncBufferedReflection: starting reflector call, recordId=${currentRecord.id}, observationTokens=${sliceTokenEstimate}, compressionTarget=${compressionTarget} (inputTokens), activeObsLength=${activeObservations.length}, reflectedLineCount=${reflectedObservationLineCount}`);
		if (writer) {
			const startMarker = createBufferingStartMarker({
				cycleId,
				operationType: "reflection",
				tokensToBuffer: sliceTokenEstimate,
				recordId: record.id,
				threadId: record.threadId ?? "",
				threadIds: record.threadId ? [record.threadId] : [],
				config: this.getObservationMarkerConfig(currentRecord)
			});
			writer.custom({
				...startMarker,
				transient: true
			}).catch(() => {});
			await this.persistMarkerToStorage(startMarker, currentRecord.threadId ?? "", currentRecord.resourceId ?? void 0);
		}
		const compressionStartLevel = await this.getCompressionStartLevel(requestContext);
		const reflectResult = await this.call(activeObservations, void 0, void 0, compressionTarget, void 0, true, compressionStartLevel, requestContext, priorExtractedValues, observabilityContext, void 0, mainAgent, sendSignal);
		await persistThreadExtractedValues(this.storage, this.reflectionConfig.extractors, currentRecord.threadId ?? void 0, reflectResult.extractedValues);
		const reflectionTokenCount = this.tokenCounter.countObservations(reflectResult.observations);
		omDebug(`[OM:reflect] doAsyncBufferedReflection: reflector returned ${reflectionTokenCount} tokens (${reflectResult.observations?.length} chars), saving to recordId=${currentRecord.id}`);
		await this.storage.updateBufferedReflection({
			id: currentRecord.id,
			reflection: reflectResult.observations,
			tokenCount: reflectionTokenCount,
			inputTokenCount: sliceTokenEstimate,
			reflectedObservationLineCount
		});
		omDebug(`[OM:reflect] doAsyncBufferedReflection: bufferedReflection saved with lineCount=${reflectedObservationLineCount}`);
		if (writer) {
			const endMarker = createBufferingEndMarker({
				cycleId,
				operationType: "reflection",
				startedAt,
				tokensBuffered: sliceTokenEstimate,
				bufferedTokens: reflectionTokenCount,
				recordId: currentRecord.id,
				threadId: currentRecord.threadId ?? "",
				observations: reflectResult.observations,
				extractedValues: reflectResult.extractedValues,
				extractionFailures: reflectResult.extractionFailures
			});
			writer.custom({
				...endMarker,
				transient: true
			}).catch(() => {});
			await this.persistMarkerToStorage(endMarker, currentRecord.threadId ?? "", currentRecord.resourceId ?? void 0);
		}
		return {
			usage: reflectResult.usage,
			providerMetadata: reflectResult.providerMetadata
		};
	}
	/**
	* Try to activate buffered reflection when threshold is reached.
	* Returns a discriminated result so the caller can distinguish between
	* "activated", "no buffer present", and "suppressed by overshoot guard"
	* without re-deriving that state.
	*/
	async tryActivateBufferedReflection(record, lockKey, writer, messageList, activationMetadata) {
		const bufferKey = this.buffering.getReflectionBufferKey(lockKey);
		const asyncOp = BufferingCoordinator.asyncBufferingOps.get(bufferKey);
		if (asyncOp) if (activationMetadata?.triggeredBy === "ttl" || activationMetadata?.triggeredBy === "provider_change") omDebug(`[OM:reflect] tryActivateBufferedReflection: async op in progress, not blocking for ${activationMetadata.triggeredBy} trigger`);
		else {
			omDebug(`[OM:reflect] tryActivateBufferedReflection: waiting for in-progress op...`);
			try {
				await Promise.race([asyncOp, new Promise((_, reject) => setTimeout(() => reject(/* @__PURE__ */ new Error("Timeout")), 5e3))]);
			} catch {}
		}
		const freshRecord = await this.storage.getObservationalMemory(record.threadId, record.resourceId);
		omDebug(`[OM:reflect] tryActivateBufferedReflection: recordId=${record.id}, hasBufferedReflection=${!!freshRecord?.bufferedReflection}, bufferedReflectionLen=${freshRecord?.bufferedReflection?.length ?? 0}`);
		omDebug(`[OM:reflect] tryActivateBufferedReflection: freshRecord.id=${freshRecord?.id}, freshBufferedReflection=${freshRecord?.bufferedReflection ? "present (" + freshRecord.bufferedReflection.length + " chars)" : "empty"}, freshObsTokens=${freshRecord?.observationTokenCount}`);
		if (!freshRecord?.bufferedReflection) {
			omDebug(`[OM:reflect] tryActivateBufferedReflection: no buffered reflection after re-fetch`);
			return { status: "no-buffer" };
		}
		const beforeTokens = freshRecord.observationTokenCount ?? 0;
		const reflectedLineCount = freshRecord.reflectedObservationLineCount ?? 0;
		const unreflectedLines = (freshRecord.activeObservations ?? "").split("\n").slice(reflectedLineCount);
		const unreflectedContent = unreflectedLines.join("\n").trim();
		const combinedObservations = unreflectedContent ? `${freshRecord.bufferedReflection}\n\n${unreflectedContent}` : freshRecord.bufferedReflection;
		const combinedTokenCount = this.tokenCounter.countObservations(combinedObservations);
		if (activationMetadata?.triggeredBy === "ttl" || activationMetadata?.triggeredBy === "provider_change") {
			const unreflectedTailTokens = unreflectedContent ? this.tokenCounter.countObservations(unreflectedContent) : 0;
			const bufferedReflectionTokens = freshRecord.bufferedReflectionTokens ?? 0;
			if (unreflectedTailTokens < bufferedReflectionTokens) {
				omDebug(`[OM:reflect] tryActivateBufferedReflection: suppressing early ${activationMetadata.triggeredBy} activation — unreflectedTailTokens=${unreflectedTailTokens} < bufferedReflectionTokens=${bufferedReflectionTokens}; keeping buffer for threshold activation`);
				return {
					status: "suppressed",
					reason: "composition"
				};
			}
			const bufferActivation = this.reflectionConfig.bufferActivation;
			const reflectThreshold = getMaxThreshold(this.getEffectiveReflectionTokens(freshRecord));
			const regularActivationTarget = reflectThreshold * (1 - bufferActivation);
			const minCombinedTokens = Math.round(regularActivationTarget * EARLY_ACTIVATION_SIZE_FLOOR_RATIO);
			if (combinedTokenCount < minCombinedTokens) {
				omDebug(`[OM:reflect] tryActivateBufferedReflection: suppressing early ${activationMetadata.triggeredBy} activation — combinedTokenCount=${combinedTokenCount} < minCombinedTokens=${minCombinedTokens} (${EARLY_ACTIVATION_SIZE_FLOOR_RATIO * 100}% of regular activation target ${Math.round(regularActivationTarget)}, threshold=${reflectThreshold}, bufferActivation=${bufferActivation}); keeping buffer for threshold activation`);
				return {
					status: "suppressed",
					reason: "size"
				};
			}
		}
		omDebug(`[OM:reflect] tryActivateBufferedReflection: activating, beforeTokens=${beforeTokens}, combinedTokenCount=${combinedTokenCount}, reflectedLineCount=${reflectedLineCount}, unreflectedLines=${unreflectedLines.length}`);
		await this.storage.swapBufferedReflectionToActive({
			currentRecord: freshRecord,
			tokenCount: combinedTokenCount
		});
		BufferingCoordinator.lastBufferedBoundary.delete(bufferKey);
		const afterRecord = await this.storage.getObservationalMemory(record.threadId, record.resourceId);
		const afterTokens = afterRecord?.observationTokenCount ?? 0;
		omDebug(`[OM:reflect] tryActivateBufferedReflection: activation complete! beforeTokens=${beforeTokens}, afterTokens=${afterTokens}, newRecordId=${afterRecord?.id}, newGenCount=${afterRecord?.generationCount}`);
		if (writer) {
			const activationMarker = createActivationMarker({
				cycleId: BufferingCoordinator.reflectionBufferCycleIds.get(bufferKey) ?? `reflect-act-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`,
				operationType: "reflection",
				chunksActivated: 1,
				tokensActivated: beforeTokens,
				observationTokens: afterTokens,
				messagesActivated: 0,
				recordId: freshRecord.id,
				threadId: freshRecord.threadId ?? "",
				generationCount: afterRecord?.generationCount ?? freshRecord.generationCount ?? 0,
				observations: afterRecord?.activeObservations,
				triggeredBy: activationMetadata?.triggeredBy,
				lastActivityAt: activationMetadata?.lastActivityAt,
				ttlExpiredMs: activationMetadata?.ttlExpiredMs,
				previousModel: activationMetadata?.previousModel,
				currentModel: activationMetadata?.currentModel,
				config: {
					...this.getObservationMarkerConfig(freshRecord),
					activateAfterIdle: activationMetadata?.activateAfterIdle ?? this.reflectionConfig.activateAfterIdle
				}
			});
			writer.custom({
				...activationMarker,
				transient: true
			}).catch(() => {});
			await this.persistMarkerToMessage(activationMarker, messageList, freshRecord.threadId ?? "", freshRecord.resourceId ?? void 0);
		}
		BufferingCoordinator.reflectionBufferCycleIds.delete(bufferKey);
		return { status: "activated" };
	}
	/**
	* Check if reflection needed and trigger if so.
	* Supports both synchronous reflection and async buffered reflection.
	* @internal Used by observation strategies. Do not call directly.
	*/
	async maybeReflect(opts) {
		const { record, observationTokens, writer, abortSignal, mainAgent, sendSignal, messageList, currentModel, reflectionHooks, requestContext, observabilityContext, lastActivityAt, threadId: requestedThreadId } = opts;
		const lockKey = this.buffering.getLockKey(record.threadId, record.resourceId);
		const reflectThreshold = getMaxThreshold(this.getEffectiveReflectionTokens(record));
		const priorExtractedValues = await getThreadExtractedValues(this.storage, this.reflectionConfig.extractors, requestedThreadId ?? record.threadId);
		if (this.buffering.isAsyncReflectionEnabled() && observationTokens < reflectThreshold) {
			if ((() => {
				if (!this.buffering.isAsyncReflectionEnabled()) return false;
				if (record.isBufferingReflection) {
					if (isOpActiveInProcess(record.id, "bufferingReflection")) return false;
					omDebug(`[OM:shouldTriggerAsyncRefl] isBufferingReflection=true but stale, clearing`);
					this.storage.setBufferingReflectionFlag(record.id, false).catch(() => {});
				}
				const bufferKey = this.buffering.getReflectionBufferKey(lockKey);
				if (this.buffering.isAsyncBufferingInProgress(bufferKey)) return false;
				if (BufferingCoordinator.lastBufferedBoundary.has(bufferKey)) return false;
				if (record.bufferedReflection) return false;
				const activationPoint = reflectThreshold * this.reflectionConfig.bufferActivation;
				return observationTokens >= activationPoint;
			})()) this.startAsyncBufferedReflection(record, observationTokens, lockKey, writer, requestContext, observabilityContext, reflectionHooks, priorExtractedValues, mainAgent, sendSignal);
		}
		const activateAfterIdle = resolveActivationTTL(this.reflectionConfig.activateAfterIdle, currentModel);
		const ttlExpiredMs = activateAfterIdle !== void 0 && lastActivityAt !== void 0 ? Date.now() - lastActivityAt : void 0;
		const ttlExpired = ttlExpiredMs !== void 0 && activateAfterIdle !== void 0 && ttlExpiredMs >= activateAfterIdle;
		const actorModel = getCurrentModel$1(currentModel);
		const lastModel = getLastModelFromMessageList(messageList);
		const providerChanged = this.reflectionConfig.activateOnProviderChange === true && didProviderChange(actorModel, lastModel);
		if (observationTokens < reflectThreshold && !ttlExpired && !providerChanged) return;
		const activationTriggeredBy = observationTokens >= reflectThreshold ? "threshold" : providerChanged ? "provider_change" : "ttl";
		const activationMetadata = {
			triggeredBy: activationTriggeredBy,
			lastActivityAt: activationTriggeredBy === "ttl" ? lastActivityAt : void 0,
			activateAfterIdle: activationTriggeredBy === "ttl" ? activateAfterIdle : void 0,
			ttlExpiredMs: activationTriggeredBy === "ttl" ? ttlExpiredMs : void 0,
			previousModel: activationTriggeredBy === "provider_change" ? lastModel : void 0,
			currentModel: activationTriggeredBy === "provider_change" ? actorModel : void 0
		};
		if (record.isReflecting) {
			if (isOpActiveInProcess(record.id, "reflecting")) {
				omDebug(`[OM:reflect] isReflecting=true and active in this process, skipping`);
				return;
			}
			omDebug(`[OM:reflect] isReflecting=true but NOT active in this process — stale flag from dead process, clearing`);
			await this.storage.setReflectingFlag(record.id, false);
		}
		if (this.buffering.isAsyncReflectionEnabled()) {
			const activationResult = await this.tryActivateBufferedReflection(record, lockKey, writer, messageList, activationMetadata);
			if (activationResult.status === "activated") return;
			if (activationResult.status === "suppressed") {
				omDebug(`[OM:reflect] skipping sync fallback / re-buffer after suppressed early ${activationMetadata.triggeredBy} activation (reason=${activationResult.reason})`);
				return;
			}
			if (this.reflectionConfig.blockAfter && observationTokens >= this.reflectionConfig.blockAfter) omDebug(`[OM:reflect] blockAfter exceeded (${observationTokens} >= ${this.reflectionConfig.blockAfter}), falling through to sync reflection`);
			else {
				const activationPoint = reflectThreshold * this.reflectionConfig.bufferActivation;
				if (observationTokens < activationPoint) {
					omDebug(`[OM:reflect] skipping async reflection — observationTokens (${observationTokens}) below activation point (${activationPoint}), triggered by ${activationTriggeredBy}`);
					return;
				}
				omDebug(`[OM:reflect] async activation failed, no blockAfter or below it (obsTokens=${observationTokens}, blockAfter=${this.reflectionConfig.blockAfter}) — starting background reflection`);
				this.startAsyncBufferedReflection(record, observationTokens, lockKey, writer, requestContext, observabilityContext, reflectionHooks, priorExtractedValues, mainAgent, sendSignal);
				return;
			}
		}
		await this.storage.setReflectingFlag(record.id, true);
		registerOp(record.id, "reflecting");
		const cycleId = crypto.randomUUID();
		const startedAt = (/* @__PURE__ */ new Date()).toISOString();
		const threadId = requestedThreadId ?? "unknown";
		if (writer) {
			const startMarker = createObservationStartMarker({
				cycleId,
				operationType: "reflection",
				tokensToObserve: observationTokens,
				recordId: record.id,
				threadId,
				threadIds: [threadId],
				config: this.getObservationMarkerConfig(record)
			});
			await writer.custom({
				...startMarker,
				transient: true
			}).catch(() => {});
			await this.persistMarkerToStorage(startMarker, threadId, record.resourceId ?? void 0);
		}
		this.emitDebugEvent({
			type: "reflection_triggered",
			timestamp: /* @__PURE__ */ new Date(),
			threadId,
			resourceId: record.resourceId ?? "",
			inputTokens: observationTokens,
			activeObservationsLength: record.activeObservations?.length ?? 0
		});
		const streamContext = writer ? {
			writer,
			cycleId,
			startedAt,
			recordId: record.id,
			threadId,
			resourceId: record.resourceId ?? void 0
		} : void 0;
		let reflectionUsage;
		let reflectionProviderMetadata;
		let reflectionError;
		reflectionHooks?.onReflectionStart?.();
		try {
			const compressionStartLevel = await this.getCompressionStartLevel(requestContext);
			const reflectResult = await this.call(record.activeObservations, void 0, streamContext, reflectThreshold, abortSignal, void 0, compressionStartLevel, requestContext, priorExtractedValues, observabilityContext, void 0, mainAgent, sendSignal);
			reflectionUsage = reflectResult.usage;
			reflectionProviderMetadata = reflectResult.providerMetadata;
			await persistThreadExtractedValues(this.storage, this.reflectionConfig.extractors, record.threadId ?? void 0, reflectResult.extractedValues);
			const reflectionTokenCount = this.tokenCounter.countObservations(reflectResult.observations);
			await this.storage.createReflectionGeneration({
				currentRecord: record,
				reflection: reflectResult.observations,
				tokenCount: reflectionTokenCount
			});
			if (writer && streamContext) {
				const endMarker = createObservationEndMarker({
					cycleId: streamContext.cycleId,
					operationType: "reflection",
					startedAt: streamContext.startedAt,
					tokensObserved: observationTokens,
					observationTokens: reflectionTokenCount,
					observations: reflectResult.observations,
					extractedValues: reflectResult.extractedValues,
					extractionFailures: reflectResult.extractionFailures,
					recordId: record.id,
					threadId
				});
				await writer.custom({
					...endMarker,
					transient: true
				}).catch(() => {});
				await this.persistMarkerToStorage(endMarker, threadId, record.resourceId ?? void 0);
			}
			this.emitDebugEvent({
				type: "reflection_complete",
				timestamp: /* @__PURE__ */ new Date(),
				threadId,
				resourceId: record.resourceId ?? "",
				inputTokens: observationTokens,
				outputTokens: reflectionTokenCount,
				observations: reflectResult.observations,
				usage: reflectResult.usage
			});
		} catch (error) {
			if (writer && streamContext) {
				const failedMarker = createObservationFailedMarker({
					cycleId: streamContext.cycleId,
					operationType: "reflection",
					startedAt: streamContext.startedAt,
					tokensAttempted: observationTokens,
					error: error instanceof Error ? error.message : String(error),
					recordId: record.id,
					threadId
				});
				await writer.custom({
					...failedMarker,
					transient: true
				}).catch(() => {});
				await this.persistMarkerToStorage(failedMarker, threadId, record.resourceId ?? void 0);
			}
			reflectionError = error instanceof Error ? error : new Error(String(error));
			if (abortSignal?.aborted) throw error;
			omError("[OM] Reflection failed", error);
		} finally {
			await this.storage.setReflectingFlag(record.id, false);
			try {
				reflectionHooks?.onReflectionEnd?.({
					usage: reflectionUsage,
					error: reflectionError,
					...reflectionProviderMetadata ? { providerMetadata: reflectionProviderMetadata } : {}
				});
			} finally {
				unregisterOp(record.id, "reflecting");
			}
		}
	}
};
//#endregion
//#region src/processors/observational-memory/repro-capture.ts
function getOmReproCaptureDir() {
	return process.env.OM_REPRO_CAPTURE_DIR ?? ".mastra-om-repro";
}
function sanitizeCapturePathSegment(value) {
	const sanitized = value.replace(/[\\/]+/g, "_").replace(/\.{2,}/g, "_").trim();
	return sanitized.length > 0 ? sanitized : "unknown-thread";
}
function isOmReproCaptureEnabled() {
	return process.env.OM_REPRO_CAPTURE === "1";
}
function safeCaptureJson(value) {
	return JSON.parse(JSON.stringify(value, (_key, current) => {
		if (typeof current === "bigint") return current.toString();
		if (typeof current === "function") return "[function]";
		if (typeof current === "symbol") return current.toString();
		if (current instanceof Error) return {
			name: current.name,
			message: current.message,
			stack: current.stack
		};
		if (current instanceof Set) return {
			__type: "Set",
			values: Array.from(current.values())
		};
		if (current instanceof Map) return {
			__type: "Map",
			entries: Array.from(current.entries())
		};
		return current;
	}));
}
function safeCaptureJsonOrError(value) {
	try {
		return {
			ok: true,
			value: safeCaptureJson(value)
		};
	} catch (error) {
		return {
			ok: false,
			error: safeCaptureJson({
				message: error instanceof Error ? error.message : String(error),
				stack: error instanceof Error ? error.stack : void 0,
				inspected: inspect(value, {
					depth: 3,
					maxArrayLength: 20,
					breakLength: 120
				})
			})
		};
	}
}
function formatCaptureDate(value) {
	if (!value) return void 0;
	if (value instanceof Date) return value.toISOString();
	try {
		return new Date(value).toISOString();
	} catch {
		return;
	}
}
function summarizeOmTurn(value) {
	if (!value || typeof value !== "object") return value;
	const turn = value;
	return {
		__type: "ObservationTurn",
		threadId: turn.threadId,
		resourceId: turn.resourceId,
		started: turn._started,
		ended: turn._ended,
		generationCountAtStart: turn._generationCountAtStart,
		record: turn._record ? {
			id: turn._record.id,
			scope: turn._record.scope,
			threadId: turn._record.threadId,
			resourceId: turn._record.resourceId,
			createdAt: formatCaptureDate(turn._record.createdAt),
			updatedAt: formatCaptureDate(turn._record.updatedAt),
			lastObservedAt: formatCaptureDate(turn._record.lastObservedAt),
			generationCount: turn._record.generationCount,
			observationTokenCount: turn._record.observationTokenCount,
			pendingMessageTokens: turn._record.pendingMessageTokens,
			isBufferingObservation: turn._record.isBufferingObservation,
			isBufferingReflection: turn._record.isBufferingReflection
		} : void 0,
		context: turn._context ? {
			messageCount: Array.isArray(turn._context.messages) ? turn._context.messages.length : void 0,
			hasSystemMessage: Array.isArray(turn._context.systemMessage) ? turn._context.systemMessage.length > 0 : Boolean(turn._context.systemMessage),
			continuationId: turn._context.continuation?.id,
			hasOtherThreadsContext: Boolean(turn._context.otherThreadsContext),
			recordId: turn._context.record?.id
		} : void 0,
		currentStep: turn._currentStep ? {
			stepNumber: turn._currentStep.stepNumber,
			prepared: turn._currentStep._prepared,
			context: turn._currentStep._context ? {
				activated: turn._currentStep._context.activated,
				observed: turn._currentStep._context.observed,
				buffered: turn._currentStep._context.buffered,
				reflected: turn._currentStep._context.reflected,
				didThresholdCleanup: turn._currentStep._context.didThresholdCleanup,
				messageCount: Array.isArray(turn._currentStep._context.messages) ? turn._currentStep._context.messages.length : void 0,
				systemMessageCount: Array.isArray(turn._currentStep._context.systemMessage) ? turn._currentStep._context.systemMessage.length : void 0
			} : void 0
		} : void 0
	};
}
function sanitizeCaptureState(rawState) {
	return Object.fromEntries(Object.entries(rawState).map(([key, value]) => {
		if (key === "__omTurn") return [key, summarizeOmTurn(value)];
		return [key, value];
	}));
}
function buildReproMessageFingerprint(message) {
	const createdAt = message.createdAt instanceof Date ? message.createdAt.toISOString() : message.createdAt ? new Date(message.createdAt).toISOString() : "";
	return JSON.stringify({
		role: message.role,
		createdAt,
		content: message.content
	});
}
function inferReproIdRemap(preMessages, postMessages) {
	const preByFingerprint = /* @__PURE__ */ new Map();
	const postByFingerprint = /* @__PURE__ */ new Map();
	for (const message of preMessages) {
		if (!message.id) continue;
		const fingerprint = buildReproMessageFingerprint(message);
		const list = preByFingerprint.get(fingerprint) ?? [];
		list.push(message.id);
		preByFingerprint.set(fingerprint, list);
	}
	for (const message of postMessages) {
		if (!message.id) continue;
		const fingerprint = buildReproMessageFingerprint(message);
		const list = postByFingerprint.get(fingerprint) ?? [];
		list.push(message.id);
		postByFingerprint.set(fingerprint, list);
	}
	const remap = [];
	for (const [fingerprint, preIds] of preByFingerprint.entries()) {
		const postIds = postByFingerprint.get(fingerprint);
		if (!postIds || preIds.length !== 1 || postIds.length !== 1) continue;
		const fromId = preIds[0];
		const toId = postIds[0];
		if (!fromId || !toId || fromId === toId) continue;
		remap.push({
			fromId,
			toId,
			fingerprint
		});
	}
	return remap;
}
function createOmReproCaptureDir(threadId, label) {
	const sanitizedThreadId = sanitizeCapturePathSegment(threadId);
	const captureDir = join(process.cwd(), getOmReproCaptureDir(), sanitizedThreadId, `${Date.now()}-${label}-${randomUUID()}`);
	mkdirSync(captureDir, { recursive: true });
	return captureDir;
}
function writeObserverExchangeReproCapture(params) {
	if (!isOmReproCaptureEnabled() || !params.observerExchange) return;
	try {
		const captureDir = createOmReproCaptureDir(params.threadId, params.label);
		const payloads = [
			{
				fileName: "input.json",
				data: {
					threadId: params.threadId,
					resourceId: params.resourceId,
					label: params.label
				}
			},
			{
				fileName: "output.json",
				data: { details: params.details ?? {} }
			},
			{
				fileName: "observer-exchange.json",
				data: params.observerExchange
			}
		];
		const captureErrors = [];
		for (const payload of payloads) {
			const serialized = safeCaptureJsonOrError(payload.data);
			if (serialized.ok) {
				writeFileSync(join(captureDir, payload.fileName), `${JSON.stringify(serialized.value, null, 2)}\n`);
				continue;
			}
			captureErrors.push({
				fileName: payload.fileName,
				error: serialized.error
			});
			writeFileSync(join(captureDir, payload.fileName), `${JSON.stringify({ __captureError: serialized.error }, null, 2)}\n`);
		}
		if (captureErrors.length > 0) {
			writeFileSync(join(captureDir, "capture-error.json"), `${JSON.stringify(captureErrors, null, 2)}\n`);
			params.debug?.(`[OM:repro-capture] wrote ${params.label} capture with ${captureErrors.length} serialization error(s) to ${captureDir}`);
			return;
		}
		params.debug?.(`[OM:repro-capture] wrote ${params.label} capture to ${captureDir}`);
	} catch (error) {
		params.debug?.(`[OM:repro-capture] failed to write ${params.label} capture: ${String(error)}`);
	}
}
function writeProcessInputStepReproCapture(params) {
	if (!isOmReproCaptureEnabled()) return;
	try {
		const captureDir = createOmReproCaptureDir(params.threadId, `step-${params.stepNumber}`);
		const contextMessages = params.messageList.get.all.db();
		const memoryContext = parseMemoryRequestContext(params.args.requestContext);
		const preMessageIds = new Set(params.preMessages.map((message) => message.id));
		const postMessageIds = new Set(contextMessages.map((message) => message.id));
		const removedMessageIds = params.preMessages.map((message) => message.id).filter((id) => Boolean(id) && !postMessageIds.has(id));
		const addedMessageIds = contextMessages.map((message) => message.id).filter((id) => Boolean(id) && !preMessageIds.has(id));
		const idRemap = inferReproIdRemap(params.preMessages, contextMessages);
		const rawState = params.args.state ?? {};
		const sanitizedState = sanitizeCaptureState(rawState);
		const payloads = [
			{
				fileName: "input.json",
				data: {
					stepNumber: params.stepNumber,
					threadId: params.threadId,
					resourceId: params.resourceId,
					readOnly: memoryContext?.memoryConfig?.readOnly,
					messageCount: contextMessages.length,
					messageIds: contextMessages.map((message) => message.id),
					stateKeys: Object.keys(rawState),
					state: sanitizedState,
					args: {
						messages: params.args.messages,
						steps: params.args.steps,
						systemMessages: params.args.systemMessages,
						retryCount: params.args.retryCount,
						toolChoice: params.args.toolChoice,
						activeTools: params.args.activeTools,
						modelSettings: params.args.modelSettings,
						structuredOutput: params.args.structuredOutput
					}
				}
			},
			{
				fileName: "pre-state.json",
				data: {
					record: params.preRecord,
					bufferedChunks: params.preBufferedChunks,
					contextTokenCount: params.preContextTokenCount,
					messages: params.preMessages,
					messageList: params.preSerializedMessageList
				}
			},
			{
				fileName: "output.json",
				data: {
					details: params.details,
					messageDiff: {
						removedMessageIds,
						addedMessageIds,
						idRemap
					}
				}
			},
			{
				fileName: "post-state.json",
				data: {
					record: params.postRecord,
					bufferedChunks: params.postBufferedChunks,
					contextTokenCount: params.postContextTokenCount,
					messageCount: contextMessages.length,
					messageIds: contextMessages.map((message) => message.id),
					messages: contextMessages,
					messageList: params.messageList.serialize()
				}
			}
		];
		const captureErrors = [];
		for (const payload of payloads) {
			const serialized = safeCaptureJsonOrError(payload.data);
			if (serialized.ok) {
				writeFileSync(join(captureDir, payload.fileName), `${JSON.stringify(serialized.value, null, 2)}\n`);
				continue;
			}
			captureErrors.push({
				fileName: payload.fileName,
				error: serialized.error
			});
			writeFileSync(join(captureDir, payload.fileName), `${JSON.stringify({ __captureError: serialized.error }, null, 2)}\n`);
		}
		if (params.observerExchange) {
			const serialized = safeCaptureJsonOrError(params.observerExchange);
			if (serialized.ok) writeFileSync(join(captureDir, "observer-exchange.json"), `${JSON.stringify(serialized.value, null, 2)}\n`);
			else {
				captureErrors.push({
					fileName: "observer-exchange.json",
					error: serialized.error
				});
				writeFileSync(join(captureDir, "observer-exchange.json"), `${JSON.stringify({ __captureError: serialized.error }, null, 2)}\n`);
			}
		}
		if (captureErrors.length > 0) {
			writeFileSync(join(captureDir, "capture-error.json"), `${JSON.stringify(captureErrors, null, 2)}\n`);
			params.debug?.(`[OM:repro-capture] wrote processInputStep capture with ${captureErrors.length} serialization error(s) to ${captureDir}`);
			return;
		}
		params.debug?.(`[OM:repro-capture] wrote processInputStep capture to ${captureDir}`);
	} catch (error) {
		params.debug?.(`[OM:repro-capture] failed to write processInputStep capture: ${String(error)}`);
	}
}
//#endregion
//#region src/processors/observational-memory/observational-memory.ts
/**
* Returns the parts from the latest step of a message (after the last step-start marker).
* If no step-start marker exists, returns all parts.
*/
function getLatestStepParts(parts) {
	for (let i = parts.length - 1; i >= 0; i--) if (parts[i]?.type === "step-start") return parts.slice(i + 1);
	return parts;
}
/**
* Returns true when a message contains at least one part with visible user/assistant
* content (text, tool-invocation, reasoning, image, file).  Messages that only carry
* internal `data-*` parts (buffering markers, observation markers, etc.) return false.
*/
function messageHasVisibleContent(msg) {
	const content = msg.content;
	if (content?.parts && Array.isArray(content.parts)) return content.parts.some((p) => {
		const t = p?.type;
		return t && !t.startsWith("data-") && t !== "step-start";
	});
	if (content?.content) return true;
	return false;
}
/**
* Build a messageRange string from the first and last messages that have visible
* content.  Falls back to the full array boundaries when every message is data-only.
*/
function buildMessageRange(messages) {
	const first = messages.find(messageHasVisibleContent) ?? messages[0];
	const last = [...messages].reverse().find(messageHasVisibleContent) ?? messages[messages.length - 1];
	return `${first.id}:${last.id}`;
}
/**
* Returns the unix-ms timestamp of the last non-data part in the last assistant
* message, representing when the last visible LLM response completed. Used as the
* last activity time for activateAfterIdle checks.
*/
function getLastActivityFromMessages(messages) {
	if (!messages) return void 0;
	for (let i = messages.length - 1; i >= 0; i--) {
		const message = messages[i];
		if (!message || message.role !== "assistant") continue;
		if (!message.content || typeof message.content === "string") return message.createdAt ? new Date(message.createdAt).getTime() : void 0;
		for (let j = message.content.parts.length - 1; j >= 0; j--) {
			const part = message.content.parts[j];
			if (!part || part.type?.startsWith("data-")) continue;
			if (part.createdAt !== void 0) return part.createdAt;
		}
		return message.createdAt ? new Date(message.createdAt).getTime() : void 0;
	}
}
function formatModelContext(provider, modelId) {
	if (provider && modelId) return `${provider}/${modelId}`;
	return modelId;
}
function getLastModelFromMessages(messages) {
	if (!messages) return void 0;
	for (let i = messages.length - 1; i >= 0; i--) {
		const message = messages[i];
		if (!message || message.role !== "assistant" || !message.content || typeof message.content === "string") continue;
		for (let j = message.content.parts.length - 1; j >= 0; j--) {
			const part = message.content.parts[j];
			if (part?.type === "step-start" && typeof part.model === "string" && part.model.length > 0) return part.model;
		}
		const metadata = message.content.metadata;
		const model = formatModelContext(metadata?.provider, metadata?.modelId);
		if (model) return model;
	}
}
function getCurrentModel(model) {
	return formatModelContext(model?.provider, model?.modelId);
}
function parseActivationTTL(value, fieldPath) {
	if (value === void 0 || value === false) return;
	if (value === "auto") return value;
	if (typeof value === "number") {
		if (!Number.isFinite(value) || value < 0) throw new Error(`${fieldPath} must be a non-negative number of milliseconds or a duration string like "5m".`);
		return value;
	}
	const match = value.trim().match(/^(\d+(?:\.\d+)?)\s*(ms|msec|msecs|millisecond|milliseconds|s|sec|secs|second|seconds|m|min|mins|minute|minutes|h|hr|hrs|hour|hours)$/i);
	if (!match) throw new Error(`${fieldPath} must be a non-negative number of milliseconds or a duration string like "5m" or "1hr".`);
	const rawAmount = match[1];
	const rawUnit = match[2];
	const amount = Number(rawAmount);
	const unit = rawUnit.toLowerCase();
	if (!Number.isFinite(amount) || amount < 0) throw new Error(`${fieldPath} must be a non-negative number of milliseconds or a duration string like "5m".`);
	return amount * (unit === "ms" || unit === "msec" || unit === "msecs" || unit === "millisecond" || unit === "milliseconds" ? 1 : unit === "s" || unit === "sec" || unit === "secs" || unit === "second" || unit === "seconds" ? 1e3 : unit === "m" || unit === "min" || unit === "mins" || unit === "minute" || unit === "minutes" ? 6e4 : 36e5);
}
/**
* ObservationalMemory - A three-agent memory system for long conversations.
*
* This processor:
* 1. On input: Injects observations into context, filters out observed messages
* 2. On output: Tracks new messages, triggers Observer/Reflector when thresholds hit
*
* The Actor (main agent) sees:
* - Observations (compressed history)
* - Suggested continuation message
* - Recent unobserved messages
*
* @example
* ```ts
* import { ObservationalMemory } from '@mastra/memory/processors';
*
* // Minimal configuration
* const om = new ObservationalMemory({ storage });
*
* // Full configuration
* const om = new ObservationalMemory({
*   storage,
*   model: 'google/gemini-2.5-flash', // shared model for both agents
*   shareTokenBudget: true,
*   observation: {
*     messageTokens: 30_000,
*     modelSettings: { temperature: 0.3 },
*   },
*   reflection: {
*     observationTokens: 40_000,
*   },
* });
*
* const agent = new Agent({
*   inputProcessors: [om],
*   outputProcessors: [om],
* });
* ```
*/
var ObservationalMemory = class ObservationalMemory {
	storage;
	tokenCounter;
	scope;
	/** Whether retrieval-mode observation groups are enabled. */
	retrieval;
	/** Scope the recall tool was registered with — controls which retrieval instructions are injected. */
	retrievalScope;
	/** Application-provided guidance appended after the native retrieval instructions. */
	retrievalInstructions;
	retrievalSearch;
	observationConfig;
	reflectionConfig;
	onDebugEvent;
	onIndexObservations;
	/** Config-level lifecycle hooks fired for every observation/reflection cycle. */
	hooks;
	/** Observer agent runner — handles LLM calls for extracting observations. */
	observer;
	/** Reflector agent runner — handles LLM calls for compressing observations. */
	reflector;
	/** Buffering state coordinator — manages static maps and buffering lifecycle. */
	buffering;
	shouldObscureThreadIds = false;
	hasher = xxhash();
	mastra;
	memory;
	/**
	* Track message IDs observed during this instance's lifetime.
	* Prevents re-observing messages when per-thread lastObservedAt cursors
	* haven't fully advanced past messages observed in a prior cycle.
	* @internal Used by observation strategies. Do not call directly.
	*/
	observedMessageIds = /* @__PURE__ */ new Set();
	/** Internal MessageHistory for message persistence */
	messageHistory;
	/**
	* In-memory mutex for serializing observation/reflection cycles per resource/thread.
	* Prevents race conditions where two concurrent cycles could both read isObserving=false
	* before either sets it to true, leading to lost work.
	*
	* Key format: "resource:{resourceId}" or "thread:{threadId}"
	* Value: Promise that resolves when the lock is released
	*
	* NOTE: This mutex only works within a single Node.js process. For distributed
	* deployments, external locking (Redis, database locks) would be needed, or
	* accept eventual consistency (acceptable for v1).
	*/
	locks = /* @__PURE__ */ new Map();
	/**
	* Acquire a lock for the given key, execute the callback, then release.
	* If a lock is already held, waits for it to be released before acquiring.
	*/
	async withLock(key, fn) {
		const existingLock = this.locks.get(key);
		if (existingLock) await existingLock;
		let releaseLock;
		const lockPromise = new Promise((resolve) => {
			releaseLock = resolve;
		});
		this.locks.set(key, lockPromise);
		try {
			return await fn();
		} finally {
			releaseLock();
			if (this.locks.get(key) === lockPromise) this.locks.delete(key);
		}
	}
	constructor(config) {
		if (!coreFeatures.has("request-response-id-rotation")) throw new Error("Observational memory requires @mastra/core support for request-response-id-rotation. Please bump @mastra/core to a newer version.");
		if (config.model && config.observation?.model) throw new Error("Cannot set both `model` and `observation.model`. Use `model` to set both agents, or set each individually.");
		if (config.model && config.reflection?.model) throw new Error("Cannot set both `model` and `reflection.model`. Use `model` to set both agents, or set each individually.");
		this.shouldObscureThreadIds = config.obscureThreadIds || false;
		this.storage = config.storage;
		this.scope = config.scope ?? "thread";
		this.retrieval = Boolean(config.retrieval);
		this.retrievalScope = typeof config.retrieval === "object" ? config.retrieval.scope ?? "resource" : "resource";
		this.retrievalInstructions = typeof config.retrieval === "object" ? config.retrieval.instructions : void 0;
		this.retrievalSearch = typeof config.retrieval === "object" && Boolean(config.retrieval.vector);
		this.onIndexObservations = config.onIndexObservations;
		this.hooks = config.hooks;
		this.mastra = config.mastra;
		this.memory = config.memory;
		const resolveModel = (model, defaultModel) => model === "default" ? defaultModel : model;
		const observationModel = resolveModel(config.model, OBSERVATIONAL_MEMORY_DEFAULTS.observation.model) ?? resolveModel(config.observation?.model, OBSERVATIONAL_MEMORY_DEFAULTS.observation.model) ?? resolveModel(config.reflection?.model, OBSERVATIONAL_MEMORY_DEFAULTS.observation.model) ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.model;
		const reflectionModel = resolveModel(config.model, OBSERVATIONAL_MEMORY_DEFAULTS.reflection.model) ?? resolveModel(config.reflection?.model, OBSERVATIONAL_MEMORY_DEFAULTS.reflection.model) ?? resolveModel(config.observation?.model, OBSERVATIONAL_MEMORY_DEFAULTS.reflection.model) ?? OBSERVATIONAL_MEMORY_DEFAULTS.reflection.model;
		const messageTokens = config.observation?.messageTokens ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.messageTokens;
		const observationTokens = config.reflection?.observationTokens ?? OBSERVATIONAL_MEMORY_DEFAULTS.reflection.observationTokens;
		const isSharedBudget = config.shareTokenBudget ?? false;
		const isDefaultModelSelection = (model) => model === void 0 || model === "default" || model instanceof ModelByInputTokens;
		const observationSelectedModel = config.model ?? config.observation?.model ?? config.reflection?.model;
		const reflectionSelectedModel = config.model ?? config.reflection?.model ?? config.observation?.model;
		const observationDefaultMaxOutputTokens = config.observation?.modelSettings?.maxOutputTokens ?? (isDefaultModelSelection(observationSelectedModel) ? OBSERVATIONAL_MEMORY_DEFAULTS.observation.modelSettings.maxOutputTokens : void 0);
		const reflectionDefaultMaxOutputTokens = config.reflection?.modelSettings?.maxOutputTokens ?? (isDefaultModelSelection(reflectionSelectedModel) ? OBSERVATIONAL_MEMORY_DEFAULTS.reflection.modelSettings.maxOutputTokens : void 0);
		const totalBudget = messageTokens + observationTokens;
		const userExplicitlyConfiguredAsync = config.observation?.bufferTokens !== void 0 || config.observation?.bufferActivation !== void 0 || config.reflection?.bufferActivation !== void 0;
		const asyncBufferingDisabled = config.observation?.bufferTokens === false || config.scope === "resource" && !userExplicitlyConfiguredAsync;
		if (isSharedBudget && !asyncBufferingDisabled) if (userExplicitlyConfiguredAsync) throw new Error("shareTokenBudget requires async buffering to be disabled (this is a temporary limitation). Add observation: { bufferTokens: false } to your config:\n\n  observationalMemory: {\n    shareTokenBudget: true,\n    observation: { bufferTokens: false },\n  }\n\nRemove any other async buffering settings (bufferTokens, bufferActivation, blockAfter).");
		else throw new Error("shareTokenBudget requires async buffering to be disabled (this is a temporary limitation). Add observation: { bufferTokens: false } to your config:\n\n  observationalMemory: {\n    shareTokenBudget: true,\n    observation: { bufferTokens: false },\n  }\n\nAsync buffering is enabled by default — this opt-out is only needed when using shareTokenBudget.");
		const observationActivateAfterIdle = config.observation?.activateAfterIdle ?? config.activateAfterIdle;
		const observationActivateAfterIdlePath = config.observation?.activateAfterIdle !== void 0 ? "observation.activateAfterIdle" : "activateAfterIdle";
		this.observationConfig = {
			model: observationModel,
			messageTokens: isSharedBudget ? {
				min: messageTokens,
				max: totalBudget
			} : messageTokens,
			shareTokenBudget: isSharedBudget,
			modelSettings: {
				temperature: config.observation?.modelSettings?.temperature ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.modelSettings.temperature,
				...observationDefaultMaxOutputTokens !== void 0 ? { maxOutputTokens: observationDefaultMaxOutputTokens } : {}
			},
			providerOptions: config.observation?.providerOptions ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.providerOptions,
			maxTokensPerBatch: config.observation?.maxTokensPerBatch ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.maxTokensPerBatch,
			bufferTokens: asyncBufferingDisabled ? void 0 : resolveBufferTokens(config.observation?.bufferTokens ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.bufferTokens, config.observation?.messageTokens ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.messageTokens),
			bufferOnIdle: config.observation?.bufferOnIdle ?? false,
			bufferActivation: asyncBufferingDisabled ? void 0 : config.observation?.bufferActivation ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.bufferActivation,
			activateAfterIdle: parseActivationTTL(observationActivateAfterIdle, observationActivateAfterIdlePath),
			activateOnProviderChange: config.observation?.activateOnProviderChange ?? config.activateOnProviderChange ?? false,
			blockAfter: asyncBufferingDisabled ? void 0 : resolveBlockAfter(config.observation?.blockAfter ?? (config.observation?.bufferTokens ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.bufferTokens ? 1.2 : void 0), config.observation?.messageTokens ?? OBSERVATIONAL_MEMORY_DEFAULTS.observation.messageTokens),
			previousObserverTokens: config.observation?.previousObserverTokens ?? 2e3,
			instruction: config.observation?.instruction,
			threadTitle: config.observation?.threadTitle ?? false,
			observeAttachments: config.observation?.observeAttachments ?? true,
			extractors: composeObservationExtractors({
				threadTitle: config.observation?.threadTitle ?? false,
				extract: config.observation?.extract
			})
		};
		this.reflectionConfig = {
			model: reflectionModel,
			observationTokens,
			shareTokenBudget: isSharedBudget,
			modelSettings: {
				temperature: config.reflection?.modelSettings?.temperature ?? OBSERVATIONAL_MEMORY_DEFAULTS.reflection.modelSettings.temperature,
				...reflectionDefaultMaxOutputTokens !== void 0 ? { maxOutputTokens: reflectionDefaultMaxOutputTokens } : {}
			},
			providerOptions: config.reflection?.providerOptions ?? OBSERVATIONAL_MEMORY_DEFAULTS.reflection.providerOptions,
			bufferActivation: asyncBufferingDisabled ? void 0 : config?.reflection?.bufferActivation ?? OBSERVATIONAL_MEMORY_DEFAULTS.reflection.bufferActivation,
			activateAfterIdle: parseActivationTTL(config.reflection?.activateAfterIdle, "reflection.activateAfterIdle"),
			activateOnProviderChange: config.reflection?.activateOnProviderChange ?? false,
			blockAfter: asyncBufferingDisabled ? void 0 : resolveBlockAfter(config.reflection?.blockAfter ?? (config.reflection?.bufferActivation ?? OBSERVATIONAL_MEMORY_DEFAULTS.reflection.bufferActivation ? 1.2 : void 0), config.reflection?.observationTokens ?? OBSERVATIONAL_MEMORY_DEFAULTS.reflection.observationTokens),
			instruction: config.reflection?.instruction,
			extractors: composeReflectionExtractors({ extract: config.reflection?.extract })
		};
		this.tokenCounter = new TokenCounter({ model: typeof observationModel === "string" ? observationModel : void 0 });
		this.onDebugEvent = config.onDebugEvent;
		this.messageHistory = new MessageHistory({ storage: this.storage });
		this.observer = new ObserverRunner({
			observationConfig: this.observationConfig,
			observedMessageIds: this.observedMessageIds,
			resolveModel: (inputTokens) => this.resolveObservationModel(inputTokens),
			tokenCounter: this.tokenCounter,
			mastra: config.mastra,
			memory: this.memory
		});
		this.buffering = new BufferingCoordinator({
			observationConfig: this.observationConfig,
			reflectionConfig: this.reflectionConfig,
			scope: this.scope
		});
		this.reflector = new ReflectorRunner({
			reflectionConfig: this.reflectionConfig,
			observationConfig: this.observationConfig,
			tokenCounter: this.tokenCounter,
			storage: this.storage,
			scope: this.scope,
			buffering: this.buffering,
			emitDebugEvent: (e) => this.emitDebugEvent(e),
			persistMarkerToStorage: (m, t, r) => this.persistMarkerToStorage(m, t, r),
			persistMarkerToMessage: (m, ml, t, r) => this.persistMarkerToMessage(m, ml, t, r),
			getCompressionStartLevel: (rc) => this.getCompressionStartLevel(rc),
			resolveModel: (inputTokens) => this.resolveReflectionModel(inputTokens),
			mastra: config.mastra,
			memory: this.memory
		});
		this.validateBufferConfig();
		omDebug(`[OM:init] new ObservationalMemory instance created — scope=${this.scope}, messageTokens=${JSON.stringify(this.observationConfig.messageTokens)}, obsAsyncEnabled=${this.buffering.isAsyncObservationEnabled()}, bufferTokens=${this.observationConfig.bufferTokens}, bufferActivation=${this.observationConfig.bufferActivation}, blockAfter=${this.observationConfig.blockAfter}, reflectionTokens=${this.reflectionConfig.observationTokens}, refAsyncEnabled=${this.buffering.isAsyncReflectionEnabled()}, refAsyncActivation=${this.reflectionConfig.bufferActivation}, refBlockAfter=${this.reflectionConfig.blockAfter}`);
	}
	__registerMastra(mastra) {
		this.mastra = mastra;
		this.observer.__registerMastra(mastra);
		this.reflector.__registerMastra(mastra);
	}
	/**
	* Get the current configuration for this OM instance.
	* Used by the server to expose config to the UI when OM is added via processors.
	*/
	get config() {
		return {
			scope: this.scope,
			retrieval: this.retrieval,
			observation: {
				messageTokens: this.observationConfig.messageTokens,
				previousObserverTokens: this.observationConfig.previousObserverTokens
			},
			reflection: { observationTokens: this.reflectionConfig.observationTokens }
		};
	}
	/**
	* Wait for any in-flight async buffering operations for the given thread/resource.
	* Used by server endpoints to block until buffering completes so the UI can get final state.
	*/
	async waitForBuffering(threadId, resourceId, timeoutMs = 3e4) {
		return BufferingCoordinator.awaitBuffering(threadId, resourceId, this.scope, timeoutMs);
	}
	getConcreteModel(model, inputTokens) {
		if (model instanceof ModelByInputTokens) {
			if (inputTokens === void 0) throw new Error("ModelByInputTokens requires inputTokens for resolution");
			return model.resolve(inputTokens);
		}
		return model;
	}
	getModelToResolve(model, inputTokens) {
		const concreteModel = this.getConcreteModel(model, inputTokens);
		if (Array.isArray(concreteModel)) return concreteModel[0]?.model ?? "unknown";
		if (typeof concreteModel === "function") return async (ctx) => {
			const result = await concreteModel(ctx);
			if (Array.isArray(result)) return result[0]?.model ?? "unknown";
			return result;
		};
		return concreteModel;
	}
	formatModelName(model) {
		if (!model.modelId) return "(unknown)";
		return model.provider ? `${model.provider}/${model.modelId}` : model.modelId;
	}
	resolveObservationModel(inputTokens) {
		return this.resolveTieredModel(this.observationConfig.model, inputTokens);
	}
	resolveReflectionModel(inputTokens) {
		return this.resolveTieredModel(this.reflectionConfig.model, inputTokens);
	}
	resolveTieredModel(model, inputTokens) {
		if (!(model instanceof ModelByInputTokens)) return { model };
		const thresholds = model.getThresholds();
		const selectedThreshold = thresholds.find((upTo) => inputTokens <= upTo) ?? thresholds.at(-1);
		return {
			model: model.resolve(inputTokens),
			selectedThreshold,
			routingStrategy: "model-by-input-tokens",
			routingThresholds: thresholds.join(",")
		};
	}
	async resolveModelRouting(modelConfig, requestContext) {
		try {
			if (modelConfig instanceof ModelByInputTokens) {
				const routing = await Promise.all(modelConfig.getThresholds().map(async (upTo) => {
					const resolvedModel = modelConfig.resolve(upTo);
					const resolved = await this.resolveModelContext(resolvedModel, requestContext);
					return {
						upTo,
						model: resolved?.modelId ? this.formatModelName(resolved) : "(unknown)"
					};
				}));
				return {
					model: routing[0]?.model ?? "(unknown)",
					routing
				};
			}
			const resolved = await this.resolveModelContext(modelConfig, requestContext);
			return { model: resolved?.modelId ? this.formatModelName(resolved) : "(unknown)" };
		} catch (error) {
			omError("[OM] Failed to resolve model config", error);
			return { model: "(unknown)" };
		}
	}
	async resolveModelContext(modelConfig, requestContext, inputTokens) {
		const modelToResolve = this.getModelToResolve(modelConfig, inputTokens);
		if (!modelToResolve) return;
		const resolved = await resolveModelConfig(modelToResolve, requestContext, this.mastra);
		return {
			provider: resolved.provider,
			modelId: resolved.modelId
		};
	}
	/**
	* Get the default compression start level based on model behavior.
	* gemini-2.5-flash is a faithful transcriber that needs explicit pressure to compress effectively.
	*/
	async getCompressionStartLevel(requestContext) {
		try {
			if (((await this.resolveModelContext(this.reflectionConfig.model, requestContext))?.modelId ?? "").includes("gemini-2.5-flash")) return 2;
			return 1;
		} catch {
			return 1;
		}
	}
	/**
	* Get the full config including resolved model names.
	* This is async because it needs to resolve the model configs.
	*/
	async getResolvedConfig(requestContext) {
		const [observationResolved, reflectionResolved] = await Promise.all([this.resolveModelRouting(this.observationConfig.model, requestContext), this.resolveModelRouting(this.reflectionConfig.model, requestContext)]);
		return {
			scope: this.scope,
			observation: {
				messageTokens: this.observationConfig.messageTokens,
				model: observationResolved.model,
				previousObserverTokens: this.observationConfig.previousObserverTokens,
				routing: observationResolved.routing
			},
			reflection: {
				observationTokens: this.reflectionConfig.observationTokens,
				model: reflectionResolved.model,
				routing: reflectionResolved.routing
			}
		};
	}
	/**
	* Emit a debug event if the callback is configured.
	* @internal Used by observation strategies. Do not call directly.
	*/
	emitDebugEvent(event) {
		if (this.onDebugEvent) this.onDebugEvent(event);
	}
	/**
	* Validate buffer configuration on first use.
	* Ensures bufferTokens is less than the threshold and bufferActivation is valid.
	*/
	validateBufferConfig() {
		if ((this.observationConfig.bufferTokens !== void 0 || this.observationConfig.bufferActivation !== void 0 || this.reflectionConfig.bufferActivation !== void 0) && this.scope === "resource") throw new Error("Async buffering is not yet supported with scope: 'resource'. Use scope: 'thread', or set observation: { bufferTokens: false } to disable async buffering.");
		const observationThreshold = getMaxThreshold(this.observationConfig.messageTokens);
		if (this.observationConfig.bufferTokens !== void 0) {
			if (this.observationConfig.bufferTokens <= 0) throw new Error(`observation.bufferTokens must be > 0, got ${this.observationConfig.bufferTokens}`);
			if (this.observationConfig.bufferTokens >= observationThreshold) throw new Error(`observation.bufferTokens (${this.observationConfig.bufferTokens}) must be less than messageTokens (${observationThreshold})`);
		}
		if (this.observationConfig.bufferActivation !== void 0) {
			if (this.observationConfig.bufferActivation <= 0) throw new Error(`observation.bufferActivation must be > 0, got ${this.observationConfig.bufferActivation}`);
			if (this.observationConfig.bufferActivation > 1 && this.observationConfig.bufferActivation < 1e3) throw new Error(`observation.bufferActivation must be <= 1 (ratio) or >= 1000 (absolute token retention), got ${this.observationConfig.bufferActivation}`);
			if (this.observationConfig.bufferActivation >= 1e3 && this.observationConfig.bufferActivation >= observationThreshold) throw new Error(`observation.bufferActivation as absolute retention (${this.observationConfig.bufferActivation}) must be less than messageTokens (${observationThreshold})`);
		}
		if (this.observationConfig.blockAfter !== void 0) {
			if (this.observationConfig.blockAfter < observationThreshold) throw new Error(`observation.blockAfter (${this.observationConfig.blockAfter}) must be >= messageTokens (${observationThreshold})`);
			if (!this.observationConfig.bufferTokens) throw new Error(`observation.blockAfter requires observation.bufferTokens to be set (blockAfter only applies when async buffering is enabled)`);
		}
		if (this.observationConfig.previousObserverTokens !== void 0 && this.observationConfig.previousObserverTokens !== false) {
			if (!Number.isFinite(this.observationConfig.previousObserverTokens) || this.observationConfig.previousObserverTokens < 0) throw new Error(`observation.previousObserverTokens must be false or a finite number >= 0, got ${this.observationConfig.previousObserverTokens}`);
		}
		if (this.reflectionConfig.bufferActivation !== void 0) {
			if (this.reflectionConfig.bufferActivation <= 0 || this.reflectionConfig.bufferActivation > 1) throw new Error(`reflection.bufferActivation must be in range (0, 1], got ${this.reflectionConfig.bufferActivation}`);
		}
		if (this.reflectionConfig.blockAfter !== void 0) {
			const reflectionThreshold = getMaxThreshold(this.reflectionConfig.observationTokens);
			if (this.reflectionConfig.blockAfter < reflectionThreshold) throw new Error(`reflection.blockAfter (${this.reflectionConfig.blockAfter}) must be >= reflection.observationTokens (${reflectionThreshold})`);
			if (!this.reflectionConfig.bufferActivation) throw new Error(`reflection.blockAfter requires reflection.bufferActivation to be set (blockAfter only applies when async reflection is enabled)`);
		}
	}
	/**
	* Resolve the effective messageTokens for a record.
	* Only explicit per-record overrides (stored under `_overrides`) win;
	* the initial config snapshot written by getOrCreateRecord() is ignored
	* so that later instance-level changes still take effect.
	*
	* Overrides that fall below the instance-level buffering floor
	* (bufferTokens / absolute bufferActivation) are clamped to the
	* instance threshold to preserve buffering invariants.
	*/
	getEffectiveMessageTokens(record) {
		const recordTokens = (record.config?._overrides)?.observation?.messageTokens;
		if (recordTokens) {
			const maxOverride = getMaxThreshold(recordTokens);
			const bufferTokens = this.observationConfig.bufferTokens;
			if (bufferTokens && maxOverride <= bufferTokens) return this.observationConfig.messageTokens;
			const bufferActivation = this.observationConfig.bufferActivation;
			if (bufferActivation && bufferActivation >= 1e3 && maxOverride <= bufferActivation) return this.observationConfig.messageTokens;
			return recordTokens;
		}
		return this.observationConfig.messageTokens;
	}
	/**
	* Resolve the effective reflection observationTokens for a record.
	* Only explicit per-record overrides (stored under `_overrides`) win;
	* the initial config snapshot is ignored so instance-level changes
	* still take effect for existing records.
	*/
	getEffectiveReflectionTokens(record) {
		const recordTokens = (record.config?._overrides)?.reflection?.observationTokens;
		if (recordTokens) return recordTokens;
		return this.reflectionConfig.observationTokens;
	}
	/**
	* Check whether the unobserved message tokens meet the observation threshold.
	*/
	meetsObservationThreshold(opts) {
		const { record, unobservedTokens, extraTokens = 0 } = opts;
		const pendingTokens = (record.pendingMessageTokens ?? 0) + unobservedTokens + extraTokens;
		const currentObservationTokens = record.observationTokenCount ?? 0;
		return pendingTokens >= calculateDynamicThreshold(this.getEffectiveMessageTokens(record), currentObservationTokens);
	}
	/**
	* Get thread/resource IDs for storage lookup
	*/
	getStorageIds(threadId, resourceId) {
		if (this.scope === "resource") return {
			threadId: null,
			resourceId: resourceId ?? threadId
		};
		if (!threadId) throw new Error("ObservationalMemory (scope: 'thread') requires a threadId, but received an empty value. This is a bug — getThreadContext should have caught this earlier.");
		return {
			threadId,
			resourceId: resourceId ?? threadId
		};
	}
	/**
	* Get or create the observational memory record.
	* Returns the existing record if one exists, otherwise initializes a new one.
	*/
	async getOrCreateRecord(threadId, resourceId) {
		const ids = this.getStorageIds(threadId, resourceId);
		let record = await this.storage.getObservationalMemory(ids.threadId, ids.resourceId);
		if (!record) {
			const observedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			record = await this.storage.initializeObservationalMemory({
				threadId: ids.threadId,
				resourceId: ids.resourceId,
				scope: this.scope,
				config: {
					observation: this.observationConfig,
					reflection: this.reflectionConfig,
					scope: this.scope
				},
				observedTimezone
			});
		}
		return record;
	}
	/**
	* Get current config snapshot for observation markers.
	*/
	getObservationMarkerConfig() {
		return {
			messageTokens: getMaxThreshold(this.observationConfig.messageTokens),
			observationTokens: getMaxThreshold(this.reflectionConfig.observationTokens),
			scope: this.scope,
			activateAfterIdle: this.observationConfig.activateAfterIdle
		};
	}
	/**
	* Persist a data-om-* marker part on the last assistant message in messageList
	* AND save the updated message to the DB so it survives page reload.
	* (data-* parts are filtered out before sending to the LLM, so they don't affect model calls.)
	* @internal Used by ReflectorRunner. Do not call directly.
	*/
	async persistMarkerToMessage(marker, messageList, threadId, resourceId) {
		if (!messageList) return;
		const allMsgs = messageList.get.all.db();
		for (let i = allMsgs.length - 1; i >= 0; i--) {
			const msg = allMsgs[i];
			if (msg?.role === "assistant" && msg.content?.parts && Array.isArray(msg.content.parts)) {
				const markerData = marker.data;
				if (!(markerData?.cycleId && msg.content.parts.some((p) => p?.type === marker.type && p?.data?.cycleId === markerData.cycleId))) msg.content.parts.push(marker);
				try {
					await this.messageHistory.persistMessages({
						messages: [msg],
						threadId,
						resourceId
					});
				} catch (e) {
					omDebug(`[OM:persistMarker] failed to save marker to DB: ${e}`);
				}
				return;
			}
		}
	}
	/**
	* Persist a marker to the last assistant message in storage.
	* Unlike persistMarkerToMessage, this fetches messages directly from the DB
	* so it works even when no MessageList is available (e.g. async buffering ops).
	* @internal Used by observation strategies. Do not call directly.
	*/
	async persistMarkerToStorage(marker, threadId, resourceId) {
		try {
			const messages = (await this.storage.listMessages({
				threadId,
				perPage: 20,
				orderBy: {
					field: "createdAt",
					direction: "DESC"
				}
			}))?.messages ?? [];
			for (const msg of messages) if (msg?.role === "assistant" && msg.content?.parts && Array.isArray(msg.content.parts)) {
				const markerData = marker.data;
				if (!(markerData?.cycleId && msg.content.parts.some((p) => p?.type === marker.type && p?.data?.cycleId === markerData.cycleId))) msg.content.parts.push(marker);
				await this.messageHistory.persistMessages({
					messages: [msg],
					threadId,
					resourceId
				});
				return;
			}
		} catch (e) {
			omDebug(`[OM:persistMarkerToStorage] failed to save marker to DB: ${e}`);
		}
	}
	/**
	* Find the last completed observation boundary in a message's parts.
	* A completed observation is a start marker followed by an end marker.
	*
	* Returns the index of the END marker (which is the observation boundary),
	* or -1 if no completed observation is found.
	*/
	/**
	* Check if a message has an in-progress observation (start without end).
	*/
	hasInProgressObservation(message) {
		const parts = message.content?.parts;
		if (!parts || !Array.isArray(parts)) return false;
		let lastStartIndex = -1;
		let lastEndOrFailedIndex = -1;
		for (let i = parts.length - 1; i >= 0; i--) {
			const part = parts[i];
			if (part?.type === "data-om-observation-start" && lastStartIndex === -1) lastStartIndex = i;
			if ((part?.type === "data-om-observation-end" || part?.type === "data-om-observation-failed") && lastEndOrFailedIndex === -1) lastEndOrFailedIndex = i;
		}
		return lastStartIndex !== -1 && lastStartIndex > lastEndOrFailedIndex;
	}
	/**
	* Seal messages to prevent new parts from being merged into them.
	* This is used when starting buffering to capture the current content state.
	*
	* Sealing works by:
	* 1. Setting `message.content.metadata.mastra.sealed = true` (message-level flag)
	* 2. Adding `metadata.mastra.sealedAt` to the last part (boundary marker)
	*
	* When MessageList.add() receives a message with the same ID as a sealed message,
	* it creates a new message with only the parts beyond the seal boundary.
	*
	* The messages are mutated in place - since they're references to the same objects
	* in the MessageList, the seal will be recognized immediately.
	*
	* @param messages - Messages to seal (mutated in place)
	*/
	/** @internal Used by ObservationStep. */
	sealMessagesForBuffering(messages) {
		const sealedAt = Date.now();
		for (const msg of messages) {
			if (!msg.content?.parts?.length) continue;
			if (!msg.content.metadata) msg.content.metadata = {};
			const metadata = msg.content.metadata;
			if (!metadata.mastra) metadata.mastra = {};
			metadata.mastra.sealed = true;
			const lastPart = msg.content.parts[msg.content.parts.length - 1];
			if (!lastPart.metadata) lastPart.metadata = {};
			if (!lastPart.metadata.mastra) lastPart.metadata.mastra = {};
			lastPart.metadata.mastra.sealedAt = sealedAt;
		}
	}
	/**
	* Insert an observation marker into a message.
	* The marker is appended directly to the message's parts array (mutating in place).
	* Also persists the change to storage so markers survive page refresh.
	*
	* For end/failed markers, the message is also "sealed" to prevent future content
	* from being merged into it. This ensures observation markers are preserved.
	*/
	/**
	* Insert an observation marker into a message.
	* For start markers, this pushes the part directly.
	* For end/failed markers, this should be called AFTER writer.custom() has added the part,
	* so we just find the part and add sealing metadata.
	*/
	/**
	* Create a virtual message containing only the unobserved parts.
	* This is used for token counting and observation.
	*/
	createUnobservedMessage(message) {
		const unobservedParts = getUnobservedParts(message);
		if (unobservedParts.length === 0) return null;
		return {
			...message,
			content: {
				...message.content,
				parts: unobservedParts
			}
		};
	}
	/**
	* Get unobserved messages with part-level filtering.
	*
	* This method uses data-om-observation-end markers to filter at the part level:
	* 1. For messages WITH a completed observation: only return parts AFTER the end marker
	* 2. For messages WITHOUT completed observation: check timestamp against lastObservedAt
	*
	* This handles the case where a single message accumulates many parts
	* (like tool calls) during an agentic loop - we only observe the new parts.
	*/
	/** @internal Used by ObservationStep. */
	getUnobservedMessages(allMessages, record, opts) {
		const lastObservedAt = record.lastObservedAt;
		const observedMessageIds = new Set(Array.isArray(record.observedMessageIds) ? record.observedMessageIds : []);
		if (opts?.excludeBuffered) {
			const bufferedChunks = getBufferedChunks(record);
			for (const chunk of bufferedChunks) if (Array.isArray(chunk.messageIds)) for (const id of chunk.messageIds) observedMessageIds.add(id);
		}
		const result = [];
		for (const msg of allMessages) {
			if (msg.role === "system") continue;
			if (observedMessageIds?.has(msg.id)) continue;
			const endMarkerIndex = findLastCompletedObservationBoundary(msg);
			if (this.hasInProgressObservation(msg)) result.push(msg);
			else if (endMarkerIndex !== -1) {
				const virtualMsg = this.createUnobservedMessage(msg);
				if (virtualMsg) result.push(virtualMsg);
			} else if (!msg.createdAt || !lastObservedAt) result.push(msg);
			else if (new Date(msg.createdAt) > lastObservedAt) result.push(msg);
		}
		return result;
	}
	/**
	* Prepare optimized observer context by applying truncation and buffered-reflection inclusion.
	*
	* Returns the (possibly optimized) observations string to pass as "Previous Observations"
	* to the observer prompt. When no optimization options are set, returns the input unchanged.
	*/
	prepareObserverContext(existingObservations, record) {
		const { previousObserverTokens } = this.observationConfig;
		const tokenBudget = previousObserverTokens === void 0 || previousObserverTokens === false ? void 0 : previousObserverTokens;
		if (tokenBudget === void 0) return {
			context: existingObservations,
			wasTruncated: false
		};
		const bufferedReflection = record?.bufferedReflection && record?.reflectedObservationLineCount ? record.bufferedReflection : void 0;
		if (!existingObservations) return {
			context: bufferedReflection,
			wasTruncated: false
		};
		let observations = existingObservations;
		if (bufferedReflection && record?.reflectedObservationLineCount) {
			const unreflectedContent = observations.split("\n").slice(record.reflectedObservationLineCount).join("\n").trim();
			observations = unreflectedContent ? `${bufferedReflection}\n\n${unreflectedContent}` : bufferedReflection;
		}
		let wasTruncated = false;
		if (tokenBudget !== void 0) {
			if (tokenBudget === 0) return {
				context: "",
				wasTruncated: true
			};
			if (this.tokenCounter.countObservations(observations) > tokenBudget) {
				observations = this.truncateObservationsToTokenBudget(observations, tokenBudget);
				wasTruncated = true;
			}
		}
		return {
			context: observations,
			wasTruncated
		};
	}
	/**
	* Truncate observations to fit within a token budget.
	*
	* Strategy:
	* 1. Keep a raw tail of recent observations (end of block).
	* 2. Add a truncation marker: [X observations truncated here], placed at the hidden gap.
	* 3. Try to preserve important observations (🔴) from older context, newest-first.
	* 4. Enforce that at least 50% of kept observations remain raw tail observations.
	*/
	truncateObservationsToTokenBudget(observations, budget) {
		if (budget === 0) return "";
		if (this.tokenCounter.countObservations(observations) <= budget) return observations;
		const lines = observations.split("\n");
		const totalCount = lines.length;
		const lineTokens = new Array(totalCount);
		const isImportant = new Array(totalCount);
		for (let i = 0; i < totalCount; i++) {
			lineTokens[i] = this.tokenCounter.countString(lines[i]);
			isImportant[i] = lines[i].includes("🔴") || lines[i].includes("✅");
		}
		const suffixTokens = new Array(totalCount + 1);
		suffixTokens[totalCount] = 0;
		for (let i = totalCount - 1; i >= 0; i--) suffixTokens[i] = suffixTokens[i + 1] + lineTokens[i];
		const headImportantIndexes = [];
		const buildCandidateString = (tailStart, selectedImportantIndexes) => {
			const keptIndexes = [...selectedImportantIndexes, ...Array.from({ length: totalCount - tailStart }, (_, i) => tailStart + i)].sort((a, b) => a - b);
			if (keptIndexes.length === 0) return `[${totalCount} observations truncated here]`;
			const outputLines = [];
			let previousKeptIndex = -1;
			for (const keptIndex of keptIndexes) {
				const hiddenCount = keptIndex - previousKeptIndex - 1;
				if (hiddenCount === 1) outputLines.push(lines[previousKeptIndex + 1]);
				else if (hiddenCount > 1) outputLines.push(`[${hiddenCount} observations truncated here]`);
				outputLines.push(lines[keptIndex]);
				previousKeptIndex = keptIndex;
			}
			const trailingHiddenCount = totalCount - previousKeptIndex - 1;
			if (trailingHiddenCount === 1) outputLines.push(lines[totalCount - 1]);
			else if (trailingHiddenCount > 1) outputLines.push(`[${trailingHiddenCount} observations truncated here]`);
			return outputLines.join("\n");
		};
		const estimateKeptContentCost = (tailStart, selectedImportantIndexes) => {
			let cost = suffixTokens[tailStart];
			for (const idx of selectedImportantIndexes) cost += lineTokens[idx];
			return cost;
		};
		let bestCandidate;
		let bestImportantCount = -1;
		let bestRawTailLength = -1;
		for (let tailStart = 1; tailStart < totalCount; tailStart++) {
			if (isImportant[tailStart - 1]) headImportantIndexes.push(tailStart - 1);
			const rawTailLength = totalCount - tailStart;
			const maxImportantByRatio = rawTailLength;
			let importantToKeep = Math.min(headImportantIndexes.length, maxImportantByRatio);
			const getSelectedImportant = (count) => count > 0 ? headImportantIndexes.slice(Math.max(0, headImportantIndexes.length - count)) : [];
			while (importantToKeep > 0 && estimateKeptContentCost(tailStart, getSelectedImportant(importantToKeep)) > budget) importantToKeep -= 1;
			if (estimateKeptContentCost(tailStart, getSelectedImportant(importantToKeep)) > budget) continue;
			if (importantToKeep > bestImportantCount || importantToKeep === bestImportantCount && rawTailLength > bestRawTailLength) {
				const candidate = buildCandidateString(tailStart, getSelectedImportant(importantToKeep));
				if (this.tokenCounter.countObservations(candidate) <= budget) {
					bestCandidate = candidate;
					bestImportantCount = importantToKeep;
					bestRawTailLength = rawTailLength;
				}
			}
		}
		if (!bestCandidate) return `[${totalCount} observations truncated here]`;
		return bestCandidate;
	}
	/**
	* Format observations for injection into context.
	* Applies token optimization before presenting to the Actor.
	*
	* In resource scope mode, filters continuity messages to only show
	* the message for the current thread.
	*/
	formatObservationsForContext(observations, currentTask, suggestedResponse, extractedValues, unobservedContextBlocks, currentDate, retrieval = false) {
		let optimized = retrieval ? renderObservationGroupsForReflection(observations) ?? optimizeObservationsForContext(observations) : optimizeObservationsForContext(observations);
		if (currentDate) optimized = addRelativeTimeToObservations(optimized, currentDate);
		const messages = [`${OBSERVATION_CONTEXT_PROMPT}\n\n${OBSERVATION_CONTEXT_INSTRUCTIONS}${retrieval ? `\n\n${getRetrievalInstructions(this.retrievalScope, this.retrievalInstructions, this.retrievalSearch)}` : ""}`];
		if (unobservedContextBlocks) messages.push(`The following content is from OTHER conversations different from the current conversation, they're here for reference,  but they're not necessarily your focus:\nSTART_OTHER_CONVERSATIONS_BLOCK\n${unobservedContextBlocks}\nEND_OTHER_CONVERSATIONS_BLOCK`);
		const observationChunks = this.splitObservationContextChunks(optimized);
		if (observationChunks.length > 0) messages.push("<observations>", ...observationChunks);
		if (currentTask) messages.push(`<current-task>\n${currentTask}\n</current-task>`);
		if (suggestedResponse) messages.push(`<suggested-response>\n${suggestedResponse}\n</suggested-response>`);
		messages.push(...buildExtractedValueContextSections([...this.observationConfig.extractors, ...this.reflectionConfig.extractors], extractedValues));
		return messages;
	}
	splitObservationContextChunks(observations) {
		const trimmed = observations.trim();
		if (!trimmed) return [];
		return trimmed.split(/\n{2,}--- message boundary \(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z\) ---\n{2,}/).map((chunk) => chunk.trim()).filter(Boolean);
	}
	/**
	* Create a message boundary delimiter with an ISO 8601 date.
	* The date should be the lastObservedAt timestamp — the latest message
	* timestamp that was observed to produce the observations following this boundary.
	*/
	static createMessageBoundary(date) {
		return `\n\n--- message boundary (${date.toISOString()}) ---\n\n`;
	}
	/**
	* Get threadId and resourceId from either RequestContext or MessageList
	*/
	getThreadContext(requestContext, messageList) {
		const memoryContext = requestContext?.get("MastraMemory");
		if (memoryContext?.thread?.id) return {
			threadId: memoryContext.thread.id,
			resourceId: memoryContext.resourceId
		};
		const serialized = messageList.serialize();
		if (serialized.memoryInfo?.threadId) return {
			threadId: serialized.memoryInfo.threadId,
			resourceId: serialized.memoryInfo.resourceId
		};
		if (this.scope === "thread") throw new Error("ObservationalMemory (scope: 'thread') requires a threadId, but none was found in RequestContext or MessageList. Ensure the agent is configured with Memory and a valid threadId is provided.");
		return null;
	}
	/**
	* Save messages to storage, skipping messages that were already persisted by
	* async buffering. Uses the message-level sealed flag (metadata.mastra.sealed)
	* to detect already-persisted messages, avoiding redundant DB operations.
	*
	* Messages with observation markers are always saved (upserted) even if sealed,
	* because the markers need to be persisted to storage.
	*/
	async persistMessages(messagesToSave, threadId, resourceId) {
		const filteredMessages = [];
		for (const msg of messagesToSave) if (!!(msg.content?.metadata)?.mastra?.sealed) {
			if (findLastCompletedObservationBoundary(msg) !== -1) filteredMessages.push(msg);
		} else filteredMessages.push(msg);
		if (filteredMessages.length > 0) await this.messageHistory.persistMessages({
			messages: filteredMessages,
			threadId,
			resourceId
		});
	}
	/**
	* Load messages from storage that haven't been observed yet.
	* Uses cursor-based query with lastObservedAt timestamp for efficiency.
	*
	* In resource scope mode, loads messages for the entire resource (all threads).
	* In thread scope mode, loads messages for just the current thread.
	*/
	async loadMessagesFromStorage(threadId, resourceId, lastObservedAt) {
		const startDate = lastObservedAt ? new Date(lastObservedAt.getTime() + 1) : void 0;
		let result;
		if (this.scope === "resource" && resourceId) result = await this.storage.listMessagesByResourceId({
			resourceId,
			perPage: false,
			orderBy: {
				field: "createdAt",
				direction: "ASC"
			},
			filter: startDate ? { dateRange: { start: startDate } } : void 0
		});
		else result = await this.storage.listMessages({
			threadId,
			perPage: false,
			orderBy: {
				field: "createdAt",
				direction: "ASC"
			},
			filter: startDate ? { dateRange: { start: startDate } } : void 0
		});
		return result.messages.filter((msg) => msg.role !== "system");
	}
	/**
	* Format unobserved messages from other threads as <unobserved-context> blocks.
	* These are injected into the Actor's context so it has awareness of activity
	* in other threads for the same resource.
	*/
	async formatUnobservedContextBlocks(messagesByThread, currentThreadId) {
		const blocks = [];
		for (const [threadId, messages] of messagesByThread) {
			if (threadId === currentThreadId) continue;
			if (messages.length === 0) continue;
			const formattedMessages = formatMessagesForObserver(messages, { maxPartLength: 500 });
			if (formattedMessages) {
				const obscuredId = await this.representThreadIDInContext(threadId);
				blocks.push(`<other-conversation id="${obscuredId}">
${formattedMessages}
</other-conversation>`);
			}
		}
		return blocks.join("\n\n");
	}
	async representThreadIDInContext(threadId) {
		if (this.shouldObscureThreadIds) return (await this.hasher).h32ToString(threadId);
		return threadId;
	}
	/**
	* Get the maximum createdAt timestamp from a list of messages.
	* Used to set lastObservedAt to the most recent message timestamp instead of current time.
	* This ensures historical data (like LongMemEval fixtures) works correctly.
	*/
	getMaxMessageTimestamp(messages) {
		let maxTime = 0;
		for (const msg of messages) if (msg.createdAt) {
			const msgTime = new Date(msg.createdAt).getTime();
			if (msgTime > maxTime) maxTime = msgTime;
		}
		return maxTime > 0 ? new Date(maxTime) : /* @__PURE__ */ new Date();
	}
	/**
	* Wrap observations in a thread attribution tag.
	* Used in resource scope to track which thread observations came from.
	* @internal Used by observation strategies. Do not call directly.
	*/
	async wrapWithThreadTag(threadId, observations, messageRange) {
		const cleanObservations = stripThreadTags(observations);
		const groupedObservations = this.retrieval && messageRange ? wrapInObservationGroup(cleanObservations, messageRange) : cleanObservations;
		return `<thread id="${await this.representThreadIDInContext(threadId)}">\n${groupedObservations}\n</thread>`;
	}
	/**
	* Append or merge new thread sections.
	* If the new section has the same thread ID and date as an existing section,
	* merge the observations into that section to reduce token usage.
	* Otherwise, append as a new section.
	*/
	replaceOrAppendThreadSection(existingObservations, _threadId, newThreadSection, lastObservedAt) {
		if (!existingObservations) return newThreadSection;
		const threadIdMatch = newThreadSection.match(/<thread id="([^"]+)">/);
		const dateMatch = newThreadSection.match(/Date:\s*([A-Za-z]+\s+\d+,\s+\d+)/);
		if (!threadIdMatch || !dateMatch) return `${existingObservations}${ObservationalMemory.createMessageBoundary(lastObservedAt)}${newThreadSection}`;
		const newThreadId = threadIdMatch[1];
		const newDate = dateMatch[1];
		const threadOpen = `<thread id="${newThreadId}">`;
		const threadClose = "</thread>";
		const startIdx = existingObservations.indexOf(threadOpen);
		let existingSection = null;
		let existingSectionStart = -1;
		let existingSectionEnd = -1;
		if (startIdx !== -1) {
			const closeIdx = existingObservations.indexOf(threadClose, startIdx);
			if (closeIdx !== -1) {
				existingSectionEnd = closeIdx + 9;
				existingSectionStart = startIdx;
				const section = existingObservations.slice(startIdx, existingSectionEnd);
				if (section.includes(`Date: ${newDate}`) || section.includes(`Date:${newDate}`)) existingSection = section;
			}
		}
		if (existingSection) {
			const dateLineEnd = newThreadSection.indexOf("\n", newThreadSection.indexOf("Date:"));
			const newCloseIdx = newThreadSection.lastIndexOf(threadClose);
			if (dateLineEnd !== -1 && newCloseIdx !== -1) {
				const newObsContent = newThreadSection.slice(dateLineEnd + 1, newCloseIdx).trim();
				if (newObsContent) {
					const merged = `${existingSection.slice(0, existingSection.length - 9).trimEnd()}\n${newObsContent}\n${threadClose}`;
					return existingObservations.slice(0, existingSectionStart) + merged + existingObservations.slice(existingSectionEnd);
				}
			}
		}
		return `${existingObservations}${ObservationalMemory.createMessageBoundary(lastObservedAt)}${newThreadSection}`;
	}
	/**
	* @internal Used by observation strategies. Do not call directly.
	*/
	wrapObservations(rawObservations, existingObservations, threadId, lastObservedAt, messageRange) {
		if (this.scope === "resource") return (async () => {
			const threadSection = await this.wrapWithThreadTag(threadId, rawObservations, messageRange);
			return this.replaceOrAppendThreadSection(existingObservations, threadId, threadSection, lastObservedAt ?? /* @__PURE__ */ new Date());
		})();
		const grouped = this.retrieval && messageRange ? wrapInObservationGroup(rawObservations, messageRange) : rawObservations;
		return existingObservations ? `${existingObservations}\n\n${grouped}` : grouped;
	}
	/**
	* Start an async background observation that stores results to bufferedObservations.
	* This is a fire-and-forget operation that runs in the background.
	* The results will be swapped to active when the main threshold is reached.
	*
	* If another buffering operation is already in progress for this scope, this will
	* wait for it to complete before starting a new one (mutex behavior).
	*
	* @param record - Current OM record
	* @param threadId - Thread ID
	* @param unobservedMessages - All unobserved messages (will be filtered for already-buffered)
	* @param lockKey - Lock key for this scope
	* @param writer - Optional stream writer for emitting buffering markers
	*/
	async startAsyncBufferedObservation(record, threadId, unobservedMessages, lockKey, writer, contextWindowTokens, requestContext, observabilityContext) {
		const bufferKey = this.buffering.getObservationBufferKey(lockKey);
		const currentTokens = contextWindowTokens ?? await this.tokenCounter.countMessagesAsync(unobservedMessages) + (record.pendingMessageTokens ?? 0);
		BufferingCoordinator.lastBufferedBoundary.set(bufferKey, currentTokens);
		registerOp(record.id, "bufferingObservation");
		this.storage.setBufferingObservationFlag(record.id, true, currentTokens).catch((err) => {
			omError("[OM] Failed to set buffering observation flag", err);
		});
		const asyncOp = this.runAsyncBufferedObservation(record, threadId, unobservedMessages, bufferKey, writer, requestContext, observabilityContext).catch((err) => {
			omError("[OM] async buffering observation failed", err);
		}).finally(() => {
			BufferingCoordinator.asyncBufferingOps.delete(bufferKey);
			unregisterOp(record.id, "bufferingObservation");
			this.storage.setBufferingObservationFlag(record.id, false).catch((err) => {
				omError("[OM] Failed to clear buffering observation flag", err);
			});
		});
		BufferingCoordinator.asyncBufferingOps.set(bufferKey, asyncOp);
	}
	/**
	* Internal method that waits for existing buffering operation and then runs new buffering.
	* This implements the mutex-wait behavior.
	*/
	async runAsyncBufferedObservation(record, threadId, unobservedMessages, bufferKey, writer, requestContext, observabilityContext) {
		const existingOp = BufferingCoordinator.asyncBufferingOps.get(bufferKey);
		if (existingOp) try {
			await existingOp;
		} catch {}
		const freshRecord = await this.storage.getObservationalMemory(record.threadId, record.resourceId);
		if (!freshRecord) return;
		let bufferCursor = BufferingCoordinator.lastBufferedAtTime.get(bufferKey) ?? freshRecord.lastBufferedAtTime ?? null;
		if (freshRecord.lastObservedAt) {
			const lastObserved = new Date(freshRecord.lastObservedAt);
			if (!bufferCursor || lastObserved > bufferCursor) bufferCursor = lastObserved;
		}
		let candidateMessages = this.getUnobservedMessages(unobservedMessages, freshRecord, { excludeBuffered: true });
		const preFilterCount = candidateMessages.length;
		if (bufferCursor) candidateMessages = candidateMessages.filter((msg) => {
			if (!msg.createdAt) return true;
			return new Date(msg.createdAt) > bufferCursor;
		});
		omDebug(`[OM:bufferCursor] cursor=${bufferCursor?.toISOString() ?? "null"}, unobserved=${unobservedMessages.length}, afterExcludeBuffered=${preFilterCount}, afterCursorFilter=${candidateMessages.length}`);
		const minNewTokens = (this.observationConfig.bufferTokens ?? 5e3) / 2;
		if (await this.tokenCounter.countMessagesAsync(candidateMessages) < minNewTokens) return;
		const messagesToBuffer = candidateMessages;
		this.sealMessagesForBuffering(messagesToBuffer);
		try {
			await this.messageHistory.persistMessages({
				messages: messagesToBuffer,
				threadId,
				resourceId: freshRecord.resourceId ?? void 0
			});
		} catch (err) {
			omError("[OM] Failed to persist sealed messages before buffering — skipping observation cycle", err);
			return;
		}
		const cycleId = `buffer-obs-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
		const startedAt = (/* @__PURE__ */ new Date()).toISOString();
		const tokensToBuffer = await this.tokenCounter.countMessagesAsync(messagesToBuffer);
		const startMarker = createBufferingStartMarker({
			cycleId,
			operationType: "observation",
			tokensToBuffer,
			recordId: freshRecord.id,
			threadId,
			threadIds: [threadId],
			config: this.getObservationMarkerConfig()
		});
		await this.persistMarkerToStorage(startMarker, threadId, freshRecord.resourceId ?? void 0);
		if (writer) writer.custom({
			...startMarker,
			transient: true
		}).catch(() => {});
		omDebug(`[OM:bufferInput] cycleId=${cycleId}, msgCount=${messagesToBuffer.length}, msgTokens=${tokensToBuffer}, ids=${messagesToBuffer.map((m) => `${m.id?.slice(0, 8)}@${m.createdAt ? new Date(m.createdAt).toISOString() : "none"}`).join(",")}`);
		await this.runBufferedObservationCycle({
			threadId,
			resourceId: freshRecord.resourceId ?? void 0,
			trigger: "async-buffer"
		}, () => ObservationStrategy.create(this, {
			record: freshRecord,
			threadId,
			resourceId: freshRecord.resourceId ?? void 0,
			messages: messagesToBuffer,
			cycleId,
			startedAt,
			writer,
			requestContext,
			observabilityContext
		}).run());
		const maxTs = this.getMaxMessageTimestamp(messagesToBuffer);
		const cursor = new Date(maxTs.getTime() + 1);
		BufferingCoordinator.lastBufferedAtTime.set(bufferKey, cursor);
	}
	/**
	* Trigger async buffered observation if the token count has crossed a new interval.
	*
	* Encapsulates the shouldTrigger check + startAsyncBufferedObservation call.
	* Returns whether buffering was actually triggered.
	*/
	async triggerAsyncBuffering(opts) {
		if (!this.buffering.isAsyncObservationEnabled()) return false;
		const lockKey = this.buffering.getLockKey(opts.threadId, opts.resourceId);
		const shouldTrigger = this.buffering.shouldTriggerAsyncObservation(opts.pendingTokens, lockKey, opts.record, this.storage, opts.threshold);
		if (shouldTrigger) this.startAsyncBufferedObservation(opts.record, opts.threadId, opts.unobservedMessages, lockKey, opts.writer, opts.unbufferedPendingTokens, opts.requestContext);
		return shouldTrigger;
	}
	isMessageList(value) {
		return !!value && typeof value === "object" && "get" in value && "removeByIds" in value;
	}
	removeIdsFromArray(messages, ids) {
		if (ids.length === 0) return;
		const idsSet = new Set(ids);
		for (let i = messages.length - 1; i >= 0; i--) {
			const msg = messages[i];
			if (msg?.id && idsSet.has(msg.id)) messages.splice(i, 1);
		}
	}
	/**
	* Mutate partially observed messages in place and return the fully observed
	* message IDs that should be removed from the live context.
	*
	* This is the shared activation-cleanup primitive used by both the processor
	* and AI SDK integrations: callers pass the current live messages, OM trims
	* any partially observed messages down to their unobserved parts, and OM
	* returns only the IDs that are safe to remove entirely.
	*/
	async getObservedMessageIdsForCleanup(opts) {
		const { threadId, resourceId, messages, observedMessageIds, retentionFloor } = opts;
		const record = await this.getOrCreateRecord(threadId, resourceId);
		const effectiveObservedIds = observedMessageIds && observedMessageIds.length > 0 ? observedMessageIds : Array.isArray(record.observedMessageIds) ? record.observedMessageIds : [];
		if (effectiveObservedIds.length === 0) return [];
		const observedSet = new Set(effectiveObservedIds);
		const idsToRemove = /* @__PURE__ */ new Set();
		const removalOrder = [];
		let skipped = 0;
		let backoffTriggered = false;
		const retentionCounter = typeof retentionFloor === "number" ? new TokenCounter() : null;
		for (const msg of messages) {
			if (!msg?.id || msg.id === "om-continuation" || !observedSet.has(msg.id)) continue;
			const unobservedParts = getUnobservedParts(msg);
			const totalParts = msg.content?.parts?.length ?? 0;
			if (unobservedParts.length > 0 && unobservedParts.length < totalParts) {
				msg.content.parts = unobservedParts;
				continue;
			}
			if (retentionCounter && typeof retentionFloor === "number") {
				const nextRemainingMessages = messages.filter((m) => m?.id && m.id !== "om-continuation" && !idsToRemove.has(m.id) && m.id !== msg.id);
				if (retentionCounter.countMessages(nextRemainingMessages) < retentionFloor) {
					skipped += 1;
					backoffTriggered = true;
					break;
				}
			}
			idsToRemove.add(msg.id);
			removalOrder.push(msg.id);
		}
		if (retentionCounter && typeof retentionFloor === "number" && idsToRemove.size > 0) {
			let remainingMessages = messages.filter((m) => m?.id && m.id !== "om-continuation" && !idsToRemove.has(m.id));
			let remainingTokens = retentionCounter.countMessages(remainingMessages);
			while (remainingTokens < retentionFloor && removalOrder.length > 0) {
				const restoreId = removalOrder.pop();
				idsToRemove.delete(restoreId);
				skipped += 1;
				backoffTriggered = true;
				remainingMessages = messages.filter((m) => m?.id && m.id !== "om-continuation" && !idsToRemove.has(m.id));
				remainingTokens = retentionCounter.countMessages(remainingMessages);
			}
		}
		omDebug(`[OM:cleanupActivation] matched=${idsToRemove.size}, skipped=${skipped}, backoffTriggered=${backoffTriggered}`);
		return [...idsToRemove];
	}
	/**
	* Clean up observed content from either a live MessageList or a plain message array.
	*
	* - MessageList input: mutates the live container in place and returns the remaining messages
	* - Array input: mutates the array in place and returns it
	*
	* This is the shared cleanup primitive intended for both processor and non-processor
	* integrations. The processor may still pass sealedIds/state so marker/fallback cleanup
	* can persist messages safely, but callers that do not need that bookkeeping can omit it.
	*/
	/** @internal Used by ObservationStep. */
	async cleanupMessages(opts) {
		const { threadId, resourceId, observedMessageIds, retentionFloor } = opts;
		const messageList = this.isMessageList(opts.messages) ? opts.messages : void 0;
		const allMsgs = messageList ? messageList.get.all.db() : opts.messages;
		let markerIdx = -1;
		let markerMsg = null;
		for (let i = allMsgs.length - 1; i >= 0; i--) {
			const msg = allMsgs[i];
			if (!msg) continue;
			if (findLastCompletedObservationBoundary(msg) !== -1) {
				markerIdx = i;
				markerMsg = msg;
				break;
			}
		}
		omDebug(`[OM:cleanupBranch] allMsgs=${allMsgs.length}, markerFound=${markerIdx !== -1}, markerIdx=${markerIdx}, observedMessageIds=${observedMessageIds?.length ?? "undefined"}`);
		if (observedMessageIds && observedMessageIds.length > 0) {
			const idsToRemoveList = await this.getObservedMessageIdsForCleanup({
				threadId,
				resourceId,
				messages: allMsgs,
				observedMessageIds,
				retentionFloor
			});
			if (messageList) {
				if (idsToRemoveList.length > 0) messageList.removeByIds(idsToRemoveList);
				return messageList.get.all.db();
			}
			this.removeIdsFromArray(allMsgs, idsToRemoveList);
			return allMsgs;
		}
		if (markerMsg && markerIdx !== -1) {
			const idsToRemove = [];
			const messagesToSave = [];
			for (let i = 0; i < markerIdx; i++) {
				const msg = allMsgs[i];
				if (msg?.id && msg.id !== "om-continuation") {
					idsToRemove.push(msg.id);
					messagesToSave.push(msg);
				}
			}
			messagesToSave.push(markerMsg);
			const unobservedParts = getUnobservedParts(markerMsg);
			if (unobservedParts.length === 0) {
				if (markerMsg.id) idsToRemove.push(markerMsg.id);
			} else if (unobservedParts.length < (markerMsg.content?.parts?.length ?? 0)) markerMsg.content.parts = unobservedParts;
			if (messageList) {
				if (idsToRemove.length > 0) messageList.removeByIds(idsToRemove);
				if (messagesToSave.length > 0) await this.persistMessages(messagesToSave, threadId, resourceId);
				omDebug(`[OM:cleanupMarker] removed ${idsToRemove.length} messages, saved ${messagesToSave.length}`);
				return messageList.get.all.db();
			}
			this.removeIdsFromArray(allMsgs, idsToRemove);
			return allMsgs;
		}
		return messageList ? messageList.get.all.db() : allMsgs;
	}
	/**
	* Clean up the message context after a successful observation.
	*
	* Handles both activation-based cleanup (using observedMessageIds) and
	* marker-based cleanup (using observation boundary markers). Respects
	* retention floors to prevent removing too many messages.
	*/
	async cleanupObservedContext(opts) {
		const { messageList, threadId, resourceId, observedMessageIds, retentionFloor } = opts;
		await this.cleanupMessages({
			threadId,
			resourceId,
			messages: messageList,
			observedMessageIds,
			retentionFloor
		});
	}
	/**
	* Reset buffering state after a successful observation activation.
	*
	* Clears the lastBufferedBoundary, buffering flag, and optionally cleans up
	* static maps for activated message IDs.
	*/
	/** @internal Used by ObservationStep. */
	async resetBufferingState(opts) {
		const { threadId, resourceId, recordId, activatedMessageIds } = opts;
		const lockKey = this.buffering.getLockKey(threadId, resourceId);
		const bufKey = this.buffering.getObservationBufferKey(lockKey);
		BufferingCoordinator.lastBufferedBoundary.set(bufKey, 0);
		await this.storage.setBufferingObservationFlag(recordId, false, 0).catch(() => {});
		if (activatedMessageIds && activatedMessageIds.length > 0) this.buffering.cleanupStaticMaps(threadId, resourceId, activatedMessageIds);
	}
	/**
	* Build the observation system message string for injection into an LLM prompt.
	*
	* Loads thread metadata (currentTask, suggestedResponse), formats observations
	* with context prompts and instructions, and returns the fully-formed string.
	* Returns undefined if no observations exist.
	*
	* This is the public entry point for context formatting — used by both
	* Memory.getContext() (standalone) and the processor (via injectObservationsIntoMessages).
	*
	* @example
	* ```ts
	* const systemMsg = await om.buildContextSystemMessage({ threadId: 'thread-1' });
	* if (systemMsg) {
	*   const result = await generateText({ system: systemMsg, messages });
	* }
	* ```
	*/
	async buildContextSystemMessage(opts) {
		return (await this.buildContextSystemMessages(opts))?.join("\n\n");
	}
	/**
	* Build observation context as an array of system message chunks.
	* Each chunk is a separate system message for better LLM cache hit rates.
	* Used by the processor to inject multiple system messages.
	* @internal
	*/
	async buildContextSystemMessages(opts) {
		const { threadId, resourceId, unobservedContextBlocks } = opts;
		const record = opts.record ?? await this.getOrCreateRecord(threadId, resourceId);
		if (!record.activeObservations) {
			if (this.retrieval && this.retrievalScope === "resource") return [getRetrievalInstructions(this.retrievalScope, this.retrievalInstructions, this.retrievalSearch)];
			return;
		}
		const omMetadata = getThreadOMMetadata((await this.storage.getThreadById({ threadId }))?.metadata);
		const currentTask = omMetadata?.currentTask;
		const suggestedResponse = omMetadata?.suggestedResponse;
		const currentDate = opts.currentDate ?? /* @__PURE__ */ new Date();
		return this.formatObservationsForContext(record.activeObservations, currentTask, suggestedResponse, omMetadata?.extracted, unobservedContextBlocks, currentDate, this.retrieval);
	}
	/**
	* Get unobserved messages from other threads for resource-scoped observation.
	*
	* Lists all threads for the resource, filters to unobserved messages,
	* and formats them as context blocks.
	*/
	/** @internal Used by ObservationTurn. */
	async getOtherThreadsContext(resourceId, currentThreadId) {
		const { threads: allThreads } = await this.storage.listThreads({ filter: { resourceId } });
		const messagesByThread = /* @__PURE__ */ new Map();
		const recordLastObservedAt = (await this.getRecord(currentThreadId, resourceId))?.lastObservedAt;
		for (const thread of allThreads) {
			if (thread.id === currentThreadId) continue;
			const threadLastObservedAt = getThreadOMMetadata(thread.metadata)?.lastObservedAt ?? recordLastObservedAt;
			const startDate = threadLastObservedAt ? new Date(new Date(threadLastObservedAt).getTime() + 1) : void 0;
			const filtered = (await this.storage.listMessages({
				threadId: thread.id,
				perPage: false,
				orderBy: {
					field: "createdAt",
					direction: "ASC"
				},
				filter: startDate ? { dateRange: { start: startDate } } : void 0
			})).messages.filter((m) => !this.observedMessageIds.has(m.id));
			if (filtered.length > 0) messagesByThread.set(thread.id, filtered);
		}
		if (messagesByThread.size === 0) return void 0;
		return await this.formatUnobservedContextBlocks(messagesByThread, currentThreadId) || void 0;
	}
	/**
	* Emit debug event and stream progress for UI feedback.
	*/
	async emitProgress(opts) {
		const { record, pendingTokens, threshold, effectiveObservationTokensThreshold, currentObservationTokens, writer, stepNumber, threadId, resourceId } = opts;
		this.emitDebugEvent({
			type: "step_progress",
			timestamp: /* @__PURE__ */ new Date(),
			threadId,
			resourceId: resourceId ?? "",
			stepNumber,
			finishReason: "unknown",
			pendingTokens,
			threshold,
			thresholdPercent: Math.round(pendingTokens / threshold * 100),
			willSave: pendingTokens >= threshold,
			willObserve: pendingTokens >= threshold
		});
		if (writer) {
			const bufferedChunks = getBufferedChunks(record);
			const bufferedObservationTokens = bufferedChunks.reduce((sum, chunk) => sum + (chunk.tokenCount ?? 0), 0);
			const rawBufferedMessageTokens = bufferedChunks.reduce((sum, chunk) => sum + (chunk.messageTokens ?? 0), 0);
			const bufferedMessageTokens = Math.min(rawBufferedMessageTokens, pendingTokens);
			const projectedMessageRemoval = calculateProjectedMessageRemoval(bufferedChunks, this.observationConfig.bufferActivation ?? 1, getMaxThreshold(this.getEffectiveMessageTokens(record)), pendingTokens);
			let obsBufferStatus = "idle";
			if (record.isBufferingObservation) obsBufferStatus = "running";
			else if (bufferedChunks.length > 0) obsBufferStatus = "complete";
			let refBufferStatus = "idle";
			if (record.isBufferingReflection) refBufferStatus = "running";
			else if (record.bufferedReflection && record.bufferedReflection.length > 0) refBufferStatus = "complete";
			const statusPart = {
				type: "data-om-status",
				data: {
					windows: {
						active: {
							messages: {
								tokens: pendingTokens,
								threshold
							},
							observations: {
								tokens: currentObservationTokens,
								threshold: effectiveObservationTokensThreshold
							}
						},
						buffered: {
							observations: {
								chunks: bufferedChunks.length,
								messageTokens: bufferedMessageTokens,
								projectedMessageRemoval,
								observationTokens: bufferedObservationTokens,
								status: obsBufferStatus
							},
							reflection: {
								inputObservationTokens: record.bufferedReflectionInputTokens ?? 0,
								observationTokens: record.bufferedReflectionTokens ?? 0,
								status: refBufferStatus
							}
						}
					},
					recordId: record.id,
					threadId,
					stepNumber,
					generationCount: record.generationCount
				}
			};
			omDebug(`[OM:status] step=${stepNumber} msgs=${pendingTokens}/${threshold} obs=${currentObservationTokens}/${effectiveObservationTokensThreshold} gen=${record.generationCount}`);
			await writer.custom(statusPart).catch(() => {});
		}
	}
	/**
	* Get the current observation status for a thread/resource.
	*
	* Loads unobserved messages from storage, counts tokens, and checks against
	* configured thresholds. Returns a comprehensive status object that tells the
	* caller what actions are needed.
	*
	* This is a pure read operation with no side effects.
	*
	* @example
	* ```ts
	* const status = await om.getStatus({ threadId });
	* if (status.shouldObserve) {
	*   await om.observe({ threadId });
	* } else if (status.shouldBuffer) {
	*   await om.buffer({ threadId });
	* }
	* if (status.shouldReflect) {
	*   await om.reflect(threadId);
	* }
	* ```
	*/
	async getStatus(opts) {
		const { threadId, resourceId } = opts;
		const record = await this.getOrCreateRecord(threadId, resourceId);
		const currentObservationTokens = record.observationTokenCount ?? 0;
		let unobservedMessages;
		if (opts.messages) unobservedMessages = this.getUnobservedMessages(opts.messages, record);
		else {
			const rawMessages = await this.loadMessagesFromStorage(threadId, resourceId, record.lastObservedAt ? new Date(record.lastObservedAt) : void 0);
			unobservedMessages = this.getUnobservedMessages(rawMessages, record);
		}
		const contextWindowTokens = await this.tokenCounter.countMessagesAsync(unobservedMessages);
		let otherThreadTokens = 0;
		if (this.scope === "resource" && resourceId) {
			const otherContext = await this.getOtherThreadsContext(resourceId, threadId);
			otherThreadTokens = otherContext ? this.tokenCounter.countString(otherContext) : 0;
		}
		const pendingTokens = Math.max(0, contextWindowTokens + otherThreadTokens);
		const threshold = calculateDynamicThreshold(this.getEffectiveMessageTokens(record), currentObservationTokens);
		const bufferedChunks = getBufferedChunks(record);
		const bufferedChunkCount = bufferedChunks.length;
		const bufferedChunkTokens = bufferedChunks.reduce((sum, chunk) => sum + (chunk.messageTokens ?? 0), 0);
		const asyncObservationEnabled = this.buffering.isAsyncObservationEnabled();
		let shouldBuffer = false;
		if (asyncObservationEnabled && pendingTokens < threshold) {
			const lockKey = this.buffering.getLockKey(threadId, resourceId);
			shouldBuffer = this.buffering.shouldTriggerAsyncObservation(pendingTokens, lockKey, record, this.storage, threshold);
		}
		const shouldObserve = pendingTokens >= threshold;
		const reflectThreshold = getMaxThreshold(this.getEffectiveReflectionTokens(record));
		const shouldReflect = currentObservationTokens >= reflectThreshold;
		const canActivate = bufferedChunkCount > 0;
		const effectiveMessageTokens = this.getEffectiveMessageTokens(record);
		const isSharedBudget = typeof effectiveMessageTokens !== "number";
		const totalBudget = isSharedBudget ? effectiveMessageTokens.max : 0;
		return {
			record,
			pendingTokens,
			threshold,
			effectiveObservationTokensThreshold: isSharedBudget ? Math.max(totalBudget - threshold, 1e3) : reflectThreshold,
			unbufferedPendingTokens: Math.max(0, pendingTokens - bufferedChunkTokens),
			shouldObserve,
			shouldBuffer,
			shouldReflect,
			bufferedChunkCount,
			bufferedChunkTokens,
			canActivate,
			asyncObservationEnabled,
			asyncReflectionEnabled: this.buffering.isAsyncReflectionEnabled(),
			scope: this.scope
		};
	}
	/**
	* Finalize the observation lifecycle: activate any remaining buffered chunks,
	* then observe if the threshold is crossed.
	*
	* Call this at the end of a conversation, session, or turn sequence to ensure
	* no buffered observations are left orphaned and the observation cursor is
	* advanced. Produces a clean terminal state (no pending chunks, cursor up to date).
	*
	* @example
	* ```ts
	* // After all turns are complete
	* const result = await om.finalize({ threadId });
	* // result.activated: true if buffered chunks were promoted
	* // result.observed: true if a full observation pass ran
	* ```
	*/
	async finalize(opts) {
		const { threadId, resourceId, messages } = opts;
		let activated = false;
		let observed = false;
		let reflected = false;
		await BufferingCoordinator.awaitBuffering(threadId, resourceId ?? null, this.scope);
		if ((await this.getStatus({
			threadId,
			resourceId,
			messages
		})).canActivate) activated = (await this.activate({
			threadId,
			resourceId,
			messages
		})).activated;
		if ((await this.getStatus({
			threadId,
			resourceId,
			messages
		})).shouldObserve) observed = (await this.observe({
			threadId,
			resourceId,
			messages
		})).observed;
		if ((await this.getStatus({
			threadId,
			resourceId
		})).shouldReflect) reflected = (await this.reflect(threadId, resourceId)).reflected;
		const record = await this.getOrCreateRecord(threadId, resourceId);
		return {
			activated,
			observed,
			reflected,
			record
		};
	}
	/**
	* Return only the messages that haven't been fully observed yet.
	*
	* Use this to prune observed messages from an in-memory message array,
	* preventing unbounded context growth across steps in a multi-step loop.
	* This is the array-based equivalent of the processor's `cleanupObservedContext()`.
	*
	* @example
	* ```ts
	* // In a prepareStep hook, prune before sending to the model
	* messages = await om.pruneObserved({ threadId, messages });
	* ```
	*/
	async pruneObserved(opts) {
		const { threadId, resourceId, messages } = opts;
		const record = await this.getOrCreateRecord(threadId, resourceId);
		return this.getUnobservedMessages(messages, record);
	}
	/**
	* Load unobserved messages from storage for a thread/resource.
	*
	* Fetches the OM record, queries storage for messages after the
	* lastObservedAt cursor, then applies part-level filtering so
	* partially-observed messages only include their unobserved parts.
	*
	* Use this when you need to load stored conversation history that
	* hasn't been observed yet (e.g. in a stateless gateway proxy that
	* only receives the latest message from the HTTP request).
	*/
	async loadUnobservedMessages(opts) {
		const { threadId, resourceId } = opts;
		const record = await this.getOrCreateRecord(threadId, resourceId);
		const rawMessages = await this.loadMessagesFromStorage(threadId, resourceId, record.lastObservedAt ? new Date(record.lastObservedAt) : void 0);
		return this.getUnobservedMessages(rawMessages, record);
	}
	/**
	* Create a buffered observation chunk without merging into active observations.
	*
	* Loads unobserved messages from storage (filtered by the buffer cursor to avoid
	* re-buffering), calls the observer LLM, and stores the result as a pending
	* buffered chunk in the DB. The chunk can later be merged into active observations
	* via `activate()`.
	*
	* This is a synchronous (awaited) operation — the caller decides whether to
	* `await` it or fire-and-forget. All state lives in storage; no in-process
	* coordination is needed.
	*
	* @example
	* ```ts
	* const status = await om.getStatus({ threadId });
	* if (status.shouldBuffer) {
	*   await om.buffer({ threadId });
	* }
	* ```
	*/
	/** @internal Used by ObservationStep. */
	async buffer(opts) {
		const { threadId, resourceId, requestContext, observabilityContext } = opts;
		let record = opts.record ?? await this.getOrCreateRecord(threadId, resourceId);
		if (!this.buffering.isAsyncObservationEnabled()) return {
			buffered: false,
			record
		};
		if (record.isBufferingObservation && isOpActiveInProcess(record.id, "bufferingObservation")) return {
			buffered: false,
			record
		};
		const currentTokens = opts.pendingTokens ?? record.pendingMessageTokens ?? 0;
		const lockKey = this.buffering.getLockKey(threadId, resourceId);
		const bufferKey = this.buffering.getObservationBufferKey(lockKey);
		BufferingCoordinator.lastBufferedBoundary.set(bufferKey, currentTokens);
		if (record.isBufferingObservation) await this.storage.setBufferingObservationFlag(record.id, false).catch(() => {});
		const existingOp = BufferingCoordinator.asyncBufferingOps.get(bufferKey);
		if (existingOp) try {
			await existingOp;
		} catch {}
		registerOp(record.id, "bufferingObservation");
		this.storage.setBufferingObservationFlag(record.id, true, currentTokens).catch((err) => {
			omError("[OM] Failed to set buffering observation flag", err);
		});
		let resolveOp;
		const opPromise = new Promise((resolve) => {
			resolveOp = resolve;
		});
		BufferingCoordinator.asyncBufferingOps.set(bufferKey, opPromise);
		record = await this.storage.getObservationalMemory(record.threadId, record.resourceId) ?? record;
		let flagCleared = false;
		try {
			let candidateMessages;
			if (opts.messages) candidateMessages = this.getUnobservedMessages(opts.messages, record, { excludeBuffered: true });
			else {
				const rawMessages = await this.loadMessagesFromStorage(threadId, resourceId, record.lastObservedAt ? new Date(record.lastObservedAt) : void 0);
				candidateMessages = this.getUnobservedMessages(rawMessages, record, { excludeBuffered: true });
			}
			if (!opts.messages) {
				let bufferCursor = BufferingCoordinator.lastBufferedAtTime.get(bufferKey) ?? record.lastBufferedAtTime ?? null;
				if (record.lastObservedAt) {
					const lastObserved = new Date(record.lastObservedAt);
					if (!bufferCursor || lastObserved > bufferCursor) bufferCursor = lastObserved;
				}
				if (bufferCursor) candidateMessages = candidateMessages.filter((msg) => {
					if (!msg.createdAt) return true;
					return new Date(msg.createdAt) > bufferCursor;
				});
			}
			const minNewTokens = (this.observationConfig.bufferTokens ?? 5e3) / 2;
			const newTokens = await this.tokenCounter.countMessagesAsync(candidateMessages);
			if (candidateMessages.length === 0 || !opts.skipMinimumTokenCheck && newTokens < minNewTokens) return {
				buffered: false,
				record
			};
			if (opts.beforeBuffer) await opts.beforeBuffer(candidateMessages);
			else if (opts.messages) this.sealMessagesForBuffering(candidateMessages);
			const cycleId = `buffer-obs-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
			const startedAt = (/* @__PURE__ */ new Date()).toISOString();
			const startMarker = createBufferingStartMarker({
				cycleId,
				operationType: "observation",
				tokensToBuffer: newTokens,
				recordId: record.id,
				threadId,
				threadIds: [threadId],
				config: this.getObservationMarkerConfig()
			});
			await this.persistMarkerToStorage(startMarker, threadId, record.resourceId ?? void 0);
			const writer = opts.writer;
			if (writer) writer.custom({
				...startMarker,
				transient: true
			}).catch(() => {});
			await this.runBufferedObservationCycle({
				threadId,
				resourceId: record.resourceId ?? resourceId,
				trigger: "async-buffer"
			}, () => ObservationStrategy.create(this, {
				record,
				threadId,
				resourceId: record.resourceId ?? void 0,
				messages: candidateMessages,
				cycleId,
				startedAt,
				writer,
				agent: opts.agent,
				sendSignal: opts.sendSignal,
				requestContext,
				currentModel: opts.currentModel,
				observabilityContext
			}).run());
			if (isOmReproCaptureEnabled()) writeObserverExchangeReproCapture({
				threadId,
				resourceId: record.resourceId ?? void 0,
				label: `buffer-${cycleId}`,
				observerExchange: this.observer.lastExchange,
				details: {
					cycleId,
					startedAt,
					buffered: true,
					candidateMessageIds: candidateMessages.map((message) => message.id),
					candidateMessageCount: candidateMessages.length,
					pendingTokens: currentTokens,
					newTokens
				}
			});
			await this.storage.setBufferingObservationFlag(record.id, false, newTokens).catch(() => {});
			flagCleared = true;
			BufferingCoordinator.lastBufferedBoundary.set(bufferKey, newTokens);
			const maxTimestamp = this.getMaxMessageTimestamp(candidateMessages);
			const cursor = new Date(maxTimestamp.getTime() + 1);
			BufferingCoordinator.lastBufferedAtTime.set(bufferKey, cursor);
			return {
				buffered: true,
				record: await this.getOrCreateRecord(threadId, resourceId)
			};
		} catch (error) {
			omError("[OM] buffer() failed", error);
			return {
				buffered: false,
				record
			};
		} finally {
			unregisterOp(record.id, "bufferingObservation");
			BufferingCoordinator.asyncBufferingOps.delete(bufferKey);
			resolveOp();
			if (!flagCleared) await this.storage.setBufferingObservationFlag(record.id, false).catch(() => {});
		}
	}
	/**
	* Activate buffered observation chunks by merging them into active observations.
	*
	* This is a pure storage operation — no LLM call. It reads buffered chunks from
	* the DB and swaps them into active observations via `storage.swapBufferedToActive()`.
	*
	* Call this after `buffer()` has created chunks, typically at the start of a new
	* turn or when `getStatus().canActivate` is true.
	*
	* @example
	* ```ts
	* const status = await om.getStatus({ threadId });
	* if (status.canActivate) {
	*   const result = await om.activate({ threadId });
	*   if (result.activated) {
	*     console.log('Activated', result.activatedMessageIds?.length, 'message observations');
	*   }
	* }
	* ```
	*/
	/** @internal Used by ObservationStep. */
	async activate(opts) {
		const { threadId, resourceId } = opts;
		const record = await this.getOrCreateRecord(threadId, resourceId);
		if (this.buffering.isAsyncObservationEnabled()) {
			const lockKey = this.buffering.getLockKey(threadId, resourceId);
			const bufKey = this.buffering.getObservationBufferKey(lockKey);
			const dbBoundary = record.lastBufferedAtTokens ?? 0;
			if (dbBoundary > 0 && opts.messages) {
				const unobserved = this.getUnobservedMessages(opts.messages, record);
				const currentContextTokens = this.tokenCounter.countMessages(unobserved);
				if (currentContextTokens < dbBoundary * .5) {
					omDebug(`[OM:activate] resetting stale lastBufferedBoundary: dbBoundary=${dbBoundary}, currentContextTokens=${currentContextTokens}`);
					BufferingCoordinator.lastBufferedBoundary.set(bufKey, 0);
					await this.storage.setBufferingObservationFlag(record.id, false, 0).catch(() => {});
				}
			}
		}
		if (!getBufferedChunks(record).length) return {
			activated: false,
			record
		};
		let activationTriggeredBy = "threshold";
		let activationLastActivityAt;
		let activationActivateAfterIdle;
		let activateAfterIdleExpiredMs;
		let previousModel;
		let currentModel;
		if (opts.checkThreshold) {
			const thresholdMessages = opts.messages ?? await this.loadMessagesFromStorage(threadId, resourceId, record.lastObservedAt ? new Date(record.lastObservedAt) : void 0);
			const activateAfterIdle = resolveActivationTTL(this.observationConfig.activateAfterIdle, opts.currentModel);
			const lastActivityAt = getLastActivityFromMessages(thresholdMessages);
			const ttlExpiredMs = activateAfterIdle !== void 0 && lastActivityAt !== void 0 ? Date.now() - lastActivityAt : void 0;
			const ttlExpired = ttlExpiredMs !== void 0 && activateAfterIdle !== void 0 && ttlExpiredMs >= activateAfterIdle;
			const actorModel = getCurrentModel(opts.currentModel);
			const lastModel = getLastModelFromMessages(thresholdMessages);
			if (this.observationConfig.activateOnProviderChange === true && didProviderChange(actorModel, lastModel)) {
				activationTriggeredBy = "provider_change";
				previousModel = lastModel;
				currentModel = actorModel;
			} else if (ttlExpired) {
				activationTriggeredBy = "ttl";
				activationLastActivityAt = lastActivityAt;
				activationActivateAfterIdle = activateAfterIdle;
				activateAfterIdleExpiredMs = ttlExpiredMs;
			} else {
				const status = await this.getStatus({
					threadId,
					resourceId,
					messages: thresholdMessages
				});
				if (status.pendingTokens < status.threshold) return {
					activated: false,
					record
				};
			}
		}
		if (record.isBufferingObservation) {
			const lockKey = this.buffering.getLockKey(threadId, resourceId);
			const bufferKey = this.buffering.getObservationBufferKey(lockKey);
			const asyncOp = BufferingCoordinator.asyncBufferingOps.get(bufferKey);
			if (asyncOp) try {
				await Promise.race([asyncOp, new Promise((_, reject) => setTimeout(() => reject(/* @__PURE__ */ new Error("Timeout")), 6e4))]);
			} catch {}
		}
		const freshRecord = await this.storage.getObservationalMemory(record.threadId, record.resourceId);
		if (!freshRecord) return {
			activated: false,
			record
		};
		const freshChunks = getBufferedChunks(freshRecord);
		if (!freshChunks.length) return {
			activated: false,
			record
		};
		const messageTokensThreshold = getMaxThreshold(this.getEffectiveMessageTokens(freshRecord));
		const activationRatio = resolveActivationRatio(this.observationConfig.bufferActivation ?? .7, messageTokensThreshold);
		const totalChunkMessageTokens = freshChunks.reduce((sum, c) => sum + (c.messageTokens ?? 0), 0);
		const currentPendingTokens = freshRecord.pendingMessageTokens || totalChunkMessageTokens;
		const forceMaxActivation = !!(this.observationConfig.blockAfter && currentPendingTokens >= this.observationConfig.blockAfter);
		const activationResult = await this.storage.swapBufferedToActive({
			id: freshRecord.id,
			activationRatio,
			messageTokensThreshold,
			currentPendingTokens,
			forceMaxActivation,
			bufferedChunks: freshChunks
		});
		await this.storage.setBufferingObservationFlag(freshRecord.id, false).catch(() => {});
		unregisterOp(freshRecord.id, "bufferingObservation");
		const postSwapRecord = await this.storage.getObservationalMemory(record.threadId, record.resourceId);
		if (opts.writer && postSwapRecord && activationResult.activatedCycleIds.length > 0) {
			const perChunkMap = new Map(activationResult.perChunk?.map((c) => [c.cycleId, c]));
			for (const cycleId of activationResult.activatedCycleIds) {
				const chunkData = perChunkMap.get(cycleId);
				const activationMarker = createActivationMarker({
					cycleId,
					operationType: "observation",
					chunksActivated: 1,
					tokensActivated: chunkData?.messageTokens ?? activationResult.messageTokensActivated,
					observationTokens: chunkData?.observationTokens ?? activationResult.observationTokensActivated,
					messagesActivated: chunkData?.messageCount ?? activationResult.messagesActivated,
					recordId: postSwapRecord.id,
					threadId: postSwapRecord.threadId ?? record.threadId ?? "",
					generationCount: postSwapRecord.generationCount ?? 0,
					observations: chunkData?.observations ?? activationResult.observations,
					triggeredBy: activationTriggeredBy,
					lastActivityAt: activationLastActivityAt,
					ttlExpiredMs: activateAfterIdleExpiredMs,
					previousModel,
					currentModel,
					config: {
						...this.getObservationMarkerConfig(),
						activateAfterIdle: activationActivateAfterIdle ?? this.observationConfig.activateAfterIdle
					}
				});
				opts.writer.custom({
					...activationMarker,
					transient: true
				}).catch(() => {});
				await this.persistMarkerToMessage(activationMarker, opts.messageList, record.threadId ?? "", record.resourceId ?? void 0);
			}
		}
		const thread = await this.storage.getThreadById({ threadId });
		if (thread) {
			const activatedChunks = freshChunks.filter((c) => activationResult.activatedCycleIds.includes(c.cycleId));
			const lastActivated = activatedChunks[activatedChunks.length - 1];
			if (lastActivated) {
				const chunkThreadTitle = lastActivated.threadTitle;
				const newMetadata = setThreadOMMetadata(thread.metadata, {
					suggestedResponse: lastActivated.suggestedContinuation,
					currentTask: lastActivated.currentTask,
					threadTitle: chunkThreadTitle
				});
				const oldTitle = thread.title?.trim();
				const newTitle = chunkThreadTitle?.trim();
				const shouldUpdateThreadTitle = !!newTitle && newTitle.length >= 3 && newTitle !== oldTitle;
				await this.storage.updateThread({
					id: threadId,
					title: shouldUpdateThreadTitle ? newTitle : thread.title ?? "",
					metadata: newMetadata
				});
			}
		}
		return {
			activated: true,
			record: await this.getOrCreateRecord(threadId, resourceId),
			activatedMessageIds: activationResult.activatedMessageIds
		};
	}
	/**
	* Compose the config-level hooks with optional per-call hooks into a single
	* `ObserveHooks` object, binding call context onto the config-level
	* callbacks. Config-level hooks are guarded so a throwing consumer hook can
	* never fail an observation/reflection cycle; per-call hooks keep their
	* existing payloads and propagation semantics. Returns undefined when
	* neither is configured, so call sites stay zero-cost.
	*
	* Used internally by every pipeline path (manual observe/reflect,
	* turn-engine sync observation, async buffering); public only so the
	* observation turn engine can thread config-level reflection hooks into
	* reflector calls.
	*
	* @internal
	*/
	composeHooks(callHooks, context) {
		const configHooks = this.hooks;
		if (!configHooks) return callHooks;
		if (!callHooks && !Object.keys(configHooks).length) return void 0;
		const fireConfigHook = (name, arg) => {
			const hook = configHooks[name];
			if (!hook) return;
			const logHookFailure = (error) => omDebug(`[OM:hooks] config-level ${name} hook failed: ${error instanceof Error ? error.message : String(error)}`);
			try {
				const out = hook(arg);
				if (out && typeof out.then === "function") out.then(void 0, logHookFailure);
			} catch (error) {
				logHookFailure(error);
			}
		};
		return {
			onObservationStart: () => {
				fireConfigHook("onObservationStart", context);
				callHooks?.onObservationStart?.();
			},
			onObservationEnd: (result) => {
				fireConfigHook("onObservationEnd", {
					...context,
					...result
				});
				callHooks?.onObservationEnd?.(result);
			},
			onReflectionStart: () => {
				fireConfigHook("onReflectionStart", context);
				callHooks?.onReflectionStart?.();
			},
			onReflectionEnd: (result) => {
				fireConfigHook("onReflectionEnd", {
					...context,
					...result
				});
				callHooks?.onReflectionEnd?.(result);
			}
		};
	}
	/**
	* Run one buffered observation cycle, firing config-level hooks around it.
	* Shared by both async-buffer lanes — buffer() and
	* runAsyncBufferedObservation() — whose fire-and-forget callers never see
	* the strategy result. The async-buffer strategy swallows failures
	* (rethrowOnFailure=false) and surfaces them on the result instead, so the
	* end hook reports `error` for failed cycles even though nothing throws.
	*/
	async runBufferedObservationCycle(context, run) {
		const hooks = this.composeHooks(void 0, context);
		hooks?.onObservationStart?.();
		let runResult;
		let runError;
		try {
			runResult = await run();
			return runResult;
		} catch (error) {
			runError = error instanceof Error ? error : new Error(String(error));
			throw error;
		} finally {
			hooks?.onObservationEnd?.({
				usage: runResult?.usage,
				error: runError ?? runResult?.error,
				...runResult?.providerMetadata ? { providerMetadata: runResult.providerMetadata } : {}
			});
		}
	}
	/**
	* Manually trigger observation.
	*
	* When `messages` is provided, those are used directly (filtered for unobserved)
	* instead of reading from storage. This allows external systems (e.g., opencode)
	* to pass conversation messages without duplicating them into Mastra's DB.
	*
	* Returns a result indicating whether observation and/or reflection occurred,
	* along with the updated record.
	*/
	async observe(opts) {
		const { threadId, resourceId, messages, requestContext } = opts;
		const lockKey = this.buffering.getLockKey(threadId, resourceId);
		const hooks = this.composeHooks(opts.hooks, {
			threadId,
			resourceId,
			trigger: opts.trigger ?? "manual"
		});
		const reflectionHooks = hooks ? {
			onReflectionStart: hooks.onReflectionStart,
			onReflectionEnd: hooks.onReflectionEnd
		} : void 0;
		let observed = false;
		let observationUsage;
		let observationProviderMetadata;
		let generationBefore = -1;
		await this.withLock(lockKey, async () => {
			const freshRecord = await this.getOrCreateRecord(threadId, resourceId);
			generationBefore = freshRecord.generationCount;
			const unobservedMessages = messages ? this.getUnobservedMessages(messages, freshRecord) : await this.loadMessagesFromStorage(threadId, resourceId, freshRecord.lastObservedAt ? new Date(freshRecord.lastObservedAt) : void 0);
			if (!this.meetsObservationThreshold({
				record: freshRecord,
				unobservedTokens: await this.tokenCounter.countMessagesAsync(unobservedMessages)
			})) return;
			hooks?.onObservationStart?.();
			let observationError;
			try {
				const result = await ObservationStrategy.create(this, {
					record: freshRecord,
					threadId,
					resourceId,
					messages: unobservedMessages,
					reflectionHooks,
					agent: opts.agent,
					requestContext,
					writer: opts.writer,
					observabilityContext: opts.observabilityContext
				}).run();
				observed = result.observed;
				observationUsage = result.usage;
				observationProviderMetadata = result.providerMetadata;
			} catch (error) {
				observationError = error instanceof Error ? error : new Error(String(error));
				throw error;
			} finally {
				hooks?.onObservationEnd?.({
					usage: observationUsage,
					error: observationError,
					...observationProviderMetadata ? { providerMetadata: observationProviderMetadata } : {}
				});
			}
		});
		const record = await this.getOrCreateRecord(threadId, resourceId);
		const reflected = record.generationCount > generationBefore && generationBefore >= 0;
		return {
			observed,
			reflected,
			record
		};
	}
	/**
	* Manually trigger reflection with optional guidance prompt.
	*
	* @example
	* ```ts
	* // Trigger reflection with specific focus
	* await om.reflect(threadId, resourceId,
	*   "focus on the authentication implementation, only keep minimal details about UI styling"
	* );
	* ```
	*/
	async reflect(threadId, resourceId, prompt, requestContext, observabilityContext) {
		const record = await this.getOrCreateRecord(threadId, resourceId);
		if (!record.activeObservations) return {
			reflected: false,
			record,
			usage: void 0
		};
		await this.storage.setReflectingFlag(record.id, true);
		registerOp(record.id, "reflecting");
		const hooks = this.composeHooks(void 0, {
			threadId,
			resourceId,
			trigger: "manual"
		});
		hooks?.onReflectionStart?.();
		let reflectionUsage;
		let reflectionProviderMetadata;
		let reflectionError;
		try {
			const thread = await this.storage.getThreadById({ threadId });
			const previousOmMetadata = getThreadOMMetadata(thread?.metadata);
			const priorExtractedValues = getPriorExtractedValues(previousOmMetadata, this.reflectionConfig.extractors);
			const reflectThreshold = getMaxThreshold(this.getEffectiveReflectionTokens(record));
			const reflectResult = await this.reflector.call(record.activeObservations, prompt, void 0, reflectThreshold, void 0, void 0, void 0, requestContext, priorExtractedValues, observabilityContext, void 0);
			const reflectionTokenCount = this.tokenCounter.countObservations(reflectResult.observations);
			await this.storage.createReflectionGeneration({
				currentRecord: record,
				reflection: reflectResult.observations,
				tokenCount: reflectionTokenCount
			});
			if (thread && reflectResult.extractedValues) {
				const metadataUpdate = buildThreadMetadataFromExtractedValues(this.reflectionConfig.extractors, reflectResult.extractedValues);
				const newMetadata = setThreadOMMetadata(thread.metadata, {
					currentTask: metadataUpdate.currentTask ?? previousOmMetadata?.currentTask,
					suggestedResponse: metadataUpdate.suggestedResponse ?? previousOmMetadata?.suggestedResponse,
					threadTitle: metadataUpdate.threadTitle ?? previousOmMetadata?.threadTitle,
					extracted: {
						...previousOmMetadata?.extracted ?? {},
						...metadataUpdate.extracted ?? {}
					}
				});
				await this.storage.updateThread({
					id: threadId,
					title: thread.title ?? "",
					metadata: newMetadata
				});
			}
			const updatedRecord = await this.getOrCreateRecord(threadId, resourceId);
			reflectionUsage = reflectResult.usage;
			reflectionProviderMetadata = reflectResult.providerMetadata;
			return {
				reflected: true,
				record: updatedRecord,
				usage: reflectResult.usage
			};
		} catch (error) {
			reflectionError = error instanceof Error ? error : new Error(String(error));
			omError("[OM] reflect() failed", error);
			return {
				reflected: false,
				record: await this.getOrCreateRecord(threadId, resourceId),
				usage: void 0
			};
		} finally {
			hooks?.onReflectionEnd?.({
				usage: reflectionUsage,
				error: reflectionError,
				...reflectionProviderMetadata ? { providerMetadata: reflectionProviderMetadata } : {}
			});
			await this.storage.setReflectingFlag(record.id, false);
			unregisterOp(record.id, "reflecting");
		}
	}
	/**
	* Get current observations for a thread/resource
	*/
	async getObservations(threadId, resourceId) {
		const ids = this.getStorageIds(threadId, resourceId);
		return (await this.storage.getObservationalMemory(ids.threadId, ids.resourceId))?.activeObservations;
	}
	/**
	* Get current record for a thread/resource
	*/
	async getRecord(threadId, resourceId) {
		const ids = this.getStorageIds(threadId, resourceId);
		return this.storage.getObservationalMemory(ids.threadId, ids.resourceId);
	}
	/**
	* Update per-record config overrides for observation and/or reflection thresholds.
	* The provided config is deep-merged into the record's `_overrides` key,
	* so you only need to specify the fields you want to change.
	*
	* Overrides that violate buffering invariants (e.g. messageTokens below
	* bufferTokens) are silently ignored at read time — the helpers fall back
	* to the instance-level config.
	*
	* @example
	* ```ts
	* await om.updateRecordConfig('thread-1', undefined, {
	*   observation: { messageTokens: 2000 },
	*   reflection: { observationTokens: 8000 },
	* });
	* ```
	*/
	async updateRecordConfig(threadId, resourceId, config) {
		const ids = this.getStorageIds(threadId, resourceId);
		const record = await this.storage.getObservationalMemory(ids.threadId, ids.resourceId);
		if (!record) throw new Error(`No observational memory record found for thread ${ids.threadId}`);
		await this.storage.updateObservationalMemoryConfig({
			id: record.id,
			config: { _overrides: config }
		});
	}
	/**
	* Get observation history (previous generations)
	*/
	async getHistory(threadId, resourceId, limit, options) {
		const ids = this.getStorageIds(threadId, resourceId);
		return this.storage.getObservationalMemoryHistory(ids.threadId, ids.resourceId, limit, options);
	}
	/**
	* Clear all memory for a specific thread/resource
	*/
	async clear(threadId, resourceId) {
		const ids = this.getStorageIds(threadId, resourceId);
		await this.storage.clearObservationalMemory(ids.threadId, ids.resourceId);
		this.buffering.cleanupStaticMaps(ids.threadId ?? ids.resourceId, ids.resourceId);
	}
	/**
	* Get the underlying storage adapter
	*/
	getStorage() {
		return this.storage;
	}
	/**
	* Get the owning Memory instance when available.
	*/
	getMemory() {
		return this.memory;
	}
	/**
	* Get the token counter
	*/
	getTokenCounter() {
		return this.tokenCounter;
	}
	/**
	* Get current observation configuration
	*/
	getObservationConfig() {
		return this.observationConfig;
	}
	/**
	* Get current reflection configuration
	*/
	getReflectionConfig() {
		return this.reflectionConfig;
	}
	/**
	* Get the message history instance for marker persistence.
	*/
	getMessageHistory() {
		return this.messageHistory;
	}
	/**
	* Get whether thread IDs should be obscured in observations.
	*/
	getObscureThreadIds() {
		return this.shouldObscureThreadIds;
	}
	/**
	* Begin a new observation turn — the high-level API for managing the
	* observe/buffer/activate/reflect lifecycle across agentic loop steps.
	*
	* @example
	* ```ts
	* const turn = om.beginTurn({ threadId, resourceId, messageList });
	* await turn.start(memory);
	*
	* const step0 = turn.step(0);
	* const ctx = await step0.prepare();
	* // ... agent generates ...
	*
	* await turn.end();
	* ```
	*/
	beginTurn(opts) {
		return new ObservationTurn({
			om: this,
			threadId: opts.threadId,
			resourceId: opts.resourceId,
			messageList: opts.messageList,
			agent: opts.agent,
			observabilityContext: opts.observabilityContext,
			hooks: opts.hooks
		});
	}
};
//#endregion
//#region src/processors/observational-memory/temporal-markers.ts
const TEMPORAL_GAP_REMINDER_TYPE = "temporal-gap";
function getTemporalGapReminderText(gapText, timestamp) {
	return `${gapText} — ${formatTemporalTimestamp(new Date(timestamp))}`;
}
function getTemporalGapReminderMetadata(message, gapText, gapMs, timestamp) {
	const formattedTimestamp = formatTemporalTimestamp(new Date(timestamp));
	return {
		reminderType: TEMPORAL_GAP_REMINDER_TYPE,
		gapText,
		gapMs,
		timestamp: formattedTimestamp,
		timestampMs: timestamp,
		precedesMessageId: message.id,
		systemReminder: {
			type: TEMPORAL_GAP_REMINDER_TYPE,
			message: getTemporalGapReminderText(gapText, timestamp),
			gapText,
			gapMs,
			timestamp: formattedTimestamp,
			timestampMs: timestamp,
			precedesMessageId: message.id
		}
	};
}
function getTemporalGapReminderAttributes(message, gapText, gapMs, timestamp) {
	return {
		type: TEMPORAL_GAP_REMINDER_TYPE,
		gapText,
		gapMs,
		timestamp: formatTemporalTimestamp(new Date(timestamp)),
		timestampMs: timestamp,
		precedesMessageId: message.id
	};
}
function isTemporalGapMarkerForMessage(message, targetMessageId) {
	if (!isTemporalGapMarker(message)) return false;
	const metadata = message.content.metadata;
	if (metadata?.precedesMessageId === targetMessageId) return true;
	return metadata?.systemReminder?.type === "temporal-gap" && metadata.systemReminder.precedesMessageId === targetMessageId;
}
async function insertTemporalGapMarkers({ messageList, sendSignal }) {
	const latestInputMessage = messageList.get.input.db().filter((message) => Boolean(message)).at(-1);
	if (!latestInputMessage || isTemporalGapMarker(latestInputMessage)) return;
	const allMessages = messageList.get.all.db().filter((message) => Boolean(message));
	const latestInputIndex = allMessages.findIndex((message) => message.id === latestInputMessage.id);
	if (latestInputIndex <= 0) return;
	if (allMessages.some((message) => isTemporalGapMarkerForMessage(message, latestInputMessage.id))) return;
	let previousNonMarker;
	for (let index = latestInputIndex - 1; index >= 0; index--) {
		const candidate = allMessages[index];
		if (candidate && !isTemporalGapMarker(candidate)) {
			previousNonMarker = candidate;
			break;
		}
	}
	if (!previousNonMarker) return;
	const timestamp = getMessagePartTimestamp(latestInputMessage, "first");
	const gapMs = timestamp - getMessagePartTimestamp(previousNonMarker, "last");
	const gapText = formatTemporalGap(gapMs);
	if (!gapText) return;
	await sendSignal?.({
		id: `__temporal_gap_${crypto.randomUUID()}`,
		type: "reactive",
		tagName: "system-reminder",
		contents: getTemporalGapReminderText(gapText, timestamp),
		createdAt: /* @__PURE__ */ new Date(timestamp - 1),
		acceptedAt: new Date(timestamp),
		attributes: getTemporalGapReminderAttributes(latestInputMessage, gapText, gapMs, timestamp),
		metadata: getTemporalGapReminderMetadata(latestInputMessage, gapText, gapMs, timestamp)
	});
}
//#endregion
//#region src/processors/observational-memory/processor.ts
/**
* Coerce a shared `state.__omTurn` value to a usable live turn.
*
* The turn is stashed in the shared processor-state map as a live `ObservationTurn`, but it
* serializes (via `ObservationTurn.toJSON`) to a plain, method-less projection. If such a snapshot
* were ever resumed back through here, `__omTurn` would be that plain object and calling `.end()`
* on it would throw a synchronous TypeError the surrounding `.catch()` could not trap. Only treat a
* value with a callable `end()` as a turn, so OM falls through to creating a fresh one. In practice
* OM reads the live turn from the in-memory map, so this is defensive.
*/
function asLiveTurn(value) {
	return value && typeof value.end === "function" ? value : void 0;
}
/**
* Processor adapter for ObservationalMemory.
*
* This class owns the agent-lifecycle orchestration — it decides *when* to
* load history, check thresholds, trigger observation/reflection, inject
* observations into context, and save messages. The actual OM operations
* are delegated to the Turn/Step handles which compose OM primitives.
*
* Processor-specific concerns (repro capture, progress emission, token
* persistence, continuation message) stay here — they're not part of the
* Turn/Step abstraction.
*/
function getOmObservabilityContext(args) {
	if (!args.tracing || !args.tracingContext || !args.loggerVNext || !args.metrics) return;
	return {
		tracing: args.tracing,
		tracingContext: args.tracingContext,
		loggerVNext: args.loggerVNext,
		metrics: args.metrics
	};
}
/** Key used to store gateway detection result in per-processor state. */
const GATEWAY_STATE_KEY = "__isGatewayModel";
/** Check if the model is routed through a Mastra gateway (duck-type check to avoid cross-package instanceof issues). */
function isMastraGatewayModel(model) {
	return typeof model === "object" && model !== null && "gatewayId" in model && model.gatewayId === "mastra";
}
function injectObservationContextMessages({ messageList, systemMessages, continuationMessage, threadId, resourceId }) {
	if (!systemMessages?.length) return;
	messageList.clearSystemMessages("observational-memory");
	for (const msg of systemMessages) messageList.addSystem(msg, "observational-memory");
	const contMsg = continuationMessage ?? {
		id: "om-continuation",
		role: "user",
		createdAt: /* @__PURE__ */ new Date(0),
		content: {
			format: 2,
			parts: [{
				type: "text",
				text: `<system-reminder>${OBSERVATION_CONTINUATION_HINT}</system-reminder>`
			}]
		},
		threadId,
		resourceId
	};
	messageList.add(contMsg, "memory");
}
var ObservationalMemoryProcessor = class {
	id = "observational-memory";
	name = "Observational Memory";
	/** The underlying ObservationalMemory engine. */
	engine;
	/** Memory instance for loading context. */
	memory;
	/** Whether temporal-gap reminder markers should be inserted. */
	temporalMarkers;
	/** Active turn — created on first processInputStep, ended on processOutputResult. */
	turn;
	constructor(engine, memory, options) {
		this.engine = engine;
		this.memory = memory;
		this.temporalMarkers = options?.temporalMarkers ?? false;
	}
	async processInputStep(args) {
		const { messageList, requestContext, stepNumber, state: _state, writer, model, abortSignal, abort, rotateResponseMessageId } = args;
		const state = _state ?? {};
		omDebug(`[OM:processInputStep:ENTER] step=${stepNumber}, hasMastraMemory=${!!requestContext?.get("MastraMemory")}, hasMemoryInfo=${!!messageList?.serialize()?.memoryInfo?.threadId}`);
		const context = this.engine.getThreadContext(requestContext, messageList);
		if (!context) {
			omDebug(`[OM:processInputStep:NO-CONTEXT] getThreadContext returned null — returning early`);
			return messageList;
		}
		if (isMastraGatewayModel(model)) {
			state[GATEWAY_STATE_KEY] = true;
			omDebug(`[OM:processInputStep:GATEWAY] gateway handles OM — skipping local processing`);
			return messageList;
		}
		const { threadId, resourceId } = context;
		const readOnly = parseMemoryRequestContext(requestContext)?.memoryConfig?.readOnly;
		const actorModelContext = model?.modelId ? {
			provider: model.provider,
			modelId: model.modelId,
			providerOptions: args.providerOptions
		} : void 0;
		state.__omActorModelContext = actorModelContext;
		return this.engine.getTokenCounter().runWithModelContext(actorModelContext, async () => {
			const reproCaptureEnabled = isOmReproCaptureEnabled();
			const preRecordSnapshot = reproCaptureEnabled ? safeCaptureJson(await this.engine.getOrCreateRecord(threadId, resourceId)) : null;
			const preMessagesSnapshot = reproCaptureEnabled ? safeCaptureJson(messageList.get.all.db()) : null;
			const preSerializedMessageList = reproCaptureEnabled ? safeCaptureJson(messageList.serialize()) : null;
			if (readOnly) {
				const ctx = await loadMemoryContextMessages({
					memory: this.memory,
					messageList,
					threadId,
					resourceId
				});
				const systemMessages = ctx.omRecord ? await this.engine.buildContextSystemMessages({
					threadId,
					resourceId,
					record: ctx.omRecord,
					unobservedContextBlocks: ctx.otherThreadsContext
				}) : void 0;
				injectObservationContextMessages({
					messageList,
					systemMessages,
					continuationMessage: ctx.continuationMessage,
					threadId,
					resourceId
				});
				return messageList;
			}
			const activeTurn = asLiveTurn(state.__omTurn) ?? this.turn;
			if (activeTurn && activeTurn.messageList !== messageList) {
				await activeTurn.end().catch(() => {});
				if (this.turn === activeTurn) this.turn = void 0;
				state.__omTurn = void 0;
			}
			if (!this.turn || !state.__omTurn) {
				if (this.turn && !state.__omTurn) await this.turn.end().catch(() => {});
				this.turn = this.engine.beginTurn({
					threadId,
					resourceId,
					messageList,
					agent: args.agent,
					observabilityContext: getOmObservabilityContext(args),
					hooks: {
						onBufferChunkSealed: rotateResponseMessageId,
						onSyncObservationComplete: rotateResponseMessageId
					}
				});
				this.turn.writer = writer;
				this.turn.sendSignal = args.sendSignal;
				this.turn.agent = args.agent;
				this.turn.requestContext = requestContext;
				await this.turn.start(this.memory);
				if (stepNumber === 0 && this.temporalMarkers) await insertTemporalGapMarkers({
					messageList,
					sendSignal: args.sendSignal
				});
				state.__omTurn = this.turn;
			}
			this.turn.addHooks({
				onBufferChunkSealed: rotateResponseMessageId,
				onSyncObservationComplete: rotateResponseMessageId
			});
			const observabilityContext = getOmObservabilityContext(args);
			state.__omObservabilityContext = observabilityContext;
			this.turn.observabilityContext = observabilityContext;
			this.turn.actorModelContext = actorModelContext;
			{
				const step = this.turn.step(stepNumber);
				let ctx;
				try {
					ctx = await step.prepare();
				} catch (error) {
					const err = error instanceof Error ? error : new Error(String(error));
					const abortMessage = abortSignal?.aborted ? "Agent execution was aborted" : `Encountered error during memory observation: ${err.message}`;
					if (typeof abort === "function") abort(abortMessage);
					throw err;
				}
				injectObservationContextMessages({
					messageList,
					systemMessages: ctx.systemMessage,
					continuationMessage: this.turn.context.continuation,
					threadId,
					resourceId
				});
				const freshRecord = await this.engine.getOrCreateRecord(threadId, resourceId);
				await this.engine.emitProgress({
					record: freshRecord,
					stepNumber,
					pendingTokens: ctx.status.pendingTokens,
					threshold: ctx.status.threshold,
					effectiveObservationTokensThreshold: ctx.status.effectiveObservationTokensThreshold,
					currentObservationTokens: freshRecord.observationTokenCount ?? 0,
					writer,
					threadId,
					resourceId
				});
				const allDbMsgs = messageList.get.all.db();
				const tokenCounter = this.engine.getTokenCounter();
				const contextTokens = await tokenCounter.countMessagesAsync(allDbMsgs);
				const otherThreadsContext = this.turn.context.otherThreadsContext;
				const finalTotalPending = contextTokens + (otherThreadsContext ? tokenCounter.countString(otherThreadsContext) : 0);
				await this.engine.getStorage().setPendingMessageTokens(freshRecord.id, finalTotalPending).catch(() => {});
				if (reproCaptureEnabled) writeProcessInputStepReproCapture({
					threadId,
					resourceId,
					stepNumber,
					args,
					preRecord: preRecordSnapshot,
					postRecord: safeCaptureJson(freshRecord),
					preMessages: preMessagesSnapshot,
					preBufferedChunks: [],
					preContextTokenCount: 0,
					preSerializedMessageList,
					postBufferedChunks: [],
					postContextTokenCount: finalTotalPending,
					messageList,
					details: {},
					observerExchange: ctx.observerExchange
				});
			}
			return messageList;
		});
	}
	async processOutputResult(args) {
		const { messageList, requestContext, state: _state } = args;
		const state = _state ?? {};
		const context = this.engine.getThreadContext(requestContext, messageList);
		if (!context) return messageList;
		if (state[GATEWAY_STATE_KEY]) return messageList;
		state.__omObservabilityContext = getOmObservabilityContext(args);
		return this.engine.getTokenCounter().runWithModelContext(state.__omActorModelContext, async () => {
			if (parseMemoryRequestContext(requestContext)?.memoryConfig?.readOnly) return messageList;
			const turn = asLiveTurn(state.__omTurn) ?? this.turn;
			if (turn) {
				await turn.end();
				this.turn = void 0;
				state.__omTurn = void 0;
			} else {
				const newOutput = messageList.get.response.db();
				const messagesToSave = [...messageList.get.input.db(), ...newOutput];
				if (messagesToSave.length > 0 && context.threadId) await this.engine.persistMessages(messagesToSave, context.threadId, context.resourceId);
			}
			return messageList;
		});
	}
	get config() {
		return this.engine.config;
	}
	async waitForBuffering(threadId, resourceId, timeoutMs) {
		return this.engine.waitForBuffering(threadId, resourceId, timeoutMs);
	}
	async getResolvedConfig(requestContext) {
		return this.engine.getResolvedConfig(requestContext);
	}
};
//#endregion
//#region src/processors/observational-memory/observation-utils.ts
const BOUNDARY_WITH_DATE_RE = /\n{2,}--- message boundary \((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z)\) ---\n{2,}/;
/**
* Given a raw `activeObservations` string (from an `ObservationalMemoryRecord`),
* return only the observation text that would have been visible at `asOf`.
*
* Each chunk boundary contains the `lastObservedAt` timestamp of the messages
* that were observed to produce the chunk that follows it. A chunk is included
* when its boundary date is ≤ `asOf` (meaning those observations existed before
* or at the target moment). The very first chunk has no preceding boundary and
* is always included.
*
* @param activeObservations - The full `activeObservations` string from the OM record
* @param asOf - The point in time to query (e.g. a message's `createdAt`)
* @returns The filtered observations string, or an empty string if none match
*/
function getObservationsAsOf(activeObservations, asOf) {
	const trimmed = activeObservations.trim();
	if (!trimmed) return "";
	const parts = trimmed.split(BOUNDARY_WITH_DATE_RE);
	const chunks = [];
	const firstChunk = parts[0]?.trim();
	if (firstChunk) chunks.push(firstChunk);
	for (let i = 1; i < parts.length; i += 2) {
		const dateStr = parts[i];
		const chunk = parts[i + 1]?.trim();
		if (!chunk) continue;
		const boundaryDate = new Date(dateStr);
		if (isNaN(boundaryDate.getTime())) continue;
		if (boundaryDate <= asOf) chunks.push(chunk);
	}
	return chunks.join("\n\n");
}
//#endregion
//#region src/processors/observational-memory/index.ts
var observational_memory_exports = /* @__PURE__ */ __exportAll({
	Extractor: () => Extractor,
	ModelByInputTokens: () => ModelByInputTokens,
	OBSERVATIONAL_MEMORY_DEFAULTS: () => OBSERVATIONAL_MEMORY_DEFAULTS,
	OBSERVATION_CONTEXT_INSTRUCTIONS: () => OBSERVATION_CONTEXT_INSTRUCTIONS,
	OBSERVATION_CONTEXT_PROMPT: () => OBSERVATION_CONTEXT_PROMPT,
	OBSERVATION_CONTINUATION_HINT: () => OBSERVATION_CONTINUATION_HINT,
	OBSERVER_SYSTEM_PROMPT: () => OBSERVER_SYSTEM_PROMPT,
	ObservationalMemory: () => ObservationalMemory,
	ObservationalMemoryProcessor: () => ObservationalMemoryProcessor,
	TokenCounter: () => TokenCounter,
	WorkingMemoryExtractor: () => WorkingMemoryExtractor,
	buildObserverPrompt: () => buildObserverPrompt,
	buildObserverSystemPrompt: () => buildObserverSystemPrompt,
	combineObservationGroupRanges: () => combineObservationGroupRanges,
	deriveObservationGroupProvenance: () => deriveObservationGroupProvenance,
	extractCurrentTask: () => extractCurrentTask,
	formatMessagesForObserver: () => formatMessagesForObserver,
	getObservationsAsOf: () => getObservationsAsOf,
	hasCurrentTaskSection: () => hasCurrentTaskSection,
	injectAnchorIds: () => injectAnchorIds,
	optimizeObservationsForContext: () => optimizeObservationsForContext,
	parseAnchorId: () => parseAnchorId,
	parseObservationGroups: () => parseObservationGroups,
	parseObserverOutput: () => parseObserverOutput,
	reconcileObservationGroupsFromReflection: () => reconcileObservationGroupsFromReflection,
	renderObservationGroupsForReflection: () => renderObservationGroupsForReflection,
	stripEphemeralAnchorIds: () => stripEphemeralAnchorIds,
	stripObservationGroups: () => stripObservationGroups,
	summarizeConversation: () => summarizeConversation,
	wrapInObservationGroup: () => wrapInObservationGroup
});
//#endregion
//#region src/processors/working-memory-state/processor.ts
/**
* WorkingMemoryStateProcessor
*
* Experimental: delivers working memory to the model as a state signal instead
* of folding it into the system message. Storage and the `setWorkingMemory`
* tool are unchanged — this processor only changes the delivery path.
*
* Pattern matches `BrowserContextProcessor` in `@mastra/core/browser`:
* - `stateId` namespaces the state lane on the thread.
* - `cacheKey` is derived from the rendered payload so dedup is automatic.
* - `contextWindow.hasSnapshot` re-injection ensures the model still sees the
*   current snapshot after older messages drop out of the window.
*
* Delta emission (markdown mode only): when a prior snapshot exists in the
* context window, the processor emits a unified-diff delta against that
* snapshot's contents. Schema mode and the snapshot fallback always emit a
* full snapshot.
*
* @example
* ```ts
* new Memory({
*   options: {
*     workingMemory: {
*       enabled: true,
*       template: '...',
*       useStateSignals: true, // auto-attaches this processor
*     },
*   },
* });
* ```
*/
const WORKING_MEMORY_STATE_ID = "working-memory";
const WORKING_MEMORY_STATE_PROCESSOR_ID = "working-memory-state";
var WorkingMemoryStateProcessor = class {
	memory;
	memoryConfig;
	id = WORKING_MEMORY_STATE_PROCESSOR_ID;
	stateId = WORKING_MEMORY_STATE_ID;
	constructor(memory, memoryConfig) {
		this.memory = memory;
		this.memoryConfig = memoryConfig;
	}
	async computeStateSignal(args) {
		const template = await this.memory.getWorkingMemoryTemplate({ memoryConfig: this.memoryConfig });
		if (!template) return;
		const contents = (await this.memory.getWorkingMemory({
			threadId: args.threadId,
			resourceId: args.resourceId,
			memoryConfig: this.memoryConfig
		}))?.trim();
		if (!contents) return;
		const cacheKey = stableWorkingMemoryCacheKey({
			format: template.format,
			data: contents
		});
		const shouldMakeSnapshot = !args.contextWindow.hasSnapshot;
		if (args.tracking?.currentCacheKey === cacheKey && !shouldMakeSnapshot) return;
		const scope = this.memory.getMergedThreadConfig(this.memoryConfig).workingMemory?.scope ?? "resource";
		const deltaCandidate = template.format === "markdown" && !shouldMakeSnapshot ? buildMarkdownDelta({
			lastSnapshot: args.lastSnapshot,
			deltasSinceSnapshot: args.deltasSinceSnapshot,
			nextContents: contents
		}) : void 0;
		if (deltaCandidate) return {
			id: WORKING_MEMORY_STATE_ID,
			mode: "delta",
			cacheKey,
			tagName: "working-memory",
			contents: deltaCandidate.contents,
			delta: deltaCandidate.contents,
			value: contents,
			attributes: {
				format: template.format,
				scope,
				patch: "unified-diff"
			}
		};
		return {
			id: WORKING_MEMORY_STATE_ID,
			mode: "snapshot",
			cacheKey,
			tagName: "working-memory",
			contents,
			value: contents,
			attributes: {
				format: template.format,
				scope
			}
		};
	}
};
/**
* Stable cache key for the rendered working memory payload. Returns a SHA-256
* digest so dedup metadata stays compact regardless of payload size (working
* memory blobs can grow arbitrarily long).
*/
function stableWorkingMemoryCacheKey(input) {
	const hash = createHash("sha256");
	hash.update(input.format);
	hash.update("\0");
	hash.update(input.data ?? "");
	return `sha256:${hash.digest("hex")}`;
}
/**
* Build a unified-diff delta against the most recently emitted state. Prefers
* the latest delta's `value` (the post-edit full text) when available, falling
* back to the snapshot's `value` and finally the snapshot's `contents`. This
* keeps deltas incremental (B→C) instead of cumulative against a stale
* snapshot (A→C), which matters when many small edits land between snapshots.
*
* Returns undefined when:
* - there's no prior state to diff against
* - the prior state isn't a plain string (multimodal signal)
*
* In either case the caller falls back to emitting a full snapshot.
*/
function buildMarkdownDelta(args) {
	const { lastSnapshot, deltasSinceSnapshot, nextContents } = args;
	const prior = pickStringValue(readSignalValue(deltasSinceSnapshot.at(-1))) ?? pickStringValue(readSignalValue(lastSnapshot)) ?? (typeof lastSnapshot?.contents === "string" ? lastSnapshot.contents : void 0);
	if (!prior) return;
	return { contents: renderHunksOnly(prior, nextContents) };
}
function pickStringValue(value) {
	return typeof value === "string" ? value : void 0;
}
function readSignalValue(signal) {
	return (signal?.metadata)?.value;
}
/**
* Render a unified-diff-style patch body containing only `@@` hunks and their
* lines — dropping the filename preamble (`Index:` / `===` / `---` / `+++`)
* that `createPatch` emits and the `\ No newline at end of file` trailer.
* The preamble exists for tooling like `patch -p1` to know which file to
* apply to; we only ever diff a single working-memory blob. The newline
* trailer is semantically meaningless to the model and adds noise to the
* state signal.
*/
function renderHunksOnly(prior, next) {
	const { hunks } = structuredPatch("", "", prior, next, "", "", { context: 0 });
	return hunks.map((hunk) => {
		return [`@@ -${hunk.oldStart},${hunk.oldLines} +${hunk.newStart},${hunk.newLines} @@`, ...hunk.lines.filter((line) => !line.startsWith("\\ No newline at end of file"))].join("\n");
	}).join("\n");
}
//#endregion
//#region src/processors/working-memory-state/index.ts
var working_memory_state_exports = /* @__PURE__ */ __exportAll({
	WORKING_MEMORY_STATE_ID: () => WORKING_MEMORY_STATE_ID,
	WORKING_MEMORY_STATE_PROCESSOR_ID: () => WORKING_MEMORY_STATE_PROCESSOR_ID,
	WorkingMemoryStateProcessor: () => WorkingMemoryStateProcessor
});
//#endregion
//#region src/index.ts
const WORKING_MEMORY_START_TAG = "<working_memory>";
const WORKING_MEMORY_END_TAG = "</working_memory>";
const LEGACY_SYSTEM_REMINDER_METADATA_KEY = "dynamicAgentsMdReminder";
function isRecord(value) {
	return typeof value === "object" && value !== null;
}
function extractWorkingMemoryTags(text) {
	const results = [];
	let pos = 0;
	while (pos < text.length) {
		const start = text.indexOf(WORKING_MEMORY_START_TAG, pos);
		if (start === -1) break;
		const end = text.indexOf(WORKING_MEMORY_END_TAG, start + 16);
		if (end === -1) break;
		results.push(text.substring(start, end + 17));
		pos = end + 17;
	}
	return results.length > 0 ? results : null;
}
function removeWorkingMemoryTags(text) {
	let result = "";
	let pos = 0;
	while (pos < text.length) {
		const start = text.indexOf(WORKING_MEMORY_START_TAG, pos);
		if (start === -1) {
			result += text.substring(pos);
			break;
		}
		result += text.substring(pos, start);
		const end = text.indexOf(WORKING_MEMORY_END_TAG, start + 16);
		if (end === -1) {
			result += text.substring(start);
			break;
		}
		pos = end + 17;
	}
	return result;
}
function extractWorkingMemoryContent(text) {
	const start = text.indexOf(WORKING_MEMORY_START_TAG);
	if (start === -1) return null;
	const contentStart = start + 16;
	const end = text.indexOf(WORKING_MEMORY_END_TAG, contentStart);
	if (end === -1) return null;
	return text.substring(contentStart, end);
}
function isSystemReminderMessage(message) {
	if (!isRecord(message.content)) return false;
	const metadata = message.content.metadata;
	if (message.role === "signal") return isRecord(metadata) && isRecord(metadata.signal) && (metadata.signal.type === "system-reminder" || metadata.signal.type === "reactive");
	if (message.role !== "user") return false;
	if (isRecord(metadata) && (isRecord(metadata.systemReminder) || LEGACY_SYSTEM_REMINDER_METADATA_KEY in metadata)) return true;
	const firstTextPart = message.content.parts.find((part) => part.type === "text");
	return typeof firstTextPart?.text === "string" && firstTextPart.text.startsWith("<system-reminder");
}
function filterSystemReminderMessages(messages, includeSystemReminders) {
	if (includeSystemReminders) return messages;
	return messages.filter((message) => !isSystemReminderMessage(message));
}
function normalizeObservationalMemoryConfig(config) {
	if (config === true) return { model: "google/gemini-2.5-flash" };
	if (config === false || config === void 0) return void 0;
	if (typeof config === "object" && config.enabled === false) return void 0;
	return config;
}
function hasWorkingMemoryExtractor(extractors) {
	return !!extractors?.some((extractor) => extractor.slug === "working-memory");
}
const CHARS_PER_TOKEN = 4;
const DEFAULT_MESSAGE_RANGE = {
	before: 1,
	after: 1
};
const DEFAULT_TOP_K = 4;
const VECTOR_DELETE_BATCH_SIZE = 100;
const DEFAULT_EMBEDDING_CACHE_MAX_SIZE = 1e3;
/**
* Concrete implementation of MastraMemory that adds support for thread configuration
* and message injection.
*/
var Memory = class extends MastraMemory {
	_omEngine;
	_omEngineInstance;
	_mastraInstance;
	/** The shared ObservationalMemory engine. Lazily created on first access. */
	get omEngine() {
		if (!this._omEngine) this._omEngine = this._initOMEngine().then((engine) => {
			this._omEngineInstance = engine;
			if (engine && this._mastraInstance) engine.__registerMastra(this._mastraInstance);
			return engine;
		});
		return this._omEngine;
	}
	__registerMastra(mastra) {
		super.__registerMastra(mastra);
		this._mastraInstance = mastra;
		if (this._omEngineInstance) this._omEngineInstance.__registerMastra(mastra);
		else this._omEngine?.then((engine) => engine?.__registerMastra(mastra));
	}
	getMergedThreadConfig(config) {
		return this.applyManagedWorkingMemoryDefaults(super.getMergedThreadConfig(config));
	}
	applyManagedWorkingMemoryDefaults(config) {
		const omConfig = normalizeObservationalMemoryConfig(config.observationalMemory);
		if (!omConfig?.observation?.manageWorkingMemory || !config.workingMemory?.enabled) return config;
		const currentWorkingMemory = config.workingMemory;
		const workingMemory = {
			...currentWorkingMemory,
			agentManaged: currentWorkingMemory.agentManaged ?? false,
			useStateSignals: currentWorkingMemory.useStateSignals ?? true
		};
		const observation = omConfig.observation ?? {};
		const extract = observation.extract ?? [];
		return {
			...config,
			workingMemory,
			observationalMemory: {
				...omConfig,
				observation: {
					...observation,
					extract: hasWorkingMemoryExtractor(extract) ? extract : [...extract, new WorkingMemoryExtractor()]
				}
			}
		};
	}
	constructor(config = {}) {
		super({
			name: "Memory",
			...config
		});
		const mergedConfig = this.getMergedThreadConfig({
			workingMemory: config.options?.workingMemory || {
				enabled: false,
				template: this.defaultWorkingMemoryTemplate
			},
			observationalMemory: config.options?.observationalMemory
		});
		this.assertWorkingMemoryStateSignalsCompatibility(mergedConfig);
		this.threadConfig = mergedConfig;
		const omConfig = normalizeObservationalMemoryConfig(mergedConfig.observationalMemory);
		if (omConfig?.retrieval && typeof omConfig.retrieval === "object" && omConfig.retrieval.vector) {
			if (!this.vector) throw new Error("`retrieval: { vector: true }` requires a vector store. Pass a `vector` option to your Memory instance.");
			if (!this.embedder) throw new Error("`retrieval: { vector: true }` requires an embedder. Pass an `embedder` option to your Memory instance.");
		}
	}
	/**
	* Gets the memory storage domain, throwing if not available.
	*/
	async getMemoryStore() {
		const store = await this.storage.getStore("memory");
		if (!store) throw new Error(`Memory storage domain is not available on ${this.storage.constructor.name}`);
		return store;
	}
	async listMessagesByResourceId(args) {
		return (await this.getMemoryStore()).listMessagesByResourceId(args);
	}
	async validateThreadIsOwnedByResource(threadId, resourceId, config) {
		const resourceScope = typeof config?.semanticRecall === "object" && config?.semanticRecall?.scope !== `thread` || config.semanticRecall === true;
		const thread = await this.getThreadById({ threadId });
		if (!thread && !resourceScope) throw new Error(`No thread found with id ${threadId}`);
		if (thread && thread.resourceId !== resourceId) throw new Error(`Thread with id ${threadId} is for resource with id ${thread.resourceId} but resource ${resourceId} was queried.`);
	}
	createMemorySpan(operationType, observabilityContext, input, attributes) {
		const currentSpan = observabilityContext?.tracingContext?.currentSpan;
		if (!currentSpan) return void 0;
		return currentSpan.createChildSpan({
			type: SpanType.MEMORY_OPERATION,
			name: `memory: ${operationType}`,
			entityType: EntityType.MEMORY,
			entityName: "Memory",
			input,
			attributes: {
				operationType,
				...attributes
			}
		});
	}
	async recall(args) {
		const { threadId, resourceId, perPage: perPageArg, page, orderBy, threadConfig, vectorSearchString, includeSystemReminders, filter } = args;
		const config = this.getMergedThreadConfig(threadConfig || {});
		const semanticRecallEnabled = Boolean(config.semanticRecall);
		const span = this.createMemorySpan("recall", args.observabilityContext, {
			threadId,
			resourceId,
			vectorSearchString
		}, {
			semanticRecallEnabled,
			lastMessages: config.lastMessages
		});
		try {
			if (resourceId) await this.validateThreadIsOwnedByResource(threadId, resourceId, config);
			const perPage = perPageArg !== void 0 ? perPageArg : config.lastMessages;
			const historyDisabledByConfig = config.lastMessages === false && perPageArg === void 0;
			const shouldGetNewestAndReverse = !orderBy && perPage !== false;
			const effectiveOrderBy = shouldGetNewestAndReverse ? {
				field: "createdAt",
				direction: "DESC"
			} : orderBy;
			const vectorResults = [];
			this.logger.debug("Memory recall", {
				threadId,
				perPage,
				page,
				orderBy: effectiveOrderBy,
				hasWorkingMemorySchema: Boolean(config.workingMemory?.schema),
				workingMemoryEnabled: config.workingMemory?.enabled,
				semanticRecallEnabled,
				historyDisabledByConfig
			});
			const defaultRange = DEFAULT_MESSAGE_RANGE;
			const defaultTopK = DEFAULT_TOP_K;
			const vectorConfig = typeof config?.semanticRecall === `boolean` ? {
				topK: defaultTopK,
				messageRange: defaultRange
			} : {
				topK: config?.semanticRecall?.topK ?? defaultTopK,
				messageRange: config?.semanticRecall?.messageRange ?? defaultRange
			};
			const resourceScope = typeof config?.semanticRecall === "object" && config?.semanticRecall?.scope !== `thread` || config.semanticRecall === true;
			if (resourceScope && !resourceId && config?.semanticRecall && vectorSearchString) throw new Error("Memory error: Resource-scoped semantic recall is enabled but no resourceId was provided. Either provide a resourceId or explicitly set semanticRecall.scope to 'thread'.");
			let usage;
			if (historyDisabledByConfig && (!config.semanticRecall || !vectorSearchString || !this.vector)) {
				const result = {
					messages: [],
					usage: void 0,
					total: 0,
					page: page ?? 0,
					perPage: 0,
					hasMore: false
				};
				span?.end({
					output: { success: true },
					attributes: { messageCount: 0 }
				});
				return result;
			}
			if (config?.semanticRecall && vectorSearchString && this.vector) {
				const result = await this.embedMessageContent(vectorSearchString);
				usage = result.usage;
				const { embeddings, dimension } = result;
				const { indexName } = await this.createEmbeddingIndex(dimension, config);
				await Promise.all(embeddings.map(async (embedding) => {
					if (typeof this.vector === `undefined`) throw new Error(`Tried to query vector index ${indexName} but this Memory instance doesn't have an attached vector db.`);
					const scopeFilter = resourceScope ? { resource_id: resourceId } : { thread_id: threadId };
					const userFilter = typeof config.semanticRecall === "object" ? config.semanticRecall.filter : void 0;
					const combinedFilter = userFilter ? { $and: [scopeFilter, userFilter] } : scopeFilter;
					vectorResults.push(...await this.vector.query({
						indexName,
						queryVector: embedding,
						topK: vectorConfig.topK,
						filter: combinedFilter
					}));
				}));
			}
			const threshold = (typeof config.semanticRecall === "object" ? config.semanticRecall : void 0)?.threshold;
			const filteredVectorResults = threshold !== void 0 ? vectorResults.filter((r) => r.score >= threshold) : vectorResults;
			const memoryStore = await this.getMemoryStore();
			const effectivePerPage = historyDisabledByConfig ? 0 : perPage;
			const paginatedResult = await memoryStore.listMessages({
				threadId,
				resourceId,
				perPage: effectivePerPage,
				page,
				orderBy: effectiveOrderBy,
				filter,
				...filteredVectorResults?.length ? { include: filteredVectorResults.map((r) => ({
					id: r.metadata?.message_id,
					threadId: r.metadata?.thread_id,
					withNextMessages: typeof vectorConfig.messageRange === "number" ? vectorConfig.messageRange : vectorConfig.messageRange.after,
					withPreviousMessages: typeof vectorConfig.messageRange === "number" ? vectorConfig.messageRange : vectorConfig.messageRange.before
				})) } : {}
			});
			const rawMessages = shouldGetNewestAndReverse ? paginatedResult.messages.reverse() : paginatedResult.messages;
			const messages = filterSystemReminderMessages(new MessageList({
				threadId,
				resourceId
			}).add(rawMessages, "memory").get.all.db(), includeSystemReminders);
			const { total, page: resultPage, perPage: resultPerPage, hasMore } = paginatedResult;
			const recallResult = {
				messages,
				usage,
				total,
				page: resultPage,
				perPage: resultPerPage,
				hasMore
			};
			span?.end({
				output: { success: true },
				attributes: {
					messageCount: messages.length,
					embeddingTokens: usage?.tokens,
					vectorResultCount: vectorResults.length
				}
			});
			return recallResult;
		} catch (error) {
			span?.error({
				error,
				endSpan: true
			});
			throw error;
		}
	}
	async getThreadById({ threadId, resourceId }) {
		return (await this.getMemoryStore()).getThreadById({
			threadId,
			resourceId
		});
	}
	async listThreads(args) {
		return (await this.getMemoryStore()).listThreads(args);
	}
	async handleWorkingMemoryFromMetadata({ workingMemory, resourceId, memoryConfig }) {
		const config = this.getMergedThreadConfig(memoryConfig || {});
		if (config.workingMemory?.enabled) {
			if ((config.workingMemory.scope || "resource") === "resource" && resourceId) await (await this.getMemoryStore()).updateResource({
				resourceId,
				workingMemory
			});
		}
	}
	async saveThread({ thread, memoryConfig }) {
		const savedThread = await (await this.getMemoryStore()).saveThread({ thread });
		if (thread.metadata?.workingMemory && typeof thread.metadata.workingMemory === "string" && thread.resourceId) await this.handleWorkingMemoryFromMetadata({
			workingMemory: thread.metadata.workingMemory,
			resourceId: thread.resourceId,
			memoryConfig
		});
		return savedThread;
	}
	async updateThread({ id, title, metadata, memoryConfig }) {
		const updatedThread = await (await this.getMemoryStore()).updateThread({
			id,
			title,
			metadata
		});
		if (metadata?.workingMemory && typeof metadata.workingMemory === "string" && updatedThread.resourceId) await this.handleWorkingMemoryFromMetadata({
			workingMemory: metadata.workingMemory,
			resourceId: updatedThread.resourceId,
			memoryConfig
		});
		return updatedThread;
	}
	async deleteThread(threadId) {
		const memoryStore = await this.getMemoryStore();
		const thread = await memoryStore.getThreadById({ threadId });
		await memoryStore.deleteThread({ threadId });
		if (thread?.resourceId && memoryStore.supportsObservationalMemory) await memoryStore.clearObservationalMemory(threadId, thread.resourceId);
		if (this.vector) this.deleteThreadVectors(threadId);
	}
	/**
	* Lists all vector indexes that match the memory messages prefix.
	* Handles separator differences across vector store backends (e.g. '_' vs '-').
	*/
	async getMemoryVectorIndexes() {
		if (!this.vector) return [];
		const prefix = `memory${this.vector.indexSeparator ?? "_"}messages`;
		return (await this.vector.listIndexes()).filter((name) => name.startsWith(prefix));
	}
	/**
	* Deletes all vector embeddings associated with a thread.
	* This is called internally by deleteThread to clean up orphaned vectors.
	*
	* @param threadId - The ID of the thread whose vectors should be deleted
	*/
	async deleteThreadVectors(threadId) {
		try {
			const memoryIndexes = await this.getMemoryVectorIndexes();
			await Promise.all(memoryIndexes.map(async (indexName) => {
				try {
					await this.vector.deleteVectors({
						indexName,
						filter: { thread_id: threadId }
					});
				} catch {
					this.logger.debug("Failed to delete vectors for thread, skipping", {
						threadId,
						indexName
					});
				}
			}));
		} catch {
			this.logger.debug("Failed to clean up vectors for thread", { threadId });
		}
	}
	async updateWorkingMemory({ threadId, resourceId, workingMemory, memoryConfig, observabilityContext }) {
		const config = this.getMergedThreadConfig(memoryConfig || {});
		if (!config.workingMemory?.enabled) throw new Error("Working memory is not enabled for this memory instance");
		const span = this.createMemorySpan("update", observabilityContext, {
			threadId,
			resourceId
		}, { workingMemoryEnabled: true });
		try {
			const scope = config.workingMemory.scope || "resource";
			if (scope === "resource" && !resourceId) throw new Error("Memory error: Resource-scoped working memory is enabled but no resourceId was provided. Either provide a resourceId or explicitly set workingMemory.scope to 'thread'.");
			const mutexKey = scope === "resource" ? `resource-${resourceId}` : `thread-${threadId}`;
			const mutex = this.updateWorkingMemoryMutexes.has(mutexKey) ? this.updateWorkingMemoryMutexes.get(mutexKey) : new Mutex();
			this.updateWorkingMemoryMutexes.set(mutexKey, mutex);
			const release = await mutex.acquire();
			try {
				const memoryStore = await this.getMemoryStore();
				if (scope === "resource" && resourceId) await memoryStore.updateResource({
					resourceId,
					workingMemory
				});
				else {
					const thread = await this.getThreadById({ threadId });
					if (!thread) throw new Error(`Thread ${threadId} not found`);
					await memoryStore.updateThread({
						id: threadId,
						title: thread.title || "",
						metadata: {
							...thread.metadata,
							workingMemory
						}
					});
				}
			} finally {
				release();
			}
			span?.end({ output: { success: true } });
		} catch (error) {
			span?.error({
				error,
				endSpan: true
			});
			throw error;
		}
	}
	updateWorkingMemoryMutexes = /* @__PURE__ */ new Map();
	/**
	* @warning experimental! can be removed or changed at any time
	*/
	async __experimental_updateWorkingMemoryVNext({ threadId, resourceId, workingMemory, searchString, memoryConfig }) {
		const config = this.getMergedThreadConfig(memoryConfig || {});
		this.assertWorkingMemoryStateSignalsCompatibility(config);
		if (!config.workingMemory?.enabled) throw new Error("Working memory is not enabled for this memory instance");
		const mutexKey = memoryConfig?.workingMemory?.scope === `resource` ? `resource-${resourceId}` : `thread-${threadId}`;
		const mutex = this.updateWorkingMemoryMutexes.has(mutexKey) ? this.updateWorkingMemoryMutexes.get(mutexKey) : new Mutex();
		this.updateWorkingMemoryMutexes.set(mutexKey, mutex);
		const release = await mutex.acquire();
		try {
			const existingWorkingMemory = await this.getWorkingMemory({
				threadId,
				resourceId,
				memoryConfig
			}) || "";
			const template = await this.getWorkingMemoryTemplate({ memoryConfig });
			let reason = "";
			const templateContent = typeof template?.content === "string" ? template.content : null;
			const normalizeForComparison = (str) => str.replace(/\s+/g, " ").trim();
			const normalizedNewMemory = normalizeForComparison(workingMemory);
			const normalizedTemplate = templateContent ? normalizeForComparison(templateContent) : "";
			if (existingWorkingMemory) if (searchString && existingWorkingMemory?.includes(searchString)) {
				workingMemory = existingWorkingMemory.replace(searchString, workingMemory);
				reason = `found and replaced searchString with newMemory`;
			} else if (existingWorkingMemory.includes(workingMemory) || templateContent?.trim() === workingMemory.trim() || normalizedNewMemory === normalizedTemplate) return {
				success: false,
				reason: `attempted to insert duplicate data into working memory. this entry was skipped`
			};
			else {
				if (normalizedNewMemory === normalizedTemplate) return {
					success: false,
					reason: `attempted to append empty template to working memory. this entry was skipped`
				};
				if (searchString) reason = `attempted to replace working memory string that doesn't exist. Appending to working memory instead.`;
				else reason = `appended newMemory to end of working memory`;
				workingMemory = existingWorkingMemory + `
${workingMemory}`;
			}
			else if (workingMemory === templateContent || normalizedNewMemory === normalizedTemplate) return {
				success: false,
				reason: `try again when you have data to add. newMemory was equal to the working memory template`
			};
			else reason = `started new working memory`;
			if (templateContent) {
				workingMemory = workingMemory.replaceAll(templateContent, "");
				const templateWithUnixLineEndings = templateContent.replace(/\r\n/g, "\n");
				const templateWithWindowsLineEndings = templateContent.replace(/\n/g, "\r\n");
				workingMemory = workingMemory.replaceAll(templateWithUnixLineEndings, "");
				workingMemory = workingMemory.replaceAll(templateWithWindowsLineEndings, "");
			}
			const scope = config.workingMemory.scope || "resource";
			if (scope === "resource" && !resourceId) throw new Error("Memory error: Resource-scoped working memory is enabled but no resourceId was provided. Either provide a resourceId or explicitly set workingMemory.scope to 'thread'.");
			const memoryStore = await this.getMemoryStore();
			if (scope === "resource" && resourceId) {
				await memoryStore.updateResource({
					resourceId,
					workingMemory
				});
				if (reason) return {
					success: true,
					reason
				};
			} else {
				const thread = await this.getThreadById({ threadId });
				if (!thread) throw new Error(`Thread ${threadId} not found`);
				await memoryStore.updateThread({
					id: threadId,
					title: thread.title || "",
					metadata: {
						...thread.metadata,
						workingMemory
					}
				});
			}
			return {
				success: true,
				reason
			};
		} catch (e) {
			this.logger.error(e instanceof Error ? e.stack || e.message : JSON.stringify(e));
			return {
				success: false,
				reason: "Tool error."
			};
		} finally {
			release();
		}
	}
	chunkText(text, tokenSize = 4096) {
		const charSize = tokenSize * CHARS_PER_TOKEN;
		const chunks = [];
		let currentChunk = "";
		const words = text.split(/\s+/);
		for (const word of words) {
			if (word.length > charSize) {
				if (currentChunk) {
					chunks.push(currentChunk);
					currentChunk = "";
				}
				for (let i = 0; i < word.length; i += charSize) chunks.push(word.slice(i, i + charSize));
				continue;
			}
			const wordWithSpace = currentChunk ? " " + word : word;
			if (currentChunk.length + wordWithSpace.length > charSize) {
				if (currentChunk) chunks.push(currentChunk);
				currentChunk = word;
			} else currentChunk += wordWithSpace;
		}
		if (currentChunk) chunks.push(currentChunk);
		return chunks;
	}
	hasher = xxhash();
	embeddingCache = new LRUCache({ max: DEFAULT_EMBEDDING_CACHE_MAX_SIZE });
	firstEmbed;
	async embedMessageContent(content) {
		const key = (await this.hasher).h64(content);
		const cached = this.embeddingCache.get(key);
		if (cached) {
			this.logger.debug("Embedding cache hit", {
				contentHash: key.toString(),
				chunks: cached.chunks.length
			});
			return cached;
		}
		const chunks = this.chunkText(content);
		if (typeof this.embedder === `undefined`) throw new Error(`Tried to embed message content but this Memory instance doesn't have an attached embedder.`);
		const isFastEmbed = this.embedder.provider === `fastembed`;
		if (isFastEmbed && this.firstEmbed instanceof Promise) await this.firstEmbed;
		let embedFn;
		switch (this.embedder.specificationVersion) {
			case "v3":
				embedFn = embedMany;
				break;
			case "v2":
				embedFn = embedMany$1;
				break;
			default:
				embedFn = embedMany$2;
				break;
		}
		const promise = embedFn({
			values: chunks,
			maxRetries: 3,
			model: this.embedder,
			...this.embedderOptions || {}
		});
		if (isFastEmbed && !this.firstEmbed) this.firstEmbed = promise;
		const { embeddings, usage } = await promise;
		const result = {
			embeddings,
			chunks,
			usage,
			dimension: embeddings[0]?.length
		};
		this.embeddingCache.set(key, result);
		return result;
	}
	async saveMessages({ messages, memoryConfig, observabilityContext }) {
		const span = this.createMemorySpan("save", observabilityContext, void 0, { messageCount: messages.length });
		try {
			const updatedMessages = messages.filter((m) => m.role !== "system").map((m) => {
				return this.updateMessageToHideWorkingMemoryV2(m);
			}).filter((m) => Boolean(m));
			const config = this.getMergedThreadConfig(memoryConfig);
			const dbMessages = new MessageList({ generateMessageId: () => this.generateId() }).add(updatedMessages, "memory").get.all.db();
			const memoryStore = await this.getMemoryStore();
			const result = await memoryStore.saveMessages({ messages: dbMessages });
			let totalTokens = 0;
			if (this.vector && config.semanticRecall) {
				const messagesByThread = /* @__PURE__ */ new Map();
				updatedMessages.forEach((message) => {
					if (message.threadId) {
						if (!messagesByThread.has(message.threadId)) messagesByThread.set(message.threadId, []);
						messagesByThread.get(message.threadId).push(message);
					}
				});
				const threadMetadataMap = /* @__PURE__ */ new Map();
				await Promise.all(Array.from(messagesByThread.keys()).map(async (threadId) => {
					try {
						const thread = await memoryStore.getThreadById({ threadId });
						if (thread?.metadata) threadMetadataMap.set(threadId, thread.metadata);
					} catch (error) {
						const message = error instanceof Error ? error.message : String(error);
						throw new Error(`Could not fetch metadata for thread ${threadId} while saving semantic recall embeddings: ${message}`);
					}
				}));
				const embeddingData = [];
				let dimension;
				await Promise.all(updatedMessages.map(async (message) => {
					let textForEmbedding = null;
					if (message.content.content && typeof message.content.content === "string" && message.content.content.trim() !== "") textForEmbedding = message.content.content;
					else if (message.content.parts && message.content.parts.length > 0) {
						const joined = message.content.parts.filter((part) => part.type === "text").map((part) => part.text).join(" ").trim();
						if (joined) textForEmbedding = joined;
					}
					if (!textForEmbedding) return;
					const result = await this.embedMessageContent(textForEmbedding);
					dimension = result.dimension;
					if (result.usage?.tokens) totalTokens += result.usage.tokens;
					const threadMetadata = message.threadId ? threadMetadataMap.get(message.threadId) || {} : {};
					embeddingData.push({
						embeddings: result.embeddings,
						metadata: result.chunks.map(() => ({
							...threadMetadata,
							message_id: message.id,
							thread_id: message.threadId,
							resource_id: message.resourceId,
							role: message.role,
							content: textForEmbedding,
							created_at: message.createdAt instanceof Date ? message.createdAt.toISOString() : String(message.createdAt)
						}))
					});
				}));
				if (embeddingData.length > 0 && dimension !== void 0) {
					if (typeof this.vector === `undefined`) throw new Error(`Tried to upsert embeddings but this Memory instance doesn't have an attached vector db.`);
					const { indexName } = await this.createEmbeddingIndex(dimension, config);
					const allVectors = [];
					const allMetadata = [];
					for (const data of embeddingData) {
						allVectors.push(...data.embeddings);
						allMetadata.push(...data.metadata);
					}
					await this.vector.upsert({
						indexName,
						vectors: allVectors,
						metadata: allMetadata
					});
				}
			}
			const saveResult = {
				...result,
				usage: totalTokens > 0 ? { tokens: totalTokens } : void 0
			};
			span?.end({
				output: { success: true },
				attributes: {
					messageCount: dbMessages.length,
					embeddingTokens: saveResult.usage?.tokens,
					semanticRecallEnabled: Boolean(config.semanticRecall)
				}
			});
			return saveResult;
		} catch (error) {
			span?.error({
				error,
				endSpan: true
			});
			throw error;
		}
	}
	updateMessageToHideWorkingMemoryV2(message) {
		const newMessage = { ...message };
		if (message.content && typeof message.content === "object" && !Array.isArray(message.content)) newMessage.content = { ...message.content };
		if (typeof newMessage.content?.content === "string" && newMessage.content.content.length > 0) newMessage.content.content = removeWorkingMemoryTags(newMessage.content.content).trim();
		if (Array.isArray(newMessage.content?.parts)) {
			newMessage.content.parts = newMessage.content.parts.filter((part) => {
				if (part?.type === "tool-invocation") return part.toolInvocation?.toolName !== "updateWorkingMemory";
				return true;
			}).map((part) => {
				if (part?.type === "text") {
					const text = typeof part.text === "string" ? part.text : "";
					return {
						...part,
						text: removeWorkingMemoryTags(text).trim()
					};
				}
				return part;
			});
			if (newMessage.content.parts.length === 0) {
				if (!(typeof newMessage.content.content === "string" && newMessage.content.content.trim().length > 0)) return null;
			}
		}
		return newMessage;
	}
	parseWorkingMemory(text) {
		if (!this.threadConfig.workingMemory?.enabled) return null;
		return extractWorkingMemoryContent(text)?.trim() ?? null;
	}
	async getWorkingMemory({ threadId, resourceId, memoryConfig }) {
		const config = this.getMergedThreadConfig(memoryConfig || {});
		if (!config.workingMemory?.enabled) return null;
		const scope = config.workingMemory.scope || "resource";
		let workingMemoryData = null;
		if (scope === "resource" && !resourceId) throw new Error("Memory error: Resource-scoped working memory is enabled but no resourceId was provided. Either provide a resourceId or explicitly set workingMemory.scope to 'thread'.");
		if (scope === "resource" && resourceId) workingMemoryData = (await (await this.getMemoryStore()).getResourceById({ resourceId }))?.workingMemory || null;
		else workingMemoryData = (await this.getThreadById({ threadId }))?.metadata?.workingMemory;
		if (!workingMemoryData) return null;
		return workingMemoryData;
	}
	/**
	* Gets the working memory template for the current memory configuration.
	* Supports both ZodObject and JSONSchema7 schemas.
	*
	* @param memoryConfig - The memory configuration containing the working memory settings
	* @returns The working memory template with format and content, or null if working memory is disabled
	*/
	async getWorkingMemoryTemplate({ memoryConfig }) {
		const config = this.getMergedThreadConfig(memoryConfig);
		if (!config.workingMemory?.enabled) return null;
		if (config.workingMemory?.schema) try {
			const schema = config.workingMemory.schema;
			let convertedSchema;
			if (isStandardSchemaWithJSON(schema)) convertedSchema = schema["~standard"].jsonSchema.output({ target: "draft-07" });
			else convertedSchema = toStandardSchema(schema)["~standard"].jsonSchema.output({ target: "draft-07" });
			return {
				format: "json",
				content: JSON.stringify(convertedSchema)
			};
		} catch (error) {
			this.logger.error("Error converting schema", error);
			throw error;
		}
		return {
			format: "markdown",
			content: (config.workingMemory.template || this.defaultWorkingMemoryTemplate).trim()
		};
	}
	async getSystemMessage({ threadId, resourceId, memoryConfig }) {
		const config = this.getMergedThreadConfig(memoryConfig);
		this.assertWorkingMemoryStateSignalsCompatibility(config);
		if (!config.workingMemory?.enabled) return null;
		if (config.workingMemory?.useStateSignals) return null;
		const workingMemoryTemplate = await this.getWorkingMemoryTemplate({ memoryConfig });
		const workingMemoryData = await this.getWorkingMemory({
			threadId,
			resourceId,
			memoryConfig: config
		});
		if (!workingMemoryTemplate) return null;
		const workingMemoryConfig = config.workingMemory;
		if (config?.readOnly || workingMemoryConfig.agentManaged === false) return this.getReadOnlyWorkingMemoryInstruction({
			template: workingMemoryTemplate,
			data: workingMemoryData
		});
		return this.isVNextWorkingMemoryConfig(memoryConfig) ? this.__experimental_getWorkingMemoryToolInstructionVNext({
			template: workingMemoryTemplate,
			data: workingMemoryData
		}) : this.getWorkingMemoryToolInstruction({
			template: workingMemoryTemplate,
			data: workingMemoryData
		});
	}
	/**
	* Get everything needed for an LLM call in one shot.
	*
	* Assembles the system message (observations + working memory), loads
	* unobserved messages from storage, and returns them ready to use.
	*
	* @example
	* ```ts
	* const ctx = await memory.getContext({ threadId });
	* const result = await generateText({
	*   model: openai('gpt-4o'),
	*   system: ctx.systemMessage,
	*   messages: ctx.messages.map(toAiSdkMessage),
	* });
	* ```
	*/
	async getContext(opts) {
		const { threadId, resourceId, memoryConfig } = opts;
		const config = this.getMergedThreadConfig(memoryConfig);
		const memoryStore = await this.getMemoryStore();
		const systemParts = [];
		let hasObservations = false;
		let omRecord = null;
		let continuationMessage;
		let otherThreadsContext;
		const omEngine = await this.omEngine;
		if (omEngine) {
			omRecord = await omEngine.getRecord(threadId, resourceId);
			if (omRecord?.activeObservations) {
				hasObservations = true;
				if (omEngine.scope === "resource" && resourceId) otherThreadsContext = await omEngine.getOtherThreadsContext(resourceId, threadId);
				const obsSystemMessage = await omEngine.buildContextSystemMessage({
					threadId,
					resourceId,
					record: omRecord,
					unobservedContextBlocks: otherThreadsContext
				});
				if (obsSystemMessage) systemParts.push(obsSystemMessage);
				const { OBSERVATION_CONTINUATION_HINT } = await Promise.resolve().then(() => constants_exports);
				continuationMessage = {
					id: "om-continuation",
					role: "user",
					createdAt: /* @__PURE__ */ new Date(0),
					content: {
						format: 2,
						parts: [{
							type: "text",
							text: `<system-reminder>${OBSERVATION_CONTINUATION_HINT}</system-reminder>`
						}]
					},
					threadId,
					resourceId
				};
			}
		}
		const workingMemoryMessage = await this.getSystemMessage({
			threadId,
			resourceId,
			memoryConfig: config
		});
		if (workingMemoryMessage) systemParts.push(workingMemoryMessage);
		let messages;
		if (omEngine && omRecord) {
			const dateFilter = omRecord.lastObservedAt ? { dateRange: { start: new Date(new Date(omRecord.lastObservedAt).getTime() + 1) } } : void 0;
			if (omEngine.scope === "resource" && resourceId) messages = (await memoryStore.listMessagesByResourceId({
				resourceId,
				orderBy: {
					field: "createdAt",
					direction: "ASC"
				},
				perPage: false,
				filter: dateFilter
			})).messages;
			else messages = (await memoryStore.listMessages({
				threadId,
				orderBy: {
					field: "createdAt",
					direction: "ASC"
				},
				perPage: false,
				filter: dateFilter
			})).messages;
		} else {
			const lastMessages = config.lastMessages;
			if (lastMessages === false) messages = [];
			else messages = (await memoryStore.listMessages({
				threadId,
				resourceId,
				orderBy: {
					field: "createdAt",
					direction: "DESC"
				},
				perPage: typeof lastMessages === "number" ? lastMessages : void 0
			})).messages.reverse();
		}
		return {
			systemMessage: systemParts.length > 0 ? systemParts.join("\n\n") : void 0,
			messages,
			hasObservations,
			omRecord,
			continuationMessage,
			otherThreadsContext
		};
	}
	/**
	* Raw message upsert — persist messages to storage without embedding or working memory processing.
	* Used by the processor to save sealed messages before firing a background buffer operation.
	*/
	async persistMessages(messages) {
		if (messages.length === 0) return;
		const persistableMessages = messages.filter((m) => m.role !== "system");
		if (persistableMessages.length === 0) return;
		await (await this.getMemoryStore()).saveMessages({ messages: persistableMessages });
	}
	/**
	* One-time initialization of the shared ObservationalMemory engine.
	* Called lazily by the `omEngine` getter on first access.
	*/
	async _initOMEngine() {
		const omConfig = normalizeObservationalMemoryConfig(this.threadConfig.observationalMemory);
		if (!omConfig) return null;
		const memoryStore = await this.storage.getStore("memory");
		if (!memoryStore || !memoryStore.supportsObservationalMemory) return null;
		if (!coreFeatures.has("observationalMemory")) throw new Error("Observational memory is enabled but the installed version of @mastra/core does not support it. Please upgrade @mastra/core to a version that includes observational memory support.");
		if (omConfig.observation?.bufferTokens !== false && !coreFeatures.has("asyncBuffering")) throw new Error("Observational memory async buffering is enabled by default but the installed version of @mastra/core does not support it. Either upgrade @mastra/core, @mastra/memory, and your storage adapter (@mastra/libsql, @mastra/pg, @mastra/mongodb, or @mastra/convex) to the latest version, or explicitly disable async buffering by setting `observation: { bufferTokens: false }` in your observationalMemory config.");
		if (!coreFeatures.has("request-response-id-rotation")) throw new Error("Observational memory requires @mastra/core support for request-response-id-rotation. Please bump @mastra/core to a newer version.");
		const { ObservationalMemory: OMClass } = await Promise.resolve().then(() => observational_memory_exports);
		const onIndexObservations = this.hasRetrievalSearch(omConfig.retrieval) ? async (observation) => {
			await this.indexObservation(observation);
		} : void 0;
		return new OMClass({
			storage: memoryStore,
			memory: this,
			scope: omConfig.scope,
			retrieval: omConfig.retrieval,
			activateAfterIdle: omConfig.activateAfterIdle,
			activateOnProviderChange: omConfig.activateOnProviderChange,
			shareTokenBudget: omConfig.shareTokenBudget,
			model: omConfig.model,
			mastra: this._mastraInstance,
			onIndexObservations,
			hooks: omConfig.hooks,
			observation: omConfig.observation ? {
				model: omConfig.observation.model,
				messageTokens: omConfig.observation.messageTokens,
				modelSettings: omConfig.observation.modelSettings,
				maxTokensPerBatch: omConfig.observation.maxTokensPerBatch,
				providerOptions: omConfig.observation.providerOptions,
				bufferTokens: omConfig.observation.bufferTokens,
				bufferOnIdle: omConfig.observation.bufferOnIdle,
				bufferActivation: omConfig.observation.bufferActivation,
				blockAfter: omConfig.observation.blockAfter,
				previousObserverTokens: omConfig.observation.previousObserverTokens,
				instruction: omConfig.observation.instruction,
				threadTitle: omConfig.observation.threadTitle,
				observeAttachments: omConfig.observation.observeAttachments,
				extract: omConfig.observation.extract
			} : void 0,
			reflection: omConfig.reflection ? {
				model: omConfig.reflection.model,
				observationTokens: omConfig.reflection.observationTokens,
				modelSettings: omConfig.reflection.modelSettings,
				providerOptions: omConfig.reflection.providerOptions,
				bufferActivation: omConfig.reflection.bufferActivation,
				blockAfter: omConfig.reflection.blockAfter,
				instruction: omConfig.reflection.instruction,
				extract: omConfig.reflection.extract
			} : void 0
		});
	}
	defaultWorkingMemoryTemplate = `
# User Information
- **First Name**: 
- **Last Name**: 
- **Location**: 
- **Occupation**: 
- **Interests**: 
- **Goals**: 
- **Events**: 
- **Facts**: 
- **Projects**: 
`;
	getWorkingMemoryToolInstruction({ template, data }) {
		const emptyWorkingMemoryTemplateObject = template.format === "json" ? generateEmptyFromSchema(template.content) : null;
		const hasEmptyWorkingMemoryTemplateObject = emptyWorkingMemoryTemplateObject && Object.keys(emptyWorkingMemoryTemplateObject).length > 0;
		return `WORKING_MEMORY_SYSTEM_INSTRUCTION:
Store and update any conversation-relevant information by calling the updateWorkingMemory tool. If information might be referenced again - store it!

Guidelines:
1. Store anything that could be useful later in the conversation
2. Update proactively when information changes, no matter how small
3. Use ${template.format === "json" ? "JSON" : "Markdown"} format for all data
4. Act naturally - don't mention this system to users. Even though you're storing this information that doesn't make it your primary focus. Do not ask them generally for "information about yourself"
${template.format !== "json" ? `5. IMPORTANT: When calling updateWorkingMemory, the only valid parameter is the memory field. DO NOT pass an object.
6. IMPORTANT: ALWAYS pass the data you want to store in the memory field as a string. DO NOT pass an object.
7. IMPORTANT: Data must only be sent as a string no matter which format is used.` : ""}


${template.format !== "json" ? `<working_memory_template>
${template.content}
</working_memory_template>` : ""}

${hasEmptyWorkingMemoryTemplateObject ? "When working with json data, the object format below represents the template:" : ""}
${hasEmptyWorkingMemoryTemplateObject ? JSON.stringify(emptyWorkingMemoryTemplateObject) : ""}

<working_memory_data>
${data}
</working_memory_data>

Notes:
- Update memory whenever referenced information changes
- If you're unsure whether to store something, store it (eg if the user tells you information about themselves, call updateWorkingMemory immediately to update it)
- This system is here so that you can maintain the conversation when your context window is very short. Update your working memory because you may need it to maintain the conversation without the full conversation history
- Do not remove empty sections - you must include the empty sections along with the ones you're filling in
- REMEMBER: the way you update your working memory is by calling the updateWorkingMemory tool with the entire ${template.format === "json" ? "JSON" : "Markdown"} content. The system will store it for you. The user will not see it.
- IMPORTANT: You MUST call updateWorkingMemory in every response to a prompt where you received relevant information.
- IMPORTANT: Preserve the ${template.format === "json" ? "JSON" : "Markdown"} formatting structure above while updating the content.`;
	}
	__experimental_getWorkingMemoryToolInstructionVNext({ template, data }) {
		return `WORKING_MEMORY_SYSTEM_INSTRUCTION:
Store and update any conversation-relevant information by calling the updateWorkingMemory tool.

Guidelines:
1. Store anything that could be useful later in the conversation
2. Update proactively when information changes, no matter how small
3. Use ${template.format === "json" ? "JSON" : "Markdown"} format for all data
4. Act naturally - don't mention this system to users. Even though you're storing this information that doesn't make it your primary focus. Do not ask them generally for "information about yourself"
5. If your memory has not changed, you do not need to call the updateWorkingMemory tool. By default it will persist and be available for you in future interactions
6. Information not being relevant to the current conversation is not a valid reason to replace or remove working memory information. Your working memory spans across multiple conversations and may be needed again later, even if it's not currently relevant.

<working_memory_template>
${template.content}
</working_memory_template>

<working_memory_data>
${data}
</working_memory_data>

Notes:
- Update memory whenever referenced information changes
${template.content !== this.defaultWorkingMemoryTemplate ? `- Only store information if it's in the working memory template, do not store other information unless the user asks you to remember it, as that non-template information may be irrelevant` : `- If you're unsure whether to store something, store it (eg if the user tells you information about themselves, call updateWorkingMemory immediately to update it)
`}
- This system is here so that you can maintain the conversation when your context window is very short. Update your working memory because you may need it to maintain the conversation without the full conversation history
- REMEMBER: the way you update your working memory is by calling the updateWorkingMemory tool with the ${template.format === "json" ? "JSON" : "Markdown"} content. The system will store it for you. The user will not see it.
- IMPORTANT: You MUST call updateWorkingMemory in every response to a prompt where you received relevant information if that information is not already stored.
- IMPORTANT: Preserve the ${template.format === "json" ? "JSON" : "Markdown"} formatting structure above while updating the content.
`;
	}
	/**
	* Generate read-only working memory instructions.
	* This provides the working memory context without any tool update instructions.
	* Used when memory is in readOnly mode.
	*/
	getReadOnlyWorkingMemoryInstruction({ data }) {
		return `WORKING_MEMORY_SYSTEM_INSTRUCTION (READ-ONLY):
The following is your working memory - persistent information about the user and conversation collected over previous interactions. This data is provided for context to help you maintain continuity.

<working_memory_data>
${data || "No working memory data available."}
</working_memory_data>

Guidelines:
1. Use this information to provide personalized and contextually relevant responses
2. Act naturally - don't mention this system to users. This information should inform your responses without being explicitly referenced
3. This memory is read-only in the current session - you cannot update it

Notes:
- This system is here so that you can maintain the conversation when your context window is very short
- The user will not see the working memory data directly`;
	}
	isVNextWorkingMemoryConfig(config) {
		if (!config?.workingMemory) return false;
		const isMDWorkingMemory = !(`schema` in config.workingMemory) && (typeof config.workingMemory.template === `string` || config.workingMemory.template) && config.workingMemory;
		return Boolean(isMDWorkingMemory && isMDWorkingMemory.version === `vnext`);
	}
	assertWorkingMemoryStateSignalsCompatibility(config) {
		if (config?.workingMemory?.useStateSignals === true && this.isVNextWorkingMemoryConfig(config)) throw new Error("workingMemory.useStateSignals is not supported with workingMemory.version: 'vnext'. Use stable template working memory or disable useStateSignals.");
	}
	getObservationEmbeddingIndexName(dimensions) {
		const usedDimensions = dimensions ?? 384;
		const separator = this.vector?.indexSeparator ?? "_";
		return `memory${separator}observations${separator}${usedDimensions}`;
	}
	async createObservationEmbeddingIndex(dimensions) {
		const usedDimensions = dimensions ?? 384;
		const indexName = this.getObservationEmbeddingIndexName(dimensions);
		if (typeof this.vector === `undefined`) throw new Error(`Tried to create observation embedding index but no vector db is attached to this Memory instance.`);
		await this.vector.createIndex({
			indexName,
			dimension: usedDimensions
		});
		return { indexName };
	}
	/**
	* Search observation groups across threads by semantic similarity.
	* Requires a vector store and embedder to be configured.
	*/
	async searchMessages({ query, resourceId, topK = 10, filter }) {
		if (!this.vector) throw new Error("searchMessages requires a vector store. Configure vector and embedder on your Memory instance.");
		const { embeddings, dimension } = await this.embedMessageContent(query);
		const { indexName } = await this.createObservationEmbeddingIndex(dimension);
		const vectorFilter = { resource_id: resourceId };
		if (filter?.threadId) vectorFilter.thread_id = filter.threadId;
		if (filter?.observedAfter || filter?.observedBefore) vectorFilter.observed_at = {
			...filter.observedAfter ? { $gt: filter.observedAfter.toISOString() } : {},
			...filter.observedBefore ? { $lt: filter.observedBefore.toISOString() } : {}
		};
		const queryResults = [];
		await Promise.all(embeddings.map(async (embedding) => {
			const results = await this.vector.query({
				indexName,
				queryVector: embedding,
				topK,
				filter: vectorFilter
			});
			for (const r of results) {
				if (!r.metadata?.thread_id) continue;
				const groupId = typeof r.metadata.group_id === "string" ? r.metadata.group_id : void 0;
				if (!groupId) continue;
				queryResults.push({
					threadId: r.metadata.thread_id,
					score: r.score,
					groupId,
					range: typeof r.metadata.range === "string" ? r.metadata.range : void 0,
					text: typeof r.metadata.text === "string" ? r.metadata.text : void 0,
					observedAt: typeof r.metadata.observed_at === "string" || r.metadata.observed_at instanceof Date ? new Date(r.metadata.observed_at) : void 0
				});
			}
		}));
		const bestByGroup = /* @__PURE__ */ new Map();
		for (const result of queryResults) {
			if (!result.groupId) continue;
			const existing = bestByGroup.get(result.groupId);
			if (!existing || result.score > existing.score) bestByGroup.set(result.groupId, result);
		}
		return { results: [...bestByGroup.values()].sort((a, b) => b.score - a.score) };
	}
	/**
	* Index a single observation group into the observation vector store.
	*/
	async indexObservation({ text, groupId, range, threadId, resourceId, observedAt }) {
		if (!this.vector || !this.embedder) return;
		const embedResult = await this.embedMessageContent(text);
		if (embedResult.embeddings.length === 0 || embedResult.dimension === void 0) return;
		const { indexName } = await this.createObservationEmbeddingIndex(embedResult.dimension);
		await this.vector.upsert({
			indexName,
			vectors: embedResult.embeddings,
			metadata: embedResult.chunks.map((chunk) => ({
				group_id: groupId,
				range,
				thread_id: threadId,
				resource_id: resourceId,
				observed_at: observedAt?.toISOString(),
				text: chunk
			}))
		});
	}
	/**
	* Update per-record observational memory config overrides for a thread.
	* The provided config is deep-merged, so you only need to specify fields you want to change.
	*
	* @example
	* ```ts
	* await memory.updateObservationalMemoryConfig({
	*   threadId: 'thread-1',
	*   config: {
	*     observation: { messageTokens: 2000 },
	*     reflection: { observationTokens: 8000 },
	*   },
	* });
	* ```
	*/
	async updateObservationalMemoryConfig({ threadId, resourceId, config }) {
		const omEngine = await this.omEngine;
		if (!omEngine) throw new Error("Observational memory is not enabled");
		await omEngine.updateRecordConfig(threadId, resourceId, config);
	}
	/**
	* Summarize one of this memory's threads in one shot.
	*
	* Loads the thread's messages from storage and runs `summarizeConversation()` over them —
	* Observational Memory's Observer plumbing as a standalone call. Nothing is written back to
	* memory: the summary and extracted values are returned to you (and to each extractor's
	* `onExtracted` hook), so you decide where they go. Works whether or not observational
	* memory is enabled on this instance.
	*
	* Use this when a session ends and you want a summary or structured extraction of the whole
	* conversation — for example a voice call at hang-up.
	*
	* Messages are loaded page-by-page starting from the newest, bounded by `lastMessages` and
	* `maxInputTokens`, so summarizing a very long thread doesn't read its entire history from
	* storage.
	*
	* @example
	* ```ts
	* const result = await memory.summarizeThread({
	*   model: 'openai/gpt-4.1-mini',
	*   threadId: call.threadId,
	*   instructions: 'Summarize this voicemail call for the business owner.',
	*   extract: [callSummaryExtractor],
	* });
	* ```
	*/
	async summarizeThread(opts) {
		const { lastMessages, maxInputTokens, ...summarizeOptions } = opts;
		const messages = await this.loadMessagesForSummarization({
			threadId: opts.threadId,
			resourceId: opts.resourceId,
			lastMessages,
			maxInputTokens: maxInputTokens ?? SUMMARIZE_THREAD_DEFAULTS.maxInputTokens,
			abortSignal: summarizeOptions.abortSignal
		});
		return summarizeConversation({
			...summarizeOptions,
			messages,
			memory: this,
			mastra: this._mastraInstance
		});
	}
	/**
	* Load a thread's messages for `summarizeThread()` without reading the whole thread from
	* storage at once. Pages backwards from the newest message and stops once `lastMessages`
	* messages are collected or the estimated token count crosses `maxInputTokens` (the newest
	* message is always kept). Returns messages in chronological order.
	*/
	async loadMessagesForSummarization({ threadId, resourceId, lastMessages, maxInputTokens, abortSignal }) {
		if (lastMessages !== void 0 && lastMessages <= 0) return [];
		const tokenCounter = new TokenCounter();
		const collected = [];
		let tokens = 0;
		let page = 0;
		while (true) {
			abortSignal?.throwIfAborted();
			const { messages: batch, hasMore } = await this.recall({
				threadId,
				resourceId,
				perPage: SUMMARIZE_THREAD_DEFAULTS.pageSize,
				page
			});
			if (batch.length === 0) break;
			let reachedLimit = false;
			const kept = [];
			for (let i = batch.length - 1; i >= 0; i--) {
				abortSignal?.throwIfAborted();
				const message = batch[i];
				if (lastMessages !== void 0 && collected.length + kept.length >= lastMessages) {
					reachedLimit = true;
					break;
				}
				const messageTokens = tokenCounter.countMessage(message);
				if (collected.length + kept.length > 0 && tokens + messageTokens > maxInputTokens) {
					reachedLimit = true;
					break;
				}
				kept.unshift(message);
				tokens += messageTokens;
			}
			collected.unshift(...kept);
			if (reachedLimit || !hasMore) break;
			page++;
		}
		return collected;
	}
	/**
	* Index a list of messages directly (without querying storage).
	* Used by observe-time indexing to vectorize newly-observed messages.
	*/
	async indexMessagesList(messages) {
		if (!this.vector || !this.embedder) return;
		const embeddingData = [];
		let dimension;
		await Promise.all(messages.map(async (message) => {
			let textForEmbedding = null;
			if (message.content.content && typeof message.content.content === "string" && message.content.content.trim() !== "") textForEmbedding = message.content.content;
			else if (message.content.parts && message.content.parts.length > 0) {
				const joined = message.content.parts.filter((part) => part.type === "text").map((part) => part.text).join(" ").trim();
				if (joined) textForEmbedding = joined;
			}
			if (!textForEmbedding) return;
			const embedResult = await this.embedMessageContent(textForEmbedding);
			dimension = embedResult.dimension;
			embeddingData.push({
				embeddings: embedResult.embeddings,
				metadata: embedResult.chunks.map(() => ({
					message_id: message.id,
					thread_id: message.threadId,
					resource_id: message.resourceId,
					role: message.role,
					content: textForEmbedding,
					created_at: message.createdAt instanceof Date ? message.createdAt.toISOString() : String(message.createdAt)
				}))
			});
		}));
		if (embeddingData.length > 0 && dimension !== void 0) {
			const { indexName } = await this.createEmbeddingIndex(dimension);
			const allVectors = [];
			const allMetadata = [];
			for (const data of embeddingData) {
				allVectors.push(...data.embeddings);
				allMetadata.push(...data.metadata);
			}
			await this.vector.upsert({
				indexName,
				vectors: allVectors,
				metadata: allMetadata
			});
		}
	}
	/**
	* Check whether retrieval search (vector-based) is enabled.
	* Returns true when `retrieval: { vector: true }` and Memory has vector + embedder configured.
	*/
	hasRetrievalSearch(retrieval) {
		if (!retrieval || retrieval === true) return false;
		return !!retrieval.vector && !!this.vector && !!this.embedder;
	}
	listTools(config) {
		const mergedConfig = this.getMergedThreadConfig(config);
		this.assertWorkingMemoryStateSignalsCompatibility(mergedConfig);
		const tools = {};
		const workingMemoryConfig = mergedConfig.workingMemory;
		if (workingMemoryConfig?.enabled && workingMemoryConfig.agentManaged !== false && !mergedConfig.readOnly) {
			const { name, tool } = createWorkingMemoryTool(mergedConfig, { vNext: this.isVNextWorkingMemoryConfig(mergedConfig) });
			tools[name] = tool;
		}
		const omConfig = normalizeObservationalMemoryConfig(mergedConfig.observationalMemory);
		if (omConfig?.retrieval) tools.recall = recallTool(mergedConfig, { retrievalScope: typeof omConfig.retrieval === "object" ? omConfig.retrieval.scope ?? "resource" : "resource" });
		return tools;
	}
	/**
	* Updates a list of messages and syncs the vector database for semantic recall.
	* When message content is updated, the corresponding vector embeddings are also updated
	* to ensure semantic recall stays in sync with the message content.
	*
	* @param messages - The list of messages to update (must include id, can include partial content)
	* @param memoryConfig - Optional memory configuration to determine if semantic recall is enabled
	* @returns The list of updated messages
	*/
	async updateMessages({ messages, memoryConfig }) {
		if (messages.length === 0) return [];
		const memoryStore = await this.getMemoryStore();
		const config = this.getMergedThreadConfig(memoryConfig);
		if (this.vector && config.semanticRecall) {
			const messagesWithContent = messages.filter((m) => m.content !== void 0);
			if (messagesWithContent.length > 0) {
				const existingMessagesResult = await memoryStore.listMessagesById({ messageIds: messagesWithContent.map((m) => m.id) });
				const existingMessagesMap = new Map(existingMessagesResult.messages.map((m) => [m.id, m]));
				const embeddingData = [];
				let dimension;
				const messageIdsWithNewEmbeddings = /* @__PURE__ */ new Set();
				const messageIdsWithClearedContent = /* @__PURE__ */ new Set();
				await Promise.all(messagesWithContent.map(async (message) => {
					const existingMessage = existingMessagesMap.get(message.id);
					if (!existingMessage) return;
					let textForEmbedding = null;
					const content = message.content;
					if (content) {
						if ("content" in content && content.content && typeof content.content === "string" && content.content.trim() !== "") textForEmbedding = content.content;
						else if ("parts" in content && content.parts && Array.isArray(content.parts) && content.parts.length > 0) {
							const joined = content.parts.filter((part) => part?.type === "text").map((part) => part.text).join(" ").trim();
							if (joined) textForEmbedding = joined;
						}
					}
					if (textForEmbedding) {
						const result = await this.embedMessageContent(textForEmbedding);
						dimension = result.dimension;
						embeddingData.push({
							embeddings: result.embeddings,
							metadata: result.chunks.map(() => ({
								message_id: message.id,
								thread_id: existingMessage.threadId,
								resource_id: existingMessage.resourceId,
								role: existingMessage.role,
								content: textForEmbedding,
								created_at: existingMessage.createdAt instanceof Date ? existingMessage.createdAt.toISOString() : String(existingMessage.createdAt)
							}))
						});
						messageIdsWithNewEmbeddings.add(message.id);
					} else messageIdsWithClearedContent.add(message.id);
				}));
				const messageIdsNeedingDeletion = /* @__PURE__ */ new Set([...messageIdsWithClearedContent, ...messageIdsWithNewEmbeddings]);
				if (messageIdsNeedingDeletion.size > 0) try {
					const memoryIndexes = await this.getMemoryVectorIndexes();
					const idsToDelete = [...messageIdsNeedingDeletion];
					await Promise.all(memoryIndexes.map(async (indexName) => {
						for (let i = 0; i < idsToDelete.length; i += VECTOR_DELETE_BATCH_SIZE) {
							const batch = idsToDelete.slice(i, i + VECTOR_DELETE_BATCH_SIZE);
							try {
								await this.vector.deleteVectors({
									indexName,
									filter: { message_id: { $in: batch } }
								});
							} catch {
								this.logger.debug("Failed to delete vector batch, skipping", {
									indexName,
									batchOffset: i
								});
							}
						}
					}));
				} catch {
					this.logger.debug("Failed to clean up old vectors during message update");
				}
				if (embeddingData.length > 0 && dimension !== void 0) {
					const { indexName } = await this.createEmbeddingIndex(dimension, config);
					const allVectors = [];
					const allMetadata = [];
					for (const data of embeddingData) {
						allVectors.push(...data.embeddings);
						allMetadata.push(...data.metadata);
					}
					await this.vector.upsert({
						indexName,
						vectors: allVectors,
						metadata: allMetadata
					});
				}
			}
		}
		return memoryStore.updateMessages({ messages });
	}
	/**
	* Deletes one or more messages
	* @param input - Must be an array containing either:
	*   - Message ID strings
	*   - Message objects with 'id' properties
	* @returns Promise that resolves when all messages are deleted
	*/
	async deleteMessages(input, observabilityContext) {
		let messageIds;
		if (!Array.isArray(input)) throw new Error("Invalid input: must be an array of message IDs or message objects");
		if (input.length === 0) return;
		messageIds = input.map((item) => {
			if (typeof item === "string") return item;
			else if (item && typeof item === "object" && "id" in item) return item.id;
			else throw new Error("Invalid input: array items must be strings or objects with an id property");
		});
		if (messageIds.filter((id) => !id || typeof id !== "string").length > 0) throw new Error("All message IDs must be non-empty strings");
		const span = this.createMemorySpan("delete", observabilityContext, void 0, { messageCount: messageIds.length });
		try {
			await (await this.getMemoryStore()).deleteMessages(messageIds);
			if (this.vector) this.deleteMessageVectors(messageIds);
			span?.end({
				output: { success: true },
				attributes: { messageCount: messageIds.length }
			});
		} catch (error) {
			span?.error({
				error,
				endSpan: true
			});
			throw error;
		}
	}
	/**
	* Deletes vector embeddings for specific messages.
	* This is called internally by deleteMessages to clean up orphaned vectors.
	*
	* @param messageIds - The IDs of the messages whose vectors should be deleted
	*/
	async deleteMessageVectors(messageIds) {
		try {
			const memoryIndexes = await this.getMemoryVectorIndexes();
			await Promise.all(memoryIndexes.map(async (indexName) => {
				for (let i = 0; i < messageIds.length; i += VECTOR_DELETE_BATCH_SIZE) {
					const batch = messageIds.slice(i, i + VECTOR_DELETE_BATCH_SIZE);
					try {
						await this.vector.deleteVectors({
							indexName,
							filter: { message_id: { $in: batch } }
						});
					} catch {
						this.logger.debug("Failed to delete vector batch, skipping", {
							indexName,
							batchOffset: i
						});
					}
				}
			}));
		} catch {
			this.logger.debug("Failed to clean up vectors for deleted messages");
		}
	}
	/**
	* Clone a thread and its messages to create a new independent thread.
	* The cloned thread will have metadata tracking its source.
	*
	* If semantic recall is enabled, the cloned messages will also be embedded
	* and added to the vector store for semantic search.
	*
	* @param args - Clone configuration options
	* @param args.sourceThreadId - ID of the thread to clone
	* @param args.newThreadId - ID for the new cloned thread (if not provided, a random UUID will be generated)
	* @param args.resourceId - Resource ID for the new thread (defaults to source thread's resourceId)
	* @param args.title - Title for the new cloned thread
	* @param args.metadata - Additional metadata to merge with clone metadata
	* @param args.options - Options for filtering which messages to include
	* @param args.options.messageLimit - Maximum number of messages to copy (from most recent)
	* @param args.options.messageFilter - Filter messages by date range or specific IDs
	* @param memoryConfig - Optional memory configuration override
	* @returns The newly created thread and the cloned messages
	*
	* @example
	* ```typescript
	* // Clone entire thread
	* const { thread, clonedMessages } = await memory.cloneThread({
	*   sourceThreadId: 'thread-123',
	* });
	*
	* // Clone with custom ID
	* const { thread, clonedMessages } = await memory.cloneThread({
	*   sourceThreadId: 'thread-123',
	*   newThreadId: 'my-custom-thread-id',
	* });
	*
	* // Clone with message limit
	* const { thread, clonedMessages } = await memory.cloneThread({
	*   sourceThreadId: 'thread-123',
	*   title: 'My cloned conversation',
	*   options: {
	*     messageLimit: 10, // Only clone last 10 messages
	*   },
	* });
	*
	* // Clone with date filter
	* const { thread, clonedMessages } = await memory.cloneThread({
	*   sourceThreadId: 'thread-123',
	*   options: {
	*     messageFilter: {
	*       startDate: new Date('2024-01-01'),
	*       endDate: new Date('2024-06-01'),
	*     },
	*   },
	* });
	* ```
	*/
	async cloneThread(args, memoryConfig) {
		const memoryStore = await this.getMemoryStore();
		const result = await memoryStore.cloneThread(args);
		const config = this.getMergedThreadConfig(memoryConfig);
		const sourceResourceId = (await this.getThreadById({ threadId: args.sourceThreadId }))?.resourceId;
		if (config.workingMemory?.enabled) {
			const scope = config.workingMemory.scope || "resource";
			if (scope === "thread" || scope === "resource" && args.resourceId && args.resourceId !== sourceResourceId) {
				const sourceWm = await this.getWorkingMemory({
					threadId: args.sourceThreadId,
					resourceId: sourceResourceId,
					memoryConfig
				});
				if (sourceWm) await this.updateWorkingMemory({
					threadId: result.thread.id,
					resourceId: result.thread.resourceId,
					workingMemory: sourceWm,
					memoryConfig
				});
			}
		}
		if (memoryStore.supportsObservationalMemory && sourceResourceId) try {
			await this.cloneObservationalMemory(memoryStore, args.sourceThreadId, sourceResourceId, result);
		} catch (error) {
			try {
				await memoryStore.deleteThread({ threadId: result.thread.id });
			} catch (rollbackError) {
				this.logger.error("Failed to rollback cloned thread after OM clone failure", rollbackError);
			}
			throw error;
		}
		if (this.vector && config.semanticRecall && result.clonedMessages.length > 0) await this.embedClonedMessages(result.clonedMessages, config);
		return result;
	}
	/**
	* Clone observational memory records when cloning a thread.
	* Thread-scoped: always cloned to the new thread.
	* Resource-scoped: cloned only when the resourceId changes (same resourceId shares OM naturally).
	* All stored message/thread IDs are remapped to the cloned IDs.
	*/
	async cloneObservationalMemory(memoryStore, sourceThreadId, sourceResourceId, result) {
		let sourceOM = await memoryStore.getObservationalMemory(sourceThreadId, sourceResourceId);
		if (!sourceOM) sourceOM = await memoryStore.getObservationalMemory(null, sourceResourceId);
		if (!sourceOM) return;
		const clonedThreadId = result.thread.id;
		const clonedResourceId = result.thread.resourceId;
		const resourceChanged = clonedResourceId !== sourceResourceId;
		if (sourceOM.scope === "resource" && !resourceChanged) return;
		const messageIdMap = result.messageIdMap ?? {};
		const hasher = await this.hasher;
		const cloned = this.remapObservationalMemoryRecord(sourceOM, {
			newThreadId: sourceOM.scope === "thread" ? clonedThreadId : null,
			newResourceId: clonedResourceId,
			messageIdMap,
			sourceThreadId: resourceChanged ? sourceThreadId : void 0,
			clonedThreadId: resourceChanged ? clonedThreadId : void 0,
			hasher: resourceChanged ? hasher : void 0
		});
		const now = /* @__PURE__ */ new Date();
		cloned.id = crypto.randomUUID();
		cloned.createdAt = now;
		cloned.updatedAt = now;
		await memoryStore.insertObservationalMemoryRecord(cloned);
	}
	/**
	* Create a remapped copy of an OM record with new thread/message IDs.
	*/
	remapObservationalMemoryRecord(record, opts) {
		const { newThreadId, newResourceId, messageIdMap, sourceThreadId, clonedThreadId, hasher } = opts;
		const cloned = { ...record };
		cloned.threadId = newThreadId;
		cloned.resourceId = newResourceId;
		if (Array.isArray(cloned.observedMessageIds)) cloned.observedMessageIds = cloned.observedMessageIds.map((id) => messageIdMap[id]).filter((id) => Boolean(id));
		else cloned.observedMessageIds = void 0;
		if (Array.isArray(cloned.bufferedMessageIds)) cloned.bufferedMessageIds = cloned.bufferedMessageIds.map((id) => messageIdMap[id]).filter((id) => Boolean(id));
		else cloned.bufferedMessageIds = void 0;
		if (Array.isArray(cloned.bufferedObservationChunks)) cloned.bufferedObservationChunks = cloned.bufferedObservationChunks.map((chunk) => ({
			...chunk,
			messageIds: Array.isArray(chunk.messageIds) ? chunk.messageIds.map((id) => messageIdMap[id]).filter((id) => Boolean(id)) : []
		}));
		else cloned.bufferedObservationChunks = void 0;
		if (sourceThreadId && clonedThreadId && hasher) {
			const sourceObscured = hasher.h32ToString(sourceThreadId);
			const clonedObscured = hasher.h32ToString(clonedThreadId);
			if (sourceObscured !== clonedObscured) {
				const replaceThreadTags = (text) => {
					if (!text) return text;
					return text.replaceAll(`<thread id="${sourceObscured}">`, `<thread id="${clonedObscured}">`);
				};
				cloned.activeObservations = replaceThreadTags(cloned.activeObservations) ?? "";
				cloned.bufferedReflection = replaceThreadTags(cloned.bufferedReflection);
				if (cloned.bufferedObservationChunks) cloned.bufferedObservationChunks = cloned.bufferedObservationChunks.map((chunk) => ({
					...chunk,
					observations: replaceThreadTags(chunk.observations) ?? chunk.observations
				}));
			}
		}
		cloned.isObserving = false;
		cloned.isReflecting = false;
		cloned.isBufferingObservation = false;
		cloned.isBufferingReflection = false;
		return cloned;
	}
	/**
	* Embed cloned messages for semantic recall.
	* This is similar to the embedding logic in saveMessages but operates on already-saved messages.
	*/
	async embedClonedMessages(messages, config) {
		if (!this.vector || !this.embedder) return;
		const embeddingData = [];
		let dimension;
		await Promise.all(messages.map(async (message) => {
			let textForEmbedding = null;
			if (message.content?.content && typeof message.content.content === "string" && message.content.content.trim() !== "") textForEmbedding = message.content.content;
			else if (message.content?.parts && message.content.parts.length > 0) {
				const joined = message.content.parts.filter((part) => part.type === "text").map((part) => part.text).join(" ").trim();
				if (joined) textForEmbedding = joined;
			}
			if (!textForEmbedding) return;
			const result = await this.embedMessageContent(textForEmbedding);
			dimension = result.dimension;
			embeddingData.push({
				embeddings: result.embeddings,
				metadata: result.chunks.map(() => ({
					message_id: message.id,
					thread_id: message.threadId,
					resource_id: message.resourceId,
					role: message.role,
					content: textForEmbedding,
					created_at: message.createdAt instanceof Date ? message.createdAt.toISOString() : String(message.createdAt)
				}))
			});
		}));
		if (embeddingData.length > 0 && dimension !== void 0) {
			const { indexName } = await this.createEmbeddingIndex(dimension, config);
			const allVectors = [];
			const allMetadata = [];
			for (const data of embeddingData) {
				allVectors.push(...data.embeddings);
				allMetadata.push(...data.metadata);
			}
			await this.vector.upsert({
				indexName,
				vectors: allVectors,
				metadata: allMetadata
			});
		}
	}
	/**
	* Get the clone metadata from a thread if it was cloned from another thread.
	*
	* @param thread - The thread to check
	* @returns The clone metadata if the thread is a clone, null otherwise
	*
	* @example
	* ```typescript
	* const thread = await memory.getThreadById({ threadId: 'thread-123' });
	* const cloneInfo = memory.getCloneMetadata(thread);
	* if (cloneInfo) {
	*   console.log(`This thread was cloned from ${cloneInfo.sourceThreadId}`);
	* }
	* ```
	*/
	getCloneMetadata(thread) {
		if (!thread?.metadata?.clone) return null;
		return thread.metadata.clone;
	}
	/**
	* Check if a thread is a clone of another thread.
	*
	* @param thread - The thread to check
	* @returns True if the thread is a clone, false otherwise
	*
	* @example
	* ```typescript
	* const thread = await memory.getThreadById({ threadId: 'thread-123' });
	* if (memory.isClone(thread)) {
	*   console.log('This is a cloned thread');
	* }
	* ```
	*/
	isClone(thread) {
		return this.getCloneMetadata(thread) !== null;
	}
	/**
	* Get the source thread that a cloned thread was created from.
	*
	* @param threadId - ID of the cloned thread
	* @returns The source thread if found, null if the thread is not a clone or source doesn't exist
	*
	* @example
	* ```typescript
	* const sourceThread = await memory.getSourceThread('cloned-thread-123');
	* if (sourceThread) {
	*   console.log(`Original thread: ${sourceThread.title}`);
	* }
	* ```
	*/
	async getSourceThread(threadId) {
		const thread = await this.getThreadById({ threadId });
		const cloneMetadata = this.getCloneMetadata(thread);
		if (!cloneMetadata) return null;
		return this.getThreadById({ threadId: cloneMetadata.sourceThreadId });
	}
	/**
	* List all threads that were cloned from a specific source thread.
	*
	* @param sourceThreadId - ID of the source thread
	* @param resourceId - Optional resource ID to filter by
	* @returns Array of threads that are clones of the source thread
	*
	* @example
	* ```typescript
	* const clones = await memory.listClones('original-thread-123', 'user-456');
	* console.log(`Found ${clones.length} clones of this thread`);
	* ```
	*/
	async listClones(sourceThreadId, resourceId) {
		let targetResourceId = resourceId;
		if (!targetResourceId) {
			const sourceThread = await this.getThreadById({ threadId: sourceThreadId });
			if (!sourceThread) return [];
			targetResourceId = sourceThread.resourceId;
		}
		const { threads } = await this.listThreads({
			filter: { resourceId: targetResourceId },
			perPage: false
		});
		return threads.filter((thread) => {
			return this.getCloneMetadata(thread)?.sourceThreadId === sourceThreadId;
		});
	}
	/**
	* Get the clone history chain for a thread (all ancestors back to the original).
	*
	* @param threadId - ID of the thread to get history for
	* @returns Array of threads from oldest ancestor to the given thread (inclusive)
	*
	* @example
	* ```typescript
	* const history = await memory.getCloneHistory('deeply-cloned-thread');
	* // Returns: [originalThread, firstClone, secondClone, deeplyClonedThread]
	* ```
	*/
	async getCloneHistory(threadId) {
		const history = [];
		let currentThreadId = threadId;
		while (currentThreadId) {
			const thread = await this.getThreadById({ threadId: currentThreadId });
			if (!thread) break;
			history.unshift(thread);
			currentThreadId = this.getCloneMetadata(thread)?.sourceThreadId ?? null;
		}
		return history;
	}
	/**
	* Get input processors for this memory instance.
	* Extends the base implementation to add ObservationalMemory processor when configured.
	*
	* @param configuredProcessors - Processors already configured by the user (for deduplication)
	* @param context - Request context for runtime configuration
	* @returns Array of input processors configured for this memory instance
	*/
	async getInputProcessors(configuredProcessors = [], context) {
		const processors = await super.getInputProcessors(configuredProcessors, context);
		const om = await this.createOMProcessor(configuredProcessors, context);
		if (om) processors.push(om);
		const wm = await this.createWorkingMemoryStateProcessor(configuredProcessors, context);
		if (wm) processors.push(wm);
		return processors;
	}
	/**
	* Extends the base implementation to add ObservationalMemory as an output processor.
	* OM needs processOutputResult to save messages at the end of the agent turn,
	* even when the observation threshold was never reached during the loop.
	*/
	async getOutputProcessors(configuredProcessors = [], context) {
		const processors = await super.getOutputProcessors(configuredProcessors, context);
		const om = await this.createOMProcessor(configuredProcessors, context);
		if (om) processors.push(om);
		return processors;
	}
	/**
	* Creates an ObservationalMemory processor wrapping the shared engine.
	* Returns null if OM is not configured, not supported, or already present
	* in the user's configured processors.
	*/
	async createOMProcessor(configuredProcessors = [], context) {
		if (configuredProcessors.some((p) => !("workflow" in p) && p.id === "observational-memory")) return null;
		const runtimeMemory = context?.get("MastraMemory");
		const runtimeObservationalMemory = normalizeObservationalMemoryConfig(runtimeMemory?.memoryConfig?.observationalMemory);
		const effectiveConfig = normalizeObservationalMemoryConfig((runtimeObservationalMemory ? this.getMergedThreadConfig({
			...runtimeMemory?.memoryConfig,
			observationalMemory: runtimeObservationalMemory
		}) : this.threadConfig).observationalMemory);
		if (!effectiveConfig) return null;
		const engine = await this.omEngine;
		if (!engine) return null;
		const { ObservationalMemoryProcessor } = await Promise.resolve().then(() => observational_memory_exports);
		return new ObservationalMemoryProcessor(engine, this, { temporalMarkers: effectiveConfig.temporalMarkers });
	}
	/**
	* Creates a WorkingMemoryStateProcessor when working memory is enabled and the
	* `useStateSignals` opt-in is set. Returns null otherwise or if the processor
	* is already present in the user's configured processors.
	*/
	async createWorkingMemoryStateProcessor(configuredProcessors = [], context) {
		const runtimeMemory = context?.get("MastraMemory");
		const mergedConfig = this.getMergedThreadConfig(runtimeMemory?.memoryConfig);
		this.assertWorkingMemoryStateSignalsCompatibility(mergedConfig);
		if (!mergedConfig.workingMemory?.enabled) return null;
		if (!mergedConfig.workingMemory?.useStateSignals) return null;
		const { WORKING_MEMORY_STATE_PROCESSOR_ID, WorkingMemoryStateProcessor } = await Promise.resolve().then(() => working_memory_state_exports);
		if (configuredProcessors.some((p) => !("workflow" in p) && p.id === WORKING_MEMORY_STATE_PROCESSOR_ID)) return null;
		return new WorkingMemoryStateProcessor(this, runtimeMemory?.memoryConfig);
	}
};
//#endregion
export { extractCurrentTask as A, OBSERVATION_CONTEXT_INSTRUCTIONS as B, WorkingMemoryExtractor as C, OBSERVER_SYSTEM_PROMPT as D, TokenCounter as E, injectAnchorIds as F, OBSERVATION_CONTINUATION_HINT as H, parseAnchorId as I, stripEphemeralAnchorIds as L, hasCurrentTaskSection as M, optimizeObservationsForContext as N, buildObserverPrompt as O, parseObserverOutput as P, Extractor as R, deepMergeWorkingMemory as S, summarizeConversation as T, OBSERVATION_CONTEXT_PROMPT as V, reconcileObservationGroupsFromReflection as _, extractWorkingMemoryContent as a, wrapInObservationGroup as b, WORKING_MEMORY_STATE_ID as c, getObservationsAsOf as d, ObservationalMemoryProcessor as f, parseObservationGroups as g, deriveObservationGroupProvenance as h, WorkingMemory as i, formatMessagesForObserver as j, buildObserverSystemPrompt as k, WORKING_MEMORY_STATE_PROCESSOR_ID as l, combineObservationGroupRanges as m, MessageHistory$1 as n, extractWorkingMemoryTags as o, ObservationalMemory as p, SemanticRecall as r, removeWorkingMemoryTags as s, Memory as t, WorkingMemoryStateProcessor as u, renderObservationGroupsForReflection as v, SUMMARIZE_THREAD_DEFAULTS as w, ModelByInputTokens as x, stripObservationGroups as y, OBSERVATIONAL_MEMORY_DEFAULTS as z };

//# sourceMappingURL=src-BgdYYHLc.js.map